import "./web.7c552b00.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;


var $7DyRn = parcelRequire("7DyRn");

var $hF90B = parcelRequire("hF90B");

var $bNfEN = parcelRequire("bNfEN");
/**
 * Clamp a number
 * @param {number} num 
 * @param {number} min 
 * @param {number} max 
 * @returns {number}
 */ function $98dd9785d83e1f2f$export$7d15b64cf5a3a4c4(num, min, max) {
    if (num > max) return max;
    else if (num < min) return min;
    else return num;
}
function $98dd9785d83e1f2f$export$fee647fc849da40e(elm) {
    var rect = elm.getBoundingClientRect();
    var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
}



var $dLq9J = parcelRequire("dLq9J");
var $75b3f03462ab0244$var$previousMousePos = {
    X: 0,
    Y: 0
};
var $75b3f03462ab0244$var$currentMousePos = {
    X: 0,
    Y: 0
};
var $75b3f03462ab0244$var$executionStartTime = 0;
var $75b3f03462ab0244$var$uiUpdatesCompleted = 0;
async function $75b3f03462ab0244$export$6264774bc3649f49() {
    if ((0, $10c90e54c8ae0167$export$ca2646a4c0f0768f).value == "" || !(0, $7DyRn.default).vmInited) return;
    else if ((0, $bNfEN.registerInts)[(0, $10c90e54c8ae0167$export$ca2646a4c0f0768f).value] != undefined) {
        (0, $7DyRn.default).registerPeekValue = (0, $10c90e54c8ae0167$export$ca2646a4c0f0768f).value;
        (0, $10c90e54c8ae0167$export$ea454f442ecb1c77).textContent = await $75b3f03462ab0244$export$eb4a8147dc332844((0, $bNfEN.registerInts)[(0, $7DyRn.default).registerPeekValue], document.getElementById("peek-format-select").value);
        (0, $10c90e54c8ae0167$export$ca2646a4c0f0768f).setAttribute("valid-reg", "true");
    } else (0, $10c90e54c8ae0167$export$ca2646a4c0f0768f).setAttribute("valid-reg", "false");
}
async function $75b3f03462ab0244$export$eb4a8147dc332844(regInt, format) {
    let bytes = new Uint8Array(new SharedArrayBuffer(regInt == (0, $bNfEN.registerInts)["d0"] || regInt == (0, $bNfEN.registerInts)["vt"] ? 128 : 4));
    if (regInt == (0, $bNfEN.registerInts)["d0"] || regInt == (0, $bNfEN.registerInts)["vt"]) {
        if (regInt == (0, $bNfEN.registerInts)["d0"]) await (0, $bNfEN.goputer).getBuffer("data", $dLq9J.transfer(bytes, bytes.data));
        else await (0, $bNfEN.goputer).getBuffer("text", $dLq9J.transfer(bytes, bytes.data));
    } else await (0, $bNfEN.goputer).getRegisterBytes(regInt, $dLq9J.transfer(bytes, bytes.data));
    let result = "";
    switch(format){
        case "hex":
            bytes.forEach((element)=>{
                result += element.toString(16).padStart(2, "0");
            });
            return `0x${result}`;
        case "binary":
            bytes.forEach((element)=>{
                result += element.toString(2).padStart(8, "0");
                result += " ";
            });
            return result;
        case "text":
            for(let i = 0; i < bytes.length; i++){
                if (bytes[i] == 0) continue;
                else result += String.fromCharCode(bytes[i]);
            }
            if (result.length == 0) return "No string found";
            return result;
        case "decimal":
            if (regInt == (0, $bNfEN.registerInts)["d0"] || regInt == (0, $bNfEN.registerInts)["vt"]) {
                bytes.forEach((element)=>{
                    result += element.toString() + " ";
                });
                return result;
            } else return (await (0, $bNfEN.goputer).getRegister(regInt)).toString();
        default:
            break;
    }
}
async function $75b3f03462ab0244$export$889b795e702c4b25(e) {
    (0, $7DyRn.default).errorDiv.replaceChildren();
    (0, $7DyRn.default).compileFailed = false;
    await (0, $bNfEN.goputer).compileCode();
    (0, $7DyRn.default).codeHasBeenCompiled = true;
    if (!(0, $7DyRn.default).compileFailed) {
        document.getElementById("run-code-button").disabled = false;
        document.getElementById("download-code-button").disabled = false;
        (0, $hF90B.ShowError)((0, $hF90B.ErrorTypes).Success, "Code compiled successfully!");
    } else (0, $7DyRn.default).codeHasBeenCompiled = false;
}
let $75b3f03462ab0244$var$lastUpdateTime = 0;
const $75b3f03462ab0244$var$targetFrameTime = Math.round(1000 / (0, $7DyRn.default).UPS);
function $75b3f03462ab0244$var$scheduleNextUpdate() {
    if (!(0, $7DyRn.default).vmIsAlive) return;
    requestAnimationFrame(async (timestamp)=>{
        const elapsed = timestamp - $75b3f03462ab0244$var$lastUpdateTime;
        if (elapsed >= $75b3f03462ab0244$var$targetFrameTime) {
            $75b3f03462ab0244$var$lastUpdateTime = timestamp;
            await $75b3f03462ab0244$export$f28d650a7979dc6a();
        }
        $75b3f03462ab0244$var$scheduleNextUpdate();
    });
}
async function $75b3f03462ab0244$export$ddae37e51c7979e2(e) {
    if (!(0, $7DyRn.default).codeHasBeenCompiled) (0, $hF90B.ShowError)((0, $hF90B.ErrorTypes).Error, "No code has been uploaded or compiled!");
    else {
        await (0, $bNfEN.goputer).initVm();
        (0, $7DyRn.default).vmIsAlive = true;
        $75b3f03462ab0244$export$64cd6327b1b8b7f9(true);
        (0, $7DyRn.default).vmInited = true;
        (0, $bNfEN.goputer).run();
        $75b3f03462ab0244$var$executionStartTime = Date.now();
        (0, $10c90e54c8ae0167$export$67ea982130081db).setAttribute("running", "true");
        $75b3f03462ab0244$var$lastUpdateTime = performance.now();
        $75b3f03462ab0244$var$scheduleNextUpdate();
    }
}
function $75b3f03462ab0244$export$3248c033e90a4ba0(e) {
    if ((0, $7DyRn.default).vmIsAlive) {
        if ((0, $7DyRn.default).mouseOverDisplay) {
            $75b3f03462ab0244$var$currentMousePos.X = Math.round(e.clientX - (0, $10c90e54c8ae0167$export$67ea982130081db).getBoundingClientRect().left);
            $75b3f03462ab0244$var$currentMousePos.Y = Math.round(e.clientY - (0, $10c90e54c8ae0167$export$67ea982130081db).getBoundingClientRect().top);
        }
    }
}
async function $75b3f03462ab0244$export$bab59f27a7347e45(e) {
    if ((0, $7DyRn.default).keyboardLocked) {
        e.preventDefault();
        (0, $7DyRn.default).keysDown.push(await (0, $bNfEN.goputer).mappedKey(e.code));
    }
}
async function $75b3f03462ab0244$export$aef3a35367ddc990(e) {
    if ((0, $7DyRn.default).keyboardLocked) {
        e.preventDefault();
        (0, $7DyRn.default).keysUp.push(await (0, $bNfEN.goputer).mappedKey(e.code)) // I am aware this is depreceated however, this is the most practical way to get integer keycodes.
        ;
    }
}
function $75b3f03462ab0244$export$64cd6327b1b8b7f9(locked) {
    if (locked) {
        (0, $7DyRn.default).keyboardLocked = true;
        document.getElementById("kbd-locked-message").querySelector("span").innerText = " Keyboard locked";
        document.getElementById("kbd-locked-message").querySelector("i").classList.remove("bi-unlock");
        document.getElementById("kbd-locked-message").querySelector("i").classList.add("bi-lock");
    } else {
        (0, $7DyRn.default).keyboardLocked = false;
        document.getElementById("kbd-locked-message").querySelector("span").innerText = " Keyboard unlocked";
        document.getElementById("kbd-locked-message").querySelector("i").classList.add("bi-unlock");
        document.getElementById("kbd-locked-message").querySelector("i").classList.remove("bi-lock");
    }
}
async function $75b3f03462ab0244$export$f28d650a7979dc6a() {
    if (!(0, $7DyRn.default).vmIsAlive) console.error("VM isn't alive therefore can't run code.");
    else {
        //Handle called interrupts.
        var x = await (0, $bNfEN.goputer).getInterrupt();
        switch(x){
            case (0, $bNfEN.interruptInts)["ss"]:
                (0, $7DyRn.default).oscillator.frequency.value = 0;
                (0, $7DyRn.default).audioVolume.gain.value = 0;
                break;
            case (0, $bNfEN.interruptInts)["sf"]:
                (0, $7DyRn.default).oscillator.type = await (0, $bNfEN.goputer).getRegister((0, $bNfEN.registerInts)["sw"]) == 0 ? "square" : "sine";
                (0, $7DyRn.default).oscillator.frequency.value = await (0, $bNfEN.goputer).getRegister((0, $bNfEN.registerInts)["st"]);
                (0, $7DyRn.default).audioVolume.gain.value = await (0, $bNfEN.goputer).getRegister((0, $bNfEN.registerInts)["sv"]) / 255;
                if (!(0, $7DyRn.default).soundStarted) {
                    (0, $7DyRn.default).oscillator.start();
                    (0, $7DyRn.default).soundStarted = true;
                }
                break;
            case (0, $bNfEN.interruptInts)["iof"]:
                //Set IO states for IO bulbs.
                for(let i = 0; i < (0, $7DyRn.default).ioBulbNames.length; i++){
                    console.log(`${i}: ${await (0, $bNfEN.goputer).getRegister((0, $bNfEN.registerInts)[(0, $7DyRn.default).ioBulbNames[i]]) > 0}`);
                    (0, $7DyRn.default).ioBulbs[(0, $7DyRn.default).ioBulbNames[i]].setAttribute("enabled", await (0, $bNfEN.goputer).getRegister((0, $bNfEN.registerInts)[(0, $7DyRn.default).ioBulbNames[i]]) > 0 ? "true" : "false");
                }
                break;
            default:
                break;
        }
        await (0, $bNfEN.goputer).drawing.drawScene();
        // Handle subscribed interrupts
        //Mouse
        if ($75b3f03462ab0244$var$previousMousePos.X != $75b3f03462ab0244$var$currentMousePos.X || $75b3f03462ab0244$var$previousMousePos.Y != $75b3f03462ab0244$var$currentMousePos.Y) {
            await (0, $bNfEN.goputer).setRegister((0, $bNfEN.registerInts)["mx"], Math.floor($75b3f03462ab0244$var$previousMousePos.X / 2));
            await (0, $bNfEN.goputer).setRegister((0, $bNfEN.registerInts)["my"], Math.floor($75b3f03462ab0244$var$previousMousePos.Y / 2));
            $75b3f03462ab0244$var$previousMousePos.X = $75b3f03462ab0244$var$currentMousePos.X;
            $75b3f03462ab0244$var$previousMousePos.Y = $75b3f03462ab0244$var$currentMousePos.Y;
            if (await (0, $bNfEN.goputer).isSubscribed((0, $bNfEN.interruptInts)["mm"])) await (0, $bNfEN.goputer).sendInterrupt((0, $bNfEN.interruptInts)["mm"]);
        }
        //Keyboard
        while((0, $7DyRn.default).keysDown.length > 0){
            await (0, $bNfEN.goputer).setRegister((0, $bNfEN.registerInts)["kc"], (0, $7DyRn.default).keysDown.pop());
            await (0, $bNfEN.goputer).setRegister((0, $bNfEN.registerInts)["kp"], 1);
            if (await (0, $bNfEN.goputer).isSubscribed((0, $bNfEN.interruptInts)["kd"])) await (0, $bNfEN.goputer).sendInterrupt((0, $bNfEN.interruptInts)["kd"]);
        }
        while((0, $7DyRn.default).keysUp.length > 0){
            await (0, $bNfEN.goputer).setRegister((0, $bNfEN.registerInts)["kc"], (0, $7DyRn.default).keysUp.pop());
            await (0, $bNfEN.goputer).setRegister((0, $bNfEN.registerInts)["kp"], 0);
            if (await (0, $bNfEN.goputer).isSubscribed((0, $bNfEN.interruptInts)["ku"])) await (0, $bNfEN.goputer).sendInterrupt((0, $bNfEN.interruptInts)["ku"]);
        }
        //IO Switches
        const switchQueueCopy = [
            ...(0, $7DyRn.default).switchQueue
        ];
        for (const element of switchQueueCopy){
            await (0, $bNfEN.goputer).setRegister((0, $bNfEN.registerInts)[element.register], element.enabled ? 1 : 0);
            console.log(element.register);
            if (await (0, $bNfEN.goputer).isSubscribed((0, $bNfEN.interruptInts)[element.register])) {
                console.log("subbed");
                await (0, $bNfEN.goputer).sendInterrupt((0, $bNfEN.interruptInts)[element.register]);
            }
        }
        (0, $7DyRn.default).switchQueue = [];
        //Update hardware info
        if ((0, $98dd9785d83e1f2f$export$fee647fc849da40e)((0, $10c90e54c8ae0167$export$dc61b14e6b2175fe))) (0, $10c90e54c8ae0167$export$dc61b14e6b2175fe).textContent = String(await (0, $bNfEN.goputer).currentItn);
        if ((0, $98dd9785d83e1f2f$export$fee647fc849da40e)((0, $10c90e54c8ae0167$export$90a0d993c601caf8))) (0, $10c90e54c8ae0167$export$90a0d993c601caf8).textContent = await $75b3f03462ab0244$export$eb4a8147dc332844((0, $bNfEN.registerInts)["prc"], "hex");
        if ((0, $7DyRn.default).registerPeekValue != null && await $75b3f03462ab0244$export$eb4a8147dc332844((0, $bNfEN.registerInts)[(0, $7DyRn.default).registerPeekValue], document.getElementById("peek-format-select").value) != (0, $7DyRn.default).prevRegPeekValue) {
            (0, $7DyRn.default).currentRegPeekValue = await $75b3f03462ab0244$export$eb4a8147dc332844((0, $bNfEN.registerInts)[(0, $7DyRn.default).registerPeekValue], document.getElementById("peek-format-select").value);
            (0, $10c90e54c8ae0167$export$ea454f442ecb1c77).textContent = (0, $7DyRn.default).currentRegPeekValue;
            (0, $7DyRn.default).prevRegPeekValue = (0, $7DyRn.default).currentRegPeekValue;
        }
        //Finally cycle VM & update graphics.
        $75b3f03462ab0244$var$uiUpdatesCompleted++;
    }
    if (await (0, $bNfEN.goputer).isFinished() && $75b3f03462ab0244$var$uiUpdatesCompleted != 0) {
        console.log(`Time elapsed: ${Date.now() - $75b3f03462ab0244$var$executionStartTime}ms`);
        console.log(`Average time per UI update: ${(Date.now() - $75b3f03462ab0244$var$executionStartTime) / $75b3f03462ab0244$var$uiUpdatesCompleted}ms`);
        $75b3f03462ab0244$var$executionStartTime = 0;
        $75b3f03462ab0244$var$uiUpdatesCompleted = 0;
        (0, $7DyRn.default).vmIsAlive = false;
        (0, $10c90e54c8ae0167$export$67ea982130081db).setAttribute("running", "false");
        $75b3f03462ab0244$export$64cd6327b1b8b7f9(false);
        return;
    }
}
function $75b3f03462ab0244$export$fd0c85d281559718(e) {
    let downloadLink = document.createElement("a");
    downloadLink.href = (0, $10c90e54c8ae0167$export$67ea982130081db).toDataURL("image/png");
    downloadLink.download = "video.png";
    downloadLink.click();
}



var $7DyRn = parcelRequire("7DyRn");
/// <reference types="./index.d.ts" />
/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /*
 * This program is based on JZlib 1.0.2 ymnk, JCraft,Inc.
 * JZlib is based on zlib-1.1.3, so all credit should go authors
 * Jean-loup Gailly(jloup@gzip.org) and Mark Adler(madler@alumni.caltech.edu)
 * and contributors of zlib.
 */ // deno-lint-ignore-file no-this-alias prefer-const
// Global
const $651421c71ecae26c$var$MAX_BITS = 15;
const $651421c71ecae26c$var$D_CODES = 30;
const $651421c71ecae26c$var$BL_CODES = 19;
const $651421c71ecae26c$var$LENGTH_CODES = 29;
const $651421c71ecae26c$var$LITERALS = 256;
const $651421c71ecae26c$var$L_CODES = $651421c71ecae26c$var$LITERALS + 1 + $651421c71ecae26c$var$LENGTH_CODES;
const $651421c71ecae26c$var$HEAP_SIZE = 2 * $651421c71ecae26c$var$L_CODES + 1;
const $651421c71ecae26c$var$END_BLOCK = 256;
// Bit length codes must not exceed MAX_BL_BITS bits
const $651421c71ecae26c$var$MAX_BL_BITS = 7;
// repeat previous bit length 3-6 times (2 bits of repeat count)
const $651421c71ecae26c$var$REP_3_6 = 16;
// repeat a zero length 3-10 times (3 bits of repeat count)
const $651421c71ecae26c$var$REPZ_3_10 = 17;
// repeat a zero length 11-138 times (7 bits of repeat count)
const $651421c71ecae26c$var$REPZ_11_138 = 18;
// The lengths of the bit length codes are sent in order of decreasing
// probability, to avoid transmitting the lengths for unused bit
// length codes.
const $651421c71ecae26c$var$Buf_size = 16;
// JZlib version : "1.0.2"
const $651421c71ecae26c$var$Z_DEFAULT_COMPRESSION = -1;
// compression strategy
const $651421c71ecae26c$var$Z_FILTERED = 1;
const $651421c71ecae26c$var$Z_HUFFMAN_ONLY = 2;
const $651421c71ecae26c$var$Z_DEFAULT_STRATEGY = 0;
const $651421c71ecae26c$var$Z_NO_FLUSH = 0;
const $651421c71ecae26c$var$Z_PARTIAL_FLUSH = 1;
const $651421c71ecae26c$var$Z_FULL_FLUSH = 3;
const $651421c71ecae26c$var$Z_FINISH = 4;
const $651421c71ecae26c$var$Z_OK = 0;
const $651421c71ecae26c$var$Z_STREAM_END = 1;
const $651421c71ecae26c$var$Z_NEED_DICT = 2;
const $651421c71ecae26c$var$Z_STREAM_ERROR = -2;
const $651421c71ecae26c$var$Z_DATA_ERROR = -3;
const $651421c71ecae26c$var$Z_BUF_ERROR = -5;
// Tree
function $651421c71ecae26c$var$extractArray(array) {
    return $651421c71ecae26c$var$flatArray(array.map(([length, value])=>new Array(length).fill(value, 0, length)));
}
function $651421c71ecae26c$var$flatArray(array) {
    return array.reduce((a, b)=>a.concat(Array.isArray(b) ? $651421c71ecae26c$var$flatArray(b) : b), []);
}
// see definition of array dist_code below
const $651421c71ecae26c$var$_dist_code = [
    0,
    1,
    2,
    3
].concat(...$651421c71ecae26c$var$extractArray([
    [
        2,
        4
    ],
    [
        2,
        5
    ],
    [
        4,
        6
    ],
    [
        4,
        7
    ],
    [
        8,
        8
    ],
    [
        8,
        9
    ],
    [
        16,
        10
    ],
    [
        16,
        11
    ],
    [
        32,
        12
    ],
    [
        32,
        13
    ],
    [
        64,
        14
    ],
    [
        64,
        15
    ],
    [
        2,
        0
    ],
    [
        1,
        16
    ],
    [
        1,
        17
    ],
    [
        2,
        18
    ],
    [
        2,
        19
    ],
    [
        4,
        20
    ],
    [
        4,
        21
    ],
    [
        8,
        22
    ],
    [
        8,
        23
    ],
    [
        16,
        24
    ],
    [
        16,
        25
    ],
    [
        32,
        26
    ],
    [
        32,
        27
    ],
    [
        64,
        28
    ],
    [
        64,
        29
    ]
]));
function $651421c71ecae26c$var$Tree() {
    const that = this;
    // dyn_tree; // the dynamic tree
    // max_code; // largest code with non zero frequency
    // stat_desc; // the corresponding static tree
    // Compute the optimal bit lengths for a tree and update the total bit
    // length
    // for the current block.
    // IN assertion: the fields freq and dad are set, heap[heap_max] and
    // above are the tree nodes sorted by increasing frequency.
    // OUT assertions: the field len is set to the optimal bit length, the
    // array bl_count contains the frequencies for each bit length.
    // The length opt_len is updated; static_len is also updated if stree is
    // not null.
    function gen_bitlen(s) {
        const tree = that.dyn_tree;
        const stree = that.stat_desc.static_tree;
        const extra = that.stat_desc.extra_bits;
        const base = that.stat_desc.extra_base;
        const max_length = that.stat_desc.max_length;
        let h; // heap index
        let n, m; // iterate over the tree elements
        let bits; // bit length
        let xbits; // extra bits
        let f; // frequency
        let overflow = 0; // number of elements with bit length too large
        for(bits = 0; bits <= $651421c71ecae26c$var$MAX_BITS; bits++)s.bl_count[bits] = 0;
        // In a first pass, compute the optimal bit lengths (which may
        // overflow in the case of the bit length tree).
        tree[s.heap[s.heap_max] * 2 + 1] = 0; // root of the heap
        for(h = s.heap_max + 1; h < $651421c71ecae26c$var$HEAP_SIZE; h++){
            n = s.heap[h];
            bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
            if (bits > max_length) {
                bits = max_length;
                overflow++;
            }
            tree[n * 2 + 1] = bits;
            // We overwrite tree[n*2+1] which is no longer needed
            if (n > that.max_code) continue; // not a leaf node
            s.bl_count[bits]++;
            xbits = 0;
            if (n >= base) xbits = extra[n - base];
            f = tree[n * 2];
            s.opt_len += f * (bits + xbits);
            if (stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
        }
        if (overflow === 0) return;
        // This happens for example on obj2 and pic of the Calgary corpus
        // Find the first bit length which could increase:
        do {
            bits = max_length - 1;
            while(s.bl_count[bits] === 0)bits--;
            s.bl_count[bits]--; // move one leaf down the tree
            s.bl_count[bits + 1] += 2; // move one overflow item as its brother
            s.bl_count[max_length]--;
            // The brother of the overflow item also moves one step up,
            // but this does not affect bl_count[max_length]
            overflow -= 2;
        }while (overflow > 0);
        for(bits = max_length; bits !== 0; bits--){
            n = s.bl_count[bits];
            while(n !== 0){
                m = s.heap[--h];
                if (m > that.max_code) continue;
                if (tree[m * 2 + 1] != bits) {
                    s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2];
                    tree[m * 2 + 1] = bits;
                }
                n--;
            }
        }
    }
    // Reverse the first len bits of a code, using straightforward code (a
    // faster
    // method would use a table)
    // IN assertion: 1 <= len <= 15
    function bi_reverse(code, len // its bit length
    ) {
        let res = 0;
        do {
            res |= code & 1;
            code >>>= 1;
            res <<= 1;
        }while (--len > 0);
        return res >>> 1;
    }
    // Generate the codes for a given tree and bit counts (which need not be
    // optimal).
    // IN assertion: the array bl_count contains the bit length statistics for
    // the given tree and the field len is set for all tree elements.
    // OUT assertion: the field code is set for all tree elements of non
    // zero code length.
    function gen_codes(tree, max_code, bl_count // number of codes at each bit length
    ) {
        const next_code = []; // next code value for each
        // bit length
        let code = 0; // running code value
        let bits; // bit index
        let n; // code index
        let len;
        // The distribution counts are first used to generate the code values
        // without bit reversal.
        for(bits = 1; bits <= $651421c71ecae26c$var$MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
        // Check that the bit counts in bl_count are consistent. The last code
        // must be all ones.
        // Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
        // "inconsistent bit counts");
        // Tracev((stderr,"gen_codes: max_code %d ", max_code));
        for(n = 0; n <= max_code; n++){
            len = tree[n * 2 + 1];
            if (len === 0) continue;
            // Now reverse the bits
            tree[n * 2] = bi_reverse(next_code[len]++, len);
        }
    }
    // Construct one Huffman tree and assigns the code bit strings and lengths.
    // Update the total bit length for the current block.
    // IN assertion: the field freq is set for all tree elements.
    // OUT assertions: the fields len and code are set to the optimal bit length
    // and corresponding code. The length opt_len is updated; static_len is
    // also updated if stree is not null. The field max_code is set.
    that.build_tree = function(s) {
        const tree = that.dyn_tree;
        const stree = that.stat_desc.static_tree;
        const elems = that.stat_desc.elems;
        let n, m; // iterate over heap elements
        let max_code = -1; // largest code with non zero frequency
        let node; // new node being created
        // Construct the initial heap, with least frequent element in
        // heap[1]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
        // heap[0] is not used.
        s.heap_len = 0;
        s.heap_max = $651421c71ecae26c$var$HEAP_SIZE;
        for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
            s.heap[++s.heap_len] = max_code = n;
            s.depth[n] = 0;
        } else tree[n * 2 + 1] = 0;
        // The pkzip format requires that at least one distance code exists,
        // and that at least one bit should be sent even if there is only one
        // possible code. So to avoid special checks later on we force at least
        // two codes of non zero frequency.
        while(s.heap_len < 2){
            node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
            tree[node * 2] = 1;
            s.depth[node] = 0;
            s.opt_len--;
            if (stree) s.static_len -= stree[node * 2 + 1];
        // node is 0 or 1 so it does not have extra bits
        }
        that.max_code = max_code;
        // The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
        // establish sub-heaps of increasing lengths:
        for(n = Math.floor(s.heap_len / 2); n >= 1; n--)s.pqdownheap(tree, n);
        // Construct the Huffman tree by repeatedly combining the least two
        // frequent nodes.
        node = elems; // next internal node of the tree
        do {
            // n = node of least frequency
            n = s.heap[1];
            s.heap[1] = s.heap[s.heap_len--];
            s.pqdownheap(tree, 1);
            m = s.heap[1]; // m = node of next least frequency
            s.heap[--s.heap_max] = n; // keep the nodes sorted by frequency
            s.heap[--s.heap_max] = m;
            // Create a new node father of n and m
            tree[node * 2] = tree[n * 2] + tree[m * 2];
            s.depth[node] = Math.max(s.depth[n], s.depth[m]) + 1;
            tree[n * 2 + 1] = tree[m * 2 + 1] = node;
            // and insert the new node in the heap
            s.heap[1] = node++;
            s.pqdownheap(tree, 1);
        }while (s.heap_len >= 2);
        s.heap[--s.heap_max] = s.heap[1];
        // At this point, the fields freq and dad are set. We can now
        // generate the bit lengths.
        gen_bitlen(s);
        // The field len is now set, we can generate the bit codes
        gen_codes(tree, that.max_code, s.bl_count);
    };
}
$651421c71ecae26c$var$Tree._length_code = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7
].concat(...$651421c71ecae26c$var$extractArray([
    [
        2,
        8
    ],
    [
        2,
        9
    ],
    [
        2,
        10
    ],
    [
        2,
        11
    ],
    [
        4,
        12
    ],
    [
        4,
        13
    ],
    [
        4,
        14
    ],
    [
        4,
        15
    ],
    [
        8,
        16
    ],
    [
        8,
        17
    ],
    [
        8,
        18
    ],
    [
        8,
        19
    ],
    [
        16,
        20
    ],
    [
        16,
        21
    ],
    [
        16,
        22
    ],
    [
        16,
        23
    ],
    [
        32,
        24
    ],
    [
        32,
        25
    ],
    [
        32,
        26
    ],
    [
        31,
        27
    ],
    [
        1,
        28
    ]
]));
$651421c71ecae26c$var$Tree.base_length = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    10,
    12,
    14,
    16,
    20,
    24,
    28,
    32,
    40,
    48,
    56,
    64,
    80,
    96,
    112,
    128,
    160,
    192,
    224,
    0
];
$651421c71ecae26c$var$Tree.base_dist = [
    0,
    1,
    2,
    3,
    4,
    6,
    8,
    12,
    16,
    24,
    32,
    48,
    64,
    96,
    128,
    192,
    256,
    384,
    512,
    768,
    1024,
    1536,
    2048,
    3072,
    4096,
    6144,
    8192,
    12288,
    16384,
    24576
];
// Mapping from a distance to a distance code. dist is the distance - 1 and
// must not have side effects. _dist_code[256] and _dist_code[257] are never
// used.
$651421c71ecae26c$var$Tree.d_code = function(dist) {
    return dist < 256 ? $651421c71ecae26c$var$_dist_code[dist] : $651421c71ecae26c$var$_dist_code[256 + (dist >>> 7)];
};
// extra bits for each length code
$651421c71ecae26c$var$Tree.extra_lbits = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
// extra bits for each distance code
$651421c71ecae26c$var$Tree.extra_dbits = [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
// extra bits for each bit length code
$651421c71ecae26c$var$Tree.extra_blbits = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
$651421c71ecae26c$var$Tree.bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
// StaticTree
function $651421c71ecae26c$var$StaticTree(static_tree, extra_bits, extra_base, elems, max_length) {
    const that = this;
    that.static_tree = static_tree;
    that.extra_bits = extra_bits;
    that.extra_base = extra_base;
    that.elems = elems;
    that.max_length = max_length;
}
const $651421c71ecae26c$var$static_ltree2_first_part = [
    12,
    140,
    76,
    204,
    44,
    172,
    108,
    236,
    28,
    156,
    92,
    220,
    60,
    188,
    124,
    252,
    2,
    130,
    66,
    194,
    34,
    162,
    98,
    226,
    18,
    146,
    82,
    210,
    50,
    178,
    114,
    242,
    10,
    138,
    74,
    202,
    42,
    170,
    106,
    234,
    26,
    154,
    90,
    218,
    58,
    186,
    122,
    250,
    6,
    134,
    70,
    198,
    38,
    166,
    102,
    230,
    22,
    150,
    86,
    214,
    54,
    182,
    118,
    246,
    14,
    142,
    78,
    206,
    46,
    174,
    110,
    238,
    30,
    158,
    94,
    222,
    62,
    190,
    126,
    254,
    1,
    129,
    65,
    193,
    33,
    161,
    97,
    225,
    17,
    145,
    81,
    209,
    49,
    177,
    113,
    241,
    9,
    137,
    73,
    201,
    41,
    169,
    105,
    233,
    25,
    153,
    89,
    217,
    57,
    185,
    121,
    249,
    5,
    133,
    69,
    197,
    37,
    165,
    101,
    229,
    21,
    149,
    85,
    213,
    53,
    181,
    117,
    245,
    13,
    141,
    77,
    205,
    45,
    173,
    109,
    237,
    29,
    157,
    93,
    221,
    61,
    189,
    125,
    253,
    19,
    275,
    147,
    403,
    83,
    339,
    211,
    467,
    51,
    307,
    179,
    435,
    115,
    371,
    243,
    499,
    11,
    267,
    139,
    395,
    75,
    331,
    203,
    459,
    43,
    299,
    171,
    427,
    107,
    363,
    235,
    491,
    27,
    283,
    155,
    411,
    91,
    347,
    219,
    475,
    59,
    315,
    187,
    443,
    123,
    379,
    251,
    507,
    7,
    263,
    135,
    391,
    71,
    327,
    199,
    455,
    39,
    295,
    167,
    423,
    103,
    359,
    231,
    487,
    23,
    279,
    151,
    407,
    87,
    343,
    215,
    471,
    55,
    311,
    183,
    439,
    119,
    375,
    247,
    503,
    15,
    271,
    143,
    399,
    79,
    335,
    207,
    463,
    47,
    303,
    175,
    431,
    111,
    367,
    239,
    495,
    31,
    287,
    159,
    415,
    95,
    351,
    223,
    479,
    63,
    319,
    191,
    447,
    127,
    383,
    255,
    511,
    0,
    64,
    32,
    96,
    16,
    80,
    48,
    112,
    8,
    72,
    40,
    104,
    24,
    88,
    56,
    120,
    4,
    68,
    36,
    100,
    20,
    84,
    52,
    116,
    3,
    131,
    67,
    195,
    35,
    163,
    99,
    227
];
const $651421c71ecae26c$var$static_ltree2_second_part = $651421c71ecae26c$var$extractArray([
    [
        144,
        8
    ],
    [
        112,
        9
    ],
    [
        24,
        7
    ],
    [
        8,
        8
    ]
]);
$651421c71ecae26c$var$StaticTree.static_ltree = $651421c71ecae26c$var$flatArray($651421c71ecae26c$var$static_ltree2_first_part.map((value, index)=>[
        value,
        $651421c71ecae26c$var$static_ltree2_second_part[index]
    ]));
const $651421c71ecae26c$var$static_dtree_first_part = [
    0,
    16,
    8,
    24,
    4,
    20,
    12,
    28,
    2,
    18,
    10,
    26,
    6,
    22,
    14,
    30,
    1,
    17,
    9,
    25,
    5,
    21,
    13,
    29,
    3,
    19,
    11,
    27,
    7,
    23
];
const $651421c71ecae26c$var$static_dtree_second_part = $651421c71ecae26c$var$extractArray([
    [
        30,
        5
    ]
]);
$651421c71ecae26c$var$StaticTree.static_dtree = $651421c71ecae26c$var$flatArray($651421c71ecae26c$var$static_dtree_first_part.map((value, index)=>[
        value,
        $651421c71ecae26c$var$static_dtree_second_part[index]
    ]));
$651421c71ecae26c$var$StaticTree.static_l_desc = new $651421c71ecae26c$var$StaticTree($651421c71ecae26c$var$StaticTree.static_ltree, $651421c71ecae26c$var$Tree.extra_lbits, $651421c71ecae26c$var$LITERALS + 1, $651421c71ecae26c$var$L_CODES, $651421c71ecae26c$var$MAX_BITS);
$651421c71ecae26c$var$StaticTree.static_d_desc = new $651421c71ecae26c$var$StaticTree($651421c71ecae26c$var$StaticTree.static_dtree, $651421c71ecae26c$var$Tree.extra_dbits, 0, $651421c71ecae26c$var$D_CODES, $651421c71ecae26c$var$MAX_BITS);
$651421c71ecae26c$var$StaticTree.static_bl_desc = new $651421c71ecae26c$var$StaticTree(null, $651421c71ecae26c$var$Tree.extra_blbits, 0, $651421c71ecae26c$var$BL_CODES, $651421c71ecae26c$var$MAX_BL_BITS);
// Deflate
const $651421c71ecae26c$var$MAX_MEM_LEVEL = 9;
const $651421c71ecae26c$var$DEF_MEM_LEVEL = 8;
function $651421c71ecae26c$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    const that = this;
    that.good_length = good_length;
    that.max_lazy = max_lazy;
    that.nice_length = nice_length;
    that.max_chain = max_chain;
    that.func = func;
}
const $651421c71ecae26c$var$STORED = 0;
const $651421c71ecae26c$var$FAST = 1;
const $651421c71ecae26c$var$SLOW = 2;
const $651421c71ecae26c$var$config_table = [
    new $651421c71ecae26c$var$Config(0, 0, 0, 0, $651421c71ecae26c$var$STORED),
    new $651421c71ecae26c$var$Config(4, 4, 8, 4, $651421c71ecae26c$var$FAST),
    new $651421c71ecae26c$var$Config(4, 5, 16, 8, $651421c71ecae26c$var$FAST),
    new $651421c71ecae26c$var$Config(4, 6, 32, 32, $651421c71ecae26c$var$FAST),
    new $651421c71ecae26c$var$Config(4, 4, 16, 16, $651421c71ecae26c$var$SLOW),
    new $651421c71ecae26c$var$Config(8, 16, 32, 32, $651421c71ecae26c$var$SLOW),
    new $651421c71ecae26c$var$Config(8, 16, 128, 128, $651421c71ecae26c$var$SLOW),
    new $651421c71ecae26c$var$Config(8, 32, 128, 256, $651421c71ecae26c$var$SLOW),
    new $651421c71ecae26c$var$Config(32, 128, 258, 1024, $651421c71ecae26c$var$SLOW),
    new $651421c71ecae26c$var$Config(32, 258, 258, 4096, $651421c71ecae26c$var$SLOW)
];
const $651421c71ecae26c$var$z_errmsg = [
    "need dictionary",
    // 2
    "stream end",
    "",
    "",
    "stream error",
    "data error",
    "",
    "buffer error",
    "",
    ""
];
// block not completed, need more input or more output
const $651421c71ecae26c$var$NeedMore = 0;
// block flush performed
const $651421c71ecae26c$var$BlockDone = 1;
// finish started, need only more output at next deflate
const $651421c71ecae26c$var$FinishStarted = 2;
// finish done, accept no more input or output
const $651421c71ecae26c$var$FinishDone = 3;
// preset dictionary flag in zlib header
const $651421c71ecae26c$var$PRESET_DICT = 0x20;
const $651421c71ecae26c$var$INIT_STATE = 42;
const $651421c71ecae26c$var$BUSY_STATE = 113;
const $651421c71ecae26c$var$FINISH_STATE = 666;
// The deflate compression method
const $651421c71ecae26c$var$Z_DEFLATED = 8;
const $651421c71ecae26c$var$STORED_BLOCK = 0;
const $651421c71ecae26c$var$STATIC_TREES = 1;
const $651421c71ecae26c$var$DYN_TREES = 2;
const $651421c71ecae26c$var$MIN_MATCH = 3;
const $651421c71ecae26c$var$MAX_MATCH = 258;
const $651421c71ecae26c$var$MIN_LOOKAHEAD = $651421c71ecae26c$var$MAX_MATCH + $651421c71ecae26c$var$MIN_MATCH + 1;
function $651421c71ecae26c$var$smaller(tree, n, m, depth) {
    const tn2 = tree[n * 2];
    const tm2 = tree[m * 2];
    return tn2 < tm2 || tn2 == tm2 && depth[n] <= depth[m];
}
function $651421c71ecae26c$var$Deflate() {
    const that = this;
    let strm; // pointer back to this zlib stream
    let status; // as the name implies
    // pending_buf; // output still pending
    let pending_buf_size; // size of pending_buf
    // pending_out; // next pending byte to output to the stream
    // pending; // nb of bytes in the pending buffer
    // dist_buf; // buffer for distances
    // lc_buf; // buffer for literals or lengths
    // To simplify the code, dist_buf and lc_buf have the same number of elements.
    // To use different lengths, an extra flag array would be necessary.
    let last_flush; // value of flush param for previous deflate call
    let w_size; // LZ77 win size (32K by default)
    let w_bits; // log2(w_size) (8..16)
    let w_mask; // w_size - 1
    let win;
    // Sliding win. Input bytes are read into the second half of the win,
    // and move to the first half later to keep a dictionary of at least wSize
    // bytes. With this organization, matches are limited to a distance of
    // wSize-MAX_MATCH bytes, but this ensures that IO is always
    // performed with a length multiple of the block size. Also, it limits
    // the win size to 64K, which is quite useful on MSDOS.
    // To do: use the user input buffer as sliding win.
    let window_size;
    // Actual size of win: 2*wSize, except when the user input buffer
    // is directly used as sliding win.
    let prev;
    // Link to older string with same hash index. To limit the size of this
    // array to 64K, this link is maintained only for the last 32K strings.
    // An index in this array is thus a win index modulo 32K.
    let head; // Heads of the hash chains or NIL.
    let ins_h; // hash index of string to be inserted
    let hash_size; // number of elements in hash table
    let hash_bits; // log2(hash_size)
    let hash_mask; // hash_size-1
    // Number of bits by which ins_h must be shifted at each input
    // step. It must be such that after MIN_MATCH steps, the oldest
    // byte no longer takes part in the hash key, that is:
    // hash_shift * MIN_MATCH >= hash_bits
    let hash_shift;
    // Window position at the beginning of the current output block. Gets
    // negative when the win is moved backwards.
    let block_start;
    let match_length; // length of best match
    let prev_match; // previous match
    let match_available; // set if previous match exists
    let strstart; // start of string to insert
    let match_start; // start of matching string
    let lookahead; // number of valid bytes ahead in win
    // Length of the best match at previous step. Matches not greater than this
    // are discarded. This is used in the lazy match evaluation.
    let prev_length;
    // To speed up deflation, hash chains are never searched beyond this
    // length. A higher limit improves compression ratio but degrades the speed.
    let max_chain_length;
    // Attempt to find a better match only when the current match is strictly
    // smaller than this value. This mechanism is used only for compression
    // levels >= 4.
    let max_lazy_match;
    // Insert new strings in the hash table only if the match length is not
    // greater than this length. This saves time but degrades compression.
    // max_insert_length is used only for compression levels <= 3.
    let level; // compression level (1..9)
    let strategy; // favor or force Huffman coding
    // Use a faster search when the previous match is longer than this
    let good_match;
    // Stop searching when current match exceeds this
    let nice_match;
    let dyn_ltree; // literal and length tree
    let dyn_dtree; // distance tree
    let bl_tree; // Huffman tree for bit lengths
    const l_desc = new $651421c71ecae26c$var$Tree(); // desc for literal tree
    const d_desc = new $651421c71ecae26c$var$Tree(); // desc for distance tree
    const bl_desc = new $651421c71ecae26c$var$Tree(); // desc for bit length tree
    // that.heap_len; // number of elements in the heap
    // that.heap_max; // element of largest frequency
    // The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
    // The same heap array is used to build all trees.
    // Depth of each subtree used as tie breaker for trees of equal frequency
    that.depth = [];
    // Size of match buffer for literals/lengths. There are 4 reasons for
    // limiting lit_bufsize to 64K:
    // - frequencies can be kept in 16 bit counters
    // - if compression is not successful for the first block, all input
    // data is still in the win so we can still emit a stored block even
    // when input comes from standard input. (This can also be done for
    // all blocks if lit_bufsize is not greater than 32K.)
    // - if compression is not successful for a file smaller than 64K, we can
    // even emit a stored file instead of a stored block (saving 5 bytes).
    // This is applicable only for zip (not gzip or zlib).
    // - creating new Huffman trees less frequently may not provide fast
    // adaptation to changes in the input data statistics. (Take for
    // example a binary file with poorly compressible code followed by
    // a highly compressible string table.) Smaller buffer sizes give
    // fast adaptation but have of course the overhead of transmitting
    // trees more frequently.
    // - I can't count above 4
    let lit_bufsize;
    let last_lit; // running index in dist_buf and lc_buf
    // that.opt_len; // bit length of current block with optimal trees
    // that.static_len; // bit length of current block with static trees
    let matches; // number of string matches in current block
    let last_eob_len; // bit length of EOB code for last block
    // Output buffer. bits are inserted starting at the bottom (least
    // significant bits).
    let bi_buf;
    // Number of valid bits in bi_buf. All bits above the last valid bit
    // are always zero.
    let bi_valid;
    // number of codes at each bit length for an optimal tree
    that.bl_count = [];
    // heap used to build the Huffman trees
    that.heap = [];
    dyn_ltree = [];
    dyn_dtree = [];
    bl_tree = [];
    function lm_init() {
        window_size = 2 * w_size;
        head[hash_size - 1] = 0;
        for(let i = 0; i < hash_size - 1; i++)head[i] = 0;
        // Set the default configuration parameters:
        max_lazy_match = $651421c71ecae26c$var$config_table[level].max_lazy;
        good_match = $651421c71ecae26c$var$config_table[level].good_length;
        nice_match = $651421c71ecae26c$var$config_table[level].nice_length;
        max_chain_length = $651421c71ecae26c$var$config_table[level].max_chain;
        strstart = 0;
        block_start = 0;
        lookahead = 0;
        match_length = prev_length = $651421c71ecae26c$var$MIN_MATCH - 1;
        match_available = 0;
        ins_h = 0;
    }
    function init_block() {
        let i;
        // Initialize the trees.
        for(i = 0; i < $651421c71ecae26c$var$L_CODES; i++)dyn_ltree[i * 2] = 0;
        for(i = 0; i < $651421c71ecae26c$var$D_CODES; i++)dyn_dtree[i * 2] = 0;
        for(i = 0; i < $651421c71ecae26c$var$BL_CODES; i++)bl_tree[i * 2] = 0;
        dyn_ltree[$651421c71ecae26c$var$END_BLOCK * 2] = 1;
        that.opt_len = that.static_len = 0;
        last_lit = matches = 0;
    }
    // Initialize the tree data structures for a new zlib stream.
    function tr_init() {
        l_desc.dyn_tree = dyn_ltree;
        l_desc.stat_desc = $651421c71ecae26c$var$StaticTree.static_l_desc;
        d_desc.dyn_tree = dyn_dtree;
        d_desc.stat_desc = $651421c71ecae26c$var$StaticTree.static_d_desc;
        bl_desc.dyn_tree = bl_tree;
        bl_desc.stat_desc = $651421c71ecae26c$var$StaticTree.static_bl_desc;
        bi_buf = 0;
        bi_valid = 0;
        last_eob_len = 8; // enough lookahead for inflate
        // Initialize the first block of the first file:
        init_block();
    }
    // Restore the heap property by moving down the tree starting at node k,
    // exchanging a node with the smallest of its two sons if necessary,
    // stopping
    // when the heap property is re-established (each father smaller than its
    // two sons).
    that.pqdownheap = function(tree, k // node to move down
    ) {
        const heap = that.heap;
        const v = heap[k];
        let j = k << 1; // left son of k
        while(j <= that.heap_len){
            // Set j to the smallest of the two sons:
            if (j < that.heap_len && $651421c71ecae26c$var$smaller(tree, heap[j + 1], heap[j], that.depth)) j++;
            // Exit if v is smaller than both sons
            if ($651421c71ecae26c$var$smaller(tree, v, heap[j], that.depth)) break;
            // Exchange v with the smallest son
            heap[k] = heap[j];
            k = j;
            // And continue down the tree, setting j to the left son of k
            j <<= 1;
        }
        heap[k] = v;
    };
    // Scan a literal or distance tree to determine the frequencies of the codes
    // in the bit length tree.
    function scan_tree(tree, max_code // and its largest code of non zero frequency
    ) {
        let prevlen = -1; // last emitted length
        let curlen; // length of current code
        let nextlen = tree[1]; // length of next code
        let count = 0; // repeat count of the current code
        let max_count = 7; // max repeat count
        let min_count = 4; // min repeat count
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        }
        tree[(max_code + 1) * 2 + 1] = 0xffff; // guard
        for(let n = 0; n <= max_code; n++){
            curlen = nextlen;
            nextlen = tree[(n + 1) * 2 + 1];
            if (++count < max_count && curlen == nextlen) continue;
            else if (count < min_count) bl_tree[curlen * 2] += count;
            else if (curlen !== 0) {
                if (curlen != prevlen) bl_tree[curlen * 2]++;
                bl_tree[$651421c71ecae26c$var$REP_3_6 * 2]++;
            } else if (count <= 10) bl_tree[$651421c71ecae26c$var$REPZ_3_10 * 2]++;
            else bl_tree[$651421c71ecae26c$var$REPZ_11_138 * 2]++;
            count = 0;
            prevlen = curlen;
            if (nextlen === 0) {
                max_count = 138;
                min_count = 3;
            } else if (curlen == nextlen) {
                max_count = 6;
                min_count = 3;
            } else {
                max_count = 7;
                min_count = 4;
            }
        }
    }
    // Construct the Huffman tree for the bit lengths and return the index in
    // bl_order of the last bit length code to send.
    function build_bl_tree() {
        let max_blindex; // index of last bit length code of non zero freq
        // Determine the bit length frequencies for literal and distance trees
        scan_tree(dyn_ltree, l_desc.max_code);
        scan_tree(dyn_dtree, d_desc.max_code);
        // Build the bit length tree:
        bl_desc.build_tree(that);
        // opt_len now includes the length of the tree representations, except
        // the lengths of the bit lengths codes and the 5+5+4 bits for the
        // counts.
        // Determine the number of bit length codes to send. The pkzip format
        // requires that at least 4 bit length codes be sent. (appnote.txt says
        // 3 but the actual value used is 4.)
        for(max_blindex = $651421c71ecae26c$var$BL_CODES - 1; max_blindex >= 3; max_blindex--){
            if (bl_tree[$651421c71ecae26c$var$Tree.bl_order[max_blindex] * 2 + 1] !== 0) break;
        }
        // Update opt_len to include the bit length tree and counts
        that.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
        return max_blindex;
    }
    // Output a byte on the stream.
    // IN assertion: there is enough room in pending_buf.
    function put_byte(p) {
        that.pending_buf[that.pending++] = p;
    }
    function put_short(w) {
        put_byte(w & 0xff);
        put_byte(w >>> 8 & 0xff);
    }
    function putShortMSB(b) {
        put_byte(b >> 8 & 0xff);
        put_byte(b & 255);
    }
    function send_bits(value, length) {
        let val;
        const len = length;
        if (bi_valid > $651421c71ecae26c$var$Buf_size - len) {
            val = value;
            // bi_buf |= (val << bi_valid);
            bi_buf |= val << bi_valid & 0xffff;
            put_short(bi_buf);
            bi_buf = val >>> $651421c71ecae26c$var$Buf_size - bi_valid;
            bi_valid += len - $651421c71ecae26c$var$Buf_size;
        } else {
            // bi_buf |= (value) << bi_valid;
            bi_buf |= value << bi_valid & 0xffff;
            bi_valid += len;
        }
    }
    function send_code(c, tree) {
        const c2 = c * 2;
        send_bits(tree[c2] & 0xffff, tree[c2 + 1] & 0xffff);
    }
    // Send a literal or distance tree in compressed form, using the codes in
    // bl_tree.
    function send_tree(tree, max_code // and its largest code of non zero frequency
    ) {
        let n; // iterates over all tree elements
        let prevlen = -1; // last emitted length
        let curlen; // length of current code
        let nextlen = tree[1]; // length of next code
        let count = 0; // repeat count of the current code
        let max_count = 7; // max repeat count
        let min_count = 4; // min repeat count
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        }
        for(n = 0; n <= max_code; n++){
            curlen = nextlen;
            nextlen = tree[(n + 1) * 2 + 1];
            if (++count < max_count && curlen == nextlen) continue;
            else if (count < min_count) do send_code(curlen, bl_tree);
            while (--count !== 0);
            else if (curlen !== 0) {
                if (curlen != prevlen) {
                    send_code(curlen, bl_tree);
                    count--;
                }
                send_code($651421c71ecae26c$var$REP_3_6, bl_tree);
                send_bits(count - 3, 2);
            } else if (count <= 10) {
                send_code($651421c71ecae26c$var$REPZ_3_10, bl_tree);
                send_bits(count - 3, 3);
            } else {
                send_code($651421c71ecae26c$var$REPZ_11_138, bl_tree);
                send_bits(count - 11, 7);
            }
            count = 0;
            prevlen = curlen;
            if (nextlen === 0) {
                max_count = 138;
                min_count = 3;
            } else if (curlen == nextlen) {
                max_count = 6;
                min_count = 3;
            } else {
                max_count = 7;
                min_count = 4;
            }
        }
    }
    // Send the header for a block using dynamic Huffman trees: the counts, the
    // lengths of the bit length codes, the literal tree and the distance tree.
    // IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
    function send_all_trees(lcodes, dcodes, blcodes) {
        let rank; // index in bl_order
        send_bits(lcodes - 257, 5); // not +255 as stated in appnote.txt
        send_bits(dcodes - 1, 5);
        send_bits(blcodes - 4, 4); // not -3 as stated in appnote.txt
        for(rank = 0; rank < blcodes; rank++)send_bits(bl_tree[$651421c71ecae26c$var$Tree.bl_order[rank] * 2 + 1], 3);
        send_tree(dyn_ltree, lcodes - 1); // literal tree
        send_tree(dyn_dtree, dcodes - 1); // distance tree
    }
    // Flush the bit buffer, keeping at most 7 bits in it.
    function bi_flush() {
        if (bi_valid == 16) {
            put_short(bi_buf);
            bi_buf = 0;
            bi_valid = 0;
        } else if (bi_valid >= 8) {
            put_byte(bi_buf & 0xff);
            bi_buf >>>= 8;
            bi_valid -= 8;
        }
    }
    // Send one empty static block to give enough lookahead for inflate.
    // This takes 10 bits, of which 7 may remain in the bit buffer.
    // The current inflate code requires 9 bits of lookahead. If the
    // last two codes for the previous block (real code plus EOB) were coded
    // on 5 bits or less, inflate may have only 5+3 bits of lookahead to decode
    // the last real code. In this case we send two empty static blocks instead
    // of one. (There are no problems if the previous block is stored or fixed.)
    // To simplify the code, we assume the worst case of last real code encoded
    // on one bit only.
    function _tr_align() {
        send_bits($651421c71ecae26c$var$STATIC_TREES << 1, 3);
        send_code($651421c71ecae26c$var$END_BLOCK, $651421c71ecae26c$var$StaticTree.static_ltree);
        bi_flush();
        // Of the 10 bits for the empty block, we have already sent
        // (10 - bi_valid) bits. The lookahead for the last real code (before
        // the EOB of the previous block) was thus at least one plus the length
        // of the EOB plus what we have just sent of the empty static block.
        if (1 + last_eob_len + 10 - bi_valid < 9) {
            send_bits($651421c71ecae26c$var$STATIC_TREES << 1, 3);
            send_code($651421c71ecae26c$var$END_BLOCK, $651421c71ecae26c$var$StaticTree.static_ltree);
            bi_flush();
        }
        last_eob_len = 7;
    }
    // Save the match info and tally the frequency counts. Return true if
    // the current block must be flushed.
    function _tr_tally(dist, lc // match length-MIN_MATCH or unmatched char (if dist==0)
    ) {
        let out_length, in_length, dcode;
        that.dist_buf[last_lit] = dist;
        that.lc_buf[last_lit] = lc & 0xff;
        last_lit++;
        if (dist === 0) // lc is the unmatched char
        dyn_ltree[lc * 2]++;
        else {
            matches++;
            // Here, lc is the match length - MIN_MATCH
            dist--; // dist = match distance - 1
            dyn_ltree[($651421c71ecae26c$var$Tree._length_code[lc] + $651421c71ecae26c$var$LITERALS + 1) * 2]++;
            dyn_dtree[$651421c71ecae26c$var$Tree.d_code(dist) * 2]++;
        }
        if ((last_lit & 0x1fff) === 0 && level > 2) {
            // Compute an upper bound for the compressed length
            out_length = last_lit * 8;
            in_length = strstart - block_start;
            for(dcode = 0; dcode < $651421c71ecae26c$var$D_CODES; dcode++)out_length += dyn_dtree[dcode * 2] * (5 + $651421c71ecae26c$var$Tree.extra_dbits[dcode]);
            out_length >>>= 3;
            if (matches < Math.floor(last_lit / 2) && out_length < Math.floor(in_length / 2)) return true;
        }
        return last_lit == lit_bufsize - 1;
    // We avoid equality with lit_bufsize because of wraparound at 64K
    // on 16 bit machines and because stored blocks are restricted to
    // 64K-1 bytes.
    }
    // Send the block data compressed using the given Huffman trees
    function compress_block(ltree, dtree) {
        let dist; // distance of matched string
        let lc; // match length or unmatched char (if dist === 0)
        let lx = 0; // running index in dist_buf and lc_buf
        let code; // the code to send
        let extra; // number of extra bits to send
        if (last_lit !== 0) do {
            dist = that.dist_buf[lx];
            lc = that.lc_buf[lx];
            lx++;
            if (dist === 0) send_code(lc, ltree); // send a literal byte
            else {
                // Here, lc is the match length - MIN_MATCH
                code = $651421c71ecae26c$var$Tree._length_code[lc];
                send_code(code + $651421c71ecae26c$var$LITERALS + 1, ltree); // send the length
                // code
                extra = $651421c71ecae26c$var$Tree.extra_lbits[code];
                if (extra !== 0) {
                    lc -= $651421c71ecae26c$var$Tree.base_length[code];
                    send_bits(lc, extra); // send the extra length bits
                }
                dist--; // dist is now the match distance - 1
                code = $651421c71ecae26c$var$Tree.d_code(dist);
                send_code(code, dtree); // send the distance code
                extra = $651421c71ecae26c$var$Tree.extra_dbits[code];
                if (extra !== 0) {
                    dist -= $651421c71ecae26c$var$Tree.base_dist[code];
                    send_bits(dist, extra); // send the extra distance bits
                }
            } // literal or match pair ?
        }while (lx < last_lit);
        send_code($651421c71ecae26c$var$END_BLOCK, ltree);
        last_eob_len = ltree[$651421c71ecae26c$var$END_BLOCK * 2 + 1];
    }
    // Flush the bit buffer and align the output on a byte boundary
    function bi_windup() {
        if (bi_valid > 8) put_short(bi_buf);
        else if (bi_valid > 0) put_byte(bi_buf & 0xff);
        bi_buf = 0;
        bi_valid = 0;
    }
    // Copy a stored block, storing first the length and its
    // one's complement if requested.
    function copy_block(buf, len, header // true if block header must be written
    ) {
        bi_windup(); // align on byte boundary
        last_eob_len = 8; // enough lookahead for inflate
        if (header) {
            put_short(len);
            put_short(~len);
        }
        that.pending_buf.set(win.subarray(buf, buf + len), that.pending);
        that.pending += len;
    }
    // Send a stored block
    function _tr_stored_block(buf, stored_len, eof // true if this is the last block for a file
    ) {
        send_bits(($651421c71ecae26c$var$STORED_BLOCK << 1) + (eof ? 1 : 0), 3); // send block type
        copy_block(buf, stored_len, true); // with header
    }
    // Determine the best encoding for the current block: dynamic trees, static
    // trees or store, and output the encoded block to the zip file.
    function _tr_flush_block(buf, stored_len, eof // true if this is the last block for a file
    ) {
        let opt_lenb, static_lenb; // opt_len and static_len in bytes
        let max_blindex = 0; // index of last bit length code of non zero freq
        // Build the Huffman trees unless a stored block is forced
        if (level > 0) {
            // Construct the literal and distance trees
            l_desc.build_tree(that);
            d_desc.build_tree(that);
            // At this point, opt_len and static_len are the total bit lengths
            // of
            // the compressed block data, excluding the tree representations.
            // Build the bit length tree for the above two trees, and get the
            // index
            // in bl_order of the last bit length code to send.
            max_blindex = build_bl_tree();
            // Determine the best encoding. Compute first the block length in
            // bytes
            opt_lenb = that.opt_len + 3 + 7 >>> 3;
            static_lenb = that.static_len + 3 + 7 >>> 3;
            if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
        } else opt_lenb = static_lenb = stored_len + 5; // force a stored block
        if (stored_len + 4 <= opt_lenb && buf != -1) // 4: two words for the lengths
        // The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
        // Otherwise we can't have processed more than WSIZE input bytes
        // since
        // the last block flush, because compression would have been
        // successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
        // transform a block into a stored block.
        _tr_stored_block(buf, stored_len, eof);
        else if (static_lenb == opt_lenb) {
            send_bits(($651421c71ecae26c$var$STATIC_TREES << 1) + (eof ? 1 : 0), 3);
            compress_block($651421c71ecae26c$var$StaticTree.static_ltree, $651421c71ecae26c$var$StaticTree.static_dtree);
        } else {
            send_bits(($651421c71ecae26c$var$DYN_TREES << 1) + (eof ? 1 : 0), 3);
            send_all_trees(l_desc.max_code + 1, d_desc.max_code + 1, max_blindex + 1);
            compress_block(dyn_ltree, dyn_dtree);
        }
        // The above check is made mod 2^32, for files larger than 512 MB
        // and uLong implemented on 32 bits.
        init_block();
        if (eof) bi_windup();
    }
    function flush_block_only(eof) {
        _tr_flush_block(block_start >= 0 ? block_start : -1, strstart - block_start, eof);
        block_start = strstart;
        strm.flush_pending();
    }
    // Fill the win when the lookahead becomes insufficient.
    // Updates strstart and lookahead.
    //
    // IN assertion: lookahead < MIN_LOOKAHEAD
    // OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
    // At least one byte has been read, or avail_in === 0; reads are
    // performed for at least two bytes (required for the zip translate_eol
    // option -- not supported here).
    function fill_window() {
        let n, m;
        let p;
        let more; // Amount of free space at the end of the win.
        do {
            more = window_size - lookahead - strstart;
            // Deal with !@#$% 64K limit:
            if (more === 0 && strstart === 0 && lookahead === 0) more = w_size;
            else if (more == -1) // Very unlikely, but possible on 16 bit machine if strstart ==
            // 0
            // and lookahead == 1 (input done one byte at time)
            more--;
            else if (strstart >= w_size + w_size - $651421c71ecae26c$var$MIN_LOOKAHEAD) {
                win.set(win.subarray(w_size, w_size + w_size), 0);
                match_start -= w_size;
                strstart -= w_size; // we now have strstart >= MAX_DIST
                block_start -= w_size;
                // Slide the hash table (could be avoided with 32 bit values
                // at the expense of memory usage). We slide even when level ==
                // 0
                // to keep the hash table consistent if we switch back to level
                // > 0
                // later. (Using level 0 permanently is not an optimal usage of
                // zlib, so we don't care about this pathological case.)
                n = hash_size;
                p = n;
                do {
                    m = head[--p] & 0xffff;
                    head[p] = m >= w_size ? m - w_size : 0;
                }while (--n !== 0);
                n = w_size;
                p = n;
                do {
                    m = prev[--p] & 0xffff;
                    prev[p] = m >= w_size ? m - w_size : 0;
                // If n is not on any hash chain, prev[n] is garbage but
                // its value will never be used.
                }while (--n !== 0);
                more += w_size;
            }
            if (strm.avail_in === 0) return;
            // If there was no sliding:
            // strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
            // more == window_size - lookahead - strstart
            // => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
            // => more >= window_size - 2*WSIZE + 2
            // In the BIG_MEM or MMAP case (not yet supported),
            // window_size == input_size + MIN_LOOKAHEAD &&
            // strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
            // Otherwise, window_size == 2*WSIZE so more >= 2.
            // If there was sliding, more >= WSIZE. So in all cases, more >= 2.
            n = strm.read_buf(win, strstart + lookahead, more);
            lookahead += n;
            // Initialize the hash value now that we have some input:
            if (lookahead >= $651421c71ecae26c$var$MIN_MATCH) {
                ins_h = win[strstart] & 0xff;
                ins_h = (ins_h << hash_shift ^ win[strstart + 1] & 0xff) & hash_mask;
            }
        // If the whole input has less than MIN_MATCH bytes, ins_h is
        // garbage,
        // but this is not important since only literal bytes will be
        // emitted.
        }while (lookahead < $651421c71ecae26c$var$MIN_LOOKAHEAD && strm.avail_in !== 0);
    }
    // Copy without compression as much as possible from the input stream,
    // return
    // the current block state.
    // This function does not insert new strings in the dictionary since
    // uncompressible data is probably not useful. This function is used
    // only for the level=0 compression option.
    // NOTE: this function should be optimized to avoid extra copying from
    // win to pending_buf.
    function deflate_stored(flush) {
        // Stored blocks are limited to 0xffff bytes, pending_buf is limited
        // to pending_buf_size, and each stored block has a 5 byte header:
        let max_block_size = 0xffff;
        let max_start;
        if (max_block_size > pending_buf_size - 5) max_block_size = pending_buf_size - 5;
        // Copy as much as possible from input to output:
        // eslint-disable-next-line no-constant-condition
        while(true){
            // Fill the win as much as possible:
            if (lookahead <= 1) {
                fill_window();
                if (lookahead === 0 && flush == $651421c71ecae26c$var$Z_NO_FLUSH) return $651421c71ecae26c$var$NeedMore;
                if (lookahead === 0) break; // flush the current block
            }
            strstart += lookahead;
            lookahead = 0;
            // Emit a stored block if pending_buf will be full:
            max_start = block_start + max_block_size;
            if (strstart === 0 || strstart >= max_start) {
                // strstart === 0 is possible when wraparound on 16-bit machine
                lookahead = strstart - max_start;
                strstart = max_start;
                flush_block_only(false);
                if (strm.avail_out === 0) return $651421c71ecae26c$var$NeedMore;
            }
            // Flush if we may have to slide, otherwise block_start may become
            // negative and the data will be gone:
            if (strstart - block_start >= w_size - $651421c71ecae26c$var$MIN_LOOKAHEAD) {
                flush_block_only(false);
                if (strm.avail_out === 0) return $651421c71ecae26c$var$NeedMore;
            }
        }
        flush_block_only(flush == $651421c71ecae26c$var$Z_FINISH);
        if (strm.avail_out === 0) return flush == $651421c71ecae26c$var$Z_FINISH ? $651421c71ecae26c$var$FinishStarted : $651421c71ecae26c$var$NeedMore;
        return flush == $651421c71ecae26c$var$Z_FINISH ? $651421c71ecae26c$var$FinishDone : $651421c71ecae26c$var$BlockDone;
    }
    function longest_match(cur_match) {
        let chain_length = max_chain_length; // max hash chain length
        let scan = strstart; // current string
        let match; // matched string
        let len; // length of current match
        let best_len = prev_length; // best match length so far
        const limit = strstart > w_size - $651421c71ecae26c$var$MIN_LOOKAHEAD ? strstart - (w_size - $651421c71ecae26c$var$MIN_LOOKAHEAD) : 0;
        let _nice_match = nice_match;
        // Stop when cur_match becomes <= limit. To simplify the code,
        // we prevent matches with the string of win index 0.
        const wmask = w_mask;
        const strend = strstart + $651421c71ecae26c$var$MAX_MATCH;
        let scan_end1 = win[scan + best_len - 1];
        let scan_end = win[scan + best_len];
        // The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of
        // 16.
        // It is easy to get rid of this optimization if necessary.
        // Do not waste too much time if we already have a good match:
        if (prev_length >= good_match) chain_length >>= 2;
        // Do not look for matches beyond the end of the input. This is
        // necessary
        // to make deflate deterministic.
        if (_nice_match > lookahead) _nice_match = lookahead;
        do {
            match = cur_match;
            // Skip to next match if the match length cannot increase
            // or if the match length is less than 2:
            if (win[match + best_len] != scan_end || win[match + best_len - 1] != scan_end1 || win[match] != win[scan] || win[++match] != win[scan + 1]) continue;
            // The check at best_len-1 can be removed because it will be made
            // again later. (This heuristic is not always a win.)
            // It is not necessary to compare scan[2] and match[2] since they
            // are always equal when the other bytes match, given that
            // the hash keys are equal and that HASH_BITS >= 8.
            scan += 2;
            match++;
            // We check for insufficient lookahead only every 8th comparison;
            // the 256th check will be made at strstart+258.
            // eslint-disable-next-line no-empty
            do ;
            while (win[++scan] == win[++match] && win[++scan] == win[++match] && win[++scan] == win[++match] && win[++scan] == win[++match] && win[++scan] == win[++match] && win[++scan] == win[++match] && win[++scan] == win[++match] && win[++scan] == win[++match] && scan < strend);
            len = $651421c71ecae26c$var$MAX_MATCH - (strend - scan);
            scan = strend - $651421c71ecae26c$var$MAX_MATCH;
            if (len > best_len) {
                match_start = cur_match;
                best_len = len;
                if (len >= _nice_match) break;
                scan_end1 = win[scan + best_len - 1];
                scan_end = win[scan + best_len];
            }
        }while ((cur_match = prev[cur_match & wmask] & 0xffff) > limit && --chain_length !== 0);
        if (best_len <= lookahead) return best_len;
        return lookahead;
    }
    // Compress as much as possible from the input stream, return the current
    // block state.
    // This function does not perform lazy evaluation of matches and inserts
    // new strings in the dictionary only for unmatched strings or for short
    // matches. It is used only for the fast compression options.
    function deflate_fast(flush) {
        // short hash_head = 0; // head of the hash chain
        let hash_head = 0; // head of the hash chain
        let bflush; // set if current block must be flushed
        // eslint-disable-next-line no-constant-condition
        while(true){
            // Make sure that we always have enough lookahead, except
            // at the end of the input file. We need MAX_MATCH bytes
            // for the next match, plus MIN_MATCH bytes to insert the
            // string following the next match.
            if (lookahead < $651421c71ecae26c$var$MIN_LOOKAHEAD) {
                fill_window();
                if (lookahead < $651421c71ecae26c$var$MIN_LOOKAHEAD && flush == $651421c71ecae26c$var$Z_NO_FLUSH) return $651421c71ecae26c$var$NeedMore;
                if (lookahead === 0) break; // flush the current block
            }
            // Insert the string win[strstart .. strstart+2] in the
            // dictionary, and set hash_head to the head of the hash chain:
            if (lookahead >= $651421c71ecae26c$var$MIN_MATCH) {
                ins_h = (ins_h << hash_shift ^ win[strstart + ($651421c71ecae26c$var$MIN_MATCH - 1)] & 0xff) & hash_mask;
                // prev[strstart&w_mask]=hash_head=head[ins_h];
                hash_head = head[ins_h] & 0xffff;
                prev[strstart & w_mask] = head[ins_h];
                head[ins_h] = strstart;
            }
            // Find the longest match, discarding those <= prev_length.
            // At this point we have always match_length < MIN_MATCH
            if (hash_head !== 0 && (strstart - hash_head & 0xffff) <= w_size - $651421c71ecae26c$var$MIN_LOOKAHEAD) // To simplify the code, we prevent matches with the string
            // of win index 0 (in particular we have to avoid a match
            // of the string with itself at the start of the input file).
            {
                if (strategy != $651421c71ecae26c$var$Z_HUFFMAN_ONLY) match_length = longest_match(hash_head);
            }
            if (match_length >= $651421c71ecae26c$var$MIN_MATCH) {
                // check_match(strstart, match_start, match_length);
                bflush = _tr_tally(strstart - match_start, match_length - $651421c71ecae26c$var$MIN_MATCH);
                lookahead -= match_length;
                // Insert new strings in the hash table only if the match length
                // is not too large. This saves time but degrades compression.
                if (match_length <= max_lazy_match && lookahead >= $651421c71ecae26c$var$MIN_MATCH) {
                    match_length--; // string at strstart already in hash table
                    do {
                        strstart++;
                        ins_h = (ins_h << hash_shift ^ win[strstart + ($651421c71ecae26c$var$MIN_MATCH - 1)] & 0xff) & hash_mask;
                        // prev[strstart&w_mask]=hash_head=head[ins_h];
                        hash_head = head[ins_h] & 0xffff;
                        prev[strstart & w_mask] = head[ins_h];
                        head[ins_h] = strstart;
                    // strstart never exceeds WSIZE-MAX_MATCH, so there are
                    // always MIN_MATCH bytes ahead.
                    }while (--match_length !== 0);
                    strstart++;
                } else {
                    strstart += match_length;
                    match_length = 0;
                    ins_h = win[strstart] & 0xff;
                    ins_h = (ins_h << hash_shift ^ win[strstart + 1] & 0xff) & hash_mask;
                // If lookahead < MIN_MATCH, ins_h is garbage, but it does
                // not
                // matter since it will be recomputed at next deflate call.
                }
            } else {
                // No match, output a literal byte
                bflush = _tr_tally(0, win[strstart] & 0xff);
                lookahead--;
                strstart++;
            }
            if (bflush) {
                flush_block_only(false);
                if (strm.avail_out === 0) return $651421c71ecae26c$var$NeedMore;
            }
        }
        flush_block_only(flush == $651421c71ecae26c$var$Z_FINISH);
        if (strm.avail_out === 0) {
            if (flush == $651421c71ecae26c$var$Z_FINISH) return $651421c71ecae26c$var$FinishStarted;
            else return $651421c71ecae26c$var$NeedMore;
        }
        return flush == $651421c71ecae26c$var$Z_FINISH ? $651421c71ecae26c$var$FinishDone : $651421c71ecae26c$var$BlockDone;
    }
    // Same as above, but achieves better compression. We use a lazy
    // evaluation for matches: a match is finally adopted only if there is
    // no better match at the next win position.
    function deflate_slow(flush) {
        // short hash_head = 0; // head of hash chain
        let hash_head = 0; // head of hash chain
        let bflush; // set if current block must be flushed
        let max_insert;
        // Process the input block.
        // eslint-disable-next-line no-constant-condition
        while(true){
            // Make sure that we always have enough lookahead, except
            // at the end of the input file. We need MAX_MATCH bytes
            // for the next match, plus MIN_MATCH bytes to insert the
            // string following the next match.
            if (lookahead < $651421c71ecae26c$var$MIN_LOOKAHEAD) {
                fill_window();
                if (lookahead < $651421c71ecae26c$var$MIN_LOOKAHEAD && flush == $651421c71ecae26c$var$Z_NO_FLUSH) return $651421c71ecae26c$var$NeedMore;
                if (lookahead === 0) break; // flush the current block
            }
            // Insert the string win[strstart .. strstart+2] in the
            // dictionary, and set hash_head to the head of the hash chain:
            if (lookahead >= $651421c71ecae26c$var$MIN_MATCH) {
                ins_h = (ins_h << hash_shift ^ win[strstart + ($651421c71ecae26c$var$MIN_MATCH - 1)] & 0xff) & hash_mask;
                // prev[strstart&w_mask]=hash_head=head[ins_h];
                hash_head = head[ins_h] & 0xffff;
                prev[strstart & w_mask] = head[ins_h];
                head[ins_h] = strstart;
            }
            // Find the longest match, discarding those <= prev_length.
            prev_length = match_length;
            prev_match = match_start;
            match_length = $651421c71ecae26c$var$MIN_MATCH - 1;
            if (hash_head !== 0 && prev_length < max_lazy_match && (strstart - hash_head & 0xffff) <= w_size - $651421c71ecae26c$var$MIN_LOOKAHEAD) {
                // To simplify the code, we prevent matches with the string
                // of win index 0 (in particular we have to avoid a match
                // of the string with itself at the start of the input file).
                if (strategy != $651421c71ecae26c$var$Z_HUFFMAN_ONLY) match_length = longest_match(hash_head);
                // longest_match() sets match_start
                if (match_length <= 5 && (strategy == $651421c71ecae26c$var$Z_FILTERED || match_length == $651421c71ecae26c$var$MIN_MATCH && strstart - match_start > 4096)) // If prev_match is also MIN_MATCH, match_start is garbage
                // but we will ignore the current match anyway.
                match_length = $651421c71ecae26c$var$MIN_MATCH - 1;
            }
            // If there was a match at the previous step and the current
            // match is not better, output the previous match:
            if (prev_length >= $651421c71ecae26c$var$MIN_MATCH && match_length <= prev_length) {
                max_insert = strstart + lookahead - $651421c71ecae26c$var$MIN_MATCH;
                // Do not insert strings in hash table beyond this.
                // check_match(strstart-1, prev_match, prev_length);
                bflush = _tr_tally(strstart - 1 - prev_match, prev_length - $651421c71ecae26c$var$MIN_MATCH);
                // Insert in hash table all strings up to the end of the match.
                // strstart-1 and strstart are already inserted. If there is not
                // enough lookahead, the last two strings are not inserted in
                // the hash table.
                lookahead -= prev_length - 1;
                prev_length -= 2;
                do if (++strstart <= max_insert) {
                    ins_h = (ins_h << hash_shift ^ win[strstart + ($651421c71ecae26c$var$MIN_MATCH - 1)] & 0xff) & hash_mask;
                    // prev[strstart&w_mask]=hash_head=head[ins_h];
                    hash_head = head[ins_h] & 0xffff;
                    prev[strstart & w_mask] = head[ins_h];
                    head[ins_h] = strstart;
                }
                while (--prev_length !== 0);
                match_available = 0;
                match_length = $651421c71ecae26c$var$MIN_MATCH - 1;
                strstart++;
                if (bflush) {
                    flush_block_only(false);
                    if (strm.avail_out === 0) return $651421c71ecae26c$var$NeedMore;
                }
            } else if (match_available !== 0) {
                // If there was no match at the previous position, output a
                // single literal. If there was a match but the current match
                // is longer, truncate the previous match to a single literal.
                bflush = _tr_tally(0, win[strstart - 1] & 0xff);
                if (bflush) flush_block_only(false);
                strstart++;
                lookahead--;
                if (strm.avail_out === 0) return $651421c71ecae26c$var$NeedMore;
            } else {
                // There is no previous match to compare with, wait for
                // the next step to decide.
                match_available = 1;
                strstart++;
                lookahead--;
            }
        }
        if (match_available !== 0) {
            bflush = _tr_tally(0, win[strstart - 1] & 0xff);
            match_available = 0;
        }
        flush_block_only(flush == $651421c71ecae26c$var$Z_FINISH);
        if (strm.avail_out === 0) {
            if (flush == $651421c71ecae26c$var$Z_FINISH) return $651421c71ecae26c$var$FinishStarted;
            else return $651421c71ecae26c$var$NeedMore;
        }
        return flush == $651421c71ecae26c$var$Z_FINISH ? $651421c71ecae26c$var$FinishDone : $651421c71ecae26c$var$BlockDone;
    }
    function deflateReset(strm) {
        strm.total_in = strm.total_out = 0;
        strm.msg = null; //
        that.pending = 0;
        that.pending_out = 0;
        status = $651421c71ecae26c$var$BUSY_STATE;
        last_flush = $651421c71ecae26c$var$Z_NO_FLUSH;
        tr_init();
        lm_init();
        return $651421c71ecae26c$var$Z_OK;
    }
    that.deflateInit = function(strm, _level, bits, _method, memLevel, _strategy) {
        if (!_method) _method = $651421c71ecae26c$var$Z_DEFLATED;
        if (!memLevel) memLevel = $651421c71ecae26c$var$DEF_MEM_LEVEL;
        if (!_strategy) _strategy = $651421c71ecae26c$var$Z_DEFAULT_STRATEGY;
        // byte[] my_version=ZLIB_VERSION;
        //
        // if (!version || version[0] != my_version[0]
        // || stream_size != sizeof(z_stream)) {
        // return Z_VERSION_ERROR;
        // }
        strm.msg = null;
        if (_level == $651421c71ecae26c$var$Z_DEFAULT_COMPRESSION) _level = 6;
        if (memLevel < 1 || memLevel > $651421c71ecae26c$var$MAX_MEM_LEVEL || _method != $651421c71ecae26c$var$Z_DEFLATED || bits < 9 || bits > 15 || _level < 0 || _level > 9 || _strategy < 0 || _strategy > $651421c71ecae26c$var$Z_HUFFMAN_ONLY) return $651421c71ecae26c$var$Z_STREAM_ERROR;
        strm.dstate = that;
        w_bits = bits;
        w_size = 1 << w_bits;
        w_mask = w_size - 1;
        hash_bits = memLevel + 7;
        hash_size = 1 << hash_bits;
        hash_mask = hash_size - 1;
        hash_shift = Math.floor((hash_bits + $651421c71ecae26c$var$MIN_MATCH - 1) / $651421c71ecae26c$var$MIN_MATCH);
        win = new Uint8Array(w_size * 2);
        prev = [];
        head = [];
        lit_bufsize = 1 << memLevel + 6; // 16K elements by default
        that.pending_buf = new Uint8Array(lit_bufsize * 4);
        pending_buf_size = lit_bufsize * 4;
        that.dist_buf = new Uint16Array(lit_bufsize);
        that.lc_buf = new Uint8Array(lit_bufsize);
        level = _level;
        strategy = _strategy;
        return deflateReset(strm);
    };
    that.deflateEnd = function() {
        if (status != $651421c71ecae26c$var$INIT_STATE && status != $651421c71ecae26c$var$BUSY_STATE && status != $651421c71ecae26c$var$FINISH_STATE) return $651421c71ecae26c$var$Z_STREAM_ERROR;
        // Deallocate in reverse order of allocations:
        that.lc_buf = null;
        that.dist_buf = null;
        that.pending_buf = null;
        head = null;
        prev = null;
        win = null;
        // free
        that.dstate = null;
        return status == $651421c71ecae26c$var$BUSY_STATE ? $651421c71ecae26c$var$Z_DATA_ERROR : $651421c71ecae26c$var$Z_OK;
    };
    that.deflateParams = function(strm, _level, _strategy) {
        let err = $651421c71ecae26c$var$Z_OK;
        if (_level == $651421c71ecae26c$var$Z_DEFAULT_COMPRESSION) _level = 6;
        if (_level < 0 || _level > 9 || _strategy < 0 || _strategy > $651421c71ecae26c$var$Z_HUFFMAN_ONLY) return $651421c71ecae26c$var$Z_STREAM_ERROR;
        if ($651421c71ecae26c$var$config_table[level].func != $651421c71ecae26c$var$config_table[_level].func && strm.total_in !== 0) // Flush the last buffer:
        err = strm.deflate($651421c71ecae26c$var$Z_PARTIAL_FLUSH);
        if (level != _level) {
            level = _level;
            max_lazy_match = $651421c71ecae26c$var$config_table[level].max_lazy;
            good_match = $651421c71ecae26c$var$config_table[level].good_length;
            nice_match = $651421c71ecae26c$var$config_table[level].nice_length;
            max_chain_length = $651421c71ecae26c$var$config_table[level].max_chain;
        }
        strategy = _strategy;
        return err;
    };
    that.deflateSetDictionary = function(_strm, dictionary, dictLength) {
        let length = dictLength;
        let n, index = 0;
        if (!dictionary || status != $651421c71ecae26c$var$INIT_STATE) return $651421c71ecae26c$var$Z_STREAM_ERROR;
        if (length < $651421c71ecae26c$var$MIN_MATCH) return $651421c71ecae26c$var$Z_OK;
        if (length > w_size - $651421c71ecae26c$var$MIN_LOOKAHEAD) {
            length = w_size - $651421c71ecae26c$var$MIN_LOOKAHEAD;
            index = dictLength - length; // use the tail of the dictionary
        }
        win.set(dictionary.subarray(index, index + length), 0);
        strstart = length;
        block_start = length;
        // Insert all strings in the hash table (except for the last two bytes).
        // s->lookahead stays null, so s->ins_h will be recomputed at the next
        // call of fill_window.
        ins_h = win[0] & 0xff;
        ins_h = (ins_h << hash_shift ^ win[1] & 0xff) & hash_mask;
        for(n = 0; n <= length - $651421c71ecae26c$var$MIN_MATCH; n++){
            ins_h = (ins_h << hash_shift ^ win[n + ($651421c71ecae26c$var$MIN_MATCH - 1)] & 0xff) & hash_mask;
            prev[n & w_mask] = head[ins_h];
            head[ins_h] = n;
        }
        return $651421c71ecae26c$var$Z_OK;
    };
    that.deflate = function(_strm, flush) {
        let i, header, level_flags, old_flush, bstate;
        if (flush > $651421c71ecae26c$var$Z_FINISH || flush < 0) return $651421c71ecae26c$var$Z_STREAM_ERROR;
        if (!_strm.next_out || !_strm.next_in && _strm.avail_in !== 0 || status == $651421c71ecae26c$var$FINISH_STATE && flush != $651421c71ecae26c$var$Z_FINISH) {
            _strm.msg = $651421c71ecae26c$var$z_errmsg[$651421c71ecae26c$var$Z_NEED_DICT - $651421c71ecae26c$var$Z_STREAM_ERROR];
            return $651421c71ecae26c$var$Z_STREAM_ERROR;
        }
        if (_strm.avail_out === 0) {
            _strm.msg = $651421c71ecae26c$var$z_errmsg[$651421c71ecae26c$var$Z_NEED_DICT - $651421c71ecae26c$var$Z_BUF_ERROR];
            return $651421c71ecae26c$var$Z_BUF_ERROR;
        }
        strm = _strm; // just in case
        old_flush = last_flush;
        last_flush = flush;
        // Write the zlib header
        if (status == $651421c71ecae26c$var$INIT_STATE) {
            header = $651421c71ecae26c$var$Z_DEFLATED + (w_bits - 8 << 4) << 8;
            level_flags = (level - 1 & 0xff) >> 1;
            if (level_flags > 3) level_flags = 3;
            header |= level_flags << 6;
            if (strstart !== 0) header |= $651421c71ecae26c$var$PRESET_DICT;
            header += 31 - header % 31;
            status = $651421c71ecae26c$var$BUSY_STATE;
            putShortMSB(header);
        }
        // Flush as much pending output as possible
        if (that.pending !== 0) {
            strm.flush_pending();
            if (strm.avail_out === 0) {
                // console.log(" avail_out==0");
                // Since avail_out is 0, deflate will be called again with
                // more output space, but possibly with both pending and
                // avail_in equal to zero. There won't be anything to do,
                // but this is not an error situation so make sure we
                // return OK instead of BUF_ERROR at next call of deflate:
                last_flush = -1;
                return $651421c71ecae26c$var$Z_OK;
            }
        // Make sure there is something to do and avoid duplicate
        // consecutive
        // flushes. For repeated and useless calls with Z_FINISH, we keep
        // returning Z_STREAM_END instead of Z_BUFF_ERROR.
        } else if (strm.avail_in === 0 && flush <= old_flush && flush != $651421c71ecae26c$var$Z_FINISH) {
            strm.msg = $651421c71ecae26c$var$z_errmsg[$651421c71ecae26c$var$Z_NEED_DICT - $651421c71ecae26c$var$Z_BUF_ERROR];
            return $651421c71ecae26c$var$Z_BUF_ERROR;
        }
        // User must not provide more input after the first FINISH:
        if (status == $651421c71ecae26c$var$FINISH_STATE && strm.avail_in !== 0) {
            _strm.msg = $651421c71ecae26c$var$z_errmsg[$651421c71ecae26c$var$Z_NEED_DICT - $651421c71ecae26c$var$Z_BUF_ERROR];
            return $651421c71ecae26c$var$Z_BUF_ERROR;
        }
        // Start a new block or continue the current one.
        if (strm.avail_in !== 0 || lookahead !== 0 || flush != $651421c71ecae26c$var$Z_NO_FLUSH && status != $651421c71ecae26c$var$FINISH_STATE) {
            bstate = -1;
            switch($651421c71ecae26c$var$config_table[level].func){
                case $651421c71ecae26c$var$STORED:
                    bstate = deflate_stored(flush);
                    break;
                case $651421c71ecae26c$var$FAST:
                    bstate = deflate_fast(flush);
                    break;
                case $651421c71ecae26c$var$SLOW:
                    bstate = deflate_slow(flush);
                    break;
                default:
            }
            if (bstate == $651421c71ecae26c$var$FinishStarted || bstate == $651421c71ecae26c$var$FinishDone) status = $651421c71ecae26c$var$FINISH_STATE;
            if (bstate == $651421c71ecae26c$var$NeedMore || bstate == $651421c71ecae26c$var$FinishStarted) {
                if (strm.avail_out === 0) last_flush = -1; // avoid BUF_ERROR next call, see above
                return $651421c71ecae26c$var$Z_OK;
            // If flush != Z_NO_FLUSH && avail_out === 0, the next call
            // of deflate should use the same flush parameter to make sure
            // that the flush is complete. So we don't have to output an
            // empty block here, this will be done at next call. This also
            // ensures that for a very small output buffer, we emit at most
            // one empty block.
            }
            if (bstate == $651421c71ecae26c$var$BlockDone) {
                if (flush == $651421c71ecae26c$var$Z_PARTIAL_FLUSH) _tr_align();
                else {
                    _tr_stored_block(0, 0, false);
                    // For a full flush, this empty block will be recognized
                    // as a special marker by inflate_sync().
                    if (flush == $651421c71ecae26c$var$Z_FULL_FLUSH) // state.head[s.hash_size-1]=0;
                    for(i = 0; i < hash_size /*-1*/ ; i++)// forget history
                    head[i] = 0;
                }
                strm.flush_pending();
                if (strm.avail_out === 0) {
                    last_flush = -1; // avoid BUF_ERROR at next call, see above
                    return $651421c71ecae26c$var$Z_OK;
                }
            }
        }
        if (flush != $651421c71ecae26c$var$Z_FINISH) return $651421c71ecae26c$var$Z_OK;
        return $651421c71ecae26c$var$Z_STREAM_END;
    };
}
// ZStream
function $651421c71ecae26c$var$ZStream() {
    const that = this;
    that.next_in_index = 0;
    that.next_out_index = 0;
    // that.next_in; // next input byte
    that.avail_in = 0; // number of bytes available at next_in
    that.total_in = 0; // total nb of input bytes read so far
    // that.next_out; // next output byte should be put there
    that.avail_out = 0; // remaining free space at next_out
    that.total_out = 0; // total nb of bytes output so far
// that.msg;
// that.dstate;
}
$651421c71ecae26c$var$ZStream.prototype = {
    deflateInit (level, bits) {
        const that = this;
        that.dstate = new $651421c71ecae26c$var$Deflate();
        if (!bits) bits = $651421c71ecae26c$var$MAX_BITS;
        return that.dstate.deflateInit(that, level, bits);
    },
    deflate (flush) {
        const that = this;
        if (!that.dstate) return $651421c71ecae26c$var$Z_STREAM_ERROR;
        return that.dstate.deflate(that, flush);
    },
    deflateEnd () {
        const that = this;
        if (!that.dstate) return $651421c71ecae26c$var$Z_STREAM_ERROR;
        const ret = that.dstate.deflateEnd();
        that.dstate = null;
        return ret;
    },
    deflateParams (level, strategy) {
        const that = this;
        if (!that.dstate) return $651421c71ecae26c$var$Z_STREAM_ERROR;
        return that.dstate.deflateParams(that, level, strategy);
    },
    deflateSetDictionary (dictionary, dictLength) {
        const that = this;
        if (!that.dstate) return $651421c71ecae26c$var$Z_STREAM_ERROR;
        return that.dstate.deflateSetDictionary(that, dictionary, dictLength);
    },
    // Read a new buffer from the current input stream, update the
    // total number of bytes read. All deflate() input goes through
    // this function so some applications may wish to modify it to avoid
    // allocating a large strm->next_in buffer and copying from it.
    // (See also flush_pending()).
    read_buf (buf, start, size) {
        const that = this;
        let len = that.avail_in;
        if (len > size) len = size;
        if (len === 0) return 0;
        that.avail_in -= len;
        buf.set(that.next_in.subarray(that.next_in_index, that.next_in_index + len), start);
        that.next_in_index += len;
        that.total_in += len;
        return len;
    },
    // Flush as much pending output as possible. All deflate() output goes
    // through this function so some applications may wish to modify it
    // to avoid allocating a large strm->next_out buffer and copying into it.
    // (See also read_buf()).
    flush_pending () {
        const that = this;
        let len = that.dstate.pending;
        if (len > that.avail_out) len = that.avail_out;
        if (len === 0) return;
        // if (that.dstate.pending_buf.length <= that.dstate.pending_out || that.next_out.length <= that.next_out_index
        // || that.dstate.pending_buf.length < (that.dstate.pending_out + len) || that.next_out.length < (that.next_out_index +
        // len)) {
        // console.log(that.dstate.pending_buf.length + ", " + that.dstate.pending_out + ", " + that.next_out.length + ", " +
        // that.next_out_index + ", " + len);
        // console.log("avail_out=" + that.avail_out);
        // }
        that.next_out.set(that.dstate.pending_buf.subarray(that.dstate.pending_out, that.dstate.pending_out + len), that.next_out_index);
        that.next_out_index += len;
        that.dstate.pending_out += len;
        that.total_out += len;
        that.avail_out -= len;
        that.dstate.pending -= len;
        if (that.dstate.pending === 0) that.dstate.pending_out = 0;
    }
};
// Deflate
function $651421c71ecae26c$export$ae157b6234afe138(options) {
    const that = this;
    const z = new $651421c71ecae26c$var$ZStream();
    const bufsize = $651421c71ecae26c$var$getMaximumCompressedSize(options && options.chunkSize ? options.chunkSize : 65536);
    const flush = $651421c71ecae26c$var$Z_NO_FLUSH;
    const buf = new Uint8Array(bufsize);
    let level = options ? options.level : $651421c71ecae26c$var$Z_DEFAULT_COMPRESSION;
    if (typeof level == "undefined") level = $651421c71ecae26c$var$Z_DEFAULT_COMPRESSION;
    z.deflateInit(level);
    z.next_out = buf;
    that.append = function(data, onprogress) {
        let err, array, lastIndex = 0, bufferIndex = 0, bufferSize = 0;
        const buffers = [];
        if (!data.length) return;
        z.next_in_index = 0;
        z.next_in = data;
        z.avail_in = data.length;
        do {
            z.next_out_index = 0;
            z.avail_out = bufsize;
            err = z.deflate(flush);
            if (err != $651421c71ecae26c$var$Z_OK) throw new Error("deflating: " + z.msg);
            if (z.next_out_index) {
                if (z.next_out_index == bufsize) buffers.push(new Uint8Array(buf));
                else buffers.push(buf.slice(0, z.next_out_index));
            }
            bufferSize += z.next_out_index;
            if (onprogress && z.next_in_index > 0 && z.next_in_index != lastIndex) {
                onprogress(z.next_in_index);
                lastIndex = z.next_in_index;
            }
        }while (z.avail_in > 0 || z.avail_out === 0);
        if (buffers.length > 1) {
            array = new Uint8Array(bufferSize);
            buffers.forEach(function(chunk) {
                array.set(chunk, bufferIndex);
                bufferIndex += chunk.length;
            });
        } else array = buffers[0] || new Uint8Array();
        return array;
    };
    that.flush = function() {
        let err, array, bufferIndex = 0, bufferSize = 0;
        const buffers = [];
        do {
            z.next_out_index = 0;
            z.avail_out = bufsize;
            err = z.deflate($651421c71ecae26c$var$Z_FINISH);
            if (err != $651421c71ecae26c$var$Z_STREAM_END && err != $651421c71ecae26c$var$Z_OK) throw new Error("deflating: " + z.msg);
            if (bufsize - z.avail_out > 0) buffers.push(buf.slice(0, z.next_out_index));
            bufferSize += z.next_out_index;
        }while (z.avail_in > 0 || z.avail_out === 0);
        z.deflateEnd();
        array = new Uint8Array(bufferSize);
        buffers.forEach(function(chunk) {
            array.set(chunk, bufferIndex);
            bufferIndex += chunk.length;
        });
        return array;
    };
}
function $651421c71ecae26c$var$getMaximumCompressedSize(uncompressedSize) {
    return uncompressedSize + 5 * (Math.floor(uncompressedSize / 16383) + 1);
}


/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /*
 * This program is based on JZlib 1.0.2 ymnk, JCraft,Inc.
 * JZlib is based on zlib-1.1.3, so all credit should go authors
 * Jean-loup Gailly(jloup@gzip.org) and Mark Adler(madler@alumni.caltech.edu)
 * and contributors of zlib.
 */ // deno-lint-ignore-file no-this-alias prefer-const
// Global
const $7b5e4d5528b9fdff$var$MAX_BITS = 15;
const $7b5e4d5528b9fdff$var$Z_OK = 0;
const $7b5e4d5528b9fdff$var$Z_STREAM_END = 1;
const $7b5e4d5528b9fdff$var$Z_NEED_DICT = 2;
const $7b5e4d5528b9fdff$var$Z_STREAM_ERROR = -2;
const $7b5e4d5528b9fdff$var$Z_DATA_ERROR = -3;
const $7b5e4d5528b9fdff$var$Z_MEM_ERROR = -4;
const $7b5e4d5528b9fdff$var$Z_BUF_ERROR = -5;
const $7b5e4d5528b9fdff$var$inflate_mask = [
    0x00000000,
    0x00000001,
    0x00000003,
    0x00000007,
    0x0000000f,
    0x0000001f,
    0x0000003f,
    0x0000007f,
    0x000000ff,
    0x000001ff,
    0x000003ff,
    0x000007ff,
    0x00000fff,
    0x00001fff,
    0x00003fff,
    0x00007fff,
    0x0000ffff
];
const $7b5e4d5528b9fdff$var$MANY = 1440;
// JZlib version : "1.0.2"
const $7b5e4d5528b9fdff$var$Z_NO_FLUSH = 0;
const $7b5e4d5528b9fdff$var$Z_FINISH = 4;
// InfTree
const $7b5e4d5528b9fdff$var$fixed_bl = 9;
const $7b5e4d5528b9fdff$var$fixed_bd = 5;
const $7b5e4d5528b9fdff$var$fixed_tl = [
    96,
    7,
    256,
    0,
    8,
    80,
    0,
    8,
    16,
    84,
    8,
    115,
    82,
    7,
    31,
    0,
    8,
    112,
    0,
    8,
    48,
    0,
    9,
    192,
    80,
    7,
    10,
    0,
    8,
    96,
    0,
    8,
    32,
    0,
    9,
    160,
    0,
    8,
    0,
    0,
    8,
    128,
    0,
    8,
    64,
    0,
    9,
    224,
    80,
    7,
    6,
    0,
    8,
    88,
    0,
    8,
    24,
    0,
    9,
    144,
    83,
    7,
    59,
    0,
    8,
    120,
    0,
    8,
    56,
    0,
    9,
    208,
    81,
    7,
    17,
    0,
    8,
    104,
    0,
    8,
    40,
    0,
    9,
    176,
    0,
    8,
    8,
    0,
    8,
    136,
    0,
    8,
    72,
    0,
    9,
    240,
    80,
    7,
    4,
    0,
    8,
    84,
    0,
    8,
    20,
    85,
    8,
    227,
    83,
    7,
    43,
    0,
    8,
    116,
    0,
    8,
    52,
    0,
    9,
    200,
    81,
    7,
    13,
    0,
    8,
    100,
    0,
    8,
    36,
    0,
    9,
    168,
    0,
    8,
    4,
    0,
    8,
    132,
    0,
    8,
    68,
    0,
    9,
    232,
    80,
    7,
    8,
    0,
    8,
    92,
    0,
    8,
    28,
    0,
    9,
    152,
    84,
    7,
    83,
    0,
    8,
    124,
    0,
    8,
    60,
    0,
    9,
    216,
    82,
    7,
    23,
    0,
    8,
    108,
    0,
    8,
    44,
    0,
    9,
    184,
    0,
    8,
    12,
    0,
    8,
    140,
    0,
    8,
    76,
    0,
    9,
    248,
    80,
    7,
    3,
    0,
    8,
    82,
    0,
    8,
    18,
    85,
    8,
    163,
    83,
    7,
    35,
    0,
    8,
    114,
    0,
    8,
    50,
    0,
    9,
    196,
    81,
    7,
    11,
    0,
    8,
    98,
    0,
    8,
    34,
    0,
    9,
    164,
    0,
    8,
    2,
    0,
    8,
    130,
    0,
    8,
    66,
    0,
    9,
    228,
    80,
    7,
    7,
    0,
    8,
    90,
    0,
    8,
    26,
    0,
    9,
    148,
    84,
    7,
    67,
    0,
    8,
    122,
    0,
    8,
    58,
    0,
    9,
    212,
    82,
    7,
    19,
    0,
    8,
    106,
    0,
    8,
    42,
    0,
    9,
    180,
    0,
    8,
    10,
    0,
    8,
    138,
    0,
    8,
    74,
    0,
    9,
    244,
    80,
    7,
    5,
    0,
    8,
    86,
    0,
    8,
    22,
    192,
    8,
    0,
    83,
    7,
    51,
    0,
    8,
    118,
    0,
    8,
    54,
    0,
    9,
    204,
    81,
    7,
    15,
    0,
    8,
    102,
    0,
    8,
    38,
    0,
    9,
    172,
    0,
    8,
    6,
    0,
    8,
    134,
    0,
    8,
    70,
    0,
    9,
    236,
    80,
    7,
    9,
    0,
    8,
    94,
    0,
    8,
    30,
    0,
    9,
    156,
    84,
    7,
    99,
    0,
    8,
    126,
    0,
    8,
    62,
    0,
    9,
    220,
    82,
    7,
    27,
    0,
    8,
    110,
    0,
    8,
    46,
    0,
    9,
    188,
    0,
    8,
    14,
    0,
    8,
    142,
    0,
    8,
    78,
    0,
    9,
    252,
    96,
    7,
    256,
    0,
    8,
    81,
    0,
    8,
    17,
    85,
    8,
    131,
    82,
    7,
    31,
    0,
    8,
    113,
    0,
    8,
    49,
    0,
    9,
    194,
    80,
    7,
    10,
    0,
    8,
    97,
    0,
    8,
    33,
    0,
    9,
    162,
    0,
    8,
    1,
    0,
    8,
    129,
    0,
    8,
    65,
    0,
    9,
    226,
    80,
    7,
    6,
    0,
    8,
    89,
    0,
    8,
    25,
    0,
    9,
    146,
    83,
    7,
    59,
    0,
    8,
    121,
    0,
    8,
    57,
    0,
    9,
    210,
    81,
    7,
    17,
    0,
    8,
    105,
    0,
    8,
    41,
    0,
    9,
    178,
    0,
    8,
    9,
    0,
    8,
    137,
    0,
    8,
    73,
    0,
    9,
    242,
    80,
    7,
    4,
    0,
    8,
    85,
    0,
    8,
    21,
    80,
    8,
    258,
    83,
    7,
    43,
    0,
    8,
    117,
    0,
    8,
    53,
    0,
    9,
    202,
    81,
    7,
    13,
    0,
    8,
    101,
    0,
    8,
    37,
    0,
    9,
    170,
    0,
    8,
    5,
    0,
    8,
    133,
    0,
    8,
    69,
    0,
    9,
    234,
    80,
    7,
    8,
    0,
    8,
    93,
    0,
    8,
    29,
    0,
    9,
    154,
    84,
    7,
    83,
    0,
    8,
    125,
    0,
    8,
    61,
    0,
    9,
    218,
    82,
    7,
    23,
    0,
    8,
    109,
    0,
    8,
    45,
    0,
    9,
    186,
    0,
    8,
    13,
    0,
    8,
    141,
    0,
    8,
    77,
    0,
    9,
    250,
    80,
    7,
    3,
    0,
    8,
    83,
    0,
    8,
    19,
    85,
    8,
    195,
    83,
    7,
    35,
    0,
    8,
    115,
    0,
    8,
    51,
    0,
    9,
    198,
    81,
    7,
    11,
    0,
    8,
    99,
    0,
    8,
    35,
    0,
    9,
    166,
    0,
    8,
    3,
    0,
    8,
    131,
    0,
    8,
    67,
    0,
    9,
    230,
    80,
    7,
    7,
    0,
    8,
    91,
    0,
    8,
    27,
    0,
    9,
    150,
    84,
    7,
    67,
    0,
    8,
    123,
    0,
    8,
    59,
    0,
    9,
    214,
    82,
    7,
    19,
    0,
    8,
    107,
    0,
    8,
    43,
    0,
    9,
    182,
    0,
    8,
    11,
    0,
    8,
    139,
    0,
    8,
    75,
    0,
    9,
    246,
    80,
    7,
    5,
    0,
    8,
    87,
    0,
    8,
    23,
    192,
    8,
    0,
    83,
    7,
    51,
    0,
    8,
    119,
    0,
    8,
    55,
    0,
    9,
    206,
    81,
    7,
    15,
    0,
    8,
    103,
    0,
    8,
    39,
    0,
    9,
    174,
    0,
    8,
    7,
    0,
    8,
    135,
    0,
    8,
    71,
    0,
    9,
    238,
    80,
    7,
    9,
    0,
    8,
    95,
    0,
    8,
    31,
    0,
    9,
    158,
    84,
    7,
    99,
    0,
    8,
    127,
    0,
    8,
    63,
    0,
    9,
    222,
    82,
    7,
    27,
    0,
    8,
    111,
    0,
    8,
    47,
    0,
    9,
    190,
    0,
    8,
    15,
    0,
    8,
    143,
    0,
    8,
    79,
    0,
    9,
    254,
    96,
    7,
    256,
    0,
    8,
    80,
    0,
    8,
    16,
    84,
    8,
    115,
    82,
    7,
    31,
    0,
    8,
    112,
    0,
    8,
    48,
    0,
    9,
    193,
    80,
    7,
    10,
    0,
    8,
    96,
    0,
    8,
    32,
    0,
    9,
    161,
    0,
    8,
    0,
    0,
    8,
    128,
    0,
    8,
    64,
    0,
    9,
    225,
    80,
    7,
    6,
    0,
    8,
    88,
    0,
    8,
    24,
    0,
    9,
    145,
    83,
    7,
    59,
    0,
    8,
    120,
    0,
    8,
    56,
    0,
    9,
    209,
    81,
    7,
    17,
    0,
    8,
    104,
    0,
    8,
    40,
    0,
    9,
    177,
    0,
    8,
    8,
    0,
    8,
    136,
    0,
    8,
    72,
    0,
    9,
    241,
    80,
    7,
    4,
    0,
    8,
    84,
    0,
    8,
    20,
    85,
    8,
    227,
    83,
    7,
    43,
    0,
    8,
    116,
    0,
    8,
    52,
    0,
    9,
    201,
    81,
    7,
    13,
    0,
    8,
    100,
    0,
    8,
    36,
    0,
    9,
    169,
    0,
    8,
    4,
    0,
    8,
    132,
    0,
    8,
    68,
    0,
    9,
    233,
    80,
    7,
    8,
    0,
    8,
    92,
    0,
    8,
    28,
    0,
    9,
    153,
    84,
    7,
    83,
    0,
    8,
    124,
    0,
    8,
    60,
    0,
    9,
    217,
    82,
    7,
    23,
    0,
    8,
    108,
    0,
    8,
    44,
    0,
    9,
    185,
    0,
    8,
    12,
    0,
    8,
    140,
    0,
    8,
    76,
    0,
    9,
    249,
    80,
    7,
    3,
    0,
    8,
    82,
    0,
    8,
    18,
    85,
    8,
    163,
    83,
    7,
    35,
    0,
    8,
    114,
    0,
    8,
    50,
    0,
    9,
    197,
    81,
    7,
    11,
    0,
    8,
    98,
    0,
    8,
    34,
    0,
    9,
    165,
    0,
    8,
    2,
    0,
    8,
    130,
    0,
    8,
    66,
    0,
    9,
    229,
    80,
    7,
    7,
    0,
    8,
    90,
    0,
    8,
    26,
    0,
    9,
    149,
    84,
    7,
    67,
    0,
    8,
    122,
    0,
    8,
    58,
    0,
    9,
    213,
    82,
    7,
    19,
    0,
    8,
    106,
    0,
    8,
    42,
    0,
    9,
    181,
    0,
    8,
    10,
    0,
    8,
    138,
    0,
    8,
    74,
    0,
    9,
    245,
    80,
    7,
    5,
    0,
    8,
    86,
    0,
    8,
    22,
    192,
    8,
    0,
    83,
    7,
    51,
    0,
    8,
    118,
    0,
    8,
    54,
    0,
    9,
    205,
    81,
    7,
    15,
    0,
    8,
    102,
    0,
    8,
    38,
    0,
    9,
    173,
    0,
    8,
    6,
    0,
    8,
    134,
    0,
    8,
    70,
    0,
    9,
    237,
    80,
    7,
    9,
    0,
    8,
    94,
    0,
    8,
    30,
    0,
    9,
    157,
    84,
    7,
    99,
    0,
    8,
    126,
    0,
    8,
    62,
    0,
    9,
    221,
    82,
    7,
    27,
    0,
    8,
    110,
    0,
    8,
    46,
    0,
    9,
    189,
    0,
    8,
    14,
    0,
    8,
    142,
    0,
    8,
    78,
    0,
    9,
    253,
    96,
    7,
    256,
    0,
    8,
    81,
    0,
    8,
    17,
    85,
    8,
    131,
    82,
    7,
    31,
    0,
    8,
    113,
    0,
    8,
    49,
    0,
    9,
    195,
    80,
    7,
    10,
    0,
    8,
    97,
    0,
    8,
    33,
    0,
    9,
    163,
    0,
    8,
    1,
    0,
    8,
    129,
    0,
    8,
    65,
    0,
    9,
    227,
    80,
    7,
    6,
    0,
    8,
    89,
    0,
    8,
    25,
    0,
    9,
    147,
    83,
    7,
    59,
    0,
    8,
    121,
    0,
    8,
    57,
    0,
    9,
    211,
    81,
    7,
    17,
    0,
    8,
    105,
    0,
    8,
    41,
    0,
    9,
    179,
    0,
    8,
    9,
    0,
    8,
    137,
    0,
    8,
    73,
    0,
    9,
    243,
    80,
    7,
    4,
    0,
    8,
    85,
    0,
    8,
    21,
    80,
    8,
    258,
    83,
    7,
    43,
    0,
    8,
    117,
    0,
    8,
    53,
    0,
    9,
    203,
    81,
    7,
    13,
    0,
    8,
    101,
    0,
    8,
    37,
    0,
    9,
    171,
    0,
    8,
    5,
    0,
    8,
    133,
    0,
    8,
    69,
    0,
    9,
    235,
    80,
    7,
    8,
    0,
    8,
    93,
    0,
    8,
    29,
    0,
    9,
    155,
    84,
    7,
    83,
    0,
    8,
    125,
    0,
    8,
    61,
    0,
    9,
    219,
    82,
    7,
    23,
    0,
    8,
    109,
    0,
    8,
    45,
    0,
    9,
    187,
    0,
    8,
    13,
    0,
    8,
    141,
    0,
    8,
    77,
    0,
    9,
    251,
    80,
    7,
    3,
    0,
    8,
    83,
    0,
    8,
    19,
    85,
    8,
    195,
    83,
    7,
    35,
    0,
    8,
    115,
    0,
    8,
    51,
    0,
    9,
    199,
    81,
    7,
    11,
    0,
    8,
    99,
    0,
    8,
    35,
    0,
    9,
    167,
    0,
    8,
    3,
    0,
    8,
    131,
    0,
    8,
    67,
    0,
    9,
    231,
    80,
    7,
    7,
    0,
    8,
    91,
    0,
    8,
    27,
    0,
    9,
    151,
    84,
    7,
    67,
    0,
    8,
    123,
    0,
    8,
    59,
    0,
    9,
    215,
    82,
    7,
    19,
    0,
    8,
    107,
    0,
    8,
    43,
    0,
    9,
    183,
    0,
    8,
    11,
    0,
    8,
    139,
    0,
    8,
    75,
    0,
    9,
    247,
    80,
    7,
    5,
    0,
    8,
    87,
    0,
    8,
    23,
    192,
    8,
    0,
    83,
    7,
    51,
    0,
    8,
    119,
    0,
    8,
    55,
    0,
    9,
    207,
    81,
    7,
    15,
    0,
    8,
    103,
    0,
    8,
    39,
    0,
    9,
    175,
    0,
    8,
    7,
    0,
    8,
    135,
    0,
    8,
    71,
    0,
    9,
    239,
    80,
    7,
    9,
    0,
    8,
    95,
    0,
    8,
    31,
    0,
    9,
    159,
    84,
    7,
    99,
    0,
    8,
    127,
    0,
    8,
    63,
    0,
    9,
    223,
    82,
    7,
    27,
    0,
    8,
    111,
    0,
    8,
    47,
    0,
    9,
    191,
    0,
    8,
    15,
    0,
    8,
    143,
    0,
    8,
    79,
    0,
    9,
    255
];
const $7b5e4d5528b9fdff$var$fixed_td = [
    80,
    5,
    1,
    87,
    5,
    257,
    83,
    5,
    17,
    91,
    5,
    4097,
    81,
    5,
    5,
    89,
    5,
    1025,
    85,
    5,
    65,
    93,
    5,
    16385,
    80,
    5,
    3,
    88,
    5,
    513,
    84,
    5,
    33,
    92,
    5,
    8193,
    82,
    5,
    9,
    90,
    5,
    2049,
    86,
    5,
    129,
    192,
    5,
    24577,
    80,
    5,
    2,
    87,
    5,
    385,
    83,
    5,
    25,
    91,
    5,
    6145,
    81,
    5,
    7,
    89,
    5,
    1537,
    85,
    5,
    97,
    93,
    5,
    24577,
    80,
    5,
    4,
    88,
    5,
    769,
    84,
    5,
    49,
    92,
    5,
    12289,
    82,
    5,
    13,
    90,
    5,
    3073,
    86,
    5,
    193,
    192,
    5,
    24577
];
// Tables for deflate from PKZIP's appnote.txt.
const $7b5e4d5528b9fdff$var$cplens = [
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
// see note #13 above about 258
const $7b5e4d5528b9fdff$var$cplext = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    112,
    112 // 112==invalid
];
const $7b5e4d5528b9fdff$var$cpdist = [
    1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577
];
const $7b5e4d5528b9fdff$var$cpdext = [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
// If BMAX needs to be larger than 16, then h and x[] should be uLong.
const $7b5e4d5528b9fdff$var$BMAX = 15; // maximum bit length of any code
function $7b5e4d5528b9fdff$var$InfTree() {
    const that = this;
    let hn; // hufts used in space
    let v; // work area for huft_build
    let c; // bit length count table
    let r; // table entry for structure assignment
    let u; // table stack
    let x; // bit offsets, then code stack
    function huft_build(b, // BMAX)
    bindex, n, s, d, e, t, m, hp, hn, v // working area: values in order of bit length
    ) {
        // Given a list of code lengths and a maximum table size, make a set of
        // tables to decode that set of codes. Return Z_OK on success,
        // Z_BUF_ERROR
        // if the given code set is incomplete (the tables are still built in
        // this
        // case), Z_DATA_ERROR if the input is invalid (an over-subscribed set
        // of
        // lengths), or Z_MEM_ERROR if not enough memory.
        let a; // counter for codes of length k
        let f; // i repeats in table every f entries
        let g; // maximum code length
        let h; // table level
        let i; // counter, current code
        let j; // counter
        let k; // number of bits in current code
        let l; // bits per table (returned in m)
        let mask; // (1 << w) - 1, to avoid cc -O bug on HP
        let p; // pointer into c[], b[], or v[]
        let q; // points to current table
        let w; // bits before this table == (l * h)
        let xp; // pointer into x
        let y; // number of dummy codes added
        let z; // number of entries in current table
        // Generate counts for each bit length
        p = 0;
        i = n;
        do {
            c[b[bindex + p]]++;
            p++;
            i--; // assume all entries <= BMAX
        }while (i !== 0);
        if (c[0] == n) {
            t[0] = -1;
            m[0] = 0;
            return $7b5e4d5528b9fdff$var$Z_OK;
        }
        // Find minimum and maximum length, bound *m by those
        l = m[0];
        for(j = 1; j <= $7b5e4d5528b9fdff$var$BMAX; j++)if (c[j] !== 0) break;
        k = j; // minimum code length
        if (l < j) l = j;
        for(i = $7b5e4d5528b9fdff$var$BMAX; i !== 0; i--){
            if (c[i] !== 0) break;
        }
        g = i; // maximum code length
        if (l > i) l = i;
        m[0] = l;
        // Adjust last length count to fill out codes, if needed
        for(y = 1 << j; j < i; j++, y <<= 1){
            if ((y -= c[j]) < 0) return $7b5e4d5528b9fdff$var$Z_DATA_ERROR;
        }
        if ((y -= c[i]) < 0) return $7b5e4d5528b9fdff$var$Z_DATA_ERROR;
        c[i] += y;
        // Generate starting offsets into the value table for each length
        x[1] = j = 0;
        p = 1;
        xp = 2;
        while(--i !== 0){
            x[xp] = j += c[p];
            xp++;
            p++;
        }
        // Make a table of values in order of bit lengths
        i = 0;
        p = 0;
        do {
            if ((j = b[bindex + p]) !== 0) v[x[j]++] = i;
            p++;
        }while (++i < n);
        n = x[g]; // set n to length of v
        // Generate the Huffman codes and for each, make the table entries
        x[0] = i = 0; // first Huffman code is zero
        p = 0; // grab values in bit order
        h = -1; // no tables yet--level -1
        w = -l; // bits decoded == (l * h)
        u[0] = 0; // just to keep compilers happy
        q = 0; // ditto
        z = 0; // ditto
        // go through the bit lengths (k already is bits in shortest code)
        for(; k <= g; k++){
            a = c[k];
            while(a-- !== 0){
                // here i is the Huffman code of length k bits for value *p
                // make tables up to required level
                while(k > w + l){
                    h++;
                    w += l; // previous table always l bits
                    // compute minimum size table less than or equal to l bits
                    z = g - w;
                    z = z > l ? l : z; // table size upper limit
                    if ((f = 1 << (j = k - w)) > a + 1) {
                        // too few codes for
                        // k-w bit table
                        f -= a + 1; // deduct codes from patterns left
                        xp = k;
                        if (j < z) while(++j < z){
                            if ((f <<= 1) <= c[++xp]) break; // enough codes to use up j bits
                            f -= c[xp]; // else deduct codes from patterns
                        }
                    }
                    z = 1 << j; // table entries for j-bit table
                    // allocate new table
                    if (hn[0] + z > $7b5e4d5528b9fdff$var$MANY) return $7b5e4d5528b9fdff$var$Z_DATA_ERROR; // overflow of MANY
                    u[h] = q = /* hp+ */ hn[0]; // DEBUG
                    hn[0] += z;
                    // connect to last table, if there is one
                    if (h !== 0) {
                        x[h] = i; // save pattern for backing up
                        r[0] = /* (byte) */ j; // bits in this table
                        r[1] = /* (byte) */ l; // bits to dump before this table
                        j = i >>> w - l;
                        r[2] = /* (int) */ q - u[h - 1] - j; // offset to this table
                        hp.set(r, (u[h - 1] + j) * 3);
                    // to
                    // last
                    // table
                    } else t[0] = q; // first table is returned result
                }
                // set up table entry in r
                r[1] = /* (byte) */ k - w;
                if (p >= n) r[0] = 192; // out of values--invalid code
                else if (v[p] < s) {
                    r[0] = /* (byte) */ v[p] < 256 ? 0 : 96; // 256 is
                    // end-of-block
                    r[2] = v[p++]; // simple code is just the value
                } else {
                    r[0] = /* (byte) */ e[v[p] - s] + 16 + 64; // non-simple--look
                    // up in lists
                    r[2] = d[v[p++] - s];
                }
                // fill code-like entries with r
                f = 1 << k - w;
                for(j = i >>> w; j < z; j += f)hp.set(r, (q + j) * 3);
                // backwards increment the k-bit code i
                for(j = 1 << k - 1; (i & j) !== 0; j >>>= 1)i ^= j;
                i ^= j;
                // backup over finished tables
                mask = (1 << w) - 1; // needed on HP, cc -O bug
                while((i & mask) != x[h]){
                    h--; // don't need to update q
                    w -= l;
                    mask = (1 << w) - 1;
                }
            }
        }
        // Return Z_BUF_ERROR if we were given an incomplete table
        return y !== 0 && g != 1 ? $7b5e4d5528b9fdff$var$Z_BUF_ERROR : $7b5e4d5528b9fdff$var$Z_OK;
    }
    function initWorkArea(vsize) {
        let i;
        if (!hn) {
            hn = []; // []; //new Array(1);
            v = []; // new Array(vsize);
            c = new Int32Array($7b5e4d5528b9fdff$var$BMAX + 1); // new Array(BMAX + 1);
            r = []; // new Array(3);
            u = new Int32Array($7b5e4d5528b9fdff$var$BMAX); // new Array(BMAX);
            x = new Int32Array($7b5e4d5528b9fdff$var$BMAX + 1); // new Array(BMAX + 1);
        }
        if (v.length < vsize) v = []; // new Array(vsize);
        for(i = 0; i < vsize; i++)v[i] = 0;
        for(i = 0; i < $7b5e4d5528b9fdff$var$BMAX + 1; i++)c[i] = 0;
        for(i = 0; i < 3; i++)r[i] = 0;
        // for(int i=0; i<BMAX; i++){u[i]=0;}
        u.set(c.subarray(0, $7b5e4d5528b9fdff$var$BMAX), 0);
        // for(int i=0; i<BMAX+1; i++){x[i]=0;}
        x.set(c.subarray(0, $7b5e4d5528b9fdff$var$BMAX + 1), 0);
    }
    that.inflate_trees_bits = function(c, bb, tb, hp, z // for messages
    ) {
        let result;
        initWorkArea(19);
        hn[0] = 0;
        result = huft_build(c, 0, 19, 19, null, null, tb, bb, hp, hn, v);
        if (result == $7b5e4d5528b9fdff$var$Z_DATA_ERROR) z.msg = "oversubscribed dynamic bit lengths tree";
        else if (result == $7b5e4d5528b9fdff$var$Z_BUF_ERROR || bb[0] === 0) {
            z.msg = "incomplete dynamic bit lengths tree";
            result = $7b5e4d5528b9fdff$var$Z_DATA_ERROR;
        }
        return result;
    };
    that.inflate_trees_dynamic = function(nl, nd, c, bl, bd, tl, td, hp, z // for messages
    ) {
        let result;
        // build literal/length tree
        initWorkArea(288);
        hn[0] = 0;
        result = huft_build(c, 0, nl, 257, $7b5e4d5528b9fdff$var$cplens, $7b5e4d5528b9fdff$var$cplext, tl, bl, hp, hn, v);
        if (result != $7b5e4d5528b9fdff$var$Z_OK || bl[0] === 0) {
            if (result == $7b5e4d5528b9fdff$var$Z_DATA_ERROR) z.msg = "oversubscribed literal/length tree";
            else if (result != $7b5e4d5528b9fdff$var$Z_MEM_ERROR) {
                z.msg = "incomplete literal/length tree";
                result = $7b5e4d5528b9fdff$var$Z_DATA_ERROR;
            }
            return result;
        }
        // build distance tree
        initWorkArea(288);
        result = huft_build(c, nl, nd, 0, $7b5e4d5528b9fdff$var$cpdist, $7b5e4d5528b9fdff$var$cpdext, td, bd, hp, hn, v);
        if (result != $7b5e4d5528b9fdff$var$Z_OK || bd[0] === 0 && nl > 257) {
            if (result == $7b5e4d5528b9fdff$var$Z_DATA_ERROR) z.msg = "oversubscribed distance tree";
            else if (result == $7b5e4d5528b9fdff$var$Z_BUF_ERROR) {
                z.msg = "incomplete distance tree";
                result = $7b5e4d5528b9fdff$var$Z_DATA_ERROR;
            } else if (result != $7b5e4d5528b9fdff$var$Z_MEM_ERROR) {
                z.msg = "empty distance tree with lengths";
                result = $7b5e4d5528b9fdff$var$Z_DATA_ERROR;
            }
            return result;
        }
        return $7b5e4d5528b9fdff$var$Z_OK;
    };
}
$7b5e4d5528b9fdff$var$InfTree.inflate_trees_fixed = function(bl, bd, tl, td // distance tree result
) {
    bl[0] = $7b5e4d5528b9fdff$var$fixed_bl;
    bd[0] = $7b5e4d5528b9fdff$var$fixed_bd;
    tl[0] = $7b5e4d5528b9fdff$var$fixed_tl;
    td[0] = $7b5e4d5528b9fdff$var$fixed_td;
    return $7b5e4d5528b9fdff$var$Z_OK;
};
// InfCodes
// waiting for "i:"=input,
// "o:"=output,
// "x:"=nothing
const $7b5e4d5528b9fdff$var$START = 0; // x: set up for LEN
const $7b5e4d5528b9fdff$var$LEN = 1; // i: get length/literal/eob next
const $7b5e4d5528b9fdff$var$LENEXT = 2; // i: getting length extra (have base)
const $7b5e4d5528b9fdff$var$DIST = 3; // i: get distance next
const $7b5e4d5528b9fdff$var$DISTEXT = 4; // i: getting distance extra
const $7b5e4d5528b9fdff$var$COPY = 5; // o: copying bytes in win, waiting
// for space
const $7b5e4d5528b9fdff$var$LIT = 6; // o: got literal, waiting for output
// space
const $7b5e4d5528b9fdff$var$WASH = 7; // o: got eob, possibly still output
// waiting
const $7b5e4d5528b9fdff$var$END = 8; // x: got eob and all data flushed
const $7b5e4d5528b9fdff$var$BADCODE = 9; // x: got error
function $7b5e4d5528b9fdff$var$InfCodes() {
    const that = this;
    let mode; // current inflate_codes mode
    // mode dependent information
    let len = 0;
    let tree; // pointer into tree
    let tree_index = 0;
    let need = 0; // bits needed
    let lit = 0;
    // if EXT or COPY, where and how much
    let get = 0; // bits to get for extra
    let dist = 0; // distance back to copy from
    let lbits = 0; // ltree bits decoded per branch
    let dbits = 0; // dtree bits decoder per branch
    let ltree; // literal/length/eob tree
    let ltree_index = 0; // literal/length/eob tree
    let dtree; // distance tree
    let dtree_index = 0; // distance tree
    // Called with number of bytes left to write in win at least 258
    // (the maximum string length) and number of input bytes available
    // at least ten. The ten bytes are six bytes for the longest length/
    // distance pair plus four bytes for overloading the bit buffer.
    function inflate_fast(bl, bd, tl, tl_index, td, td_index, s, z) {
        let t; // temporary pointer
        let tp; // temporary pointer
        let tp_index; // temporary pointer
        let e; // extra bits or operation
        let b; // bit buffer
        let k; // bits in bit buffer
        let p; // input data pointer
        let n; // bytes available there
        let q; // output win write pointer
        let m; // bytes to end of win or read pointer
        let ml; // mask for literal/length tree
        let md; // mask for distance tree
        let c; // bytes to copy
        let d; // distance back to copy from
        let r; // copy source pointer
        let tp_index_t_3; // (tp_index+t)*3
        // load input, output, bit values
        p = z.next_in_index;
        n = z.avail_in;
        b = s.bitb;
        k = s.bitk;
        q = s.write;
        m = q < s.read ? s.read - q - 1 : s.end - q;
        // initialize masks
        ml = $7b5e4d5528b9fdff$var$inflate_mask[bl];
        md = $7b5e4d5528b9fdff$var$inflate_mask[bd];
        // do until not enough input or output space for fast loop
        do {
            // get literal/length code
            while(k < 20){
                n--;
                b |= (z.read_byte(p++) & 0xff) << k;
                k += 8;
            }
            t = b & ml;
            tp = tl;
            tp_index = tl_index;
            tp_index_t_3 = (tp_index + t) * 3;
            if ((e = tp[tp_index_t_3]) === 0) {
                b >>= tp[tp_index_t_3 + 1];
                k -= tp[tp_index_t_3 + 1];
                s.win[q++] = /* (byte) */ tp[tp_index_t_3 + 2];
                m--;
                continue;
            }
            do {
                b >>= tp[tp_index_t_3 + 1];
                k -= tp[tp_index_t_3 + 1];
                if ((e & 16) !== 0) {
                    e &= 15;
                    c = tp[tp_index_t_3 + 2] + /* (int) */ (b & $7b5e4d5528b9fdff$var$inflate_mask[e]);
                    b >>= e;
                    k -= e;
                    // decode distance base of block to copy
                    while(k < 15){
                        n--;
                        b |= (z.read_byte(p++) & 0xff) << k;
                        k += 8;
                    }
                    t = b & md;
                    tp = td;
                    tp_index = td_index;
                    tp_index_t_3 = (tp_index + t) * 3;
                    e = tp[tp_index_t_3];
                    do {
                        b >>= tp[tp_index_t_3 + 1];
                        k -= tp[tp_index_t_3 + 1];
                        if ((e & 16) !== 0) {
                            // get extra bits to add to distance base
                            e &= 15;
                            while(k < e){
                                n--;
                                b |= (z.read_byte(p++) & 0xff) << k;
                                k += 8;
                            }
                            d = tp[tp_index_t_3 + 2] + (b & $7b5e4d5528b9fdff$var$inflate_mask[e]);
                            b >>= e;
                            k -= e;
                            // do the copy
                            m -= c;
                            if (q >= d) {
                                // just copy
                                r = q - d;
                                if (q - r > 0 && 2 > q - r) {
                                    s.win[q++] = s.win[r++]; // minimum
                                    // count is
                                    // three,
                                    s.win[q++] = s.win[r++]; // so unroll
                                    // loop a
                                    // little
                                    c -= 2;
                                } else {
                                    s.win.set(s.win.subarray(r, r + 2), q);
                                    q += 2;
                                    r += 2;
                                    c -= 2;
                                }
                            } else {
                                r = q - d;
                                do r += s.end; // force pointer in win
                                while (r < 0); // covers invalid distances
                                e = s.end - r;
                                if (c > e) {
                                    c -= e; // wrapped copy
                                    if (q - r > 0 && e > q - r) do s.win[q++] = s.win[r++];
                                    while (--e !== 0);
                                    else {
                                        s.win.set(s.win.subarray(r, r + e), q);
                                        q += e;
                                        r += e;
                                        e = 0;
                                    }
                                    r = 0; // copy rest from start of win
                                }
                            }
                            // copy all or what's left
                            if (q - r > 0 && c > q - r) do s.win[q++] = s.win[r++];
                            while (--c !== 0);
                            else {
                                s.win.set(s.win.subarray(r, r + c), q);
                                q += c;
                                r += c;
                                c = 0;
                            }
                            break;
                        } else if ((e & 64) === 0) {
                            t += tp[tp_index_t_3 + 2];
                            t += b & $7b5e4d5528b9fdff$var$inflate_mask[e];
                            tp_index_t_3 = (tp_index + t) * 3;
                            e = tp[tp_index_t_3];
                        } else {
                            z.msg = "invalid distance code";
                            c = z.avail_in - n;
                            c = k >> 3 < c ? k >> 3 : c;
                            n += c;
                            p -= c;
                            k -= c << 3;
                            s.bitb = b;
                            s.bitk = k;
                            z.avail_in = n;
                            z.total_in += p - z.next_in_index;
                            z.next_in_index = p;
                            s.write = q;
                            return $7b5e4d5528b9fdff$var$Z_DATA_ERROR;
                        }
                    // eslint-disable-next-line no-constant-condition
                    }while (true);
                    break;
                }
                if ((e & 64) === 0) {
                    t += tp[tp_index_t_3 + 2];
                    t += b & $7b5e4d5528b9fdff$var$inflate_mask[e];
                    tp_index_t_3 = (tp_index + t) * 3;
                    if ((e = tp[tp_index_t_3]) === 0) {
                        b >>= tp[tp_index_t_3 + 1];
                        k -= tp[tp_index_t_3 + 1];
                        s.win[q++] = /* (byte) */ tp[tp_index_t_3 + 2];
                        m--;
                        break;
                    }
                } else if ((e & 32) !== 0) {
                    c = z.avail_in - n;
                    c = k >> 3 < c ? k >> 3 : c;
                    n += c;
                    p -= c;
                    k -= c << 3;
                    s.bitb = b;
                    s.bitk = k;
                    z.avail_in = n;
                    z.total_in += p - z.next_in_index;
                    z.next_in_index = p;
                    s.write = q;
                    return $7b5e4d5528b9fdff$var$Z_STREAM_END;
                } else {
                    z.msg = "invalid literal/length code";
                    c = z.avail_in - n;
                    c = k >> 3 < c ? k >> 3 : c;
                    n += c;
                    p -= c;
                    k -= c << 3;
                    s.bitb = b;
                    s.bitk = k;
                    z.avail_in = n;
                    z.total_in += p - z.next_in_index;
                    z.next_in_index = p;
                    s.write = q;
                    return $7b5e4d5528b9fdff$var$Z_DATA_ERROR;
                }
            // eslint-disable-next-line no-constant-condition
            }while (true);
        }while (m >= 258 && n >= 10);
        // not enough input or output--restore pointers and return
        c = z.avail_in - n;
        c = k >> 3 < c ? k >> 3 : c;
        n += c;
        p -= c;
        k -= c << 3;
        s.bitb = b;
        s.bitk = k;
        z.avail_in = n;
        z.total_in += p - z.next_in_index;
        z.next_in_index = p;
        s.write = q;
        return $7b5e4d5528b9fdff$var$Z_OK;
    }
    that.init = function(bl, bd, tl, tl_index, td, td_index) {
        mode = $7b5e4d5528b9fdff$var$START;
        lbits = /* (byte) */ bl;
        dbits = /* (byte) */ bd;
        ltree = tl;
        ltree_index = tl_index;
        dtree = td;
        dtree_index = td_index;
        tree = null;
    };
    that.proc = function(s, z, r) {
        let j; // temporary storage
        let tindex; // temporary pointer
        let e; // extra bits or operation
        let b = 0; // bit buffer
        let k = 0; // bits in bit buffer
        let p = 0; // input data pointer
        let n; // bytes available there
        let q; // output win write pointer
        let m; // bytes to end of win or read pointer
        let f; // pointer to copy strings from
        // copy input/output information to locals (UPDATE macro restores)
        p = z.next_in_index;
        n = z.avail_in;
        b = s.bitb;
        k = s.bitk;
        q = s.write;
        m = q < s.read ? s.read - q - 1 : s.end - q;
        // process input and output based on current state
        // eslint-disable-next-line no-constant-condition
        while(true)switch(mode){
            // waiting for "i:"=input, "o:"=output, "x:"=nothing
            case $7b5e4d5528b9fdff$var$START:
                if (m >= 258 && n >= 10) {
                    s.bitb = b;
                    s.bitk = k;
                    z.avail_in = n;
                    z.total_in += p - z.next_in_index;
                    z.next_in_index = p;
                    s.write = q;
                    r = inflate_fast(lbits, dbits, ltree, ltree_index, dtree, dtree_index, s, z);
                    p = z.next_in_index;
                    n = z.avail_in;
                    b = s.bitb;
                    k = s.bitk;
                    q = s.write;
                    m = q < s.read ? s.read - q - 1 : s.end - q;
                    if (r != $7b5e4d5528b9fdff$var$Z_OK) {
                        mode = r == $7b5e4d5528b9fdff$var$Z_STREAM_END ? $7b5e4d5528b9fdff$var$WASH : $7b5e4d5528b9fdff$var$BADCODE;
                        break;
                    }
                }
                need = lbits;
                tree = ltree;
                tree_index = ltree_index;
                mode = $7b5e4d5528b9fdff$var$LEN;
            /* falls through */ case $7b5e4d5528b9fdff$var$LEN:
                j = need;
                while(k < j){
                    if (n !== 0) r = $7b5e4d5528b9fdff$var$Z_OK;
                    else {
                        s.bitb = b;
                        s.bitk = k;
                        z.avail_in = n;
                        z.total_in += p - z.next_in_index;
                        z.next_in_index = p;
                        s.write = q;
                        return s.inflate_flush(z, r);
                    }
                    n--;
                    b |= (z.read_byte(p++) & 0xff) << k;
                    k += 8;
                }
                tindex = (tree_index + (b & $7b5e4d5528b9fdff$var$inflate_mask[j])) * 3;
                b >>>= tree[tindex + 1];
                k -= tree[tindex + 1];
                e = tree[tindex];
                if (e === 0) {
                    lit = tree[tindex + 2];
                    mode = $7b5e4d5528b9fdff$var$LIT;
                    break;
                }
                if ((e & 16) !== 0) {
                    get = e & 15;
                    len = tree[tindex + 2];
                    mode = $7b5e4d5528b9fdff$var$LENEXT;
                    break;
                }
                if ((e & 64) === 0) {
                    need = e;
                    tree_index = tindex / 3 + tree[tindex + 2];
                    break;
                }
                if ((e & 32) !== 0) {
                    mode = $7b5e4d5528b9fdff$var$WASH;
                    break;
                }
                mode = $7b5e4d5528b9fdff$var$BADCODE; // invalid code
                z.msg = "invalid literal/length code";
                r = $7b5e4d5528b9fdff$var$Z_DATA_ERROR;
                s.bitb = b;
                s.bitk = k;
                z.avail_in = n;
                z.total_in += p - z.next_in_index;
                z.next_in_index = p;
                s.write = q;
                return s.inflate_flush(z, r);
            case $7b5e4d5528b9fdff$var$LENEXT:
                j = get;
                while(k < j){
                    if (n !== 0) r = $7b5e4d5528b9fdff$var$Z_OK;
                    else {
                        s.bitb = b;
                        s.bitk = k;
                        z.avail_in = n;
                        z.total_in += p - z.next_in_index;
                        z.next_in_index = p;
                        s.write = q;
                        return s.inflate_flush(z, r);
                    }
                    n--;
                    b |= (z.read_byte(p++) & 0xff) << k;
                    k += 8;
                }
                len += b & $7b5e4d5528b9fdff$var$inflate_mask[j];
                b >>= j;
                k -= j;
                need = dbits;
                tree = dtree;
                tree_index = dtree_index;
                mode = $7b5e4d5528b9fdff$var$DIST;
            /* falls through */ case $7b5e4d5528b9fdff$var$DIST:
                j = need;
                while(k < j){
                    if (n !== 0) r = $7b5e4d5528b9fdff$var$Z_OK;
                    else {
                        s.bitb = b;
                        s.bitk = k;
                        z.avail_in = n;
                        z.total_in += p - z.next_in_index;
                        z.next_in_index = p;
                        s.write = q;
                        return s.inflate_flush(z, r);
                    }
                    n--;
                    b |= (z.read_byte(p++) & 0xff) << k;
                    k += 8;
                }
                tindex = (tree_index + (b & $7b5e4d5528b9fdff$var$inflate_mask[j])) * 3;
                b >>= tree[tindex + 1];
                k -= tree[tindex + 1];
                e = tree[tindex];
                if ((e & 16) !== 0) {
                    get = e & 15;
                    dist = tree[tindex + 2];
                    mode = $7b5e4d5528b9fdff$var$DISTEXT;
                    break;
                }
                if ((e & 64) === 0) {
                    need = e;
                    tree_index = tindex / 3 + tree[tindex + 2];
                    break;
                }
                mode = $7b5e4d5528b9fdff$var$BADCODE; // invalid code
                z.msg = "invalid distance code";
                r = $7b5e4d5528b9fdff$var$Z_DATA_ERROR;
                s.bitb = b;
                s.bitk = k;
                z.avail_in = n;
                z.total_in += p - z.next_in_index;
                z.next_in_index = p;
                s.write = q;
                return s.inflate_flush(z, r);
            case $7b5e4d5528b9fdff$var$DISTEXT:
                j = get;
                while(k < j){
                    if (n !== 0) r = $7b5e4d5528b9fdff$var$Z_OK;
                    else {
                        s.bitb = b;
                        s.bitk = k;
                        z.avail_in = n;
                        z.total_in += p - z.next_in_index;
                        z.next_in_index = p;
                        s.write = q;
                        return s.inflate_flush(z, r);
                    }
                    n--;
                    b |= (z.read_byte(p++) & 0xff) << k;
                    k += 8;
                }
                dist += b & $7b5e4d5528b9fdff$var$inflate_mask[j];
                b >>= j;
                k -= j;
                mode = $7b5e4d5528b9fdff$var$COPY;
            /* falls through */ case $7b5e4d5528b9fdff$var$COPY:
                f = q - dist;
                while(f < 0)f += s.end; // of "if" handles invalid distances
                while(len !== 0){
                    if (m === 0) {
                        if (q == s.end && s.read !== 0) {
                            q = 0;
                            m = q < s.read ? s.read - q - 1 : s.end - q;
                        }
                        if (m === 0) {
                            s.write = q;
                            r = s.inflate_flush(z, r);
                            q = s.write;
                            m = q < s.read ? s.read - q - 1 : s.end - q;
                            if (q == s.end && s.read !== 0) {
                                q = 0;
                                m = q < s.read ? s.read - q - 1 : s.end - q;
                            }
                            if (m === 0) {
                                s.bitb = b;
                                s.bitk = k;
                                z.avail_in = n;
                                z.total_in += p - z.next_in_index;
                                z.next_in_index = p;
                                s.write = q;
                                return s.inflate_flush(z, r);
                            }
                        }
                    }
                    s.win[q++] = s.win[f++];
                    m--;
                    if (f == s.end) f = 0;
                    len--;
                }
                mode = $7b5e4d5528b9fdff$var$START;
                break;
            case $7b5e4d5528b9fdff$var$LIT:
                if (m === 0) {
                    if (q == s.end && s.read !== 0) {
                        q = 0;
                        m = q < s.read ? s.read - q - 1 : s.end - q;
                    }
                    if (m === 0) {
                        s.write = q;
                        r = s.inflate_flush(z, r);
                        q = s.write;
                        m = q < s.read ? s.read - q - 1 : s.end - q;
                        if (q == s.end && s.read !== 0) {
                            q = 0;
                            m = q < s.read ? s.read - q - 1 : s.end - q;
                        }
                        if (m === 0) {
                            s.bitb = b;
                            s.bitk = k;
                            z.avail_in = n;
                            z.total_in += p - z.next_in_index;
                            z.next_in_index = p;
                            s.write = q;
                            return s.inflate_flush(z, r);
                        }
                    }
                }
                r = $7b5e4d5528b9fdff$var$Z_OK;
                s.win[q++] = /* (byte) */ lit;
                m--;
                mode = $7b5e4d5528b9fdff$var$START;
                break;
            case $7b5e4d5528b9fdff$var$WASH:
                if (k > 7) {
                    k -= 8;
                    n++;
                    p--; // can always return one
                }
                s.write = q;
                r = s.inflate_flush(z, r);
                q = s.write;
                m = q < s.read ? s.read - q - 1 : s.end - q;
                if (s.read != s.write) {
                    s.bitb = b;
                    s.bitk = k;
                    z.avail_in = n;
                    z.total_in += p - z.next_in_index;
                    z.next_in_index = p;
                    s.write = q;
                    return s.inflate_flush(z, r);
                }
                mode = $7b5e4d5528b9fdff$var$END;
            /* falls through */ case $7b5e4d5528b9fdff$var$END:
                r = $7b5e4d5528b9fdff$var$Z_STREAM_END;
                s.bitb = b;
                s.bitk = k;
                z.avail_in = n;
                z.total_in += p - z.next_in_index;
                z.next_in_index = p;
                s.write = q;
                return s.inflate_flush(z, r);
            case $7b5e4d5528b9fdff$var$BADCODE:
                r = $7b5e4d5528b9fdff$var$Z_DATA_ERROR;
                s.bitb = b;
                s.bitk = k;
                z.avail_in = n;
                z.total_in += p - z.next_in_index;
                z.next_in_index = p;
                s.write = q;
                return s.inflate_flush(z, r);
            default:
                r = $7b5e4d5528b9fdff$var$Z_STREAM_ERROR;
                s.bitb = b;
                s.bitk = k;
                z.avail_in = n;
                z.total_in += p - z.next_in_index;
                z.next_in_index = p;
                s.write = q;
                return s.inflate_flush(z, r);
        }
    };
    that.free = function() {
    // ZFREE(z, c);
    };
}
// InfBlocks
// Table for deflate from PKZIP's appnote.txt.
const $7b5e4d5528b9fdff$var$border = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
const $7b5e4d5528b9fdff$var$TYPE = 0; // get type bits (3, including end bit)
const $7b5e4d5528b9fdff$var$LENS = 1; // get lengths for stored
const $7b5e4d5528b9fdff$var$STORED = 2; // processing stored block
const $7b5e4d5528b9fdff$var$TABLE = 3; // get table lengths
const $7b5e4d5528b9fdff$var$BTREE = 4; // get bit lengths tree for a dynamic
// block
const $7b5e4d5528b9fdff$var$DTREE = 5; // get length, distance trees for a
// dynamic block
const $7b5e4d5528b9fdff$var$CODES = 6; // processing fixed or dynamic block
const $7b5e4d5528b9fdff$var$DRY = 7; // output remaining win bytes
const $7b5e4d5528b9fdff$var$DONELOCKS = 8; // finished last block, done
const $7b5e4d5528b9fdff$var$BADBLOCKS = 9; // ot a data error--stuck here
function $7b5e4d5528b9fdff$var$InfBlocks(z, w) {
    const that = this;
    let mode = $7b5e4d5528b9fdff$var$TYPE; // current inflate_block mode
    let left = 0; // if STORED, bytes left to copy
    let table = 0; // table lengths (14 bits)
    let index = 0; // index into blens (or border)
    let blens; // bit lengths of codes
    const bb = [
        0
    ]; // bit length tree depth
    const tb = [
        0
    ]; // bit length decoding tree
    const codes = new $7b5e4d5528b9fdff$var$InfCodes(); // if CODES, current state
    let last = 0; // true if this block is the last block
    let hufts = new Int32Array($7b5e4d5528b9fdff$var$MANY * 3); // single malloc for tree space
    const check = 0; // check on output
    const inftree = new $7b5e4d5528b9fdff$var$InfTree();
    that.bitk = 0; // bits in bit buffer
    that.bitb = 0; // bit buffer
    that.win = new Uint8Array(w); // sliding win
    that.end = w; // one byte after sliding win
    that.read = 0; // win read pointer
    that.write = 0; // win write pointer
    that.reset = function(z, c) {
        if (c) c[0] = check;
        // if (mode == BTREE || mode == DTREE) {
        // }
        if (mode == $7b5e4d5528b9fdff$var$CODES) codes.free(z);
        mode = $7b5e4d5528b9fdff$var$TYPE;
        that.bitk = 0;
        that.bitb = 0;
        that.read = that.write = 0;
    };
    that.reset(z, null);
    // copy as much as possible from the sliding win to the output area
    that.inflate_flush = function(z, r) {
        let n;
        let p;
        let q;
        // local copies of source and destination pointers
        p = z.next_out_index;
        q = that.read;
        // compute number of bytes to copy as far as end of win
        n = /* (int) */ (q <= that.write ? that.write : that.end) - q;
        if (n > z.avail_out) n = z.avail_out;
        if (n !== 0 && r == $7b5e4d5528b9fdff$var$Z_BUF_ERROR) r = $7b5e4d5528b9fdff$var$Z_OK;
        // update counters
        z.avail_out -= n;
        z.total_out += n;
        // copy as far as end of win
        z.next_out.set(that.win.subarray(q, q + n), p);
        p += n;
        q += n;
        // see if more to copy at beginning of win
        if (q == that.end) {
            // wrap pointers
            q = 0;
            if (that.write == that.end) that.write = 0;
            // compute bytes to copy
            n = that.write - q;
            if (n > z.avail_out) n = z.avail_out;
            if (n !== 0 && r == $7b5e4d5528b9fdff$var$Z_BUF_ERROR) r = $7b5e4d5528b9fdff$var$Z_OK;
            // update counters
            z.avail_out -= n;
            z.total_out += n;
            // copy
            z.next_out.set(that.win.subarray(q, q + n), p);
            p += n;
            q += n;
        }
        // update pointers
        z.next_out_index = p;
        that.read = q;
        // done
        return r;
    };
    that.proc = function(z, r) {
        let t; // temporary storage
        let b; // bit buffer
        let k; // bits in bit buffer
        let p; // input data pointer
        let n; // bytes available there
        let q; // output win write pointer
        let m; // bytes to end of win or read pointer
        let i;
        // copy input/output information to locals (UPDATE macro restores)
        // {
        p = z.next_in_index;
        n = z.avail_in;
        b = that.bitb;
        k = that.bitk;
        // }
        // {
        q = that.write;
        m = /* (int) */ q < that.read ? that.read - q - 1 : that.end - q;
        // }
        // process input based on current state
        // DEBUG dtree
        // eslint-disable-next-line no-constant-condition
        while(true){
            let bl, bd, tl, td, bl_, bd_, tl_, td_;
            switch(mode){
                case $7b5e4d5528b9fdff$var$TYPE:
                    while(k < 3){
                        if (n !== 0) r = $7b5e4d5528b9fdff$var$Z_OK;
                        else {
                            that.bitb = b;
                            that.bitk = k;
                            z.avail_in = n;
                            z.total_in += p - z.next_in_index;
                            z.next_in_index = p;
                            that.write = q;
                            return that.inflate_flush(z, r);
                        }
                        n--;
                        b |= (z.read_byte(p++) & 0xff) << k;
                        k += 8;
                    }
                    t = /* (int) */ b & 7;
                    last = t & 1;
                    switch(t >>> 1){
                        case 0:
                            // {
                            b >>>= 3;
                            k -= 3;
                            // }
                            t = k & 7; // go to byte boundary
                            // {
                            b >>>= t;
                            k -= t;
                            // }
                            mode = $7b5e4d5528b9fdff$var$LENS; // get length of stored block
                            break;
                        case 1:
                            // {
                            bl = []; // new Array(1);
                            bd = []; // new Array(1);
                            tl = [
                                []
                            ]; // new Array(1);
                            td = [
                                []
                            ]; // new Array(1);
                            $7b5e4d5528b9fdff$var$InfTree.inflate_trees_fixed(bl, bd, tl, td);
                            codes.init(bl[0], bd[0], tl[0], 0, td[0], 0);
                            // }
                            // {
                            b >>>= 3;
                            k -= 3;
                            // }
                            mode = $7b5e4d5528b9fdff$var$CODES;
                            break;
                        case 2:
                            // {
                            b >>>= 3;
                            k -= 3;
                            // }
                            mode = $7b5e4d5528b9fdff$var$TABLE;
                            break;
                        case 3:
                            // {
                            b >>>= 3;
                            k -= 3;
                            // }
                            mode = $7b5e4d5528b9fdff$var$BADBLOCKS;
                            z.msg = "invalid block type";
                            r = $7b5e4d5528b9fdff$var$Z_DATA_ERROR;
                            that.bitb = b;
                            that.bitk = k;
                            z.avail_in = n;
                            z.total_in += p - z.next_in_index;
                            z.next_in_index = p;
                            that.write = q;
                            return that.inflate_flush(z, r);
                    }
                    break;
                case $7b5e4d5528b9fdff$var$LENS:
                    while(k < 32){
                        if (n !== 0) r = $7b5e4d5528b9fdff$var$Z_OK;
                        else {
                            that.bitb = b;
                            that.bitk = k;
                            z.avail_in = n;
                            z.total_in += p - z.next_in_index;
                            z.next_in_index = p;
                            that.write = q;
                            return that.inflate_flush(z, r);
                        }
                        n--;
                        b |= (z.read_byte(p++) & 0xff) << k;
                        k += 8;
                    }
                    if ((~b >>> 16 & 0xffff) != (b & 0xffff)) {
                        mode = $7b5e4d5528b9fdff$var$BADBLOCKS;
                        z.msg = "invalid stored block lengths";
                        r = $7b5e4d5528b9fdff$var$Z_DATA_ERROR;
                        that.bitb = b;
                        that.bitk = k;
                        z.avail_in = n;
                        z.total_in += p - z.next_in_index;
                        z.next_in_index = p;
                        that.write = q;
                        return that.inflate_flush(z, r);
                    }
                    left = b & 0xffff;
                    b = k = 0; // dump bits
                    mode = left !== 0 ? $7b5e4d5528b9fdff$var$STORED : last !== 0 ? $7b5e4d5528b9fdff$var$DRY : $7b5e4d5528b9fdff$var$TYPE;
                    break;
                case $7b5e4d5528b9fdff$var$STORED:
                    if (n === 0) {
                        that.bitb = b;
                        that.bitk = k;
                        z.avail_in = n;
                        z.total_in += p - z.next_in_index;
                        z.next_in_index = p;
                        that.write = q;
                        return that.inflate_flush(z, r);
                    }
                    if (m === 0) {
                        if (q == that.end && that.read !== 0) {
                            q = 0;
                            m = /* (int) */ q < that.read ? that.read - q - 1 : that.end - q;
                        }
                        if (m === 0) {
                            that.write = q;
                            r = that.inflate_flush(z, r);
                            q = that.write;
                            m = /* (int) */ q < that.read ? that.read - q - 1 : that.end - q;
                            if (q == that.end && that.read !== 0) {
                                q = 0;
                                m = /* (int) */ q < that.read ? that.read - q - 1 : that.end - q;
                            }
                            if (m === 0) {
                                that.bitb = b;
                                that.bitk = k;
                                z.avail_in = n;
                                z.total_in += p - z.next_in_index;
                                z.next_in_index = p;
                                that.write = q;
                                return that.inflate_flush(z, r);
                            }
                        }
                    }
                    r = $7b5e4d5528b9fdff$var$Z_OK;
                    t = left;
                    if (t > n) t = n;
                    if (t > m) t = m;
                    that.win.set(z.read_buf(p, t), q);
                    p += t;
                    n -= t;
                    q += t;
                    m -= t;
                    if ((left -= t) !== 0) break;
                    mode = last !== 0 ? $7b5e4d5528b9fdff$var$DRY : $7b5e4d5528b9fdff$var$TYPE;
                    break;
                case $7b5e4d5528b9fdff$var$TABLE:
                    while(k < 14){
                        if (n !== 0) r = $7b5e4d5528b9fdff$var$Z_OK;
                        else {
                            that.bitb = b;
                            that.bitk = k;
                            z.avail_in = n;
                            z.total_in += p - z.next_in_index;
                            z.next_in_index = p;
                            that.write = q;
                            return that.inflate_flush(z, r);
                        }
                        n--;
                        b |= (z.read_byte(p++) & 0xff) << k;
                        k += 8;
                    }
                    table = t = b & 0x3fff;
                    if ((t & 0x1f) > 29 || (t >> 5 & 0x1f) > 29) {
                        mode = $7b5e4d5528b9fdff$var$BADBLOCKS;
                        z.msg = "too many length or distance symbols";
                        r = $7b5e4d5528b9fdff$var$Z_DATA_ERROR;
                        that.bitb = b;
                        that.bitk = k;
                        z.avail_in = n;
                        z.total_in += p - z.next_in_index;
                        z.next_in_index = p;
                        that.write = q;
                        return that.inflate_flush(z, r);
                    }
                    t = 258 + (t & 0x1f) + (t >> 5 & 0x1f);
                    if (!blens || blens.length < t) blens = []; // new Array(t);
                    else for(i = 0; i < t; i++)blens[i] = 0;
                    // {
                    b >>>= 14;
                    k -= 14;
                    // }
                    index = 0;
                    mode = $7b5e4d5528b9fdff$var$BTREE;
                /* falls through */ case $7b5e4d5528b9fdff$var$BTREE:
                    while(index < 4 + (table >>> 10)){
                        while(k < 3){
                            if (n !== 0) r = $7b5e4d5528b9fdff$var$Z_OK;
                            else {
                                that.bitb = b;
                                that.bitk = k;
                                z.avail_in = n;
                                z.total_in += p - z.next_in_index;
                                z.next_in_index = p;
                                that.write = q;
                                return that.inflate_flush(z, r);
                            }
                            n--;
                            b |= (z.read_byte(p++) & 0xff) << k;
                            k += 8;
                        }
                        blens[$7b5e4d5528b9fdff$var$border[index++]] = b & 7;
                        // {
                        b >>>= 3;
                        k -= 3;
                    // }
                    }
                    while(index < 19)blens[$7b5e4d5528b9fdff$var$border[index++]] = 0;
                    bb[0] = 7;
                    t = inftree.inflate_trees_bits(blens, bb, tb, hufts, z);
                    if (t != $7b5e4d5528b9fdff$var$Z_OK) {
                        r = t;
                        if (r == $7b5e4d5528b9fdff$var$Z_DATA_ERROR) {
                            blens = null;
                            mode = $7b5e4d5528b9fdff$var$BADBLOCKS;
                        }
                        that.bitb = b;
                        that.bitk = k;
                        z.avail_in = n;
                        z.total_in += p - z.next_in_index;
                        z.next_in_index = p;
                        that.write = q;
                        return that.inflate_flush(z, r);
                    }
                    index = 0;
                    mode = $7b5e4d5528b9fdff$var$DTREE;
                /* falls through */ case $7b5e4d5528b9fdff$var$DTREE:
                    // eslint-disable-next-line no-constant-condition
                    while(true){
                        t = table;
                        if (index >= 258 + (t & 0x1f) + (t >> 5 & 0x1f)) break;
                        let j, c;
                        t = bb[0];
                        while(k < t){
                            if (n !== 0) r = $7b5e4d5528b9fdff$var$Z_OK;
                            else {
                                that.bitb = b;
                                that.bitk = k;
                                z.avail_in = n;
                                z.total_in += p - z.next_in_index;
                                z.next_in_index = p;
                                that.write = q;
                                return that.inflate_flush(z, r);
                            }
                            n--;
                            b |= (z.read_byte(p++) & 0xff) << k;
                            k += 8;
                        }
                        // if (tb[0] == -1) {
                        // System.err.println("null...");
                        // }
                        t = hufts[(tb[0] + (b & $7b5e4d5528b9fdff$var$inflate_mask[t])) * 3 + 1];
                        c = hufts[(tb[0] + (b & $7b5e4d5528b9fdff$var$inflate_mask[t])) * 3 + 2];
                        if (c < 16) {
                            b >>>= t;
                            k -= t;
                            blens[index++] = c;
                        } else {
                            i = c == 18 ? 7 : c - 14;
                            j = c == 18 ? 11 : 3;
                            while(k < t + i){
                                if (n !== 0) r = $7b5e4d5528b9fdff$var$Z_OK;
                                else {
                                    that.bitb = b;
                                    that.bitk = k;
                                    z.avail_in = n;
                                    z.total_in += p - z.next_in_index;
                                    z.next_in_index = p;
                                    that.write = q;
                                    return that.inflate_flush(z, r);
                                }
                                n--;
                                b |= (z.read_byte(p++) & 0xff) << k;
                                k += 8;
                            }
                            b >>>= t;
                            k -= t;
                            j += b & $7b5e4d5528b9fdff$var$inflate_mask[i];
                            b >>>= i;
                            k -= i;
                            i = index;
                            t = table;
                            if (i + j > 258 + (t & 0x1f) + (t >> 5 & 0x1f) || c == 16 && i < 1) {
                                blens = null;
                                mode = $7b5e4d5528b9fdff$var$BADBLOCKS;
                                z.msg = "invalid bit length repeat";
                                r = $7b5e4d5528b9fdff$var$Z_DATA_ERROR;
                                that.bitb = b;
                                that.bitk = k;
                                z.avail_in = n;
                                z.total_in += p - z.next_in_index;
                                z.next_in_index = p;
                                that.write = q;
                                return that.inflate_flush(z, r);
                            }
                            c = c == 16 ? blens[i - 1] : 0;
                            do blens[i++] = c;
                            while (--j !== 0);
                            index = i;
                        }
                    }
                    tb[0] = -1;
                    // {
                    bl_ = []; // new Array(1);
                    bd_ = []; // new Array(1);
                    tl_ = []; // new Array(1);
                    td_ = []; // new Array(1);
                    bl_[0] = 9; // must be <= 9 for lookahead assumptions
                    bd_[0] = 6; // must be <= 9 for lookahead assumptions
                    t = table;
                    t = inftree.inflate_trees_dynamic(257 + (t & 0x1f), 1 + (t >> 5 & 0x1f), blens, bl_, bd_, tl_, td_, hufts, z);
                    if (t != $7b5e4d5528b9fdff$var$Z_OK) {
                        if (t == $7b5e4d5528b9fdff$var$Z_DATA_ERROR) {
                            blens = null;
                            mode = $7b5e4d5528b9fdff$var$BADBLOCKS;
                        }
                        r = t;
                        that.bitb = b;
                        that.bitk = k;
                        z.avail_in = n;
                        z.total_in += p - z.next_in_index;
                        z.next_in_index = p;
                        that.write = q;
                        return that.inflate_flush(z, r);
                    }
                    codes.init(bl_[0], bd_[0], hufts, tl_[0], hufts, td_[0]);
                    // }
                    mode = $7b5e4d5528b9fdff$var$CODES;
                /* falls through */ case $7b5e4d5528b9fdff$var$CODES:
                    that.bitb = b;
                    that.bitk = k;
                    z.avail_in = n;
                    z.total_in += p - z.next_in_index;
                    z.next_in_index = p;
                    that.write = q;
                    if ((r = codes.proc(that, z, r)) != $7b5e4d5528b9fdff$var$Z_STREAM_END) return that.inflate_flush(z, r);
                    r = $7b5e4d5528b9fdff$var$Z_OK;
                    codes.free(z);
                    p = z.next_in_index;
                    n = z.avail_in;
                    b = that.bitb;
                    k = that.bitk;
                    q = that.write;
                    m = /* (int) */ q < that.read ? that.read - q - 1 : that.end - q;
                    if (last === 0) {
                        mode = $7b5e4d5528b9fdff$var$TYPE;
                        break;
                    }
                    mode = $7b5e4d5528b9fdff$var$DRY;
                /* falls through */ case $7b5e4d5528b9fdff$var$DRY:
                    that.write = q;
                    r = that.inflate_flush(z, r);
                    q = that.write;
                    m = /* (int) */ q < that.read ? that.read - q - 1 : that.end - q;
                    if (that.read != that.write) {
                        that.bitb = b;
                        that.bitk = k;
                        z.avail_in = n;
                        z.total_in += p - z.next_in_index;
                        z.next_in_index = p;
                        that.write = q;
                        return that.inflate_flush(z, r);
                    }
                    mode = $7b5e4d5528b9fdff$var$DONELOCKS;
                /* falls through */ case $7b5e4d5528b9fdff$var$DONELOCKS:
                    r = $7b5e4d5528b9fdff$var$Z_STREAM_END;
                    that.bitb = b;
                    that.bitk = k;
                    z.avail_in = n;
                    z.total_in += p - z.next_in_index;
                    z.next_in_index = p;
                    that.write = q;
                    return that.inflate_flush(z, r);
                case $7b5e4d5528b9fdff$var$BADBLOCKS:
                    r = $7b5e4d5528b9fdff$var$Z_DATA_ERROR;
                    that.bitb = b;
                    that.bitk = k;
                    z.avail_in = n;
                    z.total_in += p - z.next_in_index;
                    z.next_in_index = p;
                    that.write = q;
                    return that.inflate_flush(z, r);
                default:
                    r = $7b5e4d5528b9fdff$var$Z_STREAM_ERROR;
                    that.bitb = b;
                    that.bitk = k;
                    z.avail_in = n;
                    z.total_in += p - z.next_in_index;
                    z.next_in_index = p;
                    that.write = q;
                    return that.inflate_flush(z, r);
            }
        }
    };
    that.free = function(z) {
        that.reset(z, null);
        that.win = null;
        hufts = null;
    // ZFREE(z, s);
    };
    that.set_dictionary = function(d, start, n) {
        that.win.set(d.subarray(start, start + n), 0);
        that.read = that.write = n;
    };
    // Returns true if inflate is currently at the end of a block generated
    // by Z_SYNC_FLUSH or Z_FULL_FLUSH.
    that.sync_point = function() {
        return mode == $7b5e4d5528b9fdff$var$LENS ? 1 : 0;
    };
}
// Inflate
// preset dictionary flag in zlib header
const $7b5e4d5528b9fdff$var$PRESET_DICT = 0x20;
const $7b5e4d5528b9fdff$var$Z_DEFLATED = 8;
const $7b5e4d5528b9fdff$var$METHOD = 0; // waiting for method byte
const $7b5e4d5528b9fdff$var$FLAG = 1; // waiting for flag byte
const $7b5e4d5528b9fdff$var$DICT4 = 2; // four dictionary check bytes to go
const $7b5e4d5528b9fdff$var$DICT3 = 3; // three dictionary check bytes to go
const $7b5e4d5528b9fdff$var$DICT2 = 4; // two dictionary check bytes to go
const $7b5e4d5528b9fdff$var$DICT1 = 5; // one dictionary check byte to go
const $7b5e4d5528b9fdff$var$DICT0 = 6; // waiting for inflateSetDictionary
const $7b5e4d5528b9fdff$var$BLOCKS = 7; // decompressing blocks
const $7b5e4d5528b9fdff$var$DONE = 12; // finished check, done
const $7b5e4d5528b9fdff$var$BAD = 13; // got an error--stay here
const $7b5e4d5528b9fdff$var$mark = [
    0,
    0,
    0xff,
    0xff
];
function $7b5e4d5528b9fdff$var$Inflate() {
    const that = this;
    that.mode = 0; // current inflate mode
    // mode dependent information
    that.method = 0; // if FLAGS, method byte
    // if CHECK, check values to compare
    that.was = [
        0
    ]; // new Array(1); // computed check value
    that.need = 0; // stream check value
    // if BAD, inflateSync's marker bytes count
    that.marker = 0;
    // mode independent information
    that.wbits = 0; // log2(win size) (8..15, defaults to 15)
    // this.blocks; // current inflate_blocks state
    function inflateReset(z) {
        if (!z || !z.istate) return $7b5e4d5528b9fdff$var$Z_STREAM_ERROR;
        z.total_in = z.total_out = 0;
        z.msg = null;
        z.istate.mode = $7b5e4d5528b9fdff$var$BLOCKS;
        z.istate.blocks.reset(z, null);
        return $7b5e4d5528b9fdff$var$Z_OK;
    }
    that.inflateEnd = function(z) {
        if (that.blocks) that.blocks.free(z);
        that.blocks = null;
        // ZFREE(z, z->state);
        return $7b5e4d5528b9fdff$var$Z_OK;
    };
    that.inflateInit = function(z, w) {
        z.msg = null;
        that.blocks = null;
        // set win size
        if (w < 8 || w > 15) {
            that.inflateEnd(z);
            return $7b5e4d5528b9fdff$var$Z_STREAM_ERROR;
        }
        that.wbits = w;
        z.istate.blocks = new $7b5e4d5528b9fdff$var$InfBlocks(z, 1 << w);
        // reset state
        inflateReset(z);
        return $7b5e4d5528b9fdff$var$Z_OK;
    };
    that.inflate = function(z, f) {
        let r;
        let b;
        if (!z || !z.istate || !z.next_in) return $7b5e4d5528b9fdff$var$Z_STREAM_ERROR;
        const istate = z.istate;
        f = f == $7b5e4d5528b9fdff$var$Z_FINISH ? $7b5e4d5528b9fdff$var$Z_BUF_ERROR : $7b5e4d5528b9fdff$var$Z_OK;
        r = $7b5e4d5528b9fdff$var$Z_BUF_ERROR;
        // eslint-disable-next-line no-constant-condition
        while(true)switch(istate.mode){
            case $7b5e4d5528b9fdff$var$METHOD:
                if (z.avail_in === 0) return r;
                r = f;
                z.avail_in--;
                z.total_in++;
                if (((istate.method = z.read_byte(z.next_in_index++)) & 0xf) != $7b5e4d5528b9fdff$var$Z_DEFLATED) {
                    istate.mode = $7b5e4d5528b9fdff$var$BAD;
                    z.msg = "unknown compression method";
                    istate.marker = 5; // can't try inflateSync
                    break;
                }
                if ((istate.method >> 4) + 8 > istate.wbits) {
                    istate.mode = $7b5e4d5528b9fdff$var$BAD;
                    z.msg = "invalid win size";
                    istate.marker = 5; // can't try inflateSync
                    break;
                }
                istate.mode = $7b5e4d5528b9fdff$var$FLAG;
            /* falls through */ case $7b5e4d5528b9fdff$var$FLAG:
                if (z.avail_in === 0) return r;
                r = f;
                z.avail_in--;
                z.total_in++;
                b = z.read_byte(z.next_in_index++) & 0xff;
                if (((istate.method << 8) + b) % 31 !== 0) {
                    istate.mode = $7b5e4d5528b9fdff$var$BAD;
                    z.msg = "incorrect header check";
                    istate.marker = 5; // can't try inflateSync
                    break;
                }
                if ((b & $7b5e4d5528b9fdff$var$PRESET_DICT) === 0) {
                    istate.mode = $7b5e4d5528b9fdff$var$BLOCKS;
                    break;
                }
                istate.mode = $7b5e4d5528b9fdff$var$DICT4;
            /* falls through */ case $7b5e4d5528b9fdff$var$DICT4:
                if (z.avail_in === 0) return r;
                r = f;
                z.avail_in--;
                z.total_in++;
                istate.need = (z.read_byte(z.next_in_index++) & 0xff) << 24 & 0xff000000;
                istate.mode = $7b5e4d5528b9fdff$var$DICT3;
            /* falls through */ case $7b5e4d5528b9fdff$var$DICT3:
                if (z.avail_in === 0) return r;
                r = f;
                z.avail_in--;
                z.total_in++;
                istate.need += (z.read_byte(z.next_in_index++) & 0xff) << 16 & 0xff0000;
                istate.mode = $7b5e4d5528b9fdff$var$DICT2;
            /* falls through */ case $7b5e4d5528b9fdff$var$DICT2:
                if (z.avail_in === 0) return r;
                r = f;
                z.avail_in--;
                z.total_in++;
                istate.need += (z.read_byte(z.next_in_index++) & 0xff) << 8 & 0xff00;
                istate.mode = $7b5e4d5528b9fdff$var$DICT1;
            /* falls through */ case $7b5e4d5528b9fdff$var$DICT1:
                if (z.avail_in === 0) return r;
                r = f;
                z.avail_in--;
                z.total_in++;
                istate.need += z.read_byte(z.next_in_index++) & 0xff;
                istate.mode = $7b5e4d5528b9fdff$var$DICT0;
                return $7b5e4d5528b9fdff$var$Z_NEED_DICT;
            case $7b5e4d5528b9fdff$var$DICT0:
                istate.mode = $7b5e4d5528b9fdff$var$BAD;
                z.msg = "need dictionary";
                istate.marker = 0; // can try inflateSync
                return $7b5e4d5528b9fdff$var$Z_STREAM_ERROR;
            case $7b5e4d5528b9fdff$var$BLOCKS:
                r = istate.blocks.proc(z, r);
                if (r == $7b5e4d5528b9fdff$var$Z_DATA_ERROR) {
                    istate.mode = $7b5e4d5528b9fdff$var$BAD;
                    istate.marker = 0; // can try inflateSync
                    break;
                }
                if (r == $7b5e4d5528b9fdff$var$Z_OK) r = f;
                if (r != $7b5e4d5528b9fdff$var$Z_STREAM_END) return r;
                r = f;
                istate.blocks.reset(z, istate.was);
                istate.mode = $7b5e4d5528b9fdff$var$DONE;
            /* falls through */ case $7b5e4d5528b9fdff$var$DONE:
                z.avail_in = 0;
                return $7b5e4d5528b9fdff$var$Z_STREAM_END;
            case $7b5e4d5528b9fdff$var$BAD:
                return $7b5e4d5528b9fdff$var$Z_DATA_ERROR;
            default:
                return $7b5e4d5528b9fdff$var$Z_STREAM_ERROR;
        }
    };
    that.inflateSetDictionary = function(z, dictionary, dictLength) {
        let index = 0, length = dictLength;
        if (!z || !z.istate || z.istate.mode != $7b5e4d5528b9fdff$var$DICT0) return $7b5e4d5528b9fdff$var$Z_STREAM_ERROR;
        const istate = z.istate;
        if (length >= 1 << istate.wbits) {
            length = (1 << istate.wbits) - 1;
            index = dictLength - length;
        }
        istate.blocks.set_dictionary(dictionary, index, length);
        istate.mode = $7b5e4d5528b9fdff$var$BLOCKS;
        return $7b5e4d5528b9fdff$var$Z_OK;
    };
    that.inflateSync = function(z) {
        let n; // number of bytes to look at
        let p; // pointer to bytes
        let m; // number of marker bytes found in a row
        let r, w; // temporaries to save total_in and total_out
        // set up
        if (!z || !z.istate) return $7b5e4d5528b9fdff$var$Z_STREAM_ERROR;
        const istate = z.istate;
        if (istate.mode != $7b5e4d5528b9fdff$var$BAD) {
            istate.mode = $7b5e4d5528b9fdff$var$BAD;
            istate.marker = 0;
        }
        if ((n = z.avail_in) === 0) return $7b5e4d5528b9fdff$var$Z_BUF_ERROR;
        p = z.next_in_index;
        m = istate.marker;
        // search
        while(n !== 0 && m < 4){
            if (z.read_byte(p) == $7b5e4d5528b9fdff$var$mark[m]) m++;
            else if (z.read_byte(p) !== 0) m = 0;
            else m = 4 - m;
            p++;
            n--;
        }
        // restore
        z.total_in += p - z.next_in_index;
        z.next_in_index = p;
        z.avail_in = n;
        istate.marker = m;
        // return no joy or set up to restart on a new block
        if (m != 4) return $7b5e4d5528b9fdff$var$Z_DATA_ERROR;
        r = z.total_in;
        w = z.total_out;
        inflateReset(z);
        z.total_in = r;
        z.total_out = w;
        istate.mode = $7b5e4d5528b9fdff$var$BLOCKS;
        return $7b5e4d5528b9fdff$var$Z_OK;
    };
    // Returns true if inflate is currently at the end of a block generated
    // by Z_SYNC_FLUSH or Z_FULL_FLUSH. This function is used by one PPP
    // implementation to provide an additional safety check. PPP uses
    // Z_SYNC_FLUSH
    // but removes the length bytes of the resulting empty stored block. When
    // decompressing, PPP checks that at the end of input packet, inflate is
    // waiting for these length bytes.
    that.inflateSyncPoint = function(z) {
        if (!z || !z.istate || !z.istate.blocks) return $7b5e4d5528b9fdff$var$Z_STREAM_ERROR;
        return z.istate.blocks.sync_point();
    };
}
// ZStream
function $7b5e4d5528b9fdff$var$ZStream() {}
$7b5e4d5528b9fdff$var$ZStream.prototype = {
    inflateInit (bits) {
        const that = this;
        that.istate = new $7b5e4d5528b9fdff$var$Inflate();
        if (!bits) bits = $7b5e4d5528b9fdff$var$MAX_BITS;
        return that.istate.inflateInit(that, bits);
    },
    inflate (f) {
        const that = this;
        if (!that.istate) return $7b5e4d5528b9fdff$var$Z_STREAM_ERROR;
        return that.istate.inflate(that, f);
    },
    inflateEnd () {
        const that = this;
        if (!that.istate) return $7b5e4d5528b9fdff$var$Z_STREAM_ERROR;
        const ret = that.istate.inflateEnd(that);
        that.istate = null;
        return ret;
    },
    inflateSync () {
        const that = this;
        if (!that.istate) return $7b5e4d5528b9fdff$var$Z_STREAM_ERROR;
        return that.istate.inflateSync(that);
    },
    inflateSetDictionary (dictionary, dictLength) {
        const that = this;
        if (!that.istate) return $7b5e4d5528b9fdff$var$Z_STREAM_ERROR;
        return that.istate.inflateSetDictionary(that, dictionary, dictLength);
    },
    read_byte (start) {
        const that = this;
        return that.next_in[start];
    },
    read_buf (start, size) {
        const that = this;
        return that.next_in.subarray(start, start + size);
    }
};
// Inflater
function $7b5e4d5528b9fdff$export$d1de70a877d6e43c(options) {
    const that = this;
    const z = new $7b5e4d5528b9fdff$var$ZStream();
    const bufsize = options && options.chunkSize ? Math.floor(options.chunkSize * 2) : 131072;
    const flush = $7b5e4d5528b9fdff$var$Z_NO_FLUSH;
    const buf = new Uint8Array(bufsize);
    let nomoreinput = false;
    z.inflateInit();
    z.next_out = buf;
    that.append = function(data, onprogress) {
        const buffers = [];
        let err, array, lastIndex = 0, bufferIndex = 0, bufferSize = 0;
        if (data.length === 0) return;
        z.next_in_index = 0;
        z.next_in = data;
        z.avail_in = data.length;
        do {
            z.next_out_index = 0;
            z.avail_out = bufsize;
            if (z.avail_in === 0 && !nomoreinput) {
                z.next_in_index = 0;
                nomoreinput = true;
            }
            err = z.inflate(flush);
            if (nomoreinput && err === $7b5e4d5528b9fdff$var$Z_BUF_ERROR) {
                if (z.avail_in !== 0) throw new Error("inflating: bad input");
            } else if (err !== $7b5e4d5528b9fdff$var$Z_OK && err !== $7b5e4d5528b9fdff$var$Z_STREAM_END) throw new Error("inflating: " + z.msg);
            if ((nomoreinput || err === $7b5e4d5528b9fdff$var$Z_STREAM_END) && z.avail_in === data.length) throw new Error("inflating: bad input");
            if (z.next_out_index) {
                if (z.next_out_index === bufsize) buffers.push(new Uint8Array(buf));
                else buffers.push(buf.slice(0, z.next_out_index));
            }
            bufferSize += z.next_out_index;
            if (onprogress && z.next_in_index > 0 && z.next_in_index != lastIndex) {
                onprogress(z.next_in_index);
                lastIndex = z.next_in_index;
            }
        }while (z.avail_in > 0 || z.avail_out === 0);
        if (buffers.length > 1) {
            array = new Uint8Array(bufferSize);
            buffers.forEach(function(chunk) {
                array.set(chunk, bufferIndex);
                bufferIndex += chunk.length;
            });
        } else array = buffers[0] || new Uint8Array();
        return array;
    };
    that.flush = function() {
        z.inflateEnd();
    };
}


/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /* global navigator, CompressionStream, DecompressionStream */ /*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ const $0302f6c577bd011b$export$dbfc2ae0cf3df69a = 0xffffffff;
const $0302f6c577bd011b$export$4164cee1a26178fd = 0xffff;
const $0302f6c577bd011b$export$2cf0a12381b29e07 = 0x08;
const $0302f6c577bd011b$export$6135a805f19e5577 = 0x00;
const $0302f6c577bd011b$export$367f2443b409227a = 0x63;
const $0302f6c577bd011b$export$2b2cf5904cb82788 = 0x04034b50;
const $0302f6c577bd011b$export$40fbd2cd06477e1d = 0x08074b50;
const $0302f6c577bd011b$export$fb8fb01339553b17 = $0302f6c577bd011b$export$40fbd2cd06477e1d;
const $0302f6c577bd011b$export$a72d49bf27f9bcd = 0x02014b50;
const $0302f6c577bd011b$export$13a06f7e64cf6a1 = 0x06054b50;
const $0302f6c577bd011b$export$8414b1953f7f48c6 = 0x06064b50;
const $0302f6c577bd011b$export$5078166106cbcc66 = 0x07064b50;
const $0302f6c577bd011b$export$6383d4b2e2323b68 = 22;
const $0302f6c577bd011b$export$c545bb91a1b43732 = 20;
const $0302f6c577bd011b$export$9eb09cdd39f04a62 = 56;
const $0302f6c577bd011b$export$4edccc0d25441f8c = $0302f6c577bd011b$export$6383d4b2e2323b68 + $0302f6c577bd011b$export$c545bb91a1b43732 + $0302f6c577bd011b$export$9eb09cdd39f04a62;
const $0302f6c577bd011b$export$3da9e4d76b1bf88 = 0x0001;
const $0302f6c577bd011b$export$714aa3fe052f4e13 = 0x9901;
const $0302f6c577bd011b$export$93e014de2b9c33c8 = 0x000a;
const $0302f6c577bd011b$export$109a97d45e55cdec = 0x0001;
const $0302f6c577bd011b$export$6cfe9e8823acaac3 = 0x5455;
const $0302f6c577bd011b$export$b48bdd5195f1a53a = 0x7075;
const $0302f6c577bd011b$export$b49699c0acb50fe1 = 0x6375;
const $0302f6c577bd011b$export$7db0c075c39cb343 = 0x01;
const $0302f6c577bd011b$export$ac9ca09a23eb90ff = 0x06;
const $0302f6c577bd011b$export$3ec1d940e3bc0a58 = 0x0008;
const $0302f6c577bd011b$export$fb6e9f896320db55 = 0x0800;
const $0302f6c577bd011b$export$2d169f352844a92f = 0x10;
const $0302f6c577bd011b$export$e0f048be47b3707 = 0x14;
const $0302f6c577bd011b$export$c695aaa0200b0023 = 0x2D;
const $0302f6c577bd011b$export$476ad4f47ce8ae93 = 0x33;
const $0302f6c577bd011b$export$4a765df57d89fe04 = "/";
const $0302f6c577bd011b$export$c4acb27cbfd4cf71 = new Date(2107, 11, 31);
const $0302f6c577bd011b$export$c21855736e7fcd29 = new Date(1980, 0, 1);
const $0302f6c577bd011b$export$a43287864529b8fd = undefined;
const $0302f6c577bd011b$export$817d840279c95122 = "undefined";
const $0302f6c577bd011b$export$31a3bc04c4494acf = "function";


/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /* global TransformStream */ class $507e8aac44e5ad1e$export$7c33862539992df6 {
    constructor(Codec){
        return class extends TransformStream {
            constructor(_format, options){
                const codec = new Codec(options);
                super({
                    transform (chunk, controller) {
                        controller.enqueue(codec.append(chunk));
                    },
                    flush (controller) {
                        const chunk = codec.flush();
                        if (chunk) controller.enqueue(chunk);
                    }
                });
            }
        };
    }
}


const $1c2d4410a52b3cac$var$MINIMUM_CHUNK_SIZE = 64;
let $1c2d4410a52b3cac$var$maxWorkers = 2;
try {
    if (typeof navigator != (0, $0302f6c577bd011b$export$817d840279c95122) && navigator.hardwareConcurrency) $1c2d4410a52b3cac$var$maxWorkers = navigator.hardwareConcurrency;
} catch (_error) {
// ignored
}
const $1c2d4410a52b3cac$var$DEFAULT_CONFIGURATION = {
    chunkSize: 524288,
    maxWorkers: $1c2d4410a52b3cac$var$maxWorkers,
    terminateWorkerTimeout: 5000,
    useWebWorkers: true,
    useCompressionStream: true,
    workerScripts: (0, $0302f6c577bd011b$export$a43287864529b8fd),
    CompressionStreamNative: typeof CompressionStream != (0, $0302f6c577bd011b$export$817d840279c95122) && CompressionStream,
    DecompressionStreamNative: typeof DecompressionStream != (0, $0302f6c577bd011b$export$817d840279c95122) && DecompressionStream
};
const $1c2d4410a52b3cac$var$config = Object.assign({}, $1c2d4410a52b3cac$var$DEFAULT_CONFIGURATION);
function $1c2d4410a52b3cac$export$3de01744a82b21a4() {
    return $1c2d4410a52b3cac$var$config;
}
function $1c2d4410a52b3cac$export$f0bad416b890a4ec(config) {
    return Math.max(config.chunkSize, $1c2d4410a52b3cac$var$MINIMUM_CHUNK_SIZE);
}
function $1c2d4410a52b3cac$export$8d21e34596265fa2(configuration) {
    const { baseURL: baseURL, chunkSize: chunkSize, maxWorkers: maxWorkers, terminateWorkerTimeout: terminateWorkerTimeout, useCompressionStream: useCompressionStream, useWebWorkers: useWebWorkers, Deflate: Deflate, Inflate: Inflate, CompressionStream: CompressionStream1, DecompressionStream: DecompressionStream1, workerScripts: workerScripts } = configuration;
    $1c2d4410a52b3cac$var$setIfDefined("baseURL", baseURL);
    $1c2d4410a52b3cac$var$setIfDefined("chunkSize", chunkSize);
    $1c2d4410a52b3cac$var$setIfDefined("maxWorkers", maxWorkers);
    $1c2d4410a52b3cac$var$setIfDefined("terminateWorkerTimeout", terminateWorkerTimeout);
    $1c2d4410a52b3cac$var$setIfDefined("useCompressionStream", useCompressionStream);
    $1c2d4410a52b3cac$var$setIfDefined("useWebWorkers", useWebWorkers);
    if (Deflate) $1c2d4410a52b3cac$var$config.CompressionStream = new (0, $507e8aac44e5ad1e$export$7c33862539992df6)(Deflate);
    if (Inflate) $1c2d4410a52b3cac$var$config.DecompressionStream = new (0, $507e8aac44e5ad1e$export$7c33862539992df6)(Inflate);
    $1c2d4410a52b3cac$var$setIfDefined("CompressionStream", CompressionStream1);
    $1c2d4410a52b3cac$var$setIfDefined("DecompressionStream", DecompressionStream1);
    if (workerScripts !== (0, $0302f6c577bd011b$export$a43287864529b8fd)) {
        const { deflate: deflate, inflate: inflate } = workerScripts;
        if (deflate || inflate) {
            if (!$1c2d4410a52b3cac$var$config.workerScripts) $1c2d4410a52b3cac$var$config.workerScripts = {};
        }
        if (deflate) {
            if (!Array.isArray(deflate)) throw new Error("workerScripts.deflate must be an array");
            $1c2d4410a52b3cac$var$config.workerScripts.deflate = deflate;
        }
        if (inflate) {
            if (!Array.isArray(inflate)) throw new Error("workerScripts.inflate must be an array");
            $1c2d4410a52b3cac$var$config.workerScripts.inflate = inflate;
        }
    }
}
function $1c2d4410a52b3cac$var$setIfDefined(propertyName, propertyValue) {
    if (propertyValue !== (0, $0302f6c577bd011b$export$a43287864529b8fd)) $1c2d4410a52b3cac$var$config[propertyName] = propertyValue;
}


/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ // deno-lint-ignore-file no-prototype-builtins
/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ const $d7fe75dc25057a0e$export$53cb456310d1907e = {};
function $d7fe75dc25057a0e$export$200548c990602f61() {
    return "application/octet-stream";
}


const $80578c62b8d54528$var$table = {
    "application": {
        "andrew-inset": "ez",
        "annodex": "anx",
        "atom+xml": "atom",
        "atomcat+xml": "atomcat",
        "atomserv+xml": "atomsrv",
        "bbolin": "lin",
        "cap": [
            "cap",
            "pcap"
        ],
        "cu-seeme": "cu",
        "davmount+xml": "davmount",
        "dsptype": "tsp",
        "ecmascript": [
            "es",
            "ecma"
        ],
        "futuresplash": "spl",
        "hta": "hta",
        "java-archive": "jar",
        "java-serialized-object": "ser",
        "java-vm": "class",
        "javascript": "js",
        "m3g": "m3g",
        "mac-binhex40": "hqx",
        "mathematica": [
            "nb",
            "ma",
            "mb"
        ],
        "msaccess": "mdb",
        "msword": [
            "doc",
            "dot"
        ],
        "mxf": "mxf",
        "oda": "oda",
        "ogg": "ogx",
        "pdf": "pdf",
        "pgp-keys": "key",
        "pgp-signature": [
            "asc",
            "sig"
        ],
        "pics-rules": "prf",
        "postscript": [
            "ps",
            "ai",
            "eps",
            "epsi",
            "epsf",
            "eps2",
            "eps3"
        ],
        "rar": "rar",
        "rdf+xml": "rdf",
        "rss+xml": "rss",
        "rtf": "rtf",
        "smil": [
            "smi",
            "smil"
        ],
        "xhtml+xml": [
            "xhtml",
            "xht"
        ],
        "xml": [
            "xml",
            "xsl",
            "xsd"
        ],
        "xspf+xml": "xspf",
        "zip": "zip",
        "vnd.android.package-archive": "apk",
        "vnd.cinderella": "cdy",
        "vnd.google-earth.kml+xml": "kml",
        "vnd.google-earth.kmz": "kmz",
        "vnd.mozilla.xul+xml": "xul",
        "vnd.ms-excel": [
            "xls",
            "xlb",
            "xlt",
            "xlm",
            "xla",
            "xlc",
            "xlw"
        ],
        "vnd.ms-pki.seccat": "cat",
        "vnd.ms-pki.stl": "stl",
        "vnd.ms-powerpoint": [
            "ppt",
            "pps",
            "pot"
        ],
        "vnd.oasis.opendocument.chart": "odc",
        "vnd.oasis.opendocument.database": "odb",
        "vnd.oasis.opendocument.formula": "odf",
        "vnd.oasis.opendocument.graphics": "odg",
        "vnd.oasis.opendocument.graphics-template": "otg",
        "vnd.oasis.opendocument.image": "odi",
        "vnd.oasis.opendocument.presentation": "odp",
        "vnd.oasis.opendocument.presentation-template": "otp",
        "vnd.oasis.opendocument.spreadsheet": "ods",
        "vnd.oasis.opendocument.spreadsheet-template": "ots",
        "vnd.oasis.opendocument.text": "odt",
        "vnd.oasis.opendocument.text-master": "odm",
        "vnd.oasis.opendocument.text-template": "ott",
        "vnd.oasis.opendocument.text-web": "oth",
        "vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
        "vnd.openxmlformats-officedocument.spreadsheetml.template": "xltx",
        "vnd.openxmlformats-officedocument.presentationml.presentation": "pptx",
        "vnd.openxmlformats-officedocument.presentationml.slideshow": "ppsx",
        "vnd.openxmlformats-officedocument.presentationml.template": "potx",
        "vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
        "vnd.openxmlformats-officedocument.wordprocessingml.template": "dotx",
        "vnd.smaf": "mmf",
        "vnd.stardivision.calc": "sdc",
        "vnd.stardivision.chart": "sds",
        "vnd.stardivision.draw": "sda",
        "vnd.stardivision.impress": "sdd",
        "vnd.stardivision.math": [
            "sdf",
            "smf"
        ],
        "vnd.stardivision.writer": [
            "sdw",
            "vor"
        ],
        "vnd.stardivision.writer-global": "sgl",
        "vnd.sun.xml.calc": "sxc",
        "vnd.sun.xml.calc.template": "stc",
        "vnd.sun.xml.draw": "sxd",
        "vnd.sun.xml.draw.template": "std",
        "vnd.sun.xml.impress": "sxi",
        "vnd.sun.xml.impress.template": "sti",
        "vnd.sun.xml.math": "sxm",
        "vnd.sun.xml.writer": "sxw",
        "vnd.sun.xml.writer.global": "sxg",
        "vnd.sun.xml.writer.template": "stw",
        "vnd.symbian.install": [
            "sis",
            "sisx"
        ],
        "vnd.visio": [
            "vsd",
            "vst",
            "vss",
            "vsw"
        ],
        "vnd.wap.wbxml": "wbxml",
        "vnd.wap.wmlc": "wmlc",
        "vnd.wap.wmlscriptc": "wmlsc",
        "vnd.wordperfect": "wpd",
        "vnd.wordperfect5.1": "wp5",
        "x-123": "wk",
        "x-7z-compressed": "7z",
        "x-abiword": "abw",
        "x-apple-diskimage": "dmg",
        "x-bcpio": "bcpio",
        "x-bittorrent": "torrent",
        "x-cbr": [
            "cbr",
            "cba",
            "cbt",
            "cb7"
        ],
        "x-cbz": "cbz",
        "x-cdf": [
            "cdf",
            "cda"
        ],
        "x-cdlink": "vcd",
        "x-chess-pgn": "pgn",
        "x-cpio": "cpio",
        "x-csh": "csh",
        "x-debian-package": [
            "deb",
            "udeb"
        ],
        "x-director": [
            "dcr",
            "dir",
            "dxr",
            "cst",
            "cct",
            "cxt",
            "w3d",
            "fgd",
            "swa"
        ],
        "x-dms": "dms",
        "x-doom": "wad",
        "x-dvi": "dvi",
        "x-httpd-eruby": "rhtml",
        "x-font": "pcf.Z",
        "x-freemind": "mm",
        "x-gnumeric": "gnumeric",
        "x-go-sgf": "sgf",
        "x-graphing-calculator": "gcf",
        "x-gtar": [
            "gtar",
            "taz"
        ],
        "x-hdf": "hdf",
        "x-httpd-php": [
            "phtml",
            "pht",
            "php"
        ],
        "x-httpd-php-source": "phps",
        "x-httpd-php3": "php3",
        "x-httpd-php3-preprocessed": "php3p",
        "x-httpd-php4": "php4",
        "x-httpd-php5": "php5",
        "x-ica": "ica",
        "x-info": "info",
        "x-internet-signup": [
            "ins",
            "isp"
        ],
        "x-iphone": "iii",
        "x-iso9660-image": "iso",
        "x-java-jnlp-file": "jnlp",
        "x-jmol": "jmz",
        "x-killustrator": "kil",
        "x-koan": [
            "skp",
            "skd",
            "skt",
            "skm"
        ],
        "x-kpresenter": [
            "kpr",
            "kpt"
        ],
        "x-kword": [
            "kwd",
            "kwt"
        ],
        "x-latex": "latex",
        "x-lha": "lha",
        "x-lyx": "lyx",
        "x-lzh": "lzh",
        "x-lzx": "lzx",
        "x-maker": [
            "frm",
            "maker",
            "frame",
            "fm",
            "fb",
            "book",
            "fbdoc"
        ],
        "x-ms-wmd": "wmd",
        "x-ms-wmz": "wmz",
        "x-msdos-program": [
            "com",
            "exe",
            "bat",
            "dll"
        ],
        "x-msi": "msi",
        "x-netcdf": [
            "nc",
            "cdf"
        ],
        "x-ns-proxy-autoconfig": [
            "pac",
            "dat"
        ],
        "x-nwc": "nwc",
        "x-object": "o",
        "x-oz-application": "oza",
        "x-pkcs7-certreqresp": "p7r",
        "x-python-code": [
            "pyc",
            "pyo"
        ],
        "x-qgis": [
            "qgs",
            "shp",
            "shx"
        ],
        "x-quicktimeplayer": "qtl",
        "x-redhat-package-manager": "rpm",
        "x-ruby": "rb",
        "x-sh": "sh",
        "x-shar": "shar",
        "x-shockwave-flash": [
            "swf",
            "swfl"
        ],
        "x-silverlight": "scr",
        "x-stuffit": "sit",
        "x-sv4cpio": "sv4cpio",
        "x-sv4crc": "sv4crc",
        "x-tar": "tar",
        "x-tcl": "tcl",
        "x-tex-gf": "gf",
        "x-tex-pk": "pk",
        "x-texinfo": [
            "texinfo",
            "texi"
        ],
        "x-trash": [
            "~",
            "%",
            "bak",
            "old",
            "sik"
        ],
        "x-troff": [
            "t",
            "tr",
            "roff"
        ],
        "x-troff-man": "man",
        "x-troff-me": "me",
        "x-troff-ms": "ms",
        "x-ustar": "ustar",
        "x-wais-source": "src",
        "x-wingz": "wz",
        "x-x509-ca-cert": [
            "crt",
            "der",
            "cer"
        ],
        "x-xcf": "xcf",
        "x-xfig": "fig",
        "x-xpinstall": "xpi",
        "applixware": "aw",
        "atomsvc+xml": "atomsvc",
        "ccxml+xml": "ccxml",
        "cdmi-capability": "cdmia",
        "cdmi-container": "cdmic",
        "cdmi-domain": "cdmid",
        "cdmi-object": "cdmio",
        "cdmi-queue": "cdmiq",
        "docbook+xml": "dbk",
        "dssc+der": "dssc",
        "dssc+xml": "xdssc",
        "emma+xml": "emma",
        "epub+zip": "epub",
        "exi": "exi",
        "font-tdpfr": "pfr",
        "gml+xml": "gml",
        "gpx+xml": "gpx",
        "gxf": "gxf",
        "hyperstudio": "stk",
        "inkml+xml": [
            "ink",
            "inkml"
        ],
        "ipfix": "ipfix",
        "json": "json",
        "jsonml+json": "jsonml",
        "lost+xml": "lostxml",
        "mads+xml": "mads",
        "marc": "mrc",
        "marcxml+xml": "mrcx",
        "mathml+xml": "mathml",
        "mbox": "mbox",
        "mediaservercontrol+xml": "mscml",
        "metalink+xml": "metalink",
        "metalink4+xml": "meta4",
        "mets+xml": "mets",
        "mods+xml": "mods",
        "mp21": [
            "m21",
            "mp21"
        ],
        "mp4": "mp4s",
        "oebps-package+xml": "opf",
        "omdoc+xml": "omdoc",
        "onenote": [
            "onetoc",
            "onetoc2",
            "onetmp",
            "onepkg"
        ],
        "oxps": "oxps",
        "patch-ops-error+xml": "xer",
        "pgp-encrypted": "pgp",
        "pkcs10": "p10",
        "pkcs7-mime": [
            "p7m",
            "p7c"
        ],
        "pkcs7-signature": "p7s",
        "pkcs8": "p8",
        "pkix-attr-cert": "ac",
        "pkix-crl": "crl",
        "pkix-pkipath": "pkipath",
        "pkixcmp": "pki",
        "pls+xml": "pls",
        "prs.cww": "cww",
        "pskc+xml": "pskcxml",
        "reginfo+xml": "rif",
        "relax-ng-compact-syntax": "rnc",
        "resource-lists+xml": "rl",
        "resource-lists-diff+xml": "rld",
        "rls-services+xml": "rs",
        "rpki-ghostbusters": "gbr",
        "rpki-manifest": "mft",
        "rpki-roa": "roa",
        "rsd+xml": "rsd",
        "sbml+xml": "sbml",
        "scvp-cv-request": "scq",
        "scvp-cv-response": "scs",
        "scvp-vp-request": "spq",
        "scvp-vp-response": "spp",
        "sdp": "sdp",
        "set-payment-initiation": "setpay",
        "set-registration-initiation": "setreg",
        "shf+xml": "shf",
        "sparql-query": "rq",
        "sparql-results+xml": "srx",
        "srgs": "gram",
        "srgs+xml": "grxml",
        "sru+xml": "sru",
        "ssdl+xml": "ssdl",
        "ssml+xml": "ssml",
        "tei+xml": [
            "tei",
            "teicorpus"
        ],
        "thraud+xml": "tfi",
        "timestamped-data": "tsd",
        "vnd.3gpp.pic-bw-large": "plb",
        "vnd.3gpp.pic-bw-small": "psb",
        "vnd.3gpp.pic-bw-var": "pvb",
        "vnd.3gpp2.tcap": "tcap",
        "vnd.3m.post-it-notes": "pwn",
        "vnd.accpac.simply.aso": "aso",
        "vnd.accpac.simply.imp": "imp",
        "vnd.acucobol": "acu",
        "vnd.acucorp": [
            "atc",
            "acutc"
        ],
        "vnd.adobe.air-application-installer-package+zip": "air",
        "vnd.adobe.formscentral.fcdt": "fcdt",
        "vnd.adobe.fxp": [
            "fxp",
            "fxpl"
        ],
        "vnd.adobe.xdp+xml": "xdp",
        "vnd.adobe.xfdf": "xfdf",
        "vnd.ahead.space": "ahead",
        "vnd.airzip.filesecure.azf": "azf",
        "vnd.airzip.filesecure.azs": "azs",
        "vnd.amazon.ebook": "azw",
        "vnd.americandynamics.acc": "acc",
        "vnd.amiga.ami": "ami",
        "vnd.anser-web-certificate-issue-initiation": "cii",
        "vnd.anser-web-funds-transfer-initiation": "fti",
        "vnd.antix.game-component": "atx",
        "vnd.apple.installer+xml": "mpkg",
        "vnd.apple.mpegurl": "m3u8",
        "vnd.aristanetworks.swi": "swi",
        "vnd.astraea-software.iota": "iota",
        "vnd.audiograph": "aep",
        "vnd.blueice.multipass": "mpm",
        "vnd.bmi": "bmi",
        "vnd.businessobjects": "rep",
        "vnd.chemdraw+xml": "cdxml",
        "vnd.chipnuts.karaoke-mmd": "mmd",
        "vnd.claymore": "cla",
        "vnd.cloanto.rp9": "rp9",
        "vnd.clonk.c4group": [
            "c4g",
            "c4d",
            "c4f",
            "c4p",
            "c4u"
        ],
        "vnd.cluetrust.cartomobile-config": "c11amc",
        "vnd.cluetrust.cartomobile-config-pkg": "c11amz",
        "vnd.commonspace": "csp",
        "vnd.contact.cmsg": "cdbcmsg",
        "vnd.cosmocaller": "cmc",
        "vnd.crick.clicker": "clkx",
        "vnd.crick.clicker.keyboard": "clkk",
        "vnd.crick.clicker.palette": "clkp",
        "vnd.crick.clicker.template": "clkt",
        "vnd.crick.clicker.wordbank": "clkw",
        "vnd.criticaltools.wbs+xml": "wbs",
        "vnd.ctc-posml": "pml",
        "vnd.cups-ppd": "ppd",
        "vnd.curl.car": "car",
        "vnd.curl.pcurl": "pcurl",
        "vnd.dart": "dart",
        "vnd.data-vision.rdz": "rdz",
        "vnd.dece.data": [
            "uvf",
            "uvvf",
            "uvd",
            "uvvd"
        ],
        "vnd.dece.ttml+xml": [
            "uvt",
            "uvvt"
        ],
        "vnd.dece.unspecified": [
            "uvx",
            "uvvx"
        ],
        "vnd.dece.zip": [
            "uvz",
            "uvvz"
        ],
        "vnd.denovo.fcselayout-link": "fe_launch",
        "vnd.dna": "dna",
        "vnd.dolby.mlp": "mlp",
        "vnd.dpgraph": "dpg",
        "vnd.dreamfactory": "dfac",
        "vnd.ds-keypoint": "kpxx",
        "vnd.dvb.ait": "ait",
        "vnd.dvb.service": "svc",
        "vnd.dynageo": "geo",
        "vnd.ecowin.chart": "mag",
        "vnd.enliven": "nml",
        "vnd.epson.esf": "esf",
        "vnd.epson.msf": "msf",
        "vnd.epson.quickanime": "qam",
        "vnd.epson.salt": "slt",
        "vnd.epson.ssf": "ssf",
        "vnd.eszigno3+xml": [
            "es3",
            "et3"
        ],
        "vnd.ezpix-album": "ez2",
        "vnd.ezpix-package": "ez3",
        "vnd.fdf": "fdf",
        "vnd.fdsn.mseed": "mseed",
        "vnd.fdsn.seed": [
            "seed",
            "dataless"
        ],
        "vnd.flographit": "gph",
        "vnd.fluxtime.clip": "ftc",
        "vnd.framemaker": [
            "fm",
            "frame",
            "maker",
            "book"
        ],
        "vnd.frogans.fnc": "fnc",
        "vnd.frogans.ltf": "ltf",
        "vnd.fsc.weblaunch": "fsc",
        "vnd.fujitsu.oasys": "oas",
        "vnd.fujitsu.oasys2": "oa2",
        "vnd.fujitsu.oasys3": "oa3",
        "vnd.fujitsu.oasysgp": "fg5",
        "vnd.fujitsu.oasysprs": "bh2",
        "vnd.fujixerox.ddd": "ddd",
        "vnd.fujixerox.docuworks": "xdw",
        "vnd.fujixerox.docuworks.binder": "xbd",
        "vnd.fuzzysheet": "fzs",
        "vnd.genomatix.tuxedo": "txd",
        "vnd.geogebra.file": "ggb",
        "vnd.geogebra.tool": "ggt",
        "vnd.geometry-explorer": [
            "gex",
            "gre"
        ],
        "vnd.geonext": "gxt",
        "vnd.geoplan": "g2w",
        "vnd.geospace": "g3w",
        "vnd.gmx": "gmx",
        "vnd.grafeq": [
            "gqf",
            "gqs"
        ],
        "vnd.groove-account": "gac",
        "vnd.groove-help": "ghf",
        "vnd.groove-identity-message": "gim",
        "vnd.groove-injector": "grv",
        "vnd.groove-tool-message": "gtm",
        "vnd.groove-tool-template": "tpl",
        "vnd.groove-vcard": "vcg",
        "vnd.hal+xml": "hal",
        "vnd.handheld-entertainment+xml": "zmm",
        "vnd.hbci": "hbci",
        "vnd.hhe.lesson-player": "les",
        "vnd.hp-hpgl": "hpgl",
        "vnd.hp-hpid": "hpid",
        "vnd.hp-hps": "hps",
        "vnd.hp-jlyt": "jlt",
        "vnd.hp-pcl": "pcl",
        "vnd.hp-pclxl": "pclxl",
        "vnd.hydrostatix.sof-data": "sfd-hdstx",
        "vnd.ibm.minipay": "mpy",
        "vnd.ibm.modcap": [
            "afp",
            "listafp",
            "list3820"
        ],
        "vnd.ibm.rights-management": "irm",
        "vnd.ibm.secure-container": "sc",
        "vnd.iccprofile": [
            "icc",
            "icm"
        ],
        "vnd.igloader": "igl",
        "vnd.immervision-ivp": "ivp",
        "vnd.immervision-ivu": "ivu",
        "vnd.insors.igm": "igm",
        "vnd.intercon.formnet": [
            "xpw",
            "xpx"
        ],
        "vnd.intergeo": "i2g",
        "vnd.intu.qbo": "qbo",
        "vnd.intu.qfx": "qfx",
        "vnd.ipunplugged.rcprofile": "rcprofile",
        "vnd.irepository.package+xml": "irp",
        "vnd.is-xpr": "xpr",
        "vnd.isac.fcs": "fcs",
        "vnd.jam": "jam",
        "vnd.jcp.javame.midlet-rms": "rms",
        "vnd.jisp": "jisp",
        "vnd.joost.joda-archive": "joda",
        "vnd.kahootz": [
            "ktz",
            "ktr"
        ],
        "vnd.kde.karbon": "karbon",
        "vnd.kde.kchart": "chrt",
        "vnd.kde.kformula": "kfo",
        "vnd.kde.kivio": "flw",
        "vnd.kde.kontour": "kon",
        "vnd.kde.kpresenter": [
            "kpr",
            "kpt"
        ],
        "vnd.kde.kspread": "ksp",
        "vnd.kde.kword": [
            "kwd",
            "kwt"
        ],
        "vnd.kenameaapp": "htke",
        "vnd.kidspiration": "kia",
        "vnd.kinar": [
            "kne",
            "knp"
        ],
        "vnd.koan": [
            "skp",
            "skd",
            "skt",
            "skm"
        ],
        "vnd.kodak-descriptor": "sse",
        "vnd.las.las+xml": "lasxml",
        "vnd.llamagraphics.life-balance.desktop": "lbd",
        "vnd.llamagraphics.life-balance.exchange+xml": "lbe",
        "vnd.lotus-1-2-3": "123",
        "vnd.lotus-approach": "apr",
        "vnd.lotus-freelance": "pre",
        "vnd.lotus-notes": "nsf",
        "vnd.lotus-organizer": "org",
        "vnd.lotus-screencam": "scm",
        "vnd.lotus-wordpro": "lwp",
        "vnd.macports.portpkg": "portpkg",
        "vnd.mcd": "mcd",
        "vnd.medcalcdata": "mc1",
        "vnd.mediastation.cdkey": "cdkey",
        "vnd.mfer": "mwf",
        "vnd.mfmp": "mfm",
        "vnd.micrografx.flo": "flo",
        "vnd.micrografx.igx": "igx",
        "vnd.mif": "mif",
        "vnd.mobius.daf": "daf",
        "vnd.mobius.dis": "dis",
        "vnd.mobius.mbk": "mbk",
        "vnd.mobius.mqy": "mqy",
        "vnd.mobius.msl": "msl",
        "vnd.mobius.plc": "plc",
        "vnd.mobius.txf": "txf",
        "vnd.mophun.application": "mpn",
        "vnd.mophun.certificate": "mpc",
        "vnd.ms-artgalry": "cil",
        "vnd.ms-cab-compressed": "cab",
        "vnd.ms-excel.addin.macroenabled.12": "xlam",
        "vnd.ms-excel.sheet.binary.macroenabled.12": "xlsb",
        "vnd.ms-excel.sheet.macroenabled.12": "xlsm",
        "vnd.ms-excel.template.macroenabled.12": "xltm",
        "vnd.ms-fontobject": "eot",
        "vnd.ms-htmlhelp": "chm",
        "vnd.ms-ims": "ims",
        "vnd.ms-lrm": "lrm",
        "vnd.ms-officetheme": "thmx",
        "vnd.ms-powerpoint.addin.macroenabled.12": "ppam",
        "vnd.ms-powerpoint.presentation.macroenabled.12": "pptm",
        "vnd.ms-powerpoint.slide.macroenabled.12": "sldm",
        "vnd.ms-powerpoint.slideshow.macroenabled.12": "ppsm",
        "vnd.ms-powerpoint.template.macroenabled.12": "potm",
        "vnd.ms-project": [
            "mpp",
            "mpt"
        ],
        "vnd.ms-word.document.macroenabled.12": "docm",
        "vnd.ms-word.template.macroenabled.12": "dotm",
        "vnd.ms-works": [
            "wps",
            "wks",
            "wcm",
            "wdb"
        ],
        "vnd.ms-wpl": "wpl",
        "vnd.ms-xpsdocument": "xps",
        "vnd.mseq": "mseq",
        "vnd.musician": "mus",
        "vnd.muvee.style": "msty",
        "vnd.mynfc": "taglet",
        "vnd.neurolanguage.nlu": "nlu",
        "vnd.nitf": [
            "ntf",
            "nitf"
        ],
        "vnd.noblenet-directory": "nnd",
        "vnd.noblenet-sealer": "nns",
        "vnd.noblenet-web": "nnw",
        "vnd.nokia.n-gage.data": "ngdat",
        "vnd.nokia.n-gage.symbian.install": "n-gage",
        "vnd.nokia.radio-preset": "rpst",
        "vnd.nokia.radio-presets": "rpss",
        "vnd.novadigm.edm": "edm",
        "vnd.novadigm.edx": "edx",
        "vnd.novadigm.ext": "ext",
        "vnd.oasis.opendocument.chart-template": "otc",
        "vnd.oasis.opendocument.formula-template": "odft",
        "vnd.oasis.opendocument.image-template": "oti",
        "vnd.olpc-sugar": "xo",
        "vnd.oma.dd2+xml": "dd2",
        "vnd.openofficeorg.extension": "oxt",
        "vnd.openxmlformats-officedocument.presentationml.slide": "sldx",
        "vnd.osgeo.mapguide.package": "mgp",
        "vnd.osgi.dp": "dp",
        "vnd.osgi.subsystem": "esa",
        "vnd.palm": [
            "pdb",
            "pqa",
            "oprc"
        ],
        "vnd.pawaafile": "paw",
        "vnd.pg.format": "str",
        "vnd.pg.osasli": "ei6",
        "vnd.picsel": "efif",
        "vnd.pmi.widget": "wg",
        "vnd.pocketlearn": "plf",
        "vnd.powerbuilder6": "pbd",
        "vnd.previewsystems.box": "box",
        "vnd.proteus.magazine": "mgz",
        "vnd.publishare-delta-tree": "qps",
        "vnd.pvi.ptid1": "ptid",
        "vnd.quark.quarkxpress": [
            "qxd",
            "qxt",
            "qwd",
            "qwt",
            "qxl",
            "qxb"
        ],
        "vnd.realvnc.bed": "bed",
        "vnd.recordare.musicxml": "mxl",
        "vnd.recordare.musicxml+xml": "musicxml",
        "vnd.rig.cryptonote": "cryptonote",
        "vnd.rn-realmedia": "rm",
        "vnd.rn-realmedia-vbr": "rmvb",
        "vnd.route66.link66+xml": "link66",
        "vnd.sailingtracker.track": "st",
        "vnd.seemail": "see",
        "vnd.sema": "sema",
        "vnd.semd": "semd",
        "vnd.semf": "semf",
        "vnd.shana.informed.formdata": "ifm",
        "vnd.shana.informed.formtemplate": "itp",
        "vnd.shana.informed.interchange": "iif",
        "vnd.shana.informed.package": "ipk",
        "vnd.simtech-mindmapper": [
            "twd",
            "twds"
        ],
        "vnd.smart.teacher": "teacher",
        "vnd.solent.sdkm+xml": [
            "sdkm",
            "sdkd"
        ],
        "vnd.spotfire.dxp": "dxp",
        "vnd.spotfire.sfs": "sfs",
        "vnd.stepmania.package": "smzip",
        "vnd.stepmania.stepchart": "sm",
        "vnd.sus-calendar": [
            "sus",
            "susp"
        ],
        "vnd.svd": "svd",
        "vnd.syncml+xml": "xsm",
        "vnd.syncml.dm+wbxml": "bdm",
        "vnd.syncml.dm+xml": "xdm",
        "vnd.tao.intent-module-archive": "tao",
        "vnd.tcpdump.pcap": [
            "pcap",
            "cap",
            "dmp"
        ],
        "vnd.tmobile-livetv": "tmo",
        "vnd.trid.tpt": "tpt",
        "vnd.triscape.mxs": "mxs",
        "vnd.trueapp": "tra",
        "vnd.ufdl": [
            "ufd",
            "ufdl"
        ],
        "vnd.uiq.theme": "utz",
        "vnd.umajin": "umj",
        "vnd.unity": "unityweb",
        "vnd.uoml+xml": "uoml",
        "vnd.vcx": "vcx",
        "vnd.visionary": "vis",
        "vnd.vsf": "vsf",
        "vnd.webturbo": "wtb",
        "vnd.wolfram.player": "nbp",
        "vnd.wqd": "wqd",
        "vnd.wt.stf": "stf",
        "vnd.xara": "xar",
        "vnd.xfdl": "xfdl",
        "vnd.yamaha.hv-dic": "hvd",
        "vnd.yamaha.hv-script": "hvs",
        "vnd.yamaha.hv-voice": "hvp",
        "vnd.yamaha.openscoreformat": "osf",
        "vnd.yamaha.openscoreformat.osfpvg+xml": "osfpvg",
        "vnd.yamaha.smaf-audio": "saf",
        "vnd.yamaha.smaf-phrase": "spf",
        "vnd.yellowriver-custom-menu": "cmp",
        "vnd.zul": [
            "zir",
            "zirz"
        ],
        "vnd.zzazz.deck+xml": "zaz",
        "voicexml+xml": "vxml",
        "widget": "wgt",
        "winhlp": "hlp",
        "wsdl+xml": "wsdl",
        "wspolicy+xml": "wspolicy",
        "x-ace-compressed": "ace",
        "x-authorware-bin": [
            "aab",
            "x32",
            "u32",
            "vox"
        ],
        "x-authorware-map": "aam",
        "x-authorware-seg": "aas",
        "x-blorb": [
            "blb",
            "blorb"
        ],
        "x-bzip": "bz",
        "x-bzip2": [
            "bz2",
            "boz"
        ],
        "x-cfs-compressed": "cfs",
        "x-chat": "chat",
        "x-conference": "nsc",
        "x-dgc-compressed": "dgc",
        "x-dtbncx+xml": "ncx",
        "x-dtbook+xml": "dtb",
        "x-dtbresource+xml": "res",
        "x-eva": "eva",
        "x-font-bdf": "bdf",
        "x-font-ghostscript": "gsf",
        "x-font-linux-psf": "psf",
        "x-font-otf": "otf",
        "x-font-pcf": "pcf",
        "x-font-snf": "snf",
        "x-font-ttf": [
            "ttf",
            "ttc"
        ],
        "x-font-type1": [
            "pfa",
            "pfb",
            "pfm",
            "afm"
        ],
        "x-font-woff": "woff",
        "x-freearc": "arc",
        "x-gca-compressed": "gca",
        "x-glulx": "ulx",
        "x-gramps-xml": "gramps",
        "x-install-instructions": "install",
        "x-lzh-compressed": [
            "lzh",
            "lha"
        ],
        "x-mie": "mie",
        "x-mobipocket-ebook": [
            "prc",
            "mobi"
        ],
        "x-ms-application": "application",
        "x-ms-shortcut": "lnk",
        "x-ms-xbap": "xbap",
        "x-msbinder": "obd",
        "x-mscardfile": "crd",
        "x-msclip": "clp",
        "x-msdownload": [
            "exe",
            "dll",
            "com",
            "bat",
            "msi"
        ],
        "x-msmediaview": [
            "mvb",
            "m13",
            "m14"
        ],
        "x-msmetafile": [
            "wmf",
            "wmz",
            "emf",
            "emz"
        ],
        "x-msmoney": "mny",
        "x-mspublisher": "pub",
        "x-msschedule": "scd",
        "x-msterminal": "trm",
        "x-mswrite": "wri",
        "x-nzb": "nzb",
        "x-pkcs12": [
            "p12",
            "pfx"
        ],
        "x-pkcs7-certificates": [
            "p7b",
            "spc"
        ],
        "x-research-info-systems": "ris",
        "x-silverlight-app": "xap",
        "x-sql": "sql",
        "x-stuffitx": "sitx",
        "x-subrip": "srt",
        "x-t3vm-image": "t3",
        "x-tads": "gam",
        "x-tex": "tex",
        "x-tex-tfm": "tfm",
        "x-tgif": "obj",
        "x-xliff+xml": "xlf",
        "x-xz": "xz",
        "x-zmachine": [
            "z1",
            "z2",
            "z3",
            "z4",
            "z5",
            "z6",
            "z7",
            "z8"
        ],
        "xaml+xml": "xaml",
        "xcap-diff+xml": "xdf",
        "xenc+xml": "xenc",
        "xml-dtd": "dtd",
        "xop+xml": "xop",
        "xproc+xml": "xpl",
        "xslt+xml": "xslt",
        "xv+xml": [
            "mxml",
            "xhvml",
            "xvml",
            "xvm"
        ],
        "yang": "yang",
        "yin+xml": "yin",
        "envoy": "evy",
        "fractals": "fif",
        "internet-property-stream": "acx",
        "olescript": "axs",
        "vnd.ms-outlook": "msg",
        "vnd.ms-pkicertstore": "sst",
        "x-compress": "z",
        "x-compressed": "tgz",
        "x-gzip": "gz",
        "x-perfmon": [
            "pma",
            "pmc",
            "pml",
            "pmr",
            "pmw"
        ],
        "x-pkcs7-mime": [
            "p7c",
            "p7m"
        ],
        "ynd.ms-pkipko": "pko"
    },
    "audio": {
        "amr": "amr",
        "amr-wb": "awb",
        "annodex": "axa",
        "basic": [
            "au",
            "snd"
        ],
        "flac": "flac",
        "midi": [
            "mid",
            "midi",
            "kar",
            "rmi"
        ],
        "mpeg": [
            "mpga",
            "mpega",
            "mp2",
            "mp3",
            "m4a",
            "mp2a",
            "m2a",
            "m3a"
        ],
        "mpegurl": "m3u",
        "ogg": [
            "oga",
            "ogg",
            "spx"
        ],
        "prs.sid": "sid",
        "x-aiff": [
            "aif",
            "aiff",
            "aifc"
        ],
        "x-gsm": "gsm",
        "x-ms-wma": "wma",
        "x-ms-wax": "wax",
        "x-pn-realaudio": "ram",
        "x-realaudio": "ra",
        "x-sd2": "sd2",
        "x-wav": "wav",
        "adpcm": "adp",
        "mp4": "mp4a",
        "s3m": "s3m",
        "silk": "sil",
        "vnd.dece.audio": [
            "uva",
            "uvva"
        ],
        "vnd.digital-winds": "eol",
        "vnd.dra": "dra",
        "vnd.dts": "dts",
        "vnd.dts.hd": "dtshd",
        "vnd.lucent.voice": "lvp",
        "vnd.ms-playready.media.pya": "pya",
        "vnd.nuera.ecelp4800": "ecelp4800",
        "vnd.nuera.ecelp7470": "ecelp7470",
        "vnd.nuera.ecelp9600": "ecelp9600",
        "vnd.rip": "rip",
        "webm": "weba",
        "x-aac": "aac",
        "x-caf": "caf",
        "x-matroska": "mka",
        "x-pn-realaudio-plugin": "rmp",
        "xm": "xm",
        "mid": [
            "mid",
            "rmi"
        ]
    },
    "chemical": {
        "x-alchemy": "alc",
        "x-cache": [
            "cac",
            "cache"
        ],
        "x-cache-csf": "csf",
        "x-cactvs-binary": [
            "cbin",
            "cascii",
            "ctab"
        ],
        "x-cdx": "cdx",
        "x-chem3d": "c3d",
        "x-cif": "cif",
        "x-cmdf": "cmdf",
        "x-cml": "cml",
        "x-compass": "cpa",
        "x-crossfire": "bsd",
        "x-csml": [
            "csml",
            "csm"
        ],
        "x-ctx": "ctx",
        "x-cxf": [
            "cxf",
            "cef"
        ],
        "x-embl-dl-nucleotide": [
            "emb",
            "embl"
        ],
        "x-gamess-input": [
            "inp",
            "gam",
            "gamin"
        ],
        "x-gaussian-checkpoint": [
            "fch",
            "fchk"
        ],
        "x-gaussian-cube": "cub",
        "x-gaussian-input": [
            "gau",
            "gjc",
            "gjf"
        ],
        "x-gaussian-log": "gal",
        "x-gcg8-sequence": "gcg",
        "x-genbank": "gen",
        "x-hin": "hin",
        "x-isostar": [
            "istr",
            "ist"
        ],
        "x-jcamp-dx": [
            "jdx",
            "dx"
        ],
        "x-kinemage": "kin",
        "x-macmolecule": "mcm",
        "x-macromodel-input": [
            "mmd",
            "mmod"
        ],
        "x-mdl-molfile": "mol",
        "x-mdl-rdfile": "rd",
        "x-mdl-rxnfile": "rxn",
        "x-mdl-sdfile": [
            "sd",
            "sdf"
        ],
        "x-mdl-tgf": "tgf",
        "x-mmcif": "mcif",
        "x-mol2": "mol2",
        "x-molconn-Z": "b",
        "x-mopac-graph": "gpt",
        "x-mopac-input": [
            "mop",
            "mopcrt",
            "mpc",
            "zmt"
        ],
        "x-mopac-out": "moo",
        "x-ncbi-asn1": "asn",
        "x-ncbi-asn1-ascii": [
            "prt",
            "ent"
        ],
        "x-ncbi-asn1-binary": [
            "val",
            "aso"
        ],
        "x-pdb": [
            "pdb",
            "ent"
        ],
        "x-rosdal": "ros",
        "x-swissprot": "sw",
        "x-vamas-iso14976": "vms",
        "x-vmd": "vmd",
        "x-xtel": "xtel",
        "x-xyz": "xyz"
    },
    "image": {
        "gif": "gif",
        "ief": "ief",
        "jpeg": [
            "jpeg",
            "jpg",
            "jpe"
        ],
        "pcx": "pcx",
        "png": "png",
        "svg+xml": [
            "svg",
            "svgz"
        ],
        "tiff": [
            "tiff",
            "tif"
        ],
        "vnd.djvu": [
            "djvu",
            "djv"
        ],
        "vnd.wap.wbmp": "wbmp",
        "x-canon-cr2": "cr2",
        "x-canon-crw": "crw",
        "x-cmu-raster": "ras",
        "x-coreldraw": "cdr",
        "x-coreldrawpattern": "pat",
        "x-coreldrawtemplate": "cdt",
        "x-corelphotopaint": "cpt",
        "x-epson-erf": "erf",
        "x-icon": "ico",
        "x-jg": "art",
        "x-jng": "jng",
        "x-nikon-nef": "nef",
        "x-olympus-orf": "orf",
        "x-photoshop": "psd",
        "x-portable-anymap": "pnm",
        "x-portable-bitmap": "pbm",
        "x-portable-graymap": "pgm",
        "x-portable-pixmap": "ppm",
        "x-rgb": "rgb",
        "x-xbitmap": "xbm",
        "x-xpixmap": "xpm",
        "x-xwindowdump": "xwd",
        "bmp": "bmp",
        "cgm": "cgm",
        "g3fax": "g3",
        "ktx": "ktx",
        "prs.btif": "btif",
        "sgi": "sgi",
        "vnd.dece.graphic": [
            "uvi",
            "uvvi",
            "uvg",
            "uvvg"
        ],
        "vnd.dwg": "dwg",
        "vnd.dxf": "dxf",
        "vnd.fastbidsheet": "fbs",
        "vnd.fpx": "fpx",
        "vnd.fst": "fst",
        "vnd.fujixerox.edmics-mmr": "mmr",
        "vnd.fujixerox.edmics-rlc": "rlc",
        "vnd.ms-modi": "mdi",
        "vnd.ms-photo": "wdp",
        "vnd.net-fpx": "npx",
        "vnd.xiff": "xif",
        "webp": "webp",
        "x-3ds": "3ds",
        "x-cmx": "cmx",
        "x-freehand": [
            "fh",
            "fhc",
            "fh4",
            "fh5",
            "fh7"
        ],
        "x-pict": [
            "pic",
            "pct"
        ],
        "x-tga": "tga",
        "cis-cod": "cod",
        "pipeg": "jfif"
    },
    "message": {
        "rfc822": [
            "eml",
            "mime",
            "mht",
            "mhtml",
            "nws"
        ]
    },
    "model": {
        "iges": [
            "igs",
            "iges"
        ],
        "mesh": [
            "msh",
            "mesh",
            "silo"
        ],
        "vrml": [
            "wrl",
            "vrml"
        ],
        "x3d+vrml": [
            "x3dv",
            "x3dvz"
        ],
        "x3d+xml": [
            "x3d",
            "x3dz"
        ],
        "x3d+binary": [
            "x3db",
            "x3dbz"
        ],
        "vnd.collada+xml": "dae",
        "vnd.dwf": "dwf",
        "vnd.gdl": "gdl",
        "vnd.gtw": "gtw",
        "vnd.mts": "mts",
        "vnd.vtu": "vtu"
    },
    "text": {
        "cache-manifest": [
            "manifest",
            "appcache"
        ],
        "calendar": [
            "ics",
            "icz",
            "ifb"
        ],
        "css": "css",
        "csv": "csv",
        "h323": "323",
        "html": [
            "html",
            "htm",
            "shtml",
            "stm"
        ],
        "iuls": "uls",
        "mathml": "mml",
        "plain": [
            "txt",
            "text",
            "brf",
            "conf",
            "def",
            "list",
            "log",
            "in",
            "bas"
        ],
        "richtext": "rtx",
        "scriptlet": [
            "sct",
            "wsc"
        ],
        "texmacs": [
            "tm",
            "ts"
        ],
        "tab-separated-values": "tsv",
        "vnd.sun.j2me.app-descriptor": "jad",
        "vnd.wap.wml": "wml",
        "vnd.wap.wmlscript": "wmls",
        "x-bibtex": "bib",
        "x-boo": "boo",
        "x-c++hdr": [
            "h++",
            "hpp",
            "hxx",
            "hh"
        ],
        "x-c++src": [
            "c++",
            "cpp",
            "cxx",
            "cc"
        ],
        "x-component": "htc",
        "x-dsrc": "d",
        "x-diff": [
            "diff",
            "patch"
        ],
        "x-haskell": "hs",
        "x-java": "java",
        "x-literate-haskell": "lhs",
        "x-moc": "moc",
        "x-pascal": [
            "p",
            "pas"
        ],
        "x-pcs-gcd": "gcd",
        "x-perl": [
            "pl",
            "pm"
        ],
        "x-python": "py",
        "x-scala": "scala",
        "x-setext": "etx",
        "x-tcl": [
            "tcl",
            "tk"
        ],
        "x-tex": [
            "tex",
            "ltx",
            "sty",
            "cls"
        ],
        "x-vcalendar": "vcs",
        "x-vcard": "vcf",
        "n3": "n3",
        "prs.lines.tag": "dsc",
        "sgml": [
            "sgml",
            "sgm"
        ],
        "troff": [
            "t",
            "tr",
            "roff",
            "man",
            "me",
            "ms"
        ],
        "turtle": "ttl",
        "uri-list": [
            "uri",
            "uris",
            "urls"
        ],
        "vcard": "vcard",
        "vnd.curl": "curl",
        "vnd.curl.dcurl": "dcurl",
        "vnd.curl.scurl": "scurl",
        "vnd.curl.mcurl": "mcurl",
        "vnd.dvb.subtitle": "sub",
        "vnd.fly": "fly",
        "vnd.fmi.flexstor": "flx",
        "vnd.graphviz": "gv",
        "vnd.in3d.3dml": "3dml",
        "vnd.in3d.spot": "spot",
        "x-asm": [
            "s",
            "asm"
        ],
        "x-c": [
            "c",
            "cc",
            "cxx",
            "cpp",
            "h",
            "hh",
            "dic"
        ],
        "x-fortran": [
            "f",
            "for",
            "f77",
            "f90"
        ],
        "x-opml": "opml",
        "x-nfo": "nfo",
        "x-sfv": "sfv",
        "x-uuencode": "uu",
        "webviewhtml": "htt"
    },
    "video": {
        "avif": ".avif",
        "3gpp": "3gp",
        "annodex": "axv",
        "dl": "dl",
        "dv": [
            "dif",
            "dv"
        ],
        "fli": "fli",
        "gl": "gl",
        "mpeg": [
            "mpeg",
            "mpg",
            "mpe",
            "m1v",
            "m2v",
            "mp2",
            "mpa",
            "mpv2"
        ],
        "mp4": [
            "mp4",
            "mp4v",
            "mpg4"
        ],
        "quicktime": [
            "qt",
            "mov"
        ],
        "ogg": "ogv",
        "vnd.mpegurl": [
            "mxu",
            "m4u"
        ],
        "x-flv": "flv",
        "x-la-asf": [
            "lsf",
            "lsx"
        ],
        "x-mng": "mng",
        "x-ms-asf": [
            "asf",
            "asx",
            "asr"
        ],
        "x-ms-wm": "wm",
        "x-ms-wmv": "wmv",
        "x-ms-wmx": "wmx",
        "x-ms-wvx": "wvx",
        "x-msvideo": "avi",
        "x-sgi-movie": "movie",
        "x-matroska": [
            "mpv",
            "mkv",
            "mk3d",
            "mks"
        ],
        "3gpp2": "3g2",
        "h261": "h261",
        "h263": "h263",
        "h264": "h264",
        "jpeg": "jpgv",
        "jpm": [
            "jpm",
            "jpgm"
        ],
        "mj2": [
            "mj2",
            "mjp2"
        ],
        "vnd.dece.hd": [
            "uvh",
            "uvvh"
        ],
        "vnd.dece.mobile": [
            "uvm",
            "uvvm"
        ],
        "vnd.dece.pd": [
            "uvp",
            "uvvp"
        ],
        "vnd.dece.sd": [
            "uvs",
            "uvvs"
        ],
        "vnd.dece.video": [
            "uvv",
            "uvvv"
        ],
        "vnd.dvb.file": "dvb",
        "vnd.fvt": "fvt",
        "vnd.ms-playready.media.pyv": "pyv",
        "vnd.uvvu.mp4": [
            "uvu",
            "uvvu"
        ],
        "vnd.vivo": "viv",
        "webm": "webm",
        "x-f4v": "f4v",
        "x-m4v": "m4v",
        "x-ms-vob": "vob",
        "x-smv": "smv"
    },
    "x-conference": {
        "x-cooltalk": "ice"
    },
    "x-world": {
        "x-vrml": [
            "vrm",
            "vrml",
            "wrl",
            "flr",
            "wrz",
            "xaf",
            "xof"
        ]
    }
};
const $80578c62b8d54528$export$53cb456310d1907e = (()=>{
    const mimeTypes = {};
    for(const type in $80578c62b8d54528$var$table)// eslint-disable-next-line no-prototype-builtins
    if ($80578c62b8d54528$var$table.hasOwnProperty(type)) {
        for(const subtype in $80578c62b8d54528$var$table[type])// eslint-disable-next-line no-prototype-builtins
        if ($80578c62b8d54528$var$table[type].hasOwnProperty(subtype)) {
            const value = $80578c62b8d54528$var$table[type][subtype];
            if (typeof value == "string") mimeTypes[value] = type + "/" + subtype;
            else for(let indexMimeType = 0; indexMimeType < value.length; indexMimeType++)mimeTypes[value[indexMimeType]] = type + "/" + subtype;
        }
    }
    return mimeTypes;
})();
function $80578c62b8d54528$export$200548c990602f61(filename) {
    return filename && $80578c62b8d54528$export$53cb456310d1907e[filename.split(".").pop().toLowerCase()] || (0, $d7fe75dc25057a0e$export$200548c990602f61)();
}


/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /* global setTimeout, clearTimeout */ 
/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /*
 * This program is based on JZlib 1.0.2 ymnk, JCraft,Inc.
 * JZlib is based on zlib-1.1.3, so all credit should go authors
 * Jean-loup Gailly(jloup@gzip.org) and Mark Adler(madler@alumni.caltech.edu)
 * and contributors of zlib.
 */ /* global TransformStream */ // deno-lint-ignore-file no-this-alias
/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /* global TransformStream */ // deno-lint-ignore-file no-this-alias
/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /* global TransformStream */ /*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ const $7272846072e67247$var$table = [];
for(let i = 0; i < 256; i++){
    let t = i;
    for(let j = 0; j < 8; j++)if (t & 1) t = t >>> 1 ^ 0xEDB88320;
    else t = t >>> 1;
    $7272846072e67247$var$table[i] = t;
}
class $7272846072e67247$export$16d8d62894c71747 {
    constructor(crc){
        this.crc = crc || -1;
    }
    append(data) {
        let crc = this.crc | 0;
        for(let offset = 0, length = data.length | 0; offset < length; offset++)crc = crc >>> 8 ^ $7272846072e67247$var$table[(crc ^ data[offset]) & 0xFF];
        this.crc = crc;
    }
    get() {
        return ~this.crc;
    }
}


class $77e41b50431c57cf$export$b3cd3a37bd85e6ee extends TransformStream {
    constructor(){
        const crc32 = new (0, $7272846072e67247$export$16d8d62894c71747)();
        super({
            transform (chunk) {
                crc32.append(chunk);
            },
            flush (controller) {
                const value = new Uint8Array(4);
                const dataView = new DataView(value.buffer);
                dataView.setUint32(0, crc32.get());
                controller.enqueue(value);
            }
        });
    }
}


/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /* global crypto, TransformStream */ // deno-lint-ignore-file no-this-alias
/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /* global TextEncoder */ function $ba4ced2ed37d6fed$export$7d0d7672e8a1c5cf(value) {
    if (typeof TextEncoder == "undefined") {
        value = unescape(encodeURIComponent(value));
        const result = new Uint8Array(value.length);
        for(let i = 0; i < result.length; i++)result[i] = value.charCodeAt(i);
        return result;
    } else return new TextEncoder().encode(value);
}


// Derived from https://github.com/xqdoo00o/jszip/blob/master/lib/sjcl.js and https://github.com/bitwiseshiftleft/sjcl
// deno-lint-ignore-file no-this-alias
/*
 * SJCL is open. You can use, modify and redistribute it under a BSD
 * license or under the GNU GPL, version 2.0.
 */ /** @fileOverview Javascript cryptography implementation.
 *
 * Crush to remove comments, shorten variable names and
 * generally reduce transmission size.
 *
 * @author Emily Stark
 * @author Mike Hamburg
 * @author Dan Boneh
 */ /*jslint indent: 2, bitwise: false, nomen: false, plusplus: false, white: false, regexp: false */ /** @fileOverview Arrays of bits, encoded as arrays of Numbers.
 *
 * @author Emily Stark
 * @author Mike Hamburg
 * @author Dan Boneh
 */ /**
 * Arrays of bits, encoded as arrays of Numbers.
 * @namespace
 * @description
 * <p>
 * These objects are the currency accepted by SJCL's crypto functions.
 * </p>
 *
 * <p>
 * Most of our crypto primitives operate on arrays of 4-byte words internally,
 * but many of them can take arguments that are not a multiple of 4 bytes.
 * This library encodes arrays of bits (whose size need not be a multiple of 8
 * bits) as arrays of 32-bit words.  The bits are packed, big-endian, into an
 * array of words, 32 bits at a time.  Since the words are double-precision
 * floating point numbers, they fit some extra data.  We use this (in a private,
 * possibly-changing manner) to encode the number of bits actually  present
 * in the last word of the array.
 * </p>
 *
 * <p>
 * Because bitwise ops clear this out-of-band data, these arrays can be passed
 * to ciphers like AES which want arrays of words.
 * </p>
 */ const $7031d31a808888eb$var$bitArray = {
    /**
	 * Concatenate two bit arrays.
	 * @param {bitArray} a1 The first array.
	 * @param {bitArray} a2 The second array.
	 * @return {bitArray} The concatenation of a1 and a2.
	 */ concat (a1, a2) {
        if (a1.length === 0 || a2.length === 0) return a1.concat(a2);
        const last = a1[a1.length - 1], shift = $7031d31a808888eb$var$bitArray.getPartial(last);
        if (shift === 32) return a1.concat(a2);
        else return $7031d31a808888eb$var$bitArray._shiftRight(a2, shift, last | 0, a1.slice(0, a1.length - 1));
    },
    /**
	 * Find the length of an array of bits.
	 * @param {bitArray} a The array.
	 * @return {Number} The length of a, in bits.
	 */ bitLength (a) {
        const l = a.length;
        if (l === 0) return 0;
        const x = a[l - 1];
        return (l - 1) * 32 + $7031d31a808888eb$var$bitArray.getPartial(x);
    },
    /**
	 * Truncate an array.
	 * @param {bitArray} a The array.
	 * @param {Number} len The length to truncate to, in bits.
	 * @return {bitArray} A new array, truncated to len bits.
	 */ clamp (a, len) {
        if (a.length * 32 < len) return a;
        a = a.slice(0, Math.ceil(len / 32));
        const l = a.length;
        len = len & 31;
        if (l > 0 && len) a[l - 1] = $7031d31a808888eb$var$bitArray.partial(len, a[l - 1] & 0x80000000 >> len - 1, 1);
        return a;
    },
    /**
	 * Make a partial word for a bit array.
	 * @param {Number} len The number of bits in the word.
	 * @param {Number} x The bits.
	 * @param {Number} [_end=0] Pass 1 if x has already been shifted to the high side.
	 * @return {Number} The partial word.
	 */ partial (len, x, _end) {
        if (len === 32) return x;
        return (_end ? x | 0 : x << 32 - len) + len * 0x10000000000;
    },
    /**
	 * Get the number of bits used by a partial word.
	 * @param {Number} x The partial word.
	 * @return {Number} The number of bits used by the partial word.
	 */ getPartial (x) {
        return Math.round(x / 0x10000000000) || 32;
    },
    /** Shift an array right.
	 * @param {bitArray} a The array to shift.
	 * @param {Number} shift The number of bits to shift.
	 * @param {Number} [carry=0] A byte to carry in
	 * @param {bitArray} [out=[]] An array to prepend to the output.
	 * @private
	 */ _shiftRight (a, shift, carry, out) {
        if (out === undefined) out = [];
        for(; shift >= 32; shift -= 32){
            out.push(carry);
            carry = 0;
        }
        if (shift === 0) return out.concat(a);
        for(let i = 0; i < a.length; i++){
            out.push(carry | a[i] >>> shift);
            carry = a[i] << 32 - shift;
        }
        const last2 = a.length ? a[a.length - 1] : 0;
        const shift2 = $7031d31a808888eb$var$bitArray.getPartial(last2);
        out.push($7031d31a808888eb$var$bitArray.partial(shift + shift2 & 31, shift + shift2 > 32 ? carry : out.pop(), 1));
        return out;
    }
};
/** @fileOverview Bit array codec implementations.
 *
 * @author Emily Stark
 * @author Mike Hamburg
 * @author Dan Boneh
 */ /**
 * Arrays of bytes
 * @namespace
 */ const $7031d31a808888eb$export$1c37c01eba8ed446 = {
    bytes: {
        /** Convert from a bitArray to an array of bytes. */ fromBits (arr) {
            const bl = $7031d31a808888eb$var$bitArray.bitLength(arr);
            const byteLength = bl / 8;
            const out = new Uint8Array(byteLength);
            let tmp;
            for(let i = 0; i < byteLength; i++){
                if ((i & 3) === 0) tmp = arr[i / 4];
                out[i] = tmp >>> 24;
                tmp <<= 8;
            }
            return out;
        },
        /** Convert from an array of bytes to a bitArray. */ toBits (bytes) {
            const out = [];
            let i;
            let tmp = 0;
            for(i = 0; i < bytes.length; i++){
                tmp = tmp << 8 | bytes[i];
                if ((i & 3) === 3) {
                    out.push(tmp);
                    tmp = 0;
                }
            }
            if (i & 3) out.push($7031d31a808888eb$var$bitArray.partial(8 * (i & 3), tmp));
            return out;
        }
    }
};
const $7031d31a808888eb$var$hash = {};
/**
 * Context for a SHA-1 operation in progress.
 * @constructor
 */ $7031d31a808888eb$var$hash.sha1 = function(hash) {
    if (hash) {
        this._h = hash._h.slice(0);
        this._buffer = hash._buffer.slice(0);
        this._length = hash._length;
    } else this.reset();
};
$7031d31a808888eb$var$hash.sha1.prototype = {
    /**
	 * The hash's block size, in bits.
	 * @constant
	 */ blockSize: 512,
    /**
	 * Reset the hash state.
	 * @return this
	 */ reset () {
        const sha1 = this;
        sha1._h = this._init.slice(0);
        sha1._buffer = [];
        sha1._length = 0;
        return sha1;
    },
    /**
	 * Input several words to the hash.
	 * @param {bitArray|String} data the data to hash.
	 * @return this
	 */ update (data) {
        const sha1 = this;
        if (typeof data === "string") data = $7031d31a808888eb$export$1c37c01eba8ed446.utf8String.toBits(data);
        const b = sha1._buffer = $7031d31a808888eb$var$bitArray.concat(sha1._buffer, data);
        const ol = sha1._length;
        const nl = sha1._length = ol + $7031d31a808888eb$var$bitArray.bitLength(data);
        if (nl > 9007199254740991) throw new Error("Cannot hash more than 2^53 - 1 bits");
        const c = new Uint32Array(b);
        let j = 0;
        for(let i = sha1.blockSize + ol - (sha1.blockSize + ol & sha1.blockSize - 1); i <= nl; i += sha1.blockSize){
            sha1._block(c.subarray(16 * j, 16 * (j + 1)));
            j += 1;
        }
        b.splice(0, 16 * j);
        return sha1;
    },
    /**
	 * Complete hashing and output the hash value.
	 * @return {bitArray} The hash value, an array of 5 big-endian words. TODO
	 */ finalize () {
        const sha1 = this;
        let b = sha1._buffer;
        const h = sha1._h;
        // Round out and push the buffer
        b = $7031d31a808888eb$var$bitArray.concat(b, [
            $7031d31a808888eb$var$bitArray.partial(1, 1)
        ]);
        // Round out the buffer to a multiple of 16 words, less the 2 length words.
        for(let i = b.length + 2; i & 15; i++)b.push(0);
        // append the length
        b.push(Math.floor(sha1._length / 0x100000000));
        b.push(sha1._length | 0);
        while(b.length)sha1._block(b.splice(0, 16));
        sha1.reset();
        return h;
    },
    /**
	 * The SHA-1 initialization vector.
	 * @private
	 */ _init: [
        0x67452301,
        0xEFCDAB89,
        0x98BADCFE,
        0x10325476,
        0xC3D2E1F0
    ],
    /**
	 * The SHA-1 hash key.
	 * @private
	 */ _key: [
        0x5A827999,
        0x6ED9EBA1,
        0x8F1BBCDC,
        0xCA62C1D6
    ],
    /**
	 * The SHA-1 logical functions f(0), f(1), ..., f(79).
	 * @private
	 */ _f (t, b, c, d) {
        if (t <= 19) return b & c | ~b & d;
        else if (t <= 39) return b ^ c ^ d;
        else if (t <= 59) return b & c | b & d | c & d;
        else if (t <= 79) return b ^ c ^ d;
    },
    /**
	 * Circular left-shift operator.
	 * @private
	 */ _S (n, x) {
        return x << n | x >>> 32 - n;
    },
    /**
	 * Perform one cycle of SHA-1.
	 * @param {Uint32Array|bitArray} words one block of words.
	 * @private
	 */ _block (words) {
        const sha1 = this;
        const h = sha1._h;
        // When words is passed to _block, it has 16 elements. SHA1 _block
        // function extends words with new elements (at the end there are 80 elements). 
        // The problem is that if we use Uint32Array instead of Array, 
        // the length of Uint32Array cannot be changed. Thus, we replace words with a 
        // normal Array here.
        const w = Array(80); // do not use Uint32Array here as the instantiation is slower
        for(let j = 0; j < 16; j++)w[j] = words[j];
        let a = h[0];
        let b = h[1];
        let c = h[2];
        let d = h[3];
        let e = h[4];
        for(let t = 0; t <= 79; t++){
            if (t >= 16) w[t] = sha1._S(1, w[t - 3] ^ w[t - 8] ^ w[t - 14] ^ w[t - 16]);
            const tmp = sha1._S(5, a) + sha1._f(t, b, c, d) + e + w[t] + sha1._key[Math.floor(t / 20)] | 0;
            e = d;
            d = c;
            c = sha1._S(30, b);
            b = a;
            a = tmp;
        }
        h[0] = h[0] + a | 0;
        h[1] = h[1] + b | 0;
        h[2] = h[2] + c | 0;
        h[3] = h[3] + d | 0;
        h[4] = h[4] + e | 0;
    }
};
/** @fileOverview Low-level AES implementation.
 *
 * This file contains a low-level implementation of AES, optimized for
 * size and for efficiency on several browsers.  It is based on
 * OpenSSL's aes_core.c, a public-domain implementation by Vincent
 * Rijmen, Antoon Bosselaers and Paulo Barreto.
 *
 * An older version of this implementation is available in the public
 * domain, but this one is (c) Emily Stark, Mike Hamburg, Dan Boneh,
 * Stanford University 2008-2010 and BSD-licensed for liability
 * reasons.
 *
 * @author Emily Stark
 * @author Mike Hamburg
 * @author Dan Boneh
 */ const $7031d31a808888eb$export$f135d47a138454a1 = {};
/**
 * Schedule out an AES key for both encryption and decryption.  This
 * is a low-level class.  Use a cipher mode to do bulk encryption.
 *
 * @constructor
 * @param {Array} key The key as an array of 4, 6 or 8 words.
 */ $7031d31a808888eb$export$f135d47a138454a1.aes = class {
    constructor(key){
        /**
		 * The expanded S-box and inverse S-box tables.  These will be computed
		 * on the client so that we don't have to send them down the wire.
		 *
		 * There are two tables, _tables[0] is for encryption and
		 * _tables[1] is for decryption.
		 *
		 * The first 4 sub-tables are the expanded S-box with MixColumns.  The
		 * last (_tables[01][4]) is the S-box itself.
		 *
		 * @private
		 */ const aes = this;
        aes._tables = [
            [
                [],
                [],
                [],
                [],
                []
            ],
            [
                [],
                [],
                [],
                [],
                []
            ]
        ];
        if (!aes._tables[0][0][0]) aes._precompute();
        const sbox = aes._tables[0][4];
        const decTable = aes._tables[1];
        const keyLen = key.length;
        let i, encKey, decKey, rcon = 1;
        if (keyLen !== 4 && keyLen !== 6 && keyLen !== 8) throw new Error("invalid aes key size");
        aes._key = [
            encKey = key.slice(0),
            decKey = []
        ];
        // schedule encryption keys
        for(i = keyLen; i < 4 * keyLen + 28; i++){
            let tmp = encKey[i - 1];
            // apply sbox
            if (i % keyLen === 0 || keyLen === 8 && i % keyLen === 4) {
                tmp = sbox[tmp >>> 24] << 24 ^ sbox[tmp >> 16 & 255] << 16 ^ sbox[tmp >> 8 & 255] << 8 ^ sbox[tmp & 255];
                // shift rows and add rcon
                if (i % keyLen === 0) {
                    tmp = tmp << 8 ^ tmp >>> 24 ^ rcon << 24;
                    rcon = rcon << 1 ^ (rcon >> 7) * 283;
                }
            }
            encKey[i] = encKey[i - keyLen] ^ tmp;
        }
        // schedule decryption keys
        for(let j = 0; i; j++, i--){
            const tmp = encKey[j & 3 ? i : i - 4];
            if (i <= 4 || j < 4) decKey[j] = tmp;
            else decKey[j] = decTable[0][sbox[tmp >>> 24]] ^ decTable[1][sbox[tmp >> 16 & 255]] ^ decTable[2][sbox[tmp >> 8 & 255]] ^ decTable[3][sbox[tmp & 255]];
        }
    }
    // public
    /* Something like this might appear here eventually
	name: "AES",
	blockSize: 4,
	keySizes: [4,6,8],
	*/ /**
	 * Encrypt an array of 4 big-endian words.
	 * @param {Array} data The plaintext.
	 * @return {Array} The ciphertext.
	 */ encrypt(data) {
        return this._crypt(data, 0);
    }
    /**
	 * Decrypt an array of 4 big-endian words.
	 * @param {Array} data The ciphertext.
	 * @return {Array} The plaintext.
	 */ decrypt(data) {
        return this._crypt(data, 1);
    }
    /**
	 * Expand the S-box tables.
	 *
	 * @private
	 */ _precompute() {
        const encTable = this._tables[0];
        const decTable = this._tables[1];
        const sbox = encTable[4];
        const sboxInv = decTable[4];
        const d = [];
        const th = [];
        let xInv, x2, x4, x8;
        // Compute double and third tables
        for(let i = 0; i < 256; i++)th[(d[i] = i << 1 ^ (i >> 7) * 283) ^ i] = i;
        for(let x = xInv = 0; !sbox[x]; x ^= x2 || 1, xInv = th[xInv] || 1){
            // Compute sbox
            let s = xInv ^ xInv << 1 ^ xInv << 2 ^ xInv << 3 ^ xInv << 4;
            s = s >> 8 ^ s & 255 ^ 99;
            sbox[x] = s;
            sboxInv[s] = x;
            // Compute MixColumns
            x8 = d[x4 = d[x2 = d[x]]];
            let tDec = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
            let tEnc = d[s] * 0x101 ^ s * 0x1010100;
            for(let i = 0; i < 4; i++){
                encTable[i][x] = tEnc = tEnc << 24 ^ tEnc >>> 8;
                decTable[i][s] = tDec = tDec << 24 ^ tDec >>> 8;
            }
        }
        // Compactify.  Considerable speedup on Firefox.
        for(let i = 0; i < 5; i++){
            encTable[i] = encTable[i].slice(0);
            decTable[i] = decTable[i].slice(0);
        }
    }
    /**
	 * Encryption and decryption core.
	 * @param {Array} input Four words to be encrypted or decrypted.
	 * @param dir The direction, 0 for encrypt and 1 for decrypt.
	 * @return {Array} The four encrypted or decrypted words.
	 * @private
	 */ _crypt(input, dir) {
        if (input.length !== 4) throw new Error("invalid aes block size");
        const key = this._key[dir];
        const nInnerRounds = key.length / 4 - 2;
        const out = [
            0,
            0,
            0,
            0
        ];
        const table = this._tables[dir];
        // load up the tables
        const t0 = table[0];
        const t1 = table[1];
        const t2 = table[2];
        const t3 = table[3];
        const sbox = table[4];
        // state variables a,b,c,d are loaded with pre-whitened data
        let a = input[0] ^ key[0];
        let b = input[dir ? 3 : 1] ^ key[1];
        let c = input[2] ^ key[2];
        let d = input[dir ? 1 : 3] ^ key[3];
        let kIndex = 4;
        let a2, b2, c2;
        // Inner rounds.  Cribbed from OpenSSL.
        for(let i = 0; i < nInnerRounds; i++){
            a2 = t0[a >>> 24] ^ t1[b >> 16 & 255] ^ t2[c >> 8 & 255] ^ t3[d & 255] ^ key[kIndex];
            b2 = t0[b >>> 24] ^ t1[c >> 16 & 255] ^ t2[d >> 8 & 255] ^ t3[a & 255] ^ key[kIndex + 1];
            c2 = t0[c >>> 24] ^ t1[d >> 16 & 255] ^ t2[a >> 8 & 255] ^ t3[b & 255] ^ key[kIndex + 2];
            d = t0[d >>> 24] ^ t1[a >> 16 & 255] ^ t2[b >> 8 & 255] ^ t3[c & 255] ^ key[kIndex + 3];
            kIndex += 4;
            a = a2;
            b = b2;
            c = c2;
        }
        // Last round.
        for(let i = 0; i < 4; i++){
            out[dir ? 3 & -i : i] = sbox[a >>> 24] << 24 ^ sbox[b >> 16 & 255] << 16 ^ sbox[c >> 8 & 255] << 8 ^ sbox[d & 255] ^ key[kIndex++];
            a2 = a;
            a = b;
            b = c;
            c = d;
            d = a2;
        }
        return out;
    }
};
/**
 * Random values
 * @namespace
 */ const $7031d31a808888eb$export$4385e60b38654f68 = {
    /** 
	 * Generate random words with pure js, cryptographically not as strong & safe as native implementation.
	 * @param {TypedArray} typedArray The array to fill.
	 * @return {TypedArray} The random values.
	 */ getRandomValues (typedArray) {
        const words = new Uint32Array(typedArray.buffer);
        const r = (m_w)=>{
            let m_z = 0x3ade68b1;
            const mask = 0xffffffff;
            return function() {
                m_z = 0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10) & mask;
                m_w = 0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10) & mask;
                const result = ((m_z << 0x10) + m_w & mask) / 0x100000000 + .5;
                return result * (Math.random() > .5 ? 1 : -1);
            };
        };
        for(let i = 0, rcache; i < typedArray.length; i += 4){
            const _r = r((rcache || Math.random()) * 0x100000000);
            rcache = _r() * 0x3ade67b7;
            words[i / 4] = _r() * 0x100000000 | 0;
        }
        return typedArray;
    }
};
/** @fileOverview CTR mode implementation.
 *
 * Special thanks to Roy Nicholson for pointing out a bug in our
 * implementation.
 *
 * @author Emily Stark
 * @author Mike Hamburg
 * @author Dan Boneh
 */ /** Brian Gladman's CTR Mode.
* @constructor
* @param {Object} _prf The aes instance to generate key.
* @param {bitArray} _iv The iv for ctr mode, it must be 128 bits.
*/ const $7031d31a808888eb$export$549ff81930776885 = {};
/**
 * Brian Gladman's CTR Mode.
 * @namespace
 */ $7031d31a808888eb$export$549ff81930776885.ctrGladman = class {
    constructor(prf, iv){
        this._prf = prf;
        this._initIv = iv;
        this._iv = iv;
    }
    reset() {
        this._iv = this._initIv;
    }
    /** Input some data to calculate.
	 * @param {bitArray} data the data to process, it must be intergral multiple of 128 bits unless it's the last.
	 */ update(data) {
        return this.calculate(this._prf, data, this._iv);
    }
    incWord(word) {
        if ((word >> 24 & 0xff) === 0xff) {
            let b1 = word >> 16 & 0xff;
            let b2 = word >> 8 & 0xff;
            let b3 = word & 0xff;
            if (b1 === 0xff) {
                b1 = 0;
                if (b2 === 0xff) {
                    b2 = 0;
                    if (b3 === 0xff) b3 = 0;
                    else ++b3;
                } else ++b2;
            } else ++b1;
            word = 0;
            word += b1 << 16;
            word += b2 << 8;
            word += b3;
        } else word += 16777216;
        return word;
    }
    incCounter(counter) {
        if ((counter[0] = this.incWord(counter[0])) === 0) // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
        counter[1] = this.incWord(counter[1]);
    }
    calculate(prf, data, iv) {
        let l;
        if (!(l = data.length)) return [];
        const bl = $7031d31a808888eb$var$bitArray.bitLength(data);
        for(let i = 0; i < l; i += 4){
            this.incCounter(iv);
            const e = prf.encrypt(iv);
            data[i] ^= e[0];
            data[i + 1] ^= e[1];
            data[i + 2] ^= e[2];
            data[i + 3] ^= e[3];
        }
        return $7031d31a808888eb$var$bitArray.clamp(data, bl);
    }
};
const $7031d31a808888eb$export$5675c2f3af4366e2 = {
    importKey (password) {
        return new $7031d31a808888eb$export$5675c2f3af4366e2.hmacSha1($7031d31a808888eb$export$1c37c01eba8ed446.bytes.toBits(password));
    },
    pbkdf2 (prf, salt, count, length) {
        count = count || 10000;
        if (length < 0 || count < 0) throw new Error("invalid params to pbkdf2");
        const byteLength = (length >> 5) + 1 << 2;
        let u, ui, i, j, k;
        const arrayBuffer = new ArrayBuffer(byteLength);
        const out = new DataView(arrayBuffer);
        let outLength = 0;
        const b = $7031d31a808888eb$var$bitArray;
        salt = $7031d31a808888eb$export$1c37c01eba8ed446.bytes.toBits(salt);
        for(k = 1; outLength < (byteLength || 1); k++){
            u = ui = prf.encrypt(b.concat(salt, [
                k
            ]));
            for(i = 1; i < count; i++){
                ui = prf.encrypt(ui);
                for(j = 0; j < ui.length; j++)u[j] ^= ui[j];
            }
            for(i = 0; outLength < (byteLength || 1) && i < u.length; i++){
                out.setInt32(outLength, u[i]);
                outLength += 4;
            }
        }
        return arrayBuffer.slice(0, length / 8);
    }
};
/** @fileOverview HMAC implementation.
 *
 * @author Emily Stark
 * @author Mike Hamburg
 * @author Dan Boneh
 */ /** HMAC with the specified hash function.
 * @constructor
 * @param {bitArray} key the key for HMAC.
 * @param {Object} [Hash=hash.sha1] The hash function to use.
 */ $7031d31a808888eb$export$5675c2f3af4366e2.hmacSha1 = class {
    constructor(key){
        const hmac = this;
        const Hash = hmac._hash = $7031d31a808888eb$var$hash.sha1;
        const exKey = [
            [],
            []
        ];
        const bs = Hash.prototype.blockSize / 32;
        hmac._baseHash = [
            new Hash(),
            new Hash()
        ];
        if (key.length > bs) key = Hash.hash(key);
        for(let i = 0; i < bs; i++){
            exKey[0][i] = key[i] ^ 0x36363636;
            exKey[1][i] = key[i] ^ 0x5C5C5C5C;
        }
        hmac._baseHash[0].update(exKey[0]);
        hmac._baseHash[1].update(exKey[1]);
        hmac._resultHash = new Hash(hmac._baseHash[0]);
    }
    reset() {
        const hmac = this;
        hmac._resultHash = new hmac._hash(hmac._baseHash[0]);
        hmac._updated = false;
    }
    update(data) {
        const hmac = this;
        hmac._updated = true;
        hmac._resultHash.update(data);
    }
    digest() {
        const hmac = this;
        const w = hmac._resultHash.finalize();
        const result = new hmac._hash(hmac._baseHash[1]).update(w).finalize();
        hmac.reset();
        return result;
    }
    encrypt(data) {
        if (!this._updated) {
            this.update(data);
            return this.digest(data);
        } else throw new Error("encrypt on already updated hmac called!");
    }
};


/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /* global crypto */ 
const $b6d61903a29d25a0$var$GET_RANDOM_VALUES_SUPPORTED = typeof crypto != "undefined" && typeof crypto.getRandomValues == "function";
const $b6d61903a29d25a0$export$91dc8f5b62a122fd = "Invalid password";
const $b6d61903a29d25a0$export$ae8341b00030fc9d = "Invalid signature";
function $b6d61903a29d25a0$export$960b9ff25e7d4257(array) {
    if ($b6d61903a29d25a0$var$GET_RANDOM_VALUES_SUPPORTED) return crypto.getRandomValues(array);
    else return (0, $7031d31a808888eb$export$4385e60b38654f68).getRandomValues(array);
}


const $2c52f391c94dc662$var$BLOCK_LENGTH = 16;
const $2c52f391c94dc662$var$RAW_FORMAT = "raw";
const $2c52f391c94dc662$var$PBKDF2_ALGORITHM = {
    name: "PBKDF2"
};
const $2c52f391c94dc662$var$HASH_ALGORITHM = {
    name: "HMAC"
};
const $2c52f391c94dc662$var$HASH_FUNCTION = "SHA-1";
const $2c52f391c94dc662$var$BASE_KEY_ALGORITHM = Object.assign({
    hash: $2c52f391c94dc662$var$HASH_ALGORITHM
}, $2c52f391c94dc662$var$PBKDF2_ALGORITHM);
const $2c52f391c94dc662$var$DERIVED_BITS_ALGORITHM = Object.assign({
    iterations: 1000,
    hash: {
        name: $2c52f391c94dc662$var$HASH_FUNCTION
    }
}, $2c52f391c94dc662$var$PBKDF2_ALGORITHM);
const $2c52f391c94dc662$var$DERIVED_BITS_USAGE = [
    "deriveBits"
];
const $2c52f391c94dc662$var$SALT_LENGTH = [
    8,
    12,
    16
];
const $2c52f391c94dc662$var$KEY_LENGTH = [
    16,
    24,
    32
];
const $2c52f391c94dc662$var$SIGNATURE_LENGTH = 10;
const $2c52f391c94dc662$var$COUNTER_DEFAULT_VALUE = [
    0,
    0,
    0,
    0
];
const $2c52f391c94dc662$var$UNDEFINED_TYPE = "undefined";
const $2c52f391c94dc662$var$FUNCTION_TYPE = "function";
// deno-lint-ignore valid-typeof
const $2c52f391c94dc662$var$CRYPTO_API_SUPPORTED = typeof crypto != $2c52f391c94dc662$var$UNDEFINED_TYPE;
const $2c52f391c94dc662$var$subtle = $2c52f391c94dc662$var$CRYPTO_API_SUPPORTED && crypto.subtle;
const $2c52f391c94dc662$var$SUBTLE_API_SUPPORTED = $2c52f391c94dc662$var$CRYPTO_API_SUPPORTED && typeof $2c52f391c94dc662$var$subtle != $2c52f391c94dc662$var$UNDEFINED_TYPE;
const $2c52f391c94dc662$var$IMPORT_KEY_SUPPORTED = $2c52f391c94dc662$var$CRYPTO_API_SUPPORTED && $2c52f391c94dc662$var$SUBTLE_API_SUPPORTED && typeof $2c52f391c94dc662$var$subtle.importKey == $2c52f391c94dc662$var$FUNCTION_TYPE;
const $2c52f391c94dc662$var$DERIVE_BITS_SUPPORTED = $2c52f391c94dc662$var$CRYPTO_API_SUPPORTED && $2c52f391c94dc662$var$SUBTLE_API_SUPPORTED && typeof $2c52f391c94dc662$var$subtle.deriveBits == $2c52f391c94dc662$var$FUNCTION_TYPE;
const $2c52f391c94dc662$var$codecBytes = (0, $7031d31a808888eb$export$1c37c01eba8ed446).bytes;
const $2c52f391c94dc662$var$Aes = (0, $7031d31a808888eb$export$f135d47a138454a1).aes;
const $2c52f391c94dc662$var$CtrGladman = (0, $7031d31a808888eb$export$549ff81930776885).ctrGladman;
const $2c52f391c94dc662$var$HmacSha1 = (0, $7031d31a808888eb$export$5675c2f3af4366e2).hmacSha1;
class $2c52f391c94dc662$export$2bd61c0866eee75e extends TransformStream {
    constructor({ password: password, signed: signed, encryptionStrength: encryptionStrength }){
        super({
            start () {
                Object.assign(this, {
                    ready: new Promise((resolve)=>this.resolveReady = resolve),
                    password: password,
                    signed: signed,
                    strength: encryptionStrength - 1,
                    pending: new Uint8Array()
                });
            },
            async transform (chunk, controller) {
                const aesCrypto = this;
                const { password: password, strength: strength, resolveReady: resolveReady, ready: ready } = aesCrypto;
                if (password) {
                    await $2c52f391c94dc662$var$createDecryptionKeys(aesCrypto, strength, password, $2c52f391c94dc662$var$subarray(chunk, 0, $2c52f391c94dc662$var$SALT_LENGTH[strength] + 2));
                    chunk = $2c52f391c94dc662$var$subarray(chunk, $2c52f391c94dc662$var$SALT_LENGTH[strength] + 2);
                    resolveReady();
                } else await ready;
                const output = new Uint8Array(chunk.length - $2c52f391c94dc662$var$SIGNATURE_LENGTH - (chunk.length - $2c52f391c94dc662$var$SIGNATURE_LENGTH) % $2c52f391c94dc662$var$BLOCK_LENGTH);
                controller.enqueue($2c52f391c94dc662$var$append(aesCrypto, chunk, output, 0, $2c52f391c94dc662$var$SIGNATURE_LENGTH, true));
            },
            async flush (controller) {
                const { signed: signed, ctr: ctr, hmac: hmac, pending: pending, ready: ready } = this;
                await ready;
                const chunkToDecrypt = $2c52f391c94dc662$var$subarray(pending, 0, pending.length - $2c52f391c94dc662$var$SIGNATURE_LENGTH);
                const originalSignature = $2c52f391c94dc662$var$subarray(pending, pending.length - $2c52f391c94dc662$var$SIGNATURE_LENGTH);
                let decryptedChunkArray = new Uint8Array();
                if (chunkToDecrypt.length) {
                    const encryptedChunk = $2c52f391c94dc662$var$toBits($2c52f391c94dc662$var$codecBytes, chunkToDecrypt);
                    hmac.update(encryptedChunk);
                    const decryptedChunk = ctr.update(encryptedChunk);
                    decryptedChunkArray = $2c52f391c94dc662$var$fromBits($2c52f391c94dc662$var$codecBytes, decryptedChunk);
                }
                if (signed) {
                    const signature = $2c52f391c94dc662$var$subarray($2c52f391c94dc662$var$fromBits($2c52f391c94dc662$var$codecBytes, hmac.digest()), 0, $2c52f391c94dc662$var$SIGNATURE_LENGTH);
                    for(let indexSignature = 0; indexSignature < $2c52f391c94dc662$var$SIGNATURE_LENGTH; indexSignature++){
                        if (signature[indexSignature] != originalSignature[indexSignature]) throw new Error((0, $b6d61903a29d25a0$export$ae8341b00030fc9d));
                    }
                }
                controller.enqueue(decryptedChunkArray);
            }
        });
    }
}
class $2c52f391c94dc662$export$5eab59cbcb1482d5 extends TransformStream {
    constructor({ password: password, encryptionStrength: encryptionStrength }){
        // deno-lint-ignore prefer-const
        let stream;
        super({
            start () {
                Object.assign(this, {
                    ready: new Promise((resolve)=>this.resolveReady = resolve),
                    password: password,
                    strength: encryptionStrength - 1,
                    pending: new Uint8Array()
                });
            },
            async transform (chunk, controller) {
                const aesCrypto = this;
                const { password: password, strength: strength, resolveReady: resolveReady, ready: ready } = aesCrypto;
                let preamble = new Uint8Array();
                if (password) {
                    preamble = await $2c52f391c94dc662$var$createEncryptionKeys(aesCrypto, strength, password);
                    resolveReady();
                } else await ready;
                const output = new Uint8Array(preamble.length + chunk.length - chunk.length % $2c52f391c94dc662$var$BLOCK_LENGTH);
                output.set(preamble, 0);
                controller.enqueue($2c52f391c94dc662$var$append(aesCrypto, chunk, output, preamble.length, 0));
            },
            async flush (controller) {
                const { ctr: ctr, hmac: hmac, pending: pending, ready: ready } = this;
                await ready;
                let encryptedChunkArray = new Uint8Array();
                if (pending.length) {
                    const encryptedChunk = ctr.update($2c52f391c94dc662$var$toBits($2c52f391c94dc662$var$codecBytes, pending));
                    hmac.update(encryptedChunk);
                    encryptedChunkArray = $2c52f391c94dc662$var$fromBits($2c52f391c94dc662$var$codecBytes, encryptedChunk);
                }
                stream.signature = $2c52f391c94dc662$var$fromBits($2c52f391c94dc662$var$codecBytes, hmac.digest()).slice(0, $2c52f391c94dc662$var$SIGNATURE_LENGTH);
                controller.enqueue($2c52f391c94dc662$var$concat(encryptedChunkArray, stream.signature));
            }
        });
        stream = this;
    }
}
function $2c52f391c94dc662$var$append(aesCrypto, input, output, paddingStart, paddingEnd, verifySignature) {
    const { ctr: ctr, hmac: hmac, pending: pending } = aesCrypto;
    const inputLength = input.length - paddingEnd;
    if (pending.length) {
        input = $2c52f391c94dc662$var$concat(pending, input);
        output = $2c52f391c94dc662$var$expand(output, inputLength - inputLength % $2c52f391c94dc662$var$BLOCK_LENGTH);
    }
    let offset;
    for(offset = 0; offset <= inputLength - $2c52f391c94dc662$var$BLOCK_LENGTH; offset += $2c52f391c94dc662$var$BLOCK_LENGTH){
        const inputChunk = $2c52f391c94dc662$var$toBits($2c52f391c94dc662$var$codecBytes, $2c52f391c94dc662$var$subarray(input, offset, offset + $2c52f391c94dc662$var$BLOCK_LENGTH));
        if (verifySignature) hmac.update(inputChunk);
        const outputChunk = ctr.update(inputChunk);
        if (!verifySignature) hmac.update(outputChunk);
        output.set($2c52f391c94dc662$var$fromBits($2c52f391c94dc662$var$codecBytes, outputChunk), offset + paddingStart);
    }
    aesCrypto.pending = $2c52f391c94dc662$var$subarray(input, offset);
    return output;
}
async function $2c52f391c94dc662$var$createDecryptionKeys(decrypt, strength, password, preamble) {
    const passwordVerificationKey = await $2c52f391c94dc662$var$createKeys(decrypt, strength, password, $2c52f391c94dc662$var$subarray(preamble, 0, $2c52f391c94dc662$var$SALT_LENGTH[strength]));
    const passwordVerification = $2c52f391c94dc662$var$subarray(preamble, $2c52f391c94dc662$var$SALT_LENGTH[strength]);
    if (passwordVerificationKey[0] != passwordVerification[0] || passwordVerificationKey[1] != passwordVerification[1]) throw new Error((0, $b6d61903a29d25a0$export$91dc8f5b62a122fd));
}
async function $2c52f391c94dc662$var$createEncryptionKeys(encrypt, strength, password) {
    const salt = (0, $b6d61903a29d25a0$export$960b9ff25e7d4257)(new Uint8Array($2c52f391c94dc662$var$SALT_LENGTH[strength]));
    const passwordVerification = await $2c52f391c94dc662$var$createKeys(encrypt, strength, password, salt);
    return $2c52f391c94dc662$var$concat(salt, passwordVerification);
}
async function $2c52f391c94dc662$var$createKeys(aesCrypto, strength, password, salt) {
    aesCrypto.password = null;
    const encodedPassword = (0, $ba4ced2ed37d6fed$export$7d0d7672e8a1c5cf)(password);
    const baseKey = await $2c52f391c94dc662$var$importKey($2c52f391c94dc662$var$RAW_FORMAT, encodedPassword, $2c52f391c94dc662$var$BASE_KEY_ALGORITHM, false, $2c52f391c94dc662$var$DERIVED_BITS_USAGE);
    const derivedBits = await $2c52f391c94dc662$var$deriveBits(Object.assign({
        salt: salt
    }, $2c52f391c94dc662$var$DERIVED_BITS_ALGORITHM), baseKey, 8 * ($2c52f391c94dc662$var$KEY_LENGTH[strength] * 2 + 2));
    const compositeKey = new Uint8Array(derivedBits);
    const key = $2c52f391c94dc662$var$toBits($2c52f391c94dc662$var$codecBytes, $2c52f391c94dc662$var$subarray(compositeKey, 0, $2c52f391c94dc662$var$KEY_LENGTH[strength]));
    const authentication = $2c52f391c94dc662$var$toBits($2c52f391c94dc662$var$codecBytes, $2c52f391c94dc662$var$subarray(compositeKey, $2c52f391c94dc662$var$KEY_LENGTH[strength], $2c52f391c94dc662$var$KEY_LENGTH[strength] * 2));
    const passwordVerification = $2c52f391c94dc662$var$subarray(compositeKey, $2c52f391c94dc662$var$KEY_LENGTH[strength] * 2);
    Object.assign(aesCrypto, {
        keys: {
            key: key,
            authentication: authentication,
            passwordVerification: passwordVerification
        },
        ctr: new $2c52f391c94dc662$var$CtrGladman(new $2c52f391c94dc662$var$Aes(key), Array.from($2c52f391c94dc662$var$COUNTER_DEFAULT_VALUE)),
        hmac: new $2c52f391c94dc662$var$HmacSha1(authentication)
    });
    return passwordVerification;
}
function $2c52f391c94dc662$var$importKey(format, password, algorithm, extractable, keyUsages) {
    if ($2c52f391c94dc662$var$IMPORT_KEY_SUPPORTED) return $2c52f391c94dc662$var$subtle.importKey(format, password, algorithm, extractable, keyUsages);
    else return (0, $7031d31a808888eb$export$5675c2f3af4366e2).importKey(password);
}
async function $2c52f391c94dc662$var$deriveBits(algorithm, baseKey, length) {
    if ($2c52f391c94dc662$var$DERIVE_BITS_SUPPORTED) return await $2c52f391c94dc662$var$subtle.deriveBits(algorithm, baseKey, length);
    else return (0, $7031d31a808888eb$export$5675c2f3af4366e2).pbkdf2(baseKey, algorithm.salt, $2c52f391c94dc662$var$DERIVED_BITS_ALGORITHM.iterations, length);
}
function $2c52f391c94dc662$var$concat(leftArray, rightArray) {
    let array = leftArray;
    if (leftArray.length + rightArray.length) {
        array = new Uint8Array(leftArray.length + rightArray.length);
        array.set(leftArray, 0);
        array.set(rightArray, leftArray.length);
    }
    return array;
}
function $2c52f391c94dc662$var$expand(inputArray, length) {
    if (length && length > inputArray.length) {
        const array = inputArray;
        inputArray = new Uint8Array(length);
        inputArray.set(array, 0);
    }
    return inputArray;
}
function $2c52f391c94dc662$var$subarray(array, begin, end) {
    return array.subarray(begin, end);
}
function $2c52f391c94dc662$var$fromBits(codecBytes, chunk) {
    return codecBytes.fromBits(chunk);
}
function $2c52f391c94dc662$var$toBits(codecBytes, chunk) {
    return codecBytes.toBits(chunk);
}


/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /* global TransformStream */ // deno-lint-ignore-file no-this-alias


const $5fa2f2bb2248cff4$var$HEADER_LENGTH = 12;
class $5fa2f2bb2248cff4$export$e544bedcbaacddb4 extends TransformStream {
    constructor({ password: password, passwordVerification: passwordVerification }){
        super({
            start () {
                Object.assign(this, {
                    password: password,
                    passwordVerification: passwordVerification
                });
                $5fa2f2bb2248cff4$var$createKeys(this, password);
            },
            transform (chunk, controller) {
                const zipCrypto = this;
                if (zipCrypto.password) {
                    const decryptedHeader = $5fa2f2bb2248cff4$var$decrypt(zipCrypto, chunk.subarray(0, $5fa2f2bb2248cff4$var$HEADER_LENGTH));
                    zipCrypto.password = null;
                    if (decryptedHeader[$5fa2f2bb2248cff4$var$HEADER_LENGTH - 1] != zipCrypto.passwordVerification) throw new Error((0, $b6d61903a29d25a0$export$91dc8f5b62a122fd));
                    chunk = chunk.subarray($5fa2f2bb2248cff4$var$HEADER_LENGTH);
                }
                controller.enqueue($5fa2f2bb2248cff4$var$decrypt(zipCrypto, chunk));
            }
        });
    }
}
class $5fa2f2bb2248cff4$export$6a553e0f48fe9272 extends TransformStream {
    constructor({ password: password, passwordVerification: passwordVerification }){
        super({
            start () {
                Object.assign(this, {
                    password: password,
                    passwordVerification: passwordVerification
                });
                $5fa2f2bb2248cff4$var$createKeys(this, password);
            },
            transform (chunk, controller) {
                const zipCrypto = this;
                let output;
                let offset;
                if (zipCrypto.password) {
                    zipCrypto.password = null;
                    const header = (0, $b6d61903a29d25a0$export$960b9ff25e7d4257)(new Uint8Array($5fa2f2bb2248cff4$var$HEADER_LENGTH));
                    header[$5fa2f2bb2248cff4$var$HEADER_LENGTH - 1] = zipCrypto.passwordVerification;
                    output = new Uint8Array(chunk.length + header.length);
                    output.set($5fa2f2bb2248cff4$var$encrypt(zipCrypto, header), 0);
                    offset = $5fa2f2bb2248cff4$var$HEADER_LENGTH;
                } else {
                    output = new Uint8Array(chunk.length);
                    offset = 0;
                }
                output.set($5fa2f2bb2248cff4$var$encrypt(zipCrypto, chunk), offset);
                controller.enqueue(output);
            }
        });
    }
}
function $5fa2f2bb2248cff4$var$decrypt(target, input) {
    const output = new Uint8Array(input.length);
    for(let index = 0; index < input.length; index++){
        output[index] = $5fa2f2bb2248cff4$var$getByte(target) ^ input[index];
        $5fa2f2bb2248cff4$var$updateKeys(target, output[index]);
    }
    return output;
}
function $5fa2f2bb2248cff4$var$encrypt(target, input) {
    const output = new Uint8Array(input.length);
    for(let index = 0; index < input.length; index++){
        output[index] = $5fa2f2bb2248cff4$var$getByte(target) ^ input[index];
        $5fa2f2bb2248cff4$var$updateKeys(target, input[index]);
    }
    return output;
}
function $5fa2f2bb2248cff4$var$createKeys(target, password) {
    const keys = [
        0x12345678,
        0x23456789,
        0x34567890
    ];
    Object.assign(target, {
        keys: keys,
        crcKey0: new (0, $7272846072e67247$export$16d8d62894c71747)(keys[0]),
        crcKey2: new (0, $7272846072e67247$export$16d8d62894c71747)(keys[2])
    });
    for(let index = 0; index < password.length; index++)$5fa2f2bb2248cff4$var$updateKeys(target, password.charCodeAt(index));
}
function $5fa2f2bb2248cff4$var$updateKeys(target, byte) {
    let [key0, key1, key2] = target.keys;
    target.crcKey0.append([
        byte
    ]);
    key0 = ~target.crcKey0.get();
    key1 = $5fa2f2bb2248cff4$var$getInt32(Math.imul($5fa2f2bb2248cff4$var$getInt32(key1 + $5fa2f2bb2248cff4$var$getInt8(key0)), 134775813) + 1);
    target.crcKey2.append([
        key1 >>> 24
    ]);
    key2 = ~target.crcKey2.get();
    target.keys = [
        key0,
        key1,
        key2
    ];
}
function $5fa2f2bb2248cff4$var$getByte(target) {
    const temp = target.keys[2] | 2;
    return $5fa2f2bb2248cff4$var$getInt8(Math.imul(temp, temp ^ 1) >>> 8);
}
function $5fa2f2bb2248cff4$var$getInt8(number) {
    return number & 0xFF;
}
function $5fa2f2bb2248cff4$var$getInt32(number) {
    return number & 0xFFFFFFFF;
}



const $bf23bffe8e4366ff$var$COMPRESSION_FORMAT = "deflate-raw";
class $bf23bffe8e4366ff$export$f23141db764e06fe extends TransformStream {
    constructor(options, { chunkSize: chunkSize, CompressionStream: CompressionStream, CompressionStreamNative: CompressionStreamNative }){
        super({});
        const { compressed: compressed, encrypted: encrypted, useCompressionStream: useCompressionStream, zipCrypto: zipCrypto, signed: signed, level: level } = options;
        const stream = this;
        let crc32Stream, encryptionStream;
        let readable = $bf23bffe8e4366ff$var$filterEmptyChunks(super.readable);
        if ((!encrypted || zipCrypto) && signed) {
            [readable, crc32Stream] = readable.tee();
            crc32Stream = $bf23bffe8e4366ff$var$pipeThrough(crc32Stream, new (0, $77e41b50431c57cf$export$b3cd3a37bd85e6ee)());
        }
        if (compressed) readable = $bf23bffe8e4366ff$var$pipeThroughCommpressionStream(readable, useCompressionStream, {
            level: level,
            chunkSize: chunkSize
        }, CompressionStreamNative, CompressionStream);
        if (encrypted) {
            if (zipCrypto) readable = $bf23bffe8e4366ff$var$pipeThrough(readable, new (0, $5fa2f2bb2248cff4$export$6a553e0f48fe9272)(options));
            else {
                encryptionStream = new (0, $2c52f391c94dc662$export$5eab59cbcb1482d5)(options);
                readable = $bf23bffe8e4366ff$var$pipeThrough(readable, encryptionStream);
            }
        }
        $bf23bffe8e4366ff$var$setReadable(stream, readable, async ()=>{
            let signature;
            if (encrypted && !zipCrypto) signature = encryptionStream.signature;
            if ((!encrypted || zipCrypto) && signed) {
                signature = await crc32Stream.getReader().read();
                signature = new DataView(signature.value.buffer).getUint32(0);
            }
            stream.signature = signature;
        });
    }
}
class $bf23bffe8e4366ff$export$12a3288b0c0341df extends TransformStream {
    constructor(options, { chunkSize: chunkSize, DecompressionStream: DecompressionStream, DecompressionStreamNative: DecompressionStreamNative }){
        super({});
        const { zipCrypto: zipCrypto, encrypted: encrypted, signed: signed, signature: signature, compressed: compressed, useCompressionStream: useCompressionStream } = options;
        let crc32Stream, decryptionStream;
        let readable = $bf23bffe8e4366ff$var$filterEmptyChunks(super.readable);
        if (encrypted) {
            if (zipCrypto) readable = $bf23bffe8e4366ff$var$pipeThrough(readable, new (0, $5fa2f2bb2248cff4$export$e544bedcbaacddb4)(options));
            else {
                decryptionStream = new (0, $2c52f391c94dc662$export$2bd61c0866eee75e)(options);
                readable = $bf23bffe8e4366ff$var$pipeThrough(readable, decryptionStream);
            }
        }
        if (compressed) readable = $bf23bffe8e4366ff$var$pipeThroughCommpressionStream(readable, useCompressionStream, {
            chunkSize: chunkSize
        }, DecompressionStreamNative, DecompressionStream);
        if ((!encrypted || zipCrypto) && signed) {
            [readable, crc32Stream] = readable.tee();
            crc32Stream = $bf23bffe8e4366ff$var$pipeThrough(crc32Stream, new (0, $77e41b50431c57cf$export$b3cd3a37bd85e6ee)());
        }
        $bf23bffe8e4366ff$var$setReadable(this, readable, async ()=>{
            if ((!encrypted || zipCrypto) && signed) {
                const streamSignature = await crc32Stream.getReader().read();
                const dataViewSignature = new DataView(streamSignature.value.buffer);
                if (signature != dataViewSignature.getUint32(0, false)) throw new Error((0, $b6d61903a29d25a0$export$ae8341b00030fc9d));
            }
        });
    }
}
function $bf23bffe8e4366ff$var$filterEmptyChunks(readable) {
    return $bf23bffe8e4366ff$var$pipeThrough(readable, new TransformStream({
        transform (chunk, controller) {
            if (chunk && chunk.length) controller.enqueue(chunk);
        }
    }));
}
function $bf23bffe8e4366ff$var$setReadable(stream, readable, flush) {
    readable = $bf23bffe8e4366ff$var$pipeThrough(readable, new TransformStream({
        flush: flush
    }));
    Object.defineProperty(stream, "readable", {
        get () {
            return readable;
        }
    });
}
function $bf23bffe8e4366ff$var$pipeThroughCommpressionStream(readable, useCompressionStream, options, CodecStreamNative, CodecStream) {
    try {
        const CompressionStream = useCompressionStream && CodecStreamNative ? CodecStreamNative : CodecStream;
        readable = $bf23bffe8e4366ff$var$pipeThrough(readable, new CompressionStream($bf23bffe8e4366ff$var$COMPRESSION_FORMAT, options));
    } catch (error) {
        if (useCompressionStream) readable = $bf23bffe8e4366ff$var$pipeThrough(readable, new CodecStream($bf23bffe8e4366ff$var$COMPRESSION_FORMAT, options));
        else throw error;
    }
    return readable;
}
function $bf23bffe8e4366ff$var$pipeThrough(readable, transformStream) {
    return readable.pipeThrough(transformStream);
}


const $fda7c3f883c12402$export$7b364f17ef2dca82 = "message";
const $fda7c3f883c12402$export$c443c9777d3a700 = "start";
const $fda7c3f883c12402$export$62b45386af1a69d6 = "pull";
const $fda7c3f883c12402$export$c026d075734dfa81 = "data";
const $fda7c3f883c12402$export$94f33f60a013531c = "ack";
const $fda7c3f883c12402$export$9ac33487a6b3f22b = "close";
const $fda7c3f883c12402$export$c8ea3b6e95d7ab36 = "deflate";
const $fda7c3f883c12402$export$1c8ed04f989a62a8 = "inflate";
class $fda7c3f883c12402$export$5b4e81abd8ae50b3 extends TransformStream {
    constructor(options, config){
        super({});
        const codec = this;
        const { codecType: codecType } = options;
        let Stream;
        if (codecType.startsWith($fda7c3f883c12402$export$c8ea3b6e95d7ab36)) Stream = (0, $bf23bffe8e4366ff$export$f23141db764e06fe);
        else if (codecType.startsWith($fda7c3f883c12402$export$1c8ed04f989a62a8)) Stream = (0, $bf23bffe8e4366ff$export$12a3288b0c0341df);
        let size = 0;
        const stream = new Stream(options, config);
        const readable = super.readable;
        const transformStream = new TransformStream({
            transform (chunk, controller) {
                if (chunk && chunk.length) {
                    size += chunk.length;
                    controller.enqueue(chunk);
                }
            },
            flush () {
                const { signature: signature } = stream;
                Object.assign(codec, {
                    signature: signature,
                    size: size
                });
            }
        });
        Object.defineProperty(codec, "readable", {
            get () {
                return readable.pipeThrough(stream).pipeThrough(transformStream);
            }
        });
    }
}


/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /* global Worker, URL, TransformStream, WritableStream */ 

// deno-lint-ignore valid-typeof
const $8b1939cbc48e5442$var$WEB_WORKERS_SUPPORTED = typeof Worker != (0, $0302f6c577bd011b$export$817d840279c95122);
class $8b1939cbc48e5442$export$fca1864ffae7c17d {
    constructor(workerData, { readable: readable, writable: writable }, { options: options, config: config, streamOptions: streamOptions, useWebWorkers: useWebWorkers, transferStreams: transferStreams, scripts: scripts }, onTaskFinished){
        const { signal: signal } = streamOptions;
        Object.assign(workerData, {
            busy: true,
            readable: readable.pipeThrough(new $8b1939cbc48e5442$var$ProgressWatcherStream(readable, streamOptions, config), {
                signal: signal
            }),
            writable: writable,
            options: Object.assign({}, options),
            scripts: scripts,
            transferStreams: transferStreams,
            terminate () {
                const { worker: worker, busy: busy } = workerData;
                if (worker && !busy) {
                    worker.terminate();
                    workerData.interface = null;
                }
            },
            onTaskFinished () {
                workerData.busy = false;
                onTaskFinished(workerData);
            }
        });
        return (useWebWorkers && $8b1939cbc48e5442$var$WEB_WORKERS_SUPPORTED ? $8b1939cbc48e5442$var$createWebWorkerInterface : $8b1939cbc48e5442$var$createWorkerInterface)(workerData, config);
    }
}
class $8b1939cbc48e5442$var$ProgressWatcherStream extends TransformStream {
    constructor(readableSource, { onstart: onstart, onprogress: onprogress, size: size, onend: onend }, { chunkSize: chunkSize }){
        let chunkOffset = 0;
        super({
            start () {
                if (onstart) $8b1939cbc48e5442$var$callHandler(onstart, size);
            },
            async transform (chunk, controller) {
                chunkOffset += chunk.length;
                if (onprogress) await $8b1939cbc48e5442$var$callHandler(onprogress, chunkOffset, size);
                controller.enqueue(chunk);
            },
            flush () {
                readableSource.size = chunkOffset;
                if (onend) $8b1939cbc48e5442$var$callHandler(onend, chunkOffset);
            }
        }, {
            highWaterMark: 1,
            size: ()=>chunkSize
        });
    }
}
async function $8b1939cbc48e5442$var$callHandler(handler, ...parameters) {
    try {
        await handler(...parameters);
    } catch (_error) {
    // ignored
    }
}
function $8b1939cbc48e5442$var$createWorkerInterface(workerData, config) {
    return {
        run: ()=>$8b1939cbc48e5442$var$runWorker(workerData, config)
    };
}
function $8b1939cbc48e5442$var$createWebWorkerInterface(workerData, { baseURL: baseURL, chunkSize: chunkSize }) {
    if (!workerData.interface) Object.assign(workerData, {
        worker: $8b1939cbc48e5442$var$getWebWorker(workerData.scripts[0], baseURL, workerData),
        interface: {
            run: ()=>$8b1939cbc48e5442$var$runWebWorker(workerData, {
                    chunkSize: chunkSize
                })
        }
    });
    return workerData.interface;
}
async function $8b1939cbc48e5442$var$runWorker({ options: options, readable: readable, writable: writable, onTaskFinished: onTaskFinished }, config) {
    const codecStream = new (0, $fda7c3f883c12402$export$5b4e81abd8ae50b3)(options, config);
    try {
        await readable.pipeThrough(codecStream).pipeTo(writable, {
            preventClose: true,
            preventAbort: true
        });
        const { signature: signature, size: size } = codecStream;
        return {
            signature: signature,
            size: size
        };
    } finally{
        onTaskFinished();
    }
}
async function $8b1939cbc48e5442$var$runWebWorker(workerData, config) {
    let resolveResult, rejectResult;
    const result = new Promise((resolve, reject)=>{
        resolveResult = resolve;
        rejectResult = reject;
    });
    Object.assign(workerData, {
        reader: null,
        writer: null,
        resolveResult: resolveResult,
        rejectResult: rejectResult,
        result: result
    });
    const { readable: readable, options: options, scripts: scripts } = workerData;
    const { writable: writable, closed: closed } = $8b1939cbc48e5442$var$watchClosedStream(workerData.writable);
    const streamsTransferred = $8b1939cbc48e5442$var$sendMessage({
        type: (0, $fda7c3f883c12402$export$c443c9777d3a700),
        scripts: scripts.slice(1),
        options: options,
        config: config,
        readable: readable,
        writable: writable
    }, workerData);
    if (!streamsTransferred) Object.assign(workerData, {
        reader: readable.getReader(),
        writer: writable.getWriter()
    });
    const resultValue = await result;
    try {
        await writable.close();
    } catch (_error) {
    // ignored
    }
    await closed;
    return resultValue;
}
function $8b1939cbc48e5442$var$watchClosedStream(writableSource) {
    const writer = writableSource.getWriter();
    let resolveStreamClosed;
    const closed = new Promise((resolve)=>resolveStreamClosed = resolve);
    const writable = new WritableStream({
        async write (chunk) {
            await writer.ready;
            await writer.write(chunk);
        },
        close () {
            writer.releaseLock();
            resolveStreamClosed();
        },
        abort (reason) {
            return writer.abort(reason);
        }
    });
    return {
        writable: writable,
        closed: closed
    };
}
let $8b1939cbc48e5442$var$classicWorkersSupported = true;
let $8b1939cbc48e5442$var$transferStreamsSupported = true;
function $8b1939cbc48e5442$var$getWebWorker(url, baseURL, workerData) {
    const workerOptions = {
        type: "module"
    };
    let scriptUrl, worker;
    // deno-lint-ignore valid-typeof
    if (typeof url == (0, $0302f6c577bd011b$export$31a3bc04c4494acf)) url = url();
    try {
        scriptUrl = new URL(url, baseURL);
    } catch (_error) {
        scriptUrl = url;
    }
    if ($8b1939cbc48e5442$var$classicWorkersSupported) try {
        worker = new Worker(scriptUrl);
    } catch (_error) {
        $8b1939cbc48e5442$var$classicWorkersSupported = false;
        worker = new Worker(scriptUrl, workerOptions);
    }
    else worker = new Worker(scriptUrl, workerOptions);
    worker.addEventListener((0, $fda7c3f883c12402$export$7b364f17ef2dca82), (event)=>$8b1939cbc48e5442$var$onMessage(event, workerData));
    return worker;
}
function $8b1939cbc48e5442$var$sendMessage(message, { worker: worker, writer: writer, onTaskFinished: onTaskFinished, transferStreams: transferStreams }) {
    try {
        let { value: value, readable: readable, writable: writable } = message;
        const transferables = [];
        if (value) {
            const { buffer: buffer, length: length } = value;
            if (length != buffer.byteLength) value = new Uint8Array(value);
            message.value = value.buffer;
            transferables.push(message.value);
        }
        if (transferStreams && $8b1939cbc48e5442$var$transferStreamsSupported) {
            if (readable) transferables.push(readable);
            if (writable) transferables.push(writable);
        } else message.readable = message.writable = null;
        if (transferables.length) try {
            worker.postMessage(message, transferables);
            return true;
        } catch (_error) {
            $8b1939cbc48e5442$var$transferStreamsSupported = false;
            message.readable = message.writable = null;
            worker.postMessage(message);
        }
        else worker.postMessage(message);
    } catch (error) {
        if (writer) writer.releaseLock();
        onTaskFinished();
        throw error;
    }
}
async function $8b1939cbc48e5442$var$onMessage({ data: data }, workerData) {
    const { type: type, value: value, messageId: messageId, result: result, error: error } = data;
    const { reader: reader, writer: writer, resolveResult: resolveResult, rejectResult: rejectResult, onTaskFinished: onTaskFinished } = workerData;
    try {
        if (error) {
            const { message: message, stack: stack, code: code, name: name } = error;
            const responseError = new Error(message);
            Object.assign(responseError, {
                stack: stack,
                code: code,
                name: name
            });
            close(responseError);
        } else {
            if (type == (0, $fda7c3f883c12402$export$62b45386af1a69d6)) {
                const { value: value, done: done } = await reader.read();
                $8b1939cbc48e5442$var$sendMessage({
                    type: (0, $fda7c3f883c12402$export$c026d075734dfa81),
                    value: value,
                    done: done,
                    messageId: messageId
                }, workerData);
            }
            if (type == (0, $fda7c3f883c12402$export$c026d075734dfa81)) {
                await writer.ready;
                await writer.write(new Uint8Array(value));
                $8b1939cbc48e5442$var$sendMessage({
                    type: (0, $fda7c3f883c12402$export$94f33f60a013531c),
                    messageId: messageId
                }, workerData);
            }
            if (type == (0, $fda7c3f883c12402$export$9ac33487a6b3f22b)) close(null, result);
        }
    } catch (error) {
        close(error);
    }
    function close(error, result) {
        if (error) rejectResult(error);
        else resolveResult(result);
        if (writer) writer.releaseLock();
        onTaskFinished();
    }
}


let $2f7887a251aac91a$var$pool = [];
const $2f7887a251aac91a$var$pendingRequests = [];
let $2f7887a251aac91a$var$indexWorker = 0;
async function $2f7887a251aac91a$export$dd2e08b4a54c623f(stream, workerOptions) {
    const { options: options, config: config } = workerOptions;
    const { transferStreams: transferStreams, useWebWorkers: useWebWorkers, useCompressionStream: useCompressionStream, codecType: codecType, compressed: compressed, signed: signed, encrypted: encrypted } = options;
    const { workerScripts: workerScripts, maxWorkers: maxWorkers, terminateWorkerTimeout: terminateWorkerTimeout } = config;
    workerOptions.transferStreams = transferStreams || transferStreams === (0, $0302f6c577bd011b$export$a43287864529b8fd);
    const streamCopy = !compressed && !signed && !encrypted && !workerOptions.transferStreams;
    workerOptions.useWebWorkers = !streamCopy && (useWebWorkers || useWebWorkers === (0, $0302f6c577bd011b$export$a43287864529b8fd) && config.useWebWorkers);
    workerOptions.scripts = workerOptions.useWebWorkers && workerScripts ? workerScripts[codecType] : [];
    options.useCompressionStream = useCompressionStream || useCompressionStream === (0, $0302f6c577bd011b$export$a43287864529b8fd) && config.useCompressionStream;
    let worker;
    const workerData = $2f7887a251aac91a$var$pool.find((workerData)=>!workerData.busy);
    if (workerData) {
        $2f7887a251aac91a$var$clearTerminateTimeout(workerData);
        worker = new (0, $8b1939cbc48e5442$export$fca1864ffae7c17d)(workerData, stream, workerOptions, onTaskFinished);
    } else if ($2f7887a251aac91a$var$pool.length < maxWorkers) {
        const workerData = {
            indexWorker: $2f7887a251aac91a$var$indexWorker
        };
        $2f7887a251aac91a$var$indexWorker++;
        $2f7887a251aac91a$var$pool.push(workerData);
        worker = new (0, $8b1939cbc48e5442$export$fca1864ffae7c17d)(workerData, stream, workerOptions, onTaskFinished);
    } else worker = await new Promise((resolve)=>$2f7887a251aac91a$var$pendingRequests.push({
            resolve: resolve,
            stream: stream,
            workerOptions: workerOptions
        }));
    return worker.run();
    function onTaskFinished(workerData) {
        if ($2f7887a251aac91a$var$pendingRequests.length) {
            const [{ resolve: resolve, stream: stream, workerOptions: workerOptions }] = $2f7887a251aac91a$var$pendingRequests.splice(0, 1);
            resolve(new (0, $8b1939cbc48e5442$export$fca1864ffae7c17d)(workerData, stream, workerOptions, onTaskFinished));
        } else if (workerData.worker) {
            $2f7887a251aac91a$var$clearTerminateTimeout(workerData);
            if (Number.isFinite(terminateWorkerTimeout) && terminateWorkerTimeout >= 0) workerData.terminateTimeout = setTimeout(()=>{
                $2f7887a251aac91a$var$pool = $2f7887a251aac91a$var$pool.filter((data)=>data != workerData);
                workerData.terminate();
            }, terminateWorkerTimeout);
        } else $2f7887a251aac91a$var$pool = $2f7887a251aac91a$var$pool.filter((data)=>data != workerData);
    }
}
function $2f7887a251aac91a$var$clearTerminateTimeout(workerData) {
    const { terminateTimeout: terminateTimeout } = workerData;
    if (terminateTimeout) {
        clearTimeout(terminateTimeout);
        workerData.terminateTimeout = null;
    }
}
function $2f7887a251aac91a$export$797d499998d6363b() {
    $2f7887a251aac91a$var$pool.forEach((workerData)=>{
        $2f7887a251aac91a$var$clearTerminateTimeout(workerData);
        workerData.terminate();
    });
}


/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ 
function $9a9cdc2e4ebf7a3a$export$2bee588cb9b7b41d(e) {
    const t = ()=>URL.createObjectURL(new Blob([
            'const{Array:e,Object:t,Number:n,Math:r,Error:s,Uint8Array:i,Uint16Array:o,Uint32Array:c,Int32Array:f,Map:a,DataView:l,Promise:u,TextEncoder:w,crypto:h,postMessage:d,TransformStream:p,ReadableStream:y,WritableStream:m,CompressionStream:b,DecompressionStream:g}=self;class k{constructor(e){return class extends p{constructor(t,n){const r=new e(n);super({transform(e,t){t.enqueue(r.append(e))},flush(e){const t=r.flush();t&&e.enqueue(t)}})}}}}const v=[];for(let e=0;256>e;e++){let t=e;for(let e=0;8>e;e++)1&t?t=t>>>1^3988292384:t>>>=1;v[e]=t}class S{constructor(e){this.t=e||-1}append(e){let t=0|this.t;for(let n=0,r=0|e.length;r>n;n++)t=t>>>8^v[255&(t^e[n])];this.t=t}get(){return~this.t}}class z extends p{constructor(){const e=new S;super({transform(t){e.append(t)},flush(t){const n=new i(4);new l(n.buffer).setUint32(0,e.get()),t.enqueue(n)}})}}const _={concat(e,t){if(0===e.length||0===t.length)return e.concat(t);const n=e[e.length-1],r=_.i(n);return 32===r?e.concat(t):_.o(t,r,0|n,e.slice(0,e.length-1))},l(e){const t=e.length;if(0===t)return 0;const n=e[t-1];return 32*(t-1)+_.i(n)},u(e,t){if(32*e.length<t)return e;const n=(e=e.slice(0,r.ceil(t/32))).length;return t&=31,n>0&&t&&(e[n-1]=_.h(t,e[n-1]&2147483648>>t-1,1)),e},h:(e,t,n)=>32===e?t:(n?0|t:t<<32-e)+1099511627776*e,i:e=>r.round(e/1099511627776)||32,o(e,t,n,r){for(void 0===r&&(r=[]);t>=32;t-=32)r.push(n),n=0;if(0===t)return r.concat(e);for(let s=0;s<e.length;s++)r.push(n|e[s]>>>t),n=e[s]<<32-t;const s=e.length?e[e.length-1]:0,i=_.i(s);return r.push(_.h(t+i&31,t+i>32?n:r.pop(),1)),r}},C={p:{m(e){const t=_.l(e)/8,n=new i(t);let r;for(let s=0;t>s;s++)0==(3&s)&&(r=e[s/4]),n[s]=r>>>24,r<<=8;return n},g(e){const t=[];let n,r=0;for(n=0;n<e.length;n++)r=r<<8|e[n],3==(3&n)&&(t.push(r),r=0);return 3&n&&t.push(_.h(8*(3&n),r)),t}}},I={k:function(e){e?(this.v=e.v.slice(0),this.S=e.S.slice(0),this._=e._):this.reset()}};I.k.prototype={blockSize:512,reset(){const e=this;return e.v=this.C.slice(0),e.S=[],e._=0,e},update(e){const t=this;"string"==typeof e&&(e=C.I.g(e));const n=t.S=_.concat(t.S,e),r=t._,i=t._=r+_.l(e);if(i>9007199254740991)throw new s("Cannot hash more than 2^53 - 1 bits");const o=new c(n);let f=0;for(let e=t.blockSize+r-(t.blockSize+r&t.blockSize-1);i>=e;e+=t.blockSize)t.A(o.subarray(16*f,16*(f+1))),f+=1;return n.splice(0,16*f),t},D(){const e=this;let t=e.S;const n=e.v;t=_.concat(t,[_.h(1,1)]);for(let e=t.length+2;15&e;e++)t.push(0);for(t.push(r.floor(e._/4294967296)),t.push(0|e._);t.length;)e.A(t.splice(0,16));return e.reset(),n},C:[1732584193,4023233417,2562383102,271733878,3285377520],V:[1518500249,1859775393,2400959708,3395469782],R:(e,t,n,r)=>e>19?e>39?e>59?e>79?void 0:t^n^r:t&n|t&r|n&r:t^n^r:t&n|~t&r,B:(e,t)=>t<<e|t>>>32-e,A(t){const n=this,s=n.v,i=e(80);for(let e=0;16>e;e++)i[e]=t[e];let o=s[0],c=s[1],f=s[2],a=s[3],l=s[4];for(let e=0;79>=e;e++){16>e||(i[e]=n.B(1,i[e-3]^i[e-8]^i[e-14]^i[e-16]));const t=n.B(5,o)+n.R(e,c,f,a)+l+i[e]+n.V[r.floor(e/20)]|0;l=a,a=f,f=n.B(30,c),c=o,o=t}s[0]=s[0]+o|0,s[1]=s[1]+c|0,s[2]=s[2]+f|0,s[3]=s[3]+a|0,s[4]=s[4]+l|0}};const x={getRandomValues(e){const t=new c(e.buffer),n=e=>{let t=987654321;const n=4294967295;return()=>(t=36969*(65535&t)+(t>>16)&n,(((t<<16)+(e=18e3*(65535&e)+(e>>16)&n)&n)/4294967296+.5)*(r.random()>.5?1:-1))};for(let s,i=0;i<e.length;i+=4){const e=n(4294967296*(s||r.random()));s=987654071*e(),t[i/4]=4294967296*e()|0}return e}},A={importKey:e=>new A.M(C.p.g(e)),K(e,t,n,r){if(n=n||1e4,0>r||0>n)throw new s("invalid params to pbkdf2");const i=1+(r>>5)<<2;let o,c,f,a,u;const w=new ArrayBuffer(i),h=new l(w);let d=0;const p=_;for(t=C.p.g(t),u=1;(i||1)>d;u++){for(o=c=e.encrypt(p.concat(t,[u])),f=1;n>f;f++)for(c=e.encrypt(c),a=0;a<c.length;a++)o[a]^=c[a];for(f=0;(i||1)>d&&f<o.length;f++)h.setInt32(d,o[f]),d+=4}return w.slice(0,r/8)},M:class{constructor(e){const t=this,n=t.P=I.k,r=[[],[]],s=n.prototype.blockSize/32;t.U=[new n,new n],e.length>s&&(e=n.hash(e));for(let t=0;s>t;t++)r[0][t]=909522486^e[t],r[1][t]=1549556828^e[t];t.U[0].update(r[0]),t.U[1].update(r[1]),t.N=new n(t.U[0])}reset(){const e=this;e.N=new e.P(e.U[0]),e.T=!1}update(e){this.T=!0,this.N.update(e)}digest(){const e=this,t=e.N.D(),n=new e.P(e.U[1]).update(t).D();return e.reset(),n}encrypt(e){if(this.T)throw new s("encrypt on already updated hmac called!");return this.update(e),this.digest(e)}}},D=void 0!==h&&"function"==typeof h.getRandomValues;function V(e){return D?h.getRandomValues(e):x.getRandomValues(e)}const R={name:"PBKDF2"},B=t.assign({hash:{name:"HMAC"}},R),E=t.assign({iterations:1e3,hash:{name:"SHA-1"}},R),M=["deriveBits"],K=[8,12,16],P=[16,24,32],U=[0,0,0,0],N=void 0!==h,T=N&&h.subtle,W=N&&void 0!==T,H=N&&W&&"function"==typeof T.importKey,L=N&&W&&"function"==typeof T.deriveBits,j=C.p,F=class{constructor(e){const t=this;t.W=[[[],[],[],[],[]],[[],[],[],[],[]]],t.W[0][0][0]||t.H();const n=t.W[0][4],r=t.W[1],i=e.length;let o,c,f,a=1;if(4!==i&&6!==i&&8!==i)throw new s("invalid aes key size");for(t.V=[c=e.slice(0),f=[]],o=i;4*i+28>o;o++){let e=c[o-1];(o%i==0||8===i&&o%i==4)&&(e=n[e>>>24]<<24^n[e>>16&255]<<16^n[e>>8&255]<<8^n[255&e],o%i==0&&(e=e<<8^e>>>24^a<<24,a=a<<1^283*(a>>7))),c[o]=c[o-i]^e}for(let e=0;o;e++,o--){const t=c[3&e?o:o-4];f[e]=4>=o||4>e?t:r[0][n[t>>>24]]^r[1][n[t>>16&255]]^r[2][n[t>>8&255]]^r[3][n[255&t]]}}encrypt(e){return this.L(e,0)}decrypt(e){return this.L(e,1)}H(){const e=this.W[0],t=this.W[1],n=e[4],r=t[4],s=[],i=[];let o,c,f,a;for(let e=0;256>e;e++)i[(s[e]=e<<1^283*(e>>7))^e]=e;for(let l=o=0;!n[l];l^=c||1,o=i[o]||1){let i=o^o<<1^o<<2^o<<3^o<<4;i=i>>8^255&i^99,n[l]=i,r[i]=l,a=s[f=s[c=s[l]]];let u=16843009*a^65537*f^257*c^16843008*l,w=257*s[i]^16843008*i;for(let n=0;4>n;n++)e[n][l]=w=w<<24^w>>>8,t[n][i]=u=u<<24^u>>>8}for(let n=0;5>n;n++)e[n]=e[n].slice(0),t[n]=t[n].slice(0)}L(e,t){if(4!==e.length)throw new s("invalid aes block size");const n=this.V[t],r=n.length/4-2,i=[0,0,0,0],o=this.W[t],c=o[0],f=o[1],a=o[2],l=o[3],u=o[4];let w,h,d,p=e[0]^n[0],y=e[t?3:1]^n[1],m=e[2]^n[2],b=e[t?1:3]^n[3],g=4;for(let e=0;r>e;e++)w=c[p>>>24]^f[y>>16&255]^a[m>>8&255]^l[255&b]^n[g],h=c[y>>>24]^f[m>>16&255]^a[b>>8&255]^l[255&p]^n[g+1],d=c[m>>>24]^f[b>>16&255]^a[p>>8&255]^l[255&y]^n[g+2],b=c[b>>>24]^f[p>>16&255]^a[y>>8&255]^l[255&m]^n[g+3],g+=4,p=w,y=h,m=d;for(let e=0;4>e;e++)i[t?3&-e:e]=u[p>>>24]<<24^u[y>>16&255]<<16^u[m>>8&255]<<8^u[255&b]^n[g++],w=p,p=y,y=m,m=b,b=w;return i}},O=class{constructor(e,t){this.j=e,this.F=t,this.O=t}reset(){this.O=this.F}update(e){return this.q(this.j,e,this.O)}G(e){if(255==(e>>24&255)){let t=e>>16&255,n=e>>8&255,r=255&e;255===t?(t=0,255===n?(n=0,255===r?r=0:++r):++n):++t,e=0,e+=t<<16,e+=n<<8,e+=r}else e+=1<<24;return e}J(e){0===(e[0]=this.G(e[0]))&&(e[1]=this.G(e[1]))}q(e,t,n){let r;if(!(r=t.length))return[];const s=_.l(t);for(let s=0;r>s;s+=4){this.J(n);const r=e.encrypt(n);t[s]^=r[0],t[s+1]^=r[1],t[s+2]^=r[2],t[s+3]^=r[3]}return _.u(t,s)}},q=A.M;class G extends p{constructor({password:e,signed:n,encryptionStrength:r}){super({start(){t.assign(this,{ready:new u((e=>this.X=e)),password:e,signed:n,Y:r-1,pending:new i})},async transform(e,t){const n=this,{password:r,Y:o,X:c,ready:f}=n;r?(await(async(e,t,n,r)=>{const i=await X(e,t,n,Z(r,0,K[t])),o=Z(r,K[t]);if(i[0]!=o[0]||i[1]!=o[1])throw new s("Invalid password")})(n,o,r,Z(e,0,K[o]+2)),e=Z(e,K[o]+2),c()):await f;const a=new i(e.length-10-(e.length-10)%16);t.enqueue(Q(n,e,a,0,10,!0))},async flush(e){const{signed:t,Z:n,$:r,pending:o,ready:c}=this;await c;const f=Z(o,0,o.length-10),a=Z(o,o.length-10);let l=new i;if(f.length){const e=ee(j,f);r.update(e);const t=n.update(e);l=$(j,t)}if(t){const e=Z($(j,r.digest()),0,10);for(let t=0;10>t;t++)if(e[t]!=a[t])throw new s("Invalid signature")}e.enqueue(l)}})}}class J extends p{constructor({password:e,encryptionStrength:n}){let r;super({start(){t.assign(this,{ready:new u((e=>this.X=e)),password:e,Y:n-1,pending:new i})},async transform(e,t){const n=this,{password:r,Y:s,X:o,ready:c}=n;let f=new i;r?(f=await(async(e,t,n)=>{const r=V(new i(K[t]));return Y(r,await X(e,t,n,r))})(n,s,r),o()):await c;const a=new i(f.length+e.length-e.length%16);a.set(f,0),t.enqueue(Q(n,e,a,f.length,0))},async flush(e){const{Z:t,$:n,pending:s,ready:o}=this;await o;let c=new i;if(s.length){const e=t.update(ee(j,s));n.update(e),c=$(j,e)}r.signature=$(j,n.digest()).slice(0,10),e.enqueue(Y(c,r.signature))}}),r=this}}function Q(e,t,n,r,s,o){const{Z:c,$:f,pending:a}=e,l=t.length-s;let u;for(a.length&&(t=Y(a,t),n=((e,t)=>{if(t&&t>e.length){const n=e;(e=new i(t)).set(n,0)}return e})(n,l-l%16)),u=0;l-16>=u;u+=16){const e=ee(j,Z(t,u,u+16));o&&f.update(e);const s=c.update(e);o||f.update(s),n.set($(j,s),u+r)}return e.pending=Z(t,u),n}async function X(n,r,s,o){n.password=null;const c=(e=>{if(void 0===w){const t=new i((e=unescape(encodeURIComponent(e))).length);for(let n=0;n<t.length;n++)t[n]=e.charCodeAt(n);return t}return(new w).encode(e)})(s),f=await((e,t,n,r,s)=>H?T.importKey("raw",t,n,!1,s):A.importKey(t))(0,c,B,0,M),a=await(async(e,t,n)=>L?await T.deriveBits(e,t,n):A.K(t,e.salt,E.iterations,n))(t.assign({salt:o},E),f,8*(2*P[r]+2)),l=new i(a),u=ee(j,Z(l,0,P[r])),h=ee(j,Z(l,P[r],2*P[r])),d=Z(l,2*P[r]);return t.assign(n,{keys:{key:u,ee:h,passwordVerification:d},Z:new O(new F(u),e.from(U)),$:new q(h)}),d}function Y(e,t){let n=e;return e.length+t.length&&(n=new i(e.length+t.length),n.set(e,0),n.set(t,e.length)),n}function Z(e,t,n){return e.subarray(t,n)}function $(e,t){return e.m(t)}function ee(e,t){return e.g(t)}class te extends p{constructor({password:e,passwordVerification:n}){super({start(){t.assign(this,{password:e,passwordVerification:n}),ie(this,e)},transform(e,t){const n=this;if(n.password){const t=re(n,e.subarray(0,12));if(n.password=null,t[11]!=n.passwordVerification)throw new s("Invalid password");e=e.subarray(12)}t.enqueue(re(n,e))}})}}class ne extends p{constructor({password:e,passwordVerification:n}){super({start(){t.assign(this,{password:e,passwordVerification:n}),ie(this,e)},transform(e,t){const n=this;let r,s;if(n.password){n.password=null;const t=V(new i(12));t[11]=n.passwordVerification,r=new i(e.length+t.length),r.set(se(n,t),0),s=12}else r=new i(e.length),s=0;r.set(se(n,e),s),t.enqueue(r)}})}}function re(e,t){const n=new i(t.length);for(let r=0;r<t.length;r++)n[r]=ce(e)^t[r],oe(e,n[r]);return n}function se(e,t){const n=new i(t.length);for(let r=0;r<t.length;r++)n[r]=ce(e)^t[r],oe(e,t[r]);return n}function ie(e,n){const r=[305419896,591751049,878082192];t.assign(e,{keys:r,te:new S(r[0]),ne:new S(r[2])});for(let t=0;t<n.length;t++)oe(e,n.charCodeAt(t))}function oe(e,t){let[n,s,i]=e.keys;e.te.append([t]),n=~e.te.get(),s=ae(r.imul(ae(s+fe(n)),134775813)+1),e.ne.append([s>>>24]),i=~e.ne.get(),e.keys=[n,s,i]}function ce(e){const t=2|e.keys[2];return fe(r.imul(t,1^t)>>>8)}function fe(e){return 255&e}function ae(e){return 4294967295&e}class le extends p{constructor(e,{chunkSize:t,CompressionStream:n,CompressionStreamNative:r}){super({});const{compressed:s,encrypted:i,useCompressionStream:o,zipCrypto:c,signed:f,level:a}=e,u=this;let w,h,d=we(super.readable);i&&!c||!f||([d,w]=d.tee(),w=pe(w,new z)),s&&(d=de(d,o,{level:a,chunkSize:t},r,n)),i&&(c?d=pe(d,new ne(e)):(h=new J(e),d=pe(d,h))),he(u,d,(async()=>{let e;i&&!c&&(e=h.signature),i&&!c||!f||(e=await w.getReader().read(),e=new l(e.value.buffer).getUint32(0)),u.signature=e}))}}class ue extends p{constructor(e,{chunkSize:t,DecompressionStream:n,DecompressionStreamNative:r}){super({});const{zipCrypto:i,encrypted:o,signed:c,signature:f,compressed:a,useCompressionStream:u}=e;let w,h,d=we(super.readable);o&&(i?d=pe(d,new te(e)):(h=new G(e),d=pe(d,h))),a&&(d=de(d,u,{chunkSize:t},r,n)),o&&!i||!c||([d,w]=d.tee(),w=pe(w,new z)),he(this,d,(async()=>{if((!o||i)&&c){const e=await w.getReader().read(),t=new l(e.value.buffer);if(f!=t.getUint32(0,!1))throw new s("Invalid signature")}}))}}function we(e){return pe(e,new p({transform(e,t){e&&e.length&&t.enqueue(e)}}))}function he(e,n,r){n=pe(n,new p({flush:r})),t.defineProperty(e,"readable",{get:()=>n})}function de(e,t,n,r,s){try{e=pe(e,new(t&&r?r:s)("deflate-raw",n))}catch(r){if(!t)throw r;e=pe(e,new s("deflate-raw",n))}return e}function pe(e,t){return e.pipeThrough(t)}class ye extends p{constructor(e,n){super({});const r=this,{codecType:s}=e;let i;s.startsWith("deflate")?i=le:s.startsWith("inflate")&&(i=ue);let o=0;const c=new i(e,n),f=super.readable,a=new p({transform(e,t){e&&e.length&&(o+=e.length,t.enqueue(e))},flush(){const{signature:e}=c;t.assign(r,{signature:e,size:o})}});t.defineProperty(r,"readable",{get:()=>f.pipeThrough(c).pipeThrough(a)})}}const me=new a,be=new a;let ge=0;async function ke(e){try{const{options:t,scripts:r,config:s}=e;r&&r.length&&importScripts.apply(void 0,r),self.initCodec&&self.initCodec(),s.CompressionStreamNative=self.CompressionStream,s.DecompressionStreamNative=self.DecompressionStream,self.Deflate&&(s.CompressionStream=new k(self.Deflate)),self.Inflate&&(s.DecompressionStream=new k(self.Inflate));const i={highWaterMark:1,size:()=>s.chunkSize},o=e.readable||new y({async pull(e){const t=new u((e=>me.set(ge,e)));ve({type:"pull",messageId:ge}),ge=(ge+1)%n.MAX_SAFE_INTEGER;const{value:r,done:s}=await t;e.enqueue(r),s&&e.close()}},i),c=e.writable||new m({async write(e){let t;const r=new u((e=>t=e));be.set(ge,t),ve({type:"data",value:e,messageId:ge}),ge=(ge+1)%n.MAX_SAFE_INTEGER,await r}},i),f=new ye(t,s);await o.pipeThrough(f).pipeTo(c,{preventAbort:!0});try{await c.close()}catch(e){}const{signature:a,size:l}=f;ve({type:"close",result:{signature:a,size:l}})}catch(e){Se(e)}}function ve(e){let{value:t}=e;if(t)if(t.length)try{t=new i(t),e.value=t.buffer,d(e,[e.value])}catch(t){d(e)}else d(e);else d(e)}function Se(e){const{message:t,stack:n,code:r,name:s}=e;d({error:{message:t,stack:n,code:r,name:s}})}function ze(t){return _e(t.map((([t,n])=>new e(t).fill(n,0,t))))}function _e(t){return t.reduce(((t,n)=>t.concat(e.isArray(n)?_e(n):n)),[])}addEventListener("message",(({data:e})=>{const{type:t,messageId:n,value:r,done:s}=e;try{if("start"==t&&ke(e),"data"==t){const e=me.get(n);me.delete(n),e({value:new i(r),done:s})}if("ack"==t){const e=be.get(n);be.delete(n),e()}}catch(e){Se(e)}}));const Ce=[0,1,2,3].concat(...ze([[2,4],[2,5],[4,6],[4,7],[8,8],[8,9],[16,10],[16,11],[32,12],[32,13],[64,14],[64,15],[2,0],[1,16],[1,17],[2,18],[2,19],[4,20],[4,21],[8,22],[8,23],[16,24],[16,25],[32,26],[32,27],[64,28],[64,29]]));function Ie(){const e=this;function t(e,t){let n=0;do{n|=1&e,e>>>=1,n<<=1}while(--t>0);return n>>>1}e.re=n=>{const s=e.se,i=e.oe.ie,o=e.oe.ce;let c,f,a,l=-1;for(n.fe=0,n.ae=573,c=0;o>c;c++)0!==s[2*c]?(n.le[++n.fe]=l=c,n.ue[c]=0):s[2*c+1]=0;for(;2>n.fe;)a=n.le[++n.fe]=2>l?++l:0,s[2*a]=1,n.ue[a]=0,n.we--,i&&(n.he-=i[2*a+1]);for(e.de=l,c=r.floor(n.fe/2);c>=1;c--)n.pe(s,c);a=o;do{c=n.le[1],n.le[1]=n.le[n.fe--],n.pe(s,1),f=n.le[1],n.le[--n.ae]=c,n.le[--n.ae]=f,s[2*a]=s[2*c]+s[2*f],n.ue[a]=r.max(n.ue[c],n.ue[f])+1,s[2*c+1]=s[2*f+1]=a,n.le[1]=a++,n.pe(s,1)}while(n.fe>=2);n.le[--n.ae]=n.le[1],(t=>{const n=e.se,r=e.oe.ie,s=e.oe.ye,i=e.oe.me,o=e.oe.be;let c,f,a,l,u,w,h=0;for(l=0;15>=l;l++)t.ge[l]=0;for(n[2*t.le[t.ae]+1]=0,c=t.ae+1;573>c;c++)f=t.le[c],l=n[2*n[2*f+1]+1]+1,l>o&&(l=o,h++),n[2*f+1]=l,f>e.de||(t.ge[l]++,u=0,i>f||(u=s[f-i]),w=n[2*f],t.we+=w*(l+u),r&&(t.he+=w*(r[2*f+1]+u)));if(0!==h){do{for(l=o-1;0===t.ge[l];)l--;t.ge[l]--,t.ge[l+1]+=2,t.ge[o]--,h-=2}while(h>0);for(l=o;0!==l;l--)for(f=t.ge[l];0!==f;)a=t.le[--c],a>e.de||(n[2*a+1]!=l&&(t.we+=(l-n[2*a+1])*n[2*a],n[2*a+1]=l),f--)}})(n),((e,n,r)=>{const s=[];let i,o,c,f=0;for(i=1;15>=i;i++)s[i]=f=f+r[i-1]<<1;for(o=0;n>=o;o++)c=e[2*o+1],0!==c&&(e[2*o]=t(s[c]++,c))})(s,e.de,n.ge)}}function xe(e,t,n,r,s){const i=this;i.ie=e,i.ye=t,i.me=n,i.ce=r,i.be=s}Ie.ke=[0,1,2,3,4,5,6,7].concat(...ze([[2,8],[2,9],[2,10],[2,11],[4,12],[4,13],[4,14],[4,15],[8,16],[8,17],[8,18],[8,19],[16,20],[16,21],[16,22],[16,23],[32,24],[32,25],[32,26],[31,27],[1,28]])),Ie.ve=[0,1,2,3,4,5,6,7,8,10,12,14,16,20,24,28,32,40,48,56,64,80,96,112,128,160,192,224,0],Ie.Se=[0,1,2,3,4,6,8,12,16,24,32,48,64,96,128,192,256,384,512,768,1024,1536,2048,3072,4096,6144,8192,12288,16384,24576],Ie.ze=e=>256>e?Ce[e]:Ce[256+(e>>>7)],Ie._e=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],Ie.Ce=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],Ie.Ie=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],Ie.xe=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];const Ae=ze([[144,8],[112,9],[24,7],[8,8]]);xe.Ae=_e([12,140,76,204,44,172,108,236,28,156,92,220,60,188,124,252,2,130,66,194,34,162,98,226,18,146,82,210,50,178,114,242,10,138,74,202,42,170,106,234,26,154,90,218,58,186,122,250,6,134,70,198,38,166,102,230,22,150,86,214,54,182,118,246,14,142,78,206,46,174,110,238,30,158,94,222,62,190,126,254,1,129,65,193,33,161,97,225,17,145,81,209,49,177,113,241,9,137,73,201,41,169,105,233,25,153,89,217,57,185,121,249,5,133,69,197,37,165,101,229,21,149,85,213,53,181,117,245,13,141,77,205,45,173,109,237,29,157,93,221,61,189,125,253,19,275,147,403,83,339,211,467,51,307,179,435,115,371,243,499,11,267,139,395,75,331,203,459,43,299,171,427,107,363,235,491,27,283,155,411,91,347,219,475,59,315,187,443,123,379,251,507,7,263,135,391,71,327,199,455,39,295,167,423,103,359,231,487,23,279,151,407,87,343,215,471,55,311,183,439,119,375,247,503,15,271,143,399,79,335,207,463,47,303,175,431,111,367,239,495,31,287,159,415,95,351,223,479,63,319,191,447,127,383,255,511,0,64,32,96,16,80,48,112,8,72,40,104,24,88,56,120,4,68,36,100,20,84,52,116,3,131,67,195,35,163,99,227].map(((e,t)=>[e,Ae[t]])));const De=ze([[30,5]]);function Ve(e,t,n,r,s){const i=this;i.De=e,i.Ve=t,i.Re=n,i.Be=r,i.Ee=s}xe.Me=_e([0,16,8,24,4,20,12,28,2,18,10,26,6,22,14,30,1,17,9,25,5,21,13,29,3,19,11,27,7,23].map(((e,t)=>[e,De[t]]))),xe.Ke=new xe(xe.Ae,Ie._e,257,286,15),xe.Pe=new xe(xe.Me,Ie.Ce,0,30,15),xe.Ue=new xe(null,Ie.Ie,0,19,7);const Re=[new Ve(0,0,0,0,0),new Ve(4,4,8,4,1),new Ve(4,5,16,8,1),new Ve(4,6,32,32,1),new Ve(4,4,16,16,2),new Ve(8,16,32,32,2),new Ve(8,16,128,128,2),new Ve(8,32,128,256,2),new Ve(32,128,258,1024,2),new Ve(32,258,258,4096,2)],Be=["need dictionary","stream end","","","stream error","data error","","buffer error","",""];function Ee(e,t,n,r){const s=e[2*t],i=e[2*n];return i>s||s==i&&r[t]<=r[n]}function Me(){const e=this;let t,n,s,c,f,a,l,u,w,h,d,p,y,m,b,g,k,v,S,z,_,C,I,x,A,D,V,R,B,E,M,K,P;const U=new Ie,N=new Ie,T=new Ie;let W,H,L,j,F,O;function q(){let t;for(t=0;286>t;t++)M[2*t]=0;for(t=0;30>t;t++)K[2*t]=0;for(t=0;19>t;t++)P[2*t]=0;M[512]=1,e.we=e.he=0,H=L=0}function G(e,t){let n,r=-1,s=e[1],i=0,o=7,c=4;0===s&&(o=138,c=3),e[2*(t+1)+1]=65535;for(let f=0;t>=f;f++)n=s,s=e[2*(f+1)+1],++i<o&&n==s||(c>i?P[2*n]+=i:0!==n?(n!=r&&P[2*n]++,P[32]++):i>10?P[36]++:P[34]++,i=0,r=n,0===s?(o=138,c=3):n==s?(o=6,c=3):(o=7,c=4))}function J(t){e.Ne[e.pending++]=t}function Q(e){J(255&e),J(e>>>8&255)}function X(e,t){let n;const r=t;O>16-r?(n=e,F|=n<<O&65535,Q(F),F=n>>>16-O,O+=r-16):(F|=e<<O&65535,O+=r)}function Y(e,t){const n=2*e;X(65535&t[n],65535&t[n+1])}function Z(e,t){let n,r,s=-1,i=e[1],o=0,c=7,f=4;for(0===i&&(c=138,f=3),n=0;t>=n;n++)if(r=i,i=e[2*(n+1)+1],++o>=c||r!=i){if(f>o)do{Y(r,P)}while(0!=--o);else 0!==r?(r!=s&&(Y(r,P),o--),Y(16,P),X(o-3,2)):o>10?(Y(18,P),X(o-11,7)):(Y(17,P),X(o-3,3));o=0,s=r,0===i?(c=138,f=3):r==i?(c=6,f=3):(c=7,f=4)}}function $(){16==O?(Q(F),F=0,O=0):8>O||(J(255&F),F>>>=8,O-=8)}function ee(t,n){let s,i,o;if(e.Te[H]=t,e.We[H]=255&n,H++,0===t?M[2*n]++:(L++,t--,M[2*(Ie.ke[n]+256+1)]++,K[2*Ie.ze(t)]++),0==(8191&H)&&V>2){for(s=8*H,i=_-k,o=0;30>o;o++)s+=K[2*o]*(5+Ie.Ce[o]);if(s>>>=3,L<r.floor(H/2)&&s<r.floor(i/2))return!0}return H==W-1}function te(t,n){let r,s,i,o,c=0;if(0!==H)do{r=e.Te[c],s=e.We[c],c++,0===r?Y(s,t):(i=Ie.ke[s],Y(i+256+1,t),o=Ie._e[i],0!==o&&(s-=Ie.ve[i],X(s,o)),r--,i=Ie.ze(r),Y(i,n),o=Ie.Ce[i],0!==o&&(r-=Ie.Se[i],X(r,o)))}while(H>c);Y(256,t),j=t[513]}function ne(){O>8?Q(F):O>0&&J(255&F),F=0,O=0}function re(t,n,r){X(0+(r?1:0),3),((t,n)=>{ne(),j=8,Q(n),Q(~n),e.Ne.set(u.subarray(t,t+n),e.pending),e.pending+=n})(t,n)}function se(n){((t,n,r)=>{let s,i,o=0;V>0?(U.re(e),N.re(e),o=(()=>{let t;for(G(M,U.de),G(K,N.de),T.re(e),t=18;t>=3&&0===P[2*Ie.xe[t]+1];t--);return e.we+=14+3*(t+1),t})(),s=e.we+3+7>>>3,i=e.he+3+7>>>3,i>s||(s=i)):s=i=n+5,n+4>s||-1==t?i==s?(X(2+(r?1:0),3),te(xe.Ae,xe.Me)):(X(4+(r?1:0),3),((e,t,n)=>{let r;for(X(e-257,5),X(t-1,5),X(n-4,4),r=0;n>r;r++)X(P[2*Ie.xe[r]+1],3);Z(M,e-1),Z(K,t-1)})(U.de+1,N.de+1,o+1),te(M,K)):re(t,n,r),q(),r&&ne()})(0>k?-1:k,_-k,n),k=_,t.He()}function ie(){let e,n,r,s;do{if(s=w-I-_,0===s&&0===_&&0===I)s=f;else if(-1==s)s--;else if(_>=f+f-262){u.set(u.subarray(f,f+f),0),C-=f,_-=f,k-=f,e=y,r=e;do{n=65535&d[--r],d[r]=f>n?0:n-f}while(0!=--e);e=f,r=e;do{n=65535&h[--r],h[r]=f>n?0:n-f}while(0!=--e);s+=f}if(0===t.Le)return;e=t.je(u,_+I,s),I+=e,3>I||(p=255&u[_],p=(p<<g^255&u[_+1])&b)}while(262>I&&0!==t.Le)}function oe(e){let t,n,r=A,s=_,i=x;const o=_>f-262?_-(f-262):0;let c=E;const a=l,w=_+258;let d=u[s+i-1],p=u[s+i];B>x||(r>>=2),c>I&&(c=I);do{if(t=e,u[t+i]==p&&u[t+i-1]==d&&u[t]==u[s]&&u[++t]==u[s+1]){s+=2,t++;do{}while(u[++s]==u[++t]&&u[++s]==u[++t]&&u[++s]==u[++t]&&u[++s]==u[++t]&&u[++s]==u[++t]&&u[++s]==u[++t]&&u[++s]==u[++t]&&u[++s]==u[++t]&&w>s);if(n=258-(w-s),s=w-258,n>i){if(C=e,i=n,n>=c)break;d=u[s+i-1],p=u[s+i]}}}while((e=65535&h[e&a])>o&&0!=--r);return i>I?I:i}e.ue=[],e.ge=[],e.le=[],M=[],K=[],P=[],e.pe=(t,n)=>{const r=e.le,s=r[n];let i=n<<1;for(;i<=e.fe&&(i<e.fe&&Ee(t,r[i+1],r[i],e.ue)&&i++,!Ee(t,s,r[i],e.ue));)r[n]=r[i],n=i,i<<=1;r[n]=s},e.Fe=(t,S,C,H,L,G)=>(H||(H=8),L||(L=8),G||(G=0),t.Oe=null,-1==S&&(S=6),1>L||L>9||8!=H||9>C||C>15||0>S||S>9||0>G||G>2?-2:(t.qe=e,a=C,f=1<<a,l=f-1,m=L+7,y=1<<m,b=y-1,g=r.floor((m+3-1)/3),u=new i(2*f),h=[],d=[],W=1<<L+6,e.Ne=new i(4*W),s=4*W,e.Te=new o(W),e.We=new i(W),V=S,R=G,(t=>(t.Ge=t.Je=0,t.Oe=null,e.pending=0,e.Qe=0,n=113,c=0,U.se=M,U.oe=xe.Ke,N.se=K,N.oe=xe.Pe,T.se=P,T.oe=xe.Ue,F=0,O=0,j=8,q(),(()=>{w=2*f,d[y-1]=0;for(let e=0;y-1>e;e++)d[e]=0;D=Re[V].Ve,B=Re[V].De,E=Re[V].Re,A=Re[V].Be,_=0,k=0,I=0,v=x=2,z=0,p=0})(),0))(t))),e.Xe=()=>42!=n&&113!=n&&666!=n?-2:(e.We=null,e.Te=null,e.Ne=null,d=null,h=null,u=null,e.qe=null,113==n?-3:0),e.Ye=(e,t,n)=>{let r=0;return-1==t&&(t=6),0>t||t>9||0>n||n>2?-2:(Re[V].Ee!=Re[t].Ee&&0!==e.Ge&&(r=e.Ze(1)),V!=t&&(V=t,D=Re[V].Ve,B=Re[V].De,E=Re[V].Re,A=Re[V].Be),R=n,r)},e.$e=(e,t,r)=>{let s,i=r,o=0;if(!t||42!=n)return-2;if(3>i)return 0;for(i>f-262&&(i=f-262,o=r-i),u.set(t.subarray(o,o+i),0),_=i,k=i,p=255&u[0],p=(p<<g^255&u[1])&b,s=0;i-3>=s;s++)p=(p<<g^255&u[s+2])&b,h[s&l]=d[p],d[p]=s;return 0},e.Ze=(r,i)=>{let o,w,m,A,B;if(i>4||0>i)return-2;if(!r.et||!r.tt&&0!==r.Le||666==n&&4!=i)return r.Oe=Be[4],-2;if(0===r.nt)return r.Oe=Be[7],-5;var E;if(t=r,A=c,c=i,42==n&&(w=8+(a-8<<4)<<8,m=(V-1&255)>>1,m>3&&(m=3),w|=m<<6,0!==_&&(w|=32),w+=31-w%31,n=113,J((E=w)>>8&255),J(255&E)),0!==e.pending){if(t.He(),0===t.nt)return c=-1,0}else if(0===t.Le&&A>=i&&4!=i)return t.Oe=Be[7],-5;if(666==n&&0!==t.Le)return r.Oe=Be[7],-5;if(0!==t.Le||0!==I||0!=i&&666!=n){switch(B=-1,Re[V].Ee){case 0:B=(e=>{let n,r=65535;for(r>s-5&&(r=s-5);;){if(1>=I){if(ie(),0===I&&0==e)return 0;if(0===I)break}if(_+=I,I=0,n=k+r,(0===_||_>=n)&&(I=_-n,_=n,se(!1),0===t.nt))return 0;if(_-k>=f-262&&(se(!1),0===t.nt))return 0}return se(4==e),0===t.nt?4==e?2:0:4==e?3:1})(i);break;case 1:B=(e=>{let n,r=0;for(;;){if(262>I){if(ie(),262>I&&0==e)return 0;if(0===I)break}if(3>I||(p=(p<<g^255&u[_+2])&b,r=65535&d[p],h[_&l]=d[p],d[p]=_),0===r||(_-r&65535)>f-262||2!=R&&(v=oe(r)),3>v)n=ee(0,255&u[_]),I--,_++;else if(n=ee(_-C,v-3),I-=v,v>D||3>I)_+=v,v=0,p=255&u[_],p=(p<<g^255&u[_+1])&b;else{v--;do{_++,p=(p<<g^255&u[_+2])&b,r=65535&d[p],h[_&l]=d[p],d[p]=_}while(0!=--v);_++}if(n&&(se(!1),0===t.nt))return 0}return se(4==e),0===t.nt?4==e?2:0:4==e?3:1})(i);break;case 2:B=(e=>{let n,r,s=0;for(;;){if(262>I){if(ie(),262>I&&0==e)return 0;if(0===I)break}if(3>I||(p=(p<<g^255&u[_+2])&b,s=65535&d[p],h[_&l]=d[p],d[p]=_),x=v,S=C,v=2,0!==s&&D>x&&f-262>=(_-s&65535)&&(2!=R&&(v=oe(s)),5>=v&&(1==R||3==v&&_-C>4096)&&(v=2)),3>x||v>x)if(0!==z){if(n=ee(0,255&u[_-1]),n&&se(!1),_++,I--,0===t.nt)return 0}else z=1,_++,I--;else{r=_+I-3,n=ee(_-1-S,x-3),I-=x-1,x-=2;do{++_>r||(p=(p<<g^255&u[_+2])&b,s=65535&d[p],h[_&l]=d[p],d[p]=_)}while(0!=--x);if(z=0,v=2,_++,n&&(se(!1),0===t.nt))return 0}}return 0!==z&&(n=ee(0,255&u[_-1]),z=0),se(4==e),0===t.nt?4==e?2:0:4==e?3:1})(i)}if(2!=B&&3!=B||(n=666),0==B||2==B)return 0===t.nt&&(c=-1),0;if(1==B){if(1==i)X(2,3),Y(256,xe.Ae),$(),9>1+j+10-O&&(X(2,3),Y(256,xe.Ae),$()),j=7;else if(re(0,0,!1),3==i)for(o=0;y>o;o++)d[o]=0;if(t.He(),0===t.nt)return c=-1,0}}return 4!=i?0:1}}function Ke(){const e=this;e.rt=0,e.st=0,e.Le=0,e.Ge=0,e.nt=0,e.Je=0}function Pe(e){const t=new Ke,n=(o=e&&e.chunkSize?e.chunkSize:65536)+5*(r.floor(o/16383)+1);var o;const c=new i(n);let f=e?e.level:-1;void 0===f&&(f=-1),t.Fe(f),t.et=c,this.append=(e,r)=>{let o,f,a=0,l=0,u=0;const w=[];if(e.length){t.rt=0,t.tt=e,t.Le=e.length;do{if(t.st=0,t.nt=n,o=t.Ze(0),0!=o)throw new s("deflating: "+t.Oe);t.st&&(t.st==n?w.push(new i(c)):w.push(c.slice(0,t.st))),u+=t.st,r&&t.rt>0&&t.rt!=a&&(r(t.rt),a=t.rt)}while(t.Le>0||0===t.nt);return w.length>1?(f=new i(u),w.forEach((e=>{f.set(e,l),l+=e.length}))):f=w[0]||new i,f}},this.flush=()=>{let e,r,o=0,f=0;const a=[];do{if(t.st=0,t.nt=n,e=t.Ze(4),1!=e&&0!=e)throw new s("deflating: "+t.Oe);n-t.nt>0&&a.push(c.slice(0,t.st)),f+=t.st}while(t.Le>0||0===t.nt);return t.Xe(),r=new i(f),a.forEach((e=>{r.set(e,o),o+=e.length})),r}}Ke.prototype={Fe(e,t){const n=this;return n.qe=new Me,t||(t=15),n.qe.Fe(n,e,t)},Ze(e){const t=this;return t.qe?t.qe.Ze(t,e):-2},Xe(){const e=this;if(!e.qe)return-2;const t=e.qe.Xe();return e.qe=null,t},Ye(e,t){const n=this;return n.qe?n.qe.Ye(n,e,t):-2},$e(e,t){const n=this;return n.qe?n.qe.$e(n,e,t):-2},je(e,t,n){const r=this;let s=r.Le;return s>n&&(s=n),0===s?0:(r.Le-=s,e.set(r.tt.subarray(r.rt,r.rt+s),t),r.rt+=s,r.Ge+=s,s)},He(){const e=this;let t=e.qe.pending;t>e.nt&&(t=e.nt),0!==t&&(e.et.set(e.qe.Ne.subarray(e.qe.Qe,e.qe.Qe+t),e.st),e.st+=t,e.qe.Qe+=t,e.Je+=t,e.nt-=t,e.qe.pending-=t,0===e.qe.pending&&(e.qe.Qe=0))}};const Ue=[0,1,3,7,15,31,63,127,255,511,1023,2047,4095,8191,16383,32767,65535],Ne=[96,7,256,0,8,80,0,8,16,84,8,115,82,7,31,0,8,112,0,8,48,0,9,192,80,7,10,0,8,96,0,8,32,0,9,160,0,8,0,0,8,128,0,8,64,0,9,224,80,7,6,0,8,88,0,8,24,0,9,144,83,7,59,0,8,120,0,8,56,0,9,208,81,7,17,0,8,104,0,8,40,0,9,176,0,8,8,0,8,136,0,8,72,0,9,240,80,7,4,0,8,84,0,8,20,85,8,227,83,7,43,0,8,116,0,8,52,0,9,200,81,7,13,0,8,100,0,8,36,0,9,168,0,8,4,0,8,132,0,8,68,0,9,232,80,7,8,0,8,92,0,8,28,0,9,152,84,7,83,0,8,124,0,8,60,0,9,216,82,7,23,0,8,108,0,8,44,0,9,184,0,8,12,0,8,140,0,8,76,0,9,248,80,7,3,0,8,82,0,8,18,85,8,163,83,7,35,0,8,114,0,8,50,0,9,196,81,7,11,0,8,98,0,8,34,0,9,164,0,8,2,0,8,130,0,8,66,0,9,228,80,7,7,0,8,90,0,8,26,0,9,148,84,7,67,0,8,122,0,8,58,0,9,212,82,7,19,0,8,106,0,8,42,0,9,180,0,8,10,0,8,138,0,8,74,0,9,244,80,7,5,0,8,86,0,8,22,192,8,0,83,7,51,0,8,118,0,8,54,0,9,204,81,7,15,0,8,102,0,8,38,0,9,172,0,8,6,0,8,134,0,8,70,0,9,236,80,7,9,0,8,94,0,8,30,0,9,156,84,7,99,0,8,126,0,8,62,0,9,220,82,7,27,0,8,110,0,8,46,0,9,188,0,8,14,0,8,142,0,8,78,0,9,252,96,7,256,0,8,81,0,8,17,85,8,131,82,7,31,0,8,113,0,8,49,0,9,194,80,7,10,0,8,97,0,8,33,0,9,162,0,8,1,0,8,129,0,8,65,0,9,226,80,7,6,0,8,89,0,8,25,0,9,146,83,7,59,0,8,121,0,8,57,0,9,210,81,7,17,0,8,105,0,8,41,0,9,178,0,8,9,0,8,137,0,8,73,0,9,242,80,7,4,0,8,85,0,8,21,80,8,258,83,7,43,0,8,117,0,8,53,0,9,202,81,7,13,0,8,101,0,8,37,0,9,170,0,8,5,0,8,133,0,8,69,0,9,234,80,7,8,0,8,93,0,8,29,0,9,154,84,7,83,0,8,125,0,8,61,0,9,218,82,7,23,0,8,109,0,8,45,0,9,186,0,8,13,0,8,141,0,8,77,0,9,250,80,7,3,0,8,83,0,8,19,85,8,195,83,7,35,0,8,115,0,8,51,0,9,198,81,7,11,0,8,99,0,8,35,0,9,166,0,8,3,0,8,131,0,8,67,0,9,230,80,7,7,0,8,91,0,8,27,0,9,150,84,7,67,0,8,123,0,8,59,0,9,214,82,7,19,0,8,107,0,8,43,0,9,182,0,8,11,0,8,139,0,8,75,0,9,246,80,7,5,0,8,87,0,8,23,192,8,0,83,7,51,0,8,119,0,8,55,0,9,206,81,7,15,0,8,103,0,8,39,0,9,174,0,8,7,0,8,135,0,8,71,0,9,238,80,7,9,0,8,95,0,8,31,0,9,158,84,7,99,0,8,127,0,8,63,0,9,222,82,7,27,0,8,111,0,8,47,0,9,190,0,8,15,0,8,143,0,8,79,0,9,254,96,7,256,0,8,80,0,8,16,84,8,115,82,7,31,0,8,112,0,8,48,0,9,193,80,7,10,0,8,96,0,8,32,0,9,161,0,8,0,0,8,128,0,8,64,0,9,225,80,7,6,0,8,88,0,8,24,0,9,145,83,7,59,0,8,120,0,8,56,0,9,209,81,7,17,0,8,104,0,8,40,0,9,177,0,8,8,0,8,136,0,8,72,0,9,241,80,7,4,0,8,84,0,8,20,85,8,227,83,7,43,0,8,116,0,8,52,0,9,201,81,7,13,0,8,100,0,8,36,0,9,169,0,8,4,0,8,132,0,8,68,0,9,233,80,7,8,0,8,92,0,8,28,0,9,153,84,7,83,0,8,124,0,8,60,0,9,217,82,7,23,0,8,108,0,8,44,0,9,185,0,8,12,0,8,140,0,8,76,0,9,249,80,7,3,0,8,82,0,8,18,85,8,163,83,7,35,0,8,114,0,8,50,0,9,197,81,7,11,0,8,98,0,8,34,0,9,165,0,8,2,0,8,130,0,8,66,0,9,229,80,7,7,0,8,90,0,8,26,0,9,149,84,7,67,0,8,122,0,8,58,0,9,213,82,7,19,0,8,106,0,8,42,0,9,181,0,8,10,0,8,138,0,8,74,0,9,245,80,7,5,0,8,86,0,8,22,192,8,0,83,7,51,0,8,118,0,8,54,0,9,205,81,7,15,0,8,102,0,8,38,0,9,173,0,8,6,0,8,134,0,8,70,0,9,237,80,7,9,0,8,94,0,8,30,0,9,157,84,7,99,0,8,126,0,8,62,0,9,221,82,7,27,0,8,110,0,8,46,0,9,189,0,8,14,0,8,142,0,8,78,0,9,253,96,7,256,0,8,81,0,8,17,85,8,131,82,7,31,0,8,113,0,8,49,0,9,195,80,7,10,0,8,97,0,8,33,0,9,163,0,8,1,0,8,129,0,8,65,0,9,227,80,7,6,0,8,89,0,8,25,0,9,147,83,7,59,0,8,121,0,8,57,0,9,211,81,7,17,0,8,105,0,8,41,0,9,179,0,8,9,0,8,137,0,8,73,0,9,243,80,7,4,0,8,85,0,8,21,80,8,258,83,7,43,0,8,117,0,8,53,0,9,203,81,7,13,0,8,101,0,8,37,0,9,171,0,8,5,0,8,133,0,8,69,0,9,235,80,7,8,0,8,93,0,8,29,0,9,155,84,7,83,0,8,125,0,8,61,0,9,219,82,7,23,0,8,109,0,8,45,0,9,187,0,8,13,0,8,141,0,8,77,0,9,251,80,7,3,0,8,83,0,8,19,85,8,195,83,7,35,0,8,115,0,8,51,0,9,199,81,7,11,0,8,99,0,8,35,0,9,167,0,8,3,0,8,131,0,8,67,0,9,231,80,7,7,0,8,91,0,8,27,0,9,151,84,7,67,0,8,123,0,8,59,0,9,215,82,7,19,0,8,107,0,8,43,0,9,183,0,8,11,0,8,139,0,8,75,0,9,247,80,7,5,0,8,87,0,8,23,192,8,0,83,7,51,0,8,119,0,8,55,0,9,207,81,7,15,0,8,103,0,8,39,0,9,175,0,8,7,0,8,135,0,8,71,0,9,239,80,7,9,0,8,95,0,8,31,0,9,159,84,7,99,0,8,127,0,8,63,0,9,223,82,7,27,0,8,111,0,8,47,0,9,191,0,8,15,0,8,143,0,8,79,0,9,255],Te=[80,5,1,87,5,257,83,5,17,91,5,4097,81,5,5,89,5,1025,85,5,65,93,5,16385,80,5,3,88,5,513,84,5,33,92,5,8193,82,5,9,90,5,2049,86,5,129,192,5,24577,80,5,2,87,5,385,83,5,25,91,5,6145,81,5,7,89,5,1537,85,5,97,93,5,24577,80,5,4,88,5,769,84,5,49,92,5,12289,82,5,13,90,5,3073,86,5,193,192,5,24577],We=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0],He=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,112,112],Le=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577],je=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];function Fe(){let e,t,n,r,s,i;function o(e,t,o,c,f,a,l,u,w,h,d){let p,y,m,b,g,k,v,S,z,_,C,I,x,A,D;_=0,g=o;do{n[e[t+_]]++,_++,g--}while(0!==g);if(n[0]==o)return l[0]=-1,u[0]=0,0;for(S=u[0],k=1;15>=k&&0===n[k];k++);for(v=k,k>S&&(S=k),g=15;0!==g&&0===n[g];g--);for(m=g,S>g&&(S=g),u[0]=S,A=1<<k;g>k;k++,A<<=1)if(0>(A-=n[k]))return-3;if(0>(A-=n[g]))return-3;for(n[g]+=A,i[1]=k=0,_=1,x=2;0!=--g;)i[x]=k+=n[_],x++,_++;g=0,_=0;do{0!==(k=e[t+_])&&(d[i[k]++]=g),_++}while(++g<o);for(o=i[m],i[0]=g=0,_=0,b=-1,I=-S,s[0]=0,C=0,D=0;m>=v;v++)for(p=n[v];0!=p--;){for(;v>I+S;){if(b++,I+=S,D=m-I,D=D>S?S:D,(y=1<<(k=v-I))>p+1&&(y-=p+1,x=v,D>k))for(;++k<D&&(y<<=1)>n[++x];)y-=n[x];if(D=1<<k,h[0]+D>1440)return-3;s[b]=C=h[0],h[0]+=D,0!==b?(i[b]=g,r[0]=k,r[1]=S,k=g>>>I-S,r[2]=C-s[b-1]-k,w.set(r,3*(s[b-1]+k))):l[0]=C}for(r[1]=v-I,o>_?d[_]<c?(r[0]=256>d[_]?0:96,r[2]=d[_++]):(r[0]=a[d[_]-c]+16+64,r[2]=f[d[_++]-c]):r[0]=192,y=1<<v-I,k=g>>>I;D>k;k+=y)w.set(r,3*(C+k));for(k=1<<v-1;0!=(g&k);k>>>=1)g^=k;for(g^=k,z=(1<<I)-1;(g&z)!=i[b];)b--,I-=S,z=(1<<I)-1}return 0!==A&&1!=m?-5:0}function c(o){let c;for(e||(e=[],t=[],n=new f(16),r=[],s=new f(15),i=new f(16)),t.length<o&&(t=[]),c=0;o>c;c++)t[c]=0;for(c=0;16>c;c++)n[c]=0;for(c=0;3>c;c++)r[c]=0;s.set(n.subarray(0,15),0),i.set(n.subarray(0,16),0)}this.it=(n,r,s,i,f)=>{let a;return c(19),e[0]=0,a=o(n,0,19,19,null,null,s,r,i,e,t),-3==a?f.Oe="oversubscribed dynamic bit lengths tree":-5!=a&&0!==r[0]||(f.Oe="incomplete dynamic bit lengths tree",a=-3),a},this.ot=(n,r,s,i,f,a,l,u,w)=>{let h;return c(288),e[0]=0,h=o(s,0,n,257,We,He,a,i,u,e,t),0!=h||0===i[0]?(-3==h?w.Oe="oversubscribed literal/length tree":-4!=h&&(w.Oe="incomplete literal/length tree",h=-3),h):(c(288),h=o(s,n,r,0,Le,je,l,f,u,e,t),0!=h||0===f[0]&&n>257?(-3==h?w.Oe="oversubscribed distance tree":-5==h?(w.Oe="incomplete distance tree",h=-3):-4!=h&&(w.Oe="empty distance tree with lengths",h=-3),h):0)}}function Oe(){const e=this;let t,n,r,s,i=0,o=0,c=0,f=0,a=0,l=0,u=0,w=0,h=0,d=0;function p(e,t,n,r,s,i,o,c){let f,a,l,u,w,h,d,p,y,m,b,g,k,v,S,z;d=c.rt,p=c.Le,w=o.ct,h=o.ft,y=o.write,m=y<o.read?o.read-y-1:o.end-y,b=Ue[e],g=Ue[t];do{for(;20>h;)p--,w|=(255&c.lt(d++))<<h,h+=8;if(f=w&b,a=n,l=r,z=3*(l+f),0!==(u=a[z]))for(;;){if(w>>=a[z+1],h-=a[z+1],0!=(16&u)){for(u&=15,k=a[z+2]+(w&Ue[u]),w>>=u,h-=u;15>h;)p--,w|=(255&c.lt(d++))<<h,h+=8;for(f=w&g,a=s,l=i,z=3*(l+f),u=a[z];;){if(w>>=a[z+1],h-=a[z+1],0!=(16&u)){for(u&=15;u>h;)p--,w|=(255&c.lt(d++))<<h,h+=8;if(v=a[z+2]+(w&Ue[u]),w>>=u,h-=u,m-=k,v>y){S=y-v;do{S+=o.end}while(0>S);if(u=o.end-S,k>u){if(k-=u,y-S>0&&u>y-S)do{o.ut[y++]=o.ut[S++]}while(0!=--u);else o.ut.set(o.ut.subarray(S,S+u),y),y+=u,S+=u,u=0;S=0}}else S=y-v,y-S>0&&2>y-S?(o.ut[y++]=o.ut[S++],o.ut[y++]=o.ut[S++],k-=2):(o.ut.set(o.ut.subarray(S,S+2),y),y+=2,S+=2,k-=2);if(y-S>0&&k>y-S)do{o.ut[y++]=o.ut[S++]}while(0!=--k);else o.ut.set(o.ut.subarray(S,S+k),y),y+=k,S+=k,k=0;break}if(0!=(64&u))return c.Oe="invalid distance code",k=c.Le-p,k=k>h>>3?h>>3:k,p+=k,d-=k,h-=k<<3,o.ct=w,o.ft=h,c.Le=p,c.Ge+=d-c.rt,c.rt=d,o.write=y,-3;f+=a[z+2],f+=w&Ue[u],z=3*(l+f),u=a[z]}break}if(0!=(64&u))return 0!=(32&u)?(k=c.Le-p,k=k>h>>3?h>>3:k,p+=k,d-=k,h-=k<<3,o.ct=w,o.ft=h,c.Le=p,c.Ge+=d-c.rt,c.rt=d,o.write=y,1):(c.Oe="invalid literal/length code",k=c.Le-p,k=k>h>>3?h>>3:k,p+=k,d-=k,h-=k<<3,o.ct=w,o.ft=h,c.Le=p,c.Ge+=d-c.rt,c.rt=d,o.write=y,-3);if(f+=a[z+2],f+=w&Ue[u],z=3*(l+f),0===(u=a[z])){w>>=a[z+1],h-=a[z+1],o.ut[y++]=a[z+2],m--;break}}else w>>=a[z+1],h-=a[z+1],o.ut[y++]=a[z+2],m--}while(m>=258&&p>=10);return k=c.Le-p,k=k>h>>3?h>>3:k,p+=k,d-=k,h-=k<<3,o.ct=w,o.ft=h,c.Le=p,c.Ge+=d-c.rt,c.rt=d,o.write=y,0}e.init=(e,i,o,c,f,a)=>{t=0,u=e,w=i,r=o,h=c,s=f,d=a,n=null},e.wt=(e,y,m)=>{let b,g,k,v,S,z,_,C=0,I=0,x=0;for(x=y.rt,v=y.Le,C=e.ct,I=e.ft,S=e.write,z=S<e.read?e.read-S-1:e.end-S;;)switch(t){case 0:if(z>=258&&v>=10&&(e.ct=C,e.ft=I,y.Le=v,y.Ge+=x-y.rt,y.rt=x,e.write=S,m=p(u,w,r,h,s,d,e,y),x=y.rt,v=y.Le,C=e.ct,I=e.ft,S=e.write,z=S<e.read?e.read-S-1:e.end-S,0!=m)){t=1==m?7:9;break}c=u,n=r,o=h,t=1;case 1:for(b=c;b>I;){if(0===v)return e.ct=C,e.ft=I,y.Le=v,y.Ge+=x-y.rt,y.rt=x,e.write=S,e.ht(y,m);m=0,v--,C|=(255&y.lt(x++))<<I,I+=8}if(g=3*(o+(C&Ue[b])),C>>>=n[g+1],I-=n[g+1],k=n[g],0===k){f=n[g+2],t=6;break}if(0!=(16&k)){a=15&k,i=n[g+2],t=2;break}if(0==(64&k)){c=k,o=g/3+n[g+2];break}if(0!=(32&k)){t=7;break}return t=9,y.Oe="invalid literal/length code",m=-3,e.ct=C,e.ft=I,y.Le=v,y.Ge+=x-y.rt,y.rt=x,e.write=S,e.ht(y,m);case 2:for(b=a;b>I;){if(0===v)return e.ct=C,e.ft=I,y.Le=v,y.Ge+=x-y.rt,y.rt=x,e.write=S,e.ht(y,m);m=0,v--,C|=(255&y.lt(x++))<<I,I+=8}i+=C&Ue[b],C>>=b,I-=b,c=w,n=s,o=d,t=3;case 3:for(b=c;b>I;){if(0===v)return e.ct=C,e.ft=I,y.Le=v,y.Ge+=x-y.rt,y.rt=x,e.write=S,e.ht(y,m);m=0,v--,C|=(255&y.lt(x++))<<I,I+=8}if(g=3*(o+(C&Ue[b])),C>>=n[g+1],I-=n[g+1],k=n[g],0!=(16&k)){a=15&k,l=n[g+2],t=4;break}if(0==(64&k)){c=k,o=g/3+n[g+2];break}return t=9,y.Oe="invalid distance code",m=-3,e.ct=C,e.ft=I,y.Le=v,y.Ge+=x-y.rt,y.rt=x,e.write=S,e.ht(y,m);case 4:for(b=a;b>I;){if(0===v)return e.ct=C,e.ft=I,y.Le=v,y.Ge+=x-y.rt,y.rt=x,e.write=S,e.ht(y,m);m=0,v--,C|=(255&y.lt(x++))<<I,I+=8}l+=C&Ue[b],C>>=b,I-=b,t=5;case 5:for(_=S-l;0>_;)_+=e.end;for(;0!==i;){if(0===z&&(S==e.end&&0!==e.read&&(S=0,z=S<e.read?e.read-S-1:e.end-S),0===z&&(e.write=S,m=e.ht(y,m),S=e.write,z=S<e.read?e.read-S-1:e.end-S,S==e.end&&0!==e.read&&(S=0,z=S<e.read?e.read-S-1:e.end-S),0===z)))return e.ct=C,e.ft=I,y.Le=v,y.Ge+=x-y.rt,y.rt=x,e.write=S,e.ht(y,m);e.ut[S++]=e.ut[_++],z--,_==e.end&&(_=0),i--}t=0;break;case 6:if(0===z&&(S==e.end&&0!==e.read&&(S=0,z=S<e.read?e.read-S-1:e.end-S),0===z&&(e.write=S,m=e.ht(y,m),S=e.write,z=S<e.read?e.read-S-1:e.end-S,S==e.end&&0!==e.read&&(S=0,z=S<e.read?e.read-S-1:e.end-S),0===z)))return e.ct=C,e.ft=I,y.Le=v,y.Ge+=x-y.rt,y.rt=x,e.write=S,e.ht(y,m);m=0,e.ut[S++]=f,z--,t=0;break;case 7:if(I>7&&(I-=8,v++,x--),e.write=S,m=e.ht(y,m),S=e.write,z=S<e.read?e.read-S-1:e.end-S,e.read!=e.write)return e.ct=C,e.ft=I,y.Le=v,y.Ge+=x-y.rt,y.rt=x,e.write=S,e.ht(y,m);t=8;case 8:return m=1,e.ct=C,e.ft=I,y.Le=v,y.Ge+=x-y.rt,y.rt=x,e.write=S,e.ht(y,m);case 9:return m=-3,e.ct=C,e.ft=I,y.Le=v,y.Ge+=x-y.rt,y.rt=x,e.write=S,e.ht(y,m);default:return m=-2,e.ct=C,e.ft=I,y.Le=v,y.Ge+=x-y.rt,y.rt=x,e.write=S,e.ht(y,m)}},e.dt=()=>{}}Fe.yt=(e,t,n,r)=>(e[0]=9,t[0]=5,n[0]=Ne,r[0]=Te,0);const qe=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];function Ge(e,t){const n=this;let r,s=0,o=0,c=0,a=0;const l=[0],u=[0],w=new Oe;let h=0,d=new f(4320);const p=new Fe;n.ft=0,n.ct=0,n.ut=new i(t),n.end=t,n.read=0,n.write=0,n.reset=(e,t)=>{t&&(t[0]=0),6==s&&w.dt(e),s=0,n.ft=0,n.ct=0,n.read=n.write=0},n.reset(e,null),n.ht=(e,t)=>{let r,s,i;return s=e.st,i=n.read,r=(i>n.write?n.end:n.write)-i,r>e.nt&&(r=e.nt),0!==r&&-5==t&&(t=0),e.nt-=r,e.Je+=r,e.et.set(n.ut.subarray(i,i+r),s),s+=r,i+=r,i==n.end&&(i=0,n.write==n.end&&(n.write=0),r=n.write-i,r>e.nt&&(r=e.nt),0!==r&&-5==t&&(t=0),e.nt-=r,e.Je+=r,e.et.set(n.ut.subarray(i,i+r),s),s+=r,i+=r),e.st=s,n.read=i,t},n.wt=(e,t)=>{let i,f,y,m,b,g,k,v;for(m=e.rt,b=e.Le,f=n.ct,y=n.ft,g=n.write,k=g<n.read?n.read-g-1:n.end-g;;){let S,z,_,C,I,x,A,D;switch(s){case 0:for(;3>y;){if(0===b)return n.ct=f,n.ft=y,e.Le=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.ht(e,t);t=0,b--,f|=(255&e.lt(m++))<<y,y+=8}switch(i=7&f,h=1&i,i>>>1){case 0:f>>>=3,y-=3,i=7&y,f>>>=i,y-=i,s=1;break;case 1:S=[],z=[],_=[[]],C=[[]],Fe.yt(S,z,_,C),w.init(S[0],z[0],_[0],0,C[0],0),f>>>=3,y-=3,s=6;break;case 2:f>>>=3,y-=3,s=3;break;case 3:return f>>>=3,y-=3,s=9,e.Oe="invalid block type",t=-3,n.ct=f,n.ft=y,e.Le=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.ht(e,t)}break;case 1:for(;32>y;){if(0===b)return n.ct=f,n.ft=y,e.Le=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.ht(e,t);t=0,b--,f|=(255&e.lt(m++))<<y,y+=8}if((~f>>>16&65535)!=(65535&f))return s=9,e.Oe="invalid stored block lengths",t=-3,n.ct=f,n.ft=y,e.Le=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.ht(e,t);o=65535&f,f=y=0,s=0!==o?2:0!==h?7:0;break;case 2:if(0===b)return n.ct=f,n.ft=y,e.Le=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.ht(e,t);if(0===k&&(g==n.end&&0!==n.read&&(g=0,k=g<n.read?n.read-g-1:n.end-g),0===k&&(n.write=g,t=n.ht(e,t),g=n.write,k=g<n.read?n.read-g-1:n.end-g,g==n.end&&0!==n.read&&(g=0,k=g<n.read?n.read-g-1:n.end-g),0===k)))return n.ct=f,n.ft=y,e.Le=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.ht(e,t);if(t=0,i=o,i>b&&(i=b),i>k&&(i=k),n.ut.set(e.je(m,i),g),m+=i,b-=i,g+=i,k-=i,0!=(o-=i))break;s=0!==h?7:0;break;case 3:for(;14>y;){if(0===b)return n.ct=f,n.ft=y,e.Le=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.ht(e,t);t=0,b--,f|=(255&e.lt(m++))<<y,y+=8}if(c=i=16383&f,(31&i)>29||(i>>5&31)>29)return s=9,e.Oe="too many length or distance symbols",t=-3,n.ct=f,n.ft=y,e.Le=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.ht(e,t);if(i=258+(31&i)+(i>>5&31),!r||r.length<i)r=[];else for(v=0;i>v;v++)r[v]=0;f>>>=14,y-=14,a=0,s=4;case 4:for(;4+(c>>>10)>a;){for(;3>y;){if(0===b)return n.ct=f,n.ft=y,e.Le=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.ht(e,t);t=0,b--,f|=(255&e.lt(m++))<<y,y+=8}r[qe[a++]]=7&f,f>>>=3,y-=3}for(;19>a;)r[qe[a++]]=0;if(l[0]=7,i=p.it(r,l,u,d,e),0!=i)return-3==(t=i)&&(r=null,s=9),n.ct=f,n.ft=y,e.Le=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.ht(e,t);a=0,s=5;case 5:for(;i=c,258+(31&i)+(i>>5&31)>a;){let o,w;for(i=l[0];i>y;){if(0===b)return n.ct=f,n.ft=y,e.Le=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.ht(e,t);t=0,b--,f|=(255&e.lt(m++))<<y,y+=8}if(i=d[3*(u[0]+(f&Ue[i]))+1],w=d[3*(u[0]+(f&Ue[i]))+2],16>w)f>>>=i,y-=i,r[a++]=w;else{for(v=18==w?7:w-14,o=18==w?11:3;i+v>y;){if(0===b)return n.ct=f,n.ft=y,e.Le=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.ht(e,t);t=0,b--,f|=(255&e.lt(m++))<<y,y+=8}if(f>>>=i,y-=i,o+=f&Ue[v],f>>>=v,y-=v,v=a,i=c,v+o>258+(31&i)+(i>>5&31)||16==w&&1>v)return r=null,s=9,e.Oe="invalid bit length repeat",t=-3,n.ct=f,n.ft=y,e.Le=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.ht(e,t);w=16==w?r[v-1]:0;do{r[v++]=w}while(0!=--o);a=v}}if(u[0]=-1,I=[],x=[],A=[],D=[],I[0]=9,x[0]=6,i=c,i=p.ot(257+(31&i),1+(i>>5&31),r,I,x,A,D,d,e),0!=i)return-3==i&&(r=null,s=9),t=i,n.ct=f,n.ft=y,e.Le=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.ht(e,t);w.init(I[0],x[0],d,A[0],d,D[0]),s=6;case 6:if(n.ct=f,n.ft=y,e.Le=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,1!=(t=w.wt(n,e,t)))return n.ht(e,t);if(t=0,w.dt(e),m=e.rt,b=e.Le,f=n.ct,y=n.ft,g=n.write,k=g<n.read?n.read-g-1:n.end-g,0===h){s=0;break}s=7;case 7:if(n.write=g,t=n.ht(e,t),g=n.write,k=g<n.read?n.read-g-1:n.end-g,n.read!=n.write)return n.ct=f,n.ft=y,e.Le=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.ht(e,t);s=8;case 8:return t=1,n.ct=f,n.ft=y,e.Le=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.ht(e,t);case 9:return t=-3,n.ct=f,n.ft=y,e.Le=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.ht(e,t);default:return t=-2,n.ct=f,n.ft=y,e.Le=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.ht(e,t)}}},n.dt=e=>{n.reset(e,null),n.ut=null,d=null},n.bt=(e,t,r)=>{n.ut.set(e.subarray(t,t+r),0),n.read=n.write=r},n.gt=()=>1==s?1:0}const Je=[0,0,255,255];function Qe(){const e=this;function t(e){return e&&e.kt?(e.Ge=e.Je=0,e.Oe=null,e.kt.mode=7,e.kt.vt.reset(e,null),0):-2}e.mode=0,e.method=0,e.St=[0],e.zt=0,e.marker=0,e._t=0,e.Ct=t=>(e.vt&&e.vt.dt(t),e.vt=null,0),e.It=(n,r)=>(n.Oe=null,e.vt=null,8>r||r>15?(e.Ct(n),-2):(e._t=r,n.kt.vt=new Ge(n,1<<r),t(n),0)),e.xt=(e,t)=>{let n,r;if(!e||!e.kt||!e.tt)return-2;const s=e.kt;for(t=4==t?-5:0,n=-5;;)switch(s.mode){case 0:if(0===e.Le)return n;if(n=t,e.Le--,e.Ge++,8!=(15&(s.method=e.lt(e.rt++)))){s.mode=13,e.Oe="unknown compression method",s.marker=5;break}if(8+(s.method>>4)>s._t){s.mode=13,e.Oe="invalid win size",s.marker=5;break}s.mode=1;case 1:if(0===e.Le)return n;if(n=t,e.Le--,e.Ge++,r=255&e.lt(e.rt++),((s.method<<8)+r)%31!=0){s.mode=13,e.Oe="incorrect header check",s.marker=5;break}if(0==(32&r)){s.mode=7;break}s.mode=2;case 2:if(0===e.Le)return n;n=t,e.Le--,e.Ge++,s.zt=(255&e.lt(e.rt++))<<24&4278190080,s.mode=3;case 3:if(0===e.Le)return n;n=t,e.Le--,e.Ge++,s.zt+=(255&e.lt(e.rt++))<<16&16711680,s.mode=4;case 4:if(0===e.Le)return n;n=t,e.Le--,e.Ge++,s.zt+=(255&e.lt(e.rt++))<<8&65280,s.mode=5;case 5:return 0===e.Le?n:(n=t,e.Le--,e.Ge++,s.zt+=255&e.lt(e.rt++),s.mode=6,2);case 6:return s.mode=13,e.Oe="need dictionary",s.marker=0,-2;case 7:if(n=s.vt.wt(e,n),-3==n){s.mode=13,s.marker=0;break}if(0==n&&(n=t),1!=n)return n;n=t,s.vt.reset(e,s.St),s.mode=12;case 12:return e.Le=0,1;case 13:return-3;default:return-2}},e.At=(e,t,n)=>{let r=0,s=n;if(!e||!e.kt||6!=e.kt.mode)return-2;const i=e.kt;return s<1<<i._t||(s=(1<<i._t)-1,r=n-s),i.vt.bt(t,r,s),i.mode=7,0},e.Dt=e=>{let n,r,s,i,o;if(!e||!e.kt)return-2;const c=e.kt;if(13!=c.mode&&(c.mode=13,c.marker=0),0===(n=e.Le))return-5;for(r=e.rt,s=c.marker;0!==n&&4>s;)e.lt(r)==Je[s]?s++:s=0!==e.lt(r)?0:4-s,r++,n--;return e.Ge+=r-e.rt,e.rt=r,e.Le=n,c.marker=s,4!=s?-3:(i=e.Ge,o=e.Je,t(e),e.Ge=i,e.Je=o,c.mode=7,0)},e.Vt=e=>e&&e.kt&&e.kt.vt?e.kt.vt.gt():-2}function Xe(){}function Ye(e){const t=new Xe,n=e&&e.chunkSize?r.floor(2*e.chunkSize):131072,o=new i(n);let c=!1;t.It(),t.et=o,this.append=(e,r)=>{const f=[];let a,l,u=0,w=0,h=0;if(0!==e.length){t.rt=0,t.tt=e,t.Le=e.length;do{if(t.st=0,t.nt=n,0!==t.Le||c||(t.rt=0,c=!0),a=t.xt(0),c&&-5===a){if(0!==t.Le)throw new s("inflating: bad input")}else if(0!==a&&1!==a)throw new s("inflating: "+t.Oe);if((c||1===a)&&t.Le===e.length)throw new s("inflating: bad input");t.st&&(t.st===n?f.push(new i(o)):f.push(o.slice(0,t.st))),h+=t.st,r&&t.rt>0&&t.rt!=u&&(r(t.rt),u=t.rt)}while(t.Le>0||0===t.nt);return f.length>1?(l=new i(h),f.forEach((e=>{l.set(e,w),w+=e.length}))):l=f[0]||new i,l}},this.flush=()=>{t.Ct()}}Xe.prototype={It(e){const t=this;return t.kt=new Qe,e||(e=15),t.kt.It(t,e)},xt(e){const t=this;return t.kt?t.kt.xt(t,e):-2},Ct(){const e=this;if(!e.kt)return-2;const t=e.kt.Ct(e);return e.kt=null,t},Dt(){const e=this;return e.kt?e.kt.Dt(e):-2},At(e,t){const n=this;return n.kt?n.kt.At(n,e,t):-2},lt(e){return this.tt[e]},je(e,t){return this.tt.subarray(e,e+t)}},self.initCodec=()=>{self.Deflate=Pe,self.Inflate=Ye};\n'
        ], {
            type: "text/javascript"
        }));
    e({
        workerScripts: {
            inflate: [
                t
            ],
            deflate: [
                t
            ]
        }
    });
}



/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ // deno-lint-ignore-file no-this-alias
function $ba3e0f242a548a07$export$9b952ca07c20c1ad(library, options = {}, registerDataHandler) {
    return {
        Deflate: $ba3e0f242a548a07$var$createCodecClass(library.Deflate, options.deflate, registerDataHandler),
        Inflate: $ba3e0f242a548a07$var$createCodecClass(library.Inflate, options.inflate, registerDataHandler)
    };
}
function $ba3e0f242a548a07$var$createCodecClass(constructor, constructorOptions, registerDataHandler) {
    return class {
        constructor(options){
            const codecAdapter = this;
            const onData = (data)=>{
                if (codecAdapter.pendingData) {
                    const previousPendingData = codecAdapter.pendingData;
                    codecAdapter.pendingData = new Uint8Array(previousPendingData.length + data.length);
                    const { pendingData: pendingData } = codecAdapter;
                    pendingData.set(previousPendingData, 0);
                    pendingData.set(data, previousPendingData.length);
                } else codecAdapter.pendingData = new Uint8Array(data);
            };
            if (Object.hasOwn(options, "level") && options.level === undefined) delete options.level;
            codecAdapter.codec = new constructor(Object.assign({}, constructorOptions, options));
            registerDataHandler(codecAdapter.codec, onData);
        }
        append(data) {
            this.codec.push(data);
            return getResponse(this);
        }
        flush() {
            this.codec.push(new Uint8Array(), true);
            return getResponse(this);
        }
    };
    function getResponse(codec) {
        if (codec.pendingData) {
            const output = codec.pendingData;
            codec.pendingData = null;
            return output;
        } else return new Uint8Array();
    }
}



/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /* global Blob, atob, btoa, XMLHttpRequest, URL, fetch, ReadableStream, WritableStream, FileReader, TransformStream, Response */ // deno-lint-ignore-file no-this-alias


const $9e0a2ae6b9542b81$var$ERR_HTTP_STATUS = "HTTP error ";
const $9e0a2ae6b9542b81$export$b71577fe3c3fd8a2 = "HTTP Range not supported";
const $9e0a2ae6b9542b81$export$7fd7075d73b79aba = "Writer iterator completed too soon";
const $9e0a2ae6b9542b81$var$CONTENT_TYPE_TEXT_PLAIN = "text/plain";
const $9e0a2ae6b9542b81$var$HTTP_HEADER_CONTENT_LENGTH = "Content-Length";
const $9e0a2ae6b9542b81$var$HTTP_HEADER_CONTENT_RANGE = "Content-Range";
const $9e0a2ae6b9542b81$var$HTTP_HEADER_ACCEPT_RANGES = "Accept-Ranges";
const $9e0a2ae6b9542b81$var$HTTP_HEADER_RANGE = "Range";
const $9e0a2ae6b9542b81$var$HTTP_HEADER_CONTENT_TYPE = "Content-Type";
const $9e0a2ae6b9542b81$var$HTTP_METHOD_HEAD = "HEAD";
const $9e0a2ae6b9542b81$var$HTTP_METHOD_GET = "GET";
const $9e0a2ae6b9542b81$var$HTTP_RANGE_UNIT = "bytes";
const $9e0a2ae6b9542b81$var$DEFAULT_CHUNK_SIZE = 65536;
const $9e0a2ae6b9542b81$var$PROPERTY_NAME_WRITABLE = "writable";
class $9e0a2ae6b9542b81$var$Stream {
    constructor(){
        this.size = 0;
    }
    init() {
        this.initialized = true;
    }
}
class $9e0a2ae6b9542b81$export$2f7a2f0e90c07dc4 extends $9e0a2ae6b9542b81$var$Stream {
    get readable() {
        const reader = this;
        const { chunkSize: chunkSize = $9e0a2ae6b9542b81$var$DEFAULT_CHUNK_SIZE } = reader;
        const readable = new ReadableStream({
            start () {
                this.chunkOffset = 0;
            },
            async pull (controller) {
                const { offset: offset = 0, size: size, diskNumberStart: diskNumberStart } = readable;
                const { chunkOffset: chunkOffset } = this;
                controller.enqueue(await $9e0a2ae6b9542b81$export$e21b2fe168d56a89(reader, offset + chunkOffset, Math.min(chunkSize, size - chunkOffset), diskNumberStart));
                if (chunkOffset + chunkSize > size) controller.close();
                else this.chunkOffset += chunkSize;
            }
        });
        return readable;
    }
}
class $9e0a2ae6b9542b81$export$d7a960146e1a269e extends $9e0a2ae6b9542b81$var$Stream {
    constructor(){
        super();
        const writer = this;
        const writable = new WritableStream({
            write (chunk) {
                return writer.writeUint8Array(chunk);
            }
        });
        Object.defineProperty(writer, $9e0a2ae6b9542b81$var$PROPERTY_NAME_WRITABLE, {
            get () {
                return writable;
            }
        });
    }
    writeUint8Array() {
    // abstract
    }
}
class $9e0a2ae6b9542b81$export$b43666fe9f809ae0 extends $9e0a2ae6b9542b81$export$2f7a2f0e90c07dc4 {
    constructor(dataURI){
        super();
        let dataEnd = dataURI.length;
        while(dataURI.charAt(dataEnd - 1) == "=")dataEnd--;
        const dataStart = dataURI.indexOf(",") + 1;
        Object.assign(this, {
            dataURI: dataURI,
            dataStart: dataStart,
            size: Math.floor((dataEnd - dataStart) * 0.75)
        });
    }
    readUint8Array(offset, length) {
        const { dataStart: dataStart, dataURI: dataURI } = this;
        const dataArray = new Uint8Array(length);
        const start = Math.floor(offset / 3) * 4;
        const bytes = atob(dataURI.substring(start + dataStart, Math.ceil((offset + length) / 3) * 4 + dataStart));
        const delta = offset - Math.floor(start / 4) * 3;
        for(let indexByte = delta; indexByte < delta + length; indexByte++)dataArray[indexByte - delta] = bytes.charCodeAt(indexByte);
        return dataArray;
    }
}
class $9e0a2ae6b9542b81$export$e54009c5f365f844 extends $9e0a2ae6b9542b81$export$d7a960146e1a269e {
    constructor(contentType){
        super();
        Object.assign(this, {
            data: "data:" + (contentType || "") + ";base64,",
            pending: []
        });
    }
    writeUint8Array(array) {
        const writer = this;
        let indexArray = 0;
        let dataString = writer.pending;
        const delta = writer.pending.length;
        writer.pending = "";
        for(indexArray = 0; indexArray < Math.floor((delta + array.length) / 3) * 3 - delta; indexArray++)dataString += String.fromCharCode(array[indexArray]);
        for(; indexArray < array.length; indexArray++)writer.pending += String.fromCharCode(array[indexArray]);
        if (dataString.length > 2) writer.data += btoa(dataString);
        else writer.pending = dataString;
    }
    getData() {
        return this.data + btoa(this.pending);
    }
}
class $9e0a2ae6b9542b81$export$aa5015be25fe7f79 extends $9e0a2ae6b9542b81$export$2f7a2f0e90c07dc4 {
    constructor(blob){
        super();
        Object.assign(this, {
            blob: blob,
            size: blob.size
        });
    }
    async readUint8Array(offset, length) {
        const reader = this;
        return new Uint8Array(await reader.blob.slice(offset, offset + length).arrayBuffer());
    }
}
class $9e0a2ae6b9542b81$export$b1948fceba813858 extends $9e0a2ae6b9542b81$var$Stream {
    constructor(contentType){
        super();
        const writer = this;
        const transformStream = new TransformStream();
        const headers = [];
        if (contentType) headers.push([
            $9e0a2ae6b9542b81$var$HTTP_HEADER_CONTENT_TYPE,
            contentType
        ]);
        Object.defineProperty(writer, $9e0a2ae6b9542b81$var$PROPERTY_NAME_WRITABLE, {
            get () {
                return transformStream.writable;
            }
        });
        writer.blob = new Response(transformStream.readable, {
            headers: headers
        }).blob();
    }
    getData() {
        return this.blob;
    }
}
class $9e0a2ae6b9542b81$export$43d3fd7deddee00 extends $9e0a2ae6b9542b81$export$aa5015be25fe7f79 {
    constructor(text){
        super(new Blob([
            text
        ], {
            type: $9e0a2ae6b9542b81$var$CONTENT_TYPE_TEXT_PLAIN
        }));
    }
}
class $9e0a2ae6b9542b81$export$4e2ccb0172e96d5b extends $9e0a2ae6b9542b81$export$b1948fceba813858 {
    constructor(encoding){
        super(encoding);
        Object.assign(this, {
            encoding: encoding,
            utf8: !encoding || encoding.toLowerCase() == "utf-8"
        });
    }
    async getData() {
        const { encoding: encoding, utf8: utf8 } = this;
        const blob = await super.getData();
        if (blob.text && utf8) return blob.text();
        else {
            const reader = new FileReader();
            return new Promise((resolve, reject)=>{
                Object.assign(reader, {
                    onload: ({ target: target })=>resolve(target.result),
                    onerror: ()=>reject(reader.error)
                });
                reader.readAsText(blob, encoding);
            });
        }
    }
}
class $9e0a2ae6b9542b81$var$FetchReader extends $9e0a2ae6b9542b81$export$2f7a2f0e90c07dc4 {
    constructor(url, options){
        super();
        $9e0a2ae6b9542b81$var$createHtpReader(this, url, options);
    }
    async init() {
        super.init();
        await $9e0a2ae6b9542b81$var$initHttpReader(this, $9e0a2ae6b9542b81$var$sendFetchRequest, $9e0a2ae6b9542b81$var$getFetchRequestData);
    }
    readUint8Array(index, length) {
        return $9e0a2ae6b9542b81$var$readUint8ArrayHttpReader(this, index, length, $9e0a2ae6b9542b81$var$sendFetchRequest, $9e0a2ae6b9542b81$var$getFetchRequestData);
    }
}
class $9e0a2ae6b9542b81$var$XHRReader extends $9e0a2ae6b9542b81$export$2f7a2f0e90c07dc4 {
    constructor(url, options){
        super();
        $9e0a2ae6b9542b81$var$createHtpReader(this, url, options);
    }
    async init() {
        super.init();
        await $9e0a2ae6b9542b81$var$initHttpReader(this, $9e0a2ae6b9542b81$var$sendXMLHttpRequest, $9e0a2ae6b9542b81$var$getXMLHttpRequestData);
    }
    readUint8Array(index, length) {
        return $9e0a2ae6b9542b81$var$readUint8ArrayHttpReader(this, index, length, $9e0a2ae6b9542b81$var$sendXMLHttpRequest, $9e0a2ae6b9542b81$var$getXMLHttpRequestData);
    }
}
function $9e0a2ae6b9542b81$var$createHtpReader(httpReader, url, options) {
    const { preventHeadRequest: preventHeadRequest, useRangeHeader: useRangeHeader, forceRangeRequests: forceRangeRequests } = options;
    options = Object.assign({}, options);
    delete options.preventHeadRequest;
    delete options.useRangeHeader;
    delete options.forceRangeRequests;
    delete options.useXHR;
    Object.assign(httpReader, {
        url: url,
        options: options,
        preventHeadRequest: preventHeadRequest,
        useRangeHeader: useRangeHeader,
        forceRangeRequests: forceRangeRequests
    });
}
async function $9e0a2ae6b9542b81$var$initHttpReader(httpReader, sendRequest, getRequestData) {
    const { url: url, useRangeHeader: useRangeHeader, forceRangeRequests: forceRangeRequests } = httpReader;
    if ($9e0a2ae6b9542b81$var$isHttpFamily(url) && (useRangeHeader || forceRangeRequests)) {
        const { headers: headers } = await sendRequest($9e0a2ae6b9542b81$var$HTTP_METHOD_GET, httpReader, $9e0a2ae6b9542b81$var$getRangeHeaders(httpReader));
        if (!forceRangeRequests && headers.get($9e0a2ae6b9542b81$var$HTTP_HEADER_ACCEPT_RANGES) != $9e0a2ae6b9542b81$var$HTTP_RANGE_UNIT) throw new Error($9e0a2ae6b9542b81$export$b71577fe3c3fd8a2);
        else {
            let contentSize;
            const contentRangeHeader = headers.get($9e0a2ae6b9542b81$var$HTTP_HEADER_CONTENT_RANGE);
            if (contentRangeHeader) {
                const splitHeader = contentRangeHeader.trim().split(/\s*\/\s*/);
                if (splitHeader.length) {
                    const headerValue = splitHeader[1];
                    if (headerValue && headerValue != "*") contentSize = Number(headerValue);
                }
            }
            if (contentSize === (0, $0302f6c577bd011b$export$a43287864529b8fd)) await $9e0a2ae6b9542b81$var$getContentLength(httpReader, sendRequest, getRequestData);
            else httpReader.size = contentSize;
        }
    } else await $9e0a2ae6b9542b81$var$getContentLength(httpReader, sendRequest, getRequestData);
}
async function $9e0a2ae6b9542b81$var$readUint8ArrayHttpReader(httpReader, index, length, sendRequest, getRequestData) {
    const { data: data, useRangeHeader: useRangeHeader, forceRangeRequests: forceRangeRequests, options: options } = httpReader;
    if (useRangeHeader || forceRangeRequests) {
        const response = await sendRequest($9e0a2ae6b9542b81$var$HTTP_METHOD_GET, httpReader, $9e0a2ae6b9542b81$var$getRangeHeaders(httpReader, index, length));
        if (response.status != 206) throw new Error($9e0a2ae6b9542b81$export$b71577fe3c3fd8a2);
        return new Uint8Array(await response.arrayBuffer());
    } else {
        if (!data) await getRequestData(httpReader, options);
        return new Uint8Array(data.subarray(index, index + length));
    }
}
function $9e0a2ae6b9542b81$var$getRangeHeaders(httpReader, index = 0, length = 1) {
    return Object.assign({}, $9e0a2ae6b9542b81$var$getHeaders(httpReader), {
        [$9e0a2ae6b9542b81$var$HTTP_HEADER_RANGE]: $9e0a2ae6b9542b81$var$HTTP_RANGE_UNIT + "=" + index + "-" + (index + length - 1)
    });
}
function $9e0a2ae6b9542b81$var$getHeaders({ options: options }) {
    const { headers: headers } = options;
    if (headers) {
        if (Symbol.iterator in headers) return Object.fromEntries(headers);
        else return headers;
    }
}
async function $9e0a2ae6b9542b81$var$getFetchRequestData(httpReader) {
    await $9e0a2ae6b9542b81$var$getRequestData(httpReader, $9e0a2ae6b9542b81$var$sendFetchRequest);
}
async function $9e0a2ae6b9542b81$var$getXMLHttpRequestData(httpReader) {
    await $9e0a2ae6b9542b81$var$getRequestData(httpReader, $9e0a2ae6b9542b81$var$sendXMLHttpRequest);
}
async function $9e0a2ae6b9542b81$var$getRequestData(httpReader, sendRequest) {
    const response = await sendRequest($9e0a2ae6b9542b81$var$HTTP_METHOD_GET, httpReader, $9e0a2ae6b9542b81$var$getHeaders(httpReader));
    httpReader.data = new Uint8Array(await response.arrayBuffer());
    if (!httpReader.size) httpReader.size = httpReader.data.length;
}
async function $9e0a2ae6b9542b81$var$getContentLength(httpReader, sendRequest, getRequestData) {
    if (httpReader.preventHeadRequest) await getRequestData(httpReader, httpReader.options);
    else {
        const response = await sendRequest($9e0a2ae6b9542b81$var$HTTP_METHOD_HEAD, httpReader, $9e0a2ae6b9542b81$var$getHeaders(httpReader));
        const contentLength = response.headers.get($9e0a2ae6b9542b81$var$HTTP_HEADER_CONTENT_LENGTH);
        if (contentLength) httpReader.size = Number(contentLength);
        else await getRequestData(httpReader, httpReader.options);
    }
}
async function $9e0a2ae6b9542b81$var$sendFetchRequest(method, { options: options, url: url }, headers) {
    const response = await fetch(url, Object.assign({}, options, {
        method: method,
        headers: headers
    }));
    if (response.status < 400) return response;
    else throw response.status == 416 ? new Error($9e0a2ae6b9542b81$export$b71577fe3c3fd8a2) : new Error($9e0a2ae6b9542b81$var$ERR_HTTP_STATUS + (response.statusText || response.status));
}
function $9e0a2ae6b9542b81$var$sendXMLHttpRequest(method, { url: url }, headers) {
    return new Promise((resolve, reject)=>{
        const request = new XMLHttpRequest();
        request.addEventListener("load", ()=>{
            if (request.status < 400) {
                const headers = [];
                request.getAllResponseHeaders().trim().split(/[\r\n]+/).forEach((header)=>{
                    const splitHeader = header.trim().split(/\s*:\s*/);
                    splitHeader[0] = splitHeader[0].trim().replace(/^[a-z]|-[a-z]/g, (value)=>value.toUpperCase());
                    headers.push(splitHeader);
                });
                resolve({
                    status: request.status,
                    arrayBuffer: ()=>request.response,
                    headers: new Map(headers)
                });
            } else reject(request.status == 416 ? new Error($9e0a2ae6b9542b81$export$b71577fe3c3fd8a2) : new Error($9e0a2ae6b9542b81$var$ERR_HTTP_STATUS + (request.statusText || request.status)));
        }, false);
        request.addEventListener("error", (event)=>reject(event.detail.error), false);
        request.open(method, url);
        if (headers) for (const entry of Object.entries(headers))request.setRequestHeader(entry[0], entry[1]);
        request.responseType = "arraybuffer";
        request.send();
    });
}
class $9e0a2ae6b9542b81$export$34b9a22e660cb902 extends $9e0a2ae6b9542b81$export$2f7a2f0e90c07dc4 {
    constructor(url, options = {}){
        super();
        Object.assign(this, {
            url: url,
            reader: options.useXHR ? new $9e0a2ae6b9542b81$var$XHRReader(url, options) : new $9e0a2ae6b9542b81$var$FetchReader(url, options)
        });
    }
    set size(value) {
    // ignored
    }
    get size() {
        return this.reader.size;
    }
    async init() {
        super.init();
        await this.reader.init();
    }
    readUint8Array(index, length) {
        return this.reader.readUint8Array(index, length);
    }
}
class $9e0a2ae6b9542b81$export$18c85c2468f3bcdb extends $9e0a2ae6b9542b81$export$34b9a22e660cb902 {
    constructor(url, options = {}){
        options.useRangeHeader = true;
        super(url, options);
    }
}
class $9e0a2ae6b9542b81$export$d6e62de78e81ef8b extends $9e0a2ae6b9542b81$export$2f7a2f0e90c07dc4 {
    constructor(array){
        super();
        Object.assign(this, {
            array: array,
            size: array.length
        });
    }
    readUint8Array(index, length) {
        return this.array.slice(index, index + length);
    }
}
class $9e0a2ae6b9542b81$export$1581aa6fcae2be12 extends $9e0a2ae6b9542b81$export$d7a960146e1a269e {
    init(initSize = 0) {
        super.init();
        Object.assign(this, {
            offset: 0,
            array: new Uint8Array(initSize)
        });
    }
    writeUint8Array(array) {
        const writer = this;
        if (writer.offset + array.length > writer.array.length) {
            const previousArray = writer.array;
            writer.array = new Uint8Array(previousArray.length + array.length);
            writer.array.set(previousArray);
        }
        writer.array.set(array, writer.offset);
        writer.offset += array.length;
    }
    getData() {
        return this.array;
    }
}
class $9e0a2ae6b9542b81$export$f5a4bcb16c763bf extends $9e0a2ae6b9542b81$export$2f7a2f0e90c07dc4 {
    constructor(readers){
        super();
        this.readers = readers;
    }
    async init() {
        super.init();
        const reader = this;
        const { readers: readers } = reader;
        reader.lastDiskNumber = 0;
        await Promise.all(readers.map(async (diskReader)=>{
            await diskReader.init();
            reader.size += diskReader.size;
        }));
    }
    async readUint8Array(offset, length, diskNumber = 0) {
        const reader = this;
        const { readers: readers } = this;
        let result;
        let currentDiskNumber = diskNumber;
        if (currentDiskNumber == -1) currentDiskNumber = readers.length - 1;
        let currentReaderOffset = offset;
        while(currentReaderOffset >= readers[currentDiskNumber].size){
            currentReaderOffset -= readers[currentDiskNumber].size;
            currentDiskNumber++;
        }
        const currentReader = readers[currentDiskNumber];
        const currentReaderSize = currentReader.size;
        if (currentReaderOffset + length <= currentReaderSize) result = await $9e0a2ae6b9542b81$export$e21b2fe168d56a89(currentReader, currentReaderOffset, length);
        else {
            const chunkLength = currentReaderSize - currentReaderOffset;
            result = new Uint8Array(length);
            result.set(await $9e0a2ae6b9542b81$export$e21b2fe168d56a89(currentReader, currentReaderOffset, chunkLength));
            result.set(await reader.readUint8Array(offset + chunkLength, length - chunkLength, diskNumber), chunkLength);
        }
        reader.lastDiskNumber = Math.max(currentDiskNumber, reader.lastDiskNumber);
        return result;
    }
}
class $9e0a2ae6b9542b81$export$3fae4ae4d4037452 extends $9e0a2ae6b9542b81$var$Stream {
    constructor(writerGenerator, maxSize = 4294967296){
        super();
        const zipWriter = this;
        Object.assign(zipWriter, {
            diskNumber: 0,
            diskOffset: 0,
            size: 0,
            availableSize: maxSize
        });
        let diskSourceWriter, diskWritable, diskWriter;
        const writable = new WritableStream({
            async write (chunk) {
                if (!diskWriter) {
                    const { value: value, done: done } = await writerGenerator.next();
                    if (done && !value) throw new Error($9e0a2ae6b9542b81$export$7fd7075d73b79aba);
                    else {
                        diskSourceWriter = value;
                        diskSourceWriter.size = 0;
                        diskWritable = value.writable;
                        diskWriter = diskWritable.getWriter();
                    }
                    await this.write(chunk);
                } else if (diskSourceWriter.size + chunk.length >= maxSize) {
                    const chunkLength = maxSize - diskSourceWriter.size;
                    await writeChunk(chunk.slice(0, chunkLength));
                    await closeDisk();
                    zipWriter.diskOffset += diskSourceWriter.size;
                    zipWriter.diskNumber++;
                    diskWriter = null;
                    await this.write(chunk.slice(chunkLength));
                } else {
                    if (chunk.length) await writeChunk(chunk);
                    zipWriter.availableSize = maxSize - diskSourceWriter.size;
                }
            },
            async close () {
                await diskWriter.ready;
                await closeDisk();
            }
        });
        Object.defineProperty(zipWriter, $9e0a2ae6b9542b81$var$PROPERTY_NAME_WRITABLE, {
            get () {
                return writable;
            }
        });
        async function writeChunk(chunk) {
            await diskWriter.ready;
            await diskWriter.write(chunk);
            diskSourceWriter.size += chunk.length;
            zipWriter.size += chunk.length;
        }
        async function closeDisk() {
            diskWritable.size = diskSourceWriter.size;
            await diskWriter.close();
        }
    }
}
function $9e0a2ae6b9542b81$var$isHttpFamily(url) {
    const { baseURL: baseURL } = (0, $1c2d4410a52b3cac$export$3de01744a82b21a4)();
    const { protocol: protocol } = new URL(url, baseURL);
    return protocol == "http:" || protocol == "https:";
}
async function $9e0a2ae6b9542b81$export$a0b98872cda67175(stream, initSize) {
    if (stream.init && !stream.initialized) await stream.init(initSize);
}
function $9e0a2ae6b9542b81$export$e21b2fe168d56a89(reader, offset, size, diskNumber) {
    return reader.readUint8Array(offset, size, diskNumber);
}


/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /* global BigInt, Response, ReadableStream, WritableStream */ // deno-lint-ignore-file no-this-alias




/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /* global TextDecoder */ /*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /* global TextDecoder */ const $53b8e7f2fde80989$var$CP437 = "\0\u263A\u263B\u2665\u2666\u2663\u2660\u2022\u25D8\u25CB\u25D9\u2642\u2640\u266A\u266B\u263C\u25BA\u25C4\u2195\u203C\xb6\xa7\u25AC\u21A8\u2191\u2193\u2192\u2190\u221F\u2194\u25B2\u25BC !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\u2302\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xa2\xa3\xa5\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0 ".split("");
const $53b8e7f2fde80989$var$VALID_CP437 = $53b8e7f2fde80989$var$CP437.length == 256;
function $53b8e7f2fde80989$export$a8c5cef0e5aa59d(stringValue) {
    if ($53b8e7f2fde80989$var$VALID_CP437) {
        let result = "";
        for(let indexCharacter = 0; indexCharacter < stringValue.length; indexCharacter++)result += $53b8e7f2fde80989$var$CP437[stringValue[indexCharacter]];
        return result;
    } else return new TextDecoder().decode(stringValue);
}


function $9168efd57ef556c8$export$ec5093c33bb05608(value, encoding) {
    if (encoding && encoding.trim().toLowerCase() == "cp437") return (0, $53b8e7f2fde80989$export$a8c5cef0e5aa59d)(value);
    else return new TextDecoder(encoding).decode(value);
}



/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ const $c7ffc19d30172d27$var$PROPERTY_NAMES = [
    "filename",
    "rawFilename",
    "directory",
    "encrypted",
    "compressedSize",
    "uncompressedSize",
    "lastModDate",
    "rawLastModDate",
    "comment",
    "rawComment",
    "signature",
    "extraField",
    "rawExtraField",
    "bitFlag",
    "extraFieldZip64",
    "extraFieldUnicodePath",
    "extraFieldUnicodeComment",
    "extraFieldAES",
    "filenameUTF8",
    "commentUTF8",
    "offset",
    "zip64",
    "compressionMethod",
    "extraFieldNTFS",
    "lastAccessDate",
    "creationDate",
    "extraFieldExtendedTimestamp",
    "version",
    "versionMadeBy",
    "msDosCompatible",
    "internalFileAttribute",
    "externalFileAttribute",
    "diskNumberStart"
];
class $c7ffc19d30172d27$export$3bb977b3ba9d3b59 {
    constructor(data){
        $c7ffc19d30172d27$var$PROPERTY_NAMES.forEach((name)=>this[name] = data[name]);
    }
}


const $fe13039a5c7d1454$export$cdcc3e34e6ecabd5 = "File format is not recognized";
const $fe13039a5c7d1454$export$b6d0395361933eb0 = "End of central directory not found";
const $fe13039a5c7d1454$export$3051d6f90cf589c8 = "End of Zip64 central directory not found";
const $fe13039a5c7d1454$export$6aed7fa9c46f86f3 = "End of Zip64 central directory locator not found";
const $fe13039a5c7d1454$export$887abb173462391f = "Central directory header not found";
const $fe13039a5c7d1454$export$63582277da496ca7 = "Local file header not found";
const $fe13039a5c7d1454$export$f12a4c2bd2e2cd28 = "Zip64 extra field not found";
const $fe13039a5c7d1454$export$812ffdea842816a5 = "File contains encrypted entry";
const $fe13039a5c7d1454$export$dfb2271b2ffc772d = "Encryption method not supported";
const $fe13039a5c7d1454$export$923b2f78451b7a99 = "Compression method not supported";
const $fe13039a5c7d1454$export$555887561ca63f85 = "Split zip file";
const $fe13039a5c7d1454$var$CHARSET_UTF8 = "utf-8";
const $fe13039a5c7d1454$var$CHARSET_CP437 = "cp437";
const $fe13039a5c7d1454$var$ZIP64_PROPERTIES = [
    [
        "uncompressedSize",
        (0, $0302f6c577bd011b$export$dbfc2ae0cf3df69a)
    ],
    [
        "compressedSize",
        (0, $0302f6c577bd011b$export$dbfc2ae0cf3df69a)
    ],
    [
        "offset",
        (0, $0302f6c577bd011b$export$dbfc2ae0cf3df69a)
    ],
    [
        "diskNumberStart",
        (0, $0302f6c577bd011b$export$4164cee1a26178fd)
    ]
];
const $fe13039a5c7d1454$var$ZIP64_EXTRACTION = {
    [(0, $0302f6c577bd011b$export$4164cee1a26178fd)]: {
        getValue: $fe13039a5c7d1454$var$getUint32,
        bytes: 4
    },
    [(0, $0302f6c577bd011b$export$dbfc2ae0cf3df69a)]: {
        getValue: $fe13039a5c7d1454$var$getBigUint64,
        bytes: 8
    }
};
class $fe13039a5c7d1454$export$25e4af3b2af7fc76 {
    constructor(reader, options = {}){
        if (reader instanceof ReadableStream) reader = {
            readable: reader
        };
        Object.assign(this, {
            reader: reader,
            options: options,
            config: (0, $1c2d4410a52b3cac$export$3de01744a82b21a4)()
        });
    }
    async *getEntriesGenerator(options = {}) {
        const zipReader = this;
        let { reader: reader } = zipReader;
        const { config: config } = zipReader;
        await (0, $9e0a2ae6b9542b81$export$a0b98872cda67175)(reader);
        if (reader.size === (0, $0302f6c577bd011b$export$a43287864529b8fd) || !reader.readUint8Array) {
            if (Array.isArray(reader)) reader = new (0, $9e0a2ae6b9542b81$export$f5a4bcb16c763bf)(reader);
            else reader = new (0, $9e0a2ae6b9542b81$export$aa5015be25fe7f79)(await new Response(reader.readable).blob());
            await (0, $9e0a2ae6b9542b81$export$a0b98872cda67175)(reader);
        }
        if (reader.size < (0, $0302f6c577bd011b$export$6383d4b2e2323b68)) throw new Error($fe13039a5c7d1454$export$cdcc3e34e6ecabd5);
        reader.chunkSize = (0, $1c2d4410a52b3cac$export$f0bad416b890a4ec)(config);
        const endOfDirectoryInfo = await $fe13039a5c7d1454$var$seekSignature(reader, (0, $0302f6c577bd011b$export$13a06f7e64cf6a1), reader.size, (0, $0302f6c577bd011b$export$6383d4b2e2323b68), (0, $0302f6c577bd011b$export$4164cee1a26178fd) * 16);
        if (!endOfDirectoryInfo) {
            const signatureArray = await (0, $9e0a2ae6b9542b81$export$e21b2fe168d56a89)(reader, 0, 4);
            const signatureView = $fe13039a5c7d1454$var$getDataView(signatureArray);
            if ($fe13039a5c7d1454$var$getUint32(signatureView) == (0, $0302f6c577bd011b$export$40fbd2cd06477e1d)) throw new Error($fe13039a5c7d1454$export$555887561ca63f85);
            else throw new Error($fe13039a5c7d1454$export$b6d0395361933eb0);
        }
        const endOfDirectoryView = $fe13039a5c7d1454$var$getDataView(endOfDirectoryInfo);
        let directoryDataLength = $fe13039a5c7d1454$var$getUint32(endOfDirectoryView, 12);
        let directoryDataOffset = $fe13039a5c7d1454$var$getUint32(endOfDirectoryView, 16);
        const commentOffset = endOfDirectoryInfo.offset;
        const commentLength = $fe13039a5c7d1454$var$getUint16(endOfDirectoryView, 20);
        const appendedDataOffset = commentOffset + (0, $0302f6c577bd011b$export$6383d4b2e2323b68) + commentLength;
        const lastDiskNumber = $fe13039a5c7d1454$var$getUint16(endOfDirectoryView, 4);
        const expectedLastDiskNumber = reader.lastDiskNumber || 0;
        let diskNumber = $fe13039a5c7d1454$var$getUint16(endOfDirectoryView, 6);
        if (expectedLastDiskNumber != lastDiskNumber) throw new Error($fe13039a5c7d1454$export$555887561ca63f85);
        let filesLength = $fe13039a5c7d1454$var$getUint16(endOfDirectoryView, 8);
        let prependedDataLength = 0;
        let startOffset = 0;
        if (directoryDataOffset == (0, $0302f6c577bd011b$export$dbfc2ae0cf3df69a) || directoryDataLength == (0, $0302f6c577bd011b$export$dbfc2ae0cf3df69a) || filesLength == (0, $0302f6c577bd011b$export$4164cee1a26178fd) || diskNumber == (0, $0302f6c577bd011b$export$4164cee1a26178fd)) {
            const endOfDirectoryLocatorArray = await (0, $9e0a2ae6b9542b81$export$e21b2fe168d56a89)(reader, endOfDirectoryInfo.offset - (0, $0302f6c577bd011b$export$c545bb91a1b43732), (0, $0302f6c577bd011b$export$c545bb91a1b43732));
            const endOfDirectoryLocatorView = $fe13039a5c7d1454$var$getDataView(endOfDirectoryLocatorArray);
            if ($fe13039a5c7d1454$var$getUint32(endOfDirectoryLocatorView, 0) != (0, $0302f6c577bd011b$export$5078166106cbcc66)) throw new Error($fe13039a5c7d1454$export$3051d6f90cf589c8);
            directoryDataOffset = $fe13039a5c7d1454$var$getBigUint64(endOfDirectoryLocatorView, 8);
            let endOfDirectoryArray = await (0, $9e0a2ae6b9542b81$export$e21b2fe168d56a89)(reader, directoryDataOffset, (0, $0302f6c577bd011b$export$9eb09cdd39f04a62), -1);
            let endOfDirectoryView = $fe13039a5c7d1454$var$getDataView(endOfDirectoryArray);
            const expectedDirectoryDataOffset = endOfDirectoryInfo.offset - (0, $0302f6c577bd011b$export$c545bb91a1b43732) - (0, $0302f6c577bd011b$export$9eb09cdd39f04a62);
            if ($fe13039a5c7d1454$var$getUint32(endOfDirectoryView, 0) != (0, $0302f6c577bd011b$export$8414b1953f7f48c6) && directoryDataOffset != expectedDirectoryDataOffset) {
                const originalDirectoryDataOffset = directoryDataOffset;
                directoryDataOffset = expectedDirectoryDataOffset;
                prependedDataLength = directoryDataOffset - originalDirectoryDataOffset;
                endOfDirectoryArray = await (0, $9e0a2ae6b9542b81$export$e21b2fe168d56a89)(reader, directoryDataOffset, (0, $0302f6c577bd011b$export$9eb09cdd39f04a62), -1);
                endOfDirectoryView = $fe13039a5c7d1454$var$getDataView(endOfDirectoryArray);
            }
            if ($fe13039a5c7d1454$var$getUint32(endOfDirectoryView, 0) != (0, $0302f6c577bd011b$export$8414b1953f7f48c6)) throw new Error($fe13039a5c7d1454$export$6aed7fa9c46f86f3);
            if (diskNumber == (0, $0302f6c577bd011b$export$4164cee1a26178fd)) diskNumber = $fe13039a5c7d1454$var$getUint32(endOfDirectoryView, 16);
            if (filesLength == (0, $0302f6c577bd011b$export$4164cee1a26178fd)) filesLength = $fe13039a5c7d1454$var$getBigUint64(endOfDirectoryView, 32);
            if (directoryDataLength == (0, $0302f6c577bd011b$export$dbfc2ae0cf3df69a)) directoryDataLength = $fe13039a5c7d1454$var$getBigUint64(endOfDirectoryView, 40);
            directoryDataOffset -= directoryDataLength;
        }
        if (directoryDataOffset < 0 || directoryDataOffset >= reader.size) throw new Error($fe13039a5c7d1454$export$cdcc3e34e6ecabd5);
        let offset = 0;
        let directoryArray = await (0, $9e0a2ae6b9542b81$export$e21b2fe168d56a89)(reader, directoryDataOffset, directoryDataLength, diskNumber);
        let directoryView = $fe13039a5c7d1454$var$getDataView(directoryArray);
        if (directoryDataLength) {
            const expectedDirectoryDataOffset = endOfDirectoryInfo.offset - directoryDataLength;
            if ($fe13039a5c7d1454$var$getUint32(directoryView, offset) != (0, $0302f6c577bd011b$export$a72d49bf27f9bcd) && directoryDataOffset != expectedDirectoryDataOffset) {
                const originalDirectoryDataOffset = directoryDataOffset;
                directoryDataOffset = expectedDirectoryDataOffset;
                prependedDataLength = directoryDataOffset - originalDirectoryDataOffset;
                directoryArray = await (0, $9e0a2ae6b9542b81$export$e21b2fe168d56a89)(reader, directoryDataOffset, directoryDataLength, diskNumber);
                directoryView = $fe13039a5c7d1454$var$getDataView(directoryArray);
            }
        }
        if (directoryDataOffset < 0 || directoryDataOffset >= reader.size) throw new Error($fe13039a5c7d1454$export$cdcc3e34e6ecabd5);
        const filenameEncoding = $fe13039a5c7d1454$var$getOptionValue(zipReader, options, "filenameEncoding");
        const commentEncoding = $fe13039a5c7d1454$var$getOptionValue(zipReader, options, "commentEncoding");
        for(let indexFile = 0; indexFile < filesLength; indexFile++){
            const fileEntry = new $fe13039a5c7d1454$var$ZipEntry(reader, config, zipReader.options);
            if ($fe13039a5c7d1454$var$getUint32(directoryView, offset) != (0, $0302f6c577bd011b$export$a72d49bf27f9bcd)) throw new Error($fe13039a5c7d1454$export$887abb173462391f);
            $fe13039a5c7d1454$var$readCommonHeader(fileEntry, directoryView, offset + 6);
            const languageEncodingFlag = Boolean(fileEntry.bitFlag.languageEncodingFlag);
            const filenameOffset = offset + 46;
            const extraFieldOffset = filenameOffset + fileEntry.filenameLength;
            const commentOffset = extraFieldOffset + fileEntry.extraFieldLength;
            const versionMadeBy = $fe13039a5c7d1454$var$getUint16(directoryView, offset + 4);
            const msDosCompatible = (versionMadeBy & 0) == 0;
            const rawFilename = directoryArray.subarray(filenameOffset, extraFieldOffset);
            const commentLength = $fe13039a5c7d1454$var$getUint16(directoryView, offset + 32);
            const endOffset = commentOffset + commentLength;
            const rawComment = directoryArray.subarray(commentOffset, endOffset);
            const filenameUTF8 = languageEncodingFlag;
            const commentUTF8 = languageEncodingFlag;
            const directory = msDosCompatible && ($fe13039a5c7d1454$var$getUint8(directoryView, offset + 38) & (0, $0302f6c577bd011b$export$2d169f352844a92f)) == (0, $0302f6c577bd011b$export$2d169f352844a92f);
            const offsetFileEntry = $fe13039a5c7d1454$var$getUint32(directoryView, offset + 42) + prependedDataLength;
            Object.assign(fileEntry, {
                versionMadeBy: versionMadeBy,
                msDosCompatible: msDosCompatible,
                compressedSize: 0,
                uncompressedSize: 0,
                commentLength: commentLength,
                directory: directory,
                offset: offsetFileEntry,
                diskNumberStart: $fe13039a5c7d1454$var$getUint16(directoryView, offset + 34),
                internalFileAttribute: $fe13039a5c7d1454$var$getUint16(directoryView, offset + 36),
                externalFileAttribute: $fe13039a5c7d1454$var$getUint32(directoryView, offset + 38),
                rawFilename: rawFilename,
                filenameUTF8: filenameUTF8,
                commentUTF8: commentUTF8,
                rawExtraField: directoryArray.subarray(extraFieldOffset, commentOffset)
            });
            const [filename, comment] = await Promise.all([
                (0, $9168efd57ef556c8$export$ec5093c33bb05608)(rawFilename, filenameUTF8 ? $fe13039a5c7d1454$var$CHARSET_UTF8 : filenameEncoding || $fe13039a5c7d1454$var$CHARSET_CP437),
                (0, $9168efd57ef556c8$export$ec5093c33bb05608)(rawComment, commentUTF8 ? $fe13039a5c7d1454$var$CHARSET_UTF8 : commentEncoding || $fe13039a5c7d1454$var$CHARSET_CP437)
            ]);
            Object.assign(fileEntry, {
                rawComment: rawComment,
                filename: filename,
                comment: comment,
                directory: directory || filename.endsWith((0, $0302f6c577bd011b$export$4a765df57d89fe04))
            });
            startOffset = Math.max(offsetFileEntry, startOffset);
            await $fe13039a5c7d1454$var$readCommonFooter(fileEntry, fileEntry, directoryView, offset + 6);
            const entry = new (0, $c7ffc19d30172d27$export$3bb977b3ba9d3b59)(fileEntry);
            entry.getData = (writer, options)=>fileEntry.getData(writer, entry, options);
            offset = endOffset;
            const { onprogress: onprogress } = options;
            if (onprogress) try {
                await onprogress(indexFile + 1, filesLength, new (0, $c7ffc19d30172d27$export$3bb977b3ba9d3b59)(fileEntry));
            } catch (_error) {
            // ignored
            }
            yield entry;
        }
        const extractPrependedData = $fe13039a5c7d1454$var$getOptionValue(zipReader, options, "extractPrependedData");
        const extractAppendedData = $fe13039a5c7d1454$var$getOptionValue(zipReader, options, "extractAppendedData");
        if (extractPrependedData) zipReader.prependedData = startOffset > 0 ? await (0, $9e0a2ae6b9542b81$export$e21b2fe168d56a89)(reader, 0, startOffset) : new Uint8Array();
        zipReader.comment = commentLength ? await (0, $9e0a2ae6b9542b81$export$e21b2fe168d56a89)(reader, commentOffset + (0, $0302f6c577bd011b$export$6383d4b2e2323b68), commentLength) : new Uint8Array();
        if (extractAppendedData) zipReader.appendedData = appendedDataOffset < reader.size ? await (0, $9e0a2ae6b9542b81$export$e21b2fe168d56a89)(reader, appendedDataOffset, reader.size - appendedDataOffset) : new Uint8Array();
        return true;
    }
    async getEntries(options = {}) {
        const entries = [];
        for await (const entry of this.getEntriesGenerator(options))entries.push(entry);
        return entries;
    }
    async close() {}
}
class $fe13039a5c7d1454$var$ZipEntry {
    constructor(reader, config, options){
        Object.assign(this, {
            reader: reader,
            config: config,
            options: options
        });
    }
    async getData(writer, fileEntry, options = {}) {
        const zipEntry = this;
        const { reader: reader, offset: offset, diskNumberStart: diskNumberStart, extraFieldAES: extraFieldAES, compressionMethod: compressionMethod, config: config, bitFlag: bitFlag, signature: signature, rawLastModDate: rawLastModDate, uncompressedSize: uncompressedSize, compressedSize: compressedSize } = zipEntry;
        const localDirectory = zipEntry.localDirectory = {};
        const dataArray = await (0, $9e0a2ae6b9542b81$export$e21b2fe168d56a89)(reader, offset, 30, diskNumberStart);
        const dataView = $fe13039a5c7d1454$var$getDataView(dataArray);
        let password = $fe13039a5c7d1454$var$getOptionValue(zipEntry, options, "password");
        password = password && password.length && password;
        if (extraFieldAES) {
            if (extraFieldAES.originalCompressionMethod != (0, $0302f6c577bd011b$export$367f2443b409227a)) throw new Error($fe13039a5c7d1454$export$923b2f78451b7a99);
        }
        if (compressionMethod != (0, $0302f6c577bd011b$export$6135a805f19e5577) && compressionMethod != (0, $0302f6c577bd011b$export$2cf0a12381b29e07)) throw new Error($fe13039a5c7d1454$export$923b2f78451b7a99);
        if ($fe13039a5c7d1454$var$getUint32(dataView, 0) != (0, $0302f6c577bd011b$export$2b2cf5904cb82788)) throw new Error($fe13039a5c7d1454$export$63582277da496ca7);
        $fe13039a5c7d1454$var$readCommonHeader(localDirectory, dataView, 4);
        localDirectory.rawExtraField = localDirectory.extraFieldLength ? await (0, $9e0a2ae6b9542b81$export$e21b2fe168d56a89)(reader, offset + 30 + localDirectory.filenameLength, localDirectory.extraFieldLength, diskNumberStart) : new Uint8Array();
        await $fe13039a5c7d1454$var$readCommonFooter(zipEntry, localDirectory, dataView, 4);
        Object.assign(fileEntry, {
            lastAccessDate: localDirectory.lastAccessDate,
            creationDate: localDirectory.creationDate
        });
        const encrypted = zipEntry.encrypted && localDirectory.encrypted;
        const zipCrypto = encrypted && !extraFieldAES;
        if (encrypted) {
            if (!zipCrypto && extraFieldAES.strength === (0, $0302f6c577bd011b$export$a43287864529b8fd)) throw new Error($fe13039a5c7d1454$export$dfb2271b2ffc772d);
            else if (!password) throw new Error($fe13039a5c7d1454$export$812ffdea842816a5);
        }
        const dataOffset = offset + 30 + localDirectory.filenameLength + localDirectory.extraFieldLength;
        const readable = reader.readable;
        readable.diskNumberStart = diskNumberStart;
        readable.offset = dataOffset;
        const size = readable.size = compressedSize;
        if (writer instanceof WritableStream) writer = {
            writable: writer
        };
        const { writable: writable } = writer;
        if (writable.size === (0, $0302f6c577bd011b$export$a43287864529b8fd)) writable.size = 0;
        const signal = $fe13039a5c7d1454$var$getOptionValue(zipEntry, options, "signal");
        await (0, $9e0a2ae6b9542b81$export$a0b98872cda67175)(writer, uncompressedSize);
        const { onstart: onstart, onprogress: onprogress, onend: onend } = options;
        const workerOptions = {
            options: {
                codecType: (0, $fda7c3f883c12402$export$1c8ed04f989a62a8),
                password: password,
                zipCrypto: zipCrypto,
                encryptionStrength: extraFieldAES && extraFieldAES.strength,
                signed: $fe13039a5c7d1454$var$getOptionValue(zipEntry, options, "checkSignature"),
                passwordVerification: zipCrypto && (bitFlag.dataDescriptor ? rawLastModDate >>> 8 & 0xFF : signature >>> 24 & 0xFF),
                signature: signature,
                compressed: compressionMethod != 0,
                encrypted: encrypted,
                useWebWorkers: $fe13039a5c7d1454$var$getOptionValue(zipEntry, options, "useWebWorkers"),
                useCompressionStream: $fe13039a5c7d1454$var$getOptionValue(zipEntry, options, "useCompressionStream"),
                transferStreams: $fe13039a5c7d1454$var$getOptionValue(zipEntry, options, "transferStreams")
            },
            config: config,
            streamOptions: {
                signal: signal,
                size: size,
                onstart: onstart,
                onprogress: onprogress,
                onend: onend
            }
        };
        writable.size += (await (0, $2f7887a251aac91a$export$dd2e08b4a54c623f)({
            readable: readable,
            writable: writable
        }, workerOptions)).size;
        const preventClose = $fe13039a5c7d1454$var$getOptionValue(zipEntry, options, "preventClose");
        if (!preventClose) await writable.close();
        return writer.getData ? writer.getData() : writable;
    }
}
function $fe13039a5c7d1454$var$readCommonHeader(directory, dataView, offset) {
    const rawBitFlag = directory.rawBitFlag = $fe13039a5c7d1454$var$getUint16(dataView, offset + 2);
    const encrypted = (rawBitFlag & (0, $0302f6c577bd011b$export$7db0c075c39cb343)) == (0, $0302f6c577bd011b$export$7db0c075c39cb343);
    const rawLastModDate = $fe13039a5c7d1454$var$getUint32(dataView, offset + 6);
    Object.assign(directory, {
        encrypted: encrypted,
        version: $fe13039a5c7d1454$var$getUint16(dataView, offset),
        bitFlag: {
            level: (rawBitFlag & (0, $0302f6c577bd011b$export$ac9ca09a23eb90ff)) >> 1,
            dataDescriptor: (rawBitFlag & (0, $0302f6c577bd011b$export$3ec1d940e3bc0a58)) == (0, $0302f6c577bd011b$export$3ec1d940e3bc0a58),
            languageEncodingFlag: (rawBitFlag & (0, $0302f6c577bd011b$export$fb6e9f896320db55)) == (0, $0302f6c577bd011b$export$fb6e9f896320db55)
        },
        rawLastModDate: rawLastModDate,
        lastModDate: $fe13039a5c7d1454$var$getDate(rawLastModDate),
        filenameLength: $fe13039a5c7d1454$var$getUint16(dataView, offset + 22),
        extraFieldLength: $fe13039a5c7d1454$var$getUint16(dataView, offset + 24)
    });
}
async function $fe13039a5c7d1454$var$readCommonFooter(fileEntry, directory, dataView, offset) {
    const { rawExtraField: rawExtraField } = directory;
    const extraField = directory.extraField = new Map();
    const rawExtraFieldView = $fe13039a5c7d1454$var$getDataView(new Uint8Array(rawExtraField));
    let offsetExtraField = 0;
    try {
        while(offsetExtraField < rawExtraField.length){
            const type = $fe13039a5c7d1454$var$getUint16(rawExtraFieldView, offsetExtraField);
            const size = $fe13039a5c7d1454$var$getUint16(rawExtraFieldView, offsetExtraField + 2);
            extraField.set(type, {
                type: type,
                data: rawExtraField.slice(offsetExtraField + 4, offsetExtraField + 4 + size)
            });
            offsetExtraField += 4 + size;
        }
    } catch (_error) {
    // ignored
    }
    const compressionMethod = $fe13039a5c7d1454$var$getUint16(dataView, offset + 4);
    Object.assign(directory, {
        signature: $fe13039a5c7d1454$var$getUint32(dataView, offset + 10),
        uncompressedSize: $fe13039a5c7d1454$var$getUint32(dataView, offset + 18),
        compressedSize: $fe13039a5c7d1454$var$getUint32(dataView, offset + 14)
    });
    const extraFieldZip64 = extraField.get((0, $0302f6c577bd011b$export$3da9e4d76b1bf88));
    if (extraFieldZip64) {
        $fe13039a5c7d1454$var$readExtraFieldZip64(extraFieldZip64, directory);
        directory.extraFieldZip64 = extraFieldZip64;
    }
    const extraFieldUnicodePath = extraField.get((0, $0302f6c577bd011b$export$b48bdd5195f1a53a));
    if (extraFieldUnicodePath) {
        await $fe13039a5c7d1454$var$readExtraFieldUnicode(extraFieldUnicodePath, "filename", "rawFilename", directory, fileEntry);
        directory.extraFieldUnicodePath = extraFieldUnicodePath;
    }
    const extraFieldUnicodeComment = extraField.get((0, $0302f6c577bd011b$export$b49699c0acb50fe1));
    if (extraFieldUnicodeComment) {
        await $fe13039a5c7d1454$var$readExtraFieldUnicode(extraFieldUnicodeComment, "comment", "rawComment", directory, fileEntry);
        directory.extraFieldUnicodeComment = extraFieldUnicodeComment;
    }
    const extraFieldAES = extraField.get((0, $0302f6c577bd011b$export$714aa3fe052f4e13));
    if (extraFieldAES) {
        $fe13039a5c7d1454$var$readExtraFieldAES(extraFieldAES, directory, compressionMethod);
        directory.extraFieldAES = extraFieldAES;
    } else directory.compressionMethod = compressionMethod;
    const extraFieldNTFS = extraField.get((0, $0302f6c577bd011b$export$93e014de2b9c33c8));
    if (extraFieldNTFS) {
        $fe13039a5c7d1454$var$readExtraFieldNTFS(extraFieldNTFS, directory);
        directory.extraFieldNTFS = extraFieldNTFS;
    }
    const extraFieldExtendedTimestamp = extraField.get((0, $0302f6c577bd011b$export$6cfe9e8823acaac3));
    if (extraFieldExtendedTimestamp) {
        $fe13039a5c7d1454$var$readExtraFieldExtendedTimestamp(extraFieldExtendedTimestamp, directory);
        directory.extraFieldExtendedTimestamp = extraFieldExtendedTimestamp;
    }
}
function $fe13039a5c7d1454$var$readExtraFieldZip64(extraFieldZip64, directory) {
    directory.zip64 = true;
    const extraFieldView = $fe13039a5c7d1454$var$getDataView(extraFieldZip64.data);
    const missingProperties = $fe13039a5c7d1454$var$ZIP64_PROPERTIES.filter(([propertyName, max])=>directory[propertyName] == max);
    for(let indexMissingProperty = 0, offset = 0; indexMissingProperty < missingProperties.length; indexMissingProperty++){
        const [propertyName, max] = missingProperties[indexMissingProperty];
        if (directory[propertyName] == max) {
            const extraction = $fe13039a5c7d1454$var$ZIP64_EXTRACTION[max];
            directory[propertyName] = extraFieldZip64[propertyName] = extraction.getValue(extraFieldView, offset);
            offset += extraction.bytes;
        } else if (extraFieldZip64[propertyName]) throw new Error($fe13039a5c7d1454$export$f12a4c2bd2e2cd28);
    }
}
async function $fe13039a5c7d1454$var$readExtraFieldUnicode(extraFieldUnicode, propertyName, rawPropertyName, directory, fileEntry) {
    const extraFieldView = $fe13039a5c7d1454$var$getDataView(extraFieldUnicode.data);
    const crc32 = new (0, $7272846072e67247$export$16d8d62894c71747)();
    crc32.append(fileEntry[rawPropertyName]);
    const dataViewSignature = $fe13039a5c7d1454$var$getDataView(new Uint8Array(4));
    dataViewSignature.setUint32(0, crc32.get(), true);
    Object.assign(extraFieldUnicode, {
        version: $fe13039a5c7d1454$var$getUint8(extraFieldView, 0),
        signature: $fe13039a5c7d1454$var$getUint32(extraFieldView, 1),
        [propertyName]: await (0, $9168efd57ef556c8$export$ec5093c33bb05608)(extraFieldUnicode.data.subarray(5)),
        valid: !fileEntry.bitFlag.languageEncodingFlag && extraFieldUnicode.signature == $fe13039a5c7d1454$var$getUint32(dataViewSignature, 0)
    });
    if (extraFieldUnicode.valid) {
        directory[propertyName] = extraFieldUnicode[propertyName];
        directory[propertyName + "UTF8"] = true;
    }
}
function $fe13039a5c7d1454$var$readExtraFieldAES(extraFieldAES, directory, compressionMethod) {
    const extraFieldView = $fe13039a5c7d1454$var$getDataView(extraFieldAES.data);
    const strength = $fe13039a5c7d1454$var$getUint8(extraFieldView, 4);
    Object.assign(extraFieldAES, {
        vendorVersion: $fe13039a5c7d1454$var$getUint8(extraFieldView, 0),
        vendorId: $fe13039a5c7d1454$var$getUint8(extraFieldView, 2),
        strength: strength,
        originalCompressionMethod: compressionMethod,
        compressionMethod: $fe13039a5c7d1454$var$getUint16(extraFieldView, 5)
    });
    directory.compressionMethod = extraFieldAES.compressionMethod;
}
function $fe13039a5c7d1454$var$readExtraFieldNTFS(extraFieldNTFS, directory) {
    const extraFieldView = $fe13039a5c7d1454$var$getDataView(extraFieldNTFS.data);
    let offsetExtraField = 4;
    let tag1Data;
    try {
        while(offsetExtraField < extraFieldNTFS.data.length && !tag1Data){
            const tagValue = $fe13039a5c7d1454$var$getUint16(extraFieldView, offsetExtraField);
            const attributeSize = $fe13039a5c7d1454$var$getUint16(extraFieldView, offsetExtraField + 2);
            if (tagValue == (0, $0302f6c577bd011b$export$109a97d45e55cdec)) tag1Data = extraFieldNTFS.data.slice(offsetExtraField + 4, offsetExtraField + 4 + attributeSize);
            offsetExtraField += 4 + attributeSize;
        }
    } catch (_error) {
    // ignored
    }
    try {
        if (tag1Data && tag1Data.length == 24) {
            const tag1View = $fe13039a5c7d1454$var$getDataView(tag1Data);
            const rawLastModDate = tag1View.getBigUint64(0, true);
            const rawLastAccessDate = tag1View.getBigUint64(8, true);
            const rawCreationDate = tag1View.getBigUint64(16, true);
            Object.assign(extraFieldNTFS, {
                rawLastModDate: rawLastModDate,
                rawLastAccessDate: rawLastAccessDate,
                rawCreationDate: rawCreationDate
            });
            const lastModDate = $fe13039a5c7d1454$var$getDateNTFS(rawLastModDate);
            const lastAccessDate = $fe13039a5c7d1454$var$getDateNTFS(rawLastAccessDate);
            const creationDate = $fe13039a5c7d1454$var$getDateNTFS(rawCreationDate);
            const extraFieldData = {
                lastModDate: lastModDate,
                lastAccessDate: lastAccessDate,
                creationDate: creationDate
            };
            Object.assign(extraFieldNTFS, extraFieldData);
            Object.assign(directory, extraFieldData);
        }
    } catch (_error) {
    // ignored
    }
}
function $fe13039a5c7d1454$var$readExtraFieldExtendedTimestamp(extraFieldExtendedTimestamp, directory) {
    const extraFieldView = $fe13039a5c7d1454$var$getDataView(extraFieldExtendedTimestamp.data);
    const flags = $fe13039a5c7d1454$var$getUint8(extraFieldView, 0);
    const timeProperties = [];
    const timeRawProperties = [];
    if ((flags & 0x1) == 0x1) {
        timeProperties.push("lastModDate");
        timeRawProperties.push("rawLastModDate");
    }
    if ((flags & 0x2) == 0x2) {
        timeProperties.push("lastAccessDate");
        timeRawProperties.push("rawLastAccessDate");
    }
    if ((flags & 0x4) == 0x4) {
        timeProperties.push("creationDate");
        timeRawProperties.push("rawCreationDate");
    }
    let offset = 1;
    timeProperties.forEach((propertyName, indexProperty)=>{
        if (extraFieldExtendedTimestamp.data.length >= offset + 4) {
            const time = $fe13039a5c7d1454$var$getUint32(extraFieldView, offset);
            directory[propertyName] = extraFieldExtendedTimestamp[propertyName] = new Date(time * 1000);
            const rawPropertyName = timeRawProperties[indexProperty];
            extraFieldExtendedTimestamp[rawPropertyName] = time;
        }
        offset += 4;
    });
}
async function $fe13039a5c7d1454$var$seekSignature(reader, signature, startOffset, minimumBytes, maximumLength) {
    const signatureArray = new Uint8Array(4);
    const signatureView = $fe13039a5c7d1454$var$getDataView(signatureArray);
    $fe13039a5c7d1454$var$setUint32(signatureView, 0, signature);
    const maximumBytes = minimumBytes + maximumLength;
    return await seek(minimumBytes) || await seek(Math.min(maximumBytes, startOffset));
    async function seek(length) {
        const offset = startOffset - length;
        const bytes = await (0, $9e0a2ae6b9542b81$export$e21b2fe168d56a89)(reader, offset, length);
        for(let indexByte = bytes.length - minimumBytes; indexByte >= 0; indexByte--){
            if (bytes[indexByte] == signatureArray[0] && bytes[indexByte + 1] == signatureArray[1] && bytes[indexByte + 2] == signatureArray[2] && bytes[indexByte + 3] == signatureArray[3]) return {
                offset: offset + indexByte,
                buffer: bytes.slice(indexByte, indexByte + minimumBytes).buffer
            };
        }
    }
}
function $fe13039a5c7d1454$var$getOptionValue(zipReader, options, name) {
    return options[name] === (0, $0302f6c577bd011b$export$a43287864529b8fd) ? zipReader.options[name] : options[name];
}
function $fe13039a5c7d1454$var$getDate(timeRaw) {
    const date = (timeRaw & 0xffff0000) >> 16, time = timeRaw & 0x0000ffff;
    try {
        return new Date(1980 + ((date & 0xFE00) >> 9), ((date & 0x01E0) >> 5) - 1, date & 0x001F, (time & 0xF800) >> 11, (time & 0x07E0) >> 5, (time & 0x001F) * 2, 0);
    } catch (_error) {
    // ignored
    }
}
function $fe13039a5c7d1454$var$getDateNTFS(timeRaw) {
    return new Date(Number(timeRaw / BigInt(10000) - BigInt(11644473600000)));
}
function $fe13039a5c7d1454$var$getUint8(view, offset) {
    return view.getUint8(offset);
}
function $fe13039a5c7d1454$var$getUint16(view, offset) {
    return view.getUint16(offset, true);
}
function $fe13039a5c7d1454$var$getUint32(view, offset) {
    return view.getUint32(offset, true);
}
function $fe13039a5c7d1454$var$getBigUint64(view, offset) {
    return Number(view.getBigUint64(offset, true));
}
function $fe13039a5c7d1454$var$setUint32(view, offset, value) {
    view.setUint32(offset, value, true);
}
function $fe13039a5c7d1454$var$getDataView(array) {
    return new DataView(array.buffer);
}


/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /* global BigInt, ReadableStream, WritableStream */ // deno-lint-ignore-file no-this-alias






const $2cb90b9cb96d205a$export$c3407be3767d007d = "File already exists";
const $2cb90b9cb96d205a$export$aa00b8eb8e30f01e = "Zip file comment exceeds 64KB";
const $2cb90b9cb96d205a$export$c5631773b8d6c9e2 = "File entry comment exceeds 64KB";
const $2cb90b9cb96d205a$export$e7ba549a0a27f4f5 = "File entry name exceeds 64KB";
const $2cb90b9cb96d205a$export$6a674c09fe1f3dec = "Version exceeds 65535";
const $2cb90b9cb96d205a$export$a52a97f6f11df530 = "The strength must equal 1, 2, or 3";
const $2cb90b9cb96d205a$export$84caeb3441d47629 = "Extra field type exceeds 65535";
const $2cb90b9cb96d205a$export$ca2bf648520d566 = "Extra field data exceeds 64KB";
const $2cb90b9cb96d205a$export$2866c0d2403d5bac = "Zip64 is not supported (make sure 'keepOrder' is set to 'true')";
const $2cb90b9cb96d205a$var$EXTRAFIELD_DATA_AES = new Uint8Array([
    0x07,
    0x00,
    0x02,
    0x00,
    0x41,
    0x45,
    0x03,
    0x00,
    0x00
]);
const $2cb90b9cb96d205a$var$EXTRAFIELD_LENGTH_ZIP64 = 28;
let $2cb90b9cb96d205a$var$workers = 0;
const $2cb90b9cb96d205a$var$pendingEntries = [];
class $2cb90b9cb96d205a$export$50f5658480930b4c {
    constructor(writer, options = {}){
        if (writer.writable === (0, $0302f6c577bd011b$export$a43287864529b8fd) && typeof writer.next == (0, $0302f6c577bd011b$export$31a3bc04c4494acf)) writer = new (0, $9e0a2ae6b9542b81$export$3fae4ae4d4037452)(writer);
        if (writer instanceof WritableStream) writer = {
            writable: writer
        };
        if (writer.writable.size === (0, $0302f6c577bd011b$export$a43287864529b8fd)) writer.writable.size = 0;
        const splitZipFile = writer instanceof (0, $9e0a2ae6b9542b81$export$3fae4ae4d4037452);
        if (!splitZipFile) Object.assign(writer, {
            diskNumber: 0,
            diskOffset: 0,
            availableSize: Infinity
        });
        Object.assign(this, {
            writer: writer,
            addSplitZipSignature: splitZipFile,
            options: options,
            config: (0, $1c2d4410a52b3cac$export$3de01744a82b21a4)(),
            files: new Map(),
            filenames: new Set(),
            offset: writer.writable.size,
            pendingEntriesSize: 0,
            pendingAddFileCalls: new Set()
        });
    }
    async add(name = "", reader, options = {}) {
        const zipWriter = this;
        const { pendingAddFileCalls: pendingAddFileCalls, config: config } = zipWriter;
        if ($2cb90b9cb96d205a$var$workers < config.maxWorkers) $2cb90b9cb96d205a$var$workers++;
        else await new Promise((resolve)=>$2cb90b9cb96d205a$var$pendingEntries.push(resolve));
        let promiseAddFile;
        try {
            name = name.trim();
            if (zipWriter.filenames.has(name)) throw new Error($2cb90b9cb96d205a$export$c3407be3767d007d);
            zipWriter.filenames.add(name);
            promiseAddFile = $2cb90b9cb96d205a$var$addFile(zipWriter, name, reader, options);
            pendingAddFileCalls.add(promiseAddFile);
            return await promiseAddFile;
        } catch (error) {
            zipWriter.filenames.delete(name);
            throw error;
        } finally{
            pendingAddFileCalls.delete(promiseAddFile);
            const pendingEntry = $2cb90b9cb96d205a$var$pendingEntries.shift();
            if (pendingEntry) pendingEntry();
            else $2cb90b9cb96d205a$var$workers--;
        }
    }
    async close(comment = new Uint8Array(), options = {}) {
        const { pendingAddFileCalls: pendingAddFileCalls, writer: writer } = this;
        const { writable: writable } = writer;
        while(pendingAddFileCalls.size)await Promise.all(Array.from(pendingAddFileCalls));
        await $2cb90b9cb96d205a$var$closeFile(this, comment, options);
        if (!writer.preventClose && !options.preventClose) await writable.close();
        return writer.getData ? writer.getData() : writable;
    }
}
async function $2cb90b9cb96d205a$var$addFile(zipWriter, name, reader, options) {
    name = name.trim();
    if (options.directory && !name.endsWith((0, $0302f6c577bd011b$export$4a765df57d89fe04))) name += (0, $0302f6c577bd011b$export$4a765df57d89fe04);
    else options.directory = name.endsWith((0, $0302f6c577bd011b$export$4a765df57d89fe04));
    const rawFilename = (0, $ba4ced2ed37d6fed$export$7d0d7672e8a1c5cf)(name);
    if ($2cb90b9cb96d205a$var$getLength(rawFilename) > (0, $0302f6c577bd011b$export$4164cee1a26178fd)) throw new Error($2cb90b9cb96d205a$export$e7ba549a0a27f4f5);
    const comment = options.comment || "";
    const rawComment = (0, $ba4ced2ed37d6fed$export$7d0d7672e8a1c5cf)(comment);
    if ($2cb90b9cb96d205a$var$getLength(rawComment) > (0, $0302f6c577bd011b$export$4164cee1a26178fd)) throw new Error($2cb90b9cb96d205a$export$c5631773b8d6c9e2);
    const version = zipWriter.options.version || options.version || 0;
    if (version > (0, $0302f6c577bd011b$export$4164cee1a26178fd)) throw new Error($2cb90b9cb96d205a$export$6a674c09fe1f3dec);
    const versionMadeBy = zipWriter.options.versionMadeBy || options.versionMadeBy || 20;
    if (versionMadeBy > (0, $0302f6c577bd011b$export$4164cee1a26178fd)) throw new Error($2cb90b9cb96d205a$export$6a674c09fe1f3dec);
    const lastModDate = $2cb90b9cb96d205a$var$getOptionValue(zipWriter, options, "lastModDate") || new Date();
    const lastAccessDate = $2cb90b9cb96d205a$var$getOptionValue(zipWriter, options, "lastAccessDate");
    const creationDate = $2cb90b9cb96d205a$var$getOptionValue(zipWriter, options, "creationDate");
    const password = $2cb90b9cb96d205a$var$getOptionValue(zipWriter, options, "password");
    const encryptionStrength = $2cb90b9cb96d205a$var$getOptionValue(zipWriter, options, "encryptionStrength") || 3;
    const zipCrypto = $2cb90b9cb96d205a$var$getOptionValue(zipWriter, options, "zipCrypto");
    if (password !== (0, $0302f6c577bd011b$export$a43287864529b8fd) && encryptionStrength !== (0, $0302f6c577bd011b$export$a43287864529b8fd) && (encryptionStrength < 1 || encryptionStrength > 3)) throw new Error($2cb90b9cb96d205a$export$a52a97f6f11df530);
    let rawExtraField = new Uint8Array();
    const { extraField: extraField } = options;
    if (extraField) {
        let extraFieldSize = 0;
        let offset = 0;
        extraField.forEach((data)=>extraFieldSize += 4 + $2cb90b9cb96d205a$var$getLength(data));
        rawExtraField = new Uint8Array(extraFieldSize);
        extraField.forEach((data, type)=>{
            if (type > (0, $0302f6c577bd011b$export$4164cee1a26178fd)) throw new Error($2cb90b9cb96d205a$export$84caeb3441d47629);
            if ($2cb90b9cb96d205a$var$getLength(data) > (0, $0302f6c577bd011b$export$4164cee1a26178fd)) throw new Error($2cb90b9cb96d205a$export$ca2bf648520d566);
            $2cb90b9cb96d205a$var$arraySet(rawExtraField, new Uint16Array([
                type
            ]), offset);
            $2cb90b9cb96d205a$var$arraySet(rawExtraField, new Uint16Array([
                $2cb90b9cb96d205a$var$getLength(data)
            ]), offset + 2);
            $2cb90b9cb96d205a$var$arraySet(rawExtraField, data, offset + 4);
            offset += 4 + $2cb90b9cb96d205a$var$getLength(data);
        });
    }
    let extendedTimestamp = $2cb90b9cb96d205a$var$getOptionValue(zipWriter, options, "extendedTimestamp");
    if (extendedTimestamp === (0, $0302f6c577bd011b$export$a43287864529b8fd)) extendedTimestamp = true;
    let maximumCompressedSize = 0;
    let maximumEntrySize = 0;
    let keepOrder = $2cb90b9cb96d205a$var$getOptionValue(zipWriter, options, "keepOrder");
    if (keepOrder === (0, $0302f6c577bd011b$export$a43287864529b8fd)) keepOrder = true;
    let uncompressedSize = 0;
    let msDosCompatible = $2cb90b9cb96d205a$var$getOptionValue(zipWriter, options, "msDosCompatible");
    if (msDosCompatible === (0, $0302f6c577bd011b$export$a43287864529b8fd)) msDosCompatible = true;
    const internalFileAttribute = $2cb90b9cb96d205a$var$getOptionValue(zipWriter, options, "internalFileAttribute") || 0;
    const externalFileAttribute = $2cb90b9cb96d205a$var$getOptionValue(zipWriter, options, "externalFileAttribute") || 0;
    let zip64 = $2cb90b9cb96d205a$var$getOptionValue(zipWriter, options, "zip64");
    if (reader) {
        if (reader instanceof ReadableStream) reader = {
            readable: reader
        };
        await (0, $9e0a2ae6b9542b81$export$a0b98872cda67175)(reader);
        if (reader.size === (0, $0302f6c577bd011b$export$a43287864529b8fd)) {
            options.dataDescriptor = true;
            if (zip64 || zip64 === (0, $0302f6c577bd011b$export$a43287864529b8fd)) {
                zip64 = true;
                maximumCompressedSize = (0, $0302f6c577bd011b$export$dbfc2ae0cf3df69a);
            }
        } else {
            uncompressedSize = reader.size;
            maximumCompressedSize = $2cb90b9cb96d205a$var$getMaximumCompressedSize(uncompressedSize);
        }
    }
    if (zipWriter.offset + zipWriter.pendingEntriesSize >= (0, $0302f6c577bd011b$export$dbfc2ae0cf3df69a) || uncompressedSize >= (0, $0302f6c577bd011b$export$dbfc2ae0cf3df69a) || maximumCompressedSize >= (0, $0302f6c577bd011b$export$dbfc2ae0cf3df69a)) {
        if (zip64 === false || !keepOrder) throw new Error($2cb90b9cb96d205a$export$2866c0d2403d5bac);
        else zip64 = true;
    }
    zip64 = zip64 || false;
    const level = $2cb90b9cb96d205a$var$getOptionValue(zipWriter, options, "level");
    const useWebWorkers = $2cb90b9cb96d205a$var$getOptionValue(zipWriter, options, "useWebWorkers");
    const bufferedWrite = $2cb90b9cb96d205a$var$getOptionValue(zipWriter, options, "bufferedWrite");
    let dataDescriptor = $2cb90b9cb96d205a$var$getOptionValue(zipWriter, options, "dataDescriptor");
    let dataDescriptorSignature = $2cb90b9cb96d205a$var$getOptionValue(zipWriter, options, "dataDescriptorSignature");
    const signal = $2cb90b9cb96d205a$var$getOptionValue(zipWriter, options, "signal");
    const useCompressionStream = $2cb90b9cb96d205a$var$getOptionValue(zipWriter, options, "useCompressionStream");
    if (dataDescriptor === (0, $0302f6c577bd011b$export$a43287864529b8fd)) dataDescriptor = true;
    if (dataDescriptor && dataDescriptorSignature === (0, $0302f6c577bd011b$export$a43287864529b8fd)) dataDescriptorSignature = false;
    options = Object.assign({}, options, {
        rawFilename: rawFilename,
        rawComment: rawComment,
        version: version,
        versionMadeBy: versionMadeBy,
        lastModDate: lastModDate,
        lastAccessDate: lastAccessDate,
        creationDate: creationDate,
        rawExtraField: rawExtraField,
        zip64: zip64,
        password: password,
        level: level,
        useWebWorkers: useWebWorkers,
        encryptionStrength: encryptionStrength,
        extendedTimestamp: extendedTimestamp,
        zipCrypto: zipCrypto,
        bufferedWrite: bufferedWrite,
        keepOrder: keepOrder,
        dataDescriptor: dataDescriptor,
        dataDescriptorSignature: dataDescriptorSignature,
        signal: signal,
        msDosCompatible: msDosCompatible,
        internalFileAttribute: internalFileAttribute,
        externalFileAttribute: externalFileAttribute,
        useCompressionStream: useCompressionStream
    });
    const headerInfo = $2cb90b9cb96d205a$var$getHeaderInfo(options);
    const dataDescriptorInfo = $2cb90b9cb96d205a$var$getDataDescriptorInfo(options);
    maximumEntrySize = $2cb90b9cb96d205a$var$getLength(headerInfo.localHeaderArray, dataDescriptorInfo.dataDescriptorArray) + maximumCompressedSize;
    zipWriter.pendingEntriesSize += maximumEntrySize;
    let fileEntry;
    try {
        fileEntry = await $2cb90b9cb96d205a$var$getFileEntry(zipWriter, name, reader, {
            headerInfo: headerInfo,
            dataDescriptorInfo: dataDescriptorInfo
        }, options);
    } catch (error) {
        if (!error.corruptedEntry && maximumEntrySize) zipWriter.pendingEntriesSize -= maximumEntrySize;
        throw error;
    }
    Object.assign(fileEntry, {
        name: name,
        comment: comment,
        extraField: extraField
    });
    return new (0, $c7ffc19d30172d27$export$3bb977b3ba9d3b59)(fileEntry);
}
async function $2cb90b9cb96d205a$var$getFileEntry(zipWriter, name, reader, entryInfo, options) {
    const { files: files, writer: writer } = zipWriter;
    const { keepOrder: keepOrder, dataDescriptor: dataDescriptor, signal: signal } = options;
    const previousFileEntry = Array.from(files.values()).pop();
    let fileEntry = {};
    let bufferedWrite;
    let releaseLockWriter;
    let releaseLockCurrentFileEntry;
    let writingBufferedEntryData;
    let writingEntryData;
    let fileWriter;
    files.set(name, fileEntry);
    try {
        let lockPreviousFileEntry;
        if (keepOrder) {
            lockPreviousFileEntry = previousFileEntry && previousFileEntry.lock;
            requestLockCurrentFileEntry();
        }
        if (options.bufferedWrite || zipWriter.lockWriter || !dataDescriptor) {
            fileWriter = new (0, $9e0a2ae6b9542b81$export$b1948fceba813858)();
            fileWriter.writable.size = 0;
            bufferedWrite = true;
            await (0, $9e0a2ae6b9542b81$export$a0b98872cda67175)(writer);
        } else {
            fileWriter = writer;
            zipWriter.lockWriter = Promise.resolve();
            releaseLockWriter = ()=>delete zipWriter.lockWriter;
        }
        await (0, $9e0a2ae6b9542b81$export$a0b98872cda67175)(fileWriter);
        const { writable: writable, diskNumber: diskNumber } = writer;
        let { diskOffset: diskOffset } = writer;
        if (zipWriter.addSplitZipSignature) {
            delete zipWriter.addSplitZipSignature;
            const signatureArray = new Uint8Array(4);
            const signatureArrayView = new DataView(signatureArray.buffer);
            $2cb90b9cb96d205a$var$setUint32(signatureArrayView, 0, (0, $0302f6c577bd011b$export$40fbd2cd06477e1d));
            await $2cb90b9cb96d205a$var$writeData(writable, signatureArray);
            zipWriter.offset += 4;
        }
        if (!bufferedWrite) await lockPreviousFileEntry;
        writingEntryData = true;
        fileEntry.diskNumberStart = diskNumber;
        fileEntry = await $2cb90b9cb96d205a$var$createFileEntry(reader, fileWriter, fileEntry, entryInfo, zipWriter.config, options);
        writingEntryData = false;
        files.set(name, fileEntry);
        fileEntry.filename = name;
        if (bufferedWrite) {
            await fileWriter.writable.close();
            let blob = await fileWriter.getData();
            await lockPreviousFileEntry;
            await requestLockWriter();
            writingBufferedEntryData = true;
            if (!dataDescriptor) blob = await $2cb90b9cb96d205a$var$setMissingInfo(fileEntry, blob, writable, options);
            fileEntry.diskNumberStart = writer.diskNumber;
            diskOffset = writer.diskOffset;
            await blob.stream().pipeTo(writable, {
                preventClose: true,
                signal: signal
            });
            writable.size += blob.size;
            writingBufferedEntryData = false;
        }
        fileEntry.offset = zipWriter.offset - diskOffset;
        if (fileEntry.zip64) $2cb90b9cb96d205a$var$setZip64Info(fileEntry);
        else if (fileEntry.offset >= (0, $0302f6c577bd011b$export$dbfc2ae0cf3df69a)) throw new Error($2cb90b9cb96d205a$export$2866c0d2403d5bac);
        zipWriter.offset += fileEntry.length;
        return fileEntry;
    } catch (error) {
        if (bufferedWrite && writingBufferedEntryData || !bufferedWrite && writingEntryData) {
            zipWriter.hasCorruptedEntries = true;
            if (error) error.corruptedEntry = true;
            if (bufferedWrite) zipWriter.offset += fileWriter.writable.size;
            else zipWriter.offset = fileWriter.writable.size;
        }
        files.delete(name);
        throw error;
    } finally{
        if (releaseLockCurrentFileEntry) releaseLockCurrentFileEntry();
        if (releaseLockWriter) releaseLockWriter();
    }
    function requestLockCurrentFileEntry() {
        fileEntry.lock = new Promise((resolve)=>releaseLockCurrentFileEntry = resolve);
    }
    async function requestLockWriter() {
        const { lockWriter: lockWriter } = zipWriter;
        if (lockWriter) {
            await lockWriter.then(()=>delete zipWriter.lockWriter);
            return requestLockWriter();
        } else zipWriter.lockWriter = new Promise((resolve)=>releaseLockWriter = resolve);
    }
}
async function $2cb90b9cb96d205a$var$createFileEntry(reader, writer, { diskNumberStart: diskNumberStart, lock: lock }, entryInfo, config, options) {
    const { headerInfo: headerInfo, dataDescriptorInfo: dataDescriptorInfo } = entryInfo;
    const { localHeaderArray: localHeaderArray, headerArray: headerArray, lastModDate: lastModDate, rawLastModDate: rawLastModDate, encrypted: encrypted, compressed: compressed, version: version, compressionMethod: compressionMethod, rawExtraFieldExtendedTimestamp: rawExtraFieldExtendedTimestamp, rawExtraFieldNTFS: rawExtraFieldNTFS, rawExtraFieldAES: rawExtraFieldAES } = headerInfo;
    const { dataDescriptorArray: dataDescriptorArray } = dataDescriptorInfo;
    const { rawFilename: rawFilename, lastAccessDate: lastAccessDate, creationDate: creationDate, password: password, level: level, zip64: zip64, zipCrypto: zipCrypto, dataDescriptor: dataDescriptor, directory: directory, versionMadeBy: versionMadeBy, rawComment: rawComment, rawExtraField: rawExtraField, useWebWorkers: useWebWorkers, onstart: onstart, onprogress: onprogress, onend: onend, signal: signal, encryptionStrength: encryptionStrength, extendedTimestamp: extendedTimestamp, msDosCompatible: msDosCompatible, internalFileAttribute: internalFileAttribute, externalFileAttribute: externalFileAttribute, useCompressionStream: useCompressionStream } = options;
    const fileEntry = {
        lock: lock,
        versionMadeBy: versionMadeBy,
        zip64: zip64,
        directory: Boolean(directory),
        filenameUTF8: true,
        rawFilename: rawFilename,
        commentUTF8: true,
        rawComment: rawComment,
        rawExtraFieldExtendedTimestamp: rawExtraFieldExtendedTimestamp,
        rawExtraFieldNTFS: rawExtraFieldNTFS,
        rawExtraFieldAES: rawExtraFieldAES,
        rawExtraField: rawExtraField,
        extendedTimestamp: extendedTimestamp,
        msDosCompatible: msDosCompatible,
        internalFileAttribute: internalFileAttribute,
        externalFileAttribute: externalFileAttribute,
        diskNumberStart: diskNumberStart
    };
    let uncompressedSize = 0;
    let signature;
    let compressedSize = 0;
    const { writable: writable } = writer;
    if (reader) {
        reader.chunkSize = (0, $1c2d4410a52b3cac$export$f0bad416b890a4ec)(config);
        await $2cb90b9cb96d205a$var$writeData(writable, localHeaderArray);
        const readable = reader.readable;
        const size = readable.size = reader.size;
        const workerOptions = {
            options: {
                codecType: (0, $fda7c3f883c12402$export$c8ea3b6e95d7ab36),
                level: level,
                password: password,
                encryptionStrength: encryptionStrength,
                zipCrypto: encrypted && zipCrypto,
                passwordVerification: encrypted && zipCrypto && rawLastModDate >> 8 & 0xFF,
                signed: true,
                compressed: compressed,
                encrypted: encrypted,
                useWebWorkers: useWebWorkers,
                useCompressionStream: useCompressionStream,
                transferStreams: false
            },
            config: config,
            streamOptions: {
                signal: signal,
                size: size,
                onstart: onstart,
                onprogress: onprogress,
                onend: onend
            }
        };
        const result = await (0, $2f7887a251aac91a$export$dd2e08b4a54c623f)({
            readable: readable,
            writable: writable
        }, workerOptions);
        writable.size += result.size;
        signature = result.signature;
        uncompressedSize = reader.size = readable.size;
        compressedSize = result.size;
    } else await $2cb90b9cb96d205a$var$writeData(writable, localHeaderArray);
    const rawExtraFieldZip64 = zip64 ? new Uint8Array($2cb90b9cb96d205a$var$EXTRAFIELD_LENGTH_ZIP64 + 4) : new Uint8Array();
    if (reader) $2cb90b9cb96d205a$var$setEntryInfo({
        signature: signature,
        rawExtraFieldZip64: rawExtraFieldZip64,
        compressedSize: compressedSize,
        uncompressedSize: uncompressedSize,
        headerInfo: headerInfo,
        dataDescriptorInfo: dataDescriptorInfo
    }, options);
    if (dataDescriptor) await $2cb90b9cb96d205a$var$writeData(writable, dataDescriptorArray);
    Object.assign(fileEntry, {
        compressedSize: compressedSize,
        lastModDate: lastModDate,
        rawLastModDate: rawLastModDate,
        creationDate: creationDate,
        lastAccessDate: lastAccessDate,
        encrypted: encrypted,
        length: $2cb90b9cb96d205a$var$getLength(localHeaderArray, dataDescriptorArray) + compressedSize,
        compressionMethod: compressionMethod,
        version: version,
        headerArray: headerArray,
        signature: signature,
        rawExtraFieldZip64: rawExtraFieldZip64
    });
    return fileEntry;
}
function $2cb90b9cb96d205a$var$getHeaderInfo(options) {
    const { rawFilename: rawFilename, lastModDate: lastModDate, lastAccessDate: lastAccessDate, creationDate: creationDate, password: password, level: level, zip64: zip64, zipCrypto: zipCrypto, dataDescriptor: dataDescriptor, directory: directory, rawExtraField: rawExtraField, encryptionStrength: encryptionStrength, extendedTimestamp: extendedTimestamp } = options;
    const compressed = level !== 0 && !directory;
    const encrypted = Boolean(password && $2cb90b9cb96d205a$var$getLength(password));
    let rawExtraFieldAES;
    if (encrypted && !zipCrypto) {
        rawExtraFieldAES = new Uint8Array($2cb90b9cb96d205a$var$getLength($2cb90b9cb96d205a$var$EXTRAFIELD_DATA_AES) + 2);
        const extraFieldAESView = $2cb90b9cb96d205a$var$getDataView(rawExtraFieldAES);
        $2cb90b9cb96d205a$var$setUint16(extraFieldAESView, 0, (0, $0302f6c577bd011b$export$714aa3fe052f4e13));
        $2cb90b9cb96d205a$var$arraySet(rawExtraFieldAES, $2cb90b9cb96d205a$var$EXTRAFIELD_DATA_AES, 2);
        $2cb90b9cb96d205a$var$setUint8(extraFieldAESView, 8, encryptionStrength);
    } else rawExtraFieldAES = new Uint8Array();
    let rawExtraFieldNTFS;
    let rawExtraFieldExtendedTimestamp;
    if (extendedTimestamp) {
        rawExtraFieldExtendedTimestamp = new Uint8Array(9 + (lastAccessDate ? 4 : 0) + (creationDate ? 4 : 0));
        const extraFieldExtendedTimestampView = $2cb90b9cb96d205a$var$getDataView(rawExtraFieldExtendedTimestamp);
        $2cb90b9cb96d205a$var$setUint16(extraFieldExtendedTimestampView, 0, (0, $0302f6c577bd011b$export$6cfe9e8823acaac3));
        $2cb90b9cb96d205a$var$setUint16(extraFieldExtendedTimestampView, 2, $2cb90b9cb96d205a$var$getLength(rawExtraFieldExtendedTimestamp) - 4);
        const extraFieldExtendedTimestampFlag = 0x1 + (lastAccessDate ? 0x2 : 0) + (creationDate ? 0x4 : 0);
        $2cb90b9cb96d205a$var$setUint8(extraFieldExtendedTimestampView, 4, extraFieldExtendedTimestampFlag);
        $2cb90b9cb96d205a$var$setUint32(extraFieldExtendedTimestampView, 5, Math.floor(lastModDate.getTime() / 1000));
        if (lastAccessDate) $2cb90b9cb96d205a$var$setUint32(extraFieldExtendedTimestampView, 9, Math.floor(lastAccessDate.getTime() / 1000));
        if (creationDate) $2cb90b9cb96d205a$var$setUint32(extraFieldExtendedTimestampView, 13, Math.floor(creationDate.getTime() / 1000));
        try {
            rawExtraFieldNTFS = new Uint8Array(36);
            const extraFieldNTFSView = $2cb90b9cb96d205a$var$getDataView(rawExtraFieldNTFS);
            const lastModTimeNTFS = $2cb90b9cb96d205a$var$getTimeNTFS(lastModDate);
            $2cb90b9cb96d205a$var$setUint16(extraFieldNTFSView, 0, (0, $0302f6c577bd011b$export$93e014de2b9c33c8));
            $2cb90b9cb96d205a$var$setUint16(extraFieldNTFSView, 2, 32);
            $2cb90b9cb96d205a$var$setUint16(extraFieldNTFSView, 8, (0, $0302f6c577bd011b$export$109a97d45e55cdec));
            $2cb90b9cb96d205a$var$setUint16(extraFieldNTFSView, 10, 24);
            $2cb90b9cb96d205a$var$setBigUint64(extraFieldNTFSView, 12, lastModTimeNTFS);
            $2cb90b9cb96d205a$var$setBigUint64(extraFieldNTFSView, 20, $2cb90b9cb96d205a$var$getTimeNTFS(lastAccessDate) || lastModTimeNTFS);
            $2cb90b9cb96d205a$var$setBigUint64(extraFieldNTFSView, 28, $2cb90b9cb96d205a$var$getTimeNTFS(creationDate) || lastModTimeNTFS);
        } catch (_error) {
            rawExtraFieldNTFS = new Uint8Array();
        }
    } else rawExtraFieldNTFS = rawExtraFieldExtendedTimestamp = new Uint8Array();
    let bitFlag = (0, $0302f6c577bd011b$export$fb6e9f896320db55);
    if (dataDescriptor) bitFlag = bitFlag | (0, $0302f6c577bd011b$export$3ec1d940e3bc0a58);
    let compressionMethod = (0, $0302f6c577bd011b$export$6135a805f19e5577);
    if (compressed) compressionMethod = (0, $0302f6c577bd011b$export$2cf0a12381b29e07);
    let version = options.version || (0, $0302f6c577bd011b$export$e0f048be47b3707);
    if (zip64) version = version > (0, $0302f6c577bd011b$export$c695aaa0200b0023) ? version : (0, $0302f6c577bd011b$export$c695aaa0200b0023);
    if (encrypted) {
        bitFlag = bitFlag | (0, $0302f6c577bd011b$export$7db0c075c39cb343);
        if (!zipCrypto) {
            version = version > (0, $0302f6c577bd011b$export$476ad4f47ce8ae93) ? version : (0, $0302f6c577bd011b$export$476ad4f47ce8ae93);
            compressionMethod = (0, $0302f6c577bd011b$export$367f2443b409227a);
            if (compressed) rawExtraFieldAES[9] = (0, $0302f6c577bd011b$export$2cf0a12381b29e07);
        }
    }
    const headerArray = new Uint8Array(26);
    const headerView = $2cb90b9cb96d205a$var$getDataView(headerArray);
    $2cb90b9cb96d205a$var$setUint16(headerView, 0, version);
    $2cb90b9cb96d205a$var$setUint16(headerView, 2, bitFlag);
    $2cb90b9cb96d205a$var$setUint16(headerView, 4, compressionMethod);
    const dateArray = new Uint32Array(1);
    const dateView = $2cb90b9cb96d205a$var$getDataView(dateArray);
    let lastModDateMsDos;
    if (lastModDate < (0, $0302f6c577bd011b$export$c21855736e7fcd29)) lastModDateMsDos = (0, $0302f6c577bd011b$export$c21855736e7fcd29);
    else if (lastModDate > (0, $0302f6c577bd011b$export$c4acb27cbfd4cf71)) lastModDateMsDos = (0, $0302f6c577bd011b$export$c4acb27cbfd4cf71);
    else lastModDateMsDos = lastModDate;
    $2cb90b9cb96d205a$var$setUint16(dateView, 0, (lastModDateMsDos.getHours() << 6 | lastModDateMsDos.getMinutes()) << 5 | lastModDateMsDos.getSeconds() / 2);
    $2cb90b9cb96d205a$var$setUint16(dateView, 2, (lastModDateMsDos.getFullYear() - 1980 << 4 | lastModDateMsDos.getMonth() + 1) << 5 | lastModDateMsDos.getDate());
    const rawLastModDate = dateArray[0];
    $2cb90b9cb96d205a$var$setUint32(headerView, 6, rawLastModDate);
    $2cb90b9cb96d205a$var$setUint16(headerView, 22, $2cb90b9cb96d205a$var$getLength(rawFilename));
    const extraFieldLength = $2cb90b9cb96d205a$var$getLength(rawExtraFieldAES, rawExtraFieldExtendedTimestamp, rawExtraFieldNTFS, rawExtraField);
    $2cb90b9cb96d205a$var$setUint16(headerView, 24, extraFieldLength);
    const localHeaderArray = new Uint8Array(30 + $2cb90b9cb96d205a$var$getLength(rawFilename) + extraFieldLength);
    const localHeaderView = $2cb90b9cb96d205a$var$getDataView(localHeaderArray);
    $2cb90b9cb96d205a$var$setUint32(localHeaderView, 0, (0, $0302f6c577bd011b$export$2b2cf5904cb82788));
    $2cb90b9cb96d205a$var$arraySet(localHeaderArray, headerArray, 4);
    $2cb90b9cb96d205a$var$arraySet(localHeaderArray, rawFilename, 30);
    $2cb90b9cb96d205a$var$arraySet(localHeaderArray, rawExtraFieldAES, 30 + $2cb90b9cb96d205a$var$getLength(rawFilename));
    $2cb90b9cb96d205a$var$arraySet(localHeaderArray, rawExtraFieldExtendedTimestamp, 30 + $2cb90b9cb96d205a$var$getLength(rawFilename, rawExtraFieldAES));
    $2cb90b9cb96d205a$var$arraySet(localHeaderArray, rawExtraFieldNTFS, 30 + $2cb90b9cb96d205a$var$getLength(rawFilename, rawExtraFieldAES, rawExtraFieldExtendedTimestamp));
    $2cb90b9cb96d205a$var$arraySet(localHeaderArray, rawExtraField, 30 + $2cb90b9cb96d205a$var$getLength(rawFilename, rawExtraFieldAES, rawExtraFieldExtendedTimestamp, rawExtraFieldNTFS));
    return {
        localHeaderArray: localHeaderArray,
        headerArray: headerArray,
        headerView: headerView,
        lastModDate: lastModDate,
        rawLastModDate: rawLastModDate,
        encrypted: encrypted,
        compressed: compressed,
        version: version,
        compressionMethod: compressionMethod,
        rawExtraFieldExtendedTimestamp: rawExtraFieldExtendedTimestamp,
        rawExtraFieldNTFS: rawExtraFieldNTFS,
        rawExtraFieldAES: rawExtraFieldAES
    };
}
function $2cb90b9cb96d205a$var$getDataDescriptorInfo(options) {
    const { zip64: zip64, dataDescriptor: dataDescriptor, dataDescriptorSignature: dataDescriptorSignature } = options;
    let dataDescriptorArray = new Uint8Array();
    let dataDescriptorView, dataDescriptorOffset = 0;
    if (dataDescriptor) {
        dataDescriptorArray = new Uint8Array(zip64 ? dataDescriptorSignature ? 24 : 20 : dataDescriptorSignature ? 16 : 12);
        dataDescriptorView = $2cb90b9cb96d205a$var$getDataView(dataDescriptorArray);
        if (dataDescriptorSignature) {
            dataDescriptorOffset = 4;
            $2cb90b9cb96d205a$var$setUint32(dataDescriptorView, 0, (0, $0302f6c577bd011b$export$fb8fb01339553b17));
        }
    }
    return {
        dataDescriptorArray: dataDescriptorArray,
        dataDescriptorView: dataDescriptorView,
        dataDescriptorOffset: dataDescriptorOffset
    };
}
function $2cb90b9cb96d205a$var$setEntryInfo(entryInfo, options) {
    const { signature: signature, rawExtraFieldZip64: rawExtraFieldZip64, compressedSize: compressedSize, uncompressedSize: uncompressedSize, headerInfo: headerInfo, dataDescriptorInfo: dataDescriptorInfo } = entryInfo;
    const { headerView: headerView, encrypted: encrypted } = headerInfo;
    const { dataDescriptorView: dataDescriptorView, dataDescriptorOffset: dataDescriptorOffset } = dataDescriptorInfo;
    const { zip64: zip64, zipCrypto: zipCrypto, dataDescriptor: dataDescriptor } = options;
    if ((!encrypted || zipCrypto) && signature !== (0, $0302f6c577bd011b$export$a43287864529b8fd)) {
        $2cb90b9cb96d205a$var$setUint32(headerView, 10, signature);
        if (dataDescriptor) $2cb90b9cb96d205a$var$setUint32(dataDescriptorView, dataDescriptorOffset, signature);
    }
    if (zip64) {
        const rawExtraFieldZip64View = $2cb90b9cb96d205a$var$getDataView(rawExtraFieldZip64);
        $2cb90b9cb96d205a$var$setUint16(rawExtraFieldZip64View, 0, (0, $0302f6c577bd011b$export$3da9e4d76b1bf88));
        $2cb90b9cb96d205a$var$setUint16(rawExtraFieldZip64View, 2, $2cb90b9cb96d205a$var$EXTRAFIELD_LENGTH_ZIP64);
        $2cb90b9cb96d205a$var$setUint32(headerView, 14, (0, $0302f6c577bd011b$export$dbfc2ae0cf3df69a));
        $2cb90b9cb96d205a$var$setBigUint64(rawExtraFieldZip64View, 12, BigInt(compressedSize));
        $2cb90b9cb96d205a$var$setUint32(headerView, 18, (0, $0302f6c577bd011b$export$dbfc2ae0cf3df69a));
        $2cb90b9cb96d205a$var$setBigUint64(rawExtraFieldZip64View, 4, BigInt(uncompressedSize));
        if (dataDescriptor) {
            $2cb90b9cb96d205a$var$setBigUint64(dataDescriptorView, dataDescriptorOffset + 4, BigInt(compressedSize));
            $2cb90b9cb96d205a$var$setBigUint64(dataDescriptorView, dataDescriptorOffset + 12, BigInt(uncompressedSize));
        }
    } else {
        $2cb90b9cb96d205a$var$setUint32(headerView, 14, compressedSize);
        $2cb90b9cb96d205a$var$setUint32(headerView, 18, uncompressedSize);
        if (dataDescriptor) {
            $2cb90b9cb96d205a$var$setUint32(dataDescriptorView, dataDescriptorOffset + 4, compressedSize);
            $2cb90b9cb96d205a$var$setUint32(dataDescriptorView, dataDescriptorOffset + 8, uncompressedSize);
        }
    }
}
async function $2cb90b9cb96d205a$var$setMissingInfo(fileEntry, entryData, writable, { zipCrypto: zipCrypto }) {
    const arrayBuffer = await $2cb90b9cb96d205a$var$sliceAsArrayBuffer(entryData, 0, 26);
    const arrayBufferView = new DataView(arrayBuffer);
    if (!fileEntry.encrypted || zipCrypto) $2cb90b9cb96d205a$var$setUint32(arrayBufferView, 14, fileEntry.signature);
    if (fileEntry.zip64) {
        $2cb90b9cb96d205a$var$setUint32(arrayBufferView, 18, (0, $0302f6c577bd011b$export$dbfc2ae0cf3df69a));
        $2cb90b9cb96d205a$var$setUint32(arrayBufferView, 22, (0, $0302f6c577bd011b$export$dbfc2ae0cf3df69a));
    } else {
        $2cb90b9cb96d205a$var$setUint32(arrayBufferView, 18, fileEntry.compressedSize);
        $2cb90b9cb96d205a$var$setUint32(arrayBufferView, 22, fileEntry.uncompressedSize);
    }
    await $2cb90b9cb96d205a$var$writeData(writable, new Uint8Array(arrayBuffer));
    return entryData.slice(arrayBuffer.byteLength);
}
function $2cb90b9cb96d205a$var$setZip64Info(fileEntry) {
    const { rawExtraFieldZip64: rawExtraFieldZip64, offset: offset, diskNumberStart: diskNumberStart } = fileEntry;
    const rawExtraFieldZip64View = $2cb90b9cb96d205a$var$getDataView(rawExtraFieldZip64);
    $2cb90b9cb96d205a$var$setBigUint64(rawExtraFieldZip64View, 20, BigInt(offset));
    $2cb90b9cb96d205a$var$setUint32(rawExtraFieldZip64View, 28, diskNumberStart);
}
async function $2cb90b9cb96d205a$var$closeFile(zipWriter, comment, options) {
    const { files: files, writer: writer } = zipWriter;
    let offset = 0;
    let directoryDataLength = 0;
    const { diskOffset: diskOffset, writable: writable } = writer;
    let { diskNumber: diskNumber } = writer;
    let directoryOffset = zipWriter.offset - diskOffset;
    let filesLength = files.size;
    for (const [, { rawFilename: rawFilename, rawExtraFieldZip64: rawExtraFieldZip64, rawExtraFieldAES: rawExtraFieldAES, rawExtraField: rawExtraField, rawComment: rawComment, rawExtraFieldExtendedTimestamp: rawExtraFieldExtendedTimestamp, rawExtraFieldNTFS: rawExtraFieldNTFS }] of files)directoryDataLength += 46 + $2cb90b9cb96d205a$var$getLength(rawFilename, rawComment, rawExtraFieldZip64, rawExtraFieldAES, rawExtraFieldExtendedTimestamp, rawExtraFieldNTFS, rawExtraField);
    let zip64 = options.zip64 || zipWriter.options.zip64 || false;
    if (directoryOffset >= (0, $0302f6c577bd011b$export$dbfc2ae0cf3df69a) || directoryDataLength >= (0, $0302f6c577bd011b$export$dbfc2ae0cf3df69a) || filesLength >= (0, $0302f6c577bd011b$export$4164cee1a26178fd)) {
        if (options.zip64 === false || zipWriter.options.zip64 === false) throw new Error($2cb90b9cb96d205a$export$2866c0d2403d5bac);
        else zip64 = true;
    }
    const directoryArray = new Uint8Array(directoryDataLength);
    const directoryView = $2cb90b9cb96d205a$var$getDataView(directoryArray);
    for (const [indexFileEntry, fileEntry] of Array.from(files.values()).entries()){
        const { offset: fileEntryOffset, rawFilename: rawFilename, rawExtraFieldZip64: rawExtraFieldZip64, rawExtraFieldAES: rawExtraFieldAES, rawExtraFieldNTFS: rawExtraFieldNTFS, rawExtraField: rawExtraField, rawComment: rawComment, versionMadeBy: versionMadeBy, headerArray: headerArray, directory: directory, zip64: zip64, msDosCompatible: msDosCompatible, internalFileAttribute: internalFileAttribute, externalFileAttribute: externalFileAttribute, extendedTimestamp: extendedTimestamp, lastModDate: lastModDate, diskNumberStart: diskNumberStart } = fileEntry;
        let rawExtraFieldExtendedTimestamp;
        if (extendedTimestamp) {
            rawExtraFieldExtendedTimestamp = new Uint8Array(9);
            const extraFieldExtendedTimestampView = $2cb90b9cb96d205a$var$getDataView(rawExtraFieldExtendedTimestamp);
            $2cb90b9cb96d205a$var$setUint16(extraFieldExtendedTimestampView, 0, (0, $0302f6c577bd011b$export$6cfe9e8823acaac3));
            $2cb90b9cb96d205a$var$setUint16(extraFieldExtendedTimestampView, 2, $2cb90b9cb96d205a$var$getLength(rawExtraFieldExtendedTimestamp) - 4);
            $2cb90b9cb96d205a$var$setUint8(extraFieldExtendedTimestampView, 4, 0x1);
            $2cb90b9cb96d205a$var$setUint32(extraFieldExtendedTimestampView, 5, Math.floor(lastModDate.getTime() / 1000));
        } else rawExtraFieldExtendedTimestamp = new Uint8Array();
        const extraFieldLength = $2cb90b9cb96d205a$var$getLength(rawExtraFieldZip64, rawExtraFieldAES, rawExtraFieldExtendedTimestamp, rawExtraFieldNTFS, rawExtraField);
        $2cb90b9cb96d205a$var$setUint32(directoryView, offset, (0, $0302f6c577bd011b$export$a72d49bf27f9bcd));
        $2cb90b9cb96d205a$var$setUint16(directoryView, offset + 4, versionMadeBy);
        $2cb90b9cb96d205a$var$arraySet(directoryArray, headerArray, offset + 6);
        $2cb90b9cb96d205a$var$setUint16(directoryView, offset + 30, extraFieldLength);
        $2cb90b9cb96d205a$var$setUint16(directoryView, offset + 32, $2cb90b9cb96d205a$var$getLength(rawComment));
        $2cb90b9cb96d205a$var$setUint16(directoryView, offset + 34, zip64 ? (0, $0302f6c577bd011b$export$4164cee1a26178fd) : diskNumberStart);
        $2cb90b9cb96d205a$var$setUint16(directoryView, offset + 36, internalFileAttribute);
        if (externalFileAttribute) $2cb90b9cb96d205a$var$setUint32(directoryView, offset + 38, externalFileAttribute);
        else if (directory && msDosCompatible) $2cb90b9cb96d205a$var$setUint8(directoryView, offset + 38, (0, $0302f6c577bd011b$export$2d169f352844a92f));
        $2cb90b9cb96d205a$var$setUint32(directoryView, offset + 42, zip64 ? (0, $0302f6c577bd011b$export$dbfc2ae0cf3df69a) : fileEntryOffset);
        $2cb90b9cb96d205a$var$arraySet(directoryArray, rawFilename, offset + 46);
        $2cb90b9cb96d205a$var$arraySet(directoryArray, rawExtraFieldZip64, offset + 46 + $2cb90b9cb96d205a$var$getLength(rawFilename));
        $2cb90b9cb96d205a$var$arraySet(directoryArray, rawExtraFieldAES, offset + 46 + $2cb90b9cb96d205a$var$getLength(rawFilename, rawExtraFieldZip64));
        $2cb90b9cb96d205a$var$arraySet(directoryArray, rawExtraFieldExtendedTimestamp, offset + 46 + $2cb90b9cb96d205a$var$getLength(rawFilename, rawExtraFieldZip64, rawExtraFieldAES));
        $2cb90b9cb96d205a$var$arraySet(directoryArray, rawExtraFieldNTFS, offset + 46 + $2cb90b9cb96d205a$var$getLength(rawFilename, rawExtraFieldZip64, rawExtraFieldAES, rawExtraFieldExtendedTimestamp));
        $2cb90b9cb96d205a$var$arraySet(directoryArray, rawExtraField, offset + 46 + $2cb90b9cb96d205a$var$getLength(rawFilename, rawExtraFieldZip64, rawExtraFieldAES, rawExtraFieldExtendedTimestamp, rawExtraFieldNTFS));
        $2cb90b9cb96d205a$var$arraySet(directoryArray, rawComment, offset + 46 + $2cb90b9cb96d205a$var$getLength(rawFilename) + extraFieldLength);
        offset += 46 + $2cb90b9cb96d205a$var$getLength(rawFilename, rawComment) + extraFieldLength;
        if (options.onprogress) try {
            await options.onprogress(indexFileEntry + 1, files.size, new (0, $c7ffc19d30172d27$export$3bb977b3ba9d3b59)(fileEntry));
        } catch (_error) {
        // ignored
        }
    }
    await (0, $9e0a2ae6b9542b81$export$a0b98872cda67175)(writer);
    await $2cb90b9cb96d205a$var$writeData(writable, directoryArray);
    const endOfdirectoryArray = new Uint8Array(zip64 ? (0, $0302f6c577bd011b$export$4edccc0d25441f8c) : (0, $0302f6c577bd011b$export$6383d4b2e2323b68));
    const endOfdirectoryView = $2cb90b9cb96d205a$var$getDataView(endOfdirectoryArray);
    let lastDiskNumber = writer.diskNumber;
    const { availableSize: availableSize } = writer;
    if (availableSize < endOfdirectoryArray.length) lastDiskNumber++;
    offset = 0;
    if (zip64) {
        $2cb90b9cb96d205a$var$setUint32(endOfdirectoryView, 0, (0, $0302f6c577bd011b$export$8414b1953f7f48c6));
        $2cb90b9cb96d205a$var$setBigUint64(endOfdirectoryView, 4, BigInt(44));
        $2cb90b9cb96d205a$var$setUint16(endOfdirectoryView, 12, 45);
        $2cb90b9cb96d205a$var$setUint16(endOfdirectoryView, 14, 45);
        $2cb90b9cb96d205a$var$setUint32(endOfdirectoryView, 16, lastDiskNumber);
        $2cb90b9cb96d205a$var$setUint32(endOfdirectoryView, 20, diskNumber);
        $2cb90b9cb96d205a$var$setBigUint64(endOfdirectoryView, 24, BigInt(filesLength));
        $2cb90b9cb96d205a$var$setBigUint64(endOfdirectoryView, 32, BigInt(filesLength));
        $2cb90b9cb96d205a$var$setBigUint64(endOfdirectoryView, 40, BigInt(directoryDataLength));
        $2cb90b9cb96d205a$var$setBigUint64(endOfdirectoryView, 48, BigInt(directoryOffset));
        $2cb90b9cb96d205a$var$setUint32(endOfdirectoryView, 56, (0, $0302f6c577bd011b$export$5078166106cbcc66));
        $2cb90b9cb96d205a$var$setBigUint64(endOfdirectoryView, 64, BigInt(directoryOffset) + BigInt(directoryDataLength));
        $2cb90b9cb96d205a$var$setUint32(endOfdirectoryView, 72, lastDiskNumber + 1);
        diskNumber = (0, $0302f6c577bd011b$export$4164cee1a26178fd);
        filesLength = (0, $0302f6c577bd011b$export$4164cee1a26178fd);
        directoryOffset = (0, $0302f6c577bd011b$export$dbfc2ae0cf3df69a);
        directoryDataLength = (0, $0302f6c577bd011b$export$dbfc2ae0cf3df69a);
        offset += (0, $0302f6c577bd011b$export$9eb09cdd39f04a62) + (0, $0302f6c577bd011b$export$c545bb91a1b43732);
    }
    $2cb90b9cb96d205a$var$setUint32(endOfdirectoryView, offset, (0, $0302f6c577bd011b$export$13a06f7e64cf6a1));
    $2cb90b9cb96d205a$var$setUint16(endOfdirectoryView, offset + 4, lastDiskNumber);
    $2cb90b9cb96d205a$var$setUint16(endOfdirectoryView, offset + 6, diskNumber);
    $2cb90b9cb96d205a$var$setUint16(endOfdirectoryView, offset + 8, filesLength);
    $2cb90b9cb96d205a$var$setUint16(endOfdirectoryView, offset + 10, filesLength);
    $2cb90b9cb96d205a$var$setUint32(endOfdirectoryView, offset + 12, directoryDataLength);
    $2cb90b9cb96d205a$var$setUint32(endOfdirectoryView, offset + 16, directoryOffset);
    const commentLength = $2cb90b9cb96d205a$var$getLength(comment);
    if (commentLength) {
        if (commentLength <= (0, $0302f6c577bd011b$export$4164cee1a26178fd)) $2cb90b9cb96d205a$var$setUint16(endOfdirectoryView, offset + 20, commentLength);
        else throw new Error($2cb90b9cb96d205a$export$aa00b8eb8e30f01e);
    }
    await $2cb90b9cb96d205a$var$writeData(writable, endOfdirectoryArray);
    if (commentLength) await $2cb90b9cb96d205a$var$writeData(writable, comment);
}
function $2cb90b9cb96d205a$var$sliceAsArrayBuffer(blob, start, end) {
    if (start || end) return blob.slice(start, end).arrayBuffer();
    else return blob.arrayBuffer();
}
async function $2cb90b9cb96d205a$var$writeData(writable, array) {
    const streamWriter = writable.getWriter();
    await streamWriter.ready;
    writable.size += $2cb90b9cb96d205a$var$getLength(array);
    await streamWriter.write(array);
    streamWriter.releaseLock();
}
function $2cb90b9cb96d205a$var$getTimeNTFS(date) {
    if (date) return (BigInt(date.getTime()) + BigInt(11644473600000)) * BigInt(10000);
}
function $2cb90b9cb96d205a$var$getOptionValue(zipWriter, options, name) {
    return options[name] === (0, $0302f6c577bd011b$export$a43287864529b8fd) ? zipWriter.options[name] : options[name];
}
function $2cb90b9cb96d205a$var$getMaximumCompressedSize(uncompressedSize) {
    return uncompressedSize + 5 * (Math.floor(uncompressedSize / 16383) + 1);
}
function $2cb90b9cb96d205a$var$setUint8(view, offset, value) {
    view.setUint8(offset, value);
}
function $2cb90b9cb96d205a$var$setUint16(view, offset, value) {
    view.setUint16(offset, value, true);
}
function $2cb90b9cb96d205a$var$setUint32(view, offset, value) {
    view.setUint32(offset, value, true);
}
function $2cb90b9cb96d205a$var$setBigUint64(view, offset, value) {
    view.setBigUint64(offset, value, true);
}
function $2cb90b9cb96d205a$var$arraySet(array, typedArray, offset) {
    array.set(typedArray, offset);
}
function $2cb90b9cb96d205a$var$getDataView(array) {
    return new DataView(array.buffer);
}
function $2cb90b9cb96d205a$var$getLength(...arrayLikes) {
    let result = 0;
    arrayLikes.forEach((arrayLike)=>arrayLike && (result += arrayLike.length));
    return result;
}


/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /* global WritableStream */ // deno-lint-ignore-file no-this-alias



class $93fb8e20d8e0e035$var$ZipEntry {
    constructor(fs, name, params, parent){
        const zipEntry = this;
        if (fs.root && parent && parent.getChildByName(name)) throw new Error("Entry filename already exists");
        if (!params) params = {};
        Object.assign(zipEntry, {
            fs: fs,
            name: name,
            data: params.data,
            id: fs.entries.length,
            parent: parent,
            children: [],
            uncompressedSize: 0
        });
        fs.entries.push(zipEntry);
        if (parent) zipEntry.parent.children.push(zipEntry);
    }
    moveTo(target) {
        // deprecated
        const zipEntry = this;
        zipEntry.fs.move(zipEntry, target);
    }
    getFullname() {
        return this.getRelativeName();
    }
    getRelativeName(ancestor = this.fs.root) {
        const zipEntry = this;
        let relativeName = zipEntry.name;
        let entry = zipEntry.parent;
        while(entry && entry != ancestor){
            relativeName = (entry.name ? entry.name + "/" : "") + relativeName;
            entry = entry.parent;
        }
        return relativeName;
    }
    isDescendantOf(ancestor) {
        let entry = this.parent;
        while(entry && entry.id != ancestor.id)entry = entry.parent;
        return Boolean(entry);
    }
}
class $93fb8e20d8e0e035$var$ZipFileEntry extends $93fb8e20d8e0e035$var$ZipEntry {
    constructor(fs, name, params, parent){
        super(fs, name, params, parent);
        const zipEntry = this;
        zipEntry.Reader = params.Reader;
        zipEntry.Writer = params.Writer;
        if (params.getData) zipEntry.getData = params.getData;
    }
    async getData(writer, options = {}) {
        const zipEntry = this;
        if (!writer || writer.constructor == zipEntry.Writer && zipEntry.data) return zipEntry.data;
        else {
            const reader = zipEntry.reader = new zipEntry.Reader(zipEntry.data, options);
            await Promise.all([
                (0, $9e0a2ae6b9542b81$export$a0b98872cda67175)(reader),
                (0, $9e0a2ae6b9542b81$export$a0b98872cda67175)(writer, zipEntry.data.uncompressedSize)
            ]);
            const readable = reader.readable;
            readable.size = zipEntry.uncompressedSize = reader.size;
            await readable.pipeTo(writer.writable);
            return writer.getData ? writer.getData() : writer.writable;
        }
    }
    getText(encoding, options) {
        return this.getData(new (0, $9e0a2ae6b9542b81$export$4e2ccb0172e96d5b)(encoding), options);
    }
    getBlob(mimeType, options) {
        return this.getData(new (0, $9e0a2ae6b9542b81$export$b1948fceba813858)(mimeType), options);
    }
    getData64URI(mimeType, options) {
        return this.getData(new (0, $9e0a2ae6b9542b81$export$e54009c5f365f844)(mimeType), options);
    }
    getUint8Array(options) {
        return this.getData(new (0, $9e0a2ae6b9542b81$export$1581aa6fcae2be12)(), options);
    }
    getWritable(writable = new WritableStream(), options) {
        return this.getData({
            writable: writable
        }, options);
    }
    replaceBlob(blob) {
        Object.assign(this, {
            data: blob,
            Reader: (0, $9e0a2ae6b9542b81$export$aa5015be25fe7f79),
            Writer: (0, $9e0a2ae6b9542b81$export$b1948fceba813858),
            reader: null
        });
    }
    replaceText(text) {
        Object.assign(this, {
            data: text,
            Reader: (0, $9e0a2ae6b9542b81$export$43d3fd7deddee00),
            Writer: (0, $9e0a2ae6b9542b81$export$4e2ccb0172e96d5b),
            reader: null
        });
    }
    replaceData64URI(dataURI) {
        Object.assign(this, {
            data: dataURI,
            Reader: (0, $9e0a2ae6b9542b81$export$b43666fe9f809ae0),
            Writer: (0, $9e0a2ae6b9542b81$export$e54009c5f365f844),
            reader: null
        });
    }
    replaceUint8Array(array) {
        Object.assign(this, {
            data: array,
            Reader: (0, $9e0a2ae6b9542b81$export$d6e62de78e81ef8b),
            Writer: (0, $9e0a2ae6b9542b81$export$1581aa6fcae2be12),
            reader: null
        });
    }
    replaceReadable(readable) {
        Object.assign(this, {
            data: null,
            Reader: function() {
                return {
                    readable: readable
                };
            },
            Writer: null,
            reader: null
        });
    }
}
class $93fb8e20d8e0e035$var$ZipDirectoryEntry extends $93fb8e20d8e0e035$var$ZipEntry {
    constructor(fs, name, params, parent){
        super(fs, name, params, parent);
        this.directory = true;
    }
    addDirectory(name) {
        return $93fb8e20d8e0e035$var$addChild(this, name, null, true);
    }
    addText(name, text) {
        return $93fb8e20d8e0e035$var$addChild(this, name, {
            data: text,
            Reader: (0, $9e0a2ae6b9542b81$export$43d3fd7deddee00),
            Writer: (0, $9e0a2ae6b9542b81$export$4e2ccb0172e96d5b)
        });
    }
    addBlob(name, blob) {
        return $93fb8e20d8e0e035$var$addChild(this, name, {
            data: blob,
            Reader: (0, $9e0a2ae6b9542b81$export$aa5015be25fe7f79),
            Writer: (0, $9e0a2ae6b9542b81$export$b1948fceba813858)
        });
    }
    addData64URI(name, dataURI) {
        return $93fb8e20d8e0e035$var$addChild(this, name, {
            data: dataURI,
            Reader: (0, $9e0a2ae6b9542b81$export$b43666fe9f809ae0),
            Writer: (0, $9e0a2ae6b9542b81$export$e54009c5f365f844)
        });
    }
    addUint8Array(name, array) {
        return $93fb8e20d8e0e035$var$addChild(this, name, {
            data: array,
            Reader: (0, $9e0a2ae6b9542b81$export$d6e62de78e81ef8b),
            Writer: (0, $9e0a2ae6b9542b81$export$1581aa6fcae2be12)
        });
    }
    addHttpContent(name, url, options = {}) {
        return $93fb8e20d8e0e035$var$addChild(this, name, {
            data: url,
            Reader: class extends (0, $9e0a2ae6b9542b81$export$34b9a22e660cb902) {
                constructor(url){
                    super(url, options);
                }
            }
        });
    }
    addReadable(name, readable) {
        return $93fb8e20d8e0e035$var$addChild(this, name, {
            Reader: function() {
                return {
                    readable: readable
                };
            }
        });
    }
    addFileSystemEntry(fileSystemEntry) {
        return $93fb8e20d8e0e035$var$addFileSystemEntry(this, fileSystemEntry);
    }
    addData(name, params) {
        return $93fb8e20d8e0e035$var$addChild(this, name, params);
    }
    async importBlob(blob, options = {}) {
        await this.importZip(new (0, $9e0a2ae6b9542b81$export$aa5015be25fe7f79)(blob), options);
    }
    async importData64URI(dataURI, options = {}) {
        await this.importZip(new (0, $9e0a2ae6b9542b81$export$b43666fe9f809ae0)(dataURI), options);
    }
    async importUint8Array(array, options = {}) {
        await this.importZip(new (0, $9e0a2ae6b9542b81$export$d6e62de78e81ef8b)(array), options);
    }
    async importHttpContent(url, options = {}) {
        await this.importZip(new (0, $9e0a2ae6b9542b81$export$34b9a22e660cb902)(url, options), options);
    }
    async importReadable(readable, options = {}) {
        await this.importZip({
            readable: readable
        }, options);
    }
    exportBlob(options = {}) {
        return this.exportZip(new (0, $9e0a2ae6b9542b81$export$b1948fceba813858)("application/zip"), options);
    }
    exportData64URI(options = {}) {
        return this.exportZip(new (0, $9e0a2ae6b9542b81$export$e54009c5f365f844)("application/zip"), options);
    }
    exportUint8Array(options = {}) {
        return this.exportZip(new (0, $9e0a2ae6b9542b81$export$1581aa6fcae2be12)(), options);
    }
    async exportWritable(writable = new WritableStream(), options = {}) {
        await this.exportZip({
            writable: writable
        }, options);
        return writable;
    }
    async importZip(reader, options) {
        await (0, $9e0a2ae6b9542b81$export$a0b98872cda67175)(reader);
        const zipReader = new (0, $fe13039a5c7d1454$export$25e4af3b2af7fc76)(reader, options);
        const entries = await zipReader.getEntries();
        entries.forEach((entry)=>{
            let parent = this;
            const path = entry.filename.split("/");
            const name = path.pop();
            path.forEach((pathPart)=>parent = parent.getChildByName(pathPart) || new $93fb8e20d8e0e035$var$ZipDirectoryEntry(this.fs, pathPart, null, parent));
            if (!entry.directory) $93fb8e20d8e0e035$var$addChild(parent, name, {
                data: entry,
                Reader: $93fb8e20d8e0e035$var$getZipBlobReader(Object.assign({}, options))
            });
        });
    }
    async exportZip(writer, options) {
        const zipEntry = this;
        await Promise.all([
            $93fb8e20d8e0e035$var$initReaders(zipEntry),
            (0, $9e0a2ae6b9542b81$export$a0b98872cda67175)(writer)
        ]);
        const zipWriter = new (0, $2cb90b9cb96d205a$export$50f5658480930b4c)(writer, options);
        await $93fb8e20d8e0e035$var$exportZip(zipWriter, zipEntry, $93fb8e20d8e0e035$var$getTotalSize([
            zipEntry
        ], "uncompressedSize"), options);
        await zipWriter.close();
        return writer.getData ? writer.getData() : writer.writable;
    }
    getChildByName(name) {
        const children = this.children;
        for(let childIndex = 0; childIndex < children.length; childIndex++){
            const child = children[childIndex];
            if (child.name == name) return child;
        }
    }
}
class $93fb8e20d8e0e035$var$FS {
    constructor(){
        $93fb8e20d8e0e035$var$resetFS(this);
    }
    get children() {
        return this.root.children;
    }
    remove(entry) {
        $93fb8e20d8e0e035$var$detach(entry);
        this.entries[entry.id] = null;
    }
    move(entry, destination) {
        if (entry == this.root) throw new Error("Root directory cannot be moved");
        else {
            if (destination.directory) {
                if (!destination.isDescendantOf(entry)) {
                    if (entry != destination) {
                        if (destination.getChildByName(entry.name)) throw new Error("Entry filename already exists");
                        $93fb8e20d8e0e035$var$detach(entry);
                        entry.parent = destination;
                        destination.children.push(entry);
                    }
                } else throw new Error("Entry is a ancestor of target entry");
            } else throw new Error("Target entry is not a directory");
        }
    }
    find(fullname) {
        const path = fullname.split("/");
        let node = this.root;
        for(let index = 0; node && index < path.length; index++)node = node.getChildByName(path[index]);
        return node;
    }
    getById(id) {
        return this.entries[id];
    }
    getChildByName(name) {
        return this.root.getChildByName(name);
    }
    addDirectory(name) {
        return this.root.addDirectory(name);
    }
    addText(name, text) {
        return this.root.addText(name, text);
    }
    addBlob(name, blob) {
        return this.root.addBlob(name, blob);
    }
    addData64URI(name, dataURI) {
        return this.root.addData64URI(name, dataURI);
    }
    addHttpContent(name, url, options) {
        return this.root.addHttpContent(name, url, options);
    }
    addReadable(name, readable) {
        return this.root.addReadable(name, readable);
    }
    addFileSystemEntry(fileSystemEntry) {
        return this.root.addFileSystemEntry(fileSystemEntry);
    }
    addData(name, params) {
        return this.root.addData(name, params);
    }
    async importBlob(blob, options) {
        $93fb8e20d8e0e035$var$resetFS(this);
        await this.root.importBlob(blob, options);
    }
    async importData64URI(dataURI, options) {
        $93fb8e20d8e0e035$var$resetFS(this);
        await this.root.importData64URI(dataURI, options);
    }
    async importUint8Array(array, options) {
        $93fb8e20d8e0e035$var$resetFS(this);
        await this.root.importUint8Array(array, options);
    }
    async importHttpContent(url, options) {
        $93fb8e20d8e0e035$var$resetFS(this);
        await this.root.importHttpContent(url, options);
    }
    async importReadable(readable, options) {
        $93fb8e20d8e0e035$var$resetFS(this);
        await this.root.importReadable(readable, options);
    }
    exportBlob(options) {
        return this.root.exportBlob(options);
    }
    exportData64URI(options) {
        return this.root.exportData64URI(options);
    }
    exportUint8Array(options) {
        return this.root.exportUint8Array(options);
    }
    exportWritable(writable, options) {
        return this.root.exportWritable(writable, options);
    }
}
const $93fb8e20d8e0e035$export$69c37fe6a10b78d4 = {
    FS: $93fb8e20d8e0e035$var$FS,
    ZipDirectoryEntry: $93fb8e20d8e0e035$var$ZipDirectoryEntry,
    ZipFileEntry: $93fb8e20d8e0e035$var$ZipFileEntry
};
function $93fb8e20d8e0e035$var$getTotalSize(entries, propertyName) {
    let size = 0;
    entries.forEach(process);
    return size;
    function process(entry) {
        size += entry[propertyName];
        if (entry.children) entry.children.forEach(process);
    }
}
function $93fb8e20d8e0e035$var$getZipBlobReader(options) {
    return class extends (0, $9e0a2ae6b9542b81$export$2f7a2f0e90c07dc4) {
        constructor(entry, options = {}){
            super();
            this.entry = entry;
            this.options = options;
        }
        async init() {
            super.init();
            const zipBlobReader = this;
            zipBlobReader.size = zipBlobReader.entry.uncompressedSize;
            const data = await zipBlobReader.entry.getData(new (0, $9e0a2ae6b9542b81$export$b1948fceba813858)(), Object.assign({}, zipBlobReader.options, options));
            zipBlobReader.data = data;
            zipBlobReader.blobReader = new (0, $9e0a2ae6b9542b81$export$aa5015be25fe7f79)(data);
        }
        readUint8Array(index, length) {
            return this.blobReader.readUint8Array(index, length);
        }
    };
}
async function $93fb8e20d8e0e035$var$initReaders(entry) {
    if (entry.children.length) {
        for (const child of entry.children)if (child.directory) await $93fb8e20d8e0e035$var$initReaders(child);
        else {
            const reader = child.reader = new child.Reader(child.data);
            await (0, $9e0a2ae6b9542b81$export$a0b98872cda67175)(reader);
            child.uncompressedSize = reader.size;
        }
    }
}
function $93fb8e20d8e0e035$var$detach(entry) {
    const children = entry.parent.children;
    children.forEach((child, index)=>{
        if (child.id == entry.id) children.splice(index, 1);
    });
}
async function $93fb8e20d8e0e035$var$exportZip(zipWriter, entry, totalSize, options) {
    const selectedEntry = entry;
    const entryOffsets = new Map();
    await process(zipWriter, entry);
    async function process(zipWriter, entry) {
        await exportChild();
        async function exportChild() {
            if (options.bufferedWrite) await Promise.all(entry.children.map(processChild));
            else for (const child of entry.children)await processChild(child);
        }
        async function processChild(child) {
            const name = options.relativePath ? child.getRelativeName(selectedEntry) : child.getFullname();
            await zipWriter.add(name, child.reader, Object.assign({
                directory: child.directory
            }, Object.assign({}, options, {
                onprogress: async (indexProgress)=>{
                    if (options.onprogress) {
                        entryOffsets.set(name, indexProgress);
                        try {
                            await options.onprogress(Array.from(entryOffsets.values()).reduce((previousValue, currentValue)=>previousValue + currentValue), totalSize);
                        } catch (_error) {
                        // ignored
                        }
                    }
                }
            })));
            await process(zipWriter, child);
        }
    }
}
async function $93fb8e20d8e0e035$var$addFileSystemEntry(zipEntry, fileSystemEntry) {
    if (fileSystemEntry.isDirectory) {
        const entry = zipEntry.addDirectory(fileSystemEntry.name);
        await addDirectory(entry, fileSystemEntry);
        return entry;
    } else return new Promise((resolve, reject)=>fileSystemEntry.file((file)=>resolve(zipEntry.addBlob(fileSystemEntry.name, file)), reject));
    async function addDirectory(zipEntry, fileEntry) {
        const children = await getChildren(fileEntry);
        for (const child of children)if (child.isDirectory) await addDirectory(zipEntry.addDirectory(child.name), child);
        else await new Promise((resolve, reject)=>{
            child.file((file)=>{
                const childZipEntry = zipEntry.addBlob(child.name, file);
                childZipEntry.uncompressedSize = file.size;
                resolve(childZipEntry);
            }, reject);
        });
    }
    function getChildren(fileEntry) {
        return new Promise((resolve, reject)=>{
            let entries = [];
            if (fileEntry.isDirectory) readEntries(fileEntry.createReader());
            if (fileEntry.isFile) resolve(entries);
            function readEntries(directoryReader) {
                directoryReader.readEntries((temporaryEntries)=>{
                    if (!temporaryEntries.length) resolve(entries);
                    else {
                        entries = entries.concat(temporaryEntries);
                        readEntries(directoryReader);
                    }
                }, reject);
            }
        });
    }
}
function $93fb8e20d8e0e035$var$resetFS(fs) {
    fs.entries = [];
    fs.root = new $93fb8e20d8e0e035$var$ZipDirectoryEntry(fs);
}
function $93fb8e20d8e0e035$var$addChild(parent, name, params, directory) {
    if (parent.directory) return directory ? new $93fb8e20d8e0e035$var$ZipDirectoryEntry(parent.fs, name, params, parent) : new $93fb8e20d8e0e035$var$ZipFileEntry(parent.fs, name, params, parent);
    else throw new Error("Parent entry is not a directory");
}


let $54d56db39693d3f8$var$baseURL;
try {
    $54d56db39693d3f8$var$baseURL = "file:///node_modules/@zip.js/zip.js/lib/zip-fs.js";
} catch (_error) {
// ignored
}
(0, $1c2d4410a52b3cac$export$8d21e34596265fa2)({
    baseURL: $54d56db39693d3f8$var$baseURL
});
(0, $9a9cdc2e4ebf7a3a$export$2bee588cb9b7b41d)((0, $1c2d4410a52b3cac$export$8d21e34596265fa2));


(0, $1c2d4410a52b3cac$export$8d21e34596265fa2)({
    Deflate: $651421c71ecae26c$export$ae157b6234afe138,
    Inflate: $7b5e4d5528b9fdff$export$d1de70a877d6e43c
});



var $hF90B = parcelRequire("hF90B");

var $7DyRn = parcelRequire("7DyRn");

var $bNfEN = parcelRequire("bNfEN");
var $6b2e0f2f6a0fec57$exports = {};
$6b2e0f2f6a0fec57$exports = import.meta.resolve("h3Vwp");



var $bNfEN = parcelRequire("bNfEN");

var $0ab9b66b467cb64b$exports = {};
$0ab9b66b467cb64b$exports = import.meta.resolve("6RGRo");


class $efd1fe84abc2236b$export$60953fd2130152b1 extends HTMLElement {
    /** @type {boolean} */ #deletable = true;
    /** @type {string} */ #filename;
    /** @type {FileType} */ #type = "text";
    /** @type {boolean} */ #selected;
    /** @type {boolean} */ #renamable = true;
    /**
     * 
     * @param {string} filename 
     * @param {boolean} deletable defaults to true
     * @param {FileType} fileType defaults to text
     */ constructor(){
        super();
    }
    get selected() {
        return this.#selected;
    }
    set selected(val) {
        this.#selected = val;
        this.setAttribute("selected", this.#selected);
        this.setAttribute("aria-selected", this.#selected);
    }
    get type() {
        return this.#type;
    }
    set type(val) {
        this.#type = val;
        this.setAttribute("type", val);
    }
    get filename() {
        return this.#filename;
    }
    set filename(val) {
        this.#filename = val;
        this.setAttribute("filename", val);
    }
    get deletable() {
        return this.#deletable;
    }
    set deletable(val) {
        this.#deletable = val;
        this.setAttribute("deletable", val);
    }
    get renamable() {
        return this.#renamable;
    }
    set renamable(val) {
        this.#renamable = val;
        this.setAttribute("renamable", val);
    }
    connectedCallback() {
        const shadow = this.attachShadow({
            mode: "open"
        });
        // Instantiate element tree
        let stylesheet = document.createElement("link");
        stylesheet.rel = "stylesheet";
        stylesheet.href = $6b2e0f2f6a0fec57$exports;
        let bsIcons = document.createElement("link");
        bsIcons.rel = "stylesheet";
        bsIcons.href = new URL($0ab9b66b467cb64b$exports);
        let mainParent = document.createElement("div");
        mainParent.classList.add("code-name");
        let fileNameEl = document.createElement("p");
        fileNameEl.textContent = this.filename;
        fileNameEl.addEventListener("click", (e)=>this.#focusFile(e));
        if (this.renamable) fileNameEl.addEventListener("dblclick", (e)=>this.renameFile(e));
        mainParent.appendChild(fileNameEl);
        if (this.deletable) {
            let deleteFileEl = document.createElement("i");
            deleteFileEl.classList.add("bi", "bi-x", "delete-file-button");
            deleteFileEl.title = "Delete file";
            deleteFileEl.addEventListener("click", (e)=>this.deleteFile(e));
            mainParent.appendChild(deleteFileEl);
        }
        shadow.appendChild(stylesheet);
        shadow.appendChild(bsIcons);
        shadow.appendChild(mainParent);
        this.addEventListener("focus", (e)=>{
            (0, $4864cf74b2333fa3$export$f6acc09de0557d94)(this.filename);
        });
        // Set attributes
        this.setAttribute("selected", this.selected);
        this.setAttribute("filename", this.filename);
        this.setAttribute("type", this.type);
        this.tabIndex = 0;
        this.role = "tab";
    }
    deleteFile(e) {
        if (this.deletable && confirm(`Are you sure you want to delete ${this.filename}?`)) {
            const deleteEvent = new CustomEvent("filedelete", {
                detail: this.filename,
                composed: true
            });
            this.dispatchEvent(deleteEvent);
            if ((0, $bNfEN.goputer).files.type(this.filename) == "image") {
                window.URL.revokeObjectURL((0, $4864cf74b2333fa3$export$c66125bb69fe918a).get(this.filename).objectUrl);
                (0, $4864cf74b2333fa3$export$c66125bb69fe918a).delete(this.filename);
            }
            (0, $bNfEN.goputer).files.remove(this.filename);
            this.remove();
        }
    }
    #focusFile(e) {
        const focusEvent = new CustomEvent("fileselect", {
            detail: this.filename,
            composed: true
        });
        this.dispatchEvent(focusEvent);
        this.selected = true;
    }
    renameFile(e) {
        if (!this.renamable) return;
        let newFilename = prompt("Choose a new filename:", this.filename) ?? this.filename;
        if (newFilename.trim().length == 0) return;
        if ((0, $bNfEN.goputer).files.exists(newFilename)) return;
        (0, $bNfEN.goputer).files.rename(this.filename, newFilename);
        (0, $4864cf74b2333fa3$export$6b897890ed9cf9df)(newFilename, false);
        (0, $4864cf74b2333fa3$export$f6acc09de0557d94)(newFilename);
        const renameEvent = new CustomEvent("filerename", {
            detail: {
                oldName: this.filename,
                newName: newFilename
            }
        });
        this.dispatchEvent(renameEvent);
        this.remove();
    }
    /**
     * 
     * @param {string} name 
     * @param {string} oldValue 
     * @param {string} newValue 
     */ attributeChangedCallback(name, oldValue, newValue) {
        if (name === "selected" && oldValue !== newValue) this.selected = newValue === "true";
        else if (name == "filename" && oldValue !== newValue) this.filename = newValue;
        else if (name == "type" && oldValue !== newValue) this.type = newValue;
    }
    static observedAttributes = [
        "selected",
        "filename",
        "type"
    ];
    disconnectedCallback() {}
}
customElements.define("code-tab", $efd1fe84abc2236b$export$60953fd2130152b1);



var $7DyRn = parcelRequire("7DyRn");

var $bNfEN = parcelRequire("bNfEN");


const $4864cf74b2333fa3$var$rowLength = 16;
const $4864cf74b2333fa3$export$1f9169f556c5cb13 = document.getElementById("code-names-container");
const $4864cf74b2333fa3$var$newFile = document.getElementById("new-file");
$4864cf74b2333fa3$var$newFile.addEventListener("click", $4864cf74b2333fa3$export$552ff566cdfcd44c);
// Editor elements
/** @type {HTMLDivElement} */ const $4864cf74b2333fa3$var$codeEditorDiv = document.getElementById("code-editor");
const $4864cf74b2333fa3$export$88f7b74589ded201 = document.getElementById("code-textarea");
/** @type {HTMLDivElement} */ const $4864cf74b2333fa3$var$binDisplay = document.getElementById("bin-display");
/** @type {HTMLDivElement} */ const $4864cf74b2333fa3$var$binDisplayData = document.getElementById("bin-display-data");
/** @type {HTMLInputElement} */ const $4864cf74b2333fa3$var$binDisplayInput = document.getElementById("bin-display-offset-input");
/** @type {HTMLDivElement} */ const $4864cf74b2333fa3$var$imageDisplay = document.getElementById("img-display");
/** @type {HTMLImageElement} */ const $4864cf74b2333fa3$var$imageDisplayImage = document.getElementById("img-display-img");
/** @type {HTMLParagraphElement} */ const $4864cf74b2333fa3$var$imageDisplayInfo = document.getElementById("img-display-info");
/** @type {HTMLInputElement} */ const $4864cf74b2333fa3$var$imageDisplayTrueSize = document.getElementById("img-display-true-size");
/** @type {HTMLButtonElement} */ const $4864cf74b2333fa3$var$deleteAllButton = document.getElementById("delete-all-button");
const $4864cf74b2333fa3$export$c66125bb69fe918a = new Map();
$4864cf74b2333fa3$var$deleteAllButton.addEventListener("click", (e)=>{
    if (confirm("Are you sure you want permanently to delete all files?")) {
        $4864cf74b2333fa3$export$f310fb26facca8c3();
        $4864cf74b2333fa3$export$6b897890ed9cf9df("main.gpasm");
        $4864cf74b2333fa3$export$f6acc09de0557d94("main.gpasm");
    }
});
$4864cf74b2333fa3$var$imageDisplayTrueSize.addEventListener("change", /** @param {Event} e  */ (e)=>{
    if ($4864cf74b2333fa3$var$imageDisplayTrueSize.checked) $4864cf74b2333fa3$var$imageDisplayImage.style.height = "auto";
    else $4864cf74b2333fa3$var$imageDisplayImage.style.height = "100%";
});
$4864cf74b2333fa3$var$binDisplayInput.addEventListener("input", /** @param {Event} e  */ async (e)=>{
    const realOffset = (0, $98dd9785d83e1f2f$export$7d15b64cf5a3a4c4)($4864cf74b2333fa3$var$binDisplayInput.value, 0, await (0, $bNfEN.goputer).files.size((0, $7DyRn.default).focusedFile) - 1);
    const elementOffset = Math.floor(realOffset / $4864cf74b2333fa3$var$rowLength);
    if (elementOffset != 0) $4864cf74b2333fa3$var$binDisplayData.children[elementOffset - 1].scrollIntoView();
    else $4864cf74b2333fa3$var$binDisplayData.scroll(0, 0);
    // Highlight element
    const selection = window.getSelection();
    selection.removeAllRanges();
    const range = document.createRange();
    range.setStart($4864cf74b2333fa3$var$binDisplayData.children[elementOffset].children[1].childNodes[0], realOffset % $4864cf74b2333fa3$var$rowLength * 2);
    range.setEnd($4864cf74b2333fa3$var$binDisplayData.children[elementOffset].children[1].childNodes[0], realOffset % $4864cf74b2333fa3$var$rowLength * 2 + 2);
    selection.addRange(range);
});
$4864cf74b2333fa3$export$88f7b74589ded201.addEventListener("input", async (e)=>{
    let encoder = new TextEncoder();
    let encoded = encoder.encode($4864cf74b2333fa3$export$88f7b74589ded201.value);
    await (0, $bNfEN.goputer).files.update((0, $7DyRn.default).focusedFile, encoded, encoded.length, "text");
});
$4864cf74b2333fa3$var$codeEditorDiv.addEventListener("drop", /** @type {DragEvent} */ async (e)=>{
    e.preventDefault();
    if (e.dataTransfer.files.length > 0) {
        const f = e.dataTransfer.files[0];
        if (f.name.split(".").pop() == "zip") {
            (0, $2417d44c520c778f$export$e0d86c99d3dd93a2)(f);
            return;
        }
        if (f.size > await (0, $bNfEN.goputer).usableMemorySize) {
            if (!confirm(`This file is ${f.size} bytes in size which is larger than goputer's usable memory size of ${(0, $bNfEN.goputer).usableMemorySize} bytes. Press OK if you know what you are doing.`)) return;
        }
        let fileName = "";
        if (await (0, $bNfEN.goputer).files.exists(f.name)) fileName = `dup_${f.name}`;
        else fileName = f.name;
        $4864cf74b2333fa3$export$6b897890ed9cf9df(fileName);
        // Determine extension and thus filetype
        /** @type {import("./editor/code_tab").FileType} */ let fileType = "";
        switch(fileName.split(".").pop()){
            case "txt":
            case "gpasm":
                fileType = "text";
                break;
            case "png":
            case "jpg":
                fileType = "image";
                $4864cf74b2333fa3$export$1a174d7d284a26e2(new Blob([
                    f
                ]), fileName, ()=>{
                    $4864cf74b2333fa3$export$f6acc09de0557d94(fileName);
                });
                break;
            default:
                fileType = "bin";
                break;
        }
        await (0, $bNfEN.goputer).files.update(fileName, await f.bytes(), f.size, fileType, true);
        if (fileType != "image") $4864cf74b2333fa3$export$f6acc09de0557d94(fileName);
    }
});
$4864cf74b2333fa3$var$codeEditorDiv.addEventListener("dragover", (e)=>{
    e.preventDefault();
});
async function $4864cf74b2333fa3$export$f310fb26facca8c3() {
    for (const fileName of (await (0, $bNfEN.goputer).files.fileNames)){
        if (await (0, $bNfEN.goputer).files.type(fileName) == "image") window.URL.revokeObjectURL($4864cf74b2333fa3$export$c66125bb69fe918a.get(fileName).objectUrl);
        await (0, $bNfEN.goputer).files.remove(fileName);
        document.querySelector(`code-tab[filename="${fileName}"]`).remove();
    }
    $4864cf74b2333fa3$export$c66125bb69fe918a.clear();
}
function $4864cf74b2333fa3$export$1a174d7d284a26e2(imageBlob, key, loadCallback) {
    const imgUrl = window.URL.createObjectURL(imageBlob);
    const image = new Image();
    image.onload = (e)=>{
        $4864cf74b2333fa3$export$c66125bb69fe918a.set(key, {
            blob: imageBlob,
            objectUrl: imgUrl,
            dimensions: [
                image.width,
                image.height
            ]
        });
        if (typeof loadCallback !== "undefined") loadCallback();
    };
    image.src = imgUrl;
}
function $4864cf74b2333fa3$export$552ff566cdfcd44c(e) {
    let fileName = prompt("New file name:", `new_${(0, $bNfEN.goputer).files.numFiles + 1}.gpasm`);
    if (fileName == null || fileName == "" || fileName == ".gpasm") fileName = `new_${(0, $bNfEN.goputer).files.numFiles + 1}.gpasm`;
    $4864cf74b2333fa3$export$6b897890ed9cf9df(fileName);
    $4864cf74b2333fa3$export$f6acc09de0557d94(fileName);
}
function $4864cf74b2333fa3$export$6b897890ed9cf9df(fileName, doCreation = true) {
    if (doCreation) (0, $bNfEN.goputer).files.update(fileName, new Uint8Array(), 0, "text", true);
    /** @type {CodeTabElement} */ let newTab = document.createElement("code-tab");
    newTab.filename = fileName;
    if (fileName === "main.gpasm") {
        newTab.deletable = false;
        newTab.renamable = false;
    }
    newTab.type = "text";
    newTab.addEventListener("fileselect", /** @param {CustomEvent} e  */ (e)=>{
        $4864cf74b2333fa3$export$f6acc09de0557d94(e.detail);
    });
    newTab.addEventListener("filedelete", /** @param {CustomEvent} e  */ (e)=>{
        $4864cf74b2333fa3$export$c6bb9f240aa1bba6(e.detail);
    });
    $4864cf74b2333fa3$export$1f9169f556c5cb13.insertBefore(newTab, $4864cf74b2333fa3$var$newFile);
    (0, $7DyRn.default).focusedFile = fileName;
    $4864cf74b2333fa3$export$88f7b74589ded201.value = "";
    $4864cf74b2333fa3$export$4049c55c659f618a();
}
function $4864cf74b2333fa3$export$c6bb9f240aa1bba6(fileName) {
    $4864cf74b2333fa3$export$f6acc09de0557d94("main.gpasm");
}
async function $4864cf74b2333fa3$export$f6acc09de0557d94(fileName) {
    const fileBytes = new Uint8Array(new SharedArrayBuffer(await (0, $bNfEN.goputer).files.size(fileName)));
    await (0, $bNfEN.goputer).files.get(fileName, fileBytes);
    switch(await (0, $bNfEN.goputer).files.type(fileName)){
        case "text":
            $4864cf74b2333fa3$var$binDisplay.style.display = "none";
            $4864cf74b2333fa3$var$imageDisplay.style.display = "none";
            $4864cf74b2333fa3$export$88f7b74589ded201.style.display = "block";
            let textDecoder = new TextDecoder();
            let decodedText = textDecoder.decode(fileBytes.slice());
            $4864cf74b2333fa3$export$88f7b74589ded201.value = decodedText;
            break;
        case "image":
            $4864cf74b2333fa3$export$88f7b74589ded201.style.display = "none";
            $4864cf74b2333fa3$var$binDisplay.style.display = "none";
            $4864cf74b2333fa3$var$imageDisplay.style.display = "grid";
            $4864cf74b2333fa3$var$imageDisplayImage.src = $4864cf74b2333fa3$export$c66125bb69fe918a.get(fileName).objectUrl;
            $4864cf74b2333fa3$var$imageDisplayInfo.innerText = `Dimensions: ${$4864cf74b2333fa3$export$c66125bb69fe918a.get(fileName).dimensions[0]}x${$4864cf74b2333fa3$export$c66125bb69fe918a.get(fileName).dimensions[1]}
Original size: ${$4864cf74b2333fa3$export$c66125bb69fe918a.get(fileName).blob.size} bytes Encoded size: ${(0, $bNfEN.goputer).files.size(fileName)} bytes`;
            break;
        case "bin":
            $4864cf74b2333fa3$export$88f7b74589ded201.style.display = "none";
            $4864cf74b2333fa3$var$imageDisplay.style.display = "none";
            $4864cf74b2333fa3$var$binDisplay.style.display = "block";
            $4864cf74b2333fa3$var$binDisplayData.replaceChildren();
            for(let i = 0; i < fileBytes.length; i += $4864cf74b2333fa3$var$rowLength){
                let hexString = "";
                fileBytes.slice(i, i + $4864cf74b2333fa3$var$rowLength).forEach((element)=>{
                    hexString += element.toString(16).padStart(2, "0");
                });
                // Create elements
                const container = document.createElement("div");
                const offsetAddress = document.createElement("span");
                offsetAddress.innerText = i.toString(16).padStart(8, "0");
                offsetAddress.title = i.toString();
                const row = document.createElement("span");
                row.innerText = hexString;
                container.appendChild(offsetAddress);
                container.appendChild(row);
                $4864cf74b2333fa3$var$binDisplayData.appendChild(container);
            }
            break;
        default:
            break;
    }
    (0, $7DyRn.default).focusedFile = fileName;
    $4864cf74b2333fa3$export$4049c55c659f618a();
}
function $4864cf74b2333fa3$export$4049c55c659f618a() {
    let fileElements = $4864cf74b2333fa3$export$1f9169f556c5cb13.children;
    for(let i = 0; i < fileElements.length; i++)if (fileElements[i].getAttribute("filename") != (0, $7DyRn.default).focusedFile) fileElements[i].setAttribute("selected", "false");
    else fileElements[i].setAttribute("selected", "true");
}


async function $2417d44c520c778f$export$e0d86c99d3dd93a2(fileBlob) {
    if (confirm("Importing this will delete all existing files. Are you sure you want to do this?")) (0, $4864cf74b2333fa3$export$f310fb26facca8c3)();
    else return;
    const zipFileReader = new (0, $9e0a2ae6b9542b81$export$aa5015be25fe7f79)(fileBlob);
    const zipReader = new (0, $fe13039a5c7d1454$export$25e4af3b2af7fc76)(zipFileReader);
    for (const ent of (await zipReader.getEntries()))if (!ent.directory && ent.filename.split("/").length == 1) {
        const fileWriter = new (0, $9e0a2ae6b9542b81$export$1581aa6fcae2be12)();
        await ent.getData(fileWriter);
        const fileData = await fileWriter.getData();
        const fileDataShared = Uint8Array(new SharedArrayBuffer(fileData.length));
        fileDataShared.set(fileData);
        /** @type {import("./editor/code_tab").FileType} */ let fileType;
        switch(ent.filename.split(".").pop()){
            case "txt":
            case "gpasm":
                fileType = "text";
                break;
            case "png":
            case "jpg":
                fileType = "image";
                (0, $4864cf74b2333fa3$export$1a174d7d284a26e2)(new Blob([
                    fileData
                ]), ent.filename);
                break;
            default:
                fileType = "bin";
                break;
        }
        await (0, $bNfEN.goputer).files.update(ent.filename, fileDataShared, fileDataShared.length, fileType, true);
        (0, $4864cf74b2333fa3$export$6b897890ed9cf9df)(ent.filename, false);
    }
    (0, $4864cf74b2333fa3$export$f6acc09de0557d94)("main.gpasm");
    (0, $hF90B.ShowError)((0, $hF90B.ErrorTypes).Success, "Imported code from archive");
}
async function $2417d44c520c778f$export$4bda4314ff8f4f9c(e) {
    const zipFileWriter = new (0, $9e0a2ae6b9542b81$export$b1948fceba813858)();
    const zipWriter = new (0, $2cb90b9cb96d205a$export$50f5658480930b4c)(zipFileWriter);
    for (const fileName of (await (0, $bNfEN.goputer).files.fileNames)){
        /** @type {Uint8Array} */ let fileBytes;
        if ((0, $bNfEN.goputer).files.type(fileName) == "image") fileBytes = new Uint8Array(await (0, $4864cf74b2333fa3$export$c66125bb69fe918a).get(fileName).blob.arrayBuffer());
        else {
            fileBytes = new Uint8Array(new SharedArrayBuffer(await (0, $bNfEN.goputer).files.size(fileName)));
            await (0, $bNfEN.goputer).files.get(fileName, fileBytes);
        }
        const fileReader = new (0, $9e0a2ae6b9542b81$export$d6e62de78e81ef8b)(fileBytes);
        await zipWriter.add(fileName, fileReader);
    }
    await zipWriter.close();
    const objUrl = window.URL.createObjectURL(await zipFileWriter.getData());
    const date = new Date();
    /** @type {HTMLAnchorElement} */ const linkElement = document.createElement("a");
    linkElement.href = objUrl;
    linkElement.download = `files_${date.getHours().toString().padStart(2, "0")}${date.getMinutes().toString().padStart(2, "0")}${date.getSeconds().toString().padStart(2, "0")}.zip`;
    linkElement.click();
    window.URL.revokeObjectURL(objUrl);
    (0, $hF90B.ShowError)((0, $hF90B.ErrorTypes).Success, "Zip file exported successfully.");
}
async function $2417d44c520c778f$export$48b966240d8e5e43(_) {
    // Convert method return value to bytes first.
    const programBytesSharedBuffer = new Uint8Array(new SharedArrayBuffer(await (0, $bNfEN.goputer).getProgramLength()));
    await (0, $bNfEN.goputer).getProgramBytes(programBytesSharedBuffer);
    const date = new Date();
    if (!(0, $7DyRn.default).codeHasBeenCompiled) return;
    const programBytes = new Uint8Array(programBytesSharedBuffer.length);
    programBytes.set(programBytesSharedBuffer);
    const blob = new Blob([
        programBytes
    ], {
        type: "application/octet-stream"
    });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    const filename = `program_${date.getHours().toString().padStart(2, "0")}${date.getMinutes().toString().padStart(2, "0")}${date.getSeconds().toString().padStart(2, "0")}.gp`;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(blob);
}
async function $2417d44c520c778f$export$ca7b224f96fd7e64(e) {
    const uploadForm = document.createElement("input");
    uploadForm.type = "file";
    uploadForm.accept = ".gp";
    uploadForm.multiple = false;
    uploadForm.addEventListener("change", async (e)=>{
        const file = uploadForm.files[0];
        const fileBytes = await file.arrayBuffer();
        if (new TextDecoder().decode(fileBytes.slice(0, 4)) != "GPTR") {
            alert("Invalid file.");
            return;
        }
        console.log(`Read file with ${fileBytes.byteLength} byte(s)`);
        const fileBytesShared = new Uint8Array(new SharedArrayBuffer(fileBytes.byteLength));
        fileBytesShared.set(new Uint8Array(fileBytes));
        await (0, $bNfEN.goputer).setProgramBytes(fileBytesShared, fileBytesShared.length);
        document.getElementById("run-code-button").disabled = false;
        document.getElementById("download-code-button").disabled = false;
        (0, $7DyRn.default).codeHasBeenCompiled = true;
        (0, $7DyRn.default).compileFailed = false;
        // Hide code editor
        document.getElementById("code-editor").style.visibility = "hidden";
        document.getElementById("binary-message").style.display = "block";
        document.getElementById("compile-code-button").disabled = true;
        document.getElementById("download-all-button").disabled = true;
        (0, $hF90B.ShowError)((0, $hF90B.ErrorTypes).Success, "Binary uploaded successfully");
    });
    uploadForm.click();
}


var $a3caf2326ac0f25f$exports = {};
$a3caf2326ac0f25f$exports = {
    "examples": [
        {
            "name": "Shapes",
            "description": "Draws several shapes to the screen",
            "path": "area_test",
            "program_text": "//Draws a rectangle and other shapes to the screen\n#def pos 64\n#def size 2\n\n#def line_end_x 320\n#def line_end_y 240\n\n#def white 0xFFFFFFFF\n\n//          \n#def poly 0x03_4000_8040_0040\n\n#label start\n\nlda @white\nmov d0 vc\n\nlda @pos\nmov d0 r00\nlda @size\nmov d0 r01\n\nmul r00 r01\nmov a0 vx1\nmov a0 vy1\n\nmov r00 vx0\nmov r00 vy0\nint va\n\nadd r00 r00\nmov a0 vx0\nmov a0 vy0\n\nlda @poly\nint vp\n\nlda @line_end_x\nmov d0 vx1\n\nlda @line_end_y\nmov d0 vy1\n\nclr vx0\nclr vy0\n\nint vl\n\nint vf\n"
        },
        {
            "name": "Hello World",
            "description": "Basic hello world example",
            "path": "hello_world",
            "program_text": "// Simple hello world example\n\n#def hw \"Hello World\"\n#def white 0xFFFFFFFF\n\n#label start\n\nlda @hw\nmov d0 vt\n\nlda @white\nmov d0 vc\n\nint vt\nint vf\n"
        },
        {
            "name": "IO Inputs",
            "description": "IO Inputs test",
            "path": "io_inputs",
            "program_text": "\n// Turning IO outputs on/off with switches.\n\n#label handle_io\n\nmov io08 io00\nmov io09 io01\nmov io10 io02\nmov io11 io03\nmov io12 io04\nmov io13 io05\nmov io14 io06\nmov io15 io07\n\nint iof\n\niret\n\n#intsub io08 handle_io\n#intsub io09 handle_io\n#intsub io10 handle_io\n#intsub io11 handle_io\n#intsub io12 handle_io\n#intsub io13 handle_io\n#intsub io14 handle_io\n#intsub io15 handle_io\n\n#label hang_loop\njmp @hang_loop\n\n#label start\n\njmp @hang_loop\n \n"
        },
        {
            "name": "Paint",
            "description": "Simple paint program",
            "path": "line_paint",
            "program_text": "//Paint but uses lines\n//r00 = mx previous\n//r01 = my previous\n\n#def white 0xFFFFFFFF\n#def black 0x000000FF\n\n#label handle_mouse_move\n\nmov mx vx1\nmov my vy1\n\nmov r00 vx0\nmov r01 vy0\n\nint vl\nint vf\n\nmov mx r00\nmov my r01\n\niret\n\n#label clear_bg\n\nlda @white\nmov d0 vc\nint vc\nint vf\n\nlda @black\nmov d0 vc\n\niret\n\n#intsub mm handle_mouse_move\n#intsub kd clear_bg\n\n#label loop\njmp @loop\n\n#label start\n\nlda @white\nmov d0 vc\nint vc\nint vf\n\nlda @black\nmov d0 vc\n\njmp @loop\n\n"
        },
        {
            "name": "Sound",
            "description": "Increasing sound frequency",
            "path": "sound",
            "program_text": "//Outputs a sine wave and increases frequency over time.\n#def x 10\n#def t 50\n#def vol 16\n\n#label loop\n\nadd r00 r02\nmov a0 r00\nmov r00 st\nint sf\nhlt r01\njmp @loop\n\n#label start\n\nlda @x\nmov d0 r00\nmov d0 r02\n\nlda @t\nmov d0 r01\n\nlda @vol\nmov d0 sv\n\njmp @loop\n"
        },
        {
            "name": "System Module",
            "description": "Grabs the name of the frontend from the system module",
            "path": "sys_module",
            "program_text": "// Interacts with the system module\n\n#def white 0xFFFFFFFF\n#def name_string \"Name: \"\n\n#label start\n\nlda @white\nmov d0 vc\n\nclr d0\n\nemi r00\nmov d0 vt\n\nlda @name_string\nsr vt dl\nmov d0 vt\n\nint vt\nint vf\n"
        },
        {
            "name": "Paint keyboard",
            "description": "Like paint but uses keyboard presses for drawing",
            "path": "paint_keyboard_press",
            "program_text": "//Paint that uses clicks\n\n#def bg 0xffffffff\n#def line 0x000000ff\n\n// Main hang loop\n\n#label loop\njmp @loop\n\n// Cleanup\n\n#label end_draw\n\nclr a0\nclr io00\nint iof\nint vf\n\nret\n\n// Two main draw calls\n\n#label draw_line\nint vl\nret\n\n#label draw_square\nint va\nret\n\n// Decide wether to draw square or line\n\n#label finish_draw\n\nmov mx vx1\nmov my vy1\n\nclr a0\n\neq io08 r00\ncndcall @draw_square\n\nneq io08 r00\ncndcall @draw_line\n\ncall @end_draw\n\niret\n\n#label start_draw\n\nmov mx vx0\nmov my vy0\n\nclr a0\nincr io00\nint iof\n\niret\n\n// Handle initial keyboard press\n\n#label onpress\n\nneq io00 r00\ncndjmp @start_draw\n\neq io00 r00\ncndjmp @finish_draw\n\niret\n\n// Entrypoint\n\n#label start\n\nlda @bg\nmov d0 vc\nint vc\nint vf\n\n#intsub kd onpress\n\nlda @line\nmov d0 vc\n\nincr r00\n\njmp @loop\n"
        },
        {
            "name": "Fibonacci",
            "description": "Iteraritve Fibonacci",
            "path": "fib",
            "program_text": "// Iterative fib\n// Result is stored in r02\n// Target is 46 because this results in the largest value that can be stored\n// in a 32 bit register.\n\n#def aim 46\n#def two 2\n\n#label start\n\nlda @two\nmov d0 r00\n\nlda @aim\nmov d0 r15\nlt r15 r00\ncndjmp @end\n\n// Loop\n\nincr r03\n\nclr r00\nincr r01\n\n#label main_loop\n\nadd r00 r01\nmov a0 r00\n\nmov r00 r02\nmov r01 r00\nmov r02 r01\n\nsub r15 r03\nmov a0 r15\n\ngt r15 r04\ncndjmp @main_loop\n\n#label end\n"
        }
    ]
};



var $9515b9ba06508bd8$var$examplesObj = {};
function $9515b9ba06508bd8$export$f08e7c5fc9ab694a() {
    (0, (/*@__PURE__*/$parcel$interopDefault($a3caf2326ac0f25f$exports))).examples.forEach((element)=>{
        $9515b9ba06508bd8$var$examplesObj[element.path] = element.program_text;
        let exampleContainer = document.createElement("div");
        exampleContainer.classList.add("example-container");
        exampleContainer.setAttribute("data-path", element.path);
        exampleContainer.setAttribute("role", "button");
        let exampleHeader = document.createElement("h3");
        exampleHeader.textContent = element.name;
        exampleContainer.appendChild(exampleHeader);
        let exampleDesc = document.createElement("p");
        exampleDesc.textContent = element.description;
        exampleContainer.appendChild(exampleDesc);
        exampleContainer.addEventListener("click", $9515b9ba06508bd8$var$loadExample);
        (0, $10c90e54c8ae0167$export$96e737b0349ce11f).appendChild(exampleContainer);
    });
}
async function $9515b9ba06508bd8$var$loadExample(e) {
    document.getElementById("code-textarea").value = "Loading...";
    document.getElementById("code-textarea").value = $9515b9ba06508bd8$var$examplesObj[e.currentTarget.getAttribute("data-path")];
    document.getElementById("code-textarea").dispatchEvent(new InputEvent("input", {
        bubbles: true,
        cancelable: true
    }));
}


/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ /*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ /*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ function $053d5bbcf6664967$export$a7a9523472993e97(x) {
    if (!x) throw new Error('Assertion failed.');
}
const $053d5bbcf6664967$export$c552f3b8491c68b8 = (rotation)=>{
    const mappedRotation = (rotation % 360 + 360) % 360;
    if (mappedRotation === 0 || mappedRotation === 90 || mappedRotation === 180 || mappedRotation === 270) return mappedRotation;
    else throw new Error(`Invalid rotation ${rotation}.`);
};
const $053d5bbcf6664967$export$4c7897fafd92b108 = (arr)=>{
    return arr && arr[arr.length - 1];
};
const $053d5bbcf6664967$export$ea44a6b0d261b831 = (value)=>{
    return value >= 0 && value < 2 ** 32;
};
class $053d5bbcf6664967$export$d16e6594b36c3ef7 {
    constructor(bytes){
        this.bytes = bytes;
        /** Current offset in bits. */ this.pos = 0;
    }
    seekToByte(byteOffset) {
        this.pos = 8 * byteOffset;
    }
    readBit() {
        const byteIndex = Math.floor(this.pos / 8);
        const byte = this.bytes[byteIndex] ?? 0;
        const bitIndex = 7 - (this.pos & 7);
        const bit = (byte & 1 << bitIndex) >> bitIndex;
        this.pos++;
        return bit;
    }
    readBits(n) {
        let result = 0;
        for(let i = 0; i < n; i++){
            result <<= 1;
            result |= this.readBit();
        }
        return result;
    }
    readAlignedByte() {
        // Ensure we're byte-aligned
        if (this.pos % 8 !== 0) throw new Error('Bitstream is not byte-aligned.');
        const byteIndex = this.pos / 8;
        const byte = this.bytes[byteIndex] ?? 0;
        this.pos += 8;
        return byte;
    }
    skipBits(n) {
        this.pos += n;
    }
    getBitsLeft() {
        return this.bytes.length * 8 - this.pos;
    }
    clone() {
        const clone = new $053d5bbcf6664967$export$d16e6594b36c3ef7(this.bytes);
        clone.pos = this.pos;
        return clone;
    }
}
const $053d5bbcf6664967$export$500cd5ed364299e5 = (bitstream)=>{
    let leadingZeroBits = 0;
    while(bitstream.readBit() === 0 && leadingZeroBits < 32)leadingZeroBits++;
    if (leadingZeroBits >= 32) throw new Error('Invalid exponential-Golomb code.');
    const result = (1 << leadingZeroBits) - 1 + bitstream.readBits(leadingZeroBits);
    return result;
};
const $053d5bbcf6664967$export$a3b63e900e78c883 = (bitstream)=>{
    const codeNum = $053d5bbcf6664967$export$500cd5ed364299e5(bitstream);
    return (codeNum & 1) === 0 ? -(codeNum >> 1) : codeNum + 1 >> 1;
};
const $053d5bbcf6664967$export$2d7b024149356cd9 = (bytes, start, end, value)=>{
    for(let i = start; i < end; i++){
        const byteIndex = Math.floor(i / 8);
        let byte = bytes[byteIndex];
        const bitIndex = 7 - (i & 7);
        byte &= ~(1 << bitIndex);
        byte |= (value & 1 << end - i - 1) >> end - i - 1 << bitIndex;
        bytes[byteIndex] = byte;
    }
};
const $053d5bbcf6664967$export$73470fd2221e6aef = (source)=>{
    if (source instanceof Uint8Array) return source;
    else if (source instanceof ArrayBuffer) return new Uint8Array(source);
    else return new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
};
const $053d5bbcf6664967$export$f6b0788df7b6d1ec = (source)=>{
    if (source instanceof DataView) return source;
    else if (source instanceof ArrayBuffer) return new DataView(source);
    else return new DataView(source.buffer, source.byteOffset, source.byteLength);
};
const $053d5bbcf6664967$export$f5d75491a17f02c = new TextEncoder();
const $053d5bbcf6664967$var$invertObject = (object)=>{
    return Object.fromEntries(Object.entries(object).map(([key, value])=>[
            value,
            key
        ]));
};
const $053d5bbcf6664967$export$c9d0dddad4eef393 = {
    bt709: 1,
    bt470bg: 5,
    smpte170m: 6,
    bt2020: 9,
    smpte432: 12
};
const $053d5bbcf6664967$export$6e4dfa3ebb99db16 = $053d5bbcf6664967$var$invertObject($053d5bbcf6664967$export$c9d0dddad4eef393);
const $053d5bbcf6664967$export$36a5c840f44dac9a = {
    'bt709': 1,
    'smpte170m': 6,
    'linear': 8,
    'iec61966-2-1': 13,
    'pg': 16,
    'hlg': 18
};
const $053d5bbcf6664967$export$b80730c5addac48f = $053d5bbcf6664967$var$invertObject($053d5bbcf6664967$export$36a5c840f44dac9a);
const $053d5bbcf6664967$export$62b3c37e3f8b5eb4 = {
    'rgb': 0,
    'bt709': 1,
    'bt470bg': 5,
    'smpte170m': 6,
    'bt2020-ncl': 9
};
const $053d5bbcf6664967$export$e35036e61f36d563 = $053d5bbcf6664967$var$invertObject($053d5bbcf6664967$export$62b3c37e3f8b5eb4);
const $053d5bbcf6664967$export$17ed7af6b4f218ca = (colorSpace)=>{
    return !!colorSpace && !!colorSpace.primaries && !!colorSpace.transfer && !!colorSpace.matrix && colorSpace.fullRange !== undefined;
};
const $053d5bbcf6664967$export$ba2695b5f58bd3c4 = (x)=>{
    return x instanceof ArrayBuffer || typeof SharedArrayBuffer !== 'undefined' && x instanceof SharedArrayBuffer || ArrayBuffer.isView(x);
};
class $053d5bbcf6664967$export$7ea9f882800689bb {
    constructor(){
        this.currentPromise = Promise.resolve();
    }
    async acquire() {
        let resolver;
        const nextPromise = new Promise((resolve)=>{
            resolver = resolve;
        });
        const currentPromiseAlias = this.currentPromise;
        this.currentPromise = nextPromise;
        await currentPromiseAlias;
        return resolver;
    }
}
const $053d5bbcf6664967$export$53baaea4633b455e = (bytes)=>{
    return [
        ...bytes
    ].map((x)=>x.toString(16).padStart(2, '0')).join('');
};
const $053d5bbcf6664967$export$755636eac4d8473 = (x)=>{
    x = x >> 1 & 0x55555555 | (x & 0x55555555) << 1;
    x = x >> 2 & 0x33333333 | (x & 0x33333333) << 2;
    x = x >> 4 & 0x0f0f0f0f | (x & 0x0f0f0f0f) << 4;
    x = x >> 8 & 0x00ff00ff | (x & 0x00ff00ff) << 8;
    x = x >> 16 & 0x0000ffff | (x & 0x0000ffff) << 16;
    return x >>> 0; // Ensure it's treated as an unsigned 32-bit integer
};
const $053d5bbcf6664967$export$d2630f147aa8c00c = (arr, key, valueGetter)=>{
    let low = 0;
    let high = arr.length - 1;
    let ans = -1;
    while(low <= high){
        const mid = low + high >> 1;
        const midVal = valueGetter(arr[mid]);
        if (midVal === key) {
            ans = mid;
            high = mid - 1; // Continue searching left to find the lowest index
        } else if (midVal < key) low = mid + 1;
        else high = mid - 1;
    }
    return ans;
};
const $053d5bbcf6664967$export$682d30103b1cfe4f = (arr, key, valueGetter)=>{
    let low = 0;
    let high = arr.length - 1;
    let ans = -1;
    while(low <= high){
        const mid = low + (high - low + 1) / 2 | 0;
        const midVal = valueGetter(arr[mid]);
        if (midVal <= key) {
            ans = mid;
            low = mid + 1;
        } else high = mid - 1;
    }
    return ans;
};
const $053d5bbcf6664967$export$283a1614f1b16769 = ()=>{
    let resolve;
    let reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
};
const $053d5bbcf6664967$export$fe2d9b4e03920b4c = (arr, item)=>{
    const index = arr.indexOf(item);
    if (index !== -1) arr.splice(index, 1);
};
const $053d5bbcf6664967$export$296de88ccac4bedb = (arr, predicate)=>{
    for(let i = arr.length - 1; i >= 0; i--){
        if (predicate(arr[i])) return arr[i];
    }
    return undefined;
};
const $053d5bbcf6664967$export$8855a8be7bd3e9f8 = (arr, predicate)=>{
    for(let i = arr.length - 1; i >= 0; i--){
        if (predicate(arr[i])) return i;
    }
    return -1;
};
const $053d5bbcf6664967$export$83595173025a1dfb = async function*(source) {
    if (Symbol.iterator in source) // @ts-expect-error Trust me
    yield* source[Symbol.iterator]();
    else // @ts-expect-error Trust me
    yield* source[Symbol.asyncIterator]();
};
const $053d5bbcf6664967$export$9a53079e0a0ef0fb = (iterable)=>{
    if (!(Symbol.iterator in iterable) && !(Symbol.asyncIterator in iterable)) throw new TypeError('Argument must be an iterable or async iterable.');
};
const $053d5bbcf6664967$export$cbadc5a7223772a8 = (x)=>{
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    throw new Error(`Unexpected value: ${x}`);
};
const $053d5bbcf6664967$export$32b2c839ee319ab6 = (view, byteOffset, littleEndian)=>{
    const byte1 = view.getUint8(byteOffset);
    const byte2 = view.getUint8(byteOffset + 1);
    const byte3 = view.getUint8(byteOffset + 2);
    if (littleEndian) return byte1 | byte2 << 8 | byte3 << 16;
    else return byte1 << 16 | byte2 << 8 | byte3;
};
const $053d5bbcf6664967$export$bc4fa2eeefffa8ff = (view, byteOffset, littleEndian)=>{
    // The left shift pushes the most significant bit into the sign bit region, and the subsequent right shift
    // then correctly interprets the sign bit.
    return $053d5bbcf6664967$export$32b2c839ee319ab6(view, byteOffset, littleEndian) << 8 >> 8;
};
const $053d5bbcf6664967$export$fab9cd90bc5ef1b8 = (view, byteOffset, value, littleEndian)=>{
    // Ensure the value is within 24-bit unsigned range (0 to 16777215)
    value = value >>> 0; // Convert to unsigned 32-bit
    value = value & 0xFFFFFF; // Mask to 24 bits
    if (littleEndian) {
        view.setUint8(byteOffset, value & 0xFF);
        view.setUint8(byteOffset + 1, value >>> 8 & 0xFF);
        view.setUint8(byteOffset + 2, value >>> 16 & 0xFF);
    } else {
        view.setUint8(byteOffset, value >>> 16 & 0xFF);
        view.setUint8(byteOffset + 1, value >>> 8 & 0xFF);
        view.setUint8(byteOffset + 2, value & 0xFF);
    }
};
const $053d5bbcf6664967$export$f80a9546ed30b3d2 = (view, byteOffset, value, littleEndian)=>{
    // Ensure the value is within 24-bit signed range (-8388608 to 8388607)
    value = $053d5bbcf6664967$export$7d15b64cf5a3a4c4(value, -8388608, 8388607);
    // Convert negative values to their 24-bit representation
    if (value < 0) value = value + 0x1000000 & 0xFFFFFF;
    $053d5bbcf6664967$export$fab9cd90bc5ef1b8(view, byteOffset, value, littleEndian);
};
const $053d5bbcf6664967$export$8532a5209571c04a = (view, byteOffset, value, littleEndian)=>{
    if (littleEndian) {
        view.setUint32(byteOffset + 0, value, true);
        view.setInt32(byteOffset + 4, Math.floor(value / 2 ** 32), true);
    } else {
        view.setInt32(byteOffset + 0, Math.floor(value / 2 ** 32), true);
        view.setUint32(byteOffset + 4, value, true);
    }
};
const $053d5bbcf6664967$export$3abce8f324616eb4 = (generator, map)=>{
    return {
        async next () {
            const result = await generator.next();
            if (result.done) return {
                value: undefined,
                done: true
            };
            else return {
                value: map(result.value),
                done: false
            };
        },
        return () {
            return generator.return();
        },
        throw (error) {
            return generator.throw(error);
        },
        [Symbol.asyncIterator] () {
            return this;
        }
    };
};
const $053d5bbcf6664967$export$7d15b64cf5a3a4c4 = (value, min, max)=>{
    return Math.max(min, Math.min(max, value));
};
const $053d5bbcf6664967$export$af15dfb067c7ab59 = 'und';
const $053d5bbcf6664967$export$b485511e5cd71305 = (value, digits)=>{
    const factor = 10 ** digits;
    return Math.round(value * factor) / factor;
};
const $053d5bbcf6664967$export$6abe75030bbc425c = (value, multiple)=>{
    return Math.round(value / multiple) * multiple;
};
const $053d5bbcf6664967$export$4522663bbb3faec8 = (x)=>{
    let ret = 0;
    while(x){
        ret++;
        x >>= 1;
    }
    return ret;
};
const $053d5bbcf6664967$var$ISO_639_2_REGEX = /^[a-z]{3}$/;
const $053d5bbcf6664967$export$c53f86278a6c5ab7 = (x)=>{
    return $053d5bbcf6664967$var$ISO_639_2_REGEX.test(x);
};
const $053d5bbcf6664967$export$6b7fbfaaab0cbddf = 1e6 * (1 + Number.EPSILON);
const $053d5bbcf6664967$export$81366150e5728ca5 = (a, b)=>{
    const result = {
        ...a
    };
    for(const key in b)if (typeof a[key] === 'object' && a[key] !== null && typeof b[key] === 'object' && b[key] !== null) result[key] = $053d5bbcf6664967$export$81366150e5728ca5(a[key], b[key]);
    else result[key] = b[key];
    return result;
};
const $053d5bbcf6664967$export$add9c427fd3d5823 = async (url, requestInit, getRetryDelay)=>{
    let attempts = 0;
    while(true)try {
        return await fetch(url, requestInit);
    } catch (error) {
        console.error('Retrying failed fetch. Error:', error);
        attempts++;
        const retryDelayInSeconds = getRetryDelay(attempts);
        if (retryDelayInSeconds === null) throw error;
        if (!Number.isFinite(retryDelayInSeconds) || retryDelayInSeconds < 0) throw new TypeError('Retry delay must be a non-negative finite number.');
        if (retryDelayInSeconds > 0) await new Promise((resolve)=>setTimeout(resolve, 1000 * retryDelayInSeconds));
    }
};
const $053d5bbcf6664967$export$b1c38697fb776eb0 = (x, maxDenominator)=>{
    // Handle negative numbers
    const sign = x < 0 ? -1 : 1;
    x = Math.abs(x);
    let prevNumerator = 0, prevDenominator = 1;
    let currNumerator = 1, currDenominator = 0;
    // Continued fraction algorithm
    let remainder = x;
    while(true){
        const integer = Math.floor(remainder);
        // Calculate next convergent
        const nextNumerator = integer * currNumerator + prevNumerator;
        const nextDenominator = integer * currDenominator + prevDenominator;
        if (nextDenominator > maxDenominator) return {
            numerator: sign * currNumerator,
            denominator: currDenominator
        };
        prevNumerator = currNumerator;
        prevDenominator = currDenominator;
        currNumerator = nextNumerator;
        currDenominator = nextDenominator;
        remainder = 1 / (remainder - integer);
        // Guard against precision issues
        if (!isFinite(remainder)) break;
    }
    return {
        numerator: sign * currNumerator,
        denominator: currDenominator
    };
};
class $053d5bbcf6664967$export$e0e588a18ea3887d {
    constructor(){
        this.currentPromise = Promise.resolve();
    }
    call(fn) {
        return this.currentPromise = this.currentPromise.then(fn);
    }
}


class $9fedaf112e3db83b$export$d7a960146e1a269e {
    constructor(){
        /** Setting this to true will cause the writer to ensure data is written in a strictly monotonic, streamable way. */ this.ensureMonotonicity = false;
        this.trackedWrites = null;
        this.trackedStart = -1;
        this.trackedEnd = -1;
    }
    start() {}
    maybeTrackWrites(data) {
        if (!this.trackedWrites) return;
        // Handle negative relative write positions
        let pos = this.getPos();
        if (pos < this.trackedStart) {
            if (pos + data.byteLength <= this.trackedStart) return;
            data = data.subarray(this.trackedStart - pos);
            pos = 0;
        }
        const neededSize = pos + data.byteLength - this.trackedStart;
        let newLength = this.trackedWrites.byteLength;
        while(newLength < neededSize)newLength *= 2;
        // Check if we need to resize the buffer
        if (newLength !== this.trackedWrites.byteLength) {
            const copy = new Uint8Array(newLength);
            copy.set(this.trackedWrites, 0);
            this.trackedWrites = copy;
        }
        this.trackedWrites.set(data, pos - this.trackedStart);
        this.trackedEnd = Math.max(this.trackedEnd, pos + data.byteLength);
    }
    startTrackingWrites() {
        this.trackedWrites = new Uint8Array(1024);
        this.trackedStart = this.getPos();
        this.trackedEnd = this.trackedStart;
    }
    stopTrackingWrites() {
        if (!this.trackedWrites) throw new Error('Internal error: Can\'t get tracked writes since nothing was tracked.');
        const slice = this.trackedWrites.subarray(0, this.trackedEnd - this.trackedStart);
        const result = {
            data: slice,
            start: this.trackedStart,
            end: this.trackedEnd
        };
        this.trackedWrites = null;
        return result;
    }
}
const $9fedaf112e3db83b$var$ARRAY_BUFFER_INITIAL_SIZE = 2 ** 16;
const $9fedaf112e3db83b$var$ARRAY_BUFFER_MAX_SIZE = 2 ** 32;
class $9fedaf112e3db83b$export$ad1857906a425059 extends $9fedaf112e3db83b$export$d7a960146e1a269e {
    constructor(target){
        super();
        this.pos = 0;
        this.maxPos = 0;
        this.target = target;
        this.supportsResize = 'resize' in new ArrayBuffer(0);
        if (this.supportsResize) try {
            // @ts-expect-error Don't want to bump "lib" in tsconfig
            this.buffer = new ArrayBuffer($9fedaf112e3db83b$var$ARRAY_BUFFER_INITIAL_SIZE, {
                maxByteLength: $9fedaf112e3db83b$var$ARRAY_BUFFER_MAX_SIZE
            });
        } catch  {
            this.buffer = new ArrayBuffer($9fedaf112e3db83b$var$ARRAY_BUFFER_INITIAL_SIZE);
            this.supportsResize = false;
        }
        else this.buffer = new ArrayBuffer($9fedaf112e3db83b$var$ARRAY_BUFFER_INITIAL_SIZE);
        this.bytes = new Uint8Array(this.buffer);
    }
    ensureSize(size) {
        let newLength = this.buffer.byteLength;
        while(newLength < size)newLength *= 2;
        if (newLength === this.buffer.byteLength) return;
        if (newLength > $9fedaf112e3db83b$var$ARRAY_BUFFER_MAX_SIZE) throw new Error(`ArrayBuffer exceeded maximum size of ${$9fedaf112e3db83b$var$ARRAY_BUFFER_MAX_SIZE} bytes. Please consider using another` + ` target.`);
        if (this.supportsResize) // Use resize if it exists
        // @ts-expect-error Don't want to bump "lib" in tsconfig
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        this.buffer.resize(newLength);
        else {
            const newBuffer = new ArrayBuffer(newLength);
            const newBytes = new Uint8Array(newBuffer);
            newBytes.set(this.bytes, 0);
            this.buffer = newBuffer;
            this.bytes = newBytes;
        }
    }
    write(data) {
        this.maybeTrackWrites(data);
        this.ensureSize(this.pos + data.byteLength);
        this.bytes.set(data, this.pos);
        this.pos += data.byteLength;
        this.maxPos = Math.max(this.maxPos, this.pos);
    }
    seek(newPos) {
        this.pos = newPos;
    }
    getPos() {
        return this.pos;
    }
    async flush() {}
    async finalize() {
        this.ensureSize(this.pos);
        this.target.buffer = this.buffer.slice(0, Math.max(this.maxPos, this.pos));
    }
    async close() {}
    getSlice(start, end) {
        return this.bytes.slice(start, end);
    }
}
const $9fedaf112e3db83b$var$DEFAULT_CHUNK_SIZE = 2 ** 24;
const $9fedaf112e3db83b$var$MAX_CHUNKS_AT_ONCE = 2;
class $9fedaf112e3db83b$export$6eaae741f38c80e7 extends $9fedaf112e3db83b$export$d7a960146e1a269e {
    constructor(target){
        super();
        this.pos = 0;
        this.sections = [];
        this.lastWriteEnd = 0;
        this.lastFlushEnd = 0;
        this.writer = null;
        /**
         * The data is divided up into fixed-size chunks, whose contents are first filled in RAM and then flushed out.
         * A chunk is flushed if all of its contents have been written.
         */ this.chunks = [];
        this.target = target;
        this.chunked = target._options.chunked ?? false;
        this.chunkSize = target._options.chunkSize ?? $9fedaf112e3db83b$var$DEFAULT_CHUNK_SIZE;
    }
    start() {
        this.writer = this.target._writable.getWriter();
    }
    write(data) {
        if (this.pos > this.lastWriteEnd) {
            const paddingBytesNeeded = this.pos - this.lastWriteEnd;
            this.pos = this.lastWriteEnd;
            this.write(new Uint8Array(paddingBytesNeeded));
        }
        this.maybeTrackWrites(data);
        this.sections.push({
            data: data.slice(),
            start: this.pos
        });
        this.pos += data.byteLength;
        this.lastWriteEnd = Math.max(this.lastWriteEnd, this.pos);
    }
    seek(newPos) {
        this.pos = newPos;
    }
    getPos() {
        return this.pos;
    }
    async flush() {
        if (this.pos > this.lastWriteEnd) {
            // There's a "void" between the last written byte and the next byte we're about to write. Let's pad that
            // void with zeroes explicitly.
            const paddingBytesNeeded = this.pos - this.lastWriteEnd;
            this.pos = this.lastWriteEnd;
            this.write(new Uint8Array(paddingBytesNeeded));
        }
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.writer);
        if (this.sections.length === 0) return;
        const chunks = [];
        const sorted = [
            ...this.sections
        ].sort((a, b)=>a.start - b.start);
        chunks.push({
            start: sorted[0].start,
            size: sorted[0].data.byteLength
        });
        // Figure out how many contiguous chunks we have
        for(let i = 1; i < sorted.length; i++){
            const lastChunk = chunks[chunks.length - 1];
            const section = sorted[i];
            if (section.start <= lastChunk.start + lastChunk.size) lastChunk.size = Math.max(lastChunk.size, section.start + section.data.byteLength - lastChunk.start);
            else chunks.push({
                start: section.start,
                size: section.data.byteLength
            });
        }
        for (const chunk of chunks){
            chunk.data = new Uint8Array(chunk.size);
            // Make sure to write the data in the correct order for correct overwriting
            for (const section of this.sections)// Check if the section is in the chunk
            if (chunk.start <= section.start && section.start < chunk.start + chunk.size) chunk.data.set(section.data, section.start - chunk.start);
            if (this.writer.desiredSize !== null && this.writer.desiredSize <= 0) await this.writer.ready; // Allow the writer to apply backpressure
            if (this.chunked) {
                // Let's first gather the data into bigger chunks before writing it
                this.writeDataIntoChunks(chunk.data, chunk.start);
                this.tryToFlushChunks();
            } else {
                if (this.ensureMonotonicity && chunk.start !== this.lastFlushEnd) throw new Error('Internal error: Monotonicity violation.');
                // Write out the data immediately
                this.writer.write({
                    type: 'write',
                    data: chunk.data,
                    position: chunk.start
                });
                this.lastFlushEnd = chunk.start + chunk.data.byteLength;
            }
        }
        this.sections.length = 0;
    }
    writeDataIntoChunks(data, position) {
        // First, find the chunk to write the data into, or create one if none exists
        let chunkIndex = this.chunks.findIndex((x)=>x.start <= position && position < x.start + this.chunkSize);
        if (chunkIndex === -1) chunkIndex = this.createChunk(position);
        const chunk = this.chunks[chunkIndex];
        // Figure out how much to write to the chunk, and then write to the chunk
        const relativePosition = position - chunk.start;
        const toWrite = data.subarray(0, Math.min(this.chunkSize - relativePosition, data.byteLength));
        chunk.data.set(toWrite, relativePosition);
        // Create a section describing the region of data that was just written to
        const section = {
            start: relativePosition,
            end: relativePosition + toWrite.byteLength
        };
        this.insertSectionIntoChunk(chunk, section);
        // Queue chunk for flushing to target if it has been fully written to
        if (chunk.written[0].start === 0 && chunk.written[0].end === this.chunkSize) chunk.shouldFlush = true;
        // Make sure we don't hold too many chunks in memory at once to keep memory usage down
        if (this.chunks.length > $9fedaf112e3db83b$var$MAX_CHUNKS_AT_ONCE) {
            // Flush all but the last chunk
            for(let i = 0; i < this.chunks.length - 1; i++)this.chunks[i].shouldFlush = true;
            this.tryToFlushChunks();
        }
        // If the data didn't fit in one chunk, recurse with the remaining data
        if (toWrite.byteLength < data.byteLength) this.writeDataIntoChunks(data.subarray(toWrite.byteLength), position + toWrite.byteLength);
    }
    insertSectionIntoChunk(chunk, section) {
        let low = 0;
        let high = chunk.written.length - 1;
        let index = -1;
        // Do a binary search to find the last section with a start not larger than `section`'s start
        while(low <= high){
            const mid = Math.floor(low + (high - low + 1) / 2);
            if (chunk.written[mid].start <= section.start) {
                low = mid + 1;
                index = mid;
            } else high = mid - 1;
        }
        // Insert the new section
        chunk.written.splice(index + 1, 0, section);
        if (index === -1 || chunk.written[index].end < section.start) index++;
        // Merge overlapping sections
        while(index < chunk.written.length - 1 && chunk.written[index].end >= chunk.written[index + 1].start){
            chunk.written[index].end = Math.max(chunk.written[index].end, chunk.written[index + 1].end);
            chunk.written.splice(index + 1, 1);
        }
    }
    createChunk(includesPosition) {
        const start = Math.floor(includesPosition / this.chunkSize) * this.chunkSize;
        const chunk = {
            start: start,
            data: new Uint8Array(this.chunkSize),
            written: [],
            shouldFlush: false
        };
        this.chunks.push(chunk);
        this.chunks.sort((a, b)=>a.start - b.start);
        return this.chunks.indexOf(chunk);
    }
    tryToFlushChunks(force = false) {
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.writer);
        for(let i = 0; i < this.chunks.length; i++){
            const chunk = this.chunks[i];
            if (!chunk.shouldFlush && !force) continue;
            for (const section of chunk.written){
                const position = chunk.start + section.start;
                if (this.ensureMonotonicity && position !== this.lastFlushEnd) throw new Error('Internal error: Monotonicity violation.');
                this.writer.write({
                    type: 'write',
                    data: chunk.data.subarray(section.start, section.end),
                    position: position
                });
                this.lastFlushEnd = chunk.start + section.end;
            }
            this.chunks.splice(i--, 1);
        }
    }
    finalize() {
        if (this.chunked) this.tryToFlushChunks(true);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.writer);
        return this.writer.close();
    }
    async close() {
        return this.writer?.close();
    }
}


class $0170695b8ac54025$export$a51f2b8e6ae258ea {
    constructor(){
        /** @internal */ this._output = null;
    }
}
class $0170695b8ac54025$export$aac535e25712764c extends $0170695b8ac54025$export$a51f2b8e6ae258ea {
    constructor(){
        super(...arguments);
        /** Stores the final output buffer. Until the output is finalized, this will be null. */ this.buffer = null;
    }
    /** @internal */ _createWriter() {
        return new (0, $9fedaf112e3db83b$export$ad1857906a425059)(this);
    }
}
class $0170695b8ac54025$export$a32e80808f38cf74 extends $0170695b8ac54025$export$a51f2b8e6ae258ea {
    constructor(writable, options = {}){
        super();
        if (!(writable instanceof WritableStream)) throw new TypeError('StreamTarget requires a WritableStream instance.');
        if (options != null && typeof options !== 'object') throw new TypeError('StreamTarget options, when provided, must be an object.');
        if (options.chunked !== undefined && typeof options.chunked !== 'boolean') throw new TypeError('options.chunked, when provided, must be a boolean.');
        if (options.chunkSize !== undefined && (!Number.isInteger(options.chunkSize) || options.chunkSize < 1024)) throw new TypeError('options.chunkSize, when provided, must be an integer and not smaller than 1024.');
        this._writable = writable;
        this._options = options;
    }
    /** @internal */ _createWriter() {
        return new (0, $9fedaf112e3db83b$export$6eaae741f38c80e7)(this);
    }
}

/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ /*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ /*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ /**
 * Base class for custom video decoders. To add your own custom video decoder, extend this class, implement the
 * abstract methods and static `supports` method, and register the decoder using `registerDecoder`.
 * @public
 */ class $b095dc9cfc0226bb$export$f01e062679669bd7 {
    /** Returns true iff the decoder can decode the given codec configuration. */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static supports(codec, config) {
        return false;
    }
}
class $b095dc9cfc0226bb$export$cdd5d6a76291a215 {
    /** Returns true iff the decoder can decode the given codec configuration. */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static supports(codec, config) {
        return false;
    }
}
class $b095dc9cfc0226bb$export$c3990c1299db8934 {
    /** Returns true iff the encoder can encode the given codec configuration. */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static supports(codec, config) {
        return false;
    }
}
class $b095dc9cfc0226bb$export$d4f7609adaad3935 {
    /** Returns true iff the encoder can encode the given codec configuration. */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static supports(codec, config) {
        return false;
    }
}
const $b095dc9cfc0226bb$export$15e88a215e7c6236 = [];
const $b095dc9cfc0226bb$export$568c477eb30f6f5c = [];
const $b095dc9cfc0226bb$export$97d0e85192cc043c = [];
const $b095dc9cfc0226bb$export$4f4acc973bdec892 = [];
const $b095dc9cfc0226bb$export$39246e2d5e1c3909 = (decoder)=>{
    if (decoder.prototype instanceof $b095dc9cfc0226bb$export$f01e062679669bd7) $b095dc9cfc0226bb$export$15e88a215e7c6236.push(decoder);
    else if (decoder.prototype instanceof $b095dc9cfc0226bb$export$cdd5d6a76291a215) $b095dc9cfc0226bb$export$568c477eb30f6f5c.push(decoder);
    else throw new TypeError('Decoder must be a CustomVideoDecoder or CustomAudioDecoder.');
};
const $b095dc9cfc0226bb$export$5017f45b503d0936 = (encoder)=>{
    if (encoder.prototype instanceof $b095dc9cfc0226bb$export$c3990c1299db8934) $b095dc9cfc0226bb$export$97d0e85192cc043c.push(encoder);
    else if (encoder.prototype instanceof $b095dc9cfc0226bb$export$d4f7609adaad3935) $b095dc9cfc0226bb$export$4f4acc973bdec892.push(encoder);
    else throw new TypeError('Encoder must be a CustomVideoEncoder or CustomAudioEncoder.');
};



const $94511f4b46249ea3$export$e32a4ecbb4372159 = [
    'avc',
    'hevc',
    'vp9',
    'av1',
    'vp8'
];
const $94511f4b46249ea3$export$58c594b1fe7e587b = [
    'pcm-s16',
    'pcm-s16be',
    'pcm-s24',
    'pcm-s24be',
    'pcm-s32',
    'pcm-s32be',
    'pcm-f32',
    'pcm-f32be',
    'pcm-f64',
    'pcm-f64be',
    'pcm-u8',
    'pcm-s8',
    'ulaw',
    'alaw'
];
const $94511f4b46249ea3$export$539a2909ad652ac = [
    'aac',
    'opus',
    'mp3',
    'vorbis',
    'flac'
];
const $94511f4b46249ea3$export$b1442c71888819f2 = [
    ...$94511f4b46249ea3$export$539a2909ad652ac,
    ...$94511f4b46249ea3$export$58c594b1fe7e587b
];
const $94511f4b46249ea3$export$422db9d40fc02e83 = [
    'webvtt'
]; // TODO add the rest
// https://en.wikipedia.org/wiki/Advanced_Video_Coding
const $94511f4b46249ea3$var$AVC_LEVEL_TABLE = [
    {
        maxMacroblocks: 99,
        maxBitrate: 64000,
        level: 0x0A
    },
    {
        maxMacroblocks: 396,
        maxBitrate: 192000,
        level: 0x0B
    },
    {
        maxMacroblocks: 396,
        maxBitrate: 384000,
        level: 0x0C
    },
    {
        maxMacroblocks: 396,
        maxBitrate: 768000,
        level: 0x0D
    },
    {
        maxMacroblocks: 396,
        maxBitrate: 2000000,
        level: 0x14
    },
    {
        maxMacroblocks: 792,
        maxBitrate: 4000000,
        level: 0x15
    },
    {
        maxMacroblocks: 1620,
        maxBitrate: 4000000,
        level: 0x16
    },
    {
        maxMacroblocks: 1620,
        maxBitrate: 10000000,
        level: 0x1E
    },
    {
        maxMacroblocks: 3600,
        maxBitrate: 14000000,
        level: 0x1F
    },
    {
        maxMacroblocks: 5120,
        maxBitrate: 20000000,
        level: 0x20
    },
    {
        maxMacroblocks: 8192,
        maxBitrate: 20000000,
        level: 0x28
    },
    {
        maxMacroblocks: 8192,
        maxBitrate: 50000000,
        level: 0x29
    },
    {
        maxMacroblocks: 8704,
        maxBitrate: 50000000,
        level: 0x2A
    },
    {
        maxMacroblocks: 22080,
        maxBitrate: 135000000,
        level: 0x32
    },
    {
        maxMacroblocks: 36864,
        maxBitrate: 240000000,
        level: 0x33
    },
    {
        maxMacroblocks: 36864,
        maxBitrate: 240000000,
        level: 0x34
    },
    {
        maxMacroblocks: 139264,
        maxBitrate: 240000000,
        level: 0x3C
    },
    {
        maxMacroblocks: 139264,
        maxBitrate: 480000000,
        level: 0x3D
    },
    {
        maxMacroblocks: 139264,
        maxBitrate: 800000000,
        level: 0x3E
    }
];
// https://en.wikipedia.org/wiki/High_Efficiency_Video_Coding
const $94511f4b46249ea3$var$HEVC_LEVEL_TABLE = [
    {
        maxPictureSize: 36864,
        maxBitrate: 128000,
        tier: 'L',
        level: 30
    },
    {
        maxPictureSize: 122880,
        maxBitrate: 1500000,
        tier: 'L',
        level: 60
    },
    {
        maxPictureSize: 245760,
        maxBitrate: 3000000,
        tier: 'L',
        level: 63
    },
    {
        maxPictureSize: 552960,
        maxBitrate: 6000000,
        tier: 'L',
        level: 90
    },
    {
        maxPictureSize: 983040,
        maxBitrate: 10000000,
        tier: 'L',
        level: 93
    },
    {
        maxPictureSize: 2228224,
        maxBitrate: 12000000,
        tier: 'L',
        level: 120
    },
    {
        maxPictureSize: 2228224,
        maxBitrate: 30000000,
        tier: 'H',
        level: 120
    },
    {
        maxPictureSize: 2228224,
        maxBitrate: 20000000,
        tier: 'L',
        level: 123
    },
    {
        maxPictureSize: 2228224,
        maxBitrate: 50000000,
        tier: 'H',
        level: 123
    },
    {
        maxPictureSize: 8912896,
        maxBitrate: 25000000,
        tier: 'L',
        level: 150
    },
    {
        maxPictureSize: 8912896,
        maxBitrate: 100000000,
        tier: 'H',
        level: 150
    },
    {
        maxPictureSize: 8912896,
        maxBitrate: 40000000,
        tier: 'L',
        level: 153
    },
    {
        maxPictureSize: 8912896,
        maxBitrate: 160000000,
        tier: 'H',
        level: 153
    },
    {
        maxPictureSize: 8912896,
        maxBitrate: 60000000,
        tier: 'L',
        level: 156
    },
    {
        maxPictureSize: 8912896,
        maxBitrate: 240000000,
        tier: 'H',
        level: 156
    },
    {
        maxPictureSize: 35651584,
        maxBitrate: 60000000,
        tier: 'L',
        level: 180
    },
    {
        maxPictureSize: 35651584,
        maxBitrate: 240000000,
        tier: 'H',
        level: 180
    },
    {
        maxPictureSize: 35651584,
        maxBitrate: 120000000,
        tier: 'L',
        level: 183
    },
    {
        maxPictureSize: 35651584,
        maxBitrate: 480000000,
        tier: 'H',
        level: 183
    },
    {
        maxPictureSize: 35651584,
        maxBitrate: 240000000,
        tier: 'L',
        level: 186
    },
    {
        maxPictureSize: 35651584,
        maxBitrate: 800000000,
        tier: 'H',
        level: 186
    }
];
const $94511f4b46249ea3$export$93c2d7097dbbef6 = [
    {
        maxPictureSize: 36864,
        maxBitrate: 200000,
        level: 10
    },
    {
        maxPictureSize: 73728,
        maxBitrate: 800000,
        level: 11
    },
    {
        maxPictureSize: 122880,
        maxBitrate: 1800000,
        level: 20
    },
    {
        maxPictureSize: 245760,
        maxBitrate: 3600000,
        level: 21
    },
    {
        maxPictureSize: 552960,
        maxBitrate: 7200000,
        level: 30
    },
    {
        maxPictureSize: 983040,
        maxBitrate: 12000000,
        level: 31
    },
    {
        maxPictureSize: 2228224,
        maxBitrate: 18000000,
        level: 40
    },
    {
        maxPictureSize: 2228224,
        maxBitrate: 30000000,
        level: 41
    },
    {
        maxPictureSize: 8912896,
        maxBitrate: 60000000,
        level: 50
    },
    {
        maxPictureSize: 8912896,
        maxBitrate: 120000000,
        level: 51
    },
    {
        maxPictureSize: 8912896,
        maxBitrate: 180000000,
        level: 52
    },
    {
        maxPictureSize: 35651584,
        maxBitrate: 180000000,
        level: 60
    },
    {
        maxPictureSize: 35651584,
        maxBitrate: 240000000,
        level: 61
    },
    {
        maxPictureSize: 35651584,
        maxBitrate: 480000000,
        level: 62
    }
];
// https://en.wikipedia.org/wiki/AV1
const $94511f4b46249ea3$var$AV1_LEVEL_TABLE = [
    {
        maxPictureSize: 147456,
        maxBitrate: 1500000,
        tier: 'M',
        level: 0
    },
    {
        maxPictureSize: 278784,
        maxBitrate: 3000000,
        tier: 'M',
        level: 1
    },
    {
        maxPictureSize: 665856,
        maxBitrate: 6000000,
        tier: 'M',
        level: 4
    },
    {
        maxPictureSize: 1065024,
        maxBitrate: 10000000,
        tier: 'M',
        level: 5
    },
    {
        maxPictureSize: 2359296,
        maxBitrate: 12000000,
        tier: 'M',
        level: 8
    },
    {
        maxPictureSize: 2359296,
        maxBitrate: 30000000,
        tier: 'H',
        level: 8
    },
    {
        maxPictureSize: 2359296,
        maxBitrate: 20000000,
        tier: 'M',
        level: 9
    },
    {
        maxPictureSize: 2359296,
        maxBitrate: 50000000,
        tier: 'H',
        level: 9
    },
    {
        maxPictureSize: 8912896,
        maxBitrate: 30000000,
        tier: 'M',
        level: 12
    },
    {
        maxPictureSize: 8912896,
        maxBitrate: 100000000,
        tier: 'H',
        level: 12
    },
    {
        maxPictureSize: 8912896,
        maxBitrate: 40000000,
        tier: 'M',
        level: 13
    },
    {
        maxPictureSize: 8912896,
        maxBitrate: 160000000,
        tier: 'H',
        level: 13
    },
    {
        maxPictureSize: 8912896,
        maxBitrate: 60000000,
        tier: 'M',
        level: 14
    },
    {
        maxPictureSize: 8912896,
        maxBitrate: 240000000,
        tier: 'H',
        level: 14
    },
    {
        maxPictureSize: 35651584,
        maxBitrate: 60000000,
        tier: 'M',
        level: 15
    },
    {
        maxPictureSize: 35651584,
        maxBitrate: 240000000,
        tier: 'H',
        level: 15
    },
    {
        maxPictureSize: 35651584,
        maxBitrate: 60000000,
        tier: 'M',
        level: 16
    },
    {
        maxPictureSize: 35651584,
        maxBitrate: 240000000,
        tier: 'H',
        level: 16
    },
    {
        maxPictureSize: 35651584,
        maxBitrate: 100000000,
        tier: 'M',
        level: 17
    },
    {
        maxPictureSize: 35651584,
        maxBitrate: 480000000,
        tier: 'H',
        level: 17
    },
    {
        maxPictureSize: 35651584,
        maxBitrate: 160000000,
        tier: 'M',
        level: 18
    },
    {
        maxPictureSize: 35651584,
        maxBitrate: 800000000,
        tier: 'H',
        level: 18
    },
    {
        maxPictureSize: 35651584,
        maxBitrate: 160000000,
        tier: 'M',
        level: 19
    },
    {
        maxPictureSize: 35651584,
        maxBitrate: 800000000,
        tier: 'H',
        level: 19
    }
];
const $94511f4b46249ea3$var$VP9_DEFAULT_SUFFIX = '.01.01.01.01.00';
const $94511f4b46249ea3$var$AV1_DEFAULT_SUFFIX = '.0.110.01.01.01.0';
const $94511f4b46249ea3$export$3bbd76a48c549c15 = (codec, width, height, bitrate)=>{
    if (codec === 'avc') {
        const profileIndication = 0x64; // High Profile
        const totalMacroblocks = Math.ceil(width / 16) * Math.ceil(height / 16);
        // Determine the level based on the table
        const levelInfo = $94511f4b46249ea3$var$AVC_LEVEL_TABLE.find((level)=>totalMacroblocks <= level.maxMacroblocks && bitrate <= level.maxBitrate) ?? (0, $053d5bbcf6664967$export$4c7897fafd92b108)($94511f4b46249ea3$var$AVC_LEVEL_TABLE);
        const levelIndication = levelInfo ? levelInfo.level : 0;
        const hexProfileIndication = profileIndication.toString(16).padStart(2, '0');
        const hexProfileCompatibility = '00';
        const hexLevelIndication = levelIndication.toString(16).padStart(2, '0');
        return `avc1.${hexProfileIndication}${hexProfileCompatibility}${hexLevelIndication}`;
    } else if (codec === 'hevc') {
        const profilePrefix = ''; // Profile space 0
        const profileIdc = 1; // Main Profile
        const compatibilityFlags = '6'; // Taken from the example in ISO 14496-15
        const pictureSize = width * height;
        const levelInfo = $94511f4b46249ea3$var$HEVC_LEVEL_TABLE.find((level)=>pictureSize <= level.maxPictureSize && bitrate <= level.maxBitrate) ?? (0, $053d5bbcf6664967$export$4c7897fafd92b108)($94511f4b46249ea3$var$HEVC_LEVEL_TABLE);
        const constraintFlags = 'B0'; // Progressive source flag
        return 'hev1.' + `${profilePrefix}${profileIdc}.` + `${compatibilityFlags}.` + `${levelInfo.tier}${levelInfo.level}.` + `${constraintFlags}`;
    } else if (codec === 'vp8') return 'vp8'; // Easy, this one
    else if (codec === 'vp9') {
        const profile = '00'; // Profile 0
        const pictureSize = width * height;
        const levelInfo = $94511f4b46249ea3$export$93c2d7097dbbef6.find((level)=>pictureSize <= level.maxPictureSize && bitrate <= level.maxBitrate) ?? (0, $053d5bbcf6664967$export$4c7897fafd92b108)($94511f4b46249ea3$export$93c2d7097dbbef6);
        const bitDepth = '08'; // 8-bit
        return `vp09.${profile}.${levelInfo.level.toString().padStart(2, '0')}.${bitDepth}`;
    } else if (codec === 'av1') {
        const profile = 0; // Main Profile, single digit
        const pictureSize = width * height;
        const levelInfo = $94511f4b46249ea3$var$AV1_LEVEL_TABLE.find((level)=>pictureSize <= level.maxPictureSize && bitrate <= level.maxBitrate) ?? (0, $053d5bbcf6664967$export$4c7897fafd92b108)($94511f4b46249ea3$var$AV1_LEVEL_TABLE);
        const level = levelInfo.level.toString().padStart(2, '0');
        const bitDepth = '08'; // 8-bit
        return `av01.${profile}.${level}${levelInfo.tier}.${bitDepth}`;
    }
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    throw new TypeError(`Unhandled codec '${codec}'.`);
};
const $94511f4b46249ea3$export$7b58db19f3afb5f7 = (codecString)=>{
    // Reference: https://www.webmproject.org/docs/container/#vp9-codec-feature-metadata-codecprivate
    const parts = codecString.split('.'); // We can derive the required values from the codec string
    const profile = Number(parts[1]);
    const level = Number(parts[2]);
    const bitDepth = Number(parts[3]);
    const chromaSubsampling = parts[4] ? Number(parts[4]) : 1;
    return [
        1,
        1,
        profile,
        2,
        1,
        level,
        3,
        1,
        bitDepth,
        4,
        1,
        chromaSubsampling
    ];
};
const $94511f4b46249ea3$export$ac6296ba51eb7830 = (codecString)=>{
    // Reference: https://aomediacodec.github.io/av1-isobmff/
    const parts = codecString.split('.'); // We can derive the required values from the codec string
    const marker = 1;
    const version = 1;
    const firstByte = (marker << 7) + version;
    const profile = Number(parts[1]);
    const levelAndTier = parts[2];
    const level = Number(levelAndTier.slice(0, -1));
    const secondByte = (profile << 5) + level;
    const tier = levelAndTier.slice(-1) === 'H' ? 1 : 0;
    const bitDepth = Number(parts[3]);
    const highBitDepth = bitDepth === 8 ? 0 : 1;
    const twelveBit = 0;
    const monochrome = parts[4] ? Number(parts[4]) : 0;
    const chromaSubsamplingX = parts[5] ? Number(parts[5][0]) : 1;
    const chromaSubsamplingY = parts[5] ? Number(parts[5][1]) : 1;
    const chromaSamplePosition = parts[5] ? Number(parts[5][2]) : 0; // CSP_UNKNOWN
    const thirdByte = (tier << 7) + (highBitDepth << 6) + (twelveBit << 5) + (monochrome << 4) + (chromaSubsamplingX << 3) + (chromaSubsamplingY << 2) + chromaSamplePosition;
    const initialPresentationDelayPresent = 0; // Should be fine
    const fourthByte = initialPresentationDelayPresent;
    return [
        firstByte,
        secondByte,
        thirdByte,
        fourthByte
    ];
};
const $94511f4b46249ea3$export$9eef456684b3cd18 = (trackInfo)=>{
    const { codec: codec, codecDescription: codecDescription, colorSpace: colorSpace, avcCodecInfo: avcCodecInfo, hevcCodecInfo: hevcCodecInfo, vp9CodecInfo: vp9CodecInfo, av1CodecInfo: av1CodecInfo } = trackInfo;
    if (codec === 'avc') {
        if (avcCodecInfo) {
            const bytes = new Uint8Array([
                avcCodecInfo.avcProfileIndication,
                avcCodecInfo.profileCompatibility,
                avcCodecInfo.avcLevelIndication
            ]);
            return `avc1.${(0, $053d5bbcf6664967$export$53baaea4633b455e)(bytes)}`;
        }
        if (!codecDescription || codecDescription.byteLength < 4) throw new TypeError('AVC decoder description is not provided or is not at least 4 bytes long.');
        return `avc1.${(0, $053d5bbcf6664967$export$53baaea4633b455e)(codecDescription.subarray(1, 4))}`;
    } else if (codec === 'hevc') {
        let generalProfileSpace;
        let generalProfileIdc;
        let compatibilityFlags;
        let generalTierFlag;
        let generalLevelIdc;
        let constraintFlags;
        if (hevcCodecInfo) {
            generalProfileSpace = hevcCodecInfo.generalProfileSpace;
            generalProfileIdc = hevcCodecInfo.generalProfileIdc;
            compatibilityFlags = (0, $053d5bbcf6664967$export$755636eac4d8473)(hevcCodecInfo.generalProfileCompatibilityFlags);
            generalTierFlag = hevcCodecInfo.generalTierFlag;
            generalLevelIdc = hevcCodecInfo.generalLevelIdc;
            constraintFlags = [
                ...hevcCodecInfo.generalConstraintIndicatorFlags
            ];
        } else {
            if (!codecDescription || codecDescription.byteLength < 23) throw new TypeError('HEVC decoder description is not provided or is not at least 23 bytes long.');
            const view = (0, $053d5bbcf6664967$export$f6b0788df7b6d1ec)(codecDescription);
            const profileByte = view.getUint8(1);
            generalProfileSpace = profileByte >> 6 & 0x03;
            generalProfileIdc = profileByte & 0x1F;
            compatibilityFlags = (0, $053d5bbcf6664967$export$755636eac4d8473)(view.getUint32(2));
            generalTierFlag = profileByte >> 5 & 0x01;
            generalLevelIdc = view.getUint8(12);
            constraintFlags = [];
            for(let i = 0; i < 6; i++)constraintFlags.push(view.getUint8(6 + i));
        }
        let codecString = 'hev1.';
        codecString += [
            '',
            'A',
            'B',
            'C'
        ][generalProfileSpace] + generalProfileIdc;
        codecString += '.';
        codecString += compatibilityFlags.toString(16).toUpperCase();
        codecString += '.';
        codecString += generalTierFlag === 0 ? 'L' : 'H';
        codecString += generalLevelIdc;
        while(constraintFlags.length > 0 && constraintFlags[constraintFlags.length - 1] === 0)constraintFlags.pop();
        if (constraintFlags.length > 0) {
            codecString += '.';
            codecString += constraintFlags.map((x)=>x.toString(16).toUpperCase()).join('.');
        }
        return codecString;
    } else if (codec === 'vp8') return 'vp8'; // Easy, this one
    else if (codec === 'vp9') {
        if (!vp9CodecInfo) {
            // Calculate level based on dimensions
            const pictureSize = trackInfo.width * trackInfo.height;
            let level = (0, $053d5bbcf6664967$export$4c7897fafd92b108)($94511f4b46249ea3$export$93c2d7097dbbef6).level; // Default to highest level
            for (const entry of $94511f4b46249ea3$export$93c2d7097dbbef6)if (pictureSize <= entry.maxPictureSize) {
                level = entry.level;
                break;
            }
            // We don't really know better, so let's return a general-purpose, common codec string and hope for the best
            return `vp09.00.${level.toString().padStart(2, '0')}.08`;
        }
        const profile = vp9CodecInfo.profile.toString().padStart(2, '0');
        const level = vp9CodecInfo.level.toString().padStart(2, '0');
        const bitDepth = vp9CodecInfo.bitDepth.toString().padStart(2, '0');
        const chromaSubsampling = vp9CodecInfo.chromaSubsampling.toString().padStart(2, '0');
        const colourPrimaries = vp9CodecInfo.colourPrimaries.toString().padStart(2, '0');
        const transferCharacteristics = vp9CodecInfo.transferCharacteristics.toString().padStart(2, '0');
        const matrixCoefficients = vp9CodecInfo.matrixCoefficients.toString().padStart(2, '0');
        const videoFullRangeFlag = vp9CodecInfo.videoFullRangeFlag.toString().padStart(2, '0');
        let string = `vp09.${profile}.${level}.${bitDepth}.${chromaSubsampling}`;
        string += `.${colourPrimaries}.${transferCharacteristics}.${matrixCoefficients}.${videoFullRangeFlag}`;
        if (string.endsWith($94511f4b46249ea3$var$VP9_DEFAULT_SUFFIX)) string = string.slice(0, -$94511f4b46249ea3$var$VP9_DEFAULT_SUFFIX.length);
        return string;
    } else if (codec === 'av1') {
        if (!av1CodecInfo) {
            // Calculate level based on dimensions
            const pictureSize = trackInfo.width * trackInfo.height;
            let level = (0, $053d5bbcf6664967$export$4c7897fafd92b108)($94511f4b46249ea3$export$93c2d7097dbbef6).level; // Default to highest level
            for (const entry of $94511f4b46249ea3$export$93c2d7097dbbef6)if (pictureSize <= entry.maxPictureSize) {
                level = entry.level;
                break;
            }
            // We don't really know better, so let's return a general-purpose, common codec string and hope for the best
            return `av01.0.${level.toString().padStart(2, '0')}M.08`;
        }
        // https://aomediacodec.github.io/av1-isobmff/#codecsparam
        const profile = av1CodecInfo.profile; // Single digit
        const level = av1CodecInfo.level.toString().padStart(2, '0');
        const tier = av1CodecInfo.tier ? 'H' : 'M';
        const bitDepth = av1CodecInfo.bitDepth.toString().padStart(2, '0');
        const monochrome = av1CodecInfo.monochrome ? '1' : '0';
        const chromaSubsampling = 100 * av1CodecInfo.chromaSubsamplingX + 10 * av1CodecInfo.chromaSubsamplingY + 1 * (av1CodecInfo.chromaSubsamplingX && av1CodecInfo.chromaSubsamplingY ? av1CodecInfo.chromaSamplePosition : 0);
        // The defaults are 1 (ITU-R BT.709)
        const colorPrimaries = colorSpace?.primaries ? (0, $053d5bbcf6664967$export$c9d0dddad4eef393)[colorSpace.primaries] : 1;
        const transferCharacteristics = colorSpace?.transfer ? (0, $053d5bbcf6664967$export$36a5c840f44dac9a)[colorSpace.transfer] : 1;
        const matrixCoefficients = colorSpace?.matrix ? (0, $053d5bbcf6664967$export$62b3c37e3f8b5eb4)[colorSpace.matrix] : 1;
        const videoFullRangeFlag = colorSpace?.fullRange ? 1 : 0;
        let string = `av01.${profile}.${level}${tier}.${bitDepth}`;
        string += `.${monochrome}.${chromaSubsampling.toString().padStart(3, '0')}`;
        string += `.${colorPrimaries.toString().padStart(2, '0')}`;
        string += `.${transferCharacteristics.toString().padStart(2, '0')}`;
        string += `.${matrixCoefficients.toString().padStart(2, '0')}`;
        string += `.${videoFullRangeFlag}`;
        if (string.endsWith($94511f4b46249ea3$var$AV1_DEFAULT_SUFFIX)) string = string.slice(0, -$94511f4b46249ea3$var$AV1_DEFAULT_SUFFIX.length);
        return string;
    }
    throw new TypeError(`Unhandled codec '${codec}'.`);
};
const $94511f4b46249ea3$export$9ebafb9220dc0b3b = (codec, numberOfChannels, sampleRate)=>{
    if (codec === 'aac') {
        // If stereo or higher channels and lower sample rate, likely using HE-AAC v2 with PS
        if (numberOfChannels >= 2 && sampleRate <= 24000) return 'mp4a.40.29'; // HE-AAC v2 (AAC LC + SBR + PS)
        // If sample rate is low, likely using HE-AAC v1 with SBR
        if (sampleRate <= 24000) return 'mp4a.40.5'; // HE-AAC v1 (AAC LC + SBR)
        // Default to standard AAC-LC for higher sample rates
        return 'mp4a.40.2'; // AAC-LC
    } else if (codec === 'mp3') return 'mp3';
    else if (codec === 'opus') return 'opus';
    else if (codec === 'vorbis') return 'vorbis';
    else if (codec === 'flac') return 'flac';
    else if ($94511f4b46249ea3$export$58c594b1fe7e587b.includes(codec)) return codec;
    throw new TypeError(`Unhandled codec '${codec}'.`);
};
const $94511f4b46249ea3$export$780b0c89773e885b = (trackInfo)=>{
    const { codec: codec, codecDescription: codecDescription, aacCodecInfo: aacCodecInfo } = trackInfo;
    if (codec === 'aac') {
        if (!aacCodecInfo) throw new TypeError('AAC codec info must be provided.');
        if (aacCodecInfo.isMpeg2) return 'mp4a.67';
        else {
            const audioSpecificConfig = $94511f4b46249ea3$export$e0629c673135b0af(codecDescription);
            return `mp4a.40.${audioSpecificConfig.objectType}`;
        }
    } else if (codec === 'mp3') return 'mp3';
    else if (codec === 'opus') return 'opus';
    else if (codec === 'vorbis') return 'vorbis';
    else if (codec === 'flac') return 'flac';
    else if (codec && $94511f4b46249ea3$export$58c594b1fe7e587b.includes(codec)) return codec;
    throw new TypeError(`Unhandled codec '${codec}'.`);
};
const $94511f4b46249ea3$export$e0629c673135b0af = (bytes)=>{
    if (!bytes || bytes.byteLength < 2) throw new TypeError('AAC description must be at least 2 bytes long.');
    const bitstream = new (0, $053d5bbcf6664967$export$d16e6594b36c3ef7)(bytes);
    let objectType = bitstream.readBits(5);
    if (objectType === 31) objectType = 32 + bitstream.readBits(6);
    const frequencyIndex = bitstream.readBits(4);
    let sampleRate = null;
    if (frequencyIndex === 15) sampleRate = bitstream.readBits(24);
    else {
        const freqTable = [
            96000,
            88200,
            64000,
            48000,
            44100,
            32000,
            24000,
            22050,
            16000,
            12000,
            11025,
            8000,
            7350
        ];
        if (frequencyIndex < freqTable.length) sampleRate = freqTable[frequencyIndex];
    }
    const channelConfiguration = bitstream.readBits(4);
    let numberOfChannels = null;
    if (channelConfiguration >= 1 && channelConfiguration <= 7) {
        const channelMap = {
            1: 1,
            2: 2,
            3: 3,
            4: 4,
            5: 5,
            6: 6,
            7: 8
        };
        numberOfChannels = channelMap[channelConfiguration];
    }
    return {
        objectType: objectType,
        frequencyIndex: frequencyIndex,
        sampleRate: sampleRate,
        channelConfiguration: channelConfiguration,
        numberOfChannels: numberOfChannels
    };
};
const $94511f4b46249ea3$export$8cafa39936c6eeba = 48000;
const $94511f4b46249ea3$var$PCM_CODEC_REGEX = /^pcm-([usf])(\d+)+(be)?$/;
const $94511f4b46249ea3$export$560120a2d4e71dc2 = (codec)=>{
    (0, $053d5bbcf6664967$export$a7a9523472993e97)($94511f4b46249ea3$export$58c594b1fe7e587b.includes(codec));
    if (codec === 'ulaw') return {
        dataType: 'ulaw',
        sampleSize: 1,
        littleEndian: true,
        silentValue: 255
    };
    else if (codec === 'alaw') return {
        dataType: 'alaw',
        sampleSize: 1,
        littleEndian: true,
        silentValue: 213
    };
    const match = $94511f4b46249ea3$var$PCM_CODEC_REGEX.exec(codec);
    (0, $053d5bbcf6664967$export$a7a9523472993e97)(match);
    let dataType;
    if (match[1] === 'u') dataType = 'unsigned';
    else if (match[1] === 's') dataType = 'signed';
    else dataType = 'float';
    const sampleSize = Number(match[2]) / 8;
    const littleEndian = match[3] !== 'be';
    const silentValue = codec === 'pcm-u8' ? 128 : 0;
    return {
        dataType: dataType,
        sampleSize: sampleSize,
        littleEndian: littleEndian,
        silentValue: silentValue
    };
};
const $94511f4b46249ea3$export$6cfcf5d844ba8020 = (codecString)=>{
    // Video codecs
    if (codecString.startsWith('avc1') || codecString.startsWith('avc3')) return 'avc';
    else if (codecString.startsWith('hev1') || codecString.startsWith('hvc1')) return 'hevc';
    else if (codecString === 'vp8') return 'vp8';
    else if (codecString.startsWith('vp09')) return 'vp9';
    else if (codecString.startsWith('av01')) return 'av1';
    // Audio codecs
    if (codecString.startsWith('mp4a.40') || codecString === 'mp4a.67') return 'aac';
    else if (codecString === 'mp3' || codecString === 'mp4a.69' || codecString === 'mp4a.6B' || codecString === 'mp4a.6b') return 'mp3';
    else if (codecString === 'opus') return 'opus';
    else if (codecString === 'vorbis') return 'vorbis';
    else if (codecString === 'flac') return 'flac';
    else if (codecString === 'ulaw') return 'ulaw';
    else if (codecString === 'alaw') return 'alaw';
    else if ($94511f4b46249ea3$var$PCM_CODEC_REGEX.test(codecString)) return codecString;
    // Subtitle codecs
    if (codecString === 'webvtt') return 'webvtt';
    return null;
};
const $94511f4b46249ea3$export$62bce25ec4abf86d = (codec)=>{
    if (codec === 'avc') return {
        avc: {
            format: 'avc'
        }
    };
    else if (codec === 'hevc') return {
        hevc: {
            format: 'hevc'
        }
    };
    return {};
};
const $94511f4b46249ea3$export$32be238875044d9a = (codec)=>{
    if (codec === 'aac') return {
        aac: {
            format: 'aac'
        }
    };
    else if (codec === 'opus') return {
        opus: {
            format: 'opus'
        }
    };
    return {};
};
class $94511f4b46249ea3$export$b0cc09cfadf17c04 {
    /** @internal */ constructor(factor){
        this._factor = factor;
    }
    /** @internal */ _toVideoBitrate(codec, width, height) {
        const pixels = width * height;
        const codecEfficiencyFactors = {
            avc: 1.0,
            hevc: 0.6,
            vp9: 0.6,
            av1: 0.4,
            vp8: 1.2
        };
        const referencePixels = 2073600;
        const referenceBitrate = 3000000;
        const scaleFactor = Math.pow(pixels / referencePixels, 0.95); // Slight non-linear scaling
        const baseBitrate = referenceBitrate * scaleFactor;
        const codecAdjustedBitrate = baseBitrate * codecEfficiencyFactors[codec];
        const finalBitrate = codecAdjustedBitrate * this._factor;
        return Math.ceil(finalBitrate / 1000) * 1000;
    }
    /** @internal */ _toAudioBitrate(codec) {
        if ($94511f4b46249ea3$export$58c594b1fe7e587b.includes(codec) || codec === 'flac') return undefined;
        const baseRates = {
            aac: 128000,
            opus: 64000,
            mp3: 160000,
            vorbis: 64000
        };
        const baseBitrate = baseRates[codec];
        if (!baseBitrate) throw new Error(`Unhandled codec: ${codec}`);
        let finalBitrate = baseBitrate * this._factor;
        if (codec === 'aac') {
            // AAC only works with specific bitrates, let's find the closest
            const validRates = [
                96000,
                128000,
                160000,
                192000
            ];
            finalBitrate = validRates.reduce((prev, curr)=>Math.abs(curr - finalBitrate) < Math.abs(prev - finalBitrate) ? curr : prev);
        } else if (codec === 'opus' || codec === 'vorbis') finalBitrate = Math.max(6000, finalBitrate);
        else if (codec === 'mp3') {
            const validRates = [
                8000,
                16000,
                24000,
                32000,
                40000,
                48000,
                64000,
                80000,
                96000,
                112000,
                128000,
                160000,
                192000,
                224000,
                256000,
                320000
            ];
            finalBitrate = validRates.reduce((prev, curr)=>Math.abs(curr - finalBitrate) < Math.abs(prev - finalBitrate) ? curr : prev);
        }
        return Math.round(finalBitrate / 1000) * 1000;
    }
}
const $94511f4b46249ea3$export$39d955dccbc46f15 = new $94511f4b46249ea3$export$b0cc09cfadf17c04(0.3);
const $94511f4b46249ea3$export$18133ca4c32dec70 = new $94511f4b46249ea3$export$b0cc09cfadf17c04(0.6);
const $94511f4b46249ea3$export$4f6b966f8c5fbaa6 = new $94511f4b46249ea3$export$b0cc09cfadf17c04(1);
const $94511f4b46249ea3$export$3ef58e732de25d7e = new $94511f4b46249ea3$export$b0cc09cfadf17c04(2);
const $94511f4b46249ea3$export$c3a9470fb222727c = new $94511f4b46249ea3$export$b0cc09cfadf17c04(4);
const $94511f4b46249ea3$var$VALID_VIDEO_CODEC_STRING_PREFIXES = [
    'avc1',
    'avc3',
    'hev1',
    'hvc1',
    'vp8',
    'vp09',
    'av01'
];
const $94511f4b46249ea3$var$AVC_CODEC_STRING_REGEX = /^(avc1|avc3)\.[0-9a-fA-F]{6}$/;
const $94511f4b46249ea3$var$HEVC_CODEC_STRING_REGEX = /^(hev1|hvc1)\.(?:[ABC]?\d+)\.[0-9a-fA-F]{1,8}\.[LH]\d+(?:\.[0-9a-fA-F]{1,2}){0,6}$/;
const $94511f4b46249ea3$var$VP9_CODEC_STRING_REGEX = /^vp09(?:\.\d{2}){3}(?:(?:\.\d{2}){5})?$/;
const $94511f4b46249ea3$var$AV1_CODEC_STRING_REGEX = /^av01\.\d\.\d{2}[MH]\.\d{2}(?:\.\d\.\d{3}\.\d{2}\.\d{2}\.\d{2}\.\d)?$/;
const $94511f4b46249ea3$export$c2a1d372ae0516d4 = (metadata)=>{
    if (!metadata) throw new TypeError('Video chunk metadata must be provided.');
    if (typeof metadata !== 'object') throw new TypeError('Video chunk metadata must be an object.');
    if (!metadata.decoderConfig) throw new TypeError('Video chunk metadata must include a decoder configuration.');
    if (typeof metadata.decoderConfig !== 'object') throw new TypeError('Video chunk metadata decoder configuration must be an object.');
    if (typeof metadata.decoderConfig.codec !== 'string') throw new TypeError('Video chunk metadata decoder configuration must specify a codec string.');
    if (!$94511f4b46249ea3$var$VALID_VIDEO_CODEC_STRING_PREFIXES.some((prefix)=>metadata.decoderConfig.codec.startsWith(prefix))) throw new TypeError("Video chunk metadata decoder configuration codec string must be a valid video codec string as specified in the WebCodecs Codec Registry.");
    if (!Number.isInteger(metadata.decoderConfig.codedWidth) || metadata.decoderConfig.codedWidth <= 0) throw new TypeError('Video chunk metadata decoder configuration must specify a valid codedWidth (positive integer).');
    if (!Number.isInteger(metadata.decoderConfig.codedHeight) || metadata.decoderConfig.codedHeight <= 0) throw new TypeError('Video chunk metadata decoder configuration must specify a valid codedHeight (positive integer).');
    if (metadata.decoderConfig.description !== undefined) {
        if (!(0, $053d5bbcf6664967$export$ba2695b5f58bd3c4)(metadata.decoderConfig.description)) throw new TypeError("Video chunk metadata decoder configuration description, when defined, must be an ArrayBuffer or an ArrayBuffer view.");
    }
    if (metadata.decoderConfig.colorSpace !== undefined) {
        const { colorSpace: colorSpace } = metadata.decoderConfig;
        if (typeof colorSpace !== 'object') throw new TypeError('Video chunk metadata decoder configuration colorSpace, when provided, must be an object.');
        const primariesValues = Object.keys((0, $053d5bbcf6664967$export$c9d0dddad4eef393));
        if (colorSpace.primaries != null && !primariesValues.includes(colorSpace.primaries)) throw new TypeError(`Video chunk metadata decoder configuration colorSpace primaries, when defined, must be one of` + ` ${primariesValues.join(', ')}.`);
        const transferValues = Object.keys((0, $053d5bbcf6664967$export$36a5c840f44dac9a));
        if (colorSpace.transfer != null && !transferValues.includes(colorSpace.transfer)) throw new TypeError(`Video chunk metadata decoder configuration colorSpace transfer, when defined, must be one of` + ` ${transferValues.join(', ')}.`);
        const matrixValues = Object.keys((0, $053d5bbcf6664967$export$62b3c37e3f8b5eb4));
        if (colorSpace.matrix != null && !matrixValues.includes(colorSpace.matrix)) throw new TypeError(`Video chunk metadata decoder configuration colorSpace matrix, when defined, must be one of` + ` ${matrixValues.join(', ')}.`);
        if (colorSpace.fullRange != null && typeof colorSpace.fullRange !== 'boolean') throw new TypeError('Video chunk metadata decoder configuration colorSpace fullRange, when defined, must be a boolean.');
    }
    if (metadata.decoderConfig.codec.startsWith('avc1') || metadata.decoderConfig.codec.startsWith('avc3')) {
        // AVC-specific validation
        if (!$94511f4b46249ea3$var$AVC_CODEC_STRING_REGEX.test(metadata.decoderConfig.codec)) throw new TypeError("Video chunk metadata decoder configuration codec string for AVC must be a valid AVC codec string as specified in Section 3.4 of RFC 6381.");
    // `description` may or may not be set, depending on if the format is AVCC or Annex B, so don't perform any
    // validation for it.
    // https://www.w3.org/TR/webcodecs-avc-codec-registration
    } else if (metadata.decoderConfig.codec.startsWith('hev1') || metadata.decoderConfig.codec.startsWith('hvc1')) {
        // HEVC-specific validation
        if (!$94511f4b46249ea3$var$HEVC_CODEC_STRING_REGEX.test(metadata.decoderConfig.codec)) throw new TypeError("Video chunk metadata decoder configuration codec string for HEVC must be a valid HEVC codec string as specified in Section E.3 of ISO 14496-15.");
    // `description` may or may not be set, depending on if the format is HEVC or Annex B, so don't perform any
    // validation for it.
    // https://www.w3.org/TR/webcodecs-hevc-codec-registration
    } else if (metadata.decoderConfig.codec.startsWith('vp8')) {
        // VP8-specific validation
        if (metadata.decoderConfig.codec !== 'vp8') throw new TypeError('Video chunk metadata decoder configuration codec string for VP8 must be "vp8".');
    } else if (metadata.decoderConfig.codec.startsWith('vp09')) {
        // VP9-specific validation
        if (!$94511f4b46249ea3$var$VP9_CODEC_STRING_REGEX.test(metadata.decoderConfig.codec)) throw new TypeError('Video chunk metadata decoder configuration codec string for VP9 must be a valid VP9 codec string as specified in Section "Codecs Parameter String" of https://www.webmproject.org/vp9/mp4/.');
    } else if (metadata.decoderConfig.codec.startsWith('av01')) {
        // AV1-specific validation
        if (!$94511f4b46249ea3$var$AV1_CODEC_STRING_REGEX.test(metadata.decoderConfig.codec)) throw new TypeError('Video chunk metadata decoder configuration codec string for AV1 must be a valid AV1 codec string as specified in Section "Codecs Parameter String" of https://aomediacodec.github.io/av1-isobmff/.');
    }
};
const $94511f4b46249ea3$var$VALID_AUDIO_CODEC_STRING_PREFIXES = [
    'mp4a',
    'mp3',
    'opus',
    'vorbis',
    'flac',
    'ulaw',
    'alaw',
    'pcm'
];
const $94511f4b46249ea3$export$61959146e5b74178 = (metadata)=>{
    if (!metadata) throw new TypeError('Audio chunk metadata must be provided.');
    if (typeof metadata !== 'object') throw new TypeError('Audio chunk metadata must be an object.');
    if (!metadata.decoderConfig) throw new TypeError('Audio chunk metadata must include a decoder configuration.');
    if (typeof metadata.decoderConfig !== 'object') throw new TypeError('Audio chunk metadata decoder configuration must be an object.');
    if (typeof metadata.decoderConfig.codec !== 'string') throw new TypeError('Audio chunk metadata decoder configuration must specify a codec string.');
    if (!$94511f4b46249ea3$var$VALID_AUDIO_CODEC_STRING_PREFIXES.some((prefix)=>metadata.decoderConfig.codec.startsWith(prefix))) throw new TypeError("Audio chunk metadata decoder configuration codec string must be a valid audio codec string as specified in the WebCodecs Codec Registry.");
    if (!Number.isInteger(metadata.decoderConfig.sampleRate) || metadata.decoderConfig.sampleRate <= 0) throw new TypeError('Audio chunk metadata decoder configuration must specify a valid sampleRate (positive integer).');
    if (!Number.isInteger(metadata.decoderConfig.numberOfChannels) || metadata.decoderConfig.numberOfChannels <= 0) throw new TypeError('Audio chunk metadata decoder configuration must specify a valid numberOfChannels (positive integer).');
    if (metadata.decoderConfig.description !== undefined) {
        if (!(0, $053d5bbcf6664967$export$ba2695b5f58bd3c4)(metadata.decoderConfig.description)) throw new TypeError("Audio chunk metadata decoder configuration description, when defined, must be an ArrayBuffer or an ArrayBuffer view.");
    }
    if (metadata.decoderConfig.codec.startsWith('mp4a') && metadata.decoderConfig.codec !== 'mp4a.69' && metadata.decoderConfig.codec !== 'mp4a.6B' && metadata.decoderConfig.codec !== 'mp4a.6b') {
        // AAC-specific validation
        const validStrings = [
            'mp4a.40.2',
            'mp4a.40.02',
            'mp4a.40.5',
            'mp4a.40.05',
            'mp4a.40.29',
            'mp4a.67'
        ];
        if (!validStrings.includes(metadata.decoderConfig.codec)) throw new TypeError("Audio chunk metadata decoder configuration codec string for AAC must be a valid AAC codec string as specified in https://www.w3.org/TR/webcodecs-aac-codec-registration/.");
        if (!metadata.decoderConfig.description) throw new TypeError("Audio chunk metadata decoder configuration for AAC must include a description, which is expected to be an AudioSpecificConfig as specified in ISO 14496-3.");
    } else if (metadata.decoderConfig.codec.startsWith('mp3') || metadata.decoderConfig.codec.startsWith('mp4a')) {
        // MP3-specific validation
        if (metadata.decoderConfig.codec !== 'mp3' && metadata.decoderConfig.codec !== 'mp4a.69' && metadata.decoderConfig.codec !== 'mp4a.6B' && metadata.decoderConfig.codec !== 'mp4a.6b') throw new TypeError('Audio chunk metadata decoder configuration codec string for MP3 must be "mp3", "mp4a.69" or "mp4a.6B".');
    } else if (metadata.decoderConfig.codec.startsWith('opus')) {
        // Opus-specific validation
        if (metadata.decoderConfig.codec !== 'opus') throw new TypeError('Audio chunk metadata decoder configuration codec string for Opus must be "opus".');
        if (metadata.decoderConfig.description && metadata.decoderConfig.description.byteLength < 18) // Description is optional for Opus per-spec, so we shouldn't enforce it
        throw new TypeError("Audio chunk metadata decoder configuration description, when specified, is expected to be an Identification Header as specified in Section 5.1 of RFC 7845.");
    } else if (metadata.decoderConfig.codec.startsWith('vorbis')) {
        // Vorbis-specific validation
        if (metadata.decoderConfig.codec !== 'vorbis') throw new TypeError('Audio chunk metadata decoder configuration codec string for Vorbis must be "vorbis".');
        if (!metadata.decoderConfig.description) throw new TypeError("Audio chunk metadata decoder configuration for Vorbis must include a description, which is expected to adhere to the format described in https://www.w3.org/TR/webcodecs-vorbis-codec-registration/.");
    } else if (metadata.decoderConfig.codec.startsWith('flac')) {
        // FLAC-specific validation
        if (metadata.decoderConfig.codec !== 'flac') throw new TypeError('Audio chunk metadata decoder configuration codec string for FLAC must be "flac".');
        const minDescriptionSize = 42; // 'fLaC' + metadata block header + STREAMINFO block
        if (!metadata.decoderConfig.description || metadata.decoderConfig.description.byteLength < minDescriptionSize) throw new TypeError("Audio chunk metadata decoder configuration for FLAC must include a description, which is expected to adhere to the format described in https://www.w3.org/TR/webcodecs-flac-codec-registration/.");
    } else if (metadata.decoderConfig.codec.startsWith('pcm') || metadata.decoderConfig.codec.startsWith('ulaw') || metadata.decoderConfig.codec.startsWith('alaw')) {
        // PCM-specific validation
        if (!$94511f4b46249ea3$export$58c594b1fe7e587b.includes(metadata.decoderConfig.codec)) throw new TypeError('Audio chunk metadata decoder configuration codec string for PCM must be one of the supported PCM' + ` codecs (${$94511f4b46249ea3$export$58c594b1fe7e587b.join(', ')}).`);
    }
};
const $94511f4b46249ea3$export$8b9df0b71f2f06b5 = (metadata)=>{
    if (!metadata) throw new TypeError('Subtitle metadata must be provided.');
    if (typeof metadata !== 'object') throw new TypeError('Subtitle metadata must be an object.');
    if (!metadata.config) throw new TypeError('Subtitle metadata must include a config object.');
    if (typeof metadata.config !== 'object') throw new TypeError('Subtitle metadata config must be an object.');
    if (typeof metadata.config.description !== 'string') throw new TypeError('Subtitle metadata config description must be a string.');
};
const $94511f4b46249ea3$export$32d8af07dd2de268 = (codec)=>{
    if ($94511f4b46249ea3$export$e32a4ecbb4372159.includes(codec)) return $94511f4b46249ea3$export$e282dcda1413edd2(codec);
    else if ($94511f4b46249ea3$export$b1442c71888819f2.includes(codec)) return $94511f4b46249ea3$export$bfe90ae1056d88b3(codec);
    else if ($94511f4b46249ea3$export$422db9d40fc02e83.includes(codec)) return $94511f4b46249ea3$export$b9e95343c882f8ee(codec);
    throw new TypeError(`Unknown codec '${codec}'.`);
};
const $94511f4b46249ea3$export$e282dcda1413edd2 = async (codec, { width: width = 1280, height: height = 720, bitrate: bitrate = 1e6 } = {})=>{
    if (!$94511f4b46249ea3$export$e32a4ecbb4372159.includes(codec)) return false;
    if (!Number.isInteger(width) || width <= 0) throw new TypeError('width must be a positive integer.');
    if (!Number.isInteger(height) || height <= 0) throw new TypeError('height must be a positive integer.');
    if (!(bitrate instanceof $94511f4b46249ea3$export$b0cc09cfadf17c04) && (!Number.isInteger(bitrate) || bitrate <= 0)) throw new TypeError('bitrate must be a positive integer or a quality.');
    const resolvedBitrate = bitrate instanceof $94511f4b46249ea3$export$b0cc09cfadf17c04 ? bitrate._toVideoBitrate(codec, width, height) : bitrate;
    if ((0, $b095dc9cfc0226bb$export$97d0e85192cc043c).length > 0) {
        const encoderConfig = {
            codec: $94511f4b46249ea3$export$3bbd76a48c549c15(codec, width, height, resolvedBitrate),
            width: width,
            height: height,
            bitrate: resolvedBitrate,
            ...$94511f4b46249ea3$export$62bce25ec4abf86d(codec)
        };
        if ((0, $b095dc9cfc0226bb$export$97d0e85192cc043c).some((x)=>x.supports(codec, encoderConfig))) // There's a custom encoder
        return true;
    }
    if (typeof VideoEncoder === 'undefined') return false;
    const support = await VideoEncoder.isConfigSupported({
        codec: $94511f4b46249ea3$export$3bbd76a48c549c15(codec, width, height, resolvedBitrate),
        width: width,
        height: height,
        bitrate: resolvedBitrate,
        ...$94511f4b46249ea3$export$62bce25ec4abf86d(codec)
    });
    return support.supported === true;
};
const $94511f4b46249ea3$export$bfe90ae1056d88b3 = async (codec, { numberOfChannels: numberOfChannels = 2, sampleRate: sampleRate = 48000, bitrate: bitrate = 128e3 } = {})=>{
    if (!$94511f4b46249ea3$export$b1442c71888819f2.includes(codec)) return false;
    if (!Number.isInteger(numberOfChannels) || numberOfChannels <= 0) throw new TypeError('numberOfChannels must be a positive integer.');
    if (!Number.isInteger(sampleRate) || sampleRate <= 0) throw new TypeError('sampleRate must be a positive integer.');
    if (!(bitrate instanceof $94511f4b46249ea3$export$b0cc09cfadf17c04) && (!Number.isInteger(bitrate) || bitrate <= 0)) throw new TypeError('bitrate must be a positive integer.');
    const resolvedBitrate = bitrate instanceof $94511f4b46249ea3$export$b0cc09cfadf17c04 ? bitrate._toAudioBitrate(codec) : bitrate;
    if ((0, $b095dc9cfc0226bb$export$4f4acc973bdec892).length > 0) {
        const encoderConfig = {
            codec: $94511f4b46249ea3$export$9ebafb9220dc0b3b(codec, numberOfChannels, sampleRate),
            numberOfChannels: numberOfChannels,
            sampleRate: sampleRate,
            bitrate: resolvedBitrate,
            ...$94511f4b46249ea3$export$32be238875044d9a(codec)
        };
        if ((0, $b095dc9cfc0226bb$export$4f4acc973bdec892).some((x)=>x.supports(codec, encoderConfig))) // There's a custom encoder
        return true;
    }
    if ($94511f4b46249ea3$export$58c594b1fe7e587b.includes(codec)) return true; // Because we encode these ourselves
    if (typeof AudioEncoder === 'undefined') return false;
    const support = await AudioEncoder.isConfigSupported({
        codec: $94511f4b46249ea3$export$9ebafb9220dc0b3b(codec, numberOfChannels, sampleRate),
        numberOfChannels: numberOfChannels,
        sampleRate: sampleRate,
        bitrate: resolvedBitrate,
        ...$94511f4b46249ea3$export$32be238875044d9a(codec)
    });
    return support.supported === true;
};
const $94511f4b46249ea3$export$b9e95343c882f8ee = async (codec)=>{
    if (!$94511f4b46249ea3$export$422db9d40fc02e83.includes(codec)) return false;
    return true;
};
const $94511f4b46249ea3$export$5b28f10c8836eb91 = async ()=>{
    const [videoCodecs, audioCodecs, subtitleCodecs] = await Promise.all([
        $94511f4b46249ea3$export$6ace198444a6096f(),
        $94511f4b46249ea3$export$6528b37300a6778a(),
        $94511f4b46249ea3$export$b3955b412928ca66()
    ]);
    return [
        ...videoCodecs,
        ...audioCodecs,
        ...subtitleCodecs
    ];
};
const $94511f4b46249ea3$export$6ace198444a6096f = async (checkedCodecs = $94511f4b46249ea3$export$e32a4ecbb4372159, options)=>{
    const bools = await Promise.all(checkedCodecs.map((codec)=>$94511f4b46249ea3$export$e282dcda1413edd2(codec, options)));
    return checkedCodecs.filter((_, i)=>bools[i]);
};
const $94511f4b46249ea3$export$6528b37300a6778a = async (checkedCodecs = $94511f4b46249ea3$export$b1442c71888819f2, options)=>{
    const bools = await Promise.all(checkedCodecs.map((codec)=>$94511f4b46249ea3$export$bfe90ae1056d88b3(codec, options)));
    return checkedCodecs.filter((_, i)=>bools[i]);
};
const $94511f4b46249ea3$export$b3955b412928ca66 = async (checkedCodecs = $94511f4b46249ea3$export$422db9d40fc02e83)=>{
    const bools = await Promise.all(checkedCodecs.map($94511f4b46249ea3$export$b9e95343c882f8ee));
    return checkedCodecs.filter((_, i)=>bools[i]);
};
const $94511f4b46249ea3$export$d9a7e7a53e4aaf10 = async (checkedCodecs, options)=>{
    for (const codec of checkedCodecs){
        if (await $94511f4b46249ea3$export$e282dcda1413edd2(codec, options)) return codec;
    }
    return null;
};
const $94511f4b46249ea3$export$b14b487f4044987b = async (checkedCodecs, options)=>{
    for (const codec of checkedCodecs){
        if (await $94511f4b46249ea3$export$bfe90ae1056d88b3(codec, options)) return codec;
    }
    return null;
};
const $94511f4b46249ea3$export$bd829d909016c21 = async (checkedCodecs)=>{
    for (const codec of checkedCodecs){
        if (await $94511f4b46249ea3$export$b9e95343c882f8ee(codec)) return codec;
    }
    return null;
};



/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ const $c77d4d874d58660e$var$cueBlockHeaderRegex = /(?:(.+?)\n)?((?:\d{2}:)?\d{2}:\d{2}.\d{3})\s+-->\s+((?:\d{2}:)?\d{2}:\d{2}.\d{3})/g;
const $c77d4d874d58660e$var$preambleStartRegex = /^WEBVTT(.|\n)*?\n{2}/;
const $c77d4d874d58660e$export$605131a15c078e1b = /<(?:(\d{2}):)?(\d{2}):(\d{2}).(\d{3})>/g;
class $c77d4d874d58660e$export$767933ebd734b1bc {
    constructor(options){
        this.preambleText = null;
        this.preambleEmitted = false;
        this.options = options;
    }
    parse(text) {
        text = text.replaceAll('\r\n', '\n').replaceAll('\r', '\n');
        $c77d4d874d58660e$var$cueBlockHeaderRegex.lastIndex = 0;
        let match;
        if (!this.preambleText) {
            if (!$c77d4d874d58660e$var$preambleStartRegex.test(text)) throw new Error('WebVTT preamble incorrect.');
            match = $c77d4d874d58660e$var$cueBlockHeaderRegex.exec(text);
            const preamble = text.slice(0, match?.index ?? text.length).trimEnd();
            if (!preamble) throw new Error('No WebVTT preamble provided.');
            this.preambleText = preamble;
            if (match) {
                text = text.slice(match.index);
                $c77d4d874d58660e$var$cueBlockHeaderRegex.lastIndex = 0;
            }
        }
        while(match = $c77d4d874d58660e$var$cueBlockHeaderRegex.exec(text)){
            const notes = text.slice(0, match.index);
            const cueIdentifier = match[1];
            const matchEnd = match.index + match[0].length;
            const bodyStart = text.indexOf('\n', matchEnd) + 1;
            const cueSettings = text.slice(matchEnd, bodyStart).trim();
            let bodyEnd = text.indexOf('\n\n', matchEnd);
            if (bodyEnd === -1) bodyEnd = text.length;
            const startTime = $c77d4d874d58660e$export$a8948794ee6e0e3a(match[2]);
            const endTime = $c77d4d874d58660e$export$a8948794ee6e0e3a(match[3]);
            const duration = endTime - startTime;
            const body = text.slice(bodyStart, bodyEnd).trim();
            text = text.slice(bodyEnd).trimStart();
            $c77d4d874d58660e$var$cueBlockHeaderRegex.lastIndex = 0;
            const cue = {
                timestamp: startTime / 1000,
                duration: duration / 1000,
                text: body,
                identifier: cueIdentifier,
                settings: cueSettings,
                notes: notes
            };
            const meta = {};
            if (!this.preambleEmitted) {
                meta.config = {
                    description: this.preambleText
                };
                this.preambleEmitted = true;
            }
            this.options.output(cue, meta);
        }
    }
}
const $c77d4d874d58660e$var$timestampRegex = /(?:(\d{2}):)?(\d{2}):(\d{2}).(\d{3})/;
const $c77d4d874d58660e$export$a8948794ee6e0e3a = (string)=>{
    const match = $c77d4d874d58660e$var$timestampRegex.exec(string);
    if (!match) throw new Error('Expected match.');
    return 3600000 * Number(match[1] || '0') + 60000 * Number(match[2]) + 1000 * Number(match[3]) + Number(match[4]);
};
const $c77d4d874d58660e$export$ad655d9645737731 = (timestamp)=>{
    const hours = Math.floor(timestamp / 3600000);
    const minutes = Math.floor(timestamp % 3600000 / 60000);
    const seconds = Math.floor(timestamp % 60000 / 1000);
    const milliseconds = timestamp % 1000;
    return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0') + '.' + milliseconds.toString().padStart(3, '0');
};


/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ // https://github.com/dystopiancode/pcm-g711/blob/master/pcm-g711/g711.c
const $d272c64a25724154$export$c94797cd957a5ca6 = (s16)=>{
    const MULAW_MAX = 0x1FFF;
    const MULAW_BIAS = 33;
    let number = s16;
    let mask = 0x1000;
    let sign = 0;
    let position = 12;
    let lsb = 0;
    if (number < 0) {
        number = -number;
        sign = 0x80;
    }
    number += MULAW_BIAS;
    if (number > MULAW_MAX) number = MULAW_MAX;
    while((number & mask) !== mask && position >= 5){
        mask >>= 1;
        position--;
    }
    lsb = number >> position - 4 & 0x0f;
    return ~(sign | position - 5 << 4 | lsb) & 0xFF;
};
const $d272c64a25724154$export$a39b2e9b5a716a7a = (u8)=>{
    const MULAW_BIAS = 33;
    let sign = 0;
    let position = 0;
    let number = ~u8;
    if (number & 0x80) {
        number &= -129;
        sign = -1;
    }
    position = ((number & 0xF0) >> 4) + 5;
    const decoded = (1 << position | (number & 0x0F) << position - 4 | 1 << position - 5) - MULAW_BIAS;
    return sign === 0 ? decoded : -decoded;
};
const $d272c64a25724154$export$bc1dfcaa8798b2f0 = (s16)=>{
    const ALAW_MAX = 0xFFF;
    let mask = 0x800;
    let sign = 0;
    let position = 11;
    let lsb = 0;
    let number = s16;
    if (number < 0) {
        number = -number;
        sign = 0x80;
    }
    if (number > ALAW_MAX) number = ALAW_MAX;
    while((number & mask) !== mask && position >= 5){
        mask >>= 1;
        position--;
    }
    lsb = number >> (position === 4 ? 1 : position - 4) & 0x0f;
    return (sign | position - 4 << 4 | lsb) ^ 0x55;
};
const $d272c64a25724154$export$960a470902702a7d = (u8)=>{
    let sign = 0x00;
    let position = 0;
    let number = u8 ^ 0x55;
    if (number & 0x80) {
        number &= -129;
        sign = -1;
    }
    position = ((number & 0xF0) >> 4) + 4;
    let decoded = 0;
    if (position !== 4) decoded = 1 << position | (number & 0x0F) << position - 4 | 1 << position - 5;
    else decoded = number << 1 | 1;
    return sign === 0 ? decoded : -decoded;
};



/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ 
const $8ce8f170cc716e8f$export$d83e8557fbdb95af = new Uint8Array(0);
class $8ce8f170cc716e8f$export$2bb25546e7fe690b {
    constructor(/** The encoded data of this packet. */ data, /** The type of this packet. */ type, /**
     * The presentation timestamp of this packet in seconds. May be negative. Samples with negative end timestamps
     * should not be presented.
     */ timestamp, /** The duration of this packet in seconds. */ duration, /**
     * The sequence number indicates the decode order of the packets. Packet A  must be decoded before packet B if A
     * has a lower sequence number than B. If two packets have the same sequence number, they are the same packet.
     * Otherwise, sequence numbers are arbitrary and are not guaranteed to have any meaning besides their relative
     * ordering. Negative sequence numbers mean the sequence number is undefined.
     */ sequenceNumber = -1, byteLength){
        this.data = data;
        this.type = type;
        this.timestamp = timestamp;
        this.duration = duration;
        this.sequenceNumber = sequenceNumber;
        if (data === $8ce8f170cc716e8f$export$d83e8557fbdb95af && byteLength === undefined) throw new Error('Internal error: byteLength must be explicitly provided when constructing metadata-only packets.');
        if (byteLength === undefined) byteLength = data.byteLength;
        if (!(data instanceof Uint8Array)) throw new TypeError('data must be a Uint8Array.');
        if (type !== 'key' && type !== 'delta') throw new TypeError('type must be either "key" or "delta".');
        if (!Number.isFinite(timestamp)) throw new TypeError('timestamp must be a number.');
        if (!Number.isFinite(duration) || duration < 0) throw new TypeError('duration must be a non-negative number.');
        if (!Number.isFinite(sequenceNumber)) throw new TypeError('sequenceNumber must be a number.');
        if (!Number.isInteger(byteLength) || byteLength < 0) throw new TypeError('byteLength must be a non-negative integer.');
        this.byteLength = byteLength;
    }
    /** If this packet is a metadata-only packet. Metadata-only packets don't contain their packet data. */ get isMetadataOnly() {
        return this.data === $8ce8f170cc716e8f$export$d83e8557fbdb95af;
    }
    /** The timestamp of this packet in microseconds. */ get microsecondTimestamp() {
        return Math.trunc((0, $053d5bbcf6664967$export$6b7fbfaaab0cbddf) * this.timestamp);
    }
    /** The duration of this packet in microseconds. */ get microsecondDuration() {
        return Math.trunc((0, $053d5bbcf6664967$export$6b7fbfaaab0cbddf) * this.duration);
    }
    /** Converts this packet to an EncodedVideoChunk for use with the WebCodecs API. */ toEncodedVideoChunk() {
        if (this.isMetadataOnly) throw new TypeError('Metadata-only packets cannot be converted to a video chunk.');
        if (typeof EncodedVideoChunk === 'undefined') throw new Error('Your browser does not support EncodedVideoChunk.');
        return new EncodedVideoChunk({
            data: this.data,
            type: this.type,
            timestamp: this.microsecondTimestamp,
            duration: this.microsecondDuration
        });
    }
    /** Converts this packet to an EncodedAudioChunk for use with the WebCodecs API. */ toEncodedAudioChunk() {
        if (this.isMetadataOnly) throw new TypeError('Metadata-only packets cannot be converted to an audio chunk.');
        if (typeof EncodedAudioChunk === 'undefined') throw new Error('Your browser does not support EncodedAudioChunk.');
        return new EncodedAudioChunk({
            data: this.data,
            type: this.type,
            timestamp: this.microsecondTimestamp,
            duration: this.microsecondDuration
        });
    }
    /**
     * Creates an EncodedPacket from an EncodedVideoChunk or EncodedAudioChunk. This method is useful for converting
     * chunks from the WebCodecs API to EncodedPackets.
     */ static fromEncodedChunk(chunk) {
        if (!(chunk instanceof EncodedVideoChunk || chunk instanceof EncodedAudioChunk)) throw new TypeError('chunk must be an EncodedVideoChunk or EncodedAudioChunk.');
        const data = new Uint8Array(chunk.byteLength);
        chunk.copyTo(data);
        return new $8ce8f170cc716e8f$export$2bb25546e7fe690b(data, chunk.type, chunk.timestamp / 1e6, (chunk.duration ?? 0) / 1e6);
    }
    /** Clones this packet while optionally updating timing information. */ clone(options) {
        if (options !== undefined && (typeof options !== 'object' || options === null)) throw new TypeError('options, when provided, must be an object.');
        if (options?.timestamp !== undefined && !Number.isFinite(options.timestamp)) throw new TypeError('options.timestamp, when provided, must be a number.');
        if (options?.duration !== undefined && !Number.isFinite(options.duration)) throw new TypeError('options.duration, when provided, must be a number.');
        return new $8ce8f170cc716e8f$export$2bb25546e7fe690b(this.data, this.type, options?.timestamp ?? this.timestamp, options?.duration ?? this.duration, this.sequenceNumber, this.byteLength);
    }
}


/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ 
class $641b34a2137bac97$export$41944c7dced90f9 {
    /** The width of the frame in pixels after rotation. */ get displayWidth() {
        return this.rotation % 180 === 0 ? this.codedWidth : this.codedHeight;
    }
    /** The height of the frame in pixels after rotation. */ get displayHeight() {
        return this.rotation % 180 === 0 ? this.codedHeight : this.codedWidth;
    }
    /** The presentation timestamp of the frame in microseconds. */ get microsecondTimestamp() {
        return Math.trunc((0, $053d5bbcf6664967$export$6b7fbfaaab0cbddf) * this.timestamp);
    }
    /** The duration of the frame in microseconds. */ get microsecondDuration() {
        return Math.trunc((0, $053d5bbcf6664967$export$6b7fbfaaab0cbddf) * this.duration);
    }
    constructor(data, init){
        /** @internal */ this._closed = false;
        if (data instanceof ArrayBuffer || ArrayBuffer.isView(data)) {
            if (!init || typeof init !== 'object') throw new TypeError('init must be an object.');
            if (!('format' in init) || typeof init.format !== 'string') throw new TypeError('init.format must be a string.');
            if (!Number.isInteger(init.codedWidth) || init.codedWidth <= 0) throw new TypeError('init.codedWidth must be a positive integer.');
            if (!Number.isInteger(init.codedHeight) || init.codedHeight <= 0) throw new TypeError('init.codedHeight must be a positive integer.');
            if (init.rotation !== undefined && ![
                0,
                90,
                180,
                270
            ].includes(init.rotation)) throw new TypeError('init.rotation, when provided, must be 0, 90, 180, or 270.');
            if (!Number.isFinite(init.timestamp)) throw new TypeError('init.timestamp must be a number.');
            if (init.duration !== undefined && (!Number.isFinite(init.duration) || init.duration < 0)) throw new TypeError('init.duration, when provided, must be a non-negative number.');
            this._data = (0, $053d5bbcf6664967$export$73470fd2221e6aef)(data).slice(); // Copy it
            this.format = init.format;
            this.codedWidth = init.codedWidth;
            this.codedHeight = init.codedHeight;
            this.rotation = init.rotation ?? 0;
            this.timestamp = init.timestamp;
            this.duration = init.duration ?? 0;
            this.colorSpace = new VideoColorSpace(init.colorSpace);
        } else if (typeof VideoFrame !== 'undefined' && data instanceof VideoFrame) {
            if (init?.rotation !== undefined && ![
                0,
                90,
                180,
                270
            ].includes(init.rotation)) throw new TypeError('init.rotation, when provided, must be 0, 90, 180, or 270.');
            if (init?.timestamp !== undefined && !Number.isFinite(init?.timestamp)) throw new TypeError('init.timestamp, when provided, must be a number.');
            if (init?.duration !== undefined && (!Number.isFinite(init.duration) || init.duration < 0)) throw new TypeError('init.duration, when provided, must be a non-negative number.');
            this._data = data;
            this.format = data.format;
            this.codedWidth = data.codedWidth;
            this.codedHeight = data.codedHeight;
            this.rotation = init?.rotation ?? 0;
            this.timestamp = init?.timestamp ?? data.timestamp / 1e6;
            this.duration = init?.duration ?? (data.duration ?? 0) / 1e6;
            this.colorSpace = data.colorSpace;
        } else if (typeof HTMLImageElement !== 'undefined' && data instanceof HTMLImageElement || typeof SVGImageElement !== 'undefined' && data instanceof SVGImageElement || typeof ImageBitmap !== 'undefined' && data instanceof ImageBitmap || typeof HTMLVideoElement !== 'undefined' && data instanceof HTMLVideoElement || typeof HTMLCanvasElement !== 'undefined' && data instanceof HTMLCanvasElement || typeof OffscreenCanvas !== 'undefined' && data instanceof OffscreenCanvas) {
            if (!init || typeof init !== 'object') throw new TypeError('init must be an object.');
            if (init.rotation !== undefined && ![
                0,
                90,
                180,
                270
            ].includes(init.rotation)) throw new TypeError('init.rotation, when provided, must be 0, 90, 180, or 270.');
            if (!Number.isFinite(init.timestamp)) throw new TypeError('init.timestamp must be a number.');
            if (init.duration !== undefined && (!Number.isFinite(init.duration) || init.duration < 0)) throw new TypeError('init.duration, when provided, must be a non-negative number.');
            if (typeof VideoFrame !== 'undefined') return new $641b34a2137bac97$export$41944c7dced90f9(new VideoFrame(data, {
                timestamp: Math.trunc(init.timestamp * (0, $053d5bbcf6664967$export$6b7fbfaaab0cbddf)),
                duration: Math.trunc((init.duration ?? 0) * (0, $053d5bbcf6664967$export$6b7fbfaaab0cbddf))
            }), init);
            let width = 0;
            let height = 0;
            // Determine the dimensions of the thing
            if ('naturalWidth' in data) {
                width = data.naturalWidth;
                height = data.naturalHeight;
            } else if ('videoWidth' in data) {
                width = data.videoWidth;
                height = data.videoHeight;
            } else if ('width' in data) {
                width = Number(data.width);
                height = Number(data.height);
            }
            if (!width || !height) throw new TypeError('Could not determine dimensions.');
            const canvas = new OffscreenCanvas(width, height);
            const context = canvas.getContext('2d', {
                alpha: false,
                willReadFrequently: true
            });
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(context);
            // Draw it to a canvas
            context.drawImage(data, 0, 0);
            this._data = canvas;
            this.format = 'RGBX';
            this.codedWidth = width;
            this.codedHeight = height;
            this.rotation = init.rotation ?? 0;
            this.timestamp = init.timestamp;
            this.duration = init.duration ?? 0;
            this.colorSpace = new VideoColorSpace({
                matrix: 'rgb',
                primaries: 'bt709',
                transfer: 'iec61966-2-1',
                fullRange: true
            });
        } else throw new TypeError('Invalid data type: Must be a BufferSource or CanvasImageSource.');
    }
    /** Clones this video sample. */ clone() {
        if (this._closed) throw new Error('VideoSample is closed.');
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this._data !== null);
        if ($641b34a2137bac97$var$isVideoFrame(this._data)) return new $641b34a2137bac97$export$41944c7dced90f9(this._data.clone(), {
            timestamp: this.timestamp,
            duration: this.duration
        });
        else if (this._data instanceof Uint8Array) return new $641b34a2137bac97$export$41944c7dced90f9(this._data.slice(), {
            format: this.format,
            codedWidth: this.codedWidth,
            codedHeight: this.codedHeight,
            timestamp: this.timestamp,
            duration: this.duration,
            colorSpace: this.colorSpace
        });
        else return new $641b34a2137bac97$export$41944c7dced90f9(this._data, {
            format: this.format,
            codedWidth: this.codedWidth,
            codedHeight: this.codedHeight,
            timestamp: this.timestamp,
            duration: this.duration,
            colorSpace: this.colorSpace
        });
    }
    /**
     * Closes this video sample, releasing held resources. Video samples should be closed as soon as they are not
     * needed anymore.
     */ close() {
        if (this._closed) return;
        if ($641b34a2137bac97$var$isVideoFrame(this._data)) this._data.close();
        else this._data = null; // GC that shit
        this._closed = true;
    }
    /** Returns the number of bytes required to hold this video sample's pixel data. */ allocationSize() {
        if (this._closed) throw new Error('VideoSample is closed.');
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this._data !== null);
        if ($641b34a2137bac97$var$isVideoFrame(this._data)) return this._data.allocationSize();
        else if (this._data instanceof Uint8Array) return this._data.byteLength;
        else return this.codedWidth * this.codedHeight * 4; // RGBX
    }
    /** Copies this video sample's pixel data to an ArrayBuffer or ArrayBufferView. */ async copyTo(destination) {
        if (!(0, $053d5bbcf6664967$export$ba2695b5f58bd3c4)(destination)) throw new TypeError('destination must be an ArrayBuffer or an ArrayBuffer view.');
        if (this._closed) throw new Error('VideoSample is closed.');
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this._data !== null);
        if ($641b34a2137bac97$var$isVideoFrame(this._data)) await this._data.copyTo(destination);
        else if (this._data instanceof Uint8Array) {
            const dest = (0, $053d5bbcf6664967$export$73470fd2221e6aef)(destination);
            dest.set(this._data);
        } else {
            const canvas = this._data;
            const context = canvas.getContext('2d', {
                alpha: false
            });
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(context);
            const imageData = context.getImageData(0, 0, this.codedWidth, this.codedHeight);
            const dest = (0, $053d5bbcf6664967$export$73470fd2221e6aef)(destination);
            dest.set(imageData.data);
        }
    }
    /**
     * Converts this video sample to a VideoFrame for use with the WebCodecs API. The VideoFrame returned by this
     * method *must* be closed separately from this video sample.
     */ toVideoFrame() {
        if (this._closed) throw new Error('VideoSample is closed.');
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this._data !== null);
        if ($641b34a2137bac97$var$isVideoFrame(this._data)) return new VideoFrame(this._data, {
            timestamp: this.microsecondTimestamp,
            duration: this.microsecondDuration || undefined
        });
        else if (this._data instanceof Uint8Array) return new VideoFrame(this._data, {
            format: this.format,
            codedWidth: this.codedWidth,
            codedHeight: this.codedHeight,
            timestamp: this.microsecondTimestamp,
            duration: this.microsecondDuration,
            colorSpace: this.colorSpace
        });
        else return new VideoFrame(this._data, {
            timestamp: this.microsecondTimestamp,
            duration: this.microsecondDuration
        });
    }
    draw(context, arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8) {
        let sx = 0;
        let sy = 0;
        let sWidth = this.displayWidth;
        let sHeight = this.displayHeight;
        let dx = 0;
        let dy = 0;
        let dWidth = this.displayWidth;
        let dHeight = this.displayHeight;
        if (arg5 !== undefined) {
            sx = arg1;
            sy = arg2;
            sWidth = arg3;
            sHeight = arg4;
            dx = arg5;
            dy = arg6;
            if (arg7 !== undefined) {
                dWidth = arg7;
                dHeight = arg8;
            } else {
                dWidth = sWidth;
                dHeight = sHeight;
            }
        } else {
            dx = arg1;
            dy = arg2;
            if (arg3 !== undefined) {
                dWidth = arg3;
                dHeight = arg4;
            }
        }
        if (!(typeof CanvasRenderingContext2D !== 'undefined' && context instanceof CanvasRenderingContext2D || typeof OffscreenCanvasRenderingContext2D !== 'undefined' && context instanceof OffscreenCanvasRenderingContext2D)) throw new TypeError('context must be a CanvasRenderingContext2D or OffscreenCanvasRenderingContext2D.');
        if (!Number.isFinite(sx)) throw new TypeError('sx must be a number.');
        if (!Number.isFinite(sy)) throw new TypeError('sy must be a number.');
        if (!Number.isFinite(sWidth) || sWidth < 0) throw new TypeError('sWidth must be a non-negative number.');
        if (!Number.isFinite(sHeight) || sHeight < 0) throw new TypeError('sHeight must be a non-negative number.');
        if (!Number.isFinite(dx)) throw new TypeError('dx must be a number.');
        if (!Number.isFinite(dy)) throw new TypeError('dy must be a number.');
        if (!Number.isFinite(dWidth) || dWidth < 0) throw new TypeError('dWidth must be a non-negative number.');
        if (!Number.isFinite(dHeight) || dHeight < 0) throw new TypeError('dHeight must be a non-negative number.');
        if (this._closed) throw new Error('VideoSample is closed.');
        // The provided sx,sy,sWidth,sHeight refer to the final rotated image, but that's not actually how the image is
        // stored. Therefore, we must map these back onto the original, pre-rotation image.
        if (this.rotation === 90) [sx, sy, sWidth, sHeight] = [
            sy,
            this.codedHeight - sx - sWidth,
            sHeight,
            sWidth
        ];
        else if (this.rotation === 180) [sx, sy] = [
            this.codedWidth - sx - sWidth,
            this.codedHeight - sy - sHeight
        ];
        else if (this.rotation === 270) [sx, sy, sWidth, sHeight] = [
            this.codedWidth - sy - sHeight,
            sx,
            sHeight,
            sWidth
        ];
        const source = this.toCanvasImageSource();
        context.save();
        const centerX = dx + dWidth / 2;
        const centerY = dy + dHeight / 2;
        context.translate(centerX, centerY);
        context.rotate(this.rotation * Math.PI / 180);
        const aspectRatioChange = this.rotation % 180 === 0 ? 1 : dWidth / dHeight;
        // Scale to compensate for aspect ratio changes when rotated
        context.scale(1 / aspectRatioChange, aspectRatioChange);
        context.drawImage(source, sx, sy, sWidth, sHeight, -dWidth / 2, -dHeight / 2, dWidth, dHeight);
        // Restore the previous transformation state
        context.restore();
    }
    /**
     * Converts this video sample to a CanvasImageSource for drawing to a canvas.
     *
     * You must use the value returned by this method immediately, as any VideoFrame created internally will
     * automatically be closed in the next microtask.
     */ toCanvasImageSource() {
        if (this._closed) throw new Error('VideoSample is closed.');
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this._data !== null);
        if (this._data instanceof Uint8Array) {
            // Requires VideoFrame to be defined
            const videoFrame = this.toVideoFrame();
            queueMicrotask(()=>videoFrame.close()); // Let's automatically close the frame in the next microtask
            return videoFrame;
        } else return this._data;
    }
    /** Sets the rotation metadata of this video sample. */ setRotation(newRotation) {
        if (![
            0,
            90,
            180,
            270
        ].includes(newRotation)) throw new TypeError('newRotation must be 0, 90, 180, or 270.');
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
        this.rotation = newRotation;
    }
    /** Sets the presentation timestamp of this video sample, in seconds. */ setTimestamp(newTimestamp) {
        if (!Number.isFinite(newTimestamp)) throw new TypeError('newTimestamp must be a number.');
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
        this.timestamp = newTimestamp;
    }
    /** Sets the duration of this video sample, in seconds. */ setDuration(newDuration) {
        if (!Number.isFinite(newDuration) || newDuration < 0) throw new TypeError('newDuration must be a non-negative number.');
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
        this.duration = newDuration;
    }
}
const $641b34a2137bac97$var$isVideoFrame = (x)=>{
    return typeof VideoFrame !== 'undefined' && x instanceof VideoFrame;
};
const $641b34a2137bac97$var$AUDIO_SAMPLE_FORMATS = new Set([
    'f32',
    'f32-planar',
    's16',
    's16-planar',
    's32',
    's32-planar',
    'u8',
    'u8-planar'
]);
class $641b34a2137bac97$export$290dedacb3c54314 {
    /** The presentation timestamp of the sample in microseconds. */ get microsecondTimestamp() {
        return Math.trunc((0, $053d5bbcf6664967$export$6b7fbfaaab0cbddf) * this.timestamp);
    }
    /** The duration of the sample in microseconds. */ get microsecondDuration() {
        return Math.trunc((0, $053d5bbcf6664967$export$6b7fbfaaab0cbddf) * this.duration);
    }
    constructor(init){
        /** @internal */ this._closed = false;
        if ($641b34a2137bac97$var$isAudioData(init)) {
            if (init.format === null) throw new TypeError('AudioData with null format is not supported.');
            this._data = init;
            this.format = init.format;
            this.sampleRate = init.sampleRate;
            this.numberOfFrames = init.numberOfFrames;
            this.numberOfChannels = init.numberOfChannels;
            this.timestamp = init.timestamp / 1e6;
            this.duration = init.numberOfFrames / init.sampleRate;
        } else {
            if (!init || typeof init !== 'object') throw new TypeError('Invalid AudioDataInit: must be an object.');
            if (!$641b34a2137bac97$var$AUDIO_SAMPLE_FORMATS.has(init.format)) throw new TypeError('Invalid AudioDataInit: invalid format.');
            if (!Number.isFinite(init.sampleRate) || init.sampleRate <= 0) throw new TypeError('Invalid AudioDataInit: sampleRate must be > 0.');
            if (!Number.isInteger(init.numberOfChannels) || init.numberOfChannels === 0) throw new TypeError('Invalid AudioDataInit: numberOfChannels must be an integer > 0.');
            if (!Number.isFinite(init?.timestamp)) throw new TypeError('init.timestamp must be a number.');
            const numberOfFrames = init.data.byteLength / ($641b34a2137bac97$var$getBytesPerSample(init.format) * init.numberOfChannels);
            if (!Number.isInteger(numberOfFrames)) throw new TypeError('Invalid AudioDataInit: data size is not a multiple of frame size.');
            this.format = init.format;
            this.sampleRate = init.sampleRate;
            this.numberOfFrames = numberOfFrames;
            this.numberOfChannels = init.numberOfChannels;
            this.timestamp = init.timestamp;
            this.duration = numberOfFrames / init.sampleRate;
            let dataBuffer;
            if (init.data instanceof ArrayBuffer) dataBuffer = new Uint8Array(init.data);
            else if (ArrayBuffer.isView(init.data)) dataBuffer = new Uint8Array(init.data.buffer, init.data.byteOffset, init.data.byteLength);
            else throw new TypeError('Invalid AudioDataInit: data is not a BufferSource.');
            const expectedSize = this.numberOfFrames * this.numberOfChannels * $641b34a2137bac97$var$getBytesPerSample(this.format);
            if (dataBuffer.byteLength < expectedSize) throw new TypeError('Invalid AudioDataInit: insufficient data size.');
            this._data = dataBuffer;
        }
    }
    /** Returns the number of bytes required to hold the audio sample's data as specified by the given options. */ allocationSize(options) {
        if (!options || typeof options !== 'object') throw new TypeError('options must be an object.');
        if (!Number.isInteger(options.planeIndex) || options.planeIndex < 0) throw new TypeError('planeIndex must be a non-negative integer.');
        if (options.format !== undefined && !$641b34a2137bac97$var$AUDIO_SAMPLE_FORMATS.has(options.format)) throw new TypeError('Invalid format.');
        if (options.frameOffset !== undefined && (!Number.isInteger(options.frameOffset) || options.frameOffset < 0)) throw new TypeError('frameOffset must be a non-negative integer.');
        if (options.frameCount !== undefined && (!Number.isInteger(options.frameCount) || options.frameCount < 0)) throw new TypeError('frameCount must be a non-negative integer.');
        if (this._closed) throw new Error('AudioSample is closed.');
        const destFormat = options.format ?? this.format;
        const frameOffset = options.frameOffset ?? 0;
        if (frameOffset >= this.numberOfFrames) throw new RangeError('frameOffset out of range');
        const copyFrameCount = options.frameCount !== undefined ? options.frameCount : this.numberOfFrames - frameOffset;
        if (copyFrameCount > this.numberOfFrames - frameOffset) throw new RangeError('frameCount out of range');
        const bytesPerSample = $641b34a2137bac97$var$getBytesPerSample(destFormat);
        const isPlanar = $641b34a2137bac97$var$formatIsPlanar(destFormat);
        if (isPlanar && options.planeIndex >= this.numberOfChannels) throw new RangeError('planeIndex out of range');
        if (!isPlanar && options.planeIndex !== 0) throw new RangeError('planeIndex out of range');
        const elementCount = isPlanar ? copyFrameCount : copyFrameCount * this.numberOfChannels;
        return elementCount * bytesPerSample;
    }
    /** Copies the audio sample's data to an ArrayBuffer or ArrayBufferView as specified by the given options. */ copyTo(destination, options) {
        if (!(0, $053d5bbcf6664967$export$ba2695b5f58bd3c4)(destination)) throw new TypeError('destination must be an ArrayBuffer or an ArrayBuffer view.');
        if (!options || typeof options !== 'object') throw new TypeError('options must be an object.');
        if (!Number.isInteger(options.planeIndex) || options.planeIndex < 0) throw new TypeError('planeIndex must be a non-negative integer.');
        if (options.format !== undefined && !$641b34a2137bac97$var$AUDIO_SAMPLE_FORMATS.has(options.format)) throw new TypeError('Invalid format.');
        if (options.frameOffset !== undefined && (!Number.isInteger(options.frameOffset) || options.frameOffset < 0)) throw new TypeError('frameOffset must be a non-negative integer.');
        if (options.frameCount !== undefined && (!Number.isInteger(options.frameCount) || options.frameCount < 0)) throw new TypeError('frameCount must be a non-negative integer.');
        if (this._closed) throw new Error('AudioSample is closed.');
        const { planeIndex: planeIndex, format: format, frameCount: optFrameCount, frameOffset: optFrameOffset } = options;
        const destFormat = format ?? this.format;
        if (!destFormat) throw new Error('Destination format not determined');
        const numFrames = this.numberOfFrames;
        const numChannels = this.numberOfChannels;
        const frameOffset = optFrameOffset ?? 0;
        if (frameOffset >= numFrames) throw new RangeError('frameOffset out of range');
        const copyFrameCount = optFrameCount !== undefined ? optFrameCount : numFrames - frameOffset;
        if (copyFrameCount > numFrames - frameOffset) throw new RangeError('frameCount out of range');
        const destBytesPerSample = $641b34a2137bac97$var$getBytesPerSample(destFormat);
        const destIsPlanar = $641b34a2137bac97$var$formatIsPlanar(destFormat);
        if (destIsPlanar && planeIndex >= numChannels) throw new RangeError('planeIndex out of range');
        if (!destIsPlanar && planeIndex !== 0) throw new RangeError('planeIndex out of range');
        const destElementCount = destIsPlanar ? copyFrameCount : copyFrameCount * numChannels;
        const requiredSize = destElementCount * destBytesPerSample;
        if (destination.byteLength < requiredSize) throw new RangeError('Destination buffer is too small');
        const destView = (0, $053d5bbcf6664967$export$f6b0788df7b6d1ec)(destination);
        const writeFn = $641b34a2137bac97$var$getWriteFunction(destFormat);
        if ($641b34a2137bac97$var$isAudioData(this._data)) {
            if (destIsPlanar) {
                if (destFormat === 'f32-planar') // Simple, since the browser must support f32-planar, we can just delegate here
                this._data.copyTo(destination, {
                    planeIndex: planeIndex,
                    frameOffset: frameOffset,
                    frameCount: copyFrameCount,
                    format: 'f32-planar'
                });
                else {
                    // Allocate temporary buffer for f32-planar data
                    const tempBuffer = new ArrayBuffer(copyFrameCount * 4);
                    const tempArray = new Float32Array(tempBuffer);
                    this._data.copyTo(tempArray, {
                        planeIndex: planeIndex,
                        frameOffset: frameOffset,
                        frameCount: copyFrameCount,
                        format: 'f32-planar'
                    });
                    // Convert each f32 sample to destination format
                    const tempView = new DataView(tempBuffer);
                    for(let i = 0; i < copyFrameCount; i++){
                        const destOffset = i * destBytesPerSample;
                        const sample = tempView.getFloat32(i * 4, true);
                        writeFn(destView, destOffset, sample);
                    }
                }
            } else {
                // Destination is interleaved.
                // Allocate a temporary Float32Array to hold one channel's worth of data.
                const numCh = numChannels;
                const temp = new Float32Array(copyFrameCount);
                for(let ch = 0; ch < numCh; ch++){
                    this._data.copyTo(temp, {
                        planeIndex: ch,
                        frameOffset: frameOffset,
                        frameCount: copyFrameCount,
                        format: 'f32-planar'
                    });
                    for(let i = 0; i < copyFrameCount; i++){
                        const destIndex = i * numCh + ch;
                        const destOffset = destIndex * destBytesPerSample;
                        writeFn(destView, destOffset, temp[i]);
                    }
                }
            }
        } else {
            // Branch for Uint8Array data (non-AudioData)
            const uint8Data = this._data;
            const srcView = new DataView(uint8Data.buffer, uint8Data.byteOffset, uint8Data.byteLength);
            const srcFormat = this.format;
            const readFn = $641b34a2137bac97$var$getReadFunction(srcFormat);
            const srcBytesPerSample = $641b34a2137bac97$var$getBytesPerSample(srcFormat);
            const srcIsPlanar = $641b34a2137bac97$var$formatIsPlanar(srcFormat);
            for(let i = 0; i < copyFrameCount; i++){
                if (destIsPlanar) {
                    const destOffset = i * destBytesPerSample;
                    let srcOffset;
                    if (srcIsPlanar) srcOffset = (planeIndex * numFrames + (i + frameOffset)) * srcBytesPerSample;
                    else srcOffset = ((i + frameOffset) * numChannels + planeIndex) * srcBytesPerSample;
                    const normalized = readFn(srcView, srcOffset);
                    writeFn(destView, destOffset, normalized);
                } else for(let ch = 0; ch < numChannels; ch++){
                    const destIndex = i * numChannels + ch;
                    const destOffset = destIndex * destBytesPerSample;
                    let srcOffset;
                    if (srcIsPlanar) srcOffset = (ch * numFrames + (i + frameOffset)) * srcBytesPerSample;
                    else srcOffset = ((i + frameOffset) * numChannels + ch) * srcBytesPerSample;
                    const normalized = readFn(srcView, srcOffset);
                    writeFn(destView, destOffset, normalized);
                }
            }
        }
    }
    /** Clones this audio sample. */ clone() {
        if (this._closed) throw new Error('AudioSample is closed.');
        if ($641b34a2137bac97$var$isAudioData(this._data)) {
            const sample = new $641b34a2137bac97$export$290dedacb3c54314(this._data.clone());
            sample.setTimestamp(this.timestamp); // Make sure the timestamp is precise (beyond microsecond accuracy)
            return sample;
        } else return new $641b34a2137bac97$export$290dedacb3c54314({
            format: this.format,
            sampleRate: this.sampleRate,
            numberOfFrames: this.numberOfFrames,
            numberOfChannels: this.numberOfChannels,
            timestamp: this.timestamp,
            data: this._data
        });
    }
    /**
     * Closes this audio sample, releasing held resources. Audio samples should be closed as soon as they are not
     * needed anymore.
     */ close() {
        if (this._closed) return;
        if ($641b34a2137bac97$var$isAudioData(this._data)) this._data.close();
        else this._data = new Uint8Array(0);
        this._closed = true;
    }
    /**
     * Converts this audio sample to an AudioData for use with the WebCodecs API. The AudioData returned by this
     * method *must* be closed separately from this audio sample.
     */ toAudioData() {
        if (this._closed) throw new Error('AudioSample is closed.');
        if ($641b34a2137bac97$var$isAudioData(this._data)) {
            if (this._data.timestamp === this.microsecondTimestamp) // Timestamp matches, let's just return the data (but cloned)
            return this._data.clone();
            else // It's impossible to simply change an AudioData's timestamp, so we'll need to create a new one
            if ($641b34a2137bac97$var$formatIsPlanar(this.format)) {
                const size = this.allocationSize({
                    planeIndex: 0,
                    format: this.format
                });
                const data = new ArrayBuffer(size * this.numberOfChannels);
                // We gotta read out each plane individually
                for(let i = 0; i < this.numberOfChannels; i++)this.copyTo(new Uint8Array(data, i * size, size), {
                    planeIndex: i,
                    format: this.format
                });
                return new AudioData({
                    format: this.format,
                    sampleRate: this.sampleRate,
                    numberOfFrames: this.numberOfFrames,
                    numberOfChannels: this.numberOfChannels,
                    timestamp: this.microsecondTimestamp,
                    data: data
                });
            } else {
                const data = new ArrayBuffer(this.allocationSize({
                    planeIndex: 0,
                    format: this.format
                }));
                this.copyTo(data, {
                    planeIndex: 0,
                    format: this.format
                });
                return new AudioData({
                    format: this.format,
                    sampleRate: this.sampleRate,
                    numberOfFrames: this.numberOfFrames,
                    numberOfChannels: this.numberOfChannels,
                    timestamp: this.microsecondTimestamp,
                    data: data
                });
            }
        } else return new AudioData({
            format: this.format,
            sampleRate: this.sampleRate,
            numberOfFrames: this.numberOfFrames,
            numberOfChannels: this.numberOfChannels,
            timestamp: this.microsecondTimestamp,
            data: this._data
        });
    }
    /** Convert this audio sample to an AudioBuffer for use with the Web Audio API. */ toAudioBuffer() {
        if (this._closed) throw new Error('AudioSample is closed.');
        const audioBuffer = new AudioBuffer({
            numberOfChannels: this.numberOfChannels,
            length: this.numberOfFrames,
            sampleRate: this.sampleRate
        });
        const dataBytes = new Float32Array(this.allocationSize({
            planeIndex: 0,
            format: 'f32-planar'
        }) / 4);
        for(let i = 0; i < this.numberOfChannels; i++){
            this.copyTo(dataBytes, {
                planeIndex: i,
                format: 'f32-planar'
            });
            audioBuffer.copyToChannel(dataBytes, i);
        }
        return audioBuffer;
    }
    /** Sets the presentation timestamp of this audio sample, in seconds. */ setTimestamp(newTimestamp) {
        if (!Number.isFinite(newTimestamp)) throw new TypeError('newTimestamp must be a number.');
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
        this.timestamp = newTimestamp;
    }
}
const $641b34a2137bac97$var$getBytesPerSample = (format)=>{
    switch(format){
        case 'u8':
        case 'u8-planar':
            return 1;
        case 's16':
        case 's16-planar':
            return 2;
        case 's32':
        case 's32-planar':
            return 4;
        case 'f32':
        case 'f32-planar':
            return 4;
        default:
            throw new Error('Unknown AudioSampleFormat');
    }
};
const $641b34a2137bac97$var$formatIsPlanar = (format)=>{
    switch(format){
        case 'u8-planar':
        case 's16-planar':
        case 's32-planar':
        case 'f32-planar':
            return true;
        default:
            return false;
    }
};
const $641b34a2137bac97$var$getReadFunction = (format)=>{
    switch(format){
        case 'u8':
        case 'u8-planar':
            return (view, offset)=>(view.getUint8(offset) - 128) / 128;
        case 's16':
        case 's16-planar':
            return (view, offset)=>view.getInt16(offset, true) / 32768;
        case 's32':
        case 's32-planar':
            return (view, offset)=>view.getInt32(offset, true) / 2147483648;
        case 'f32':
        case 'f32-planar':
            return (view, offset)=>view.getFloat32(offset, true);
    }
};
const $641b34a2137bac97$var$getWriteFunction = (format)=>{
    switch(format){
        case 'u8':
        case 'u8-planar':
            return (view, offset, value)=>view.setUint8(offset, (0, $053d5bbcf6664967$export$7d15b64cf5a3a4c4)((value + 1) * 127.5, 0, 255));
        case 's16':
        case 's16-planar':
            return (view, offset, value)=>view.setInt16(offset, (0, $053d5bbcf6664967$export$7d15b64cf5a3a4c4)(Math.round(value * 32767), -32768, 32767), true);
        case 's32':
        case 's32-planar':
            return (view, offset, value)=>view.setInt32(offset, (0, $053d5bbcf6664967$export$7d15b64cf5a3a4c4)(Math.round(value * 2147483647), -2147483648, 2147483647), true);
        case 'f32':
        case 'f32-planar':
            return (view, offset, value)=>view.setFloat32(offset, value, true);
    }
};
const $641b34a2137bac97$var$isAudioData = (x)=>{
    return typeof AudioData !== 'undefined' && x instanceof AudioData;
};


class $1c9745b17d341e9e$export$6de1522d9626320f {
    constructor(){
        /** @internal */ this._connectedTrack = null;
        /** @internal */ this._closingPromise = null;
        /** @internal */ this._closed = false;
        /**
         * @internal
         * A time offset in seconds that is added to all timestamps generated by this source.
         */ this._timestampOffset = 0;
    }
    /** @internal */ _ensureValidAdd() {
        if (!this._connectedTrack) throw new Error('Source is not connected to an output track.');
        if (this._connectedTrack.output.state === 'canceled') throw new Error('Output has been canceled.');
        if (this._connectedTrack.output.state === 'finalizing' || this._connectedTrack.output.state === 'finalized') throw new Error('Output has been finalized.');
        if (this._connectedTrack.output.state === 'pending') throw new Error('Output has not started.');
        if (this._closed) throw new Error('Source is closed.');
    }
    /** @internal */ _start() {}
    /** @internal */ async _flushAndClose() {}
    /**
     * Closes this source. This prevents future samples from being added and signals to the output file that no further
     * samples will come in for this track. Calling `.close()` is optional but recommended after adding the
     * last sample - for improved performance and reduced memory usage.
     */ close() {
        if (this._closingPromise) return;
        const connectedTrack = this._connectedTrack;
        if (!connectedTrack) throw new Error('Cannot call close without connecting the source to an output track.');
        if (connectedTrack.output.state === 'pending') throw new Error('Cannot call close before output has been started.');
        this._closingPromise = (async ()=>{
            await this._flushAndClose();
            this._closed = true;
            if (connectedTrack.output.state === 'finalizing' || connectedTrack.output.state === 'finalized') return;
            connectedTrack.output._muxer.onTrackClose(connectedTrack);
        })();
    }
    /** @internal */ async _flushOrWaitForClose() {
        if (this._closingPromise) // Since closing also flushes, we don't want to do it twice
        return this._closingPromise;
        else return this._flushAndClose();
    }
}
class $1c9745b17d341e9e$export$f3a17123d80000c5 extends $1c9745b17d341e9e$export$6de1522d9626320f {
    constructor(codec){
        super();
        /** @internal */ this._connectedTrack = null;
        if (!(0, $94511f4b46249ea3$export$e32a4ecbb4372159).includes(codec)) throw new TypeError(`Invalid video codec '${codec}'. Must be one of: ${(0, $94511f4b46249ea3$export$e32a4ecbb4372159).join(', ')}.`);
        this._codec = codec;
    }
}
class $1c9745b17d341e9e$export$af1b4bd1abbbd40a extends $1c9745b17d341e9e$export$f3a17123d80000c5 {
    constructor(codec){
        super(codec);
    }
    /**
     * Adds an encoded packet to the output video track.
     *
     * @param meta - Additional metadata from the encoder. You should pass this for the first call, including a valid
     * decoder config.
     *
     * @returns A Promise that resolves once the output is ready to receive more samples. You should await this Promise
     * to respect writer and encoder backpressure.
     */ add(packet, meta) {
        if (!(packet instanceof (0, $8ce8f170cc716e8f$export$2bb25546e7fe690b))) throw new TypeError('packet must be an EncodedPacket.');
        if (packet.isMetadataOnly) throw new TypeError('Metadata-only packets cannot be added.');
        if (meta !== undefined && (!meta || typeof meta !== 'object')) throw new TypeError('meta, when provided, must be an object.');
        this._ensureValidAdd();
        return this._connectedTrack.output._muxer.addEncodedVideoPacket(this._connectedTrack, packet, meta);
    }
}
const $1c9745b17d341e9e$var$validateVideoEncodingConfig = (config)=>{
    if (!config || typeof config !== 'object') throw new TypeError('Encoding config must be an object.');
    if (!(0, $94511f4b46249ea3$export$e32a4ecbb4372159).includes(config.codec)) throw new TypeError(`Invalid video codec '${config.codec}'. Must be one of: ${(0, $94511f4b46249ea3$export$e32a4ecbb4372159).join(', ')}.`);
    if (!(config.bitrate instanceof (0, $94511f4b46249ea3$export$b0cc09cfadf17c04)) && (!Number.isInteger(config.bitrate) || config.bitrate <= 0)) throw new TypeError('config.bitrate must be a positive integer or a quality.');
    if (config.latencyMode !== undefined && ![
        'quality',
        'realtime'
    ].includes(config.latencyMode)) throw new TypeError('config.latencyMode, when provided, must be \'quality\' or \'realtime\'.');
    if (config.keyFrameInterval !== undefined && (!Number.isFinite(config.keyFrameInterval) || config.keyFrameInterval < 0)) throw new TypeError('config.keyFrameInterval, when provided, must be a non-negative number.');
    if (config.fullCodecString !== undefined && typeof config.fullCodecString !== 'string') throw new TypeError('config.fullCodecString, when provided, must be a string.');
    if (config.fullCodecString !== undefined && (0, $94511f4b46249ea3$export$6cfcf5d844ba8020)(config.fullCodecString) !== config.codec) throw new TypeError(`config.fullCodecString, when provided, must be a string that matches the specified codec` + ` (${config.codec}).`);
    if (config.onEncodedPacket !== undefined && typeof config.onEncodedPacket !== 'function') throw new TypeError('config.onEncodedChunk, when provided, must be a function.');
    if (config.onEncoderConfig !== undefined && typeof config.onEncoderConfig !== 'function') throw new TypeError('config.onEncoderConfig, when provided, must be a function.');
};
class $1c9745b17d341e9e$var$VideoEncoderWrapper {
    constructor(source, encodingConfig){
        this.source = source;
        this.encodingConfig = encodingConfig;
        this.ensureEncoderPromise = null;
        this.encoderInitialized = false;
        this.encoder = null;
        this.muxer = null;
        this.lastMultipleOfKeyFrameInterval = -1;
        this.lastWidth = null;
        this.lastHeight = null;
        this.customEncoder = null;
        this.customEncoderCallSerializer = new (0, $053d5bbcf6664967$export$e0e588a18ea3887d)();
        this.customEncoderQueueSize = 0;
        /**
         * Encoders typically throw their errors "out of band", meaning asynchronously in some other execution context.
         * However, we want to surface these errors to the user within the normal control flow, so they don't go uncaught.
         * So, we keep track of the encoder error and throw it as soon as we get the chance.
         */ this.encoderError = null;
    }
    async add(videoSample, shouldClose, encodeOptions) {
        this.checkForEncoderError();
        this.source._ensureValidAdd();
        // Ensure video sample size remains constant
        if (this.lastWidth !== null && this.lastHeight !== null) {
            if (videoSample.codedWidth !== this.lastWidth || videoSample.codedHeight !== this.lastHeight) throw new Error(`Video sample size must remain constant. Expected ${this.lastWidth}x${this.lastHeight},` + ` got ${videoSample.codedWidth}x${videoSample.codedHeight}.`);
        } else {
            this.lastWidth = videoSample.codedWidth;
            this.lastHeight = videoSample.codedHeight;
        }
        if (!this.encoderInitialized) {
            if (!this.ensureEncoderPromise) this.ensureEncoder(videoSample);
            // No, this "if" statement is not useless. Sometimes, the above call to `ensureEncoder` might have
            // synchronously completed and the encoder is already initialized. In this case, we don't need to await the
            // promise anymore. This also fixes nasty async race condition bugs when multiple code paths are calling
            // this method: It's important that the call that initialized the encoder go through this code first.
            if (!this.encoderInitialized) await this.ensureEncoderPromise;
        }
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.encoderInitialized);
        const keyFrameInterval = this.encodingConfig.keyFrameInterval ?? 5;
        const multipleOfKeyFrameInterval = Math.floor(videoSample.timestamp / keyFrameInterval);
        // Ensure a key frame every keyFrameInterval seconds. It is important that all video tracks follow the same
        // "key frame" rhythm, because aligned key frames are required to start new fragments in ISOBMFF or clusters
        // in Matroska (or at least desirable).
        const finalEncodeOptions = {
            ...encodeOptions,
            keyFrame: encodeOptions?.keyFrame || keyFrameInterval === 0 || multipleOfKeyFrameInterval !== this.lastMultipleOfKeyFrameInterval
        };
        this.lastMultipleOfKeyFrameInterval = multipleOfKeyFrameInterval;
        if (this.customEncoder) {
            this.customEncoderQueueSize++;
            const promise = this.customEncoderCallSerializer.call(()=>this.customEncoder.encode(videoSample, finalEncodeOptions)).then(()=>{
                this.customEncoderQueueSize--;
                if (shouldClose) videoSample.close();
            }).catch((error)=>{
                this.encoderError ??= error;
            });
            if (this.customEncoderQueueSize >= 4) await promise;
        } else {
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.encoder);
            const videoFrame = videoSample.toVideoFrame();
            this.encoder.encode(videoFrame, finalEncodeOptions);
            videoFrame.close();
            if (shouldClose) videoSample.close();
            // We need to do this after sending the frame to the encoder as the frame otherwise might be closed
            if (this.encoder.encodeQueueSize >= 4) await new Promise((resolve)=>this.encoder.addEventListener('dequeue', resolve, {
                    once: true
                }));
        }
        await this.muxer.mutex.currentPromise; // Allow the writer to apply backpressure
    }
    async ensureEncoder(videoSample) {
        if (this.encoder) return;
        return this.ensureEncoderPromise = (async ()=>{
            const width = videoSample.codedWidth;
            const height = videoSample.codedHeight;
            const bitrate = this.encodingConfig.bitrate instanceof (0, $94511f4b46249ea3$export$b0cc09cfadf17c04) ? this.encodingConfig.bitrate._toVideoBitrate(this.encodingConfig.codec, width, height) : this.encodingConfig.bitrate;
            const encoderConfig = {
                codec: this.encodingConfig.fullCodecString ?? (0, $94511f4b46249ea3$export$3bbd76a48c549c15)(this.encodingConfig.codec, width, height, bitrate),
                width: width,
                height: height,
                bitrate: bitrate,
                framerate: this.source._connectedTrack?.metadata.frameRate,
                latencyMode: this.encodingConfig.latencyMode,
                ...(0, $94511f4b46249ea3$export$62bce25ec4abf86d)(this.encodingConfig.codec)
            };
            this.encodingConfig.onEncoderConfig?.(encoderConfig);
            const MatchingCustomEncoder = (0, $b095dc9cfc0226bb$export$97d0e85192cc043c).find((x)=>x.supports(this.encodingConfig.codec, encoderConfig));
            if (MatchingCustomEncoder) {
                // @ts-expect-error "Can't create instance of abstract class 🤓"
                this.customEncoder = new MatchingCustomEncoder();
                // @ts-expect-error It's technically readonly
                this.customEncoder.codec = this.encodingConfig.codec;
                // @ts-expect-error It's technically readonly
                this.customEncoder.config = encoderConfig;
                // @ts-expect-error It's technically readonly
                this.customEncoder.onPacket = (packet, meta)=>{
                    if (!(packet instanceof (0, $8ce8f170cc716e8f$export$2bb25546e7fe690b))) throw new TypeError('The first argument passed to onPacket must be an EncodedPacket.');
                    if (meta !== undefined && (!meta || typeof meta !== 'object')) throw new TypeError('The second argument passed to onPacket must be an object or undefined.');
                    this.encodingConfig.onEncodedPacket?.(packet, meta);
                    this.muxer.addEncodedVideoPacket(this.source._connectedTrack, packet, meta);
                };
                await this.customEncoder.init();
            } else {
                if (typeof VideoEncoder === 'undefined') throw new Error('VideoEncoder is not supported by this browser.');
                const support = await VideoEncoder.isConfigSupported(encoderConfig);
                if (!support.supported) throw new Error(`This specific encoder configuration (${encoderConfig.codec}, ${encoderConfig.bitrate} bps,` + ` ${encoderConfig.width}x${encoderConfig.height}) is not supported by this browser. Consider` + ` using another codec or changing your video parameters.`);
                this.encoder = new VideoEncoder({
                    output: (chunk, meta)=>{
                        const packet = (0, $8ce8f170cc716e8f$export$2bb25546e7fe690b).fromEncodedChunk(chunk);
                        this.encodingConfig.onEncodedPacket?.(packet, meta);
                        this.muxer.addEncodedVideoPacket(this.source._connectedTrack, packet, meta);
                    },
                    error: (error)=>{
                        this.encoderError ??= error;
                    }
                });
                this.encoder.configure(encoderConfig);
            }
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.source._connectedTrack);
            this.muxer = this.source._connectedTrack.output._muxer;
            this.encoderInitialized = true;
        })();
    }
    async flushAndClose() {
        this.checkForEncoderError();
        if (this.customEncoder) {
            this.customEncoderCallSerializer.call(()=>this.customEncoder.flush());
            await this.customEncoderCallSerializer.call(()=>this.customEncoder.close());
        } else if (this.encoder) {
            await this.encoder.flush();
            this.encoder.close();
        }
        this.checkForEncoderError();
    }
    getQueueSize() {
        if (this.customEncoder) return this.customEncoderQueueSize;
        else return this.encoder?.encodeQueueSize ?? 0;
    }
    checkForEncoderError() {
        if (this.encoderError) {
            this.encoderError.stack = new Error().stack; // Provide a more useful stack trace
            throw this.encoderError;
        }
    }
}
class $1c9745b17d341e9e$export$b20157a581909775 extends $1c9745b17d341e9e$export$f3a17123d80000c5 {
    constructor(encodingConfig){
        $1c9745b17d341e9e$var$validateVideoEncodingConfig(encodingConfig);
        super(encodingConfig.codec);
        this._encoder = new $1c9745b17d341e9e$var$VideoEncoderWrapper(this, encodingConfig);
    }
    /**
     * Encodes a video sample (frame) and then adds it to the output.
     *
     * @returns A Promise that resolves once the output is ready to receive more samples. You should await this Promise
     * to respect writer and encoder backpressure.
     */ add(videoSample, encodeOptions) {
        if (!(videoSample instanceof (0, $641b34a2137bac97$export$41944c7dced90f9))) throw new TypeError('videoSample must be a VideoSample.');
        return this._encoder.add(videoSample, false, encodeOptions);
    }
    /** @internal */ _flushAndClose() {
        return this._encoder.flushAndClose();
    }
}
class $1c9745b17d341e9e$export$ca65ccf5708c6a0c extends $1c9745b17d341e9e$export$f3a17123d80000c5 {
    constructor(canvas, encodingConfig){
        if (!(typeof HTMLCanvasElement !== 'undefined' && canvas instanceof HTMLCanvasElement) && !(typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas)) throw new TypeError('canvas must be an HTMLCanvasElement or OffscreenCanvas.');
        $1c9745b17d341e9e$var$validateVideoEncodingConfig(encodingConfig);
        super(encodingConfig.codec);
        this._encoder = new $1c9745b17d341e9e$var$VideoEncoderWrapper(this, encodingConfig);
        this._canvas = canvas;
    }
    /**
     * Captures the current canvas state as a video sample (frame), encodes it and adds it to the output.
     *
     * @param timestamp - The timestamp of the sample, in seconds.
     * @param duration - The duration of the sample, in seconds.
     *
     * @returns A Promise that resolves once the output is ready to receive more samples. You should await this Promise
     * to respect writer and encoder backpressure.
     */ add(timestamp, duration = 0, encodeOptions) {
        if (!Number.isFinite(timestamp) || timestamp < 0) throw new TypeError('timestamp must be a non-negative number.');
        if (!Number.isFinite(duration) || duration < 0) throw new TypeError('duration must be a non-negative number.');
        const sample = new (0, $641b34a2137bac97$export$41944c7dced90f9)(this._canvas, {
            timestamp: timestamp,
            duration: duration
        });
        return this._encoder.add(sample, true, encodeOptions);
    }
    /** @internal */ _flushAndClose() {
        return this._encoder.flushAndClose();
    }
}
class $1c9745b17d341e9e$export$32b714f15fd74a9d extends $1c9745b17d341e9e$export$f3a17123d80000c5 {
    constructor(track, encodingConfig){
        if (!(track instanceof MediaStreamTrack) || track.kind !== 'video') throw new TypeError('track must be a video MediaStreamTrack.');
        $1c9745b17d341e9e$var$validateVideoEncodingConfig(encodingConfig);
        encodingConfig = {
            ...encodingConfig,
            latencyMode: 'realtime'
        };
        super(encodingConfig.codec);
        /** @internal */ this._abortController = null;
        this._encoder = new $1c9745b17d341e9e$var$VideoEncoderWrapper(this, encodingConfig);
        this._track = track;
    }
    /** @internal */ _start() {
        this._abortController = new AbortController();
        let frameReceived = false;
        const processor = new MediaStreamTrackProcessor({
            track: this._track
        });
        const consumer = new WritableStream({
            write: (videoFrame)=>{
                if (!frameReceived) {
                    $1c9745b17d341e9e$var$setMediaStreamTimestampOffset(this, videoFrame);
                    frameReceived = true;
                }
                if (this._encoder.getQueueSize() >= 4) {
                    // Drop frames if the encoder is overloaded
                    videoFrame.close();
                    return;
                }
                this._encoder.add(new (0, $641b34a2137bac97$export$41944c7dced90f9)(videoFrame), true).catch((error)=>{
                    this._abortController?.abort();
                    throw error;
                });
            }
        });
        processor.readable.pipeTo(consumer, {
            signal: this._abortController.signal
        }).catch((err)=>{
            // Handle abort error silently
            if (err instanceof DOMException && err.name === 'AbortError') return;
            // Handle other errors
            console.error('Pipe error:', err);
        });
    }
    /** @internal */ async _flushAndClose() {
        if (this._abortController) {
            this._abortController.abort();
            this._abortController = null;
        }
        await this._encoder.flushAndClose();
    }
}
class $1c9745b17d341e9e$export$2e14a66180fa4af9 extends $1c9745b17d341e9e$export$6de1522d9626320f {
    constructor(codec){
        super();
        /** @internal */ this._connectedTrack = null;
        if (!(0, $94511f4b46249ea3$export$b1442c71888819f2).includes(codec)) throw new TypeError(`Invalid audio codec '${codec}'. Must be one of: ${(0, $94511f4b46249ea3$export$b1442c71888819f2).join(', ')}.`);
        this._codec = codec;
    }
}
class $1c9745b17d341e9e$export$321dfdef61157778 extends $1c9745b17d341e9e$export$2e14a66180fa4af9 {
    constructor(codec){
        super(codec);
    }
    /**
     * Adds an encoded packet to the output audio track.
     *
     * @param meta - Additional metadata from the encoder. You should pass this for the first call, including a valid
     * decoder config.
     *
     * @returns A Promise that resolves once the output is ready to receive more samples. You should await this Promise
     * to respect writer and encoder backpressure.
     */ add(packet, meta) {
        if (!(packet instanceof (0, $8ce8f170cc716e8f$export$2bb25546e7fe690b))) throw new TypeError('packet must be an EncodedPacket.');
        if (packet.isMetadataOnly) throw new TypeError('Metadata-only packets cannot be added.');
        if (meta !== undefined && (!meta || typeof meta !== 'object')) throw new TypeError('meta, when provided, must be an object.');
        this._ensureValidAdd();
        return this._connectedTrack.output._muxer.addEncodedAudioPacket(this._connectedTrack, packet, meta);
    }
}
const $1c9745b17d341e9e$var$validateAudioEncodingConfig = (config)=>{
    if (!config || typeof config !== 'object') throw new TypeError('Encoding config must be an object.');
    if (!(0, $94511f4b46249ea3$export$b1442c71888819f2).includes(config.codec)) throw new TypeError(`Invalid audio codec '${config.codec}'. Must be one of: ${(0, $94511f4b46249ea3$export$b1442c71888819f2).join(', ')}.`);
    if (config.bitrate === undefined && (!(0, $94511f4b46249ea3$export$58c594b1fe7e587b).includes(config.codec) || config.codec === 'flac')) throw new TypeError('config.bitrate must be provided for compressed audio codecs.');
    if (config.bitrate !== undefined && !(config.bitrate instanceof (0, $94511f4b46249ea3$export$b0cc09cfadf17c04)) && (!Number.isInteger(config.bitrate) || config.bitrate <= 0)) throw new TypeError('config.bitrate, when provided, must be a positive integer or a quality.');
    if (config.fullCodecString !== undefined && typeof config.fullCodecString !== 'string') throw new TypeError('config.fullCodecString, when provided, must be a string.');
    if (config.fullCodecString !== undefined && (0, $94511f4b46249ea3$export$6cfcf5d844ba8020)(config.fullCodecString) !== config.codec) throw new TypeError(`config.fullCodecString, when provided, must be a string that matches the specified codec` + ` (${config.codec}).`);
    if (config.onEncodedPacket !== undefined && typeof config.onEncodedPacket !== 'function') throw new TypeError('config.onEncodedChunk, when provided, must be a function.');
    if (config.onEncoderConfig !== undefined && typeof config.onEncoderConfig !== 'function') throw new TypeError('config.onEncoderConfig, when provided, must be a function.');
};
class $1c9745b17d341e9e$var$AudioEncoderWrapper {
    constructor(source, encodingConfig){
        this.source = source;
        this.encodingConfig = encodingConfig;
        this.ensureEncoderPromise = null;
        this.encoderInitialized = false;
        this.encoder = null;
        this.muxer = null;
        this.lastNumberOfChannels = null;
        this.lastSampleRate = null;
        this.isPcmEncoder = false;
        this.outputSampleSize = null;
        this.writeOutputValue = null;
        this.customEncoder = null;
        this.customEncoderCallSerializer = new (0, $053d5bbcf6664967$export$e0e588a18ea3887d)();
        this.customEncoderQueueSize = 0;
        /**
         * Encoders typically throw their errors "out of band", meaning asynchronously in some other execution context.
         * However, we want to surface these errors to the user within the normal control flow, so they don't go uncaught.
         * So, we keep track of the encoder error and throw it as soon as we get the chance.
         */ this.encoderError = null;
    }
    async add(audioSample, shouldClose) {
        this.checkForEncoderError();
        this.source._ensureValidAdd();
        // Ensure audio parameters remain constant
        if (this.lastNumberOfChannels !== null && this.lastSampleRate !== null) {
            if (audioSample.numberOfChannels !== this.lastNumberOfChannels || audioSample.sampleRate !== this.lastSampleRate) throw new Error(`Audio parameters must remain constant. Expected ${this.lastNumberOfChannels} channels at` + ` ${this.lastSampleRate} Hz, got ${audioSample.numberOfChannels} channels at` + ` ${audioSample.sampleRate} Hz.`);
        } else {
            this.lastNumberOfChannels = audioSample.numberOfChannels;
            this.lastSampleRate = audioSample.sampleRate;
        }
        if (!this.encoderInitialized) {
            if (!this.ensureEncoderPromise) this.ensureEncoder(audioSample);
            // No, this "if" statement is not useless. Sometimes, the above call to `ensureEncoder` might have
            // synchronously completed and the encoder is already initialized. In this case, we don't need to await the
            // promise anymore. This also fixes nasty async race condition bugs when multiple code paths are calling
            // this method: It's important that the call that initialized the encoder go through this code first.
            if (!this.encoderInitialized) await this.ensureEncoderPromise;
        }
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.encoderInitialized);
        if (this.customEncoder) {
            this.customEncoderQueueSize++;
            const promise = this.customEncoderCallSerializer.call(()=>this.customEncoder.encode(audioSample)).then(()=>{
                this.customEncoderQueueSize--;
                if (shouldClose) audioSample.close();
            }).catch((error)=>{
                this.encoderError ??= error;
            });
            if (this.customEncoderQueueSize >= 4) await promise;
            await this.muxer.mutex.currentPromise; // Allow the writer to apply backpressure
        } else if (this.isPcmEncoder) await this.doPcmEncoding(audioSample, shouldClose);
        else {
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.encoder);
            const audioData = audioSample.toAudioData();
            this.encoder.encode(audioData);
            audioData.close();
            if (shouldClose) audioSample.close();
            if (this.encoder.encodeQueueSize >= 4) await new Promise((resolve)=>this.encoder.addEventListener('dequeue', resolve, {
                    once: true
                }));
            await this.muxer.mutex.currentPromise; // Allow the writer to apply backpressure
        }
    }
    async doPcmEncoding(audioSample, shouldClose) {
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.outputSampleSize);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.writeOutputValue);
        // Need to extract data from the audio data before we close it
        const { numberOfChannels: numberOfChannels, numberOfFrames: numberOfFrames, sampleRate: sampleRate, timestamp: timestamp } = audioSample;
        const CHUNK_SIZE = 2048;
        const outputs = [];
        // Prepare all of the output buffers, each being bounded by CHUNK_SIZE so we don't generate huge packets
        for(let frame = 0; frame < numberOfFrames; frame += CHUNK_SIZE){
            const frameCount = Math.min(CHUNK_SIZE, audioSample.numberOfFrames - frame);
            const outputSize = frameCount * numberOfChannels * this.outputSampleSize;
            const outputBuffer = new ArrayBuffer(outputSize);
            const outputView = new DataView(outputBuffer);
            outputs.push({
                frameCount: frameCount,
                view: outputView
            });
        }
        const allocationSize = audioSample.allocationSize({
            planeIndex: 0,
            format: 'f32-planar'
        });
        const floats = new Float32Array(allocationSize / Float32Array.BYTES_PER_ELEMENT);
        for(let i = 0; i < numberOfChannels; i++){
            audioSample.copyTo(floats, {
                planeIndex: i,
                format: 'f32-planar'
            });
            for(let j = 0; j < outputs.length; j++){
                const { frameCount: frameCount, view: view } = outputs[j];
                for(let k = 0; k < frameCount; k++)this.writeOutputValue(view, (k * numberOfChannels + i) * this.outputSampleSize, floats[j * CHUNK_SIZE + k]);
            }
        }
        if (shouldClose) audioSample.close();
        const meta = {
            decoderConfig: {
                codec: this.encodingConfig.codec,
                numberOfChannels: numberOfChannels,
                sampleRate: sampleRate
            }
        };
        for(let i = 0; i < outputs.length; i++){
            const { frameCount: frameCount, view: view } = outputs[i];
            const outputBuffer = view.buffer;
            const startFrame = i * CHUNK_SIZE;
            const packet = new (0, $8ce8f170cc716e8f$export$2bb25546e7fe690b)(new Uint8Array(outputBuffer), 'key', timestamp + startFrame / sampleRate, frameCount / sampleRate);
            this.encodingConfig.onEncodedPacket?.(packet, meta);
            await this.muxer.addEncodedAudioPacket(this.source._connectedTrack, packet, meta); // With backpressure
        }
    }
    ensureEncoder(audioSample) {
        if (this.encoderInitialized) return;
        return this.ensureEncoderPromise = (async ()=>{
            const { numberOfChannels: numberOfChannels, sampleRate: sampleRate } = audioSample;
            const bitrate = this.encodingConfig.bitrate instanceof (0, $94511f4b46249ea3$export$b0cc09cfadf17c04) ? this.encodingConfig.bitrate._toAudioBitrate(this.encodingConfig.codec) : this.encodingConfig.bitrate;
            const encoderConfig = {
                codec: this.encodingConfig.fullCodecString ?? (0, $94511f4b46249ea3$export$9ebafb9220dc0b3b)(this.encodingConfig.codec, numberOfChannels, sampleRate),
                numberOfChannels: numberOfChannels,
                sampleRate: sampleRate,
                bitrate: bitrate,
                ...(0, $94511f4b46249ea3$export$32be238875044d9a)(this.encodingConfig.codec)
            };
            this.encodingConfig.onEncoderConfig?.(encoderConfig);
            const MatchingCustomEncoder = (0, $b095dc9cfc0226bb$export$4f4acc973bdec892).find((x)=>x.supports(this.encodingConfig.codec, encoderConfig));
            if (MatchingCustomEncoder) {
                // @ts-expect-error "Can't create instance of abstract class 🤓"
                this.customEncoder = new MatchingCustomEncoder();
                // @ts-expect-error It's technically readonly
                this.customEncoder.codec = this.encodingConfig.codec;
                // @ts-expect-error It's technically readonly
                this.customEncoder.config = encoderConfig;
                // @ts-expect-error It's technically readonly
                this.customEncoder.onPacket = (packet, meta)=>{
                    if (!(packet instanceof (0, $8ce8f170cc716e8f$export$2bb25546e7fe690b))) throw new TypeError('The first argument passed to onPacket must be an EncodedPacket.');
                    if (meta !== undefined && (!meta || typeof meta !== 'object')) throw new TypeError('The second argument passed to onPacket must be an object or undefined.');
                    this.encodingConfig.onEncodedPacket?.(packet, meta);
                    this.muxer.addEncodedAudioPacket(this.source._connectedTrack, packet, meta);
                };
                await this.customEncoder.init();
            } else if ((0, $94511f4b46249ea3$export$58c594b1fe7e587b).includes(this.encodingConfig.codec)) this.initPcmEncoder();
            else {
                if (typeof AudioEncoder === 'undefined') throw new Error('AudioEncoder is not supported by this browser.');
                const support = await AudioEncoder.isConfigSupported(encoderConfig);
                if (!support.supported) throw new Error(`This specific encoder configuration (${encoderConfig.codec}, ${encoderConfig.bitrate} bps,` + ` ${encoderConfig.numberOfChannels} channels, ${encoderConfig.sampleRate} Hz) is not` + ` supported by this browser. Consider using another codec or changing your audio parameters.`);
                this.encoder = new AudioEncoder({
                    output: (chunk, meta)=>{
                        const packet = (0, $8ce8f170cc716e8f$export$2bb25546e7fe690b).fromEncodedChunk(chunk);
                        this.encodingConfig.onEncodedPacket?.(packet, meta);
                        this.muxer.addEncodedAudioPacket(this.source._connectedTrack, packet, meta);
                    },
                    error: (error)=>{
                        this.encoderError ??= error;
                    }
                });
                this.encoder.configure(encoderConfig);
            }
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.source._connectedTrack);
            this.muxer = this.source._connectedTrack.output._muxer;
            this.encoderInitialized = true;
        })();
    }
    initPcmEncoder() {
        this.isPcmEncoder = true;
        const codec = this.encodingConfig.codec;
        const { dataType: dataType, sampleSize: sampleSize, littleEndian: littleEndian } = (0, $94511f4b46249ea3$export$560120a2d4e71dc2)(codec);
        this.outputSampleSize = sampleSize;
        // All these functions receive a float sample as input and map it into the desired format
        switch(sampleSize){
            case 1:
                if (dataType === 'unsigned') this.writeOutputValue = (view, byteOffset, value)=>view.setUint8(byteOffset, (0, $053d5bbcf6664967$export$7d15b64cf5a3a4c4)((value + 1) * 127.5, 0, 255));
                else if (dataType === 'signed') this.writeOutputValue = (view, byteOffset, value)=>{
                    view.setInt8(byteOffset, (0, $053d5bbcf6664967$export$7d15b64cf5a3a4c4)(Math.round(value * 128), -128, 127));
                };
                else if (dataType === 'ulaw') this.writeOutputValue = (view, byteOffset, value)=>{
                    const int16 = (0, $053d5bbcf6664967$export$7d15b64cf5a3a4c4)(Math.floor(value * 32767), -32768, 32767);
                    view.setUint8(byteOffset, (0, $d272c64a25724154$export$c94797cd957a5ca6)(int16));
                };
                else if (dataType === 'alaw') this.writeOutputValue = (view, byteOffset, value)=>{
                    const int16 = (0, $053d5bbcf6664967$export$7d15b64cf5a3a4c4)(Math.floor(value * 32767), -32768, 32767);
                    view.setUint8(byteOffset, (0, $d272c64a25724154$export$bc1dfcaa8798b2f0)(int16));
                };
                else (0, $053d5bbcf6664967$export$a7a9523472993e97)(false);
                break;
            case 2:
                if (dataType === 'unsigned') this.writeOutputValue = (view, byteOffset, value)=>view.setUint16(byteOffset, (0, $053d5bbcf6664967$export$7d15b64cf5a3a4c4)((value + 1) * 32767.5, 0, 65535), littleEndian);
                else if (dataType === 'signed') this.writeOutputValue = (view, byteOffset, value)=>view.setInt16(byteOffset, (0, $053d5bbcf6664967$export$7d15b64cf5a3a4c4)(Math.round(value * 32767), -32768, 32767), littleEndian);
                else (0, $053d5bbcf6664967$export$a7a9523472993e97)(false);
                break;
            case 3:
                if (dataType === 'unsigned') this.writeOutputValue = (view, byteOffset, value)=>(0, $053d5bbcf6664967$export$fab9cd90bc5ef1b8)(view, byteOffset, (0, $053d5bbcf6664967$export$7d15b64cf5a3a4c4)((value + 1) * 8388607.5, 0, 16777215), littleEndian);
                else if (dataType === 'signed') this.writeOutputValue = (view, byteOffset, value)=>(0, $053d5bbcf6664967$export$f80a9546ed30b3d2)(view, byteOffset, (0, $053d5bbcf6664967$export$7d15b64cf5a3a4c4)(Math.round(value * 8388607), -8388608, 8388607), littleEndian);
                else (0, $053d5bbcf6664967$export$a7a9523472993e97)(false);
                break;
            case 4:
                if (dataType === 'unsigned') this.writeOutputValue = (view, byteOffset, value)=>view.setUint32(byteOffset, (0, $053d5bbcf6664967$export$7d15b64cf5a3a4c4)((value + 1) * 2147483647.5, 0, 4294967295), littleEndian);
                else if (dataType === 'signed') this.writeOutputValue = (view, byteOffset, value)=>view.setInt32(byteOffset, (0, $053d5bbcf6664967$export$7d15b64cf5a3a4c4)(Math.round(value * 2147483647), -2147483648, 2147483647), littleEndian);
                else if (dataType === 'float') this.writeOutputValue = (view, byteOffset, value)=>view.setFloat32(byteOffset, value, littleEndian);
                else (0, $053d5bbcf6664967$export$a7a9523472993e97)(false);
                break;
            case 8:
                if (dataType === 'float') this.writeOutputValue = (view, byteOffset, value)=>view.setFloat64(byteOffset, value, littleEndian);
                else (0, $053d5bbcf6664967$export$a7a9523472993e97)(false);
                break;
            default:
                (0, $053d5bbcf6664967$export$cbadc5a7223772a8)(sampleSize);
                (0, $053d5bbcf6664967$export$a7a9523472993e97)(false);
        }
    }
    async flushAndClose() {
        this.checkForEncoderError();
        if (this.customEncoder) {
            this.customEncoderCallSerializer.call(()=>this.customEncoder.flush());
            await this.customEncoderCallSerializer.call(()=>this.customEncoder.close());
        } else if (this.encoder) {
            await this.encoder.flush();
            this.encoder.close();
        }
        this.checkForEncoderError();
    }
    getQueueSize() {
        if (this.customEncoder) return this.customEncoderQueueSize;
        else if (this.isPcmEncoder) return 0;
        else return this.encoder?.encodeQueueSize ?? 0;
    }
    checkForEncoderError() {
        if (this.encoderError) {
            this.encoderError.stack = new Error().stack; // Provide a more useful stack trace
            throw this.encoderError;
        }
    }
}
class $1c9745b17d341e9e$export$96d08e727ce4f142 extends $1c9745b17d341e9e$export$2e14a66180fa4af9 {
    constructor(encodingConfig){
        $1c9745b17d341e9e$var$validateAudioEncodingConfig(encodingConfig);
        super(encodingConfig.codec);
        this._encoder = new $1c9745b17d341e9e$var$AudioEncoderWrapper(this, encodingConfig);
    }
    /**
     * Encodes an audio sample and then adds it to the output.
     *
     * @returns A Promise that resolves once the output is ready to receive more samples. You should await this Promise
     * to respect writer and encoder backpressure.
     */ add(audioSample) {
        if (!(audioSample instanceof (0, $641b34a2137bac97$export$290dedacb3c54314))) throw new TypeError('audioSample must be an AudioSample.');
        return this._encoder.add(audioSample, false);
    }
    /** @internal */ _flushAndClose() {
        return this._encoder.flushAndClose();
    }
}
class $1c9745b17d341e9e$export$94482d12f8cde185 extends $1c9745b17d341e9e$export$2e14a66180fa4af9 {
    constructor(encodingConfig){
        $1c9745b17d341e9e$var$validateAudioEncodingConfig(encodingConfig);
        super(encodingConfig.codec);
        /** @internal */ this._accumulatedFrameCount = 0;
        this._encoder = new $1c9745b17d341e9e$var$AudioEncoderWrapper(this, encodingConfig);
    }
    /**
     * Converts an AudioBuffer to audio samples, encodes them and adds them to the output. The first AudioBuffer will
     * be played at timestamp 0, and any subsequent AudioBuffer will have a timestamp equal to the total duration of
     * all previous AudioBuffers.
     *
     * @returns A Promise that resolves once the output is ready to receive more samples. You should await this Promise
     * to respect writer and encoder backpressure.
     */ add(audioBuffer) {
        if (!(audioBuffer instanceof AudioBuffer)) throw new TypeError('audioBuffer must be an AudioBuffer.');
        const MAX_FLOAT_COUNT = 67108864;
        const numberOfChannels = audioBuffer.numberOfChannels;
        const sampleRate = audioBuffer.sampleRate;
        const totalFrames = audioBuffer.length;
        const maxFramesPerChunk = Math.floor(MAX_FLOAT_COUNT / numberOfChannels);
        let currentRelativeFrame = 0;
        let remainingFrames = totalFrames;
        const promises = [];
        // Create AudioData in a chunked fashion so we don't create huge Float32Arrays
        while(remainingFrames > 0){
            const framesToCopy = Math.min(maxFramesPerChunk, remainingFrames);
            const chunkData = new Float32Array(numberOfChannels * framesToCopy);
            for(let channel = 0; channel < numberOfChannels; channel++)audioBuffer.copyFromChannel(chunkData.subarray(channel * framesToCopy, channel * framesToCopy + framesToCopy), channel, currentRelativeFrame);
            const audioSample = new (0, $641b34a2137bac97$export$290dedacb3c54314)({
                format: 'f32-planar',
                sampleRate: sampleRate,
                numberOfFrames: framesToCopy,
                numberOfChannels: numberOfChannels,
                timestamp: (this._accumulatedFrameCount + currentRelativeFrame) / sampleRate,
                data: chunkData
            });
            promises.push(this._encoder.add(audioSample, true));
            currentRelativeFrame += framesToCopy;
            remainingFrames -= framesToCopy;
        }
        this._accumulatedFrameCount += totalFrames;
        return Promise.all(promises);
    }
    /** @internal */ _flushAndClose() {
        return this._encoder.flushAndClose();
    }
}
class $1c9745b17d341e9e$export$e991747f146543b3 extends $1c9745b17d341e9e$export$2e14a66180fa4af9 {
    constructor(track, encodingConfig){
        if (!(track instanceof MediaStreamTrack) || track.kind !== 'audio') throw new TypeError('track must be an audio MediaStreamTrack.');
        $1c9745b17d341e9e$var$validateAudioEncodingConfig(encodingConfig);
        super(encodingConfig.codec);
        /** @internal */ this._abortController = null;
        this._encoder = new $1c9745b17d341e9e$var$AudioEncoderWrapper(this, encodingConfig);
        this._track = track;
    }
    /** @internal */ _start() {
        this._abortController = new AbortController();
        let dataReceived = false;
        const processor = new MediaStreamTrackProcessor({
            track: this._track
        });
        const consumer = new WritableStream({
            write: (audioData)=>{
                if (!dataReceived) {
                    $1c9745b17d341e9e$var$setMediaStreamTimestampOffset(this, audioData);
                    dataReceived = true;
                }
                if (this._encoder.getQueueSize() >= 4) {
                    // Drop data if the encoder is overloaded
                    audioData.close();
                    return;
                }
                this._encoder.add(new (0, $641b34a2137bac97$export$290dedacb3c54314)(audioData), true).catch((error)=>{
                    this._abortController?.abort();
                    throw error;
                });
            }
        });
        processor.readable.pipeTo(consumer, {
            signal: this._abortController.signal
        }).catch((err)=>{
            // Handle abort error silently
            if (err instanceof DOMException && err.name === 'AbortError') return;
            // Handle other errors
            console.error('Pipe error:', err);
        });
    }
    /** @internal */ async _flushAndClose() {
        if (this._abortController) {
            this._abortController.abort();
            this._abortController = null;
        }
        await this._encoder.flushAndClose();
    }
}
const $1c9745b17d341e9e$var$setMediaStreamTimestampOffset = (source, sample)=>{
    const timestampInSeconds = sample.timestamp / 1e6;
    (0, $053d5bbcf6664967$export$a7a9523472993e97)(source._connectedTrack);
    const muxer = source._connectedTrack.output._muxer;
    if (muxer.firstMediaStreamTimestamp === null) // We're the first MediaStreamTrack of this output to receive data
    muxer.firstMediaStreamTimestamp = timestampInSeconds;
    // Math.min to ensure the timestamps can't get negative
    source._timestampOffset = -Math.min(muxer.firstMediaStreamTimestamp, timestampInSeconds);
};
class $1c9745b17d341e9e$export$472e8680c39d652a extends $1c9745b17d341e9e$export$6de1522d9626320f {
    constructor(codec){
        super();
        /** @internal */ this._connectedTrack = null;
        if (!(0, $94511f4b46249ea3$export$422db9d40fc02e83).includes(codec)) throw new TypeError(`Invalid subtitle codec '${codec}'. Must be one of: ${(0, $94511f4b46249ea3$export$422db9d40fc02e83).join(', ')}.`);
        this._codec = codec;
    }
}
class $1c9745b17d341e9e$export$2d7d8e71ce4929b3 extends $1c9745b17d341e9e$export$472e8680c39d652a {
    constructor(codec){
        super(codec);
        this._parser = new (0, $c77d4d874d58660e$export$767933ebd734b1bc)({
            codec: codec,
            output: (cue, metadata)=>this._connectedTrack?.output._muxer.addSubtitleCue(this._connectedTrack, cue, metadata)
        });
    }
    /**
     * Parses the subtitle text according to the specified codec and adds it to the output track. You don't have to
     * add the entire subtitle file at once here; you can provide it in chunks.
     *
     * @returns A Promise that resolves once the output is ready to receive more samples. You should await this Promise
     * to respect writer and encoder backpressure.
     */ add(text) {
        if (typeof text !== 'string') throw new TypeError('text must be a string.');
        this._ensureValidAdd();
        this._parser.parse(text);
        return this._connectedTrack.output._muxer.mutex.currentPromise;
    }
}

/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ 
/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ /*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ 



/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ 

// References for AVC/HEVC code:
// ISO 14496-15
// Rec. ITU-T H.264
// Rec. ITU-T H.265
// https://stackoverflow.com/questions/24884827
/** Finds all NAL units in an AVC packet in Annex B format. */ const $e4e81989f7ab3f4b$var$findNalUnitsInAnnexB = (packetData)=>{
    const nalUnits = [];
    let i = 0;
    while(i < packetData.length){
        let startCodePos = -1;
        let startCodeLength = 0;
        for(let j = i; j < packetData.length - 3; j++){
            // Check for 3-byte start code (0x000001)
            if (packetData[j] === 0 && packetData[j + 1] === 0 && packetData[j + 2] === 1) {
                startCodePos = j;
                startCodeLength = 3;
                break;
            }
            // Check for 4-byte start code (0x00000001)
            if (j < packetData.length - 4 && packetData[j] === 0 && packetData[j + 1] === 0 && packetData[j + 2] === 0 && packetData[j + 3] === 1) {
                startCodePos = j;
                startCodeLength = 4;
                break;
            }
        }
        if (startCodePos === -1) break; // No more start codes found
        // If this isn't the first start code, extract the previous NAL unit
        if (i > 0 && startCodePos > i) {
            const nalData = packetData.subarray(i, startCodePos);
            if (nalData.length > 0) nalUnits.push(nalData);
        }
        i = startCodePos + startCodeLength;
    }
    // Extract the last NAL unit if there is one
    if (i < packetData.length) {
        const nalData = packetData.subarray(i);
        if (nalData.length > 0) nalUnits.push(nalData);
    }
    return nalUnits;
};
const $e4e81989f7ab3f4b$var$removeEmulationPreventionBytes = (data)=>{
    const result = [];
    const len = data.length;
    for(let i = 0; i < len; i++)// Look for the 0x000003 pattern
    if (i + 2 < len && data[i] === 0x00 && data[i + 1] === 0x00 && data[i + 2] === 0x03) {
        result.push(0x00, 0x00); // Push the first two bytes
        i += 2; // Skip the 0x03 byte
    } else result.push(data[i]);
    return new Uint8Array(result);
};
const $e4e81989f7ab3f4b$export$47d7308d95e7dd68 = (packetData)=>{
    const NAL_UNIT_LENGTH_SIZE = 4;
    const nalUnits = $e4e81989f7ab3f4b$var$findNalUnitsInAnnexB(packetData);
    if (nalUnits.length === 0) // If no NAL units were found, it's not valid Annex B data
    return null;
    let totalSize = 0;
    for (const nalUnit of nalUnits)totalSize += NAL_UNIT_LENGTH_SIZE + nalUnit.byteLength;
    const avccData = new Uint8Array(totalSize);
    const dataView = new DataView(avccData.buffer);
    let offset = 0;
    // Write each NAL unit with its length prefix
    for (const nalUnit of nalUnits){
        const length = nalUnit.byteLength;
        dataView.setUint32(offset, length, false);
        offset += 4;
        avccData.set(nalUnit, offset);
        offset += nalUnit.byteLength;
    }
    return avccData;
};
const $e4e81989f7ab3f4b$var$extractNalUnitTypeForAvc = (data)=>{
    return data[0] & 0x1F;
};
const $e4e81989f7ab3f4b$export$5170fc4926a4cd0d = (packetData)=>{
    try {
        const nalUnits = $e4e81989f7ab3f4b$var$findNalUnitsInAnnexB(packetData);
        const spsUnits = nalUnits.filter((unit)=>$e4e81989f7ab3f4b$var$extractNalUnitTypeForAvc(unit) === 7);
        const ppsUnits = nalUnits.filter((unit)=>$e4e81989f7ab3f4b$var$extractNalUnitTypeForAvc(unit) === 8);
        const spsExtUnits = nalUnits.filter((unit)=>$e4e81989f7ab3f4b$var$extractNalUnitTypeForAvc(unit) === 13);
        if (spsUnits.length === 0) return null;
        if (ppsUnits.length === 0) return null;
        // Let's get the first SPS for profile and level information
        const spsData = spsUnits[0];
        const bitstream = new (0, $053d5bbcf6664967$export$d16e6594b36c3ef7)($e4e81989f7ab3f4b$var$removeEmulationPreventionBytes(spsData));
        bitstream.skipBits(1); // forbidden_zero_bit
        bitstream.skipBits(2); // nal_ref_idc
        const nal_unit_type = bitstream.readBits(5);
        if (nal_unit_type !== 7) {
            console.error('Invalid SPS NAL unit type');
            return null;
        }
        const profile_idc = bitstream.readAlignedByte();
        const constraint_flags = bitstream.readAlignedByte();
        const level_idc = bitstream.readAlignedByte();
        const record = {
            configurationVersion: 1,
            avcProfileIndication: profile_idc,
            profileCompatibility: constraint_flags,
            avcLevelIndication: level_idc,
            lengthSizeMinusOne: 3,
            sequenceParameterSets: spsUnits,
            pictureParameterSets: ppsUnits,
            chromaFormat: null,
            bitDepthLumaMinus8: null,
            bitDepthChromaMinus8: null,
            sequenceParameterSetExt: null
        };
        if (profile_idc === 100 || profile_idc === 110 || profile_idc === 122 || profile_idc === 144) {
            (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // seq_parameter_set_id
            const chroma_format_idc = (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream);
            if (chroma_format_idc === 3) bitstream.skipBits(1); // separate_colour_plane_flag
            const bit_depth_luma_minus8 = (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream);
            const bit_depth_chroma_minus8 = (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream);
            record.chromaFormat = chroma_format_idc;
            record.bitDepthLumaMinus8 = bit_depth_luma_minus8;
            record.bitDepthChromaMinus8 = bit_depth_chroma_minus8;
            record.sequenceParameterSetExt = spsExtUnits;
        }
        return record;
    } catch (error) {
        console.error('Error building AVC Decoder Configuration Record:', error);
        return null;
    }
};
const $e4e81989f7ab3f4b$export$82eb60e9f42d6ca8 = (record)=>{
    const bytes = [];
    // Write header
    bytes.push(record.configurationVersion);
    bytes.push(record.avcProfileIndication);
    bytes.push(record.profileCompatibility);
    bytes.push(record.avcLevelIndication);
    bytes.push(0xFC | record.lengthSizeMinusOne & 0x03); // Reserved bits (6) + lengthSizeMinusOne (2)
    // Reserved bits (3) + numOfSequenceParameterSets (5)
    bytes.push(0xE0 | record.sequenceParameterSets.length & 0x1F);
    // Write SPS
    for (const sps of record.sequenceParameterSets){
        const length = sps.byteLength;
        bytes.push(length >> 8); // High byte
        bytes.push(length & 0xFF); // Low byte
        for(let i = 0; i < length; i++)bytes.push(sps[i]);
    }
    bytes.push(record.pictureParameterSets.length);
    // Write PPS
    for (const pps of record.pictureParameterSets){
        const length = pps.byteLength;
        bytes.push(length >> 8); // High byte
        bytes.push(length & 0xFF); // Low byte
        for(let i = 0; i < length; i++)bytes.push(pps[i]);
    }
    if (record.avcProfileIndication === 100 || record.avcProfileIndication === 110 || record.avcProfileIndication === 122 || record.avcProfileIndication === 144) {
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(record.chromaFormat !== null);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(record.bitDepthLumaMinus8 !== null);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(record.bitDepthChromaMinus8 !== null);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(record.sequenceParameterSetExt !== null);
        bytes.push(0xFC | record.chromaFormat & 0x03); // Reserved bits + chroma_format
        bytes.push(0xF8 | record.bitDepthLumaMinus8 & 0x07); // Reserved bits + bit_depth_luma_minus8
        bytes.push(0xF8 | record.bitDepthChromaMinus8 & 0x07); // Reserved bits + bit_depth_chroma_minus8
        bytes.push(record.sequenceParameterSetExt.length);
        // Write SPS Ext
        for (const spsExt of record.sequenceParameterSetExt){
            const length = spsExt.byteLength;
            bytes.push(length >> 8); // High byte
            bytes.push(length & 0xFF); // Low byte
            for(let i = 0; i < length; i++)bytes.push(spsExt[i]);
        }
    }
    return new Uint8Array(bytes);
};
const $e4e81989f7ab3f4b$var$NALU_TYPE_VPS = 32;
const $e4e81989f7ab3f4b$var$NALU_TYPE_SPS = 33;
const $e4e81989f7ab3f4b$var$NALU_TYPE_PPS = 34;
const $e4e81989f7ab3f4b$var$NALU_TYPE_SEI_PREFIX = 39;
const $e4e81989f7ab3f4b$var$NALU_TYPE_SEI_SUFFIX = 40;
const $e4e81989f7ab3f4b$var$extractNalUnitTypeForHevc = (data)=>{
    return data[0] >> 1 & 0x3F;
};
const $e4e81989f7ab3f4b$export$8d721713e0db20f0 = (packetData)=>{
    try {
        const nalUnits = $e4e81989f7ab3f4b$var$findNalUnitsInAnnexB(packetData);
        const vpsUnits = nalUnits.filter((unit)=>$e4e81989f7ab3f4b$var$extractNalUnitTypeForHevc(unit) === $e4e81989f7ab3f4b$var$NALU_TYPE_VPS);
        const spsUnits = nalUnits.filter((unit)=>$e4e81989f7ab3f4b$var$extractNalUnitTypeForHevc(unit) === $e4e81989f7ab3f4b$var$NALU_TYPE_SPS);
        const ppsUnits = nalUnits.filter((unit)=>$e4e81989f7ab3f4b$var$extractNalUnitTypeForHevc(unit) === $e4e81989f7ab3f4b$var$NALU_TYPE_PPS);
        const seiUnits = nalUnits.filter((unit)=>$e4e81989f7ab3f4b$var$extractNalUnitTypeForHevc(unit) === $e4e81989f7ab3f4b$var$NALU_TYPE_SEI_PREFIX || $e4e81989f7ab3f4b$var$extractNalUnitTypeForHevc(unit) === $e4e81989f7ab3f4b$var$NALU_TYPE_SEI_SUFFIX);
        if (spsUnits.length === 0 || ppsUnits.length === 0) return null;
        const sps = spsUnits[0];
        const bitstream = new (0, $053d5bbcf6664967$export$d16e6594b36c3ef7)($e4e81989f7ab3f4b$var$removeEmulationPreventionBytes(sps));
        bitstream.skipBits(16); // NAL header
        bitstream.readBits(4); // sps_video_parameter_set_id
        const sps_max_sub_layers_minus1 = bitstream.readBits(3);
        const sps_temporal_id_nesting_flag = bitstream.readBits(1);
        const { general_profile_space: general_profile_space, general_tier_flag: general_tier_flag, general_profile_idc: general_profile_idc, general_profile_compatibility_flags: general_profile_compatibility_flags, general_constraint_indicator_flags: general_constraint_indicator_flags, general_level_idc: general_level_idc } = $e4e81989f7ab3f4b$var$parseProfileTierLevel(bitstream, sps_max_sub_layers_minus1);
        (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // sps_seq_parameter_set_id
        const chroma_format_idc = (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream);
        if (chroma_format_idc === 3) bitstream.skipBits(1); // separate_colour_plane_flag
        (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // pic_width_in_luma_samples
        (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // pic_height_in_luma_samples
        if (bitstream.readBits(1)) {
            (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // conf_win_left_offset
            (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // conf_win_right_offset
            (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // conf_win_top_offset
            (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // conf_win_bottom_offset
        }
        const bit_depth_luma_minus8 = (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream);
        const bit_depth_chroma_minus8 = (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream);
        (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // log2_max_pic_order_cnt_lsb_minus4
        const sps_sub_layer_ordering_info_present_flag = bitstream.readBits(1);
        const maxNum = sps_sub_layer_ordering_info_present_flag ? 0 : sps_max_sub_layers_minus1;
        for(let i = maxNum; i <= sps_max_sub_layers_minus1; i++){
            (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // sps_max_dec_pic_buffering_minus1[i]
            (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // sps_max_num_reorder_pics[i]
            (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // sps_max_latency_increase_plus1[i]
        }
        (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // log2_min_luma_coding_block_size_minus3
        (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // log2_diff_max_min_luma_coding_block_size
        (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // log2_min_luma_transform_block_size_minus2
        (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // log2_diff_max_min_luma_transform_block_size
        (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // max_transform_hierarchy_depth_inter
        (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // max_transform_hierarchy_depth_intra
        if (bitstream.readBits(1)) {
            if (bitstream.readBits(1)) $e4e81989f7ab3f4b$var$skipScalingListData(bitstream);
        }
        bitstream.skipBits(1); // amp_enabled_flag
        bitstream.skipBits(1); // sample_adaptive_offset_enabled_flag
        if (bitstream.readBits(1)) {
            bitstream.skipBits(4); // pcm_sample_bit_depth_luma_minus1
            bitstream.skipBits(4); // pcm_sample_bit_depth_chroma_minus1
            (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // log2_min_pcm_luma_coding_block_size_minus3
            (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // log2_diff_max_min_pcm_luma_coding_block_size
            bitstream.skipBits(1); // pcm_loop_filter_disabled_flag
        }
        const num_short_term_ref_pic_sets = (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream);
        $e4e81989f7ab3f4b$var$skipAllStRefPicSets(bitstream, num_short_term_ref_pic_sets);
        if (bitstream.readBits(1)) {
            const num_long_term_ref_pics_sps = (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream);
            for(let i = 0; i < num_long_term_ref_pics_sps; i++){
                (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // lt_ref_pic_poc_lsb_sps[i]
                bitstream.skipBits(1); // used_by_curr_pic_lt_sps_flag[i]
            }
        }
        bitstream.skipBits(1); // sps_temporal_mvp_enabled_flag
        bitstream.skipBits(1); // strong_intra_smoothing_enabled_flag
        let min_spatial_segmentation_idc = 0;
        if (bitstream.readBits(1)) min_spatial_segmentation_idc = $e4e81989f7ab3f4b$var$parseVuiForMinSpatialSegmentationIdc(bitstream, sps_max_sub_layers_minus1);
        // Parse PPS for parallelismType
        let parallelismType = 0;
        if (ppsUnits.length > 0) {
            const pps = ppsUnits[0];
            const ppsBitstream = new (0, $053d5bbcf6664967$export$d16e6594b36c3ef7)($e4e81989f7ab3f4b$var$removeEmulationPreventionBytes(pps));
            ppsBitstream.skipBits(16); // NAL header
            (0, $053d5bbcf6664967$export$500cd5ed364299e5)(ppsBitstream); // pps_pic_parameter_set_id
            (0, $053d5bbcf6664967$export$500cd5ed364299e5)(ppsBitstream); // pps_seq_parameter_set_id
            ppsBitstream.skipBits(1); // dependent_slice_segments_enabled_flag
            ppsBitstream.skipBits(1); // output_flag_present_flag
            ppsBitstream.skipBits(3); // num_extra_slice_header_bits
            ppsBitstream.skipBits(1); // sign_data_hiding_enabled_flag
            ppsBitstream.skipBits(1); // cabac_init_present_flag
            (0, $053d5bbcf6664967$export$500cd5ed364299e5)(ppsBitstream); // num_ref_idx_l0_default_active_minus1
            (0, $053d5bbcf6664967$export$500cd5ed364299e5)(ppsBitstream); // num_ref_idx_l1_default_active_minus1
            (0, $053d5bbcf6664967$export$a3b63e900e78c883)(ppsBitstream); // init_qp_minus26
            ppsBitstream.skipBits(1); // constrained_intra_pred_flag
            ppsBitstream.skipBits(1); // transform_skip_enabled_flag
            if (ppsBitstream.readBits(1)) (0, $053d5bbcf6664967$export$500cd5ed364299e5)(ppsBitstream); // diff_cu_qp_delta_depth
            (0, $053d5bbcf6664967$export$a3b63e900e78c883)(ppsBitstream); // pps_cb_qp_offset
            (0, $053d5bbcf6664967$export$a3b63e900e78c883)(ppsBitstream); // pps_cr_qp_offset
            ppsBitstream.skipBits(1); // pps_slice_chroma_qp_offsets_present_flag
            ppsBitstream.skipBits(1); // weighted_pred_flag
            ppsBitstream.skipBits(1); // weighted_bipred_flag
            ppsBitstream.skipBits(1); // transquant_bypass_enabled_flag
            const tiles_enabled_flag = ppsBitstream.readBits(1);
            const entropy_coding_sync_enabled_flag = ppsBitstream.readBits(1);
            if (!tiles_enabled_flag && !entropy_coding_sync_enabled_flag) parallelismType = 0;
            else if (tiles_enabled_flag && !entropy_coding_sync_enabled_flag) parallelismType = 2;
            else if (!tiles_enabled_flag && entropy_coding_sync_enabled_flag) parallelismType = 3;
            else parallelismType = 0;
        }
        const arrays = [
            ...vpsUnits.length ? [
                {
                    arrayCompleteness: 1,
                    nalUnitType: $e4e81989f7ab3f4b$var$NALU_TYPE_VPS,
                    nalUnits: vpsUnits
                }
            ] : [],
            ...spsUnits.length ? [
                {
                    arrayCompleteness: 1,
                    nalUnitType: $e4e81989f7ab3f4b$var$NALU_TYPE_SPS,
                    nalUnits: spsUnits
                }
            ] : [],
            ...ppsUnits.length ? [
                {
                    arrayCompleteness: 1,
                    nalUnitType: $e4e81989f7ab3f4b$var$NALU_TYPE_PPS,
                    nalUnits: ppsUnits
                }
            ] : [],
            ...seiUnits.length ? [
                {
                    arrayCompleteness: 1,
                    nalUnitType: $e4e81989f7ab3f4b$var$extractNalUnitTypeForHevc(seiUnits[0]),
                    nalUnits: seiUnits
                }
            ] : []
        ];
        const record = {
            configurationVersion: 1,
            generalProfileSpace: general_profile_space,
            generalTierFlag: general_tier_flag,
            generalProfileIdc: general_profile_idc,
            generalProfileCompatibilityFlags: general_profile_compatibility_flags,
            generalConstraintIndicatorFlags: general_constraint_indicator_flags,
            generalLevelIdc: general_level_idc,
            minSpatialSegmentationIdc: min_spatial_segmentation_idc,
            parallelismType: parallelismType,
            chromaFormatIdc: chroma_format_idc,
            bitDepthLumaMinus8: bit_depth_luma_minus8,
            bitDepthChromaMinus8: bit_depth_chroma_minus8,
            avgFrameRate: 0,
            constantFrameRate: 0,
            numTemporalLayers: sps_max_sub_layers_minus1 + 1,
            temporalIdNested: sps_temporal_id_nesting_flag,
            lengthSizeMinusOne: 3,
            arrays: arrays
        };
        return record;
    } catch (error) {
        console.error('Error building HEVC Decoder Configuration Record:', error);
        return null;
    }
};
const $e4e81989f7ab3f4b$var$parseProfileTierLevel = (bitstream, maxNumSubLayersMinus1)=>{
    const general_profile_space = bitstream.readBits(2);
    const general_tier_flag = bitstream.readBits(1);
    const general_profile_idc = bitstream.readBits(5);
    let general_profile_compatibility_flags = 0;
    for(let i = 0; i < 32; i++)general_profile_compatibility_flags = general_profile_compatibility_flags << 1 | bitstream.readBits(1);
    const general_constraint_indicator_flags = new Uint8Array(6);
    for(let i = 0; i < 6; i++)general_constraint_indicator_flags[i] = bitstream.readBits(8);
    const general_level_idc = bitstream.readBits(8);
    const sub_layer_profile_present_flag = [];
    const sub_layer_level_present_flag = [];
    for(let i = 0; i < maxNumSubLayersMinus1; i++){
        sub_layer_profile_present_flag.push(bitstream.readBits(1));
        sub_layer_level_present_flag.push(bitstream.readBits(1));
    }
    if (maxNumSubLayersMinus1 > 0) for(let i = maxNumSubLayersMinus1; i < 8; i++)bitstream.skipBits(2); // reserved_zero_2bits
    for(let i = 0; i < maxNumSubLayersMinus1; i++){
        if (sub_layer_profile_present_flag[i]) bitstream.skipBits(88);
        if (sub_layer_level_present_flag[i]) bitstream.skipBits(8);
    }
    return {
        general_profile_space: general_profile_space,
        general_tier_flag: general_tier_flag,
        general_profile_idc: general_profile_idc,
        general_profile_compatibility_flags: general_profile_compatibility_flags,
        general_constraint_indicator_flags: general_constraint_indicator_flags,
        general_level_idc: general_level_idc
    };
};
const $e4e81989f7ab3f4b$var$skipScalingListData = (bitstream)=>{
    for(let sizeId = 0; sizeId < 4; sizeId++)for(let matrixId = 0; matrixId < (sizeId === 3 ? 2 : 6); matrixId++){
        const scaling_list_pred_mode_flag = bitstream.readBits(1);
        if (!scaling_list_pred_mode_flag) (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // scaling_list_pred_matrix_id_delta
        else {
            const coefNum = Math.min(64, 1 << 4 + (sizeId << 1));
            if (sizeId > 1) (0, $053d5bbcf6664967$export$a3b63e900e78c883)(bitstream); // scaling_list_dc_coef_minus8
            for(let i = 0; i < coefNum; i++)(0, $053d5bbcf6664967$export$a3b63e900e78c883)(bitstream); // scaling_list_delta_coef
        }
    }
};
const $e4e81989f7ab3f4b$var$skipAllStRefPicSets = (bitstream, num_short_term_ref_pic_sets)=>{
    const NumDeltaPocs = [];
    for(let stRpsIdx = 0; stRpsIdx < num_short_term_ref_pic_sets; stRpsIdx++)NumDeltaPocs[stRpsIdx] = $e4e81989f7ab3f4b$var$skipStRefPicSet(bitstream, stRpsIdx, num_short_term_ref_pic_sets, NumDeltaPocs);
};
const $e4e81989f7ab3f4b$var$skipStRefPicSet = (bitstream, stRpsIdx, num_short_term_ref_pic_sets, NumDeltaPocs)=>{
    let NumDeltaPocsThis = 0;
    let inter_ref_pic_set_prediction_flag = 0;
    let RefRpsIdx = 0;
    if (stRpsIdx !== 0) inter_ref_pic_set_prediction_flag = bitstream.readBits(1);
    if (inter_ref_pic_set_prediction_flag) {
        if (stRpsIdx === num_short_term_ref_pic_sets) {
            const delta_idx_minus1 = (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream);
            RefRpsIdx = stRpsIdx - (delta_idx_minus1 + 1);
        } else RefRpsIdx = stRpsIdx - 1;
        bitstream.readBits(1); // delta_rps_sign
        (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // abs_delta_rps_minus1
        // The number of iterations is NumDeltaPocs[RefRpsIdx] + 1
        const numDelta = NumDeltaPocs[RefRpsIdx] ?? 0;
        for(let j = 0; j <= numDelta; j++){
            const used_by_curr_pic_flag = bitstream.readBits(1);
            if (!used_by_curr_pic_flag) bitstream.readBits(1); // use_delta_flag
        }
        NumDeltaPocsThis = NumDeltaPocs[RefRpsIdx];
    } else {
        const num_negative_pics = (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream);
        const num_positive_pics = (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream);
        for(let i = 0; i < num_negative_pics; i++){
            (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // delta_poc_s0_minus1[i]
            bitstream.readBits(1); // used_by_curr_pic_s0_flag[i]
        }
        for(let i = 0; i < num_positive_pics; i++){
            (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // delta_poc_s1_minus1[i]
            bitstream.readBits(1); // used_by_curr_pic_s1_flag[i]
        }
        NumDeltaPocsThis = num_negative_pics + num_positive_pics;
    }
    return NumDeltaPocsThis;
};
const $e4e81989f7ab3f4b$var$parseVuiForMinSpatialSegmentationIdc = (bitstream, sps_max_sub_layers_minus1)=>{
    if (bitstream.readBits(1)) {
        const aspect_ratio_idc = bitstream.readBits(8);
        if (aspect_ratio_idc === 255) {
            bitstream.readBits(16); // sar_width
            bitstream.readBits(16); // sar_height
        }
    }
    if (bitstream.readBits(1)) bitstream.readBits(1); // overscan_appropriate_flag
    if (bitstream.readBits(1)) {
        bitstream.readBits(3); // video_format
        bitstream.readBits(1); // video_full_range_flag
        if (bitstream.readBits(1)) {
            bitstream.readBits(8); // colour_primaries
            bitstream.readBits(8); // transfer_characteristics
            bitstream.readBits(8); // matrix_coeffs
        }
    }
    if (bitstream.readBits(1)) {
        (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // chroma_sample_loc_type_top_field
        (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // chroma_sample_loc_type_bottom_field
    }
    bitstream.readBits(1); // neutral_chroma_indication_flag
    bitstream.readBits(1); // field_seq_flag
    bitstream.readBits(1); // frame_field_info_present_flag
    if (bitstream.readBits(1)) {
        (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // def_disp_win_left_offset
        (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // def_disp_win_right_offset
        (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // def_disp_win_top_offset
        (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // def_disp_win_bottom_offset
    }
    if (bitstream.readBits(1)) {
        bitstream.readBits(32); // vui_num_units_in_tick
        bitstream.readBits(32); // vui_time_scale
        if (bitstream.readBits(1)) (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // vui_num_ticks_poc_diff_one_minus1
        if (bitstream.readBits(1)) $e4e81989f7ab3f4b$var$skipHrdParameters(bitstream, true, sps_max_sub_layers_minus1);
    }
    if (bitstream.readBits(1)) {
        bitstream.readBits(1); // tiles_fixed_structure_flag
        bitstream.readBits(1); // motion_vectors_over_pic_boundaries_flag
        bitstream.readBits(1); // restricted_ref_pic_lists_flag
        const min_spatial_segmentation_idc = (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream);
        // skip the rest
        (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // max_bytes_per_pic_denom
        (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // max_bits_per_min_cu_denom
        (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // log2_max_mv_length_horizontal
        (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // log2_max_mv_length_vertical
        return min_spatial_segmentation_idc;
    }
    return 0;
};
const $e4e81989f7ab3f4b$var$skipHrdParameters = (bitstream, commonInfPresentFlag, maxNumSubLayersMinus1)=>{
    let nal_hrd_parameters_present_flag = false;
    let vcl_hrd_parameters_present_flag = false;
    let sub_pic_hrd_params_present_flag = false;
    if (commonInfPresentFlag) {
        nal_hrd_parameters_present_flag = bitstream.readBits(1) === 1;
        vcl_hrd_parameters_present_flag = bitstream.readBits(1) === 1;
        if (nal_hrd_parameters_present_flag || vcl_hrd_parameters_present_flag) {
            sub_pic_hrd_params_present_flag = bitstream.readBits(1) === 1;
            if (sub_pic_hrd_params_present_flag) {
                bitstream.readBits(8); // tick_divisor_minus2
                bitstream.readBits(5); // du_cpb_removal_delay_increment_length_minus1
                bitstream.readBits(1); // sub_pic_cpb_params_in_pic_timing_sei_flag
                bitstream.readBits(5); // dpb_output_delay_du_length_minus1
            }
            bitstream.readBits(4); // bit_rate_scale
            bitstream.readBits(4); // cpb_size_scale
            if (sub_pic_hrd_params_present_flag) bitstream.readBits(4); // cpb_size_du_scale
            bitstream.readBits(5); // initial_cpb_removal_delay_length_minus1
            bitstream.readBits(5); // au_cpb_removal_delay_length_minus1
            bitstream.readBits(5); // dpb_output_delay_length_minus1
        }
    }
    for(let i = 0; i <= maxNumSubLayersMinus1; i++){
        const fixed_pic_rate_general_flag = bitstream.readBits(1) === 1;
        let fixed_pic_rate_within_cvs_flag = true; // Default assumption if general is true
        if (!fixed_pic_rate_general_flag) fixed_pic_rate_within_cvs_flag = bitstream.readBits(1) === 1;
        let low_delay_hrd_flag = false; // Default assumption
        if (fixed_pic_rate_within_cvs_flag) (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // elemental_duration_in_tc_minus1[i]
        else low_delay_hrd_flag = bitstream.readBits(1) === 1;
        let CpbCnt = 1; // Default if low_delay is true
        if (!low_delay_hrd_flag) {
            const cpb_cnt_minus1 = (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // cpb_cnt_minus1[i]
            CpbCnt = cpb_cnt_minus1 + 1;
        }
        if (nal_hrd_parameters_present_flag) $e4e81989f7ab3f4b$var$skipSubLayerHrdParameters(bitstream, CpbCnt, sub_pic_hrd_params_present_flag);
        if (vcl_hrd_parameters_present_flag) $e4e81989f7ab3f4b$var$skipSubLayerHrdParameters(bitstream, CpbCnt, sub_pic_hrd_params_present_flag);
    }
};
const $e4e81989f7ab3f4b$var$skipSubLayerHrdParameters = (bitstream, CpbCnt, sub_pic_hrd_params_present_flag)=>{
    for(let i = 0; i < CpbCnt; i++){
        (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // bit_rate_value_minus1[i]
        (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // cpb_size_value_minus1[i]
        if (sub_pic_hrd_params_present_flag) {
            (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // cpb_size_du_value_minus1[i]
            (0, $053d5bbcf6664967$export$500cd5ed364299e5)(bitstream); // bit_rate_du_value_minus1[i]
        }
        bitstream.readBits(1); // cbr_flag[i]
    }
};
const $e4e81989f7ab3f4b$export$5681eb4508de93bf = (record)=>{
    const bytes = [];
    bytes.push(record.configurationVersion);
    bytes.push((record.generalProfileSpace & 0x3) << 6 | (record.generalTierFlag & 0x1) << 5 | record.generalProfileIdc & 0x1F);
    bytes.push(record.generalProfileCompatibilityFlags >>> 24 & 0xFF);
    bytes.push(record.generalProfileCompatibilityFlags >>> 16 & 0xFF);
    bytes.push(record.generalProfileCompatibilityFlags >>> 8 & 0xFF);
    bytes.push(record.generalProfileCompatibilityFlags & 0xFF);
    bytes.push(...record.generalConstraintIndicatorFlags);
    bytes.push(record.generalLevelIdc & 0xFF);
    bytes.push(0xF0 | record.minSpatialSegmentationIdc >> 8 & 0x0F); // Reserved + high nibble
    bytes.push(record.minSpatialSegmentationIdc & 0xFF); // Low byte
    bytes.push(0xFC | record.parallelismType & 0x03);
    bytes.push(0xFC | record.chromaFormatIdc & 0x03);
    bytes.push(0xF8 | record.bitDepthLumaMinus8 & 0x07);
    bytes.push(0xF8 | record.bitDepthChromaMinus8 & 0x07);
    bytes.push(record.avgFrameRate >> 8 & 0xFF); // High byte
    bytes.push(record.avgFrameRate & 0xFF); // Low byte
    bytes.push((record.constantFrameRate & 0x03) << 6 | (record.numTemporalLayers & 0x07) << 3 | (record.temporalIdNested & 0x01) << 2 | record.lengthSizeMinusOne & 0x03);
    bytes.push(record.arrays.length & 0xFF);
    for (const arr of record.arrays){
        bytes.push((arr.arrayCompleteness & 0x01) << 7 | 0 | arr.nalUnitType & 0x3F);
        bytes.push(arr.nalUnits.length >> 8 & 0xFF); // High byte
        bytes.push(arr.nalUnits.length & 0xFF); // Low byte
        for (const nal of arr.nalUnits){
            bytes.push(nal.length >> 8 & 0xFF); // High byte
            bytes.push(nal.length & 0xFF); // Low byte
            for(let i = 0; i < nal.length; i++)bytes.push(nal[i]);
        }
    }
    return new Uint8Array(bytes);
};
const $e4e81989f7ab3f4b$export$2c52f19fd2de233b = (packet)=>{
    // eslint-disable-next-line @stylistic/max-len
    // https://storage.googleapis.com/downloads.webmproject.org/docs/vp9/vp9-bitstream-specification-v0.7-20170222-draft.pdf
    // http://downloads.webmproject.org/docs/vp9/vp9-bitstream_superframe-and-uncompressed-header_v1.0.pdf
    // Handle superframe
    const lastByte = packet[packet.length - 1];
    if (lastByte && (lastByte & 0xe0) === 0xc0) {
        const bytesPerFrameSize = ((lastByte & 0x18) >> 3) + 1;
        const numFrames = (lastByte & 0x07) + 1;
        const indexSize = 2 + numFrames * bytesPerFrameSize;
        // Verify matching marker bytes
        if (packet[packet.length - indexSize] !== lastByte) return null;
        // Get first frame size
        let frameSize = 0;
        const offset = packet.length - indexSize + 1;
        for(let i = 0; i < bytesPerFrameSize; i++){
            if (!packet[offset + i]) return null;
            frameSize |= packet[offset + i] << 8 * i;
        }
        packet = packet.subarray(0, frameSize);
    }
    const bitstream = new (0, $053d5bbcf6664967$export$d16e6594b36c3ef7)(packet);
    // Frame marker (0b10)
    const frameMarker = bitstream.readBits(2);
    if (frameMarker !== 2) return null;
    // Profile
    const profileLowBit = bitstream.readBits(1);
    const profileHighBit = bitstream.readBits(1);
    const profile = (profileHighBit << 1) + profileLowBit;
    // Skip reserved bit for profile 3
    if (profile === 3) bitstream.skipBits(1);
    // show_existing_frame
    const showExistingFrame = bitstream.readBits(1);
    if (showExistingFrame === 1) return null;
    // frame_type (0 = key frame)
    const frameType = bitstream.readBits(1);
    if (frameType !== 0) return null;
    // Skip show_frame and error_resilient_mode
    bitstream.skipBits(2);
    // Sync code (0x498342)
    const syncCode = bitstream.readBits(24);
    if (syncCode !== 0x498342) return null;
    // Color config
    let bitDepth = 8;
    if (profile >= 2) {
        const tenOrTwelveBit = bitstream.readBits(1);
        bitDepth = tenOrTwelveBit ? 12 : 10;
    }
    // Color space
    const colorSpace = bitstream.readBits(3);
    let chromaSubsampling = 0;
    let videoFullRangeFlag = 0;
    if (colorSpace !== 7) {
        const colorRange = bitstream.readBits(1);
        videoFullRangeFlag = colorRange;
        if (profile === 1 || profile === 3) {
            const subsamplingX = bitstream.readBits(1);
            const subsamplingY = bitstream.readBits(1);
            // 0 = 4:2:0 vertical
            // 1 = 4:2:0 colocated
            // 2 = 4:2:2
            // 3 = 4:4:4
            chromaSubsampling = !subsamplingX && !subsamplingY ? 3 // 0,0 = 4:4:4
             : subsamplingX && !subsamplingY ? 2 // 1,0 = 4:2:2
             : 1; // 1,1 = 4:2:0 colocated (default)
            // Skip reserved bit
            bitstream.skipBits(1);
        } else // For profile 0 and 2, always 4:2:0
        chromaSubsampling = 1; // Using colocated as default
    } else {
        // RGB is always 4:4:4
        chromaSubsampling = 3;
        videoFullRangeFlag = 1;
    }
    // Parse frame size
    const widthMinusOne = bitstream.readBits(16);
    const heightMinusOne = bitstream.readBits(16);
    const width = widthMinusOne + 1;
    const height = heightMinusOne + 1;
    // Calculate level based on dimensions
    const pictureSize = width * height;
    let level = (0, $053d5bbcf6664967$export$4c7897fafd92b108)((0, $94511f4b46249ea3$export$93c2d7097dbbef6)).level; // Default to highest level
    for (const entry of (0, $94511f4b46249ea3$export$93c2d7097dbbef6))if (pictureSize <= entry.maxPictureSize) {
        level = entry.level;
        break;
    }
    // Map color_space to standard values
    const matrixCoefficients = colorSpace === 7 ? 0 : colorSpace === 2 ? 1 : colorSpace === 1 ? 6 : 2;
    const colourPrimaries = colorSpace === 2 ? 1 : colorSpace === 1 ? 6 : 2;
    const transferCharacteristics = colorSpace === 2 ? 1 : colorSpace === 1 ? 6 : 2;
    return {
        profile: profile,
        level: level,
        bitDepth: bitDepth,
        chromaSubsampling: chromaSubsampling,
        videoFullRangeFlag: videoFullRangeFlag,
        colourPrimaries: colourPrimaries,
        transferCharacteristics: transferCharacteristics,
        matrixCoefficients: matrixCoefficients
    };
};
const $e4e81989f7ab3f4b$export$cf43c29bdbede92 = (packet)=>{
    // https://aomediacodec.github.io/av1-spec/av1-spec.pdf
    const bitstream = new (0, $053d5bbcf6664967$export$d16e6594b36c3ef7)(packet);
    const readLeb128 = ()=>{
        let value = 0;
        for(let i = 0; i < 8; i++){
            const byte = bitstream.readAlignedByte();
            if (byte === undefined) return 0;
            value |= (byte & 0x7f) << i * 7;
            if (!(byte & 0x80)) break;
            // Spec requirement
            if (i === 7 && byte & 0x80) return null;
        }
        // Spec requirement
        if (value >= 2 ** 32 - 1) return null;
        return value;
    };
    while(bitstream.getBitsLeft() >= 8){
        // Parse OBU header
        const obuHeader = bitstream.readBits(8);
        const obuType = obuHeader >> 3 & 0xf;
        const obuExtension = obuHeader >> 2 & 0x1;
        const obuHasSizeField = obuHeader >> 1 & 0x1;
        // Skip extension header if present
        if (obuExtension) bitstream.skipBits(8);
        // Read OBU size if present
        let obuSize;
        if (obuHasSizeField) {
            const obuSizeValue = readLeb128();
            if (obuSizeValue === null) return null; // It was invalid
            obuSize = obuSizeValue;
        } else // Calculate remaining bits and convert to bytes, rounding down
        obuSize = Math.floor(bitstream.getBitsLeft() / 8);
        // We're only interested in Sequence Header OBU (type 1)
        if (obuType === 1) {
            // Read sequence header fields
            const seqProfile = bitstream.readBits(3);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const stillPicture = bitstream.readBits(1);
            const reducedStillPictureHeader = bitstream.readBits(1);
            let seqLevel = 0;
            let seqTier = 0;
            let bufferDelayLengthMinus1 = 0;
            if (reducedStillPictureHeader) seqLevel = bitstream.readBits(5);
            else {
                // Parse timing_info_present_flag
                const timingInfoPresentFlag = bitstream.readBits(1);
                if (timingInfoPresentFlag) {
                    // Skip timing info (num_units_in_display_tick, time_scale, equal_picture_interval)
                    bitstream.skipBits(32); // num_units_in_display_tick
                    bitstream.skipBits(32); // time_scale
                    const equalPictureInterval = bitstream.readBits(1);
                    if (equalPictureInterval) // Skip num_ticks_per_picture_minus_1 (uvlc)
                    // Since this is variable length, we'd need to implement uvlc reading
                    // For now, we'll return null as this is rare
                    return null;
                }
                // Parse decoder_model_info_present_flag
                const decoderModelInfoPresentFlag = bitstream.readBits(1);
                if (decoderModelInfoPresentFlag) {
                    // Store buffer_delay_length_minus_1 instead of just skipping
                    bufferDelayLengthMinus1 = bitstream.readBits(5);
                    bitstream.skipBits(32); // num_units_in_decoding_tick
                    bitstream.skipBits(5); // buffer_removal_time_length_minus_1
                    bitstream.skipBits(5); // frame_presentation_time_length_minus_1
                }
                // Parse operating_points_cnt_minus_1
                const operatingPointsCntMinus1 = bitstream.readBits(5);
                // For each operating point
                for(let i = 0; i <= operatingPointsCntMinus1; i++){
                    // operating_point_idc[i]
                    bitstream.skipBits(12);
                    // seq_level_idx[i]
                    const seqLevelIdx = bitstream.readBits(5);
                    if (i === 0) seqLevel = seqLevelIdx;
                    if (seqLevelIdx > 7) {
                        // seq_tier[i]
                        const seqTierTemp = bitstream.readBits(1);
                        if (i === 0) seqTier = seqTierTemp;
                    }
                    if (decoderModelInfoPresentFlag) {
                        // decoder_model_present_for_this_op[i]
                        const decoderModelPresentForThisOp = bitstream.readBits(1);
                        if (decoderModelPresentForThisOp) {
                            const n = bufferDelayLengthMinus1 + 1;
                            bitstream.skipBits(n); // decoder_buffer_delay[op]
                            bitstream.skipBits(n); // encoder_buffer_delay[op]
                            bitstream.skipBits(1); // low_delay_mode_flag[op]
                        }
                    }
                    // initial_display_delay_present_flag
                    const initialDisplayDelayPresentFlag = bitstream.readBits(1);
                    if (initialDisplayDelayPresentFlag) // initial_display_delay_minus_1[i]
                    bitstream.skipBits(4);
                }
            }
            const highBitdepth = bitstream.readBits(1);
            let bitDepth = 8;
            if (seqProfile === 2 && highBitdepth) {
                const twelveBit = bitstream.readBits(1);
                bitDepth = twelveBit ? 12 : 10;
            } else if (seqProfile <= 2) bitDepth = highBitdepth ? 10 : 8;
            let monochrome = 0;
            if (seqProfile !== 1) monochrome = bitstream.readBits(1);
            let chromaSubsamplingX = 1;
            let chromaSubsamplingY = 1;
            let chromaSamplePosition = 0;
            if (!monochrome) {
                if (seqProfile === 0) {
                    chromaSubsamplingX = 1;
                    chromaSubsamplingY = 1;
                } else if (seqProfile === 1) {
                    chromaSubsamplingX = 0;
                    chromaSubsamplingY = 0;
                } else if (bitDepth === 12) {
                    chromaSubsamplingX = bitstream.readBits(1);
                    if (chromaSubsamplingX) chromaSubsamplingY = bitstream.readBits(1);
                }
                if (chromaSubsamplingX && chromaSubsamplingY) chromaSamplePosition = bitstream.readBits(2);
            }
            return {
                profile: seqProfile,
                level: seqLevel,
                tier: seqTier,
                bitDepth: bitDepth,
                monochrome: monochrome,
                chromaSubsamplingX: chromaSubsamplingX,
                chromaSubsamplingY: chromaSubsamplingY,
                chromaSamplePosition: chromaSamplePosition
            };
        }
        // Move to next OBU
        // The OBU size is in bytes, so skip that many bytes.
        bitstream.skipBits(obuSize * 8);
    }
    return null;
};
const $e4e81989f7ab3f4b$export$f126d711230ceb2 = (bytes)=>{
    const view = (0, $053d5bbcf6664967$export$f6b0788df7b6d1ec)(bytes);
    const outputChannelCount = view.getUint8(9);
    const preSkip = view.getUint16(10, true);
    const inputSampleRate = view.getUint32(12, true);
    const outputGain = view.getInt16(16, true);
    const channelMappingFamily = view.getUint8(18);
    let channelMappingTable = null;
    if (channelMappingFamily) channelMappingTable = bytes.subarray(19, 21 + outputChannelCount);
    return {
        outputChannelCount: outputChannelCount,
        preSkip: preSkip,
        inputSampleRate: inputSampleRate,
        outputGain: outputGain,
        channelMappingFamily: channelMappingFamily,
        channelMappingTable: channelMappingTable
    };
};
// From https://datatracker.ietf.org/doc/html/rfc6716, in 48 kHz samples
const $e4e81989f7ab3f4b$var$OPUS_FRAME_DURATION_TABLE = [
    480,
    960,
    1920,
    2880,
    480,
    960,
    1920,
    2880,
    480,
    960,
    1920,
    2880,
    480,
    960,
    480,
    960,
    120,
    240,
    480,
    960,
    120,
    240,
    480,
    960,
    120,
    240,
    480,
    960,
    120,
    240,
    480,
    960
];
const $e4e81989f7ab3f4b$export$4b904a3e04344373 = (packet)=>{
    const config = packet[0] >> 3;
    return {
        durationInSamples: $e4e81989f7ab3f4b$var$OPUS_FRAME_DURATION_TABLE[config]
    };
};
const $e4e81989f7ab3f4b$export$ea4c36f24bb20494 = (setupHeader)=>{
    // Verify that this is a Setup header.
    if (setupHeader.length < 7) throw new Error('Setup header is too short.');
    if (setupHeader[0] !== 5) throw new Error('Wrong packet type in Setup header.');
    const signature = String.fromCharCode(...setupHeader.slice(1, 7));
    if (signature !== 'vorbis') throw new Error('Invalid packet signature in Setup header.');
    // Reverse the entire buffer.
    const bufSize = setupHeader.length;
    const revBuffer = new Uint8Array(bufSize);
    for(let i = 0; i < bufSize; i++)revBuffer[i] = setupHeader[bufSize - 1 - i];
    // Initialize a Bitstream on the reversed buffer.
    const bitstream = new (0, $053d5bbcf6664967$export$d16e6594b36c3ef7)(revBuffer);
    // --- Find the framing bit.
    // In FFmpeg code, we scan until get_bits1() returns 1.
    let gotFramingBit = 0;
    while(bitstream.getBitsLeft() > 97)if (bitstream.readBits(1) === 1) {
        gotFramingBit = bitstream.pos;
        break;
    }
    if (gotFramingBit === 0) throw new Error('Invalid Setup header: framing bit not found.');
    // --- Search backwards for a valid mode header.
    // We try to “guess” the number of modes by reading a fixed pattern.
    let modeCount = 0;
    let gotModeHeader = false;
    let lastModeCount = 0;
    while(bitstream.getBitsLeft() >= 97){
        const tempPos = bitstream.pos;
        const a = bitstream.readBits(8);
        const b = bitstream.readBits(16);
        const c = bitstream.readBits(16);
        // If a > 63 or b or c nonzero, assume we’ve gone too far.
        if (a > 63 || b !== 0 || c !== 0) {
            bitstream.pos = tempPos;
            break;
        }
        bitstream.skipBits(1);
        modeCount++;
        if (modeCount > 64) break;
        const bsClone = bitstream.clone();
        const candidate = bsClone.readBits(6) + 1;
        if (candidate === modeCount) {
            gotModeHeader = true;
            lastModeCount = modeCount;
        }
    }
    if (!gotModeHeader) throw new Error('Invalid Setup header: mode header not found.');
    if (lastModeCount > 63) throw new Error(`Unsupported mode count: ${lastModeCount}.`);
    const finalModeCount = lastModeCount;
    // --- Reinitialize the bitstream.
    bitstream.pos = 0;
    // Skip the bits up to the found framing bit.
    bitstream.skipBits(gotFramingBit);
    // --- Now read, for each mode (in reverse order), 40 bits then one bit.
    // That one bit is the mode blockflag.
    const modeBlockflags = Array(finalModeCount).fill(0);
    for(let i = finalModeCount - 1; i >= 0; i--){
        bitstream.skipBits(40);
        modeBlockflags[i] = bitstream.readBits(1);
    }
    return {
        modeBlockflags: modeBlockflags
    };
};


class $1891065cf37256e6$export$fbc2d84bd32bc55f {
    constructor(writer){
        this.writer = writer;
        this.helper = new Uint8Array(8);
        this.helperView = new DataView(this.helper.buffer);
        /**
         * Stores the position from the start of the file to where boxes elements have been written. This is used to
         * rewrite/edit elements that were already added before, and to measure sizes of things.
         */ this.offsets = new WeakMap();
    }
    writeU32(value) {
        this.helperView.setUint32(0, value, false);
        this.writer.write(this.helper.subarray(0, 4));
    }
    writeU64(value) {
        this.helperView.setUint32(0, Math.floor(value / 2 ** 32), false);
        this.helperView.setUint32(4, value, false);
        this.writer.write(this.helper.subarray(0, 8));
    }
    writeAscii(text) {
        for(let i = 0; i < text.length; i++){
            this.helperView.setUint8(i % 8, text.charCodeAt(i));
            if (i % 8 === 7) this.writer.write(this.helper);
        }
        if (text.length % 8 !== 0) this.writer.write(this.helper.subarray(0, text.length % 8));
    }
    writeBox(box) {
        this.offsets.set(box, this.writer.getPos());
        if (box.contents && !box.children) {
            this.writeBoxHeader(box, box.size ?? box.contents.byteLength + 8);
            this.writer.write(box.contents);
        } else {
            const startPos = this.writer.getPos();
            this.writeBoxHeader(box, 0);
            if (box.contents) this.writer.write(box.contents);
            if (box.children) {
                for (const child of box.children)if (child) this.writeBox(child);
            }
            const endPos = this.writer.getPos();
            const size = box.size ?? endPos - startPos;
            this.writer.seek(startPos);
            this.writeBoxHeader(box, size);
            this.writer.seek(endPos);
        }
    }
    writeBoxHeader(box, size) {
        this.writeU32(box.largeSize ? 1 : size);
        this.writeAscii(box.type);
        if (box.largeSize) this.writeU64(size);
    }
    measureBoxHeader(box) {
        return 8 + (box.largeSize ? 8 : 0);
    }
    patchBox(box) {
        const boxOffset = this.offsets.get(box);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(boxOffset !== undefined);
        const endPos = this.writer.getPos();
        this.writer.seek(boxOffset);
        this.writeBox(box);
        this.writer.seek(endPos);
    }
    measureBox(box) {
        if (box.contents && !box.children) {
            const headerSize = this.measureBoxHeader(box);
            return headerSize + box.contents.byteLength;
        } else {
            let result = this.measureBoxHeader(box);
            if (box.contents) result += box.contents.byteLength;
            if (box.children) {
                for (const child of box.children)if (child) result += this.measureBox(child);
            }
            return result;
        }
    }
}
const $1891065cf37256e6$var$bytes = new Uint8Array(8);
const $1891065cf37256e6$var$view = new DataView($1891065cf37256e6$var$bytes.buffer);
const $1891065cf37256e6$var$u8 = (value)=>{
    return [
        (value % 0x100 + 0x100) % 0x100
    ];
};
const $1891065cf37256e6$var$u16 = (value)=>{
    $1891065cf37256e6$var$view.setUint16(0, value, false);
    return [
        $1891065cf37256e6$var$bytes[0],
        $1891065cf37256e6$var$bytes[1]
    ];
};
const $1891065cf37256e6$var$i16 = (value)=>{
    $1891065cf37256e6$var$view.setInt16(0, value, false);
    return [
        $1891065cf37256e6$var$bytes[0],
        $1891065cf37256e6$var$bytes[1]
    ];
};
const $1891065cf37256e6$var$u24 = (value)=>{
    $1891065cf37256e6$var$view.setUint32(0, value, false);
    return [
        $1891065cf37256e6$var$bytes[1],
        $1891065cf37256e6$var$bytes[2],
        $1891065cf37256e6$var$bytes[3]
    ];
};
const $1891065cf37256e6$var$u32 = (value)=>{
    $1891065cf37256e6$var$view.setUint32(0, value, false);
    return [
        $1891065cf37256e6$var$bytes[0],
        $1891065cf37256e6$var$bytes[1],
        $1891065cf37256e6$var$bytes[2],
        $1891065cf37256e6$var$bytes[3]
    ];
};
const $1891065cf37256e6$var$i32 = (value)=>{
    $1891065cf37256e6$var$view.setInt32(0, value, false);
    return [
        $1891065cf37256e6$var$bytes[0],
        $1891065cf37256e6$var$bytes[1],
        $1891065cf37256e6$var$bytes[2],
        $1891065cf37256e6$var$bytes[3]
    ];
};
const $1891065cf37256e6$var$u64 = (value)=>{
    $1891065cf37256e6$var$view.setUint32(0, Math.floor(value / 2 ** 32), false);
    $1891065cf37256e6$var$view.setUint32(4, value, false);
    return [
        $1891065cf37256e6$var$bytes[0],
        $1891065cf37256e6$var$bytes[1],
        $1891065cf37256e6$var$bytes[2],
        $1891065cf37256e6$var$bytes[3],
        $1891065cf37256e6$var$bytes[4],
        $1891065cf37256e6$var$bytes[5],
        $1891065cf37256e6$var$bytes[6],
        $1891065cf37256e6$var$bytes[7]
    ];
};
const $1891065cf37256e6$var$fixed_8_8 = (value)=>{
    $1891065cf37256e6$var$view.setInt16(0, 256 * value, false);
    return [
        $1891065cf37256e6$var$bytes[0],
        $1891065cf37256e6$var$bytes[1]
    ];
};
const $1891065cf37256e6$var$fixed_16_16 = (value)=>{
    $1891065cf37256e6$var$view.setInt32(0, 2 ** 16 * value, false);
    return [
        $1891065cf37256e6$var$bytes[0],
        $1891065cf37256e6$var$bytes[1],
        $1891065cf37256e6$var$bytes[2],
        $1891065cf37256e6$var$bytes[3]
    ];
};
const $1891065cf37256e6$var$fixed_2_30 = (value)=>{
    $1891065cf37256e6$var$view.setInt32(0, 2 ** 30 * value, false);
    return [
        $1891065cf37256e6$var$bytes[0],
        $1891065cf37256e6$var$bytes[1],
        $1891065cf37256e6$var$bytes[2],
        $1891065cf37256e6$var$bytes[3]
    ];
};
const $1891065cf37256e6$var$variableUnsignedInt = (value, byteLength)=>{
    const bytes = [];
    let remaining = value;
    do {
        let byte = remaining & 0x7f;
        remaining >>= 7;
        // If this isn't the first byte we're adding (meaning there will be more bytes after it
        // when we reverse the array), set the continuation bit
        if (bytes.length > 0) byte |= 0x80;
        bytes.push(byte);
        if (byteLength !== undefined) byteLength--;
    }while (remaining > 0 || byteLength);
    // Reverse the array since we built it backwards
    return bytes.reverse();
};
const $1891065cf37256e6$var$ascii = (text, nullTerminated = false)=>{
    const bytes = Array(text.length).fill(null).map((_, i)=>text.charCodeAt(i));
    if (nullTerminated) bytes.push(0x00);
    return bytes;
};
const $1891065cf37256e6$var$lastPresentedSample = (samples)=>{
    let result = null;
    for (const sample of samples)if (!result || sample.timestamp > result.timestamp) result = sample;
    return result;
};
const $1891065cf37256e6$var$rotationMatrix = (rotationInDegrees)=>{
    const theta = rotationInDegrees * (Math.PI / 180);
    const cosTheta = Math.round(Math.cos(theta));
    const sinTheta = Math.round(Math.sin(theta));
    // Matrices are post-multiplied in ISOBMFF, meaning this is the transpose of your typical rotation matrix
    return [
        cosTheta,
        sinTheta,
        0,
        -sinTheta,
        cosTheta,
        0,
        0,
        0,
        1
    ];
};
const $1891065cf37256e6$var$IDENTITY_MATRIX = $1891065cf37256e6$var$rotationMatrix(0);
const $1891065cf37256e6$var$matrixToBytes = (matrix)=>{
    return [
        $1891065cf37256e6$var$fixed_16_16(matrix[0]),
        $1891065cf37256e6$var$fixed_16_16(matrix[1]),
        $1891065cf37256e6$var$fixed_2_30(matrix[2]),
        $1891065cf37256e6$var$fixed_16_16(matrix[3]),
        $1891065cf37256e6$var$fixed_16_16(matrix[4]),
        $1891065cf37256e6$var$fixed_2_30(matrix[5]),
        $1891065cf37256e6$var$fixed_16_16(matrix[6]),
        $1891065cf37256e6$var$fixed_16_16(matrix[7]),
        $1891065cf37256e6$var$fixed_2_30(matrix[8])
    ];
};
const $1891065cf37256e6$export$827f4ee28efc37 = (type, contents, children)=>({
        type: type,
        contents: contents && new Uint8Array(contents.flat(10)),
        children: children
    });
const $1891065cf37256e6$export$39b48787714acfef = (type, version, flags, contents, children)=>$1891065cf37256e6$export$827f4ee28efc37(type, [
        $1891065cf37256e6$var$u8(version),
        $1891065cf37256e6$var$u24(flags),
        contents ?? []
    ], children);
const $1891065cf37256e6$export$7486382ce8a22acc = (details)=>{
    // You can find the full logic for this at
    // https://github.com/FFmpeg/FFmpeg/blob/de2fb43e785773738c660cdafb9309b1ef1bc80d/libavformat/movenc.c#L5518
    // Obviously, this lib only needs a small subset of that logic.
    const minorVersion = 0x200;
    if (details.isQuickTime) return $1891065cf37256e6$export$827f4ee28efc37('ftyp', [
        $1891065cf37256e6$var$ascii('qt  '),
        $1891065cf37256e6$var$u32(minorVersion),
        // Compatible brands
        $1891065cf37256e6$var$ascii('qt  ')
    ]);
    if (details.fragmented) return $1891065cf37256e6$export$827f4ee28efc37('ftyp', [
        $1891065cf37256e6$var$ascii('iso5'),
        $1891065cf37256e6$var$u32(minorVersion),
        // Compatible brands
        $1891065cf37256e6$var$ascii('iso5'),
        $1891065cf37256e6$var$ascii('iso6'),
        $1891065cf37256e6$var$ascii('mp41')
    ]);
    return $1891065cf37256e6$export$827f4ee28efc37('ftyp', [
        $1891065cf37256e6$var$ascii('isom'),
        $1891065cf37256e6$var$u32(minorVersion),
        // Compatible brands
        $1891065cf37256e6$var$ascii('isom'),
        details.holdsAvc ? $1891065cf37256e6$var$ascii('avc1') : [],
        $1891065cf37256e6$var$ascii('mp41')
    ]);
};
const $1891065cf37256e6$export$2af587b6535fb1d3 = (reserveLargeSize)=>({
        type: 'mdat',
        largeSize: reserveLargeSize
    });
const $1891065cf37256e6$export$464b8c6103d8110e = (trackDatas, creationTime, fragmented = false)=>$1891065cf37256e6$export$827f4ee28efc37('moov', undefined, [
        $1891065cf37256e6$export$db732afd821422cc(creationTime, trackDatas),
        ...trackDatas.map((x)=>$1891065cf37256e6$export$aaa11cf33f8318f0(x, creationTime)),
        fragmented ? $1891065cf37256e6$export$3790eea5725be2bc(trackDatas) : null
    ]);
const $1891065cf37256e6$export$db732afd821422cc = (creationTime, trackDatas)=>{
    const duration = (0, $d3ff0c06a870f18b$export$1f322e0cced0371b)(Math.max(0, ...trackDatas.filter((x)=>x.samples.length > 0).map((x)=>{
        const lastSample = $1891065cf37256e6$var$lastPresentedSample(x.samples);
        return lastSample.timestamp + lastSample.duration;
    })), (0, $d3ff0c06a870f18b$export$10813e7e0cb0efe4));
    const nextTrackId = Math.max(0, ...trackDatas.map((x)=>x.track.id)) + 1;
    // Conditionally use u64 if u32 isn't enough
    const needsU64 = !(0, $053d5bbcf6664967$export$ea44a6b0d261b831)(creationTime) || !(0, $053d5bbcf6664967$export$ea44a6b0d261b831)(duration);
    const u32OrU64 = needsU64 ? $1891065cf37256e6$var$u64 : $1891065cf37256e6$var$u32;
    return $1891065cf37256e6$export$39b48787714acfef('mvhd', +needsU64, 0, [
        u32OrU64(creationTime),
        u32OrU64(creationTime),
        $1891065cf37256e6$var$u32((0, $d3ff0c06a870f18b$export$10813e7e0cb0efe4)),
        u32OrU64(duration),
        $1891065cf37256e6$var$fixed_16_16(1),
        $1891065cf37256e6$var$fixed_8_8(1),
        Array(10).fill(0),
        $1891065cf37256e6$var$matrixToBytes($1891065cf37256e6$var$IDENTITY_MATRIX),
        Array(24).fill(0),
        $1891065cf37256e6$var$u32(nextTrackId)
    ]);
};
const $1891065cf37256e6$export$aaa11cf33f8318f0 = (trackData, creationTime)=>$1891065cf37256e6$export$827f4ee28efc37('trak', undefined, [
        $1891065cf37256e6$export$17fa19b34dc63eff(trackData, creationTime),
        $1891065cf37256e6$export$3c59af31083f4497(trackData, creationTime)
    ]);
const $1891065cf37256e6$export$17fa19b34dc63eff = (trackData, creationTime)=>{
    const lastSample = $1891065cf37256e6$var$lastPresentedSample(trackData.samples);
    const durationInGlobalTimescale = (0, $d3ff0c06a870f18b$export$1f322e0cced0371b)(lastSample ? lastSample.timestamp + lastSample.duration : 0, (0, $d3ff0c06a870f18b$export$10813e7e0cb0efe4));
    const needsU64 = !(0, $053d5bbcf6664967$export$ea44a6b0d261b831)(creationTime) || !(0, $053d5bbcf6664967$export$ea44a6b0d261b831)(durationInGlobalTimescale);
    const u32OrU64 = needsU64 ? $1891065cf37256e6$var$u64 : $1891065cf37256e6$var$u32;
    let matrix;
    if (trackData.type === 'video') {
        const rotation = trackData.track.metadata.rotation;
        matrix = $1891065cf37256e6$var$rotationMatrix(rotation ?? 0);
    } else matrix = $1891065cf37256e6$var$IDENTITY_MATRIX;
    return $1891065cf37256e6$export$39b48787714acfef('tkhd', +needsU64, 3, [
        u32OrU64(creationTime),
        u32OrU64(creationTime),
        $1891065cf37256e6$var$u32(trackData.track.id),
        $1891065cf37256e6$var$u32(0),
        u32OrU64(durationInGlobalTimescale),
        Array(8).fill(0),
        $1891065cf37256e6$var$u16(0),
        $1891065cf37256e6$var$u16(trackData.track.id),
        $1891065cf37256e6$var$fixed_8_8(trackData.type === 'audio' ? 1 : 0),
        $1891065cf37256e6$var$u16(0),
        $1891065cf37256e6$var$matrixToBytes(matrix),
        $1891065cf37256e6$var$fixed_16_16(trackData.type === 'video' ? trackData.info.width : 0),
        $1891065cf37256e6$var$fixed_16_16(trackData.type === 'video' ? trackData.info.height : 0)
    ]);
};
const $1891065cf37256e6$export$3c59af31083f4497 = (trackData, creationTime)=>$1891065cf37256e6$export$827f4ee28efc37('mdia', undefined, [
        $1891065cf37256e6$export$d7bf751a42c8c30a(trackData, creationTime),
        $1891065cf37256e6$export$94ff7631a5f2730(trackData),
        $1891065cf37256e6$export$ca8c974a6c156e08(trackData)
    ]);
const $1891065cf37256e6$export$d7bf751a42c8c30a = (trackData, creationTime)=>{
    const lastSample = $1891065cf37256e6$var$lastPresentedSample(trackData.samples);
    const localDuration = (0, $d3ff0c06a870f18b$export$1f322e0cced0371b)(lastSample ? lastSample.timestamp + lastSample.duration : 0, trackData.timescale);
    const needsU64 = !(0, $053d5bbcf6664967$export$ea44a6b0d261b831)(creationTime) || !(0, $053d5bbcf6664967$export$ea44a6b0d261b831)(localDuration);
    const u32OrU64 = needsU64 ? $1891065cf37256e6$var$u64 : $1891065cf37256e6$var$u32;
    let language = 0;
    for (const character of trackData.track.metadata.languageCode ?? (0, $053d5bbcf6664967$export$af15dfb067c7ab59)){
        language <<= 5;
        language += character.charCodeAt(0) - 0x60;
    }
    return $1891065cf37256e6$export$39b48787714acfef('mdhd', +needsU64, 0, [
        u32OrU64(creationTime),
        u32OrU64(creationTime),
        $1891065cf37256e6$var$u32(trackData.timescale),
        u32OrU64(localDuration),
        $1891065cf37256e6$var$u16(language),
        $1891065cf37256e6$var$u16(0)
    ]);
};
const $1891065cf37256e6$var$TRACK_TYPE_TO_COMPONENT_SUBTYPE = {
    video: 'vide',
    audio: 'soun',
    subtitle: 'text'
};
const $1891065cf37256e6$var$TRACK_TYPE_TO_HANDLER_NAME = {
    video: 'MediabunnyVideoHandler',
    audio: 'MediabunnySoundHandler',
    subtitle: 'MediabunnyTextHandler'
};
const $1891065cf37256e6$export$94ff7631a5f2730 = (trackData)=>$1891065cf37256e6$export$39b48787714acfef('hdlr', 0, 0, [
        $1891065cf37256e6$var$ascii('mhlr'),
        $1891065cf37256e6$var$ascii($1891065cf37256e6$var$TRACK_TYPE_TO_COMPONENT_SUBTYPE[trackData.type]),
        $1891065cf37256e6$var$u32(0),
        $1891065cf37256e6$var$u32(0),
        $1891065cf37256e6$var$u32(0),
        $1891065cf37256e6$var$ascii($1891065cf37256e6$var$TRACK_TYPE_TO_HANDLER_NAME[trackData.type], true)
    ]);
const $1891065cf37256e6$export$ca8c974a6c156e08 = (trackData)=>$1891065cf37256e6$export$827f4ee28efc37('minf', undefined, [
        $1891065cf37256e6$var$TRACK_TYPE_TO_HEADER_BOX[trackData.type](),
        $1891065cf37256e6$export$c821a16312cd29fb(),
        $1891065cf37256e6$export$984934415a7ea2c3(trackData)
    ]);
const $1891065cf37256e6$export$2c229a24b1d83b79 = ()=>$1891065cf37256e6$export$39b48787714acfef('vmhd', 0, 1, [
        $1891065cf37256e6$var$u16(0),
        $1891065cf37256e6$var$u16(0),
        $1891065cf37256e6$var$u16(0),
        $1891065cf37256e6$var$u16(0)
    ]);
const $1891065cf37256e6$export$f55db7f88545958e = ()=>$1891065cf37256e6$export$39b48787714acfef('smhd', 0, 0, [
        $1891065cf37256e6$var$u16(0),
        $1891065cf37256e6$var$u16(0)
    ]);
const $1891065cf37256e6$export$d1d1719f4df1c5bb = ()=>$1891065cf37256e6$export$39b48787714acfef('nmhd', 0, 0);
const $1891065cf37256e6$var$TRACK_TYPE_TO_HEADER_BOX = {
    video: $1891065cf37256e6$export$2c229a24b1d83b79,
    audio: $1891065cf37256e6$export$f55db7f88545958e,
    subtitle: $1891065cf37256e6$export$d1d1719f4df1c5bb
};
const $1891065cf37256e6$export$c821a16312cd29fb = ()=>$1891065cf37256e6$export$827f4ee28efc37('dinf', undefined, [
        $1891065cf37256e6$export$3292aa426d02a589()
    ]);
const $1891065cf37256e6$export$3292aa426d02a589 = ()=>$1891065cf37256e6$export$39b48787714acfef('dref', 0, 0, [
        $1891065cf37256e6$var$u32(1)
    ], [
        $1891065cf37256e6$export$128fa18b7194ef()
    ]);
const $1891065cf37256e6$export$128fa18b7194ef = ()=>$1891065cf37256e6$export$39b48787714acfef('url ', 0, 1); // Self-reference flag enabled
const $1891065cf37256e6$export$984934415a7ea2c3 = (trackData)=>{
    const needsCtts = trackData.compositionTimeOffsetTable.length > 1 || trackData.compositionTimeOffsetTable.some((x)=>x.sampleCompositionTimeOffset !== 0);
    return $1891065cf37256e6$export$827f4ee28efc37('stbl', undefined, [
        $1891065cf37256e6$export$9a60c2c775c275c0(trackData),
        $1891065cf37256e6$export$c1063a265f6056cd(trackData),
        needsCtts ? $1891065cf37256e6$export$568267ff42bd512e(trackData) : null,
        needsCtts ? $1891065cf37256e6$export$35752ae1995d4c1a(trackData) : null,
        $1891065cf37256e6$export$91ea402c832e6f11(trackData),
        $1891065cf37256e6$export$ad785f4b4d7e6d7(trackData),
        $1891065cf37256e6$export$63cc23f51cc782bb(trackData),
        $1891065cf37256e6$export$ada009fbca49d3a0(trackData)
    ]);
};
const $1891065cf37256e6$export$9a60c2c775c275c0 = (trackData)=>{
    let sampleDescription;
    if (trackData.type === 'video') sampleDescription = $1891065cf37256e6$export$9f33f6baca3a5438($1891065cf37256e6$var$VIDEO_CODEC_TO_BOX_NAME[trackData.track.source._codec], trackData);
    else if (trackData.type === 'audio') {
        const boxName = $1891065cf37256e6$var$audioCodecToBoxName(trackData.track.source._codec, trackData.muxer.isQuickTime);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(boxName);
        sampleDescription = $1891065cf37256e6$export$8d4cedd6315173ad(boxName, trackData);
    } else if (trackData.type === 'subtitle') sampleDescription = $1891065cf37256e6$export$cf7ea515e3f94033($1891065cf37256e6$var$SUBTITLE_CODEC_TO_BOX_NAME[trackData.track.source._codec], trackData);
    (0, $053d5bbcf6664967$export$a7a9523472993e97)(sampleDescription);
    return $1891065cf37256e6$export$39b48787714acfef('stsd', 0, 0, [
        $1891065cf37256e6$var$u32(1)
    ], [
        sampleDescription
    ]);
};
const $1891065cf37256e6$export$9f33f6baca3a5438 = (compressionType, trackData)=>$1891065cf37256e6$export$827f4ee28efc37(compressionType, [
        Array(6).fill(0),
        $1891065cf37256e6$var$u16(1),
        $1891065cf37256e6$var$u16(0),
        $1891065cf37256e6$var$u16(0),
        Array(12).fill(0),
        $1891065cf37256e6$var$u16(trackData.info.width),
        $1891065cf37256e6$var$u16(trackData.info.height),
        $1891065cf37256e6$var$u32(0x00480000),
        $1891065cf37256e6$var$u32(0x00480000),
        $1891065cf37256e6$var$u32(0),
        $1891065cf37256e6$var$u16(1),
        Array(32).fill(0),
        $1891065cf37256e6$var$u16(0x0018),
        $1891065cf37256e6$var$i16(0xffff)
    ], [
        $1891065cf37256e6$var$VIDEO_CODEC_TO_CONFIGURATION_BOX[trackData.track.source._codec](trackData),
        (0, $053d5bbcf6664967$export$17ed7af6b4f218ca)(trackData.info.decoderConfig.colorSpace) ? $1891065cf37256e6$export$686dc140eadc8538(trackData) : null
    ]);
const $1891065cf37256e6$export$686dc140eadc8538 = (trackData)=>$1891065cf37256e6$export$827f4ee28efc37('colr', [
        $1891065cf37256e6$var$ascii('nclx'),
        $1891065cf37256e6$var$u16((0, $053d5bbcf6664967$export$c9d0dddad4eef393)[trackData.info.decoderConfig.colorSpace.primaries]),
        $1891065cf37256e6$var$u16((0, $053d5bbcf6664967$export$36a5c840f44dac9a)[trackData.info.decoderConfig.colorSpace.transfer]),
        $1891065cf37256e6$var$u16((0, $053d5bbcf6664967$export$62b3c37e3f8b5eb4)[trackData.info.decoderConfig.colorSpace.matrix]),
        $1891065cf37256e6$var$u8((trackData.info.decoderConfig.colorSpace.fullRange ? 1 : 0) << 7)
    ]);
const $1891065cf37256e6$export$1f524d04c45a4666 = (trackData)=>trackData.info.decoderConfig && $1891065cf37256e6$export$827f4ee28efc37('avcC', [
        // For AVC, description is an AVCDecoderConfigurationRecord, so nothing else to do here
        ...(0, $053d5bbcf6664967$export$73470fd2221e6aef)(trackData.info.decoderConfig.description)
    ]);
const $1891065cf37256e6$export$211f058b3a16cd76 = (trackData)=>trackData.info.decoderConfig && $1891065cf37256e6$export$827f4ee28efc37('hvcC', [
        // For HEVC, description is an HEVCDecoderConfigurationRecord, so nothing else to do here
        ...(0, $053d5bbcf6664967$export$73470fd2221e6aef)(trackData.info.decoderConfig.description)
    ]);
const $1891065cf37256e6$export$c883f962e652afb5 = (trackData)=>{
    // Reference: https://www.webmproject.org/vp9/mp4/
    if (!trackData.info.decoderConfig) return null;
    const decoderConfig = trackData.info.decoderConfig;
    const parts = decoderConfig.codec.split('.'); // We can derive the required values from the codec string
    const profile = Number(parts[1]);
    const level = Number(parts[2]);
    const bitDepth = Number(parts[3]);
    const chromaSubsampling = parts[4] ? Number(parts[4]) : 1; // 4:2:0 colocated with luma (0,0)
    const videoFullRangeFlag = parts[8] ? Number(parts[8]) : Number(decoderConfig.colorSpace?.fullRange ?? 0);
    const thirdByte = (bitDepth << 4) + (chromaSubsampling << 1) + videoFullRangeFlag;
    const colourPrimaries = parts[5] ? Number(parts[5]) : decoderConfig.colorSpace?.primaries ? (0, $053d5bbcf6664967$export$c9d0dddad4eef393)[decoderConfig.colorSpace.primaries] : 2; // Default to undetermined
    const transferCharacteristics = parts[6] ? Number(parts[6]) : decoderConfig.colorSpace?.transfer ? (0, $053d5bbcf6664967$export$36a5c840f44dac9a)[decoderConfig.colorSpace.transfer] : 2;
    const matrixCoefficients = parts[7] ? Number(parts[7]) : decoderConfig.colorSpace?.matrix ? (0, $053d5bbcf6664967$export$62b3c37e3f8b5eb4)[decoderConfig.colorSpace.matrix] : 2;
    return $1891065cf37256e6$export$39b48787714acfef('vpcC', 1, 0, [
        $1891065cf37256e6$var$u8(profile),
        $1891065cf37256e6$var$u8(level),
        $1891065cf37256e6$var$u8(thirdByte),
        $1891065cf37256e6$var$u8(colourPrimaries),
        $1891065cf37256e6$var$u8(transferCharacteristics),
        $1891065cf37256e6$var$u8(matrixCoefficients),
        $1891065cf37256e6$var$u16(0)
    ]);
};
const $1891065cf37256e6$export$f76721e75bcb63eb = (trackData)=>{
    return $1891065cf37256e6$export$827f4ee28efc37('av1C', (0, $94511f4b46249ea3$export$ac6296ba51eb7830)(trackData.info.decoderConfig.codec));
};
const $1891065cf37256e6$export$8d4cedd6315173ad = (compressionType, trackData)=>{
    let version = 0;
    let contents;
    let sampleSizeInBits = 16;
    if ((0, $94511f4b46249ea3$export$58c594b1fe7e587b).includes(trackData.track.source._codec)) {
        const codec = trackData.track.source._codec;
        const { sampleSize: sampleSize } = (0, $94511f4b46249ea3$export$560120a2d4e71dc2)(codec);
        sampleSizeInBits = 8 * sampleSize;
        if (sampleSizeInBits > 16) version = 1;
    }
    if (version === 0) contents = [
        Array(6).fill(0),
        $1891065cf37256e6$var$u16(1),
        $1891065cf37256e6$var$u16(version),
        $1891065cf37256e6$var$u16(0),
        $1891065cf37256e6$var$u32(0),
        $1891065cf37256e6$var$u16(trackData.info.numberOfChannels),
        $1891065cf37256e6$var$u16(sampleSizeInBits),
        $1891065cf37256e6$var$u16(0),
        $1891065cf37256e6$var$u16(0),
        $1891065cf37256e6$var$u16(trackData.info.sampleRate < 2 ** 16 ? trackData.info.sampleRate : 0),
        $1891065cf37256e6$var$u16(0)
    ];
    else contents = [
        Array(6).fill(0),
        $1891065cf37256e6$var$u16(1),
        $1891065cf37256e6$var$u16(version),
        $1891065cf37256e6$var$u16(0),
        $1891065cf37256e6$var$u32(0),
        $1891065cf37256e6$var$u16(trackData.info.numberOfChannels),
        $1891065cf37256e6$var$u16(Math.min(sampleSizeInBits, 16)),
        $1891065cf37256e6$var$u16(0),
        $1891065cf37256e6$var$u16(0),
        $1891065cf37256e6$var$u16(trackData.info.sampleRate < 2 ** 16 ? trackData.info.sampleRate : 0),
        $1891065cf37256e6$var$u16(0),
        $1891065cf37256e6$var$u32(1),
        $1891065cf37256e6$var$u32(sampleSizeInBits / 8),
        $1891065cf37256e6$var$u32(trackData.info.numberOfChannels * sampleSizeInBits / 8),
        $1891065cf37256e6$var$u32(2)
    ];
    return $1891065cf37256e6$export$827f4ee28efc37(compressionType, contents, [
        $1891065cf37256e6$var$audioCodecToConfigurationBox(trackData.track.source._codec, trackData.muxer.isQuickTime)?.(trackData) ?? null
    ]);
};
const $1891065cf37256e6$export$78af894123c9ca0 = (trackData)=>{
    // We build up the bytes in a layered way which reflects the nested structure
    let objectTypeIndication;
    switch(trackData.track.source._codec){
        case 'aac':
            objectTypeIndication = 0x40;
            break;
        case 'mp3':
            objectTypeIndication = 0x6b;
            break;
        case 'vorbis':
            objectTypeIndication = 0xdd;
            break;
        default:
            throw new Error(`Unhandled audio codec: ${trackData.track.source._codec}`);
    }
    let bytes = [
        ...$1891065cf37256e6$var$u8(objectTypeIndication),
        ...$1891065cf37256e6$var$u8(0x15),
        ...$1891065cf37256e6$var$u24(0),
        ...$1891065cf37256e6$var$u32(0),
        ...$1891065cf37256e6$var$u32(0)
    ];
    if (trackData.info.decoderConfig.description) {
        const description = (0, $053d5bbcf6664967$export$73470fd2221e6aef)(trackData.info.decoderConfig.description);
        // Add the decoder description to the end
        bytes = [
            ...bytes,
            ...$1891065cf37256e6$var$u8(0x05),
            ...$1891065cf37256e6$var$variableUnsignedInt(description.byteLength),
            ...description
        ];
    }
    bytes = [
        ...$1891065cf37256e6$var$u16(1),
        ...$1891065cf37256e6$var$u8(0x00),
        ...$1891065cf37256e6$var$u8(0x04),
        ...$1891065cf37256e6$var$variableUnsignedInt(bytes.length),
        ...bytes,
        ...$1891065cf37256e6$var$u8(0x06),
        ...$1891065cf37256e6$var$u8(0x01),
        ...$1891065cf37256e6$var$u8(0x02)
    ];
    bytes = [
        ...$1891065cf37256e6$var$u8(0x03),
        ...$1891065cf37256e6$var$variableUnsignedInt(bytes.length),
        ...bytes
    ];
    return $1891065cf37256e6$export$39b48787714acfef('esds', 0, 0, bytes);
};
const $1891065cf37256e6$export$3af1cb7633944de2 = (trackData)=>{
    return $1891065cf37256e6$export$827f4ee28efc37('wave', undefined, [
        $1891065cf37256e6$export$9ef098ad812f9321(trackData),
        $1891065cf37256e6$export$97afa8f5a35b6214(trackData),
        $1891065cf37256e6$export$827f4ee28efc37('\x00\x00\x00\x00')
    ]);
};
const $1891065cf37256e6$export$9ef098ad812f9321 = (trackData)=>{
    return $1891065cf37256e6$export$827f4ee28efc37('frma', [
        $1891065cf37256e6$var$ascii($1891065cf37256e6$var$audioCodecToBoxName(trackData.track.source._codec, trackData.muxer.isQuickTime))
    ]);
};
const $1891065cf37256e6$export$97afa8f5a35b6214 = (trackData)=>{
    const { littleEndian: littleEndian } = (0, $94511f4b46249ea3$export$560120a2d4e71dc2)(trackData.track.source._codec);
    return $1891065cf37256e6$export$827f4ee28efc37('enda', [
        $1891065cf37256e6$var$u16(+littleEndian)
    ]);
};
const $1891065cf37256e6$export$a0bf1e50a7efaaa9 = (trackData)=>{
    let outputChannelCount = trackData.info.numberOfChannels;
    // Default PreSkip, should be at least 80 milliseconds worth of playback, measured in 48000 Hz samples
    let preSkip = 3840;
    let inputSampleRate = trackData.info.sampleRate;
    let outputGain = 0;
    let channelMappingFamily = 0;
    let channelMappingTable = new Uint8Array(0);
    // Read preskip and from codec private data from the encoder
    // https://www.rfc-editor.org/rfc/rfc7845#section-5
    const description = trackData.info.decoderConfig?.description;
    if (description) {
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(description.byteLength >= 18);
        const bytes = (0, $053d5bbcf6664967$export$73470fd2221e6aef)(description);
        const header = (0, $e4e81989f7ab3f4b$export$f126d711230ceb2)(bytes);
        outputChannelCount = header.outputChannelCount;
        preSkip = header.preSkip;
        inputSampleRate = header.inputSampleRate;
        outputGain = header.outputGain;
        channelMappingFamily = header.channelMappingFamily;
        if (header.channelMappingTable) channelMappingTable = header.channelMappingTable;
    }
    // https://www.opus-codec.org/docs/opus_in_isobmff.html
    return $1891065cf37256e6$export$827f4ee28efc37('dOps', [
        $1891065cf37256e6$var$u8(0),
        $1891065cf37256e6$var$u8(outputChannelCount),
        $1891065cf37256e6$var$u16(preSkip),
        $1891065cf37256e6$var$u32(inputSampleRate),
        $1891065cf37256e6$var$i16(outputGain),
        $1891065cf37256e6$var$u8(channelMappingFamily),
        ...channelMappingTable
    ]);
};
const $1891065cf37256e6$export$f5b25847108edfc3 = (trackData)=>{
    const description = trackData.info.decoderConfig?.description;
    (0, $053d5bbcf6664967$export$a7a9523472993e97)(description);
    const bytes = (0, $053d5bbcf6664967$export$73470fd2221e6aef)(description);
    return $1891065cf37256e6$export$39b48787714acfef('dfLa', 0, 0, [
        ...bytes.subarray(4)
    ]);
};
/** PCM Configuration Box, ISO/IEC 23003-5. */ const $1891065cf37256e6$var$pcmC = (trackData)=>{
    const { littleEndian: littleEndian, sampleSize: sampleSize } = (0, $94511f4b46249ea3$export$560120a2d4e71dc2)(trackData.track.source._codec);
    const formatFlags = +littleEndian;
    return $1891065cf37256e6$export$39b48787714acfef('pcmC', 0, 0, [
        $1891065cf37256e6$var$u8(formatFlags),
        $1891065cf37256e6$var$u8(8 * sampleSize)
    ]);
};
const $1891065cf37256e6$export$cf7ea515e3f94033 = (compressionType, trackData)=>$1891065cf37256e6$export$827f4ee28efc37(compressionType, [
        Array(6).fill(0),
        $1891065cf37256e6$var$u16(1)
    ], [
        $1891065cf37256e6$var$SUBTITLE_CODEC_TO_CONFIGURATION_BOX[trackData.track.source._codec](trackData)
    ]);
const $1891065cf37256e6$export$8f9a7360c50a3b5c = (trackData)=>$1891065cf37256e6$export$827f4ee28efc37('vttC', [
        ...(0, $053d5bbcf6664967$export$f5d75491a17f02c).encode(trackData.info.config.description)
    ]);
const $1891065cf37256e6$export$5b9cf329e522a9d2 = (textConfig)=>$1891065cf37256e6$export$39b48787714acfef('txtC', 0, 0, [
        ...textConfig,
        0
    ]);
const $1891065cf37256e6$export$c1063a265f6056cd = (trackData)=>{
    return $1891065cf37256e6$export$39b48787714acfef('stts', 0, 0, [
        $1891065cf37256e6$var$u32(trackData.timeToSampleTable.length),
        trackData.timeToSampleTable.map((x)=>[
                $1891065cf37256e6$var$u32(x.sampleCount),
                $1891065cf37256e6$var$u32(x.sampleDelta)
            ])
    ]);
};
const $1891065cf37256e6$export$ada009fbca49d3a0 = (trackData)=>{
    if (trackData.samples.every((x)=>x.type === 'key')) return null; // No stss box -> every frame is a key frame
    const keySamples = [
        ...trackData.samples.entries()
    ].filter(([, sample])=>sample.type === 'key');
    return $1891065cf37256e6$export$39b48787714acfef('stss', 0, 0, [
        $1891065cf37256e6$var$u32(keySamples.length),
        keySamples.map(([index])=>$1891065cf37256e6$var$u32(index + 1))
    ]);
};
const $1891065cf37256e6$export$91ea402c832e6f11 = (trackData)=>{
    return $1891065cf37256e6$export$39b48787714acfef('stsc', 0, 0, [
        $1891065cf37256e6$var$u32(trackData.compactlyCodedChunkTable.length),
        trackData.compactlyCodedChunkTable.map((x)=>[
                $1891065cf37256e6$var$u32(x.firstChunk),
                $1891065cf37256e6$var$u32(x.samplesPerChunk),
                $1891065cf37256e6$var$u32(1)
            ])
    ]);
};
const $1891065cf37256e6$export$ad785f4b4d7e6d7 = (trackData)=>{
    if (trackData.type === 'audio' && trackData.info.requiresPcmTransformation) {
        const { sampleSize: sampleSize } = (0, $94511f4b46249ea3$export$560120a2d4e71dc2)(trackData.track.source._codec);
        // With PCM, every sample has the same size
        return $1891065cf37256e6$export$39b48787714acfef('stsz', 0, 0, [
            $1891065cf37256e6$var$u32(sampleSize * trackData.info.numberOfChannels),
            $1891065cf37256e6$var$u32(trackData.samples.reduce((acc, x)=>acc + (0, $d3ff0c06a870f18b$export$1f322e0cced0371b)(x.duration, trackData.timescale), 0))
        ]);
    }
    return $1891065cf37256e6$export$39b48787714acfef('stsz', 0, 0, [
        $1891065cf37256e6$var$u32(0),
        $1891065cf37256e6$var$u32(trackData.samples.length),
        trackData.samples.map((x)=>$1891065cf37256e6$var$u32(x.size))
    ]);
};
const $1891065cf37256e6$export$63cc23f51cc782bb = (trackData)=>{
    if (trackData.finalizedChunks.length > 0 && (0, $053d5bbcf6664967$export$4c7897fafd92b108)(trackData.finalizedChunks).offset >= 2 ** 32) // If the file is large, use the co64 box
    return $1891065cf37256e6$export$39b48787714acfef('co64', 0, 0, [
        $1891065cf37256e6$var$u32(trackData.finalizedChunks.length),
        trackData.finalizedChunks.map((x)=>$1891065cf37256e6$var$u64(x.offset))
    ]);
    return $1891065cf37256e6$export$39b48787714acfef('stco', 0, 0, [
        $1891065cf37256e6$var$u32(trackData.finalizedChunks.length),
        trackData.finalizedChunks.map((x)=>$1891065cf37256e6$var$u32(x.offset))
    ]);
};
const $1891065cf37256e6$export$568267ff42bd512e = (trackData)=>{
    return $1891065cf37256e6$export$39b48787714acfef('ctts', 1, 0, [
        $1891065cf37256e6$var$u32(trackData.compositionTimeOffsetTable.length),
        trackData.compositionTimeOffsetTable.map((x)=>[
                $1891065cf37256e6$var$u32(x.sampleCount),
                $1891065cf37256e6$var$i32(x.sampleCompositionTimeOffset)
            ])
    ]);
};
const $1891065cf37256e6$export$35752ae1995d4c1a = (trackData)=>{
    let leastDecodeToDisplayDelta = Infinity;
    let greatestDecodeToDisplayDelta = -Infinity;
    let compositionStartTime = Infinity;
    let compositionEndTime = -Infinity;
    (0, $053d5bbcf6664967$export$a7a9523472993e97)(trackData.compositionTimeOffsetTable.length > 0);
    (0, $053d5bbcf6664967$export$a7a9523472993e97)(trackData.samples.length > 0);
    for(let i = 0; i < trackData.compositionTimeOffsetTable.length; i++){
        const entry = trackData.compositionTimeOffsetTable[i];
        leastDecodeToDisplayDelta = Math.min(leastDecodeToDisplayDelta, entry.sampleCompositionTimeOffset);
        greatestDecodeToDisplayDelta = Math.max(greatestDecodeToDisplayDelta, entry.sampleCompositionTimeOffset);
    }
    for(let i = 0; i < trackData.samples.length; i++){
        const sample = trackData.samples[i];
        compositionStartTime = Math.min(compositionStartTime, (0, $d3ff0c06a870f18b$export$1f322e0cced0371b)(sample.timestamp, trackData.timescale));
        compositionEndTime = Math.max(compositionEndTime, (0, $d3ff0c06a870f18b$export$1f322e0cced0371b)(sample.timestamp + sample.duration, trackData.timescale));
    }
    const compositionToDtsShift = Math.max(-leastDecodeToDisplayDelta, 0);
    if (compositionEndTime >= 2 ** 31) // For very large files, the composition end time can't be represented in i32, so let's just scrap the box in
    // that case. QuickTime fails to read the file if there's a cslg box with version 1, so that's sadly not an
    // option.
    return null;
    return $1891065cf37256e6$export$39b48787714acfef('cslg', 0, 0, [
        $1891065cf37256e6$var$i32(compositionToDtsShift),
        $1891065cf37256e6$var$i32(leastDecodeToDisplayDelta),
        $1891065cf37256e6$var$i32(greatestDecodeToDisplayDelta),
        $1891065cf37256e6$var$i32(compositionStartTime),
        $1891065cf37256e6$var$i32(compositionEndTime)
    ]);
};
const $1891065cf37256e6$export$3790eea5725be2bc = (trackDatas)=>{
    return $1891065cf37256e6$export$827f4ee28efc37('mvex', undefined, trackDatas.map($1891065cf37256e6$export$6bc8fe6cd65ef475));
};
const $1891065cf37256e6$export$6bc8fe6cd65ef475 = (trackData)=>{
    return $1891065cf37256e6$export$39b48787714acfef('trex', 0, 0, [
        $1891065cf37256e6$var$u32(trackData.track.id),
        $1891065cf37256e6$var$u32(1),
        $1891065cf37256e6$var$u32(0),
        $1891065cf37256e6$var$u32(0),
        $1891065cf37256e6$var$u32(0)
    ]);
};
const $1891065cf37256e6$export$b354dc48aba357db = (sequenceNumber, trackDatas)=>{
    return $1891065cf37256e6$export$827f4ee28efc37('moof', undefined, [
        $1891065cf37256e6$export$c7814162ac5750f6(sequenceNumber),
        ...trackDatas.map($1891065cf37256e6$export$1b50dd7bc5183097)
    ]);
};
const $1891065cf37256e6$export$c7814162ac5750f6 = (sequenceNumber)=>{
    return $1891065cf37256e6$export$39b48787714acfef('mfhd', 0, 0, [
        $1891065cf37256e6$var$u32(sequenceNumber)
    ]);
};
const $1891065cf37256e6$var$fragmentSampleFlags = (sample)=>{
    let byte1 = 0;
    let byte2 = 0;
    const byte3 = 0;
    const byte4 = 0;
    const sampleIsDifferenceSample = sample.type === 'delta';
    byte2 |= +sampleIsDifferenceSample;
    if (sampleIsDifferenceSample) byte1 |= 1; // There is redundant coding in this sample
    else byte1 |= 2; // There is no redundant coding in this sample
    // Note that there are a lot of other flags to potentially set here, but most are irrelevant / non-necessary
    return byte1 << 24 | byte2 << 16 | byte3 << 8 | byte4;
};
const $1891065cf37256e6$export$1b50dd7bc5183097 = (trackData)=>{
    return $1891065cf37256e6$export$827f4ee28efc37('traf', undefined, [
        $1891065cf37256e6$export$da645835134d649e(trackData),
        $1891065cf37256e6$export$9cf8653b3cc4b960(trackData),
        $1891065cf37256e6$export$ce5b835a260dc013(trackData)
    ]);
};
const $1891065cf37256e6$export$da645835134d649e = (trackData)=>{
    (0, $053d5bbcf6664967$export$a7a9523472993e97)(trackData.currentChunk);
    let tfFlags = 0;
    tfFlags |= 0x00008; // Default sample duration present
    tfFlags |= 0x00010; // Default sample size present
    tfFlags |= 0x00020; // Default sample flags present
    tfFlags |= 0x20000; // Default base is moof
    // Prefer the second sample over the first one, as the first one is a sync sample and therefore the "odd one out"
    const referenceSample = trackData.currentChunk.samples[1] ?? trackData.currentChunk.samples[0];
    const referenceSampleInfo = {
        duration: referenceSample.timescaleUnitsToNextSample,
        size: referenceSample.size,
        flags: $1891065cf37256e6$var$fragmentSampleFlags(referenceSample)
    };
    return $1891065cf37256e6$export$39b48787714acfef('tfhd', 0, tfFlags, [
        $1891065cf37256e6$var$u32(trackData.track.id),
        $1891065cf37256e6$var$u32(referenceSampleInfo.duration),
        $1891065cf37256e6$var$u32(referenceSampleInfo.size),
        $1891065cf37256e6$var$u32(referenceSampleInfo.flags)
    ]);
};
const $1891065cf37256e6$export$9cf8653b3cc4b960 = (trackData)=>{
    (0, $053d5bbcf6664967$export$a7a9523472993e97)(trackData.currentChunk);
    return $1891065cf37256e6$export$39b48787714acfef('tfdt', 1, 0, [
        $1891065cf37256e6$var$u64((0, $d3ff0c06a870f18b$export$1f322e0cced0371b)(trackData.currentChunk.startTimestamp, trackData.timescale))
    ]);
};
const $1891065cf37256e6$export$ce5b835a260dc013 = (trackData)=>{
    (0, $053d5bbcf6664967$export$a7a9523472993e97)(trackData.currentChunk);
    const allSampleDurations = trackData.currentChunk.samples.map((x)=>x.timescaleUnitsToNextSample);
    const allSampleSizes = trackData.currentChunk.samples.map((x)=>x.size);
    const allSampleFlags = trackData.currentChunk.samples.map($1891065cf37256e6$var$fragmentSampleFlags);
    const allSampleCompositionTimeOffsets = trackData.currentChunk.samples.map((x)=>(0, $d3ff0c06a870f18b$export$1f322e0cced0371b)(x.timestamp - x.decodeTimestamp, trackData.timescale));
    const uniqueSampleDurations = new Set(allSampleDurations);
    const uniqueSampleSizes = new Set(allSampleSizes);
    const uniqueSampleFlags = new Set(allSampleFlags);
    const uniqueSampleCompositionTimeOffsets = new Set(allSampleCompositionTimeOffsets);
    const firstSampleFlagsPresent = uniqueSampleFlags.size === 2 && allSampleFlags[0] !== allSampleFlags[1];
    const sampleDurationPresent = uniqueSampleDurations.size > 1;
    const sampleSizePresent = uniqueSampleSizes.size > 1;
    const sampleFlagsPresent = !firstSampleFlagsPresent && uniqueSampleFlags.size > 1;
    const sampleCompositionTimeOffsetsPresent = uniqueSampleCompositionTimeOffsets.size > 1 || [
        ...uniqueSampleCompositionTimeOffsets
    ].some((x)=>x !== 0);
    let flags = 0;
    flags |= 0x0001; // Data offset present
    flags |= 0x0004 * +firstSampleFlagsPresent; // First sample flags present
    flags |= 0x0100 * +sampleDurationPresent; // Sample duration present
    flags |= 0x0200 * +sampleSizePresent; // Sample size present
    flags |= 0x0400 * +sampleFlagsPresent; // Sample flags present
    flags |= 0x0800 * +sampleCompositionTimeOffsetsPresent; // Sample composition time offsets present
    return $1891065cf37256e6$export$39b48787714acfef('trun', 1, flags, [
        $1891065cf37256e6$var$u32(trackData.currentChunk.samples.length),
        $1891065cf37256e6$var$u32(trackData.currentChunk.offset - trackData.currentChunk.moofOffset || 0),
        firstSampleFlagsPresent ? $1891065cf37256e6$var$u32(allSampleFlags[0]) : [],
        trackData.currentChunk.samples.map((_, i)=>[
                sampleDurationPresent ? $1891065cf37256e6$var$u32(allSampleDurations[i]) : [],
                sampleSizePresent ? $1891065cf37256e6$var$u32(allSampleSizes[i]) : [],
                sampleFlagsPresent ? $1891065cf37256e6$var$u32(allSampleFlags[i]) : [],
                // Sample composition time offsets
                sampleCompositionTimeOffsetsPresent ? $1891065cf37256e6$var$i32(allSampleCompositionTimeOffsets[i]) : []
            ])
    ]);
};
const $1891065cf37256e6$export$2a8573005b6e768d = (trackDatas)=>{
    return $1891065cf37256e6$export$827f4ee28efc37('mfra', undefined, [
        ...trackDatas.map($1891065cf37256e6$export$cb5fdc1178739972),
        $1891065cf37256e6$export$667c6b97aebd57a4()
    ]);
};
const $1891065cf37256e6$export$cb5fdc1178739972 = (trackData, trackIndex)=>{
    const version = 1; // Using this version allows us to use 64-bit time and offset values
    return $1891065cf37256e6$export$39b48787714acfef('tfra', version, 0, [
        $1891065cf37256e6$var$u32(trackData.track.id),
        $1891065cf37256e6$var$u32(63),
        $1891065cf37256e6$var$u32(trackData.finalizedChunks.length),
        trackData.finalizedChunks.map((chunk)=>[
                $1891065cf37256e6$var$u64((0, $d3ff0c06a870f18b$export$1f322e0cced0371b)(chunk.samples[0].timestamp, trackData.timescale)),
                $1891065cf37256e6$var$u64(chunk.moofOffset),
                $1891065cf37256e6$var$u32(trackIndex + 1),
                $1891065cf37256e6$var$u32(1),
                $1891065cf37256e6$var$u32(1)
            ])
    ]);
};
const $1891065cf37256e6$export$667c6b97aebd57a4 = ()=>{
    return $1891065cf37256e6$export$39b48787714acfef('mfro', 0, 0, [
        // This value needs to be overwritten manually from the outside, where the actual size of the enclosing mfra box
        // is known
        $1891065cf37256e6$var$u32(0)
    ]);
};
const $1891065cf37256e6$export$506f656b6d2bda8b = ()=>$1891065cf37256e6$export$827f4ee28efc37('vtte');
const $1891065cf37256e6$export$8538256249d56328 = (payload, timestamp, identifier, settings, sourceId)=>$1891065cf37256e6$export$827f4ee28efc37('vttc', undefined, [
        sourceId !== null ? $1891065cf37256e6$export$827f4ee28efc37('vsid', [
            $1891065cf37256e6$var$i32(sourceId)
        ]) : null,
        identifier !== null ? $1891065cf37256e6$export$827f4ee28efc37('iden', [
            ...(0, $053d5bbcf6664967$export$f5d75491a17f02c).encode(identifier)
        ]) : null,
        timestamp !== null ? $1891065cf37256e6$export$827f4ee28efc37('ctim', [
            ...(0, $053d5bbcf6664967$export$f5d75491a17f02c).encode((0, $c77d4d874d58660e$export$ad655d9645737731)(timestamp))
        ]) : null,
        settings !== null ? $1891065cf37256e6$export$827f4ee28efc37('sttg', [
            ...(0, $053d5bbcf6664967$export$f5d75491a17f02c).encode(settings)
        ]) : null,
        $1891065cf37256e6$export$827f4ee28efc37('payl', [
            ...(0, $053d5bbcf6664967$export$f5d75491a17f02c).encode(payload)
        ])
    ]);
const $1891065cf37256e6$export$c06c3a304d56a174 = (notes)=>$1891065cf37256e6$export$827f4ee28efc37('vtta', [
        ...(0, $053d5bbcf6664967$export$f5d75491a17f02c).encode(notes)
    ]);
const $1891065cf37256e6$var$VIDEO_CODEC_TO_BOX_NAME = {
    avc: 'avc1',
    hevc: 'hvc1',
    vp8: 'vp08',
    vp9: 'vp09',
    av1: 'av01'
};
const $1891065cf37256e6$var$VIDEO_CODEC_TO_CONFIGURATION_BOX = {
    avc: $1891065cf37256e6$export$1f524d04c45a4666,
    hevc: $1891065cf37256e6$export$211f058b3a16cd76,
    vp8: $1891065cf37256e6$export$c883f962e652afb5,
    vp9: $1891065cf37256e6$export$c883f962e652afb5,
    av1: $1891065cf37256e6$export$f76721e75bcb63eb
};
const $1891065cf37256e6$var$audioCodecToBoxName = (codec, isQuickTime)=>{
    switch(codec){
        case 'aac':
            return 'mp4a';
        case 'mp3':
            return 'mp4a';
        case 'opus':
            return 'Opus';
        case 'vorbis':
            return 'mp4a';
        case 'flac':
            return 'fLaC';
        case 'ulaw':
            return 'ulaw';
        case 'alaw':
            return 'alaw';
        case 'pcm-u8':
            return 'raw ';
        case 'pcm-s8':
            return 'sowt';
    }
    // Logic diverges here
    if (isQuickTime) switch(codec){
        case 'pcm-s16':
            return 'sowt';
        case 'pcm-s16be':
            return 'twos';
        case 'pcm-s24':
            return 'in24';
        case 'pcm-s24be':
            return 'in24';
        case 'pcm-s32':
            return 'in32';
        case 'pcm-s32be':
            return 'in32';
        case 'pcm-f32':
            return 'fl32';
        case 'pcm-f32be':
            return 'fl32';
        case 'pcm-f64':
            return 'fl64';
        case 'pcm-f64be':
            return 'fl64';
    }
    else switch(codec){
        case 'pcm-s16':
            return 'ipcm';
        case 'pcm-s16be':
            return 'ipcm';
        case 'pcm-s24':
            return 'ipcm';
        case 'pcm-s24be':
            return 'ipcm';
        case 'pcm-s32':
            return 'ipcm';
        case 'pcm-s32be':
            return 'ipcm';
        case 'pcm-f32':
            return 'fpcm';
        case 'pcm-f32be':
            return 'fpcm';
        case 'pcm-f64':
            return 'fpcm';
        case 'pcm-f64be':
            return 'fpcm';
    }
};
const $1891065cf37256e6$var$audioCodecToConfigurationBox = (codec, isQuickTime)=>{
    switch(codec){
        case 'aac':
            return $1891065cf37256e6$export$78af894123c9ca0;
        case 'mp3':
            return $1891065cf37256e6$export$78af894123c9ca0;
        case 'opus':
            return $1891065cf37256e6$export$a0bf1e50a7efaaa9;
        case 'vorbis':
            return $1891065cf37256e6$export$78af894123c9ca0;
        case 'flac':
            return $1891065cf37256e6$export$f5b25847108edfc3;
    }
    // Logic diverges here
    if (isQuickTime) switch(codec){
        case 'pcm-s24':
            return $1891065cf37256e6$export$3af1cb7633944de2;
        case 'pcm-s24be':
            return $1891065cf37256e6$export$3af1cb7633944de2;
        case 'pcm-s32':
            return $1891065cf37256e6$export$3af1cb7633944de2;
        case 'pcm-s32be':
            return $1891065cf37256e6$export$3af1cb7633944de2;
        case 'pcm-f32':
            return $1891065cf37256e6$export$3af1cb7633944de2;
        case 'pcm-f32be':
            return $1891065cf37256e6$export$3af1cb7633944de2;
        case 'pcm-f64':
            return $1891065cf37256e6$export$3af1cb7633944de2;
        case 'pcm-f64be':
            return $1891065cf37256e6$export$3af1cb7633944de2;
    }
    else switch(codec){
        case 'pcm-s16':
            return $1891065cf37256e6$var$pcmC;
        case 'pcm-s16be':
            return $1891065cf37256e6$var$pcmC;
        case 'pcm-s24':
            return $1891065cf37256e6$var$pcmC;
        case 'pcm-s24be':
            return $1891065cf37256e6$var$pcmC;
        case 'pcm-s32':
            return $1891065cf37256e6$var$pcmC;
        case 'pcm-s32be':
            return $1891065cf37256e6$var$pcmC;
        case 'pcm-f32':
            return $1891065cf37256e6$var$pcmC;
        case 'pcm-f32be':
            return $1891065cf37256e6$var$pcmC;
        case 'pcm-f64':
            return $1891065cf37256e6$var$pcmC;
        case 'pcm-f64be':
            return $1891065cf37256e6$var$pcmC;
    }
    return null;
};
const $1891065cf37256e6$var$SUBTITLE_CODEC_TO_BOX_NAME = {
    webvtt: 'wvtt'
};
const $1891065cf37256e6$var$SUBTITLE_CODEC_TO_CONFIGURATION_BOX = {
    webvtt: $1891065cf37256e6$export$8f9a7360c50a3b5c
};


/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ 
class $40161f4e778629b3$export$d78afe5e2e889016 {
    constructor(output){
        this.mutex = new (0, $053d5bbcf6664967$export$7ea9f882800689bb)();
        /**
         * This field is used to synchronize multiple MediaStreamTracks. They use the same time coordinate system across
         * tracks, and to ensure correct audio-video sync, we must use the same offset for all of them. The reason an offset
         * is needed at all is because the timestamps typically don't start at zero.
         */ this.firstMediaStreamTimestamp = null;
        this.trackTimestampInfo = new WeakMap();
        this.output = output;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onTrackClose(track) {}
    validateAndNormalizeTimestamp(track, timestampInSeconds, isKeyFrame) {
        timestampInSeconds += track.source._timestampOffset;
        let timestampInfo = this.trackTimestampInfo.get(track);
        if (!timestampInfo) {
            if (!isKeyFrame) throw new Error('First frame must be a key frame.');
            timestampInfo = {
                maxTimestamp: timestampInSeconds,
                maxTimestampBeforeLastKeyFrame: timestampInSeconds
            };
            this.trackTimestampInfo.set(track, timestampInfo);
        }
        if (timestampInSeconds < 0) throw new Error(`Timestamps must be non-negative (got ${timestampInSeconds}s).`);
        if (isKeyFrame) timestampInfo.maxTimestampBeforeLastKeyFrame = timestampInfo.maxTimestamp;
        if (timestampInSeconds < timestampInfo.maxTimestampBeforeLastKeyFrame) throw new Error(`Timestamps cannot be smaller than the highest timestamp of the previous run (a run begins with a` + ` key frame and ends right before the next key frame). Got ${timestampInSeconds}s, but highest` + ` timestamp is ${timestampInfo.maxTimestampBeforeLastKeyFrame}s.`);
        timestampInfo.maxTimestamp = Math.max(timestampInfo.maxTimestamp, timestampInSeconds);
        return timestampInSeconds;
    }
}









/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ const $5fbb61cf59b6d039$export$eb7b280f6b83fd69 = (info)=>{
    const base = info.hasVideo ? 'video/' : info.hasAudio ? 'audio/' : 'application/';
    let string = base + (info.isQuickTime ? 'quicktime' : 'mp4');
    if (info.codecStrings.length > 0) {
        const uniqueCodecMimeTypes = [
            ...new Set(info.codecStrings)
        ];
        string += `; codecs="${uniqueCodecMimeTypes.join(', ')}"`;
    }
    return string;
};


const $d3ff0c06a870f18b$export$10813e7e0cb0efe4 = 1000;
const $d3ff0c06a870f18b$var$TIMESTAMP_OFFSET = 2082844800; // Seconds between Jan 1 1904 and Jan 1 1970
const $d3ff0c06a870f18b$export$1f322e0cced0371b = (timeInSeconds, timescale, round = true)=>{
    const value = timeInSeconds * timescale;
    return round ? Math.round(value) : value;
};
class $d3ff0c06a870f18b$export$37d0e98dcab80fd3 extends (0, $40161f4e778629b3$export$d78afe5e2e889016) {
    constructor(output, format){
        super(output);
        this.auxTarget = new (0, $0170695b8ac54025$export$aac535e25712764c)();
        this.auxWriter = this.auxTarget._createWriter();
        this.auxBoxWriter = new (0, $1891065cf37256e6$export$fbc2d84bd32bc55f)(this.auxWriter);
        this.mdat = null;
        this.trackDatas = [];
        this.allTracksKnown = (0, $053d5bbcf6664967$export$283a1614f1b16769)();
        this.creationTime = Math.floor(Date.now() / 1000) + $d3ff0c06a870f18b$var$TIMESTAMP_OFFSET;
        this.finalizedChunks = [];
        this.nextFragmentNumber = 1;
        // Only relevant for fragmented files, to make sure new fragments start with the highest timestamp seen so far
        this.maxWrittenTimestamp = -Infinity;
        this.format = format;
        this.writer = output._writer;
        this.boxWriter = new (0, $1891065cf37256e6$export$fbc2d84bd32bc55f)(this.writer);
        this.isQuickTime = format instanceof (0, $89c2d87f884ee1df$export$b2d97c88a119c488);
        // If the fastStart option isn't defined, enable in-memory fast start if the target is an ArrayBuffer, as the
        // memory usage remains identical
        const fastStartDefault = this.writer instanceof (0, $9fedaf112e3db83b$export$ad1857906a425059) ? 'in-memory' : false;
        this.fastStart = format._options.fastStart ?? fastStartDefault;
        this.isFragmented = this.fastStart === 'fragmented';
        if (this.fastStart === 'in-memory' || this.isFragmented) this.writer.ensureMonotonicity = true;
        this.minimumFragmentDuration = format._options.minimumFragmentDuration ?? 1;
    }
    async start() {
        const release = await this.mutex.acquire();
        const holdsAvc = this.output._tracks.some((x)=>x.type === 'video' && x.source._codec === 'avc');
        if (this.format._options.onFtyp) this.writer.startTrackingWrites();
        this.boxWriter.writeBox((0, $1891065cf37256e6$export$7486382ce8a22acc)({
            isQuickTime: this.isQuickTime,
            holdsAvc: holdsAvc,
            fragmented: this.isFragmented
        }));
        if (this.format._options.onFtyp) {
            const { data: data, start: start } = this.writer.stopTrackingWrites();
            this.format._options.onFtyp(data, start);
        }
        if (this.fastStart === 'in-memory') this.mdat = (0, $1891065cf37256e6$export$2af587b6535fb1d3)(false);
        else if (this.isFragmented) ;
        else {
            if (this.format._options.onMdat) this.writer.startTrackingWrites();
            this.mdat = (0, $1891065cf37256e6$export$2af587b6535fb1d3)(true); // Reserve large size by default, can refine this when finalizing.
            this.boxWriter.writeBox(this.mdat);
        }
        await this.writer.flush();
        release();
    }
    allTracksAreKnown() {
        for (const track of this.output._tracks){
            if (!track.source._closed && !this.trackDatas.some((x)=>x.track === track)) return false; // We haven't seen a sample from this open track yet
        }
        return true;
    }
    async getMimeType() {
        await this.allTracksKnown.promise;
        const codecStrings = this.trackDatas.map((trackData)=>{
            if (trackData.type === 'video') return trackData.info.decoderConfig.codec;
            else if (trackData.type === 'audio') return trackData.info.decoderConfig.codec;
            else {
                const map = {
                    webvtt: 'wvtt'
                };
                return map[trackData.track.source._codec];
            }
        });
        return (0, $5fbb61cf59b6d039$export$eb7b280f6b83fd69)({
            isQuickTime: this.isQuickTime,
            hasVideo: this.trackDatas.some((x)=>x.type === 'video'),
            hasAudio: this.trackDatas.some((x)=>x.type === 'audio'),
            codecStrings: codecStrings
        });
    }
    getVideoTrackData(track, packet, meta) {
        const existingTrackData = this.trackDatas.find((x)=>x.track === track);
        if (existingTrackData) return existingTrackData;
        (0, $94511f4b46249ea3$export$c2a1d372ae0516d4)(meta);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(meta);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(meta.decoderConfig);
        const decoderConfig = {
            ...meta.decoderConfig
        };
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(decoderConfig.codedWidth !== undefined);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(decoderConfig.codedHeight !== undefined);
        let requiresAnnexBTransformation = false;
        if (track.source._codec === 'avc' && !decoderConfig.description) {
            // ISOBMFF can only hold AVC in the AVCC format, not in Annex B, but the missing description indicates
            // Annex B. This means we'll need to do some converterino.
            const decoderConfigurationRecord = (0, $e4e81989f7ab3f4b$export$5170fc4926a4cd0d)(packet.data);
            if (!decoderConfigurationRecord) throw new Error("Couldn't extract an AVCDecoderConfigurationRecord from the AVC packet. Make sure the packets are in Annex B format (as specified in ITU-T-REC-H.264) when not providing a description, or provide a description (must be an AVCDecoderConfigurationRecord as specified in ISO 14496-15) and ensure the packets are in AVCC format.");
            decoderConfig.description = (0, $e4e81989f7ab3f4b$export$82eb60e9f42d6ca8)(decoderConfigurationRecord);
            requiresAnnexBTransformation = true;
        } else if (track.source._codec === 'hevc' && !decoderConfig.description) {
            // ISOBMFF can only hold HEVC in the HEVC format, not in Annex B, but the missing description indicates
            // Annex B. This means we'll need to do some converterino.
            const decoderConfigurationRecord = (0, $e4e81989f7ab3f4b$export$8d721713e0db20f0)(packet.data);
            if (!decoderConfigurationRecord) throw new Error("Couldn't extract an HEVCDecoderConfigurationRecord from the HEVC packet. Make sure the packets are in Annex B format (as specified in ITU-T-REC-H.265) when not providing a description, or provide a description (must be an HEVCDecoderConfigurationRecord as specified in ISO 14496-15) and ensure the packets are in HEVC format.");
            decoderConfig.description = (0, $e4e81989f7ab3f4b$export$5681eb4508de93bf)(decoderConfigurationRecord);
            requiresAnnexBTransformation = true;
        }
        // The frame rate set by the user may not be an integer. Since timescale is an integer, we'll approximate the
        // frame time (inverse of frame rate) with a rational number, then use that approximation's denominator
        // as the timescale.
        const timescale = (0, $053d5bbcf6664967$export$b1c38697fb776eb0)(1 / (track.metadata.frameRate ?? 57600), 1e6).denominator;
        const newTrackData = {
            muxer: this,
            track: track,
            type: 'video',
            info: {
                width: decoderConfig.codedWidth,
                height: decoderConfig.codedHeight,
                decoderConfig: decoderConfig,
                requiresAnnexBTransformation: requiresAnnexBTransformation
            },
            timescale: timescale,
            samples: [],
            sampleQueue: [],
            timestampProcessingQueue: [],
            timeToSampleTable: [],
            compositionTimeOffsetTable: [],
            lastTimescaleUnits: null,
            lastSample: null,
            finalizedChunks: [],
            currentChunk: null,
            compactlyCodedChunkTable: []
        };
        this.trackDatas.push(newTrackData);
        this.trackDatas.sort((a, b)=>a.track.id - b.track.id);
        if (this.allTracksAreKnown()) this.allTracksKnown.resolve();
        return newTrackData;
    }
    getAudioTrackData(track, meta) {
        const existingTrackData = this.trackDatas.find((x)=>x.track === track);
        if (existingTrackData) return existingTrackData;
        (0, $94511f4b46249ea3$export$61959146e5b74178)(meta);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(meta);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(meta.decoderConfig);
        const newTrackData = {
            muxer: this,
            track: track,
            type: 'audio',
            info: {
                numberOfChannels: meta.decoderConfig.numberOfChannels,
                sampleRate: meta.decoderConfig.sampleRate,
                decoderConfig: meta.decoderConfig,
                requiresPcmTransformation: !this.isFragmented && (0, $94511f4b46249ea3$export$58c594b1fe7e587b).includes(track.source._codec)
            },
            timescale: meta.decoderConfig.sampleRate,
            samples: [],
            sampleQueue: [],
            timestampProcessingQueue: [],
            timeToSampleTable: [],
            compositionTimeOffsetTable: [],
            lastTimescaleUnits: null,
            lastSample: null,
            finalizedChunks: [],
            currentChunk: null,
            compactlyCodedChunkTable: []
        };
        this.trackDatas.push(newTrackData);
        this.trackDatas.sort((a, b)=>a.track.id - b.track.id);
        if (this.allTracksAreKnown()) this.allTracksKnown.resolve();
        return newTrackData;
    }
    getSubtitleTrackData(track, meta) {
        const existingTrackData = this.trackDatas.find((x)=>x.track === track);
        if (existingTrackData) return existingTrackData;
        (0, $94511f4b46249ea3$export$8b9df0b71f2f06b5)(meta);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(meta);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(meta.config);
        const newTrackData = {
            muxer: this,
            track: track,
            type: 'subtitle',
            info: {
                config: meta.config
            },
            timescale: 1000,
            samples: [],
            sampleQueue: [],
            timestampProcessingQueue: [],
            timeToSampleTable: [],
            compositionTimeOffsetTable: [],
            lastTimescaleUnits: null,
            lastSample: null,
            finalizedChunks: [],
            currentChunk: null,
            compactlyCodedChunkTable: [],
            lastCueEndTimestamp: 0,
            cueQueue: [],
            nextSourceId: 0,
            cueToSourceId: new WeakMap()
        };
        this.trackDatas.push(newTrackData);
        this.trackDatas.sort((a, b)=>a.track.id - b.track.id);
        if (this.allTracksAreKnown()) this.allTracksKnown.resolve();
        return newTrackData;
    }
    async addEncodedVideoPacket(track, packet, meta) {
        const release = await this.mutex.acquire();
        try {
            const trackData = this.getVideoTrackData(track, packet, meta);
            let packetData = packet.data;
            if (trackData.info.requiresAnnexBTransformation) {
                const transformedData = (0, $e4e81989f7ab3f4b$export$47d7308d95e7dd68)(packetData);
                if (!transformedData) throw new Error("Failed to transform packet data. Make sure all packets are provided in Annex B format, as specified in ITU-T-REC-H.264 and ITU-T-REC-H.265.");
                packetData = transformedData;
            }
            const timestamp = this.validateAndNormalizeTimestamp(trackData.track, packet.timestamp, packet.type === 'key');
            const internalSample = this.createSampleForTrack(trackData, packetData, timestamp, packet.duration, packet.type);
            await this.registerSample(trackData, internalSample);
        } finally{
            release();
        }
    }
    async addEncodedAudioPacket(track, packet, meta) {
        const release = await this.mutex.acquire();
        try {
            const trackData = this.getAudioTrackData(track, meta);
            const timestamp = this.validateAndNormalizeTimestamp(trackData.track, packet.timestamp, packet.type === 'key');
            const internalSample = this.createSampleForTrack(trackData, packet.data, timestamp, packet.duration, packet.type);
            if (trackData.info.requiresPcmTransformation) await this.maybePadWithSilence(trackData, timestamp);
            await this.registerSample(trackData, internalSample);
        } finally{
            release();
        }
    }
    async maybePadWithSilence(trackData, untilTimestamp) {
        // The PCM transformation assumes that all samples are contiguous. This is not something that is enforced, so
        // we need to pad the "holes" in between samples (and before the first sample) with additional
        // "silence samples".
        const lastSample = (0, $053d5bbcf6664967$export$4c7897fafd92b108)(trackData.samples);
        const lastEndTimestamp = lastSample ? lastSample.timestamp + lastSample.duration : 0;
        const delta = untilTimestamp - lastEndTimestamp;
        const deltaInTimescale = $d3ff0c06a870f18b$export$1f322e0cced0371b(delta, trackData.timescale);
        if (deltaInTimescale > 0) {
            const { sampleSize: sampleSize, silentValue: silentValue } = (0, $94511f4b46249ea3$export$560120a2d4e71dc2)(trackData.info.decoderConfig.codec);
            const samplesNeeded = deltaInTimescale * trackData.info.numberOfChannels;
            const data = new Uint8Array(sampleSize * samplesNeeded).fill(silentValue);
            const paddingSample = this.createSampleForTrack(trackData, new Uint8Array(data.buffer), lastEndTimestamp, delta, 'key');
            await this.registerSample(trackData, paddingSample);
        }
    }
    async addSubtitleCue(track, cue, meta) {
        const release = await this.mutex.acquire();
        try {
            const trackData = this.getSubtitleTrackData(track, meta);
            this.validateAndNormalizeTimestamp(trackData.track, cue.timestamp, true);
            if (track.source._codec === 'webvtt') {
                trackData.cueQueue.push(cue);
                await this.processWebVTTCues(trackData, cue.timestamp);
            }
        } finally{
            release();
        }
    }
    async processWebVTTCues(trackData, until) {
        // WebVTT cues need to undergo special processing as empty sections need to be padded out with samples, and
        // overlapping samples require special logic. The algorithm produces the format specified in ISO 14496-30.
        while(trackData.cueQueue.length > 0){
            const timestamps = new Set([]);
            for (const cue of trackData.cueQueue){
                (0, $053d5bbcf6664967$export$a7a9523472993e97)(cue.timestamp <= until);
                (0, $053d5bbcf6664967$export$a7a9523472993e97)(trackData.lastCueEndTimestamp <= cue.timestamp + cue.duration);
                timestamps.add(Math.max(cue.timestamp, trackData.lastCueEndTimestamp)); // Start timestamp
                timestamps.add(cue.timestamp + cue.duration); // End timestamp
            }
            const sortedTimestamps = [
                ...timestamps
            ].sort((a, b)=>a - b);
            // These are the timestamps of the next sample we'll create:
            const sampleStart = sortedTimestamps[0];
            const sampleEnd = sortedTimestamps[1] ?? sampleStart;
            if (until < sampleEnd) break;
            // We may need to pad out empty space with an vtte box
            if (trackData.lastCueEndTimestamp < sampleStart) {
                this.auxWriter.seek(0);
                const box = (0, $1891065cf37256e6$export$506f656b6d2bda8b)();
                this.auxBoxWriter.writeBox(box);
                const body = this.auxWriter.getSlice(0, this.auxWriter.getPos());
                const sample = this.createSampleForTrack(trackData, body, trackData.lastCueEndTimestamp, sampleStart - trackData.lastCueEndTimestamp, 'key');
                await this.registerSample(trackData, sample);
                trackData.lastCueEndTimestamp = sampleStart;
            }
            this.auxWriter.seek(0);
            for(let i = 0; i < trackData.cueQueue.length; i++){
                const cue = trackData.cueQueue[i];
                if (cue.timestamp >= sampleEnd) break;
                (0, $c77d4d874d58660e$export$605131a15c078e1b).lastIndex = 0;
                const containsTimestamp = (0, $c77d4d874d58660e$export$605131a15c078e1b).test(cue.text);
                const endTimestamp = cue.timestamp + cue.duration;
                let sourceId = trackData.cueToSourceId.get(cue);
                if (sourceId === undefined && sampleEnd < endTimestamp) {
                    // We know this cue will appear in more than one sample, therefore we need to mark it with a
                    // unique ID
                    sourceId = trackData.nextSourceId++;
                    trackData.cueToSourceId.set(cue, sourceId);
                }
                if (cue.notes) {
                    // Any notes/comments are included in a special vtta box
                    const box = (0, $1891065cf37256e6$export$c06c3a304d56a174)(cue.notes);
                    this.auxBoxWriter.writeBox(box);
                }
                const box = (0, $1891065cf37256e6$export$8538256249d56328)(cue.text, containsTimestamp ? sampleStart : null, cue.identifier ?? null, cue.settings ?? null, sourceId ?? null);
                this.auxBoxWriter.writeBox(box);
                if (endTimestamp === sampleEnd) // The cue won't appear in any future sample, so we're done with it
                trackData.cueQueue.splice(i--, 1);
            }
            const body = this.auxWriter.getSlice(0, this.auxWriter.getPos());
            const sample = this.createSampleForTrack(trackData, body, sampleStart, sampleEnd - sampleStart, 'key');
            await this.registerSample(trackData, sample);
            trackData.lastCueEndTimestamp = sampleEnd;
        }
    }
    createSampleForTrack(trackData, data, timestamp, duration, type) {
        const sample = {
            timestamp: timestamp,
            decodeTimestamp: timestamp,
            duration: duration,
            data: data,
            size: data.byteLength,
            type: type,
            timescaleUnitsToNextSample: $d3ff0c06a870f18b$export$1f322e0cced0371b(duration, trackData.timescale)
        };
        return sample;
    }
    processTimestamps(trackData, nextSample) {
        if (trackData.timestampProcessingQueue.length === 0) return;
        if (trackData.type === 'audio' && trackData.info.requiresPcmTransformation) {
            let totalDuration = 0;
            // Compute the total duration in the track timescale (which is equal to the amount of PCM audio samples)
            // and simply say that's how many new samples there are.
            for(let i = 0; i < trackData.timestampProcessingQueue.length; i++){
                const sample = trackData.timestampProcessingQueue[i];
                const duration = $d3ff0c06a870f18b$export$1f322e0cced0371b(sample.duration, trackData.timescale);
                totalDuration += duration;
            }
            if (trackData.timeToSampleTable.length === 0) trackData.timeToSampleTable.push({
                sampleCount: totalDuration,
                sampleDelta: 1
            });
            else {
                const lastEntry = (0, $053d5bbcf6664967$export$4c7897fafd92b108)(trackData.timeToSampleTable);
                lastEntry.sampleCount += totalDuration;
            }
            trackData.timestampProcessingQueue.length = 0;
            return;
        }
        const sortedTimestamps = trackData.timestampProcessingQueue.map((x)=>x.timestamp).sort((a, b)=>a - b);
        for(let i = 0; i < trackData.timestampProcessingQueue.length; i++){
            const sample = trackData.timestampProcessingQueue[i];
            // Since the user only supplies presentation time, but these may be out of order, we reverse-engineer from
            // that a sensible decode timestamp. The notion of a decode timestamp doesn't really make sense
            // (presentation timestamp & decode order are all you need), but it is a concept in ISOBMFF so we need to
            // model it.
            sample.decodeTimestamp = sortedTimestamps[i];
            if (!this.isFragmented && trackData.lastTimescaleUnits === null) // In non-fragmented files, the first decode timestamp is always zero. If the first presentation
            // timestamp isn't zero, we'll simply use the composition time offset to achieve it.
            sample.decodeTimestamp = 0;
            const sampleCompositionTimeOffset = $d3ff0c06a870f18b$export$1f322e0cced0371b(sample.timestamp - sample.decodeTimestamp, trackData.timescale);
            const durationInTimescale = $d3ff0c06a870f18b$export$1f322e0cced0371b(sample.duration, trackData.timescale);
            if (trackData.lastTimescaleUnits !== null) {
                (0, $053d5bbcf6664967$export$a7a9523472993e97)(trackData.lastSample);
                const timescaleUnits = $d3ff0c06a870f18b$export$1f322e0cced0371b(sample.decodeTimestamp, trackData.timescale, false);
                const delta = Math.round(timescaleUnits - trackData.lastTimescaleUnits);
                (0, $053d5bbcf6664967$export$a7a9523472993e97)(delta >= 0);
                trackData.lastTimescaleUnits += delta;
                trackData.lastSample.timescaleUnitsToNextSample = delta;
                if (!this.isFragmented) {
                    let lastTableEntry = (0, $053d5bbcf6664967$export$4c7897fafd92b108)(trackData.timeToSampleTable);
                    (0, $053d5bbcf6664967$export$a7a9523472993e97)(lastTableEntry);
                    if (lastTableEntry.sampleCount === 1) {
                        lastTableEntry.sampleDelta = delta;
                        const entryBefore = trackData.timeToSampleTable[trackData.timeToSampleTable.length - 2];
                        if (entryBefore && entryBefore.sampleDelta === delta) {
                            // If the delta is the same as the previous one, merge the two entries
                            entryBefore.sampleCount++;
                            trackData.timeToSampleTable.pop();
                            lastTableEntry = entryBefore;
                        }
                    } else if (lastTableEntry.sampleDelta !== delta) {
                        // The delta has changed, so we need a new entry to reach the current sample
                        lastTableEntry.sampleCount--;
                        trackData.timeToSampleTable.push(lastTableEntry = {
                            sampleCount: 1,
                            sampleDelta: delta
                        });
                    }
                    if (lastTableEntry.sampleDelta === durationInTimescale) // The sample's duration matches the delta, so we can increment the count
                    lastTableEntry.sampleCount++;
                    else // Add a new entry in order to maintain the last sample's true duration
                    trackData.timeToSampleTable.push({
                        sampleCount: 1,
                        sampleDelta: durationInTimescale
                    });
                    const lastCompositionTimeOffsetTableEntry = (0, $053d5bbcf6664967$export$4c7897fafd92b108)(trackData.compositionTimeOffsetTable);
                    (0, $053d5bbcf6664967$export$a7a9523472993e97)(lastCompositionTimeOffsetTableEntry);
                    if (lastCompositionTimeOffsetTableEntry.sampleCompositionTimeOffset === sampleCompositionTimeOffset) // Simply increment the count
                    lastCompositionTimeOffsetTableEntry.sampleCount++;
                    else // The composition time offset has changed, so create a new entry with the new composition time
                    // offset
                    trackData.compositionTimeOffsetTable.push({
                        sampleCount: 1,
                        sampleCompositionTimeOffset: sampleCompositionTimeOffset
                    });
                }
            } else {
                // Decode timestamp of the first sample
                trackData.lastTimescaleUnits = $d3ff0c06a870f18b$export$1f322e0cced0371b(sample.decodeTimestamp, trackData.timescale, false);
                if (!this.isFragmented) {
                    trackData.timeToSampleTable.push({
                        sampleCount: 1,
                        sampleDelta: durationInTimescale
                    });
                    trackData.compositionTimeOffsetTable.push({
                        sampleCount: 1,
                        sampleCompositionTimeOffset: sampleCompositionTimeOffset
                    });
                }
            }
            trackData.lastSample = sample;
        }
        trackData.timestampProcessingQueue.length = 0;
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(trackData.lastSample);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(trackData.lastTimescaleUnits !== null);
        if (nextSample !== undefined && trackData.lastSample.timescaleUnitsToNextSample === 0) {
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(nextSample.type === 'key');
            // Given the next sample, we can make a guess about the duration of the last sample. This avoids having
            // the last sample's duration in each fragment be "0" for fragmented files. The guess we make here is
            // actually correct most of the time, since typically, no delta frame with a lower timestamp follows the key
            // frame (although it can happen).
            const timescaleUnits = $d3ff0c06a870f18b$export$1f322e0cced0371b(nextSample.timestamp, trackData.timescale, false);
            const delta = Math.round(timescaleUnits - trackData.lastTimescaleUnits);
            trackData.lastSample.timescaleUnitsToNextSample = delta;
        }
    }
    async registerSample(trackData, sample) {
        if (sample.type === 'key') this.processTimestamps(trackData, sample);
        trackData.timestampProcessingQueue.push(sample);
        if (this.isFragmented) {
            trackData.sampleQueue.push(sample);
            await this.interleaveSamples();
        } else await this.addSampleToTrack(trackData, sample);
    }
    async addSampleToTrack(trackData, sample) {
        if (!this.isFragmented) trackData.samples.push(sample);
        let beginNewChunk = false;
        if (!trackData.currentChunk) beginNewChunk = true;
        else {
            // Timestamp don't need to be monotonic (think B-frames), so we may need to update the start timestamp of
            // the chunk
            trackData.currentChunk.startTimestamp = Math.min(trackData.currentChunk.startTimestamp, sample.timestamp);
            const currentChunkDuration = sample.timestamp - trackData.currentChunk.startTimestamp;
            if (this.isFragmented) {
                // We can only finalize this fragment (and begin a new one) if we know that each track will be able to
                // start the new one with a key frame.
                const keyFrameQueuedEverywhere = this.trackDatas.every((otherTrackData)=>{
                    if (trackData === otherTrackData) return sample.type === 'key';
                    const firstQueuedSample = otherTrackData.sampleQueue[0];
                    if (firstQueuedSample) return firstQueuedSample.type === 'key';
                    return otherTrackData.track.source._closed;
                });
                if (currentChunkDuration >= this.minimumFragmentDuration && keyFrameQueuedEverywhere && sample.timestamp > this.maxWrittenTimestamp) {
                    beginNewChunk = true;
                    await this.finalizeFragment();
                }
            } else beginNewChunk = currentChunkDuration >= 0.5; // Chunk is long enough, we need a new one
        }
        if (beginNewChunk) {
            if (trackData.currentChunk) await this.finalizeCurrentChunk(trackData);
            trackData.currentChunk = {
                startTimestamp: sample.timestamp,
                samples: [],
                offset: null,
                moofOffset: null
            };
        }
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(trackData.currentChunk);
        trackData.currentChunk.samples.push(sample);
        if (this.isFragmented) this.maxWrittenTimestamp = Math.max(this.maxWrittenTimestamp, sample.timestamp);
    }
    async finalizeCurrentChunk(trackData) {
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(!this.isFragmented);
        if (!trackData.currentChunk) return;
        trackData.finalizedChunks.push(trackData.currentChunk);
        this.finalizedChunks.push(trackData.currentChunk);
        let sampleCount = trackData.currentChunk.samples.length;
        if (trackData.type === 'audio' && trackData.info.requiresPcmTransformation) sampleCount = trackData.currentChunk.samples.reduce((acc, sample)=>acc + $d3ff0c06a870f18b$export$1f322e0cced0371b(sample.duration, trackData.timescale), 0);
        if (trackData.compactlyCodedChunkTable.length === 0 || (0, $053d5bbcf6664967$export$4c7897fafd92b108)(trackData.compactlyCodedChunkTable).samplesPerChunk !== sampleCount) trackData.compactlyCodedChunkTable.push({
            firstChunk: trackData.finalizedChunks.length,
            samplesPerChunk: sampleCount
        });
        if (this.fastStart === 'in-memory') {
            trackData.currentChunk.offset = 0; // We'll compute the proper offset when finalizing
            return;
        }
        // Write out the data
        trackData.currentChunk.offset = this.writer.getPos();
        for (const sample of trackData.currentChunk.samples){
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(sample.data);
            this.writer.write(sample.data);
            sample.data = null; // Can be GC'd
        }
        await this.writer.flush();
    }
    async interleaveSamples(isFinalCall = false) {
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.isFragmented);
        if (!isFinalCall) {
            if (!this.allTracksAreKnown()) return; // We can't interleave yet as we don't yet know how many tracks we'll truly have
        }
        outer: while(true){
            let trackWithMinTimestamp = null;
            let minTimestamp = Infinity;
            for (const trackData of this.trackDatas){
                if (!isFinalCall && trackData.sampleQueue.length === 0 && !trackData.track.source._closed) break outer;
                if (trackData.sampleQueue.length > 0 && trackData.sampleQueue[0].timestamp < minTimestamp) {
                    trackWithMinTimestamp = trackData;
                    minTimestamp = trackData.sampleQueue[0].timestamp;
                }
            }
            if (!trackWithMinTimestamp) break;
            const sample = trackWithMinTimestamp.sampleQueue.shift();
            await this.addSampleToTrack(trackWithMinTimestamp, sample);
        }
    }
    async finalizeFragment(flushWriter = true) {
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.isFragmented);
        const fragmentNumber = this.nextFragmentNumber++;
        if (fragmentNumber === 1) {
            if (this.format._options.onMoov) this.writer.startTrackingWrites();
            // Write the moov box now that we have all decoder configs
            const movieBox = (0, $1891065cf37256e6$export$464b8c6103d8110e)(this.trackDatas, this.creationTime, true);
            this.boxWriter.writeBox(movieBox);
            if (this.format._options.onMoov) {
                const { data: data, start: start } = this.writer.stopTrackingWrites();
                this.format._options.onMoov(data, start);
            }
        }
        // Not all tracks need to be present in every fragment
        const tracksInFragment = this.trackDatas.filter((x)=>x.currentChunk);
        // Create an initial moof box and measure it; we need this to know where the following mdat box will begin
        const moofBox = (0, $1891065cf37256e6$export$b354dc48aba357db)(fragmentNumber, tracksInFragment);
        const moofOffset = this.writer.getPos();
        const mdatStartPos = moofOffset + this.boxWriter.measureBox(moofBox);
        // Header with large size. We always reserve 16 bytes for it even if we don't end up using the large size.
        const mdatHeaderSize = 16;
        let currentPos = mdatStartPos + mdatHeaderSize;
        let fragmentStartTimestamp = Infinity;
        for (const trackData of tracksInFragment){
            trackData.currentChunk.offset = currentPos;
            trackData.currentChunk.moofOffset = moofOffset;
            for (const sample of trackData.currentChunk.samples)currentPos += sample.size;
            fragmentStartTimestamp = Math.min(fragmentStartTimestamp, trackData.currentChunk.startTimestamp);
        }
        const mdatSize = currentPos - mdatStartPos;
        if (this.format._options.onMoof) this.writer.startTrackingWrites();
        const newMoofBox = (0, $1891065cf37256e6$export$b354dc48aba357db)(fragmentNumber, tracksInFragment);
        this.boxWriter.writeBox(newMoofBox);
        if (this.format._options.onMoof) {
            const { data: data, start: start } = this.writer.stopTrackingWrites();
            this.format._options.onMoof(data, start, fragmentStartTimestamp);
        }
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.writer.getPos() === mdatStartPos);
        if (this.format._options.onMdat) this.writer.startTrackingWrites();
        const mdatBox = (0, $1891065cf37256e6$export$2af587b6535fb1d3)(mdatSize >= 2 ** 32);
        mdatBox.size = mdatSize;
        this.boxWriter.writeBox(mdatBox);
        this.writer.seek(mdatStartPos + mdatHeaderSize);
        // Write sample data
        for (const trackData of tracksInFragment)for (const sample of trackData.currentChunk.samples){
            this.writer.write(sample.data);
            sample.data = null; // Can be GC'd
        }
        if (this.format._options.onMdat) {
            const { data: data, start: start } = this.writer.stopTrackingWrites();
            this.format._options.onMdat(data, start);
        }
        for (const trackData of tracksInFragment){
            trackData.finalizedChunks.push(trackData.currentChunk);
            this.finalizedChunks.push(trackData.currentChunk);
            trackData.currentChunk = null;
        }
        if (flushWriter) await this.writer.flush();
    }
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    async onTrackClose(track) {
        const release = await this.mutex.acquire();
        if (track.type === 'subtitle' && track.source._codec === 'webvtt') {
            const trackData = this.trackDatas.find((x)=>x.track === track);
            if (trackData) await this.processWebVTTCues(trackData, Infinity);
        }
        if (this.allTracksAreKnown()) this.allTracksKnown.resolve();
        if (this.isFragmented) // Since a track is now closed, we may be able to write out chunks that were previously waiting
        await this.interleaveSamples();
        release();
    }
    /** Finalizes the file, making it ready for use. Must be called after all video and audio chunks have been added. */ async finalize() {
        const release = await this.mutex.acquire();
        this.allTracksKnown.resolve();
        for (const trackData of this.trackDatas)if (trackData.type === 'subtitle' && trackData.track.source._codec === 'webvtt') await this.processWebVTTCues(trackData, Infinity);
        if (this.isFragmented) {
            await this.interleaveSamples(true);
            for (const trackData of this.trackDatas)this.processTimestamps(trackData);
            await this.finalizeFragment(false); // Don't flush the last fragment as we will flush it with the mfra box
        } else for (const trackData of this.trackDatas){
            this.processTimestamps(trackData);
            await this.finalizeCurrentChunk(trackData);
        }
        if (this.fastStart === 'in-memory') {
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.mdat);
            let mdatSize;
            // We know how many chunks there are, but computing the chunk positions requires an iterative approach:
            // In order to know where the first chunk should go, we first need to know the size of the moov box. But we
            // cannot write a proper moov box without first knowing all chunk positions. So, we generate a tentative
            // moov box with placeholder values (0) for the chunk offsets to be able to compute its size. If it then
            // turns out that appending all chunks exceeds 4 GiB, we need to repeat this process, now with the co64 box
            // being used in the moov box instead, which will make it larger. After that, we definitely know the final
            // size of the moov box and can compute the proper chunk positions.
            for(let i = 0; i < 2; i++){
                const movieBox = (0, $1891065cf37256e6$export$464b8c6103d8110e)(this.trackDatas, this.creationTime);
                const movieBoxSize = this.boxWriter.measureBox(movieBox);
                mdatSize = this.boxWriter.measureBox(this.mdat);
                let currentChunkPos = this.writer.getPos() + movieBoxSize + mdatSize;
                for (const chunk of this.finalizedChunks){
                    chunk.offset = currentChunkPos;
                    for (const { data: data } of chunk.samples){
                        (0, $053d5bbcf6664967$export$a7a9523472993e97)(data);
                        currentChunkPos += data.byteLength;
                        mdatSize += data.byteLength;
                    }
                }
                if (currentChunkPos < 2 ** 32) break;
                if (mdatSize >= 2 ** 32) this.mdat.largeSize = true;
            }
            if (this.format._options.onMoov) this.writer.startTrackingWrites();
            const movieBox = (0, $1891065cf37256e6$export$464b8c6103d8110e)(this.trackDatas, this.creationTime);
            this.boxWriter.writeBox(movieBox);
            if (this.format._options.onMoov) {
                const { data: data, start: start } = this.writer.stopTrackingWrites();
                this.format._options.onMoov(data, start);
            }
            if (this.format._options.onMdat) this.writer.startTrackingWrites();
            this.mdat.size = mdatSize;
            this.boxWriter.writeBox(this.mdat);
            for (const chunk of this.finalizedChunks)for (const sample of chunk.samples){
                (0, $053d5bbcf6664967$export$a7a9523472993e97)(sample.data);
                this.writer.write(sample.data);
                sample.data = null;
            }
            if (this.format._options.onMdat) {
                const { data: data, start: start } = this.writer.stopTrackingWrites();
                this.format._options.onMdat(data, start);
            }
        } else if (this.isFragmented) {
            // Append the mfra box to the end of the file for better random access
            const startPos = this.writer.getPos();
            const mfraBox = (0, $1891065cf37256e6$export$2a8573005b6e768d)(this.trackDatas);
            this.boxWriter.writeBox(mfraBox);
            // Patch the 'size' field of the mfro box at the end of the mfra box now that we know its actual size
            const mfraBoxSize = this.writer.getPos() - startPos;
            this.writer.seek(this.writer.getPos() - 4);
            this.boxWriter.writeU32(mfraBoxSize);
        } else {
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.mdat);
            const mdatPos = this.boxWriter.offsets.get(this.mdat);
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(mdatPos !== undefined);
            const mdatSize = this.writer.getPos() - mdatPos;
            this.mdat.size = mdatSize;
            this.mdat.largeSize = mdatSize >= 2 ** 32; // Only use the large size if we need it
            this.boxWriter.patchBox(this.mdat);
            if (this.format._options.onMdat) {
                const { data: data, start: start } = this.writer.stopTrackingWrites();
                this.format._options.onMdat(data, start);
            }
            if (this.format._options.onMoov) this.writer.startTrackingWrites();
            const movieBox = (0, $1891065cf37256e6$export$464b8c6103d8110e)(this.trackDatas, this.creationTime);
            this.boxWriter.writeBox(movieBox);
            if (this.format._options.onMoov) {
                const { data: data, start: start } = this.writer.stopTrackingWrites();
                this.format._options.onMoov(data, start);
            }
        }
        release();
    }
}


/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ 
/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ /** Wrapper around a number to be able to differentiate it in the writer. */ class $c25fcc1eb0f0e74f$export$a558265fd6cfa617 {
    constructor(value){
        this.value = value;
    }
}
class $c25fcc1eb0f0e74f$export$670c4b6cbbc07368 {
    constructor(value){
        this.value = value;
    }
}
class $c25fcc1eb0f0e74f$export$dbf3c5dec5726052 {
    constructor(value){
        this.value = value;
    }
}
var $c25fcc1eb0f0e74f$export$92f4fef17576347c;
(function(EBMLId) {
    EBMLId[EBMLId["EBML"] = 440786851] = "EBML";
    EBMLId[EBMLId["EBMLVersion"] = 17030] = "EBMLVersion";
    EBMLId[EBMLId["EBMLReadVersion"] = 17143] = "EBMLReadVersion";
    EBMLId[EBMLId["EBMLMaxIDLength"] = 17138] = "EBMLMaxIDLength";
    EBMLId[EBMLId["EBMLMaxSizeLength"] = 17139] = "EBMLMaxSizeLength";
    EBMLId[EBMLId["DocType"] = 17026] = "DocType";
    EBMLId[EBMLId["DocTypeVersion"] = 17031] = "DocTypeVersion";
    EBMLId[EBMLId["DocTypeReadVersion"] = 17029] = "DocTypeReadVersion";
    EBMLId[EBMLId["SeekHead"] = 290298740] = "SeekHead";
    EBMLId[EBMLId["Seek"] = 19899] = "Seek";
    EBMLId[EBMLId["SeekID"] = 21419] = "SeekID";
    EBMLId[EBMLId["SeekPosition"] = 21420] = "SeekPosition";
    EBMLId[EBMLId["Duration"] = 17545] = "Duration";
    EBMLId[EBMLId["Info"] = 357149030] = "Info";
    EBMLId[EBMLId["TimestampScale"] = 2807729] = "TimestampScale";
    EBMLId[EBMLId["MuxingApp"] = 19840] = "MuxingApp";
    EBMLId[EBMLId["WritingApp"] = 22337] = "WritingApp";
    EBMLId[EBMLId["Tracks"] = 374648427] = "Tracks";
    EBMLId[EBMLId["TrackEntry"] = 174] = "TrackEntry";
    EBMLId[EBMLId["TrackNumber"] = 215] = "TrackNumber";
    EBMLId[EBMLId["TrackUID"] = 29637] = "TrackUID";
    EBMLId[EBMLId["TrackType"] = 131] = "TrackType";
    EBMLId[EBMLId["FlagEnabled"] = 185] = "FlagEnabled";
    EBMLId[EBMLId["FlagDefault"] = 136] = "FlagDefault";
    EBMLId[EBMLId["FlagForced"] = 21930] = "FlagForced";
    EBMLId[EBMLId["FlagLacing"] = 156] = "FlagLacing";
    EBMLId[EBMLId["Language"] = 2274716] = "Language";
    EBMLId[EBMLId["CodecID"] = 134] = "CodecID";
    EBMLId[EBMLId["CodecPrivate"] = 25506] = "CodecPrivate";
    EBMLId[EBMLId["CodecDelay"] = 22186] = "CodecDelay";
    EBMLId[EBMLId["SeekPreRoll"] = 22203] = "SeekPreRoll";
    EBMLId[EBMLId["DefaultDuration"] = 2352003] = "DefaultDuration";
    EBMLId[EBMLId["Video"] = 224] = "Video";
    EBMLId[EBMLId["PixelWidth"] = 176] = "PixelWidth";
    EBMLId[EBMLId["PixelHeight"] = 186] = "PixelHeight";
    EBMLId[EBMLId["Audio"] = 225] = "Audio";
    EBMLId[EBMLId["SamplingFrequency"] = 181] = "SamplingFrequency";
    EBMLId[EBMLId["Channels"] = 159] = "Channels";
    EBMLId[EBMLId["BitDepth"] = 25188] = "BitDepth";
    EBMLId[EBMLId["Segment"] = 408125543] = "Segment";
    EBMLId[EBMLId["SimpleBlock"] = 163] = "SimpleBlock";
    EBMLId[EBMLId["BlockGroup"] = 160] = "BlockGroup";
    EBMLId[EBMLId["Block"] = 161] = "Block";
    EBMLId[EBMLId["BlockAdditions"] = 30113] = "BlockAdditions";
    EBMLId[EBMLId["BlockMore"] = 166] = "BlockMore";
    EBMLId[EBMLId["BlockAdditional"] = 165] = "BlockAdditional";
    EBMLId[EBMLId["BlockAddID"] = 238] = "BlockAddID";
    EBMLId[EBMLId["BlockDuration"] = 155] = "BlockDuration";
    EBMLId[EBMLId["ReferenceBlock"] = 251] = "ReferenceBlock";
    EBMLId[EBMLId["Cluster"] = 524531317] = "Cluster";
    EBMLId[EBMLId["Timestamp"] = 231] = "Timestamp";
    EBMLId[EBMLId["Cues"] = 475249515] = "Cues";
    EBMLId[EBMLId["CuePoint"] = 187] = "CuePoint";
    EBMLId[EBMLId["CueTime"] = 179] = "CueTime";
    EBMLId[EBMLId["CueTrackPositions"] = 183] = "CueTrackPositions";
    EBMLId[EBMLId["CueTrack"] = 247] = "CueTrack";
    EBMLId[EBMLId["CueClusterPosition"] = 241] = "CueClusterPosition";
    EBMLId[EBMLId["Colour"] = 21936] = "Colour";
    EBMLId[EBMLId["MatrixCoefficients"] = 21937] = "MatrixCoefficients";
    EBMLId[EBMLId["TransferCharacteristics"] = 21946] = "TransferCharacteristics";
    EBMLId[EBMLId["Primaries"] = 21947] = "Primaries";
    EBMLId[EBMLId["Range"] = 21945] = "Range";
    EBMLId[EBMLId["Projection"] = 30320] = "Projection";
    EBMLId[EBMLId["ProjectionType"] = 30321] = "ProjectionType";
    EBMLId[EBMLId["ProjectionPoseRoll"] = 30325] = "ProjectionPoseRoll";
    EBMLId[EBMLId["Attachments"] = 423732329] = "Attachments";
    EBMLId[EBMLId["Chapters"] = 272869232] = "Chapters";
    EBMLId[EBMLId["Tags"] = 307544935] = "Tags";
})($c25fcc1eb0f0e74f$export$92f4fef17576347c || ($c25fcc1eb0f0e74f$export$92f4fef17576347c = {}));
const $c25fcc1eb0f0e74f$export$4f5fbf3554ef03a1 = [
    $c25fcc1eb0f0e74f$export$92f4fef17576347c.EBML,
    $c25fcc1eb0f0e74f$export$92f4fef17576347c.Segment
];
const $c25fcc1eb0f0e74f$export$ad82c43f81560569 = [
    $c25fcc1eb0f0e74f$export$92f4fef17576347c.EBMLMaxIDLength,
    $c25fcc1eb0f0e74f$export$92f4fef17576347c.EBMLMaxSizeLength,
    $c25fcc1eb0f0e74f$export$92f4fef17576347c.SeekHead,
    $c25fcc1eb0f0e74f$export$92f4fef17576347c.Info,
    $c25fcc1eb0f0e74f$export$92f4fef17576347c.Cluster,
    $c25fcc1eb0f0e74f$export$92f4fef17576347c.Tracks,
    $c25fcc1eb0f0e74f$export$92f4fef17576347c.Cues,
    $c25fcc1eb0f0e74f$export$92f4fef17576347c.Attachments,
    $c25fcc1eb0f0e74f$export$92f4fef17576347c.Chapters,
    $c25fcc1eb0f0e74f$export$92f4fef17576347c.Tags
];
const $c25fcc1eb0f0e74f$export$56b8aa0d62897efa = [
    ...$c25fcc1eb0f0e74f$export$4f5fbf3554ef03a1,
    ...$c25fcc1eb0f0e74f$export$ad82c43f81560569
];
const $c25fcc1eb0f0e74f$export$678165a2eb4bb3fb = (value)=>{
    if (value < 256) return 1;
    else if (value < 65536) return 2;
    else if (value < 16777216) return 3;
    else if (value < 2 ** 32) return 4;
    else if (value < 2 ** 40) return 5;
    else return 6;
};
const $c25fcc1eb0f0e74f$export$9ce2bce515f960ee = (value)=>{
    if (value >= -64 && value < 64) return 1;
    else if (value >= -8192 && value < 8192) return 2;
    else if (value >= -1048576 && value < 1048576) return 3;
    else if (value >= -134217728 && value < 134217728) return 4;
    else if (value >= -(2 ** 34) && value < 2 ** 34) return 5;
    else return 6;
};
const $c25fcc1eb0f0e74f$export$637303e0a36e5fae = (value)=>{
    if (value < 127) /** Top bit is set, leaving 7 bits to hold the integer, but we can't store
         * 127 because "all bits set to one" is a reserved value. Same thing for the
         * other cases below:
         */ return 1;
    else if (value < 16383) return 2;
    else if (value < 2097151) return 3;
    else if (value < 268435455) return 4;
    else if (value < 2 ** 35 - 1) return 5;
    else if (value < 2 ** 42 - 1) return 6;
    else throw new Error('EBML varint size not supported ' + value);
};
class $c25fcc1eb0f0e74f$export$11011e8c5f0bfc4f {
    constructor(writer){
        this.writer = writer;
        this.helper = new Uint8Array(8);
        this.helperView = new DataView(this.helper.buffer);
        /**
         * Stores the position from the start of the file to where EBML elements have been written. This is used to
         * rewrite/edit elements that were already added before, and to measure sizes of things.
         */ this.offsets = new WeakMap();
        /** Same as offsets, but stores position where the element's data starts (after ID and size fields). */ this.dataOffsets = new WeakMap();
    }
    writeByte(value) {
        this.helperView.setUint8(0, value);
        this.writer.write(this.helper.subarray(0, 1));
    }
    writeFloat32(value) {
        this.helperView.setFloat32(0, value, false);
        this.writer.write(this.helper.subarray(0, 4));
    }
    writeFloat64(value) {
        this.helperView.setFloat64(0, value, false);
        this.writer.write(this.helper);
    }
    writeUnsignedInt(value, width = $c25fcc1eb0f0e74f$export$678165a2eb4bb3fb(value)) {
        let pos = 0;
        // Each case falls through:
        switch(width){
            case 6:
                // Need to use division to access >32 bits of floating point var
                this.helperView.setUint8(pos++, value / 2 ** 40 | 0);
            // eslint-disable-next-line no-fallthrough
            case 5:
                this.helperView.setUint8(pos++, value / 2 ** 32 | 0);
            // eslint-disable-next-line no-fallthrough
            case 4:
                this.helperView.setUint8(pos++, value >> 24);
            // eslint-disable-next-line no-fallthrough
            case 3:
                this.helperView.setUint8(pos++, value >> 16);
            // eslint-disable-next-line no-fallthrough
            case 2:
                this.helperView.setUint8(pos++, value >> 8);
            // eslint-disable-next-line no-fallthrough
            case 1:
                this.helperView.setUint8(pos++, value);
                break;
            default:
                throw new Error('Bad unsigned int size ' + width);
        }
        this.writer.write(this.helper.subarray(0, pos));
    }
    writeSignedInt(value, width = $c25fcc1eb0f0e74f$export$9ce2bce515f960ee(value)) {
        if (value < 0) // Two's complement stuff
        value += 2 ** (width * 8);
        this.writeUnsignedInt(value, width);
    }
    writeVarInt(value, width = $c25fcc1eb0f0e74f$export$637303e0a36e5fae(value)) {
        let pos = 0;
        switch(width){
            case 1:
                this.helperView.setUint8(pos++, 128 | value);
                break;
            case 2:
                this.helperView.setUint8(pos++, 64 | value >> 8);
                this.helperView.setUint8(pos++, value);
                break;
            case 3:
                this.helperView.setUint8(pos++, 32 | value >> 16);
                this.helperView.setUint8(pos++, value >> 8);
                this.helperView.setUint8(pos++, value);
                break;
            case 4:
                this.helperView.setUint8(pos++, 16 | value >> 24);
                this.helperView.setUint8(pos++, value >> 16);
                this.helperView.setUint8(pos++, value >> 8);
                this.helperView.setUint8(pos++, value);
                break;
            case 5:
                /**
                 * JavaScript converts its doubles to 32-bit integers for bitwise
                 * operations, so we need to do a division by 2^32 instead of a
                 * right-shift of 32 to retain those top 3 bits
                 */ this.helperView.setUint8(pos++, 8 | value / 2 ** 32 & 0x7);
                this.helperView.setUint8(pos++, value >> 24);
                this.helperView.setUint8(pos++, value >> 16);
                this.helperView.setUint8(pos++, value >> 8);
                this.helperView.setUint8(pos++, value);
                break;
            case 6:
                this.helperView.setUint8(pos++, 4 | value / 2 ** 40 & 0x3);
                this.helperView.setUint8(pos++, value / 2 ** 32 | 0);
                this.helperView.setUint8(pos++, value >> 24);
                this.helperView.setUint8(pos++, value >> 16);
                this.helperView.setUint8(pos++, value >> 8);
                this.helperView.setUint8(pos++, value);
                break;
            default:
                throw new Error('Bad EBML varint size ' + width);
        }
        this.writer.write(this.helper.subarray(0, pos));
    }
    // Assumes the string is ASCII
    writeString(str) {
        this.writer.write(new Uint8Array(str.split('').map((x)=>x.charCodeAt(0))));
    }
    writeEBML(data) {
        if (data === null) return;
        if (data instanceof Uint8Array) this.writer.write(data);
        else if (Array.isArray(data)) for (const elem of data)this.writeEBML(elem);
        else {
            this.offsets.set(data, this.writer.getPos());
            this.writeUnsignedInt(data.id); // ID field
            if (Array.isArray(data.data)) {
                const sizePos = this.writer.getPos();
                const sizeSize = data.size === -1 ? 1 : data.size ?? 4;
                if (data.size === -1) // Write the reserved all-one-bits marker for unknown/unbounded size.
                this.writeByte(0xff);
                else this.writer.seek(this.writer.getPos() + sizeSize);
                const startPos = this.writer.getPos();
                this.dataOffsets.set(data, startPos);
                this.writeEBML(data.data);
                if (data.size !== -1) {
                    const size = this.writer.getPos() - startPos;
                    const endPos = this.writer.getPos();
                    this.writer.seek(sizePos);
                    this.writeVarInt(size, sizeSize);
                    this.writer.seek(endPos);
                }
            } else if (typeof data.data === 'number') {
                const size = data.size ?? $c25fcc1eb0f0e74f$export$678165a2eb4bb3fb(data.data);
                this.writeVarInt(size);
                this.writeUnsignedInt(data.data, size);
            } else if (typeof data.data === 'string') {
                this.writeVarInt(data.data.length);
                this.writeString(data.data);
            } else if (data.data instanceof Uint8Array) {
                this.writeVarInt(data.data.byteLength, data.size);
                this.writer.write(data.data);
            } else if (data.data instanceof $c25fcc1eb0f0e74f$export$a558265fd6cfa617) {
                this.writeVarInt(4);
                this.writeFloat32(data.data.value);
            } else if (data.data instanceof $c25fcc1eb0f0e74f$export$670c4b6cbbc07368) {
                this.writeVarInt(8);
                this.writeFloat64(data.data.value);
            } else if (data.data instanceof $c25fcc1eb0f0e74f$export$dbf3c5dec5726052) {
                const size = data.size ?? $c25fcc1eb0f0e74f$export$9ce2bce515f960ee(data.data.value);
                this.writeVarInt(size);
                this.writeSignedInt(data.data.value, size);
            }
        }
    }
}
const $c25fcc1eb0f0e74f$var$MAX_VAR_INT_SIZE = 8;
const $c25fcc1eb0f0e74f$export$1dbe2cabc83a7935 = 2; // 1-byte ID and 1-byte size
const $c25fcc1eb0f0e74f$export$73688e8300f1b5bf = 4 + $c25fcc1eb0f0e74f$var$MAX_VAR_INT_SIZE; // 4-byte ID and 8-byte size
class $c25fcc1eb0f0e74f$export$921a988e0f40c14c {
    constructor(reader){
        this.reader = reader;
        this.pos = 0;
    }
    readBytes(length) {
        const { view: view, offset: offset } = this.reader.getViewAndOffset(this.pos, this.pos + length);
        this.pos += length;
        return new Uint8Array(view.buffer, offset, length);
    }
    readU8() {
        const { view: view, offset: offset } = this.reader.getViewAndOffset(this.pos, this.pos + 1);
        this.pos++;
        return view.getUint8(offset);
    }
    readS16() {
        const { view: view, offset: offset } = this.reader.getViewAndOffset(this.pos, this.pos + 2);
        this.pos += 2;
        return view.getInt16(offset, false);
    }
    readVarIntSize() {
        const { view: view, offset: offset } = this.reader.getViewAndOffset(this.pos, this.pos + 1);
        const firstByte = view.getUint8(offset);
        let width = 1;
        let mask = 0x80;
        while((firstByte & mask) === 0 && width < 8){
            width++;
            mask >>= 1;
        }
        return width;
    }
    readVarInt() {
        // Read the first byte to determine the width of the variable-length integer
        const { view: view, offset: offset } = this.reader.getViewAndOffset(this.pos, this.pos + 1);
        const firstByte = view.getUint8(offset);
        // Find the position of VINT_MARKER, which determines the width
        let width = 1;
        let mask = 128;
        while((firstByte & mask) === 0 && width < $c25fcc1eb0f0e74f$var$MAX_VAR_INT_SIZE){
            width++;
            mask >>= 1;
        }
        const { view: fullView, offset: fullOffset } = this.reader.getViewAndOffset(this.pos, this.pos + width);
        // First byte's value needs the marker bit cleared
        let value = firstByte & mask - 1;
        // Read remaining bytes
        for(let i = 1; i < width; i++){
            value *= 256;
            value += fullView.getUint8(fullOffset + i);
        }
        this.pos += width;
        return value;
    }
    readUnsignedInt(width) {
        if (width < 1 || width > 8) throw new Error('Bad unsigned int size ' + width);
        const { view: view, offset: offset } = this.reader.getViewAndOffset(this.pos, this.pos + width);
        let value = 0;
        // Read bytes from most significant to least significant
        for(let i = 0; i < width; i++){
            value *= 256;
            value += view.getUint8(offset + i);
        }
        this.pos += width;
        return value;
    }
    readSignedInt(width) {
        let value = this.readUnsignedInt(width);
        // If the highest bit is set, convert from two's complement
        if (value & 1 << width * 8 - 1) value -= 2 ** (width * 8);
        return value;
    }
    readFloat(width) {
        if (width === 0) return 0;
        if (width !== 4 && width !== 8) throw new Error('Bad float size ' + width);
        const { view: view, offset: offset } = this.reader.getViewAndOffset(this.pos, this.pos + width);
        const value = width === 4 ? view.getFloat32(offset, false) : view.getFloat64(offset, false);
        this.pos += width;
        return value;
    }
    readString(length) {
        const { view: view, offset: offset } = this.reader.getViewAndOffset(this.pos, this.pos + length);
        this.pos += length;
        return String.fromCharCode(...new Uint8Array(view.buffer, offset, length));
    }
    readElementId() {
        const size = this.readVarIntSize();
        const id = this.readUnsignedInt(size);
        return id;
    }
    readElementSize() {
        let size = this.readU8();
        if (size === 0xff) size = null;
        else {
            this.pos--;
            size = this.readVarInt();
            // In some (livestreamed) files, this is the value of the size field. While this technically is just a very
            // large number, it is intended to behave like the reserved size 0xFF, meaning the size is undefined. We
            // catch the number here. Note that it cannot be perfectly represented as a double, but the comparison works
            // nonetheless.
            // eslint-disable-next-line no-loss-of-precision
            if (size === 0x00ffffffffffffff) size = null;
        }
        return size;
    }
    readElementHeader() {
        const id = this.readElementId();
        const size = this.readElementSize();
        return {
            id: id,
            size: size
        };
    }
    /** Returns the byte offset in the file of the next element with a matching ID. */ async searchForNextElementId(ids, until) {
        const loadChunkSize = 2 ** 20; // 1 MiB
        const idsSet = new Set(ids);
        while(this.pos < until - $c25fcc1eb0f0e74f$export$73688e8300f1b5bf){
            if (!this.reader.rangeIsLoaded(this.pos, this.pos + $c25fcc1eb0f0e74f$export$73688e8300f1b5bf)) await this.reader.loadRange(this.pos, Math.min(this.pos + loadChunkSize, until));
            const elementStartPos = this.pos;
            const elementHeader = this.readElementHeader();
            if (idsSet.has(elementHeader.id)) return elementStartPos;
            $c25fcc1eb0f0e74f$export$113a1ae1f7b4a1ee(elementHeader.size);
            this.pos += elementHeader.size;
        }
        return null;
    }
}
const $c25fcc1eb0f0e74f$export$db8af6179132f20d = {
    'avc': 'V_MPEG4/ISO/AVC',
    'hevc': 'V_MPEGH/ISO/HEVC',
    'vp8': 'V_VP8',
    'vp9': 'V_VP9',
    'av1': 'V_AV1',
    'aac': 'A_AAC',
    'mp3': 'A_MPEG/L3',
    'opus': 'A_OPUS',
    'vorbis': 'A_VORBIS',
    'flac': 'A_FLAC',
    'pcm-u8': 'A_PCM/INT/LIT',
    'pcm-s16': 'A_PCM/INT/LIT',
    'pcm-s16be': 'A_PCM/INT/BIG',
    'pcm-s24': 'A_PCM/INT/LIT',
    'pcm-s24be': 'A_PCM/INT/BIG',
    'pcm-s32': 'A_PCM/INT/LIT',
    'pcm-s32be': 'A_PCM/INT/BIG',
    'pcm-f32': 'A_PCM/FLOAT/IEEE',
    'pcm-f64': 'A_PCM/FLOAT/IEEE',
    'webvtt': 'S_TEXT/WEBVTT'
};
function $c25fcc1eb0f0e74f$export$113a1ae1f7b4a1ee(size) {
    if (size === null) throw new Error('Undefined element size is used in a place where it is not supported.');
}


/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ const $e94e5bfa82a491af$export$1e9f6402772832b9 = (info)=>{
    const base = info.hasVideo ? 'video/' : info.hasAudio ? 'audio/' : 'application/';
    let string = base + (info.isWebM ? 'webm' : 'x-matroska');
    if (info.codecStrings.length > 0) {
        const uniqueCodecMimeTypes = [
            ...new Set(info.codecStrings.filter(Boolean))
        ];
        string += `; codecs="${uniqueCodecMimeTypes.join(', ')}"`;
    }
    return string;
};







const $acf6fc97ef2526f7$var$MIN_CLUSTER_TIMESTAMP_MS = -(2 ** 15);
const $acf6fc97ef2526f7$var$MAX_CLUSTER_TIMESTAMP_MS = 2 ** 15 - 1;
const $acf6fc97ef2526f7$var$APP_NAME = 'https://github.com/Vanilagy/mediabunny';
const $acf6fc97ef2526f7$var$SEGMENT_SIZE_BYTES = 6;
const $acf6fc97ef2526f7$var$CLUSTER_SIZE_BYTES = 5;
const $acf6fc97ef2526f7$var$TRACK_TYPE_MAP = {
    video: 1,
    audio: 2,
    subtitle: 17
};
class $acf6fc97ef2526f7$export$8290c5c130ddf16b extends (0, $40161f4e778629b3$export$d78afe5e2e889016) {
    constructor(output, format){
        super(output);
        this.trackDatas = [];
        this.allTracksKnown = (0, $053d5bbcf6664967$export$283a1614f1b16769)();
        this.segment = null;
        this.segmentInfo = null;
        this.seekHead = null;
        this.tracksElement = null;
        this.segmentDuration = null;
        this.cues = null;
        this.currentCluster = null;
        this.currentClusterStartMsTimestamp = null;
        this.currentClusterMaxMsTimestamp = null;
        this.trackDatasInCurrentCluster = new Map();
        this.duration = 0;
        this.writer = output._writer;
        this.format = format;
        this.ebmlWriter = new (0, $c25fcc1eb0f0e74f$export$11011e8c5f0bfc4f)(this.writer);
        if (this.format._options.appendOnly) this.writer.ensureMonotonicity = true;
    }
    async start() {
        const release = await this.mutex.acquire();
        this.writeEBMLHeader();
        if (!this.format._options.appendOnly) this.createSeekHead();
        this.createSegmentInfo();
        this.createCues();
        await this.writer.flush();
        release();
    }
    writeEBMLHeader() {
        if (this.format._options.onEbmlHeader) this.writer.startTrackingWrites();
        const ebmlHeader = {
            id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).EBML,
            data: [
                {
                    id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).EBMLVersion,
                    data: 1
                },
                {
                    id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).EBMLReadVersion,
                    data: 1
                },
                {
                    id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).EBMLMaxIDLength,
                    data: 4
                },
                {
                    id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).EBMLMaxSizeLength,
                    data: 8
                },
                {
                    id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).DocType,
                    data: this.format instanceof (0, $89c2d87f884ee1df$export$8313ce77aed075b8) ? 'webm' : 'matroska'
                },
                {
                    id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).DocTypeVersion,
                    data: 2
                },
                {
                    id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).DocTypeReadVersion,
                    data: 2
                }
            ]
        };
        this.ebmlWriter.writeEBML(ebmlHeader);
        if (this.format._options.onEbmlHeader) {
            const { data: data, start: start } = this.writer.stopTrackingWrites(); // start should be 0
            this.format._options.onEbmlHeader(data, start);
        }
    }
    /**
     * Creates a SeekHead element which is positioned near the start of the file and allows the media player to seek to
     * relevant sections more easily. Since we don't know the positions of those sections yet, we'll set them later.
     */ createSeekHead() {
        const kaxCues = new Uint8Array([
            0x1c,
            0x53,
            0xbb,
            0x6b
        ]);
        const kaxInfo = new Uint8Array([
            0x15,
            0x49,
            0xa9,
            0x66
        ]);
        const kaxTracks = new Uint8Array([
            0x16,
            0x54,
            0xae,
            0x6b
        ]);
        const seekHead = {
            id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).SeekHead,
            data: [
                {
                    id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).Seek,
                    data: [
                        {
                            id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).SeekID,
                            data: kaxCues
                        },
                        {
                            id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).SeekPosition,
                            size: 5,
                            data: 0
                        }
                    ]
                },
                {
                    id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).Seek,
                    data: [
                        {
                            id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).SeekID,
                            data: kaxInfo
                        },
                        {
                            id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).SeekPosition,
                            size: 5,
                            data: 0
                        }
                    ]
                },
                {
                    id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).Seek,
                    data: [
                        {
                            id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).SeekID,
                            data: kaxTracks
                        },
                        {
                            id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).SeekPosition,
                            size: 5,
                            data: 0
                        }
                    ]
                }
            ]
        };
        this.seekHead = seekHead;
    }
    createSegmentInfo() {
        const segmentDuration = {
            id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).Duration,
            data: new (0, $c25fcc1eb0f0e74f$export$670c4b6cbbc07368)(0)
        };
        this.segmentDuration = segmentDuration;
        const segmentInfo = {
            id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).Info,
            data: [
                {
                    id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).TimestampScale,
                    data: 1e6
                },
                {
                    id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).MuxingApp,
                    data: $acf6fc97ef2526f7$var$APP_NAME
                },
                {
                    id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).WritingApp,
                    data: $acf6fc97ef2526f7$var$APP_NAME
                },
                !this.format._options.appendOnly ? segmentDuration : null
            ]
        };
        this.segmentInfo = segmentInfo;
    }
    createTracks() {
        const tracksElement = {
            id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).Tracks,
            data: []
        };
        this.tracksElement = tracksElement;
        for (const trackData of this.trackDatas){
            const codecId = (0, $c25fcc1eb0f0e74f$export$db8af6179132f20d)[trackData.track.source._codec];
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(codecId);
            let seekPreRollNs = 0;
            if (trackData.type === 'audio' && trackData.track.source._codec === 'opus') {
                seekPreRollNs = 1e6 * 80; // In "Matroska ticks" (nanoseconds)
                const description = trackData.info.decoderConfig.description;
                if (description) {
                    const bytes = (0, $053d5bbcf6664967$export$73470fd2221e6aef)(description);
                    const header = (0, $e4e81989f7ab3f4b$export$f126d711230ceb2)(bytes);
                    // Use the preSkip value from the header
                    seekPreRollNs = Math.round(1e9 * (header.preSkip / (0, $94511f4b46249ea3$export$8cafa39936c6eeba)));
                }
            }
            tracksElement.data.push({
                id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).TrackEntry,
                data: [
                    {
                        id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).TrackNumber,
                        data: trackData.track.id
                    },
                    {
                        id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).TrackUID,
                        data: trackData.track.id
                    },
                    {
                        id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).TrackType,
                        data: $acf6fc97ef2526f7$var$TRACK_TYPE_MAP[trackData.type]
                    },
                    {
                        id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).FlagLacing,
                        data: 0
                    },
                    {
                        id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).Language,
                        data: trackData.track.metadata.languageCode ?? (0, $053d5bbcf6664967$export$af15dfb067c7ab59)
                    },
                    {
                        id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).CodecID,
                        data: codecId
                    },
                    {
                        id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).CodecDelay,
                        data: 0
                    },
                    {
                        id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).SeekPreRoll,
                        data: seekPreRollNs
                    },
                    trackData.type === 'video' ? this.videoSpecificTrackInfo(trackData) : null,
                    trackData.type === 'audio' ? this.audioSpecificTrackInfo(trackData) : null,
                    trackData.type === 'subtitle' ? this.subtitleSpecificTrackInfo(trackData) : null
                ]
            });
        }
    }
    videoSpecificTrackInfo(trackData) {
        const { frameRate: frameRate, rotation: rotation } = trackData.track.metadata;
        const elements = [
            trackData.info.decoderConfig.description ? {
                id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).CodecPrivate,
                data: (0, $053d5bbcf6664967$export$73470fd2221e6aef)(trackData.info.decoderConfig.description)
            } : null,
            frameRate ? {
                id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).DefaultDuration,
                data: 1e9 / frameRate
            } : null
        ];
        // Convert from clockwise to counter-clockwise
        const flippedRotation = rotation ? (0, $053d5bbcf6664967$export$c552f3b8491c68b8)(-rotation) : 0;
        const colorSpace = trackData.info.decoderConfig.colorSpace;
        const videoElement = {
            id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).Video,
            data: [
                {
                    id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).PixelWidth,
                    data: trackData.info.width
                },
                {
                    id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).PixelHeight,
                    data: trackData.info.height
                },
                (0, $053d5bbcf6664967$export$17ed7af6b4f218ca)(colorSpace) ? {
                    id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).Colour,
                    data: [
                        {
                            id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).MatrixCoefficients,
                            data: (0, $053d5bbcf6664967$export$62b3c37e3f8b5eb4)[colorSpace.matrix]
                        },
                        {
                            id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).TransferCharacteristics,
                            data: (0, $053d5bbcf6664967$export$36a5c840f44dac9a)[colorSpace.transfer]
                        },
                        {
                            id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).Primaries,
                            data: (0, $053d5bbcf6664967$export$c9d0dddad4eef393)[colorSpace.primaries]
                        },
                        {
                            id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).Range,
                            data: colorSpace.fullRange ? 2 : 1
                        }
                    ]
                } : null,
                flippedRotation ? {
                    id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).Projection,
                    data: [
                        {
                            id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).ProjectionType,
                            data: 0
                        },
                        {
                            id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).ProjectionPoseRoll,
                            data: new (0, $c25fcc1eb0f0e74f$export$a558265fd6cfa617)((flippedRotation + 180) % 360 - 180)
                        }
                    ]
                } : null
            ]
        };
        elements.push(videoElement);
        return elements;
    }
    audioSpecificTrackInfo(trackData) {
        const pcmInfo = (0, $94511f4b46249ea3$export$58c594b1fe7e587b).includes(trackData.track.source._codec) ? (0, $94511f4b46249ea3$export$560120a2d4e71dc2)(trackData.track.source._codec) : null;
        return [
            trackData.info.decoderConfig.description ? {
                id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).CodecPrivate,
                data: (0, $053d5bbcf6664967$export$73470fd2221e6aef)(trackData.info.decoderConfig.description)
            } : null,
            {
                id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).Audio,
                data: [
                    {
                        id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).SamplingFrequency,
                        data: new (0, $c25fcc1eb0f0e74f$export$a558265fd6cfa617)(trackData.info.sampleRate)
                    },
                    {
                        id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).Channels,
                        data: trackData.info.numberOfChannels
                    },
                    pcmInfo ? {
                        id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).BitDepth,
                        data: 8 * pcmInfo.sampleSize
                    } : null
                ]
            }
        ];
    }
    subtitleSpecificTrackInfo(trackData) {
        return [
            {
                id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).CodecPrivate,
                data: (0, $053d5bbcf6664967$export$f5d75491a17f02c).encode(trackData.info.config.description)
            }
        ];
    }
    createSegment() {
        const segment = {
            id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).Segment,
            size: this.format._options.appendOnly ? -1 : $acf6fc97ef2526f7$var$SEGMENT_SIZE_BYTES,
            data: [
                !this.format._options.appendOnly ? this.seekHead : null,
                this.segmentInfo,
                this.tracksElement
            ]
        };
        this.segment = segment;
        if (this.format._options.onSegmentHeader) this.writer.startTrackingWrites();
        this.ebmlWriter.writeEBML(segment);
        if (this.format._options.onSegmentHeader) {
            const { data: data, start: start } = this.writer.stopTrackingWrites();
            this.format._options.onSegmentHeader(data, start);
        }
    }
    createCues() {
        this.cues = {
            id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).Cues,
            data: []
        };
    }
    get segmentDataOffset() {
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.segment);
        return this.ebmlWriter.dataOffsets.get(this.segment);
    }
    allTracksAreKnown() {
        for (const track of this.output._tracks){
            if (!track.source._closed && !this.trackDatas.some((x)=>x.track === track)) return false; // We haven't seen a sample from this open track yet
        }
        return true;
    }
    async getMimeType() {
        await this.allTracksKnown.promise;
        const codecStrings = this.trackDatas.map((trackData)=>{
            if (trackData.type === 'video') return trackData.info.decoderConfig.codec;
            else if (trackData.type === 'audio') return trackData.info.decoderConfig.codec;
            else {
                const map = {
                    webvtt: 'wvtt'
                };
                return map[trackData.track.source._codec];
            }
        });
        return (0, $e94e5bfa82a491af$export$1e9f6402772832b9)({
            isWebM: this.format instanceof (0, $89c2d87f884ee1df$export$8313ce77aed075b8),
            hasVideo: this.trackDatas.some((x)=>x.type === 'video'),
            hasAudio: this.trackDatas.some((x)=>x.type === 'audio'),
            codecStrings: codecStrings
        });
    }
    getVideoTrackData(track, meta) {
        const existingTrackData = this.trackDatas.find((x)=>x.track === track);
        if (existingTrackData) return existingTrackData;
        (0, $94511f4b46249ea3$export$c2a1d372ae0516d4)(meta);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(meta);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(meta.decoderConfig);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(meta.decoderConfig.codedWidth !== undefined);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(meta.decoderConfig.codedHeight !== undefined);
        const newTrackData = {
            track: track,
            type: 'video',
            info: {
                width: meta.decoderConfig.codedWidth,
                height: meta.decoderConfig.codedHeight,
                decoderConfig: meta.decoderConfig
            },
            chunkQueue: [],
            lastWrittenMsTimestamp: null
        };
        if (track.source._codec === 'vp9') // https://www.webmproject.org/docs/container specifies that VP9 "SHOULD" make use of the CodecPrivate
        // field. Since WebCodecs makes no use of the description field for VP9, we need to derive it ourselves:
        newTrackData.info.decoderConfig = {
            ...newTrackData.info.decoderConfig,
            description: new Uint8Array((0, $94511f4b46249ea3$export$7b58db19f3afb5f7)(newTrackData.info.decoderConfig.codec))
        };
        else if (track.source._codec === 'av1') // Per https://github.com/ietf-wg-cellar/matroska-specification/blob/master/codec/av1.md, AV1 requires
        // CodecPrivate to be set, but WebCodecs makes no use of the description field for AV1. Thus, let's derive
        // it ourselves:
        newTrackData.info.decoderConfig = {
            ...newTrackData.info.decoderConfig,
            description: new Uint8Array((0, $94511f4b46249ea3$export$ac6296ba51eb7830)(newTrackData.info.decoderConfig.codec))
        };
        this.trackDatas.push(newTrackData);
        this.trackDatas.sort((a, b)=>a.track.id - b.track.id);
        if (this.allTracksAreKnown()) this.allTracksKnown.resolve();
        return newTrackData;
    }
    getAudioTrackData(track, meta) {
        const existingTrackData = this.trackDatas.find((x)=>x.track === track);
        if (existingTrackData) return existingTrackData;
        (0, $94511f4b46249ea3$export$61959146e5b74178)(meta);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(meta);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(meta.decoderConfig);
        const newTrackData = {
            track: track,
            type: 'audio',
            info: {
                numberOfChannels: meta.decoderConfig.numberOfChannels,
                sampleRate: meta.decoderConfig.sampleRate,
                decoderConfig: meta.decoderConfig
            },
            chunkQueue: [],
            lastWrittenMsTimestamp: null
        };
        this.trackDatas.push(newTrackData);
        this.trackDatas.sort((a, b)=>a.track.id - b.track.id);
        if (this.allTracksAreKnown()) this.allTracksKnown.resolve();
        return newTrackData;
    }
    getSubtitleTrackData(track, meta) {
        const existingTrackData = this.trackDatas.find((x)=>x.track === track);
        if (existingTrackData) return existingTrackData;
        (0, $94511f4b46249ea3$export$8b9df0b71f2f06b5)(meta);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(meta);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(meta.config);
        const newTrackData = {
            track: track,
            type: 'subtitle',
            info: {
                config: meta.config
            },
            chunkQueue: [],
            lastWrittenMsTimestamp: null
        };
        this.trackDatas.push(newTrackData);
        this.trackDatas.sort((a, b)=>a.track.id - b.track.id);
        if (this.allTracksAreKnown()) this.allTracksKnown.resolve();
        return newTrackData;
    }
    async addEncodedVideoPacket(track, packet, meta) {
        const release = await this.mutex.acquire();
        try {
            const trackData = this.getVideoTrackData(track, meta);
            const isKeyFrame = packet.type === 'key';
            let timestamp = this.validateAndNormalizeTimestamp(trackData.track, packet.timestamp, isKeyFrame);
            let duration = packet.duration;
            if (track.metadata.frameRate !== undefined) {
                // Constrain the time values to the frame rate
                timestamp = (0, $053d5bbcf6664967$export$6abe75030bbc425c)(timestamp, 1 / track.metadata.frameRate);
                duration = (0, $053d5bbcf6664967$export$6abe75030bbc425c)(duration, 1 / track.metadata.frameRate);
            }
            const videoChunk = this.createInternalChunk(packet.data, timestamp, duration, packet.type);
            if (track.source._codec === 'vp9') this.fixVP9ColorSpace(trackData, videoChunk);
            trackData.chunkQueue.push(videoChunk);
            await this.interleaveChunks();
        } finally{
            release();
        }
    }
    async addEncodedAudioPacket(track, packet, meta) {
        const release = await this.mutex.acquire();
        try {
            const trackData = this.getAudioTrackData(track, meta);
            const isKeyFrame = packet.type === 'key';
            const timestamp = this.validateAndNormalizeTimestamp(trackData.track, packet.timestamp, isKeyFrame);
            const audioChunk = this.createInternalChunk(packet.data, timestamp, packet.duration, packet.type);
            trackData.chunkQueue.push(audioChunk);
            await this.interleaveChunks();
        } finally{
            release();
        }
    }
    async addSubtitleCue(track, cue, meta) {
        const release = await this.mutex.acquire();
        try {
            const trackData = this.getSubtitleTrackData(track, meta);
            const timestamp = this.validateAndNormalizeTimestamp(trackData.track, cue.timestamp, true);
            let bodyText = cue.text;
            const timestampMs = Math.round(timestamp * 1000);
            // Replace in-body timestamps so that they're relative to the cue start time
            (0, $c77d4d874d58660e$export$605131a15c078e1b).lastIndex = 0;
            bodyText = bodyText.replace((0, $c77d4d874d58660e$export$605131a15c078e1b), (match)=>{
                const time = (0, $c77d4d874d58660e$export$a8948794ee6e0e3a)(match.slice(1, -1));
                const offsetTime = time - timestampMs;
                return `<${(0, $c77d4d874d58660e$export$ad655d9645737731)(offsetTime)}>`;
            });
            const body = (0, $053d5bbcf6664967$export$f5d75491a17f02c).encode(bodyText);
            const additions = `${cue.settings ?? ''}\n${cue.identifier ?? ''}\n${cue.notes ?? ''}`;
            const subtitleChunk = this.createInternalChunk(body, timestamp, cue.duration, 'key', additions.trim() ? (0, $053d5bbcf6664967$export$f5d75491a17f02c).encode(additions) : null);
            trackData.chunkQueue.push(subtitleChunk);
            await this.interleaveChunks();
        } finally{
            release();
        }
    }
    async interleaveChunks(isFinalCall = false) {
        if (!isFinalCall) {
            if (!this.allTracksAreKnown()) return; // We can't interleave yet as we don't yet know how many tracks we'll truly have
        }
        outer: while(true){
            let trackWithMinTimestamp = null;
            let minTimestamp = Infinity;
            for (const trackData of this.trackDatas){
                if (!isFinalCall && trackData.chunkQueue.length === 0 && !trackData.track.source._closed) break outer;
                if (trackData.chunkQueue.length > 0 && trackData.chunkQueue[0].timestamp < minTimestamp) {
                    trackWithMinTimestamp = trackData;
                    minTimestamp = trackData.chunkQueue[0].timestamp;
                }
            }
            if (!trackWithMinTimestamp) break;
            const chunk = trackWithMinTimestamp.chunkQueue.shift();
            this.writeBlock(trackWithMinTimestamp, chunk);
        }
        if (!isFinalCall) await this.writer.flush();
    }
    /**
     * Due to [a bug in Chromium](https://bugs.chromium.org/p/chromium/issues/detail?id=1377842), VP9 streams often
     * lack color space information. This method patches in that information.
     */ fixVP9ColorSpace(trackData, chunk) {
        // http://downloads.webmproject.org/docs/vp9/vp9-bitstream_superframe-and-uncompressed-header_v1.0.pdf
        if (chunk.type !== 'key') return;
        if (!trackData.info.decoderConfig.colorSpace || !trackData.info.decoderConfig.colorSpace.matrix) return;
        const bitstream = new (0, $053d5bbcf6664967$export$d16e6594b36c3ef7)(chunk.data);
        // Check if it's a "superframe"
        if (bitstream.readBits(2) !== 2) return;
        const profileLowBit = bitstream.readBits(1);
        const profileHighBit = bitstream.readBits(1);
        const profile = (profileHighBit << 1) + profileLowBit;
        if (profile === 3) bitstream.skipBits(1);
        const showExistingFrame = bitstream.readBits(1);
        if (showExistingFrame) return;
        const frameType = bitstream.readBits(1);
        if (frameType !== 0) return; // Just to be sure
        bitstream.skipBits(2);
        const syncCode = bitstream.readBits(24);
        if (syncCode !== 0x498342) return;
        if (profile >= 2) bitstream.skipBits(1);
        const colorSpaceID = {
            rgb: 7,
            bt709: 2,
            bt470bg: 1,
            smpte170m: 3
        }[trackData.info.decoderConfig.colorSpace.matrix];
        // The bitstream position is now at the start of the color space bits.
        // We can use the global writeBits function here as requested.
        (0, $053d5bbcf6664967$export$2d7b024149356cd9)(chunk.data, bitstream.pos, bitstream.pos + 3, colorSpaceID);
    }
    /** Converts a read-only external chunk into an internal one for easier use. */ createInternalChunk(data, timestamp, duration, type, additions = null) {
        const internalChunk = {
            data: data,
            type: type,
            timestamp: timestamp,
            duration: duration,
            additions: additions
        };
        return internalChunk;
    }
    /** Writes a block containing media data to the file. */ writeBlock(trackData, chunk) {
        // Due to the interlacing algorithm, this code will be run once we've seen one chunk from every media track.
        if (!this.segment) {
            this.createTracks();
            this.createSegment();
        }
        const msTimestamp = Math.round(1000 * chunk.timestamp);
        // We wanna only finalize this cluster (and begin a new one) if we know that each track will be able to
        // start the new one with a key frame.
        const keyFrameQueuedEverywhere = this.trackDatas.every((otherTrackData)=>{
            if (trackData === otherTrackData) return chunk.type === 'key';
            const firstQueuedSample = otherTrackData.chunkQueue[0];
            if (firstQueuedSample) return firstQueuedSample.type === 'key';
            return otherTrackData.track.source._closed;
        });
        let shouldCreateNewCluster = false;
        if (!this.currentCluster) shouldCreateNewCluster = true;
        else {
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.currentClusterStartMsTimestamp !== null);
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.currentClusterMaxMsTimestamp !== null);
            const relativeTimestamp = msTimestamp - this.currentClusterStartMsTimestamp;
            shouldCreateNewCluster = keyFrameQueuedEverywhere && msTimestamp > this.currentClusterMaxMsTimestamp && relativeTimestamp >= 1000 * (this.format._options.minimumClusterDuration ?? 1) || relativeTimestamp > $acf6fc97ef2526f7$var$MAX_CLUSTER_TIMESTAMP_MS;
        }
        if (shouldCreateNewCluster) this.createNewCluster(msTimestamp);
        const relativeTimestamp = msTimestamp - this.currentClusterStartMsTimestamp;
        if (relativeTimestamp < $acf6fc97ef2526f7$var$MIN_CLUSTER_TIMESTAMP_MS) // The block lies too far in the past, it's not representable within this cluster
        return;
        const prelude = new Uint8Array(4);
        const view = new DataView(prelude.buffer);
        // 0x80 to indicate it's the last byte of a multi-byte number
        view.setUint8(0, 0x80 | trackData.track.id);
        view.setInt16(1, relativeTimestamp, false);
        const msDuration = Math.round(1000 * chunk.duration);
        if (msDuration === 0 && !chunk.additions) {
            // No duration or additions, we can write out a SimpleBlock
            view.setUint8(3, Number(chunk.type === 'key') << 7); // Flags (keyframe flag only present for SimpleBlock)
            const simpleBlock = {
                id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).SimpleBlock,
                data: [
                    prelude,
                    chunk.data
                ]
            };
            this.ebmlWriter.writeEBML(simpleBlock);
        } else {
            const blockGroup = {
                id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).BlockGroup,
                data: [
                    {
                        id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).Block,
                        data: [
                            prelude,
                            chunk.data
                        ]
                    },
                    chunk.type === 'delta' ? {
                        id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).ReferenceBlock,
                        data: new (0, $c25fcc1eb0f0e74f$export$dbf3c5dec5726052)(trackData.lastWrittenMsTimestamp - msTimestamp)
                    } : null,
                    chunk.additions ? {
                        id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).BlockAdditions,
                        data: [
                            {
                                id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).BlockMore,
                                data: [
                                    {
                                        id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).BlockAdditional,
                                        data: chunk.additions
                                    },
                                    {
                                        id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).BlockAddID,
                                        data: 1
                                    }
                                ]
                            }
                        ]
                    } : null,
                    msDuration > 0 ? {
                        id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).BlockDuration,
                        data: msDuration
                    } : null
                ]
            };
            this.ebmlWriter.writeEBML(blockGroup);
        }
        this.duration = Math.max(this.duration, msTimestamp + msDuration);
        trackData.lastWrittenMsTimestamp = msTimestamp;
        if (!this.trackDatasInCurrentCluster.has(trackData)) this.trackDatasInCurrentCluster.set(trackData, {
            firstMsTimestamp: msTimestamp
        });
        this.currentClusterMaxMsTimestamp = Math.max(this.currentClusterMaxMsTimestamp, msTimestamp);
    }
    /** Creates a new Cluster element to contain media chunks. */ createNewCluster(msTimestamp) {
        if (this.currentCluster) this.finalizeCurrentCluster();
        if (this.format._options.onCluster) this.writer.startTrackingWrites();
        this.currentCluster = {
            id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).Cluster,
            size: this.format._options.appendOnly ? -1 : $acf6fc97ef2526f7$var$CLUSTER_SIZE_BYTES,
            data: [
                {
                    id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).Timestamp,
                    data: msTimestamp
                }
            ]
        };
        this.ebmlWriter.writeEBML(this.currentCluster);
        this.currentClusterStartMsTimestamp = msTimestamp;
        this.currentClusterMaxMsTimestamp = msTimestamp;
        this.trackDatasInCurrentCluster.clear();
    }
    finalizeCurrentCluster() {
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.currentCluster);
        if (!this.format._options.appendOnly) {
            const clusterSize = this.writer.getPos() - this.ebmlWriter.dataOffsets.get(this.currentCluster);
            const endPos = this.writer.getPos();
            // Write the size now that we know it
            this.writer.seek(this.ebmlWriter.offsets.get(this.currentCluster) + 4);
            this.ebmlWriter.writeVarInt(clusterSize, $acf6fc97ef2526f7$var$CLUSTER_SIZE_BYTES);
            this.writer.seek(endPos);
        }
        if (this.format._options.onCluster) {
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.currentClusterStartMsTimestamp !== null);
            const { data: data, start: start } = this.writer.stopTrackingWrites();
            this.format._options.onCluster(data, start, this.currentClusterStartMsTimestamp / 1000);
        }
        const clusterOffsetFromSegment = this.ebmlWriter.offsets.get(this.currentCluster) - this.segmentDataOffset;
        // Group tracks by their first timestamp and create a CuePoint for each unique timestamp
        const groupedByTimestamp = new Map();
        for (const [trackData, { firstMsTimestamp: firstMsTimestamp }] of this.trackDatasInCurrentCluster){
            if (!groupedByTimestamp.has(firstMsTimestamp)) groupedByTimestamp.set(firstMsTimestamp, []);
            groupedByTimestamp.get(firstMsTimestamp).push(trackData);
        }
        const groupedAndSortedByTimestamp = [
            ...groupedByTimestamp.entries()
        ].sort((a, b)=>a[0] - b[0]);
        // Add CuePoints to the Cues element for better seeking
        for (const [msTimestamp, trackDatas] of groupedAndSortedByTimestamp){
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.cues);
            this.cues.data.push({
                id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).CuePoint,
                data: [
                    {
                        id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).CueTime,
                        data: msTimestamp
                    },
                    // Create CueTrackPositions for each track that starts at this timestamp
                    ...trackDatas.map((trackData)=>{
                        return {
                            id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).CueTrackPositions,
                            data: [
                                {
                                    id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).CueTrack,
                                    data: trackData.track.id
                                },
                                {
                                    id: (0, $c25fcc1eb0f0e74f$export$92f4fef17576347c).CueClusterPosition,
                                    data: clusterOffsetFromSegment
                                }
                            ]
                        };
                    })
                ]
            });
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    async onTrackClose() {
        const release = await this.mutex.acquire();
        if (this.allTracksAreKnown()) this.allTracksKnown.resolve();
        // Since a track is now closed, we may be able to write out chunks that were previously waiting
        await this.interleaveChunks();
        release();
    }
    /** Finalizes the file, making it ready for use. Must be called after all media chunks have been added. */ async finalize() {
        const release = await this.mutex.acquire();
        this.allTracksKnown.resolve();
        if (!this.segment) {
            this.createTracks();
            this.createSegment();
        }
        // Flush any remaining queued chunks to the file
        await this.interleaveChunks(true);
        if (this.currentCluster) this.finalizeCurrentCluster();
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.cues);
        this.ebmlWriter.writeEBML(this.cues);
        if (!this.format._options.appendOnly) {
            const endPos = this.writer.getPos();
            // Write the Segment size
            const segmentSize = this.writer.getPos() - this.segmentDataOffset;
            this.writer.seek(this.ebmlWriter.offsets.get(this.segment) + 4);
            this.ebmlWriter.writeVarInt(segmentSize, $acf6fc97ef2526f7$var$SEGMENT_SIZE_BYTES);
            // Write the duration of the media to the Segment
            this.segmentDuration.data = new (0, $c25fcc1eb0f0e74f$export$670c4b6cbbc07368)(this.duration);
            this.writer.seek(this.ebmlWriter.offsets.get(this.segmentDuration));
            this.ebmlWriter.writeEBML(this.segmentDuration);
            // Fill in SeekHead position data and write it again
            this.seekHead.data[0].data[1].data = this.ebmlWriter.offsets.get(this.cues) - this.segmentDataOffset;
            this.seekHead.data[1].data[1].data = this.ebmlWriter.offsets.get(this.segmentInfo) - this.segmentDataOffset;
            this.seekHead.data[2].data[1].data = this.ebmlWriter.offsets.get(this.tracksElement) - this.segmentDataOffset;
            this.writer.seek(this.ebmlWriter.offsets.get(this.seekHead));
            this.ebmlWriter.writeEBML(this.seekHead);
            this.writer.seek(endPos);
        }
        release();
    }
}


/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ 

/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ const $b140cc89a13f2b66$export$a841f79ff01026a7 = 4;
const $b140cc89a13f2b66$export$b26bead6b34b6fc9 = {
    // Layer 3
    1: [
        -1,
        32,
        40,
        48,
        56,
        64,
        80,
        96,
        112,
        128,
        160,
        192,
        224,
        256,
        320,
        -1
    ],
    // Layer 2
    2: [
        -1,
        32,
        48,
        56,
        64,
        80,
        96,
        112,
        128,
        160,
        192,
        224,
        256,
        320,
        384,
        -1
    ],
    // Layer 1
    3: [
        -1,
        32,
        64,
        96,
        128,
        160,
        192,
        224,
        256,
        288,
        320,
        352,
        384,
        416,
        448,
        -1
    ]
};
const $b140cc89a13f2b66$export$e2147e89cdc4567 = {
    // Layer 3
    1: [
        -1,
        32,
        48,
        56,
        64,
        80,
        96,
        112,
        128,
        144,
        160,
        176,
        192,
        224,
        256,
        -1
    ],
    // Layer 2
    2: [
        -1,
        8,
        16,
        24,
        32,
        40,
        48,
        56,
        64,
        80,
        96,
        112,
        128,
        144,
        160,
        -1
    ],
    // Layer 1
    3: [
        -1,
        8,
        16,
        24,
        32,
        40,
        48,
        56,
        64,
        80,
        96,
        112,
        128,
        144,
        160,
        -1
    ]
};
const $b140cc89a13f2b66$export$c37650517927277c = {
    // MPEG Version 2.5
    0: [
        11025,
        12000,
        8000,
        -1
    ],
    // MPEG Version 2 (ISO/IEC 13818-3)
    2: [
        22050,
        24000,
        16000,
        -1
    ],
    // MPEG Version 1 (ISO/IEC 11172-3)
    3: [
        44100,
        48000,
        32000,
        -1
    ]
};
const $b140cc89a13f2b66$export$eb553bb06eb7ade7 = 0x58696e67;
const $b140cc89a13f2b66$export$7ecad81ba40c4d73 = 0x496e666f;
const $b140cc89a13f2b66$export$f006ae671fa5f8a8 = (layer, bitrate, sampleRate, padding)=>{
    if (layer === 3) // Layer 1
    return Math.floor((12 * bitrate / sampleRate + padding) * 4);
    else return Math.floor(144 * bitrate / sampleRate + padding);
};
const $b140cc89a13f2b66$export$48dad0e651bd414b = (mpegVersionId, channel)=>{
    return mpegVersionId === 3 ? channel === 3 ? 21 : 36 : channel === 3 ? 13 : 21;
};
const $b140cc89a13f2b66$export$2b3947bd139d5380 = (word, reader)=>{
    const startPos = reader.pos;
    const firstByte = word >>> 24;
    const secondByte = word >>> 16 & 0xff;
    const thirdByte = word >>> 8 & 0xff;
    const fourthByte = word & 0xff;
    if (firstByte !== 0xff && secondByte !== 0xff && thirdByte !== 0xff && fourthByte !== 0xff) {
        reader.pos += 4;
        return null;
    }
    reader.pos += 1;
    if (firstByte !== 0xff) return null;
    if ((secondByte & 0xe0) !== 0xe0) return null;
    const mpegVersionId = secondByte >> 3 & 0x3;
    const layer = secondByte >> 1 & 0x3;
    const bitrateIndex = thirdByte >> 4 & 0xf;
    const frequencyIndex = thirdByte >> 2 & 0x3;
    const padding = thirdByte >> 1 & 0x1;
    const channel = fourthByte >> 6 & 0x3;
    const modeExtension = fourthByte >> 4 & 0x3;
    const copyright = fourthByte >> 3 & 0x1;
    const original = fourthByte >> 2 & 0x1;
    const emphasis = fourthByte & 0x3;
    const kilobitRate = mpegVersionId === 3 ? $b140cc89a13f2b66$export$b26bead6b34b6fc9[layer]?.[bitrateIndex] : $b140cc89a13f2b66$export$e2147e89cdc4567[layer]?.[bitrateIndex];
    if (!kilobitRate || kilobitRate === -1) return null;
    const bitrate = kilobitRate * 1000;
    const sampleRate = $b140cc89a13f2b66$export$c37650517927277c[mpegVersionId]?.[frequencyIndex];
    if (!sampleRate || sampleRate === -1) return null;
    const frameLength = $b140cc89a13f2b66$export$f006ae671fa5f8a8(layer, bitrate, sampleRate, padding);
    if (reader.fileSize !== null && reader.fileSize - startPos < frameLength) // The frame doesn't fit into the rest of the file
    return null;
    let audioSamplesInFrame;
    if (mpegVersionId === 3) audioSamplesInFrame = layer === 3 ? 384 : 1152;
    else {
        if (layer === 3) audioSamplesInFrame = 384;
        else if (layer === 2) audioSamplesInFrame = 1152;
        else audioSamplesInFrame = 576;
    }
    return {
        startPos: startPos,
        totalSize: frameLength,
        mpegVersionId: mpegVersionId,
        layer: layer,
        bitrate: bitrate,
        frequencyIndex: frequencyIndex,
        sampleRate: sampleRate,
        channel: channel,
        modeExtension: modeExtension,
        copyright: copyright,
        original: original,
        emphasis: emphasis,
        audioSamplesInFrame: audioSamplesInFrame
    };
};


/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ 
class $4f2b921390477c0c$export$95b41376c3840603 {
    constructor(writer){
        this.writer = writer;
        this.helper = new Uint8Array(8);
        this.helperView = new DataView(this.helper.buffer);
    }
    writeU32(value) {
        this.helperView.setUint32(0, value, false);
        this.writer.write(this.helper.subarray(0, 4));
    }
    writeXingFrame(data) {
        const startPos = this.writer.getPos();
        const firstByte = 0xff;
        const secondByte = 0xe0 | data.mpegVersionId << 3 | data.layer << 1;
        const bitrateGroup = data.mpegVersionId === 3 ? (0, $b140cc89a13f2b66$export$b26bead6b34b6fc9) : (0, $b140cc89a13f2b66$export$e2147e89cdc4567);
        const bitrates = bitrateGroup?.[data.layer];
        if (!bitrates) throw new Error('Invalid MPEG version and layer combination.');
        const sampleRate = (0, $b140cc89a13f2b66$export$c37650517927277c)[data.mpegVersionId]?.[data.frequencyIndex];
        if (!sampleRate || sampleRate === -1) throw new Error('Invalid MPEG version and frequency index combination.');
        const padding = 0;
        const neededBytes = 155;
        // Let's find the lowest bitrate for which the frame size is sufficiently large to fit all the data
        const bitrateIndex = bitrates.findIndex((kbr)=>{
            return (0, $b140cc89a13f2b66$export$f006ae671fa5f8a8)(data.layer, 1000 * kbr, sampleRate, padding) >= neededBytes;
        });
        if (bitrateIndex === -1) throw new Error('No suitable bitrate found.');
        const thirdByte = bitrateIndex << 4 | data.frequencyIndex << 2 | padding << 1;
        const fourthByte = data.channel << 6 | data.modeExtension << 4 | data.copyright << 3 | data.original << 2 | data.emphasis;
        this.helper[0] = firstByte;
        this.helper[1] = secondByte;
        this.helper[2] = thirdByte;
        this.helper[3] = fourthByte;
        this.writer.write(this.helper.subarray(0, 4));
        const xingOffset = (0, $b140cc89a13f2b66$export$48dad0e651bd414b)(data.mpegVersionId, data.channel);
        this.writer.seek(startPos + xingOffset);
        this.writeU32((0, $b140cc89a13f2b66$export$eb553bb06eb7ade7));
        let flags = 0;
        if (data.frameCount !== null) flags |= 1;
        if (data.fileSize !== null) flags |= 2;
        if (data.toc !== null) flags |= 4;
        this.writeU32(flags);
        this.writeU32(data.frameCount ?? 0);
        this.writeU32(data.fileSize ?? 0);
        this.writer.write(data.toc ?? new Uint8Array(100));
        const frameSize = (0, $b140cc89a13f2b66$export$f006ae671fa5f8a8)(data.layer, 1000 * bitrates[bitrateIndex], sampleRate, padding);
        this.writer.seek(startPos + frameSize);
    }
}


class $a454f14d93156724$export$dd0cbd2d176c22ee extends (0, $40161f4e778629b3$export$d78afe5e2e889016) {
    constructor(output, format){
        super(output);
        this.xingFrameData = null;
        this.frameCount = 0;
        this.framePositions = [];
        this.format = format;
        this.writer = output._writer;
        this.mp3Writer = new (0, $4f2b921390477c0c$export$95b41376c3840603)(output._writer);
    }
    async start() {
    // Nothing needed here
    }
    async getMimeType() {
        return 'audio/mpeg';
    }
    async addEncodedVideoPacket() {
        throw new Error('MP3 does not support video.');
    }
    async addEncodedAudioPacket(track, packet) {
        const release = await this.mutex.acquire();
        try {
            if (!this.xingFrameData) {
                const view = (0, $053d5bbcf6664967$export$f6b0788df7b6d1ec)(packet.data);
                if (view.byteLength < 4) throw new Error('Invalid MP3 header in sample.');
                const word = view.getUint32(0, false);
                const header = (0, $b140cc89a13f2b66$export$2b3947bd139d5380)(word, {
                    pos: 0,
                    fileSize: null
                });
                if (!header) throw new Error('Invalid MP3 header in sample.');
                const xingOffset = (0, $b140cc89a13f2b66$export$48dad0e651bd414b)(header.mpegVersionId, header.channel);
                if (view.byteLength >= xingOffset + 4) {
                    const word = view.getUint32(xingOffset, false);
                    const isXing = word === (0, $b140cc89a13f2b66$export$eb553bb06eb7ade7) || word === (0, $b140cc89a13f2b66$export$7ecad81ba40c4d73);
                    if (isXing) // This is not a data frame, so let's completely ignore this sample
                    return;
                }
                this.xingFrameData = {
                    mpegVersionId: header.mpegVersionId,
                    layer: header.layer,
                    frequencyIndex: header.frequencyIndex,
                    channel: header.channel,
                    modeExtension: header.modeExtension,
                    copyright: header.copyright,
                    original: header.original,
                    emphasis: header.emphasis,
                    frameCount: null,
                    fileSize: null,
                    toc: null
                };
                // Write a Xing frame because this muxer doesn't make any bitrate constraints, meaning we don't know if
                // this will be a constant or variable bitrate file. Therefore, always write the Xing frame.
                this.mp3Writer.writeXingFrame(this.xingFrameData);
                this.frameCount++;
            }
            this.validateAndNormalizeTimestamp(track, packet.timestamp, packet.type === 'key');
            this.framePositions.push(this.writer.getPos());
            this.writer.write(packet.data);
            this.frameCount++;
            await this.writer.flush();
        } finally{
            release();
        }
    }
    async addSubtitleCue() {
        throw new Error('MP3 does not support subtitles.');
    }
    async finalize() {
        if (!this.xingFrameData) return;
        const release = await this.mutex.acquire();
        const endPos = this.writer.getPos();
        this.writer.seek(0);
        const toc = new Uint8Array(100);
        for(let i = 0; i < 100; i++){
            const index = Math.floor(this.framePositions.length * (i / 100));
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(index !== -1 && index < this.framePositions.length);
            const byteOffset = this.framePositions[index];
            toc[i] = 256 * (byteOffset / endPos);
        }
        this.xingFrameData.frameCount = this.frameCount;
        this.xingFrameData.fileSize = endPos;
        this.xingFrameData.toc = toc;
        if (this.format._options.onXingFrame) this.writer.startTrackingWrites();
        this.mp3Writer.writeXingFrame(this.xingFrameData);
        if (this.format._options.onXingFrame) {
            const { data: data, start: start } = this.writer.stopTrackingWrites();
            this.format._options.onXingFrame(data, start);
        }
        this.writer.seek(endPos);
        release();
    }
}


/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ 



/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ 

const $9c89ccf3532cc99e$export$7cc35baa0302b604 = 0x5367674f; // 'OggS'
const $9c89ccf3532cc99e$var$OGG_CRC_POLYNOMIAL = 0x04c11db7;
const $9c89ccf3532cc99e$var$OGG_CRC_TABLE = new Uint32Array(256);
for(let n = 0; n < 256; n++){
    let crc = n << 24;
    for(let k = 0; k < 8; k++)crc = crc & 0x80000000 ? crc << 1 ^ $9c89ccf3532cc99e$var$OGG_CRC_POLYNOMIAL : crc << 1;
    $9c89ccf3532cc99e$var$OGG_CRC_TABLE[n] = crc >>> 0 & 0xffffffff;
}
const $9c89ccf3532cc99e$export$f9227f88b2913eec = (bytes)=>{
    const view = (0, $053d5bbcf6664967$export$f6b0788df7b6d1ec)(bytes);
    const originalChecksum = view.getUint32(22, true);
    view.setUint32(22, 0, true); // Zero out checksum field
    let crc = 0;
    for(let i = 0; i < bytes.length; i++){
        const byte = bytes[i];
        crc = (crc << 8 ^ $9c89ccf3532cc99e$var$OGG_CRC_TABLE[crc >>> 24 ^ byte]) >>> 0;
    }
    view.setUint32(22, originalChecksum, true); // Restore checksum field
    return crc;
};
const $9c89ccf3532cc99e$export$be69fbb7cf54923f = (data, codecInfo, vorbisLastBlocksize)=>{
    let durationInSamples = 0;
    let currentBlocksize = null;
    if (data.length > 0) {
        // To know sample duration, we'll need to peak inside the packet
        if (codecInfo.codec === 'vorbis') {
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(codecInfo.vorbisInfo);
            const vorbisModeCount = codecInfo.vorbisInfo.modeBlockflags.length;
            const bitCount = (0, $053d5bbcf6664967$export$4522663bbb3faec8)(vorbisModeCount - 1);
            const modeMask = (1 << bitCount) - 1 << 1;
            const modeNumber = (data[0] & modeMask) >> 1;
            if (modeNumber >= codecInfo.vorbisInfo.modeBlockflags.length) throw new Error('Invalid mode number.');
            // In Vorbis, packet duration also depends on the blocksize of the previous packet
            let prevBlocksize = vorbisLastBlocksize;
            const blockflag = codecInfo.vorbisInfo.modeBlockflags[modeNumber];
            currentBlocksize = codecInfo.vorbisInfo.blocksizes[blockflag];
            if (blockflag === 1) {
                const prevMask = (modeMask | 0x1) + 1;
                const flag = data[0] & prevMask ? 1 : 0;
                prevBlocksize = codecInfo.vorbisInfo.blocksizes[flag];
            }
            durationInSamples = prevBlocksize !== null ? prevBlocksize + currentBlocksize >> 2 : 0; // The first sample outputs no audio data and therefore has a duration of 0
        } else if (codecInfo.codec === 'opus') {
            const toc = (0, $e4e81989f7ab3f4b$export$4b904a3e04344373)(data);
            durationInSamples = toc.durationInSamples;
        }
    }
    return {
        durationInSamples: durationInSamples,
        vorbisBlockSize: currentBlocksize
    };
};
const $9c89ccf3532cc99e$export$f428c6f78f38f4ed = (info)=>{
    let string = 'audio/ogg';
    if (info.codecStrings) {
        const uniqueCodecMimeTypes = [
            ...new Set(info.codecStrings)
        ];
        string += `; codecs="${uniqueCodecMimeTypes.join(', ')}"`;
    }
    return string;
};


/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ 
const $4b9499614f59f604$export$22c832bf800440d8 = 27;
const $4b9499614f59f604$export$3a4cf08ad4a840d4 = 282;
const $4b9499614f59f604$export$4778a6937b529c40 = $4b9499614f59f604$export$3a4cf08ad4a840d4 + 65025;
class $4b9499614f59f604$export$79792ca12d4e0429 {
    constructor(reader){
        this.reader = reader;
        this.pos = 0;
    }
    readBytes(length) {
        const { view: view, offset: offset } = this.reader.getViewAndOffset(this.pos, this.pos + length);
        this.pos += length;
        return new Uint8Array(view.buffer, offset, length);
    }
    readU8() {
        const { view: view, offset: offset } = this.reader.getViewAndOffset(this.pos, this.pos + 1);
        this.pos += 1;
        return view.getUint8(offset);
    }
    readU32() {
        const { view: view, offset: offset } = this.reader.getViewAndOffset(this.pos, this.pos + 4);
        this.pos += 4;
        return view.getUint32(offset, true);
    }
    readI32() {
        const { view: view, offset: offset } = this.reader.getViewAndOffset(this.pos, this.pos + 4);
        this.pos += 4;
        return view.getInt32(offset, true);
    }
    readI64() {
        const low = this.readU32();
        const high = this.readI32();
        return high * 0x100000000 + low;
    }
    readAscii(length) {
        const { view: view, offset: offset } = this.reader.getViewAndOffset(this.pos, this.pos + length);
        this.pos += length;
        let str = '';
        for(let i = 0; i < length; i++)str += String.fromCharCode(view.getUint8(offset + i));
        return str;
    }
    readPageHeader() {
        const startPos = this.pos;
        const capturePattern = this.readU32();
        if (capturePattern !== (0, $9c89ccf3532cc99e$export$7cc35baa0302b604)) return null;
        this.pos += 1; // Version
        const headerType = this.readU8();
        const granulePosition = this.readI64();
        const serialNumber = this.readU32();
        const sequenceNumber = this.readU32();
        const checksum = this.readU32();
        const numberPageSegments = this.readU8();
        const lacingValues = new Uint8Array(numberPageSegments);
        for(let i = 0; i < numberPageSegments; i++)lacingValues[i] = this.readU8();
        const headerSize = 27 + numberPageSegments;
        const dataSize = lacingValues.reduce((a, b)=>a + b, 0);
        const totalSize = headerSize + dataSize;
        return {
            headerStartPos: startPos,
            totalSize: totalSize,
            dataStartPos: startPos + headerSize,
            dataSize: dataSize,
            headerType: headerType,
            granulePosition: granulePosition,
            serialNumber: serialNumber,
            sequenceNumber: sequenceNumber,
            checksum: checksum,
            lacingValues: lacingValues
        };
    }
    findNextPageHeader(until) {
        while(this.pos < until - 3){
            const word = this.readU32();
            const firstByte = word & 0xff;
            const secondByte = word >>> 8 & 0xff;
            const thirdByte = word >>> 16 & 0xff;
            const fourthByte = word >>> 24 & 0xff;
            const O = 0x4f; // 'O'
            if (firstByte !== O && secondByte !== O && thirdByte !== O && fourthByte !== O) continue;
            this.pos -= 4;
            if (word === (0, $9c89ccf3532cc99e$export$7cc35baa0302b604)) // We have found the capture pattern
            return true;
            this.pos += 1;
        }
        return false;
    }
}


const $21b14c194a3b2a05$var$PAGE_SIZE_TARGET = 8192;
class $21b14c194a3b2a05$export$2a4eb5bbb730b944 extends (0, $40161f4e778629b3$export$d78afe5e2e889016) {
    constructor(output, format){
        super(output);
        this.trackDatas = [];
        this.bosPagesWritten = false;
        this.allTracksKnown = (0, $053d5bbcf6664967$export$283a1614f1b16769)();
        this.pageBytes = new Uint8Array((0, $4b9499614f59f604$export$4778a6937b529c40));
        this.pageView = new DataView(this.pageBytes.buffer);
        this.format = format;
        this.writer = output._writer;
        this.writer.ensureMonotonicity = true; // Ogg is always monotonically written!
    }
    async start() {
    // Nothin'
    }
    async getMimeType() {
        await this.allTracksKnown.promise;
        return (0, $9c89ccf3532cc99e$export$f428c6f78f38f4ed)({
            codecStrings: this.trackDatas.map((x)=>x.codecInfo.codec)
        });
    }
    addEncodedVideoPacket() {
        throw new Error('Video tracks are not supported.');
    }
    getTrackData(track, meta) {
        const existingTrackData = this.trackDatas.find((td)=>td.track === track);
        if (existingTrackData) return existingTrackData;
        // Give the track a unique random serial number
        let serialNumber;
        do serialNumber = Math.floor(2 ** 32 * Math.random());
        while (this.trackDatas.some((td)=>td.serialNumber === serialNumber));
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(track.source._codec === 'vorbis' || track.source._codec === 'opus');
        (0, $94511f4b46249ea3$export$61959146e5b74178)(meta);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(meta);
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(meta.decoderConfig);
        const newTrackData = {
            track: track,
            serialNumber: serialNumber,
            internalSampleRate: track.source._codec === 'opus' ? (0, $94511f4b46249ea3$export$8cafa39936c6eeba) : meta.decoderConfig.sampleRate,
            codecInfo: {
                codec: track.source._codec,
                vorbisInfo: null,
                opusInfo: null
            },
            vorbisLastBlocksize: null,
            packetQueue: [],
            currentTimestampInSamples: 0,
            pagesWritten: 0,
            currentGranulePosition: 0,
            currentLacingValues: [],
            currentPageData: [],
            currentPageSize: 27,
            currentPageStartsWithFreshPacket: true
        };
        this.queueHeaderPackets(newTrackData, meta);
        this.trackDatas.push(newTrackData);
        if (this.allTracksAreKnown()) this.allTracksKnown.resolve();
        return newTrackData;
    }
    queueHeaderPackets(trackData, meta) {
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(meta.decoderConfig);
        if (trackData.track.source._codec === 'vorbis') {
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(meta.decoderConfig.description);
            const bytes = (0, $053d5bbcf6664967$export$73470fd2221e6aef)(meta.decoderConfig.description);
            if (bytes[0] !== 2) throw new TypeError('First byte of Vorbis decoder description must be 2.');
            let pos = 1;
            const readPacketLength = ()=>{
                let length = 0;
                while(true){
                    const value = bytes[pos++];
                    if (value === undefined) throw new TypeError('Vorbis decoder description is too short.');
                    length += value;
                    if (value < 255) return length;
                }
            };
            const identificationHeaderLength = readPacketLength();
            const commentHeaderLength = readPacketLength();
            const setupHeaderLength = bytes.length - pos; // Setup header fills the remaining bytes
            if (setupHeaderLength <= 0) throw new TypeError('Vorbis decoder description is too short.');
            const identificationHeader = bytes.subarray(pos, pos += identificationHeaderLength);
            const commentHeader = bytes.subarray(pos, pos += commentHeaderLength);
            const setupHeader = bytes.subarray(pos);
            trackData.packetQueue.push({
                data: identificationHeader,
                endGranulePosition: 0,
                timestamp: 0,
                forcePageFlush: true
            }, {
                data: commentHeader,
                endGranulePosition: 0,
                timestamp: 0,
                forcePageFlush: false
            }, {
                data: setupHeader,
                endGranulePosition: 0,
                timestamp: 0,
                forcePageFlush: true
            });
            const view = (0, $053d5bbcf6664967$export$f6b0788df7b6d1ec)(identificationHeader);
            const blockSizeByte = view.getUint8(28);
            trackData.codecInfo.vorbisInfo = {
                blocksizes: [
                    1 << (blockSizeByte & 0xf),
                    1 << (blockSizeByte >> 4)
                ],
                modeBlockflags: (0, $e4e81989f7ab3f4b$export$ea4c36f24bb20494)(setupHeader).modeBlockflags
            };
        } else if (trackData.track.source._codec === 'opus') {
            if (!meta.decoderConfig.description) throw new TypeError('For Ogg, Opus decoder description is required.');
            const identificationHeader = (0, $053d5bbcf6664967$export$73470fd2221e6aef)(meta.decoderConfig.description);
            const commentHeader = new Uint8Array(16);
            const view = new DataView(commentHeader.buffer);
            view.setUint32(0, 0x4f707573, false); // 'Opus'
            view.setUint32(4, 0x54616773, false); // 'Tags'
            view.setUint32(8, 0, true); // Vendor String Length
            view.setUint32(12, 0, true); // User Comment List Length
            trackData.packetQueue.push({
                data: identificationHeader,
                endGranulePosition: 0,
                timestamp: 0,
                forcePageFlush: true
            }, {
                data: commentHeader,
                endGranulePosition: 0,
                timestamp: 0,
                forcePageFlush: true
            });
            trackData.codecInfo.opusInfo = {
                preSkip: (0, $e4e81989f7ab3f4b$export$f126d711230ceb2)(identificationHeader).preSkip
            };
        }
    }
    async addEncodedAudioPacket(track, packet, meta) {
        const release = await this.mutex.acquire();
        try {
            const trackData = this.getTrackData(track, meta);
            this.validateAndNormalizeTimestamp(trackData.track, packet.timestamp, packet.type === 'key');
            const currentTimestampInSamples = trackData.currentTimestampInSamples;
            const { durationInSamples: durationInSamples, vorbisBlockSize: vorbisBlockSize } = (0, $9c89ccf3532cc99e$export$be69fbb7cf54923f)(packet.data, trackData.codecInfo, trackData.vorbisLastBlocksize);
            trackData.currentTimestampInSamples += durationInSamples;
            trackData.vorbisLastBlocksize = vorbisBlockSize;
            trackData.packetQueue.push({
                data: packet.data,
                endGranulePosition: trackData.currentTimestampInSamples,
                timestamp: currentTimestampInSamples / trackData.internalSampleRate,
                forcePageFlush: false
            });
            await this.interleavePages();
        } finally{
            release();
        }
    }
    addSubtitleCue() {
        throw new Error('Subtitle tracks are not supported.');
    }
    allTracksAreKnown() {
        for (const track of this.output._tracks){
            if (!track.source._closed && !this.trackDatas.some((x)=>x.track === track)) return false; // We haven't seen a sample from this open track yet
        }
        return true;
    }
    async interleavePages(isFinalCall = false) {
        if (!this.bosPagesWritten) {
            if (!this.allTracksAreKnown()) return; // We can't interleave yet as we don't yet know how many tracks we'll truly have
            // Write the header page for all bitstreams
            for (const trackData of this.trackDatas)while(trackData.packetQueue.length > 0){
                const packet = trackData.packetQueue.shift();
                this.writePacket(trackData, packet, false);
                if (packet.forcePageFlush) break;
            }
            this.bosPagesWritten = true;
        }
        outer: while(true){
            let trackWithMinTimestamp = null;
            let minTimestamp = Infinity;
            for (const trackData of this.trackDatas){
                if (!isFinalCall && trackData.packetQueue.length <= 1 // Limit is 1, not 0, for correct EOS flag logic
                 && !trackData.track.source._closed) break outer;
                if (trackData.packetQueue.length > 0 && trackData.packetQueue[0].timestamp < minTimestamp) {
                    trackWithMinTimestamp = trackData;
                    minTimestamp = trackData.packetQueue[0].timestamp;
                }
            }
            if (!trackWithMinTimestamp) break;
            const packet = trackWithMinTimestamp.packetQueue.shift();
            const isFinalPacket = trackWithMinTimestamp.packetQueue.length === 0;
            this.writePacket(trackWithMinTimestamp, packet, isFinalPacket);
        }
        if (!isFinalCall) await this.writer.flush();
    }
    writePacket(trackData, packet, isFinalPacket) {
        let remainingLength = packet.data.length;
        let dataStartOffset = 0;
        let dataOffset = 0;
        while(true){
            if (trackData.currentLacingValues.length === 0 && dataStartOffset > 0) // This is a packet spanning multiple pages
            trackData.currentPageStartsWithFreshPacket = false;
            const segmentSize = Math.min(255, remainingLength);
            trackData.currentLacingValues.push(segmentSize);
            trackData.currentPageSize++;
            dataOffset += segmentSize;
            const segmentIsLastOfPacket = remainingLength < 255;
            if (trackData.currentLacingValues.length === 255) {
                // The page is full, we need to add part of the packet data and then flush the page
                const slice = packet.data.subarray(dataStartOffset, dataOffset);
                dataStartOffset = dataOffset;
                trackData.currentPageData.push(slice);
                trackData.currentPageSize += slice.length;
                this.writePage(trackData, isFinalPacket && segmentIsLastOfPacket);
                if (segmentIsLastOfPacket) return;
            }
            if (segmentIsLastOfPacket) break;
            remainingLength -= 255;
        }
        const slice = packet.data.subarray(dataStartOffset);
        trackData.currentPageData.push(slice);
        trackData.currentPageSize += slice.length;
        trackData.currentGranulePosition = packet.endGranulePosition;
        if (trackData.currentPageSize >= $21b14c194a3b2a05$var$PAGE_SIZE_TARGET || packet.forcePageFlush) this.writePage(trackData, isFinalPacket);
    }
    writePage(trackData, isEos) {
        this.pageView.setUint32(0, (0, $9c89ccf3532cc99e$export$7cc35baa0302b604), true); // Capture pattern
        this.pageView.setUint8(4, 0); // Version
        let headerType = 0;
        if (!trackData.currentPageStartsWithFreshPacket) headerType |= 1;
        if (trackData.pagesWritten === 0) headerType |= 2; // Beginning of stream
        if (isEos) headerType |= 4; // End of stream
        this.pageView.setUint8(5, headerType); // Header type
        const granulePosition = trackData.currentLacingValues.every((x)=>x === 255) ? -1 // No packets end on this page
         : trackData.currentGranulePosition;
        (0, $053d5bbcf6664967$export$8532a5209571c04a)(this.pageView, 6, granulePosition, true); // Granule position
        this.pageView.setUint32(14, trackData.serialNumber, true); // Serial number
        this.pageView.setUint32(18, trackData.pagesWritten, true); // Page sequence number
        this.pageView.setUint32(22, 0, true); // Checksum placeholder
        this.pageView.setUint8(26, trackData.currentLacingValues.length); // Number of page segments
        this.pageBytes.set(trackData.currentLacingValues, 27);
        let pos = 27 + trackData.currentLacingValues.length;
        for (const data of trackData.currentPageData){
            this.pageBytes.set(data, pos);
            pos += data.length;
        }
        const slice = this.pageBytes.subarray(0, pos);
        const crc = (0, $9c89ccf3532cc99e$export$f9227f88b2913eec)(slice);
        this.pageView.setUint32(22, crc, true); // Checksum
        trackData.pagesWritten++;
        trackData.currentLacingValues.length = 0;
        trackData.currentPageData.length = 0;
        trackData.currentPageSize = 27;
        trackData.currentPageStartsWithFreshPacket = true;
        if (this.format._options.onPage) this.writer.startTrackingWrites();
        this.writer.write(slice);
        if (this.format._options.onPage) {
            const { data: data, start: start } = this.writer.stopTrackingWrites();
            this.format._options.onPage(data, start, trackData.track.source);
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    async onTrackClose() {
        const release = await this.mutex.acquire();
        if (this.allTracksAreKnown()) this.allTracksKnown.resolve();
        // Since a track is now closed, we may be able to write out chunks that were previously waiting
        await this.interleavePages();
        release();
    }
    async finalize() {
        const release = await this.mutex.acquire();
        this.allTracksKnown.resolve();
        await this.interleavePages(true);
        for (const trackData of this.trackDatas)if (trackData.currentLacingValues.length > 0) this.writePage(trackData, true);
        release();
    }
}


/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ 

/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ /*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ class $65791c3b240bd28a$export$6a429f49ace8e035 {
    constructor(input){
        this.input = input;
    }
}


/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ 
/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ 






const $fb6e7064a850c9ee$var$validatePacketRetrievalOptions = (options)=>{
    if (!options || typeof options !== 'object') throw new TypeError('options must be an object.');
    if (options.metadataOnly !== undefined && typeof options.metadataOnly !== 'boolean') throw new TypeError('options.metadataOnly, when defined, must be a boolean.');
};
const $fb6e7064a850c9ee$var$validateTimestamp = (timestamp)=>{
    if (typeof timestamp !== 'number' || Number.isNaN(timestamp)) throw new TypeError('timestamp must be a number.'); // It can be non-finite, that's fine
};
class $fb6e7064a850c9ee$export$9e0d702c2617f4ac {
    constructor(track){
        if (!(track instanceof (0, $ae1d233ed6bad288$export$927f91e785b199d8))) throw new TypeError('track must be an InputTrack.');
        this._track = track;
    }
    /**
     * Retrieves the track's first packet (in decode order), or null if it has no packets. The first packet is very
     * likely to be a key packet.
     */ getFirstPacket(options = {}) {
        $fb6e7064a850c9ee$var$validatePacketRetrievalOptions(options);
        return this._track._backing.getFirstPacket(options);
    }
    /**
     * Retrieves the packet corresponding to the given timestamp, in seconds. More specifically, returns the last packet
     * (in presentation order) with a start timestamp less than or equal to the given timestamp. This method can be
     * used to retrieve a track's last packet using `getPacket(Infinity)`. The method returns null if the timestamp
     * is before the first packet in the track.
     *
     * @param timestamp - The timestamp used for retrieval, in seconds.
     */ getPacket(timestamp, options = {}) {
        $fb6e7064a850c9ee$var$validateTimestamp(timestamp);
        $fb6e7064a850c9ee$var$validatePacketRetrievalOptions(options);
        return this._track._backing.getPacket(timestamp, options);
    }
    /**
     * Retrieves the packet following the given packet (in decode order), or null if the given packet is the
     * last packet.
     */ getNextPacket(packet, options = {}) {
        if (!(packet instanceof (0, $8ce8f170cc716e8f$export$2bb25546e7fe690b))) throw new TypeError('packet must be an EncodedPacket.');
        $fb6e7064a850c9ee$var$validatePacketRetrievalOptions(options);
        return this._track._backing.getNextPacket(packet, options);
    }
    /**
     * Retrieves the key packet corresponding to the given timestamp, in seconds. More specifically, returns the last
     * key packet (in presentation order) with a start timestamp less than or equal to the given timestamp. A key packet
     * is a packet that doesn't require previous packets to be decoded. This method can be used to retrieve a track's
     * last key packet using `getKeyPacket(Infinity)`. The method returns null if the timestamp is before the first
     * key packet in the track.
     *
     * @param timestamp - The timestamp used for retrieval, in seconds.
     */ getKeyPacket(timestamp, options = {}) {
        $fb6e7064a850c9ee$var$validateTimestamp(timestamp);
        $fb6e7064a850c9ee$var$validatePacketRetrievalOptions(options);
        return this._track._backing.getKeyPacket(timestamp, options);
    }
    /**
     * Retrieves the key packet following the given packet (in decode order), or null if the given packet is the last
     * key packet.
     */ getNextKeyPacket(packet, options = {}) {
        if (!(packet instanceof (0, $8ce8f170cc716e8f$export$2bb25546e7fe690b))) throw new TypeError('packet must be an EncodedPacket.');
        $fb6e7064a850c9ee$var$validatePacketRetrievalOptions(options);
        return this._track._backing.getNextKeyPacket(packet, options);
    }
    /**
     * Creates an async iterator that yields the packets in this track in decode order. To enable fast iteration, this
     * method will intelligently preload packets based on the speed of the consumer.
     *
     * @param startPacket - (optional) The packet from which iteration should begin. This packet will also be yielded.
     * @param endTimestamp - (optional) The timestamp at which iteration should end. This packet will _not_ be yielded.
     */ packets(startPacket, endPacket, options = {}) {
        if (startPacket !== undefined && !(startPacket instanceof (0, $8ce8f170cc716e8f$export$2bb25546e7fe690b))) throw new TypeError('startPacket must be an EncodedPacket.');
        if (startPacket !== undefined && startPacket.isMetadataOnly && !options?.metadataOnly) throw new TypeError('startPacket can only be metadata-only if options.metadataOnly is enabled.');
        if (endPacket !== undefined && !(endPacket instanceof (0, $8ce8f170cc716e8f$export$2bb25546e7fe690b))) throw new TypeError('endPacket must be an EncodedPacket.');
        $fb6e7064a850c9ee$var$validatePacketRetrievalOptions(options);
        const packetQueue = [];
        let { promise: queueNotEmpty, resolve: onQueueNotEmpty } = (0, $053d5bbcf6664967$export$283a1614f1b16769)();
        let { promise: queueDequeue, resolve: onQueueDequeue } = (0, $053d5bbcf6664967$export$283a1614f1b16769)();
        let ended = false;
        let terminated = false;
        // This stores errors that are "out of band" in the sense that they didn't occur in the normal flow of this
        // method but instead in a different context. This error should not go unnoticed and must be bubbled up to
        // the consumer.
        let outOfBandError = null;
        const timestamps = [];
        // The queue should always be big enough to hold 1 second worth of packets
        const maxQueueSize = ()=>Math.max(2, timestamps.length);
        // The following is the "pump" process that keeps pumping packets into the queue
        (async ()=>{
            let packet = startPacket ?? await this.getFirstPacket(options);
            while(packet && !terminated){
                if (endPacket && packet.sequenceNumber >= endPacket?.sequenceNumber) break;
                if (packetQueue.length > maxQueueSize()) {
                    ({ promise: queueDequeue, resolve: onQueueDequeue } = (0, $053d5bbcf6664967$export$283a1614f1b16769)());
                    await queueDequeue;
                    continue;
                }
                packetQueue.push(packet);
                onQueueNotEmpty();
                ({ promise: queueNotEmpty, resolve: onQueueNotEmpty } = (0, $053d5bbcf6664967$export$283a1614f1b16769)());
                packet = await this.getNextPacket(packet, options);
            }
            ended = true;
            onQueueNotEmpty();
        })().catch((error)=>{
            if (!outOfBandError) {
                outOfBandError = error;
                onQueueNotEmpty();
            }
        });
        return {
            async next () {
                while(true){
                    if (terminated) return {
                        value: undefined,
                        done: true
                    };
                    else if (outOfBandError) throw outOfBandError;
                    else if (packetQueue.length > 0) {
                        const value = packetQueue.shift();
                        const now = performance.now();
                        timestamps.push(now);
                        while(timestamps.length > 0 && now - timestamps[0] >= 1000)timestamps.shift();
                        onQueueDequeue();
                        return {
                            value: value,
                            done: false
                        };
                    } else if (ended) return {
                        value: undefined,
                        done: true
                    };
                    else await queueNotEmpty;
                }
            },
            async return () {
                terminated = true;
                onQueueDequeue();
                onQueueNotEmpty();
                return {
                    value: undefined,
                    done: true
                };
            },
            async throw (error) {
                throw error;
            },
            [Symbol.asyncIterator] () {
                return this;
            }
        };
    }
}
class $fb6e7064a850c9ee$var$DecoderWrapper {
    constructor(onSample, onError){
        this.onSample = onSample;
        this.onError = onError;
    }
}
class $fb6e7064a850c9ee$export$f35c64f6176d5722 {
    /** @internal */ mediaSamplesInRange(startTimestamp = 0, endTimestamp = Infinity) {
        $fb6e7064a850c9ee$var$validateTimestamp(startTimestamp);
        $fb6e7064a850c9ee$var$validateTimestamp(endTimestamp);
        const sampleQueue = [];
        let firstSampleQueued = false;
        let lastSample = null;
        let { promise: queueNotEmpty, resolve: onQueueNotEmpty } = (0, $053d5bbcf6664967$export$283a1614f1b16769)();
        let { promise: queueDequeue, resolve: onQueueDequeue } = (0, $053d5bbcf6664967$export$283a1614f1b16769)();
        let decoderIsFlushed = false;
        let ended = false;
        let terminated = false;
        // This stores errors that are "out of band" in the sense that they didn't occur in the normal flow of this
        // method but instead in a different context. This error should not go unnoticed and must be bubbled up to
        // the consumer.
        let outOfBandError = null;
        // The following is the "pump" process that keeps pumping packets into the decoder
        (async ()=>{
            const decoderError = new Error();
            const decoder = await this._createDecoder((sample)=>{
                onQueueDequeue();
                if (sample.timestamp >= endTimestamp) ended = true;
                if (ended) {
                    sample.close();
                    return;
                }
                if (lastSample) {
                    if (sample.timestamp > startTimestamp) {
                        // We don't know ahead of time what the first first is. This is because the first first is the
                        // last first whose timestamp is less than or equal to the start timestamp. Therefore we need to
                        // wait for the first first after the start timestamp, and then we'll know that the previous
                        // first was the first first.
                        sampleQueue.push(lastSample);
                        firstSampleQueued = true;
                    } else lastSample.close();
                }
                if (sample.timestamp >= startTimestamp) {
                    sampleQueue.push(sample);
                    firstSampleQueued = true;
                }
                lastSample = firstSampleQueued ? null : sample;
                if (sampleQueue.length > 0) {
                    onQueueNotEmpty();
                    ({ promise: queueNotEmpty, resolve: onQueueNotEmpty } = (0, $053d5bbcf6664967$export$283a1614f1b16769)());
                }
            }, (error)=>{
                if (!outOfBandError) {
                    error.stack = decoderError.stack; // Provide a more useful stack trace
                    outOfBandError = error;
                    onQueueNotEmpty();
                }
            });
            const packetSink = this._createPacketSink();
            const keyPacket = await packetSink.getKeyPacket(startTimestamp) ?? await packetSink.getFirstPacket();
            if (!keyPacket) return;
            let currentPacket = keyPacket;
            let endPacket = undefined;
            if (endTimestamp < Infinity) {
                // When an end timestamp is set, we cannot simply use that for the packet iterator due to out-of-order
                // frames (B-frames). Instead, we'll need to keep decoding packets until we get a frame that exceeds
                // this end time. However, we can still put a bound on it: Since key frames are by definition never
                // out of order, we can stop at the first key frame after the end timestamp.
                const packet = await packetSink.getPacket(endTimestamp);
                const keyPacket = !packet ? null : packet.type === 'key' && packet.timestamp === endTimestamp ? packet : await packetSink.getNextKeyPacket(packet);
                if (keyPacket) endPacket = keyPacket;
            }
            const packets = packetSink.packets(keyPacket, endPacket);
            await packets.next(); // Skip the start packet as we already have it
            while(currentPacket && !ended){
                const maxQueueSize = $fb6e7064a850c9ee$var$computeMaxQueueSize(sampleQueue.length);
                if (sampleQueue.length + decoder.getDecodeQueueSize() > maxQueueSize) {
                    ({ promise: queueDequeue, resolve: onQueueDequeue } = (0, $053d5bbcf6664967$export$283a1614f1b16769)());
                    await queueDequeue;
                    continue;
                }
                decoder.decode(currentPacket);
                const packetResult = await packets.next();
                if (packetResult.done) break;
                currentPacket = packetResult.value;
            }
            await packets.return();
            if (!terminated) await decoder.flush();
            decoder.close();
            if (!firstSampleQueued && lastSample) sampleQueue.push(lastSample);
            decoderIsFlushed = true;
            onQueueNotEmpty(); // To unstuck the generator
        })().catch((error)=>{
            if (!outOfBandError) {
                outOfBandError = error;
                onQueueNotEmpty();
            }
        });
        return {
            async next () {
                while(true){
                    if (terminated) return {
                        value: undefined,
                        done: true
                    };
                    else if (outOfBandError) throw outOfBandError;
                    else if (sampleQueue.length > 0) {
                        const value = sampleQueue.shift();
                        onQueueDequeue();
                        return {
                            value: value,
                            done: false
                        };
                    } else if (!decoderIsFlushed) await queueNotEmpty;
                    else return {
                        value: undefined,
                        done: true
                    };
                }
            },
            async return () {
                terminated = true;
                ended = true;
                onQueueDequeue();
                onQueueNotEmpty();
                lastSample?.close();
                for (const sample of sampleQueue)sample.close();
                return {
                    value: undefined,
                    done: true
                };
            },
            async throw (error) {
                throw error;
            },
            [Symbol.asyncIterator] () {
                return this;
            }
        };
    }
    /** @internal */ mediaSamplesAtTimestamps(timestamps) {
        (0, $053d5bbcf6664967$export$9a53079e0a0ef0fb)(timestamps);
        const timestampIterator = (0, $053d5bbcf6664967$export$83595173025a1dfb)(timestamps);
        const timestampsOfInterest = [];
        const sampleQueue = [];
        let { promise: queueNotEmpty, resolve: onQueueNotEmpty } = (0, $053d5bbcf6664967$export$283a1614f1b16769)();
        let { promise: queueDequeue, resolve: onQueueDequeue } = (0, $053d5bbcf6664967$export$283a1614f1b16769)();
        let decoderIsFlushed = false;
        let terminated = false;
        // This stores errors that are "out of band" in the sense that they didn't occur in the normal flow of this
        // method but instead in a different context. This error should not go unnoticed and must be bubbled up to
        // the consumer.
        let outOfBandError = null;
        const pushToQueue = (sample)=>{
            sampleQueue.push(sample);
            onQueueNotEmpty();
            ({ promise: queueNotEmpty, resolve: onQueueNotEmpty } = (0, $053d5bbcf6664967$export$283a1614f1b16769)());
        };
        // The following is the "pump" process that keeps pumping packets into the decoder
        (async ()=>{
            const decoderError = new Error();
            const decoder = await this._createDecoder((sample)=>{
                onQueueDequeue();
                if (terminated) {
                    sample.close();
                    return;
                }
                let sampleUses = 0;
                while(timestampsOfInterest.length > 0 && sample.timestamp - timestampsOfInterest[0] > -0.0000000001 // Give it a little epsilon
                ){
                    sampleUses++;
                    timestampsOfInterest.shift();
                }
                if (sampleUses > 0) for(let i = 0; i < sampleUses; i++)// Clone the sample if we need to emit it multiple times
                pushToQueue(i < sampleUses - 1 ? sample.clone() : sample);
                else sample.close();
            }, (error)=>{
                if (!outOfBandError) {
                    error.stack = decoderError.stack; // Provide a more useful stack trace
                    outOfBandError = error;
                    onQueueNotEmpty();
                }
            });
            const packetSink = this._createPacketSink();
            let lastPacket = null;
            let lastKeyPacket = null;
            // The end sequence number (inclusive) in the next batch of packets that will be decoded. The batch starts
            // at the last key frame and goes until this sequence number.
            let maxSequenceNumber = -1;
            const decodePackets = async ()=>{
                (0, $053d5bbcf6664967$export$a7a9523472993e97)(lastKeyPacket);
                // Start at the current key packet
                let currentPacket = lastKeyPacket;
                decoder.decode(currentPacket);
                while(currentPacket.sequenceNumber < maxSequenceNumber){
                    const maxQueueSize = $fb6e7064a850c9ee$var$computeMaxQueueSize(sampleQueue.length);
                    while(sampleQueue.length + decoder.getDecodeQueueSize() > maxQueueSize && !terminated){
                        ({ promise: queueDequeue, resolve: onQueueDequeue } = (0, $053d5bbcf6664967$export$283a1614f1b16769)());
                        await queueDequeue;
                    }
                    if (terminated) break;
                    const nextPacket = await packetSink.getNextPacket(currentPacket);
                    (0, $053d5bbcf6664967$export$a7a9523472993e97)(nextPacket);
                    currentPacket = nextPacket;
                    decoder.decode(nextPacket);
                }
                maxSequenceNumber = -1;
            };
            const flushDecoder = async ()=>{
                await decoder.flush();
                // We don't expect this list to have any elements in it anymore, but in case it does, let's emit
                // nulls for every remaining element, then clear it.
                for(let i = 0; i < timestampsOfInterest.length; i++)pushToQueue(null);
                timestampsOfInterest.length = 0;
            };
            for await (const timestamp of timestampIterator){
                $fb6e7064a850c9ee$var$validateTimestamp(timestamp);
                if (terminated) break;
                const targetPacket = await packetSink.getPacket(timestamp);
                const keyPacket = targetPacket && await packetSink.getKeyPacket(timestamp);
                if (!keyPacket) {
                    if (maxSequenceNumber !== -1) {
                        await decodePackets();
                        await flushDecoder();
                    }
                    pushToQueue(null);
                    lastPacket = null;
                    continue;
                }
                // Check if the key packet has changed or if we're going back in time
                if (lastPacket && (keyPacket.sequenceNumber !== lastKeyPacket.sequenceNumber || targetPacket.timestamp < lastPacket.timestamp)) {
                    await decodePackets();
                    await flushDecoder(); // Always flush here, improves decoder compatibility
                }
                timestampsOfInterest.push(targetPacket.timestamp);
                maxSequenceNumber = Math.max(targetPacket.sequenceNumber, maxSequenceNumber);
                lastPacket = targetPacket;
                lastKeyPacket = keyPacket;
            }
            if (!terminated) {
                if (maxSequenceNumber !== -1) // We still need to decode packets
                await decodePackets();
                await flushDecoder();
            }
            decoder.close();
            decoderIsFlushed = true;
            onQueueNotEmpty(); // To unstuck the generator
        })().catch((error)=>{
            if (!outOfBandError) {
                outOfBandError = error;
                onQueueNotEmpty();
            }
        });
        return {
            async next () {
                while(true){
                    if (terminated) return {
                        value: undefined,
                        done: true
                    };
                    else if (outOfBandError) throw outOfBandError;
                    else if (sampleQueue.length > 0) {
                        const value = sampleQueue.shift();
                        (0, $053d5bbcf6664967$export$a7a9523472993e97)(value !== undefined);
                        onQueueDequeue();
                        return {
                            value: value,
                            done: false
                        };
                    } else if (!decoderIsFlushed) await queueNotEmpty;
                    else return {
                        value: undefined,
                        done: true
                    };
                }
            },
            async return () {
                terminated = true;
                onQueueDequeue();
                onQueueNotEmpty();
                for (const sample of sampleQueue)sample?.close();
                return {
                    value: undefined,
                    done: true
                };
            },
            async throw (error) {
                throw error;
            },
            [Symbol.asyncIterator] () {
                return this;
            }
        };
    }
}
const $fb6e7064a850c9ee$var$computeMaxQueueSize = (decodedSampleQueueSize)=>{
    // If we have decoded samples lying around, limit the total queue size to a small value (decoded samples can use up
    // a lot of memory). If not, we're fine with a much bigger queue of encoded packets waiting to be decoded. In fact,
    // some decoders only start flushing out decoded chunks when the packet queue is large enough.
    return decodedSampleQueueSize === 0 ? 40 : 8;
};
class $fb6e7064a850c9ee$var$VideoDecoderWrapper extends $fb6e7064a850c9ee$var$DecoderWrapper {
    constructor(onSample, onError, codec, decoderConfig, rotation, timeResolution){
        super(onSample, onError);
        this.rotation = rotation;
        this.timeResolution = timeResolution;
        this.decoder = null;
        this.customDecoder = null;
        this.customDecoderCallSerializer = new (0, $053d5bbcf6664967$export$e0e588a18ea3887d)();
        this.customDecoderQueueSize = 0;
        this.sampleQueue = [];
        const sampleHandler = (sample)=>{
            // For correct B-frame handling, we don't just hand over the frames directly but instead add them to a
            // queue, because we want to ensure frames are emitted in presentation order. We flush the queue each time
            // we receive a frame with a timestamp larger than the highest we've seen so far, as we can sure that is
            // not a B-frame. Typically, WebCodecs automatically guarantees that frames are emitted in presentation
            // order, but some browsers (Safari) don't always follow this rule.
            if (this.sampleQueue.length > 0 && sample.timestamp >= (0, $053d5bbcf6664967$export$4c7897fafd92b108)(this.sampleQueue).timestamp) {
                for (const sample of this.sampleQueue)this.finalizeAndEmitSample(sample);
                this.sampleQueue.length = 0;
            }
            const insertionIndex = (0, $053d5bbcf6664967$export$682d30103b1cfe4f)(this.sampleQueue, sample.timestamp, (x)=>x.timestamp);
            this.sampleQueue.splice(insertionIndex + 1, 0, sample);
        };
        const MatchingCustomDecoder = (0, $b095dc9cfc0226bb$export$15e88a215e7c6236).find((x)=>x.supports(codec, decoderConfig));
        if (MatchingCustomDecoder) {
            // @ts-expect-error "Can't create instance of abstract class 🤓"
            this.customDecoder = new MatchingCustomDecoder();
            // @ts-expect-error It's technically readonly
            this.customDecoder.codec = codec;
            // @ts-expect-error It's technically readonly
            this.customDecoder.config = decoderConfig;
            // @ts-expect-error It's technically readonly
            this.customDecoder.onSample = (sample)=>{
                if (!(sample instanceof (0, $641b34a2137bac97$export$41944c7dced90f9))) throw new TypeError('The argument passed to onSample must be a VideoSample.');
                sampleHandler(sample);
            };
            this.customDecoderCallSerializer.call(()=>this.customDecoder.init());
        } else {
            this.decoder = new VideoDecoder({
                output: (frame)=>sampleHandler(new (0, $641b34a2137bac97$export$41944c7dced90f9)(frame)),
                error: onError
            });
            this.decoder.configure(decoderConfig);
        }
    }
    finalizeAndEmitSample(sample) {
        // Round the timestamps to the time resolution
        sample.setTimestamp(Math.round(sample.timestamp * this.timeResolution) / this.timeResolution);
        sample.setDuration(Math.round(sample.duration * this.timeResolution) / this.timeResolution);
        sample.setRotation(this.rotation);
        this.onSample(sample);
    }
    getDecodeQueueSize() {
        if (this.customDecoder) return this.customDecoderQueueSize;
        else {
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.decoder);
            return this.decoder.decodeQueueSize;
        }
    }
    decode(packet) {
        if (this.customDecoder) {
            this.customDecoderQueueSize++;
            this.customDecoderCallSerializer.call(()=>this.customDecoder.decode(packet)).then(()=>this.customDecoderQueueSize--);
        } else {
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.decoder);
            this.decoder.decode(packet.toEncodedVideoChunk());
        }
    }
    async flush() {
        if (this.customDecoder) await this.customDecoderCallSerializer.call(()=>this.customDecoder.flush());
        else {
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.decoder);
            await this.decoder.flush();
        }
        for (const sample of this.sampleQueue)this.finalizeAndEmitSample(sample);
        this.sampleQueue.length = 0;
    }
    close() {
        if (this.customDecoder) this.customDecoderCallSerializer.call(()=>this.customDecoder.close());
        else {
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.decoder);
            this.decoder.close();
        }
        for (const sample of this.sampleQueue)sample.close();
        this.sampleQueue.length = 0;
    }
}
class $fb6e7064a850c9ee$export$5c4ef28aba086f8f extends $fb6e7064a850c9ee$export$f35c64f6176d5722 {
    constructor(videoTrack){
        if (!(videoTrack instanceof (0, $ae1d233ed6bad288$export$d22dd8f16c523af9))) throw new TypeError('videoTrack must be an InputVideoTrack.');
        super();
        this._videoTrack = videoTrack;
    }
    /** @internal */ async _createDecoder(onSample, onError) {
        if (!await this._videoTrack.canDecode()) throw new Error("This video track cannot be decoded by this browser. Make sure to check decodability before using a track.");
        const codec = this._videoTrack.codec;
        const rotation = this._videoTrack.rotation;
        const decoderConfig = await this._videoTrack.getDecoderConfig();
        const timeResolution = this._videoTrack.timeResolution;
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(codec && decoderConfig);
        return new $fb6e7064a850c9ee$var$VideoDecoderWrapper(onSample, onError, codec, decoderConfig, rotation, timeResolution);
    }
    /** @internal */ _createPacketSink() {
        return new $fb6e7064a850c9ee$export$9e0d702c2617f4ac(this._videoTrack);
    }
    /**
     * Retrieves the video sample (frame) corresponding to the given timestamp, in seconds. More specifically, returns
     * the last video sample (in presentation order) with a start timestamp less than or equal to the given timestamp.
     * Returns null if the timestamp is before the track's first timestamp.
     *
     * @param timestamp - The timestamp used for retrieval, in seconds.
     */ async getSample(timestamp) {
        $fb6e7064a850c9ee$var$validateTimestamp(timestamp);
        for await (const sample of this.mediaSamplesAtTimestamps([
            timestamp
        ]))return sample;
        throw new Error('Internal error: Iterator returned nothing.');
    }
    /**
     * Creates an async iterator that yields the video samples (frames) of this track in presentation order. This method
     * will intelligently pre-decode a few frames ahead to enable fast iteration.
     *
     * @param startTimestamp - The timestamp in seconds at which to start yielding samples (inclusive).
     * @param endTimestamp - The timestamp in seconds at which to stop yielding samples (exclusive).
     */ samples(startTimestamp = 0, endTimestamp = Infinity) {
        return this.mediaSamplesInRange(startTimestamp, endTimestamp);
    }
    /**
     * Creates an async iterator that yields a video sample (frame) for each timestamp in the argument. This method
     * uses an optimized decoding pipeline if these timestamps are monotonically sorted, decoding each packet at most
     * once, and is therefore more efficient than manually getting the sample for every timestamp. The iterator may
     * yield null if no frame is available for a given timestamp.
     *
     * @param timestamps - An iterable or async iterable of timestamps in seconds.
     */ samplesAtTimestamps(timestamps) {
        return this.mediaSamplesAtTimestamps(timestamps);
    }
}
class $fb6e7064a850c9ee$export$73f8e9bf286ad238 {
    constructor(videoTrack, options = {}){
        /** @internal */ this._nextCanvasIndex = 0;
        if (!(videoTrack instanceof (0, $ae1d233ed6bad288$export$d22dd8f16c523af9))) throw new TypeError('videoTrack must be an InputVideoTrack.');
        if (options && typeof options !== 'object') throw new TypeError('options must be an object.');
        if (options.width !== undefined && (!Number.isInteger(options.width) || options.width <= 0)) throw new TypeError('options.width, when defined, must be a positive integer.');
        if (options.height !== undefined && (!Number.isInteger(options.height) || options.height <= 0)) throw new TypeError('options.height, when defined, must be a positive integer.');
        if (options.fit !== undefined && ![
            'fill',
            'contain',
            'cover'
        ].includes(options.fit)) throw new TypeError('options.fit, when provided, must be one of "fill", "contain", or "cover".');
        if (options.width !== undefined && options.height !== undefined && options.fit === undefined) throw new TypeError('When both options.width and options.height are provided, options.fit must also be provided.');
        if (options.rotation !== undefined && ![
            0,
            90,
            180,
            270
        ].includes(options.rotation)) throw new TypeError('options.rotation, when provided, must be 0, 90, 180 or 270.');
        if (options.poolSize !== undefined && (typeof options.poolSize !== 'number' || !Number.isInteger(options.poolSize) || options.poolSize < 0)) throw new TypeError('poolSize must be a non-negative integer.');
        const rotation = options.rotation ?? videoTrack.rotation;
        let [width, height] = rotation % 180 === 0 ? [
            videoTrack.codedWidth,
            videoTrack.codedHeight
        ] : [
            videoTrack.codedHeight,
            videoTrack.codedWidth
        ];
        const originalAspectRatio = width / height;
        // If width and height aren't defined together, deduce the missing value using the aspect ratio
        if (options.width !== undefined && options.height === undefined) {
            width = options.width;
            height = Math.round(width / originalAspectRatio);
        } else if (options.width === undefined && options.height !== undefined) {
            height = options.height;
            width = Math.round(height * originalAspectRatio);
        } else if (options.width !== undefined && options.height !== undefined) {
            width = options.width;
            height = options.height;
        }
        this._videoTrack = videoTrack;
        this._width = width;
        this._height = height;
        this._rotation = rotation;
        this._fit = options.fit ?? 'fill';
        this._videoSampleSink = new $fb6e7064a850c9ee$export$5c4ef28aba086f8f(videoTrack);
        this._canvasPool = Array.from({
            length: options.poolSize ?? 0
        }, ()=>null);
    }
    /** @internal */ _videoSampleToWrappedCanvas(sample) {
        let canvas = this._canvasPool[this._nextCanvasIndex];
        if (!canvas) {
            if (typeof document !== 'undefined') {
                // Prefer an HTMLCanvasElement
                canvas = document.createElement('canvas');
                canvas.width = this._width;
                canvas.height = this._height;
            } else canvas = new OffscreenCanvas(this._width, this._height);
            if (this._canvasPool.length > 0) this._canvasPool[this._nextCanvasIndex] = canvas;
        }
        if (this._canvasPool.length > 0) this._nextCanvasIndex = (this._nextCanvasIndex + 1) % this._canvasPool.length;
        const context = canvas.getContext('2d', {
            alpha: false
        });
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(context);
        context.resetTransform();
        // These variables specify where the final sample will be drawn on the canvas
        let dx;
        let dy;
        let newWidth;
        let newHeight;
        if (this._fit === 'fill') {
            dx = 0;
            dy = 0;
            newWidth = this._width;
            newHeight = this._height;
        } else {
            const [sampleWidth, sampleHeight] = this._rotation % 180 === 0 ? [
                sample.codedWidth,
                sample.codedHeight
            ] : [
                sample.codedHeight,
                sample.codedWidth
            ];
            const scale = this._fit === 'contain' ? Math.min(this._width / sampleWidth, this._height / sampleHeight) : Math.max(this._width / sampleWidth, this._height / sampleHeight);
            newWidth = sampleWidth * scale;
            newHeight = sampleHeight * scale;
            dx = (this._width - newWidth) / 2;
            dy = (this._height - newHeight) / 2;
        }
        const aspectRatioChange = this._rotation % 180 === 0 ? 1 : newWidth / newHeight;
        context.translate(this._width / 2, this._height / 2);
        context.rotate(this._rotation * Math.PI / 180);
        // This aspect ratio compensation is done so that we can draw the sample with the intended dimensions and
        // don't need to think about how those dimensions change after the rotation
        context.scale(1 / aspectRatioChange, aspectRatioChange);
        context.translate(-this._width / 2, -this._height / 2);
        context.drawImage(sample.toCanvasImageSource(), dx, dy, newWidth, newHeight);
        const result = {
            canvas: canvas,
            timestamp: sample.timestamp,
            duration: sample.duration
        };
        sample.close();
        return result;
    }
    /**
     * Retrieves a canvas with the video frame corresponding to the given timestamp, in seconds. More specifically,
     * returns the last video frame (in presentation order) with a start timestamp less than or equal to the given
     * timestamp. Returns null if the timestamp is before the track's first timestamp.
     *
     * @param timestamp - The timestamp used for retrieval, in seconds.
     */ async getCanvas(timestamp) {
        $fb6e7064a850c9ee$var$validateTimestamp(timestamp);
        const sample = await this._videoSampleSink.getSample(timestamp);
        return sample && this._videoSampleToWrappedCanvas(sample);
    }
    /**
     * Creates an async iterator that yields canvases with the video frames of this track in presentation order. This
     * method will intelligently pre-decode a few frames ahead to enable fast iteration.
     *
     * @param startTimestamp - The timestamp in seconds at which to start yielding canvases (inclusive).
     * @param endTimestamp - The timestamp in seconds at which to stop yielding canvases (exclusive).
     */ canvases(startTimestamp = 0, endTimestamp = Infinity) {
        return (0, $053d5bbcf6664967$export$3abce8f324616eb4)(this._videoSampleSink.samples(startTimestamp, endTimestamp), (sample)=>this._videoSampleToWrappedCanvas(sample));
    }
    /**
     * Creates an async iterator that yields a canvas for each timestamp in the argument. This method uses an optimized
     * decoding pipeline if these timestamps are monotonically sorted, decoding each packet at most once, and is
     * therefore more efficient than manually getting the canvas for every timestamp. The iterator may yield null if
     * no frame is available for a given timestamp.
     *
     * @param timestamps - An iterable or async iterable of timestamps in seconds.
     */ canvasesAtTimestamps(timestamps) {
        return (0, $053d5bbcf6664967$export$3abce8f324616eb4)(this._videoSampleSink.samplesAtTimestamps(timestamps), (sample)=>sample && this._videoSampleToWrappedCanvas(sample));
    }
}
class $fb6e7064a850c9ee$var$AudioDecoderWrapper extends $fb6e7064a850c9ee$var$DecoderWrapper {
    constructor(onSample, onError, codec, decoderConfig){
        super(onSample, onError);
        this.decoder = null;
        this.customDecoder = null;
        this.customDecoderCallSerializer = new (0, $053d5bbcf6664967$export$e0e588a18ea3887d)();
        this.customDecoderQueueSize = 0;
        const sampleHandler = (sample)=>{
            const sampleRate = decoderConfig.sampleRate;
            // Round the timestamp to the sample rate
            sample.setTimestamp(Math.round(sample.timestamp * sampleRate) / sampleRate);
            onSample(sample);
        };
        const MatchingCustomDecoder = (0, $b095dc9cfc0226bb$export$568c477eb30f6f5c).find((x)=>x.supports(codec, decoderConfig));
        if (MatchingCustomDecoder) {
            // @ts-expect-error "Can't create instance of abstract class 🤓"
            this.customDecoder = new MatchingCustomDecoder();
            // @ts-expect-error It's technically readonly
            this.customDecoder.codec = codec;
            // @ts-expect-error It's technically readonly
            this.customDecoder.config = decoderConfig;
            // @ts-expect-error It's technically readonly
            this.customDecoder.onSample = (sample)=>{
                if (!(sample instanceof (0, $641b34a2137bac97$export$290dedacb3c54314))) throw new TypeError('The argument passed to onSample must be an AudioSample.');
                sampleHandler(sample);
            };
            this.customDecoderCallSerializer.call(()=>this.customDecoder.init());
        } else {
            this.decoder = new AudioDecoder({
                output: (data)=>sampleHandler(new (0, $641b34a2137bac97$export$290dedacb3c54314)(data)),
                error: onError
            });
            this.decoder.configure(decoderConfig);
        }
    }
    getDecodeQueueSize() {
        if (this.customDecoder) return this.customDecoderQueueSize;
        else {
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.decoder);
            return this.decoder.decodeQueueSize;
        }
    }
    decode(packet) {
        if (this.customDecoder) {
            this.customDecoderQueueSize++;
            this.customDecoderCallSerializer.call(()=>this.customDecoder.decode(packet)).then(()=>this.customDecoderQueueSize--);
        } else {
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.decoder);
            this.decoder.decode(packet.toEncodedAudioChunk());
        }
    }
    flush() {
        if (this.customDecoder) return this.customDecoderCallSerializer.call(()=>this.customDecoder.flush());
        else {
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.decoder);
            return this.decoder.flush();
        }
    }
    close() {
        if (this.customDecoder) this.customDecoderCallSerializer.call(()=>this.customDecoder.close());
        else {
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.decoder);
            this.decoder.close();
        }
    }
}
// There are a lot of PCM variants not natively supported by the browser and by AudioData. Therefore we need a simple
// decoder that maps any input PCM format into a PCM format supported by the browser.
class $fb6e7064a850c9ee$var$PcmAudioDecoderWrapper extends $fb6e7064a850c9ee$var$DecoderWrapper {
    constructor(onSample, onError, decoderConfig){
        super(onSample, onError);
        this.decoderConfig = decoderConfig;
        // Internal state to accumulate a precise current timestamp based on audio durations, not the (potentially
        // inaccurate) sample timestamps.
        this.currentTimestamp = null;
        (0, $053d5bbcf6664967$export$a7a9523472993e97)((0, $94511f4b46249ea3$export$58c594b1fe7e587b).includes(decoderConfig.codec));
        this.codec = decoderConfig.codec;
        const { dataType: dataType, sampleSize: sampleSize, littleEndian: littleEndian } = (0, $94511f4b46249ea3$export$560120a2d4e71dc2)(this.codec);
        this.inputSampleSize = sampleSize;
        switch(sampleSize){
            case 1:
                if (dataType === 'unsigned') this.readInputValue = (view, byteOffset)=>view.getUint8(byteOffset) - 128;
                else if (dataType === 'signed') this.readInputValue = (view, byteOffset)=>view.getInt8(byteOffset);
                else if (dataType === 'ulaw') this.readInputValue = (view, byteOffset)=>(0, $d272c64a25724154$export$a39b2e9b5a716a7a)(view.getUint8(byteOffset));
                else if (dataType === 'alaw') this.readInputValue = (view, byteOffset)=>(0, $d272c64a25724154$export$960a470902702a7d)(view.getUint8(byteOffset));
                else (0, $053d5bbcf6664967$export$a7a9523472993e97)(false);
                break;
            case 2:
                if (dataType === 'unsigned') this.readInputValue = (view, byteOffset)=>view.getUint16(byteOffset, littleEndian) - 2 ** 15;
                else if (dataType === 'signed') this.readInputValue = (view, byteOffset)=>view.getInt16(byteOffset, littleEndian);
                else (0, $053d5bbcf6664967$export$a7a9523472993e97)(false);
                break;
            case 3:
                if (dataType === 'unsigned') this.readInputValue = (view, byteOffset)=>(0, $053d5bbcf6664967$export$32b2c839ee319ab6)(view, byteOffset, littleEndian) - 2 ** 23;
                else if (dataType === 'signed') this.readInputValue = (view, byteOffset)=>(0, $053d5bbcf6664967$export$bc4fa2eeefffa8ff)(view, byteOffset, littleEndian);
                else (0, $053d5bbcf6664967$export$a7a9523472993e97)(false);
                break;
            case 4:
                if (dataType === 'unsigned') this.readInputValue = (view, byteOffset)=>view.getUint32(byteOffset, littleEndian) - 2 ** 31;
                else if (dataType === 'signed') this.readInputValue = (view, byteOffset)=>view.getInt32(byteOffset, littleEndian);
                else if (dataType === 'float') this.readInputValue = (view, byteOffset)=>view.getFloat32(byteOffset, littleEndian);
                else (0, $053d5bbcf6664967$export$a7a9523472993e97)(false);
                break;
            case 8:
                if (dataType === 'float') this.readInputValue = (view, byteOffset)=>view.getFloat64(byteOffset, littleEndian);
                else (0, $053d5bbcf6664967$export$a7a9523472993e97)(false);
                break;
            default:
                (0, $053d5bbcf6664967$export$cbadc5a7223772a8)(sampleSize);
                (0, $053d5bbcf6664967$export$a7a9523472993e97)(false);
        }
        switch(sampleSize){
            case 1:
                if (dataType === 'ulaw' || dataType === 'alaw') {
                    this.outputSampleSize = 2;
                    this.outputFormat = 's16';
                    this.writeOutputValue = (view, byteOffset, value)=>view.setInt16(byteOffset, value, true);
                } else {
                    this.outputSampleSize = 1;
                    this.outputFormat = 'u8';
                    this.writeOutputValue = (view, byteOffset, value)=>view.setUint8(byteOffset, value + 128);
                }
                break;
            case 2:
                this.outputSampleSize = 2;
                this.outputFormat = 's16';
                this.writeOutputValue = (view, byteOffset, value)=>view.setInt16(byteOffset, value, true);
                break;
            case 3:
                this.outputSampleSize = 4;
                this.outputFormat = 's32';
                // From https://www.w3.org/TR/webcodecs:
                // AudioData containing 24-bit samples SHOULD store those samples in s32 or f32. When samples are
                // stored in s32, each sample MUST be left-shifted by 8 bits.
                this.writeOutputValue = (view, byteOffset, value)=>view.setInt32(byteOffset, value << 8, true);
                break;
            case 4:
                this.outputSampleSize = 4;
                if (dataType === 'float') {
                    this.outputFormat = 'f32';
                    this.writeOutputValue = (view, byteOffset, value)=>view.setFloat32(byteOffset, value, true);
                } else {
                    this.outputFormat = 's32';
                    this.writeOutputValue = (view, byteOffset, value)=>view.setInt32(byteOffset, value, true);
                }
                break;
            case 8:
                this.outputSampleSize = 4;
                this.outputFormat = 'f32';
                this.writeOutputValue = (view, byteOffset, value)=>view.setFloat32(byteOffset, value, true);
                break;
            default:
                (0, $053d5bbcf6664967$export$cbadc5a7223772a8)(sampleSize);
                (0, $053d5bbcf6664967$export$a7a9523472993e97)(false);
        }
    }
    getDecodeQueueSize() {
        return 0;
    }
    decode(packet) {
        const inputView = (0, $053d5bbcf6664967$export$f6b0788df7b6d1ec)(packet.data);
        const numberOfFrames = packet.byteLength / this.decoderConfig.numberOfChannels / this.inputSampleSize;
        const outputBufferSize = numberOfFrames * this.decoderConfig.numberOfChannels * this.outputSampleSize;
        const outputBuffer = new ArrayBuffer(outputBufferSize);
        const outputView = new DataView(outputBuffer);
        for(let i = 0; i < numberOfFrames * this.decoderConfig.numberOfChannels; i++){
            const inputIndex = i * this.inputSampleSize;
            const outputIndex = i * this.outputSampleSize;
            const value = this.readInputValue(inputView, inputIndex);
            this.writeOutputValue(outputView, outputIndex, value);
        }
        const preciseDuration = numberOfFrames / this.decoderConfig.sampleRate;
        if (this.currentTimestamp === null || Math.abs(packet.timestamp - this.currentTimestamp) >= preciseDuration) // We need to sync with the packet timestamp again
        this.currentTimestamp = packet.timestamp;
        const preciseTimestamp = this.currentTimestamp;
        this.currentTimestamp += preciseDuration;
        const audioSample = new (0, $641b34a2137bac97$export$290dedacb3c54314)({
            format: this.outputFormat,
            data: outputBuffer,
            numberOfChannels: this.decoderConfig.numberOfChannels,
            sampleRate: this.decoderConfig.sampleRate,
            numberOfFrames: numberOfFrames,
            timestamp: preciseTimestamp
        });
        this.onSample(audioSample);
    }
    async flush() {
    // Do nothing
    }
    close() {
    // Do nothing
    }
}
class $fb6e7064a850c9ee$export$6bee19c507b4c67d extends $fb6e7064a850c9ee$export$f35c64f6176d5722 {
    constructor(audioTrack){
        if (!(audioTrack instanceof (0, $ae1d233ed6bad288$export$886fbe0dd65c2e67))) throw new TypeError('audioTrack must be an InputAudioTrack.');
        super();
        this._audioTrack = audioTrack;
    }
    /** @internal */ async _createDecoder(onSample, onError) {
        if (!await this._audioTrack.canDecode()) throw new Error("This audio track cannot be decoded by this browser. Make sure to check decodability before using a track.");
        const codec = this._audioTrack.codec;
        const decoderConfig = await this._audioTrack.getDecoderConfig();
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(codec && decoderConfig);
        if ((0, $94511f4b46249ea3$export$58c594b1fe7e587b).includes(decoderConfig.codec)) return new $fb6e7064a850c9ee$var$PcmAudioDecoderWrapper(onSample, onError, decoderConfig);
        else return new $fb6e7064a850c9ee$var$AudioDecoderWrapper(onSample, onError, codec, decoderConfig);
    }
    /** @internal */ _createPacketSink() {
        return new $fb6e7064a850c9ee$export$9e0d702c2617f4ac(this._audioTrack);
    }
    /**
     * Retrieves the audio sample corresponding to the given timestamp, in seconds. More specifically, returns
     * the last audio sample (in presentation order) with a start timestamp less than or equal to the given timestamp.
     * Returns null if the timestamp is before the track's first timestamp.
     *
     * @param timestamp - The timestamp used for retrieval, in seconds.
     */ async getSample(timestamp) {
        $fb6e7064a850c9ee$var$validateTimestamp(timestamp);
        for await (const sample of this.mediaSamplesAtTimestamps([
            timestamp
        ]))return sample;
        throw new Error('Internal error: Iterator returned nothing.');
    }
    /**
     * Creates an async iterator that yields the audio samples of this track in presentation order. This method
     * will intelligently pre-decode a few samples ahead to enable fast iteration.
     *
     * @param startTimestamp - The timestamp in seconds at which to start yielding samples (inclusive).
     * @param endTimestamp - The timestamp in seconds at which to stop yielding samples (exclusive).
     */ samples(startTimestamp = 0, endTimestamp = Infinity) {
        return this.mediaSamplesInRange(startTimestamp, endTimestamp);
    }
    /**
     * Creates an async iterator that yields an audio sample for each timestamp in the argument. This method
     * uses an optimized decoding pipeline if these timestamps are monotonically sorted, decoding each packet at most
     * once, and is therefore more efficient than manually getting the sample for every timestamp. The iterator may
     * yield null if no sample is available for a given timestamp.
     *
     * @param timestamps - An iterable or async iterable of timestamps in seconds.
     */ samplesAtTimestamps(timestamps) {
        return this.mediaSamplesAtTimestamps(timestamps);
    }
}
class $fb6e7064a850c9ee$export$e12bc7c5034ad722 {
    constructor(audioTrack){
        if (!(audioTrack instanceof (0, $ae1d233ed6bad288$export$886fbe0dd65c2e67))) throw new TypeError('audioTrack must be an InputAudioTrack.');
        this._audioSampleSink = new $fb6e7064a850c9ee$export$6bee19c507b4c67d(audioTrack);
    }
    /** @internal */ _audioSampleToWrappedArrayBuffer(sample) {
        return {
            buffer: sample.toAudioBuffer(),
            timestamp: sample.timestamp,
            duration: sample.duration
        };
    }
    /**
     * Retrieves the audio buffer corresponding to the given timestamp, in seconds. More specifically, returns
     * the last audio buffer (in presentation order) with a start timestamp less than or equal to the given timestamp.
     * Returns null if the timestamp is before the track's first timestamp.
     *
     * @param timestamp - The timestamp used for retrieval, in seconds.
     */ async getBuffer(timestamp) {
        $fb6e7064a850c9ee$var$validateTimestamp(timestamp);
        const data = await this._audioSampleSink.getSample(timestamp);
        return data && this._audioSampleToWrappedArrayBuffer(data);
    }
    /**
     * Creates an async iterator that yields audio buffers of this track in presentation order. This method
     * will intelligently pre-decode a few buffers ahead to enable fast iteration.
     *
     * @param startTimestamp - The timestamp in seconds at which to start yielding buffers (inclusive).
     * @param endTimestamp - The timestamp in seconds at which to stop yielding buffers (exclusive).
     */ buffers(startTimestamp = 0, endTimestamp = Infinity) {
        return (0, $053d5bbcf6664967$export$3abce8f324616eb4)(this._audioSampleSink.samples(startTimestamp, endTimestamp), (data)=>this._audioSampleToWrappedArrayBuffer(data));
    }
    /**
     * Creates an async iterator that yields an audio buffer for each timestamp in the argument. This method
     * uses an optimized decoding pipeline if these timestamps are monotonically sorted, decoding each packet at most
     * once, and is therefore more efficient than manually getting the buffer for every timestamp. The iterator may
     * yield null if no buffer is available for a given timestamp.
     *
     * @param timestamps - An iterable or async iterable of timestamps in seconds.
     */ buffersAtTimestamps(timestamps) {
        return (0, $053d5bbcf6664967$export$3abce8f324616eb4)(this._audioSampleSink.samplesAtTimestamps(timestamps), (data)=>data && this._audioSampleToWrappedArrayBuffer(data));
    }
}



class $ae1d233ed6bad288$export$927f91e785b199d8 {
    /** @internal */ constructor(backing){
        this._backing = backing;
    }
    /** Returns true iff this track is a video track. */ isVideoTrack() {
        return this instanceof $ae1d233ed6bad288$export$d22dd8f16c523af9;
    }
    /** Returns true iff this track is an audio track. */ isAudioTrack() {
        return this instanceof $ae1d233ed6bad288$export$886fbe0dd65c2e67;
    }
    /** The unique ID of this track in the input file. */ get id() {
        return this._backing.getId();
    }
    /** The ISO 639-2/T language code for this track. If the language is unknown, this field is 'und' (undetermined). */ get languageCode() {
        return this._backing.getLanguageCode();
    }
    /**
     * A positive number x such that all timestamps and durations of all packets of this track are
     * integer multiples of 1/x.
     */ get timeResolution() {
        return this._backing.getTimeResolution();
    }
    /**
     * Returns the start timestamp of the first packet of this track, in seconds. While often near zero, this value
     * may be positive or even negative. A negative starting timestamp means the track's timing has been offset. Samples
     * with a negative timestamp should not be presented.
     */ getFirstTimestamp() {
        return this._backing.getFirstTimestamp();
    }
    /** Returns the end timestamp of the last packet of this track, in seconds. */ computeDuration() {
        return this._backing.computeDuration();
    }
    /**
     * Computes aggregate packet statistics for this track, such as average packet rate or bitrate.
     *
     * @param targetPacketCount - This optional parameter sets a target for how many packets this method must have
     * looked at before it can return early; this means, you can use it to aggregate only a subset (prefix) of all
     * packets. This is very useful for getting a great estimate of video frame rate without having to scan through the
     * entire file.
     */ async computePacketStats(targetPacketCount = Infinity) {
        const sink = new (0, $fb6e7064a850c9ee$export$9e0d702c2617f4ac)(this);
        let startTimestamp = Infinity;
        let endTimestamp = -Infinity;
        let packetCount = 0;
        let totalPacketBytes = 0;
        for await (const packet of sink.packets(undefined, undefined, {
            metadataOnly: true
        })){
            if (packetCount >= targetPacketCount && packet.timestamp >= endTimestamp) break;
            startTimestamp = Math.min(startTimestamp, packet.timestamp);
            endTimestamp = Math.max(endTimestamp, packet.timestamp + packet.duration);
            packetCount++;
            totalPacketBytes += packet.byteLength;
        }
        return {
            packetCount: packetCount,
            averagePacketRate: packetCount ? Number((packetCount / (endTimestamp - startTimestamp)).toPrecision(16)) : 0,
            averageBitrate: packetCount ? Number((8 * totalPacketBytes / (endTimestamp - startTimestamp)).toPrecision(16)) : 0
        };
    }
}
class $ae1d233ed6bad288$export$d22dd8f16c523af9 extends $ae1d233ed6bad288$export$927f91e785b199d8 {
    /** @internal */ constructor(backing){
        super(backing);
        this._backing = backing;
    }
    get type() {
        return 'video';
    }
    get codec() {
        return this._backing.getCodec();
    }
    /** The width in pixels of the track's coded samples, before any transformations or rotations. */ get codedWidth() {
        return this._backing.getCodedWidth();
    }
    /** The height in pixels of the track's coded samples, before any transformations or rotations. */ get codedHeight() {
        return this._backing.getCodedHeight();
    }
    /** The angle in degrees by which the track's frames should be rotated (clockwise). */ get rotation() {
        return this._backing.getRotation();
    }
    /** The width in pixels of the track's frames after rotation. */ get displayWidth() {
        const rotation = this._backing.getRotation();
        return rotation % 180 === 0 ? this._backing.getCodedWidth() : this._backing.getCodedHeight();
    }
    /** The height in pixels of the track's frames after rotation. */ get displayHeight() {
        const rotation = this._backing.getRotation();
        return rotation % 180 === 0 ? this._backing.getCodedHeight() : this._backing.getCodedWidth();
    }
    /** Returns the color space of the track's samples. */ getColorSpace() {
        return this._backing.getColorSpace();
    }
    /** If this method returns true, the track's samples use a high dynamic range (HDR). */ async hasHighDynamicRange() {
        const colorSpace = await this._backing.getColorSpace();
        return colorSpace.primaries === 'bt2020' || colorSpace.primaries === 'smpte432' || colorSpace.transfer === 'pg' || colorSpace.transfer === 'hlg' || colorSpace.matrix === 'bt2020-ncl';
    }
    /** Returns the decoder configuration for decoding the track's packets using a VideoDecoder. */ getDecoderConfig() {
        return this._backing.getDecoderConfig();
    }
    async getCodecParameterString() {
        const decoderConfig = await this._backing.getDecoderConfig();
        return decoderConfig?.codec ?? null;
    }
    async canDecode() {
        try {
            const decoderConfig = await this._backing.getDecoderConfig();
            if (!decoderConfig) return false;
            const codec = this._backing.getCodec();
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(codec !== null);
            if ((0, $b095dc9cfc0226bb$export$15e88a215e7c6236).some((x)=>x.supports(codec, decoderConfig))) return true;
            if (typeof VideoDecoder === 'undefined') return false;
            const support = await VideoDecoder.isConfigSupported(decoderConfig);
            return support.supported === true;
        } catch (error) {
            console.error('Error during decodability check:', error);
            return false;
        }
    }
}
class $ae1d233ed6bad288$export$886fbe0dd65c2e67 extends $ae1d233ed6bad288$export$927f91e785b199d8 {
    /** @internal */ constructor(backing){
        super(backing);
        this._backing = backing;
    }
    get type() {
        return 'audio';
    }
    get codec() {
        return this._backing.getCodec();
    }
    /** The number of audio channels in the track. */ get numberOfChannels() {
        return this._backing.getNumberOfChannels();
    }
    /** The track's audio sample rate in hertz. */ get sampleRate() {
        return this._backing.getSampleRate();
    }
    /** Returns the decoder configuration for decoding the track's packets using an AudioDecoder. */ getDecoderConfig() {
        return this._backing.getDecoderConfig();
    }
    async getCodecParameterString() {
        const decoderConfig = await this._backing.getDecoderConfig();
        return decoderConfig?.codec ?? null;
    }
    async canDecode() {
        try {
            const decoderConfig = await this._backing.getDecoderConfig();
            if (!decoderConfig) return false;
            const codec = this._backing.getCodec();
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(codec !== null);
            if ((0, $b095dc9cfc0226bb$export$568c477eb30f6f5c).some((x)=>x.supports(codec, decoderConfig))) return true;
            if (decoderConfig.codec.startsWith('pcm-')) return true; // Since we decode it ourselves
            else {
                if (typeof AudioDecoder === 'undefined') return false;
                const support = await AudioDecoder.isConfigSupported(decoderConfig);
                return support.supported === true;
            }
        } catch (error) {
            console.error('Error during decodability check:', error);
            return false;
        }
    }
}




/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ 
class $91e0146795b1dff0$export$2f7a2f0e90c07dc4 {
    constructor(source, maxStorableBytes = Infinity){
        this.source = source;
        this.maxStorableBytes = maxStorableBytes;
        this.loadedSegments = [];
        this.loadingSegments = [];
        this.sourceSizePromise = null;
        this.nextAge = 0;
        this.totalStoredBytes = 0;
    }
    async loadRange(start, end) {
        end = Math.min(end, await this.source.getSize());
        if (start >= end) return;
        const matchingLoadingSegment = this.loadingSegments.find((x)=>x.start <= start && x.end >= end);
        if (matchingLoadingSegment) {
            // Simply wait for the existing promise to finish to avoid loading the same range twice
            await matchingLoadingSegment.promise;
            return;
        }
        const index = (0, $053d5bbcf6664967$export$682d30103b1cfe4f)(this.loadedSegments, start, (x)=>x.start);
        if (index !== -1) for(let i = index; i < this.loadedSegments.length; i++){
            const segment = this.loadedSegments[i];
            if (segment.start > start) break;
            const segmentEncasesRequestedRange = segment.end >= end;
            if (segmentEncasesRequestedRange) // Nothing to load
            return;
        }
        this.source.onread?.(start, end);
        const bytesPromise = this.source._read(start, end);
        const loadingSegment = {
            start: start,
            end: end,
            promise: bytesPromise
        };
        this.loadingSegments.push(loadingSegment);
        const bytes = await bytesPromise;
        (0, $053d5bbcf6664967$export$fe2d9b4e03920b4c)(this.loadingSegments, loadingSegment);
        this.insertIntoLoadedSegments(start, bytes);
    }
    rangeIsLoaded(start, end) {
        if (end <= start) return true;
        const index = (0, $053d5bbcf6664967$export$682d30103b1cfe4f)(this.loadedSegments, start, (x)=>x.start);
        if (index === -1) return false;
        for(let i = index; i < this.loadedSegments.length; i++){
            const segment = this.loadedSegments[i];
            if (segment.start > start) break;
            const segmentEncasesRequestedRange = segment.end >= end;
            if (segmentEncasesRequestedRange) return true;
        }
        return false;
    }
    insertIntoLoadedSegments(start, bytes) {
        const segment = {
            start: start,
            end: start + bytes.byteLength,
            bytes: bytes,
            view: new DataView(bytes.buffer),
            age: this.nextAge++
        };
        let index = (0, $053d5bbcf6664967$export$682d30103b1cfe4f)(this.loadedSegments, start, (x)=>x.start);
        if (index === -1 || this.loadedSegments[index].start < segment.start) index++;
        // Insert the segment at the right place so that the array remains sorted by start offset
        this.loadedSegments.splice(index, 0, segment);
        this.totalStoredBytes += bytes.byteLength;
        // Remove all other segments from the array that are completely covered by the newly-inserted segment
        for(let i = index + 1; i < this.loadedSegments.length; i++){
            const otherSegment = this.loadedSegments[i];
            if (otherSegment.start >= segment.end) break;
            if (segment.start <= otherSegment.start && otherSegment.end <= segment.end) {
                this.loadedSegments.splice(i, 1);
                i--;
            }
        }
        // If we overshoot the max amount of permitted bytes, let's start evicting the oldest segments
        while(this.totalStoredBytes > this.maxStorableBytes && this.loadedSegments.length > 1){
            let oldestSegment = null;
            let oldestSegmentIndex = -1;
            for(let i = 0; i < this.loadedSegments.length; i++){
                const candidate = this.loadedSegments[i];
                if (!oldestSegment || candidate.age < oldestSegment.age) {
                    oldestSegment = candidate;
                    oldestSegmentIndex = i;
                }
            }
            (0, $053d5bbcf6664967$export$a7a9523472993e97)(oldestSegment);
            this.totalStoredBytes -= oldestSegment.bytes.byteLength;
            this.loadedSegments.splice(oldestSegmentIndex, 1);
        }
    }
    getViewAndOffset(start, end) {
        const startIndex = (0, $053d5bbcf6664967$export$682d30103b1cfe4f)(this.loadedSegments, start, (x)=>x.start);
        let segment = null;
        if (startIndex !== -1) for(let i = startIndex; i < this.loadedSegments.length; i++){
            const candidate = this.loadedSegments[i];
            if (candidate.start > start) break;
            if (end <= candidate.end) {
                segment = candidate;
                break;
            }
        }
        if (!segment) throw new Error(`No segment loaded for range [${start}, ${end}).`);
        segment.age = this.nextAge++;
        return {
            view: segment.view,
            offset: segment.bytes.byteOffset + start - segment.start
        };
    }
    forgetRange(start, end) {
        if (end <= start) return;
        const startIndex = (0, $053d5bbcf6664967$export$682d30103b1cfe4f)(this.loadedSegments, start, (x)=>x.start);
        if (startIndex === -1) return;
        const segment = this.loadedSegments[startIndex];
        if (segment.start !== start || segment.end !== end) return;
        this.loadedSegments.splice(startIndex, 1);
        this.totalStoredBytes -= segment.bytes.byteLength;
    }
}


/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ class $dd38a4069eb9455d$export$55f75071f06461bb {
    constructor(reader){
        this.reader = reader;
        this.pos = 0;
        this.littleEndian = true;
    }
    readBytes(length) {
        const { view: view, offset: offset } = this.reader.getViewAndOffset(this.pos, this.pos + length);
        this.pos += length;
        return new Uint8Array(view.buffer, offset, length);
    }
    readU16() {
        const { view: view, offset: offset } = this.reader.getViewAndOffset(this.pos, this.pos + 2);
        this.pos += 2;
        return view.getUint16(offset, this.littleEndian);
    }
    readU32() {
        const { view: view, offset: offset } = this.reader.getViewAndOffset(this.pos, this.pos + 4);
        this.pos += 4;
        return view.getUint32(offset, this.littleEndian);
    }
    readU64() {
        let low;
        let high;
        if (this.littleEndian) {
            low = this.readU32();
            high = this.readU32();
        } else {
            high = this.readU32();
            low = this.readU32();
        }
        return high * 0x100000000 + low;
    }
    readAscii(length) {
        const { view: view, offset: offset } = this.reader.getViewAndOffset(this.pos, this.pos + length);
        this.pos += length;
        let str = '';
        for(let i = 0; i < length; i++)str += String.fromCharCode(view.getUint8(offset + i));
        return str;
    }
}


var $40ebdb00788778b0$export$55472bccb6ce403f;
(function(WaveFormat) {
    WaveFormat[WaveFormat["PCM"] = 1] = "PCM";
    WaveFormat[WaveFormat["IEEE_FLOAT"] = 3] = "IEEE_FLOAT";
    WaveFormat[WaveFormat["ALAW"] = 6] = "ALAW";
    WaveFormat[WaveFormat["MULAW"] = 7] = "MULAW";
    WaveFormat[WaveFormat["EXTENSIBLE"] = 65534] = "EXTENSIBLE";
})($40ebdb00788778b0$export$55472bccb6ce403f || ($40ebdb00788778b0$export$55472bccb6ce403f = {}));
class $40ebdb00788778b0$export$15dc31280b203610 extends (0, $65791c3b240bd28a$export$6a429f49ace8e035) {
    constructor(input){
        super(input);
        this.metadataPromise = null;
        this.dataStart = -1;
        this.dataSize = -1;
        this.audioInfo = null;
        this.tracks = [];
        this.metadataReader = new (0, $dd38a4069eb9455d$export$55f75071f06461bb)(input._mainReader);
        this.chunkReader = new (0, $dd38a4069eb9455d$export$55f75071f06461bb)(new (0, $91e0146795b1dff0$export$2f7a2f0e90c07dc4)(input.source, 64 * 2 ** 20));
    }
    async readMetadata() {
        return this.metadataPromise ??= (async ()=>{
            const actualFileSize = await this.metadataReader.reader.source.getSize();
            const riffType = this.metadataReader.readAscii(4);
            this.metadataReader.littleEndian = riffType !== 'RIFX';
            const isRf64 = riffType === 'RF64';
            const outerChunkSize = this.metadataReader.readU32();
            let totalFileSize = isRf64 ? actualFileSize : Math.min(outerChunkSize + 8, actualFileSize);
            const format = this.metadataReader.readAscii(4);
            if (format !== 'WAVE') throw new Error('Invalid WAVE file - wrong format');
            this.metadataReader.pos = 12;
            let chunksRead = 0;
            let dataChunkSize = null;
            while(this.metadataReader.pos < totalFileSize){
                await this.metadataReader.reader.loadRange(this.metadataReader.pos, this.metadataReader.pos + 8);
                const chunkId = this.metadataReader.readAscii(4);
                const chunkSize = this.metadataReader.readU32();
                const startPos = this.metadataReader.pos;
                if (isRf64 && chunksRead === 0 && chunkId !== 'ds64') throw new Error('Invalid RF64 file: First chunk must be "ds64".');
                if (chunkId === 'fmt ') await this.parseFmtChunk(chunkSize);
                else if (chunkId === 'data') {
                    dataChunkSize ??= chunkSize;
                    this.dataStart = this.metadataReader.pos;
                    this.dataSize = Math.min(dataChunkSize, totalFileSize - this.dataStart);
                } else if (chunkId === 'ds64') {
                    // File and data chunk sizes are defined in here instead
                    const riffChunkSize = this.metadataReader.readU64();
                    dataChunkSize = this.metadataReader.readU64();
                    totalFileSize = Math.min(riffChunkSize + 8, actualFileSize);
                }
                this.metadataReader.pos = startPos + chunkSize + (chunkSize & 1); // Handle padding
                chunksRead++;
            }
            if (!this.audioInfo) throw new Error('Invalid WAVE file - missing "fmt " chunk');
            if (this.dataStart === -1) throw new Error('Invalid WAVE file - missing "data" chunk');
            const blockSize = this.audioInfo.blockSizeInBytes;
            this.dataSize = Math.floor(this.dataSize / blockSize) * blockSize;
            this.tracks.push(new (0, $ae1d233ed6bad288$export$886fbe0dd65c2e67)(new $40ebdb00788778b0$var$WaveAudioTrackBacking(this)));
        })();
    }
    async parseFmtChunk(size) {
        await this.metadataReader.reader.loadRange(this.metadataReader.pos, this.metadataReader.pos + size);
        let formatTag = this.metadataReader.readU16();
        const numChannels = this.metadataReader.readU16();
        const sampleRate = this.metadataReader.readU32();
        this.metadataReader.pos += 4; // Bytes per second
        const blockAlign = this.metadataReader.readU16();
        let bitsPerSample;
        if (size === 14) bitsPerSample = 8;
        else bitsPerSample = this.metadataReader.readU16();
        // Handle WAVEFORMATEXTENSIBLE
        if (size >= 18 && formatTag !== 0x0165) {
            const cbSize = this.metadataReader.readU16();
            const remainingSize = size - 18;
            const extensionSize = Math.min(remainingSize, cbSize);
            if (extensionSize >= 22 && formatTag === $40ebdb00788778b0$export$55472bccb6ce403f.EXTENSIBLE) {
                // Parse WAVEFORMATEXTENSIBLE
                this.metadataReader.pos += 6;
                const subFormat = this.metadataReader.readBytes(16);
                // Get actual format from subFormat GUID
                formatTag = subFormat[0] | subFormat[1] << 8;
            }
        }
        if (formatTag === $40ebdb00788778b0$export$55472bccb6ce403f.MULAW || formatTag === $40ebdb00788778b0$export$55472bccb6ce403f.ALAW) bitsPerSample = 8;
        this.audioInfo = {
            format: formatTag,
            numberOfChannels: numChannels,
            sampleRate: sampleRate,
            sampleSizeInBytes: Math.ceil(bitsPerSample / 8),
            blockSizeInBytes: blockAlign
        };
    }
    getCodec() {
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.audioInfo);
        if (this.audioInfo.format === $40ebdb00788778b0$export$55472bccb6ce403f.MULAW) return 'ulaw';
        if (this.audioInfo.format === $40ebdb00788778b0$export$55472bccb6ce403f.ALAW) return 'alaw';
        if (this.audioInfo.format === $40ebdb00788778b0$export$55472bccb6ce403f.PCM) {
            // All formats are little-endian
            if (this.audioInfo.sampleSizeInBytes === 1) return 'pcm-u8';
            else if (this.audioInfo.sampleSizeInBytes === 2) return 'pcm-s16';
            else if (this.audioInfo.sampleSizeInBytes === 3) return 'pcm-s24';
            else if (this.audioInfo.sampleSizeInBytes === 4) return 'pcm-s32';
        }
        if (this.audioInfo.format === $40ebdb00788778b0$export$55472bccb6ce403f.IEEE_FLOAT) {
            if (this.audioInfo.sampleSizeInBytes === 4) return 'pcm-f32';
        }
        return null;
    }
    async getMimeType() {
        return 'audio/wav';
    }
    async computeDuration() {
        await this.readMetadata();
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.audioInfo);
        const numberOfBlocks = this.dataSize / this.audioInfo.blockSizeInBytes;
        return numberOfBlocks / this.audioInfo.sampleRate;
    }
    async getTracks() {
        await this.readMetadata();
        return this.tracks;
    }
}
const $40ebdb00788778b0$var$PACKET_SIZE_IN_FRAMES = 2048;
class $40ebdb00788778b0$var$WaveAudioTrackBacking {
    constructor(demuxer){
        this.demuxer = demuxer;
    }
    getId() {
        return 1;
    }
    getCodec() {
        return this.demuxer.getCodec();
    }
    async getDecoderConfig() {
        const codec = this.demuxer.getCodec();
        if (!codec) return null;
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.demuxer.audioInfo);
        return {
            codec: codec,
            numberOfChannels: this.demuxer.audioInfo.numberOfChannels,
            sampleRate: this.demuxer.audioInfo.sampleRate
        };
    }
    computeDuration() {
        return this.demuxer.computeDuration();
    }
    getNumberOfChannels() {
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.demuxer.audioInfo);
        return this.demuxer.audioInfo.numberOfChannels;
    }
    getSampleRate() {
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.demuxer.audioInfo);
        return this.demuxer.audioInfo.sampleRate;
    }
    getTimeResolution() {
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.demuxer.audioInfo);
        return this.demuxer.audioInfo.sampleRate;
    }
    getLanguageCode() {
        return 0, $053d5bbcf6664967$export$af15dfb067c7ab59;
    }
    async getFirstTimestamp() {
        return 0;
    }
    async getPacketAtIndex(packetIndex, options) {
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.demuxer.audioInfo);
        const startOffset = packetIndex * $40ebdb00788778b0$var$PACKET_SIZE_IN_FRAMES * this.demuxer.audioInfo.blockSizeInBytes;
        if (startOffset >= this.demuxer.dataSize) return null;
        const sizeInBytes = Math.min($40ebdb00788778b0$var$PACKET_SIZE_IN_FRAMES * this.demuxer.audioInfo.blockSizeInBytes, this.demuxer.dataSize - startOffset);
        let data;
        if (options.metadataOnly) data = (0, $8ce8f170cc716e8f$export$d83e8557fbdb95af);
        else {
            const sizeOfOnePacket = $40ebdb00788778b0$var$PACKET_SIZE_IN_FRAMES * this.demuxer.audioInfo.blockSizeInBytes;
            const chunkSize = Math.ceil(2 ** 19 / sizeOfOnePacket) * sizeOfOnePacket;
            const chunkStart = Math.floor(startOffset / chunkSize) * chunkSize;
            const chunkEnd = chunkStart + chunkSize;
            // Always load large 0.5 MiB chunks instead of just the required packet
            await this.demuxer.chunkReader.reader.loadRange(this.demuxer.dataStart + chunkStart, this.demuxer.dataStart + chunkEnd);
            this.demuxer.chunkReader.pos = this.demuxer.dataStart + startOffset;
            data = this.demuxer.chunkReader.readBytes(sizeInBytes);
        }
        const timestamp = packetIndex * $40ebdb00788778b0$var$PACKET_SIZE_IN_FRAMES / this.demuxer.audioInfo.sampleRate;
        const duration = sizeInBytes / this.demuxer.audioInfo.blockSizeInBytes / this.demuxer.audioInfo.sampleRate;
        return new (0, $8ce8f170cc716e8f$export$2bb25546e7fe690b)(data, 'key', timestamp, duration, packetIndex, sizeInBytes);
    }
    getFirstPacket(options) {
        return this.getPacketAtIndex(0, options);
    }
    getPacket(timestamp, options) {
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.demuxer.audioInfo);
        const packetIndex = Math.floor(timestamp * this.demuxer.audioInfo.sampleRate / $40ebdb00788778b0$var$PACKET_SIZE_IN_FRAMES);
        return this.getPacketAtIndex(packetIndex, options);
    }
    getNextPacket(packet, options) {
        (0, $053d5bbcf6664967$export$a7a9523472993e97)(this.demuxer.audioInfo);
        const packetIndex = Math.round(packet.timestamp * this.demuxer.audioInfo.sampleRate / $40ebdb00788778b0$var$PACKET_SIZE_IN_FRAMES);
        return this.getPacketAtIndex(packetIndex + 1, options);
    }
    getKeyPacket(timestamp, options) {
        return this.getPacket(timestamp, options);
    }
    getNextKeyPacket(packet, options) {
        return this.getNextPacket(packet, options);
    }
}


/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ class $e6caeef1d49f4c04$export$493c06559ceb3f8e {
    constructor(writer){
        this.writer = writer;
        this.helper = new Uint8Array(8);
        this.helperView = new DataView(this.helper.buffer);
    }
    writeU16(value) {
        this.helperView.setUint16(0, value, true);
        this.writer.write(this.helper.subarray(0, 2));
    }
    writeU32(value) {
        this.helperView.setUint32(0, value, true);
        this.writer.write(this.helper.subarray(0, 4));
    }
    writeU64(value) {
        this.helperView.setUint32(0, value, true);
        this.helperView.setUint32(4, Math.floor(value / 2 ** 32), true);
        this.writer.write(this.helper);
    }
    writeAscii(text) {
        this.writer.write(new TextEncoder().encode(text));
    }
}



class $7db04271bdb40fe4$export$93f4e13ff5550bb3 extends (0, $40161f4e778629b3$export$d78afe5e2e889016) {
    constructor(output, format){
        super(output);
        this.headerWritten = false;
        this.dataSize = 0;
        this.sampleRate = null;
        this.sampleCount = 0;
        this.format = format;
        this.writer = output._writer;
        this.riffWriter = new (0, $e6caeef1d49f4c04$export$493c06559ceb3f8e)(output._writer);
        this.isRf64 = !!format._options.large;
    }
    async start() {
    // Nothing needed here - we'll write the header with the first sample
    }
    async getMimeType() {
        return 'audio/wav';
    }
    async addEncodedVideoPacket() {
        throw new Error('WAVE does not support video.');
    }
    async addEncodedAudioPacket(track, packet, meta) {
        const release = await this.mutex.acquire();
        try {
            if (!this.headerWritten) {
                (0, $94511f4b46249ea3$export$61959146e5b74178)(meta);
                (0, $053d5bbcf6664967$export$a7a9523472993e97)(meta);
                (0, $053d5bbcf6664967$export$a7a9523472993e97)(meta.decoderConfig);
                this.writeHeader(track, meta.decoderConfig);
                this.sampleRate = meta.decoderConfig.sampleRate;
                this.headerWritten = true;
            }
            this.validateAndNormalizeTimestamp(track, packet.timestamp, packet.type === 'key');
            if (!this.isRf64 && this.writer.getPos() + packet.data.byteLength >= 2 ** 32) throw new Error("Adding more audio data would exceed the maximum RIFF size of 4 GiB. To write larger files, use RF64 by setting `large: true` in the WavOutputFormatOptions.");
            this.writer.write(packet.data);
            this.dataSize += packet.data.byteLength;
            this.sampleCount += Math.round(packet.duration * this.sampleRate);
            await this.writer.flush();
        } finally{
            release();
        }
    }
    async addSubtitleCue() {
        throw new Error('WAVE does not support subtitles.');
    }
    writeHeader(track, config) {
        if (this.format._options.onHeader) this.writer.startTrackingWrites();
        let format;
        const codec = track.source._codec;
        const pcmInfo = (0, $94511f4b46249ea3$export$560120a2d4e71dc2)(codec);
        if (pcmInfo.dataType === 'ulaw') format = (0, $40ebdb00788778b0$export$55472bccb6ce403f).MULAW;
        else if (pcmInfo.dataType === 'alaw') format = (0, $40ebdb00788778b0$export$55472bccb6ce403f).ALAW;
        else if (pcmInfo.dataType === 'float') format = (0, $40ebdb00788778b0$export$55472bccb6ce403f).IEEE_FLOAT;
        else format = (0, $40ebdb00788778b0$export$55472bccb6ce403f).PCM;
        const channels = config.numberOfChannels;
        const sampleRate = config.sampleRate;
        const blockSize = pcmInfo.sampleSize * channels;
        // RIFF header
        this.riffWriter.writeAscii(this.isRf64 ? 'RF64' : 'RIFF');
        if (this.isRf64) this.riffWriter.writeU32(0xffffffff); // Not used in RF64
        else this.riffWriter.writeU32(0); // File size placeholder
        this.riffWriter.writeAscii('WAVE');
        if (this.isRf64) {
            this.riffWriter.writeAscii('ds64');
            this.riffWriter.writeU32(28); // Chunk size
            this.riffWriter.writeU64(0); // RIFF size placeholder
            this.riffWriter.writeU64(0); // Data size placeholder
            this.riffWriter.writeU64(0); // Sample count placeholder
            this.riffWriter.writeU32(0); // Table length
        // Empty table
        }
        // fmt chunk
        this.riffWriter.writeAscii('fmt ');
        this.riffWriter.writeU32(16); // Chunk size
        this.riffWriter.writeU16(format);
        this.riffWriter.writeU16(channels);
        this.riffWriter.writeU32(sampleRate);
        this.riffWriter.writeU32(sampleRate * blockSize); // Bytes per second
        this.riffWriter.writeU16(blockSize);
        this.riffWriter.writeU16(8 * pcmInfo.sampleSize);
        // data chunk
        this.riffWriter.writeAscii('data');
        if (this.isRf64) this.riffWriter.writeU32(0xffffffff); // Not used in RF64
        else this.riffWriter.writeU32(0); // Data size placeholder
        if (this.format._options.onHeader) {
            const { data: data, start: start } = this.writer.stopTrackingWrites();
            this.format._options.onHeader(data, start);
        }
    }
    async finalize() {
        const release = await this.mutex.acquire();
        const endPos = this.writer.getPos();
        if (this.isRf64) {
            // Write riff size
            this.writer.seek(20);
            this.riffWriter.writeU64(endPos - 8);
            // Write data size
            this.writer.seek(28);
            this.riffWriter.writeU64(this.dataSize);
            // Write sample count
            this.writer.seek(36);
            this.riffWriter.writeU64(this.sampleCount);
        } else {
            // Write file size
            this.writer.seek(4);
            this.riffWriter.writeU32(endPos - 8);
            // Write data chunk size
            this.writer.seek(40);
            this.riffWriter.writeU32(this.dataSize);
        }
        this.writer.seek(endPos);
        release();
    }
}


class $89c2d87f884ee1df$export$ed6df354c75a09e0 {
    /** Returns a list of video codecs that this output format can contain. */ getSupportedVideoCodecs() {
        return this.getSupportedCodecs().filter((codec)=>(0, $94511f4b46249ea3$export$e32a4ecbb4372159).includes(codec));
    }
    /** Returns a list of audio codecs that this output format can contain. */ getSupportedAudioCodecs() {
        return this.getSupportedCodecs().filter((codec)=>(0, $94511f4b46249ea3$export$b1442c71888819f2).includes(codec));
    }
    /** Returns a list of subtitle codecs that this output format can contain. */ getSupportedSubtitleCodecs() {
        return this.getSupportedCodecs().filter((codec)=>(0, $94511f4b46249ea3$export$422db9d40fc02e83).includes(codec));
    }
    /** @internal */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _codecUnsupportedHint(codec) {
        return '';
    }
}
class $89c2d87f884ee1df$export$4c8b932577fe73ff extends $89c2d87f884ee1df$export$ed6df354c75a09e0 {
    constructor(options = {}){
        if (!options || typeof options !== 'object') throw new TypeError('options must be an object.');
        if (options.fastStart !== undefined && ![
            false,
            'in-memory',
            'fragmented'
        ].includes(options.fastStart)) throw new TypeError('options.fastStart, when provided, must be false, "in-memory", or "fragmented".');
        if (options.minimumFragmentDuration !== undefined && (!Number.isFinite(options.minimumFragmentDuration) || options.minimumFragmentDuration < 0)) throw new TypeError('options.minimumFragmentDuration, when provided, must be a non-negative number.');
        if (options.onFtyp !== undefined && typeof options.onFtyp !== 'function') throw new TypeError('options.onFtyp, when provided, must be a function.');
        if (options.onMoov !== undefined && typeof options.onMoov !== 'function') throw new TypeError('options.onMoov, when provided, must be a function.');
        if (options.onMdat !== undefined && typeof options.onMdat !== 'function') throw new TypeError('options.onMdat, when provided, must be a function.');
        if (options.onMoof !== undefined && typeof options.onMoof !== 'function') throw new TypeError('options.onMoof, when provided, must be a function.');
        super();
        this._options = options;
    }
    getSupportedTrackCounts() {
        return {
            video: {
                min: 0,
                max: Infinity
            },
            audio: {
                min: 0,
                max: Infinity
            },
            subtitle: {
                min: 0,
                max: Infinity
            },
            total: {
                min: 1,
                max: 2 ** 32 - 1
            }
        };
    }
    get supportsVideoRotationMetadata() {
        return true;
    }
    /** @internal */ _createMuxer(output) {
        return new (0, $d3ff0c06a870f18b$export$37d0e98dcab80fd3)(output, this);
    }
}
class $89c2d87f884ee1df$export$bbb82bb82ef04040 extends $89c2d87f884ee1df$export$4c8b932577fe73ff {
    /** @internal */ get _name() {
        return 'MP4';
    }
    get fileExtension() {
        return '.mp4';
    }
    get mimeType() {
        return 'video/mp4';
    }
    getSupportedCodecs() {
        return [
            ...(0, $94511f4b46249ea3$export$e32a4ecbb4372159),
            ...(0, $94511f4b46249ea3$export$539a2909ad652ac),
            // These are supported via ISO/IEC 23003-5
            'pcm-s16',
            'pcm-s16be',
            'pcm-s24',
            'pcm-s24be',
            'pcm-s32',
            'pcm-s32be',
            'pcm-f32',
            'pcm-f32be',
            'pcm-f64',
            'pcm-f64be',
            ...(0, $94511f4b46249ea3$export$422db9d40fc02e83)
        ];
    }
    /** @internal */ _codecUnsupportedHint(codec) {
        if (new $89c2d87f884ee1df$export$b2d97c88a119c488().getSupportedCodecs().includes(codec)) return ' Switching to MOV will grant support for this codec.';
        return '';
    }
}
class $89c2d87f884ee1df$export$b2d97c88a119c488 extends $89c2d87f884ee1df$export$4c8b932577fe73ff {
    /** @internal */ get _name() {
        return 'MOV';
    }
    get fileExtension() {
        return '.mov';
    }
    get mimeType() {
        return 'video/quicktime';
    }
    getSupportedCodecs() {
        return [
            ...(0, $94511f4b46249ea3$export$e32a4ecbb4372159),
            ...(0, $94511f4b46249ea3$export$b1442c71888819f2)
        ];
    }
    /** @internal */ _codecUnsupportedHint(codec) {
        if (new $89c2d87f884ee1df$export$bbb82bb82ef04040().getSupportedCodecs().includes(codec)) return ' Switching to MP4 will grant support for this codec.';
        return '';
    }
}
class $89c2d87f884ee1df$export$186a65ff2755b033 extends $89c2d87f884ee1df$export$ed6df354c75a09e0 {
    constructor(options = {}){
        if (!options || typeof options !== 'object') throw new TypeError('options must be an object.');
        if (options.appendOnly !== undefined && typeof options.appendOnly !== 'boolean') throw new TypeError('options.appendOnly, when provided, must be a boolean.');
        if (options.minimumClusterDuration !== undefined && (!Number.isFinite(options.minimumClusterDuration) || options.minimumClusterDuration < 0)) throw new TypeError('options.minimumClusterDuration, when provided, must be a non-negative number.');
        if (options.onEbmlHeader !== undefined && typeof options.onEbmlHeader !== 'function') throw new TypeError('options.onEbmlHeader, when provided, must be a function.');
        if (options.onSegmentHeader !== undefined && typeof options.onSegmentHeader !== 'function') throw new TypeError('options.onHeader, when provided, must be a function.');
        if (options.onCluster !== undefined && typeof options.onCluster !== 'function') throw new TypeError('options.onCluster, when provided, must be a function.');
        super();
        this._options = options;
    }
    /** @internal */ _createMuxer(output) {
        return new (0, $acf6fc97ef2526f7$export$8290c5c130ddf16b)(output, this);
    }
    /** @internal */ get _name() {
        return 'Matroska';
    }
    getSupportedTrackCounts() {
        return {
            video: {
                min: 0,
                max: Infinity
            },
            audio: {
                min: 0,
                max: Infinity
            },
            subtitle: {
                min: 0,
                max: Infinity
            },
            total: {
                min: 1,
                max: 127
            }
        };
    }
    get fileExtension() {
        return '.mkv';
    }
    get mimeType() {
        return 'video/x-matroska';
    }
    getSupportedCodecs() {
        return [
            ...(0, $94511f4b46249ea3$export$e32a4ecbb4372159),
            ...(0, $94511f4b46249ea3$export$539a2909ad652ac),
            ...(0, $94511f4b46249ea3$export$58c594b1fe7e587b).filter((codec)=>![
                    'pcm-s8',
                    'pcm-f32be',
                    'pcm-f64be',
                    'ulaw',
                    'alaw'
                ].includes(codec)),
            ...(0, $94511f4b46249ea3$export$422db9d40fc02e83)
        ];
    }
    get supportsVideoRotationMetadata() {
        // While it technically does support it with ProjectionPoseRoll, many players appear to ignore this value
        return false;
    }
}
class $89c2d87f884ee1df$export$8313ce77aed075b8 extends $89c2d87f884ee1df$export$186a65ff2755b033 {
    getSupportedCodecs() {
        return [
            ...(0, $94511f4b46249ea3$export$e32a4ecbb4372159).filter((codec)=>[
                    'vp8',
                    'vp9',
                    'av1'
                ].includes(codec)),
            ...(0, $94511f4b46249ea3$export$b1442c71888819f2).filter((codec)=>[
                    'opus',
                    'vorbis'
                ].includes(codec)),
            ...(0, $94511f4b46249ea3$export$422db9d40fc02e83)
        ];
    }
    /** @internal */ get _name() {
        return 'WebM';
    }
    get fileExtension() {
        return '.webm';
    }
    get mimeType() {
        return 'video/webm';
    }
    /** @internal */ _codecUnsupportedHint(codec) {
        if (new $89c2d87f884ee1df$export$186a65ff2755b033().getSupportedCodecs().includes(codec)) return ' Switching to MKV will grant support for this codec.';
        return '';
    }
}
class $89c2d87f884ee1df$export$d147245419e653bc extends $89c2d87f884ee1df$export$ed6df354c75a09e0 {
    constructor(options = {}){
        if (!options || typeof options !== 'object') throw new TypeError('options must be an object.');
        if (options.onXingFrame !== undefined && typeof options.onXingFrame !== 'function') throw new TypeError('options.onXingFrame, when provided, must be a function.');
        super();
        this._options = options;
    }
    /** @internal */ _createMuxer(output) {
        return new (0, $a454f14d93156724$export$dd0cbd2d176c22ee)(output, this);
    }
    /** @internal */ get _name() {
        return 'MP3';
    }
    getSupportedTrackCounts() {
        return {
            video: {
                min: 0,
                max: 0
            },
            audio: {
                min: 1,
                max: 1
            },
            subtitle: {
                min: 0,
                max: 0
            },
            total: {
                min: 1,
                max: 1
            }
        };
    }
    get fileExtension() {
        return '.mp3';
    }
    get mimeType() {
        return 'audio/mpeg';
    }
    getSupportedCodecs() {
        return [
            'mp3'
        ];
    }
    get supportsVideoRotationMetadata() {
        return false;
    }
}
class $89c2d87f884ee1df$export$f3ebbfb4511504b7 extends $89c2d87f884ee1df$export$ed6df354c75a09e0 {
    constructor(options = {}){
        if (!options || typeof options !== 'object') throw new TypeError('options must be an object.');
        if (options.large !== undefined && typeof options.large !== 'boolean') throw new TypeError('options.large, when provided, must be a boolean.');
        if (options.onHeader !== undefined && typeof options.onHeader !== 'function') throw new TypeError('options.onHeader, when provided, must be a function.');
        super();
        this._options = options;
    }
    /** @internal */ _createMuxer(output) {
        return new (0, $7db04271bdb40fe4$export$93f4e13ff5550bb3)(output, this);
    }
    /** @internal */ get _name() {
        return 'WAVE';
    }
    getSupportedTrackCounts() {
        return {
            video: {
                min: 0,
                max: 0
            },
            audio: {
                min: 1,
                max: 1
            },
            subtitle: {
                min: 0,
                max: 0
            },
            total: {
                min: 1,
                max: 1
            }
        };
    }
    get fileExtension() {
        return '.wav';
    }
    get mimeType() {
        return 'audio/wav';
    }
    getSupportedCodecs() {
        return [
            ...(0, $94511f4b46249ea3$export$58c594b1fe7e587b).filter((codec)=>[
                    'pcm-s16',
                    'pcm-s24',
                    'pcm-s32',
                    'pcm-f32',
                    'pcm-u8',
                    'ulaw',
                    'alaw'
                ].includes(codec))
        ];
    }
    get supportsVideoRotationMetadata() {
        return false;
    }
}
class $89c2d87f884ee1df$export$84c6a286401b1bc3 extends $89c2d87f884ee1df$export$ed6df354c75a09e0 {
    constructor(options = {}){
        if (!options || typeof options !== 'object') throw new TypeError('options must be an object.');
        if (options.onPage !== undefined && typeof options.onPage !== 'function') throw new TypeError('options.onPage, when provided, must be a function.');
        super();
        this._options = options;
    }
    /** @internal */ _createMuxer(output) {
        return new (0, $21b14c194a3b2a05$export$2a4eb5bbb730b944)(output, this);
    }
    /** @internal */ get _name() {
        return 'Ogg';
    }
    getSupportedTrackCounts() {
        return {
            video: {
                min: 0,
                max: 0
            },
            audio: {
                min: 0,
                max: Infinity
            },
            subtitle: {
                min: 0,
                max: 0
            },
            total: {
                min: 1,
                max: 2 ** 32
            }
        };
    }
    get fileExtension() {
        return '.ogg';
    }
    get mimeType() {
        return 'application/ogg';
    }
    getSupportedCodecs() {
        return [
            ...(0, $94511f4b46249ea3$export$b1442c71888819f2).filter((codec)=>[
                    'vorbis',
                    'opus'
                ].includes(codec))
        ];
    }
    get supportsVideoRotationMetadata() {
        return false;
    }
}

/*!
 * Copyright (c) 2025-present, Vanilagy and contributors
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */ 



const $39fc6ebcf9970a59$export$ecb4a7a04a3ad19f = [
    'video',
    'audio',
    'subtitle'
];
const $39fc6ebcf9970a59$var$validateBaseTrackMetadata = (metadata)=>{
    if (!metadata || typeof metadata !== 'object') throw new TypeError('metadata must be an object.');
    if (metadata.languageCode !== undefined && !(0, $053d5bbcf6664967$export$c53f86278a6c5ab7)(metadata.languageCode)) throw new TypeError('metadata.languageCode must be a three-letter, ISO 639-2/T language code.');
};
class $39fc6ebcf9970a59$export$670ff8da74c69da1 {
    constructor(options){
        /** The current state of the output. */ this.state = 'pending';
        /** @internal */ this._tracks = [];
        /** @internal */ this._startPromise = null;
        /** @internal */ this._cancelPromise = null;
        /** @internal */ this._finalizePromise = null;
        /** @internal */ this._mutex = new (0, $053d5bbcf6664967$export$7ea9f882800689bb)();
        if (!options || typeof options !== 'object') throw new TypeError('options must be an object.');
        if (!(options.format instanceof (0, $89c2d87f884ee1df$export$ed6df354c75a09e0))) throw new TypeError('options.format must be an OutputFormat.');
        if (!(options.target instanceof (0, $0170695b8ac54025$export$a51f2b8e6ae258ea))) throw new TypeError('options.target must be a Target.');
        if (options.target._output) throw new Error('Target is already used for another output.');
        options.target._output = this;
        this.format = options.format;
        this.target = options.target;
        this._writer = options.target._createWriter();
        this._muxer = options.format._createMuxer(this);
    }
    /** Adds a video track to the output with the given source. Must be called before output is started. */ addVideoTrack(source, metadata = {}) {
        if (!(source instanceof (0, $1c9745b17d341e9e$export$f3a17123d80000c5))) throw new TypeError('source must be a VideoSource.');
        $39fc6ebcf9970a59$var$validateBaseTrackMetadata(metadata);
        if (metadata.rotation !== undefined && ![
            0,
            90,
            180,
            270
        ].includes(metadata.rotation)) throw new TypeError(`Invalid video rotation: ${metadata.rotation}. Has to be 0, 90, 180 or 270.`);
        if (!this.format.supportsVideoRotationMetadata && metadata.rotation) throw new Error(`${this.format._name} does not support video rotation metadata.`);
        if (metadata.frameRate !== undefined && (!Number.isFinite(metadata.frameRate) || metadata.frameRate <= 0)) throw new TypeError(`Invalid video frame rate: ${metadata.frameRate}. Must be a positive number.`);
        this._addTrack('video', source, metadata);
    }
    /** Adds an audio track to the output with the given source. Must be called before output is started. */ addAudioTrack(source, metadata = {}) {
        if (!(source instanceof (0, $1c9745b17d341e9e$export$2e14a66180fa4af9))) throw new TypeError('source must be an AudioSource.');
        $39fc6ebcf9970a59$var$validateBaseTrackMetadata(metadata);
        this._addTrack('audio', source, metadata);
    }
    /** Adds a subtitle track to the output with the given source. Must be called before output is started. */ addSubtitleTrack(source, metadata = {}) {
        if (!(source instanceof (0, $1c9745b17d341e9e$export$472e8680c39d652a))) throw new TypeError('source must be a SubtitleSource.');
        $39fc6ebcf9970a59$var$validateBaseTrackMetadata(metadata);
        this._addTrack('subtitle', source, metadata);
    }
    /** @internal */ _addTrack(type, source, metadata) {
        if (this.state !== 'pending') throw new Error('Cannot add track after output has been started or canceled.');
        if (source._connectedTrack) throw new Error('Source is already used for a track.');
        // Verify maximum track count constraints
        const supportedTrackCounts = this.format.getSupportedTrackCounts();
        const presentTracksOfThisType = this._tracks.reduce((count, track)=>count + (track.type === type ? 1 : 0), 0);
        const maxCount = supportedTrackCounts[type].max;
        if (presentTracksOfThisType === maxCount) throw new Error(maxCount === 0 ? `${this.format._name} does not support ${type} tracks.` : `${this.format._name} does not support more than ${maxCount} ${type} track` + `${maxCount === 1 ? '' : 's'}.`);
        const maxTotalCount = supportedTrackCounts.total.max;
        if (this._tracks.length === maxTotalCount) throw new Error(`${this.format._name} does not support more than ${maxTotalCount} tracks` + `${maxTotalCount === 1 ? '' : 's'} in total.`);
        const track = {
            id: this._tracks.length + 1,
            output: this,
            type: type,
            source: source,
            metadata: metadata
        };
        if (track.type === 'video') {
            const supportedVideoCodecs = this.format.getSupportedVideoCodecs();
            if (supportedVideoCodecs.length === 0) throw new Error(`${this.format._name} does not support video tracks.` + this.format._codecUnsupportedHint(track.source._codec));
            else if (!supportedVideoCodecs.includes(track.source._codec)) throw new Error(`Codec '${track.source._codec}' cannot be contained within ${this.format._name}. Supported` + ` video codecs are: ${supportedVideoCodecs.map((codec)=>`'${codec}'`).join(', ')}.` + this.format._codecUnsupportedHint(track.source._codec));
        } else if (track.type === 'audio') {
            const supportedAudioCodecs = this.format.getSupportedAudioCodecs();
            if (supportedAudioCodecs.length === 0) throw new Error(`${this.format._name} does not support audio tracks.` + this.format._codecUnsupportedHint(track.source._codec));
            else if (!supportedAudioCodecs.includes(track.source._codec)) throw new Error(`Codec '${track.source._codec}' cannot be contained within ${this.format._name}. Supported` + ` audio codecs are: ${supportedAudioCodecs.map((codec)=>`'${codec}'`).join(', ')}.` + this.format._codecUnsupportedHint(track.source._codec));
        } else if (track.type === 'subtitle') {
            const supportedSubtitleCodecs = this.format.getSupportedSubtitleCodecs();
            if (supportedSubtitleCodecs.length === 0) throw new Error(`${this.format._name} does not support subtitle tracks.` + this.format._codecUnsupportedHint(track.source._codec));
            else if (!supportedSubtitleCodecs.includes(track.source._codec)) throw new Error(`Codec '${track.source._codec}' cannot be contained within ${this.format._name}. Supported` + ` subtitle codecs are: ${supportedSubtitleCodecs.map((codec)=>`'${codec}'`).join(', ')}.` + this.format._codecUnsupportedHint(track.source._codec));
        }
        this._tracks.push(track);
        source._connectedTrack = track;
    }
    /**
     * Starts the creation of the output file. This method should be called after all tracks have been added. Only after
     * the output has started can media samples be added to the tracks.
     *
     * @returns A promise that resolves when the output has successfully started and is ready to receive media samples.
     */ async start() {
        // Verify minimum track count constraints
        const supportedTrackCounts = this.format.getSupportedTrackCounts();
        for (const trackType of $39fc6ebcf9970a59$export$ecb4a7a04a3ad19f){
            const presentTracksOfThisType = this._tracks.reduce((count, track)=>count + (track.type === trackType ? 1 : 0), 0);
            const minCount = supportedTrackCounts[trackType].min;
            if (presentTracksOfThisType < minCount) throw new Error(minCount === supportedTrackCounts[trackType].max ? `${this.format._name} requires exactly ${minCount} ${trackType}` + ` track${minCount === 1 ? '' : 's'}.` : `${this.format._name} requires at least ${minCount} ${trackType}` + ` track${minCount === 1 ? '' : 's'}.`);
        }
        const totalMinCount = supportedTrackCounts.total.min;
        if (this._tracks.length < totalMinCount) throw new Error(totalMinCount === supportedTrackCounts.total.max ? `${this.format._name} requires exactly ${totalMinCount} track` + `${totalMinCount === 1 ? '' : 's'}.` : `${this.format._name} requires at least ${totalMinCount} track` + `${totalMinCount === 1 ? '' : 's'}.`);
        if (this.state === 'canceled') throw new Error('Output has been canceled.');
        if (this._startPromise) {
            console.warn('Output has already been started.');
            return this._startPromise;
        }
        return this._startPromise = (async ()=>{
            this.state = 'started';
            this._writer.start();
            const release = await this._mutex.acquire();
            await this._muxer.start();
            for (const track of this._tracks)track.source._start();
            release();
        })();
    }
    /**
     * Resolves with the full MIME type of the output file, including track codecs.
     *
     * The returned promise will resolve only once the precise codec strings of all tracks are known.
     */ getMimeType() {
        return this._muxer.getMimeType();
    }
    /**
     * Cancels the creation of the output file, releasing internal resources like encoders and preventing further
     * samples from being added.
     *
     * @returns A promise that resolves once all internal resources have been released.
     */ async cancel() {
        if (this._cancelPromise) {
            console.warn('Output has already been canceled.');
            return this._cancelPromise;
        } else if (this.state === 'finalizing' || this.state === 'finalized') {
            console.warn('Output has already been finalized.');
            return;
        }
        return this._cancelPromise = (async ()=>{
            this.state = 'canceled';
            const release = await this._mutex.acquire();
            const promises = this._tracks.map((x)=>x.source._flushOrWaitForClose());
            await Promise.all(promises);
            await this._writer.close();
            release();
        })();
    }
    /**
     * Finalizes the output file. This method must be called after all media samples across all tracks have been added.
     * Once the Promise returned by this method completes, the output file is ready.
     */ async finalize() {
        if (this.state === 'pending') throw new Error('Cannot finalize before starting.');
        if (this.state === 'canceled') throw new Error('Cannot finalize after canceling.');
        if (this._finalizePromise) {
            console.warn('Output has already been finalized.');
            return this._finalizePromise;
        }
        return this._finalizePromise = (async ()=>{
            this.state = 'finalizing';
            const release = await this._mutex.acquire();
            const promises = this._tracks.map((x)=>x.source._flushOrWaitForClose());
            await Promise.all(promises);
            await this._muxer.finalize();
            await this._writer.flush();
            await this._writer.finalize();
            this.state = 'finalized';
            release();
        })();
    }
}




var $7DyRn = parcelRequire("7DyRn");
let $3fdac27332d5c6a7$var$recording = false;
let $3fdac27332d5c6a7$var$recordingIntervalId = 0;
let $3fdac27332d5c6a7$var$framesAdded = 0;
const $3fdac27332d5c6a7$var$frameRate = 1 / 30;
/**
 * @type {Output}
 */ let $3fdac27332d5c6a7$var$output = undefined;
async function $3fdac27332d5c6a7$export$ec00e8cdb5f248f4(e) {
    if (!$3fdac27332d5c6a7$var$recording) {
        $3fdac27332d5c6a7$var$recording = true;
        $3fdac27332d5c6a7$var$output = new (0, $39fc6ebcf9970a59$export$670ff8da74c69da1)({
            format: new (0, $89c2d87f884ee1df$export$bbb82bb82ef04040)(),
            target: new (0, $0170695b8ac54025$export$aac535e25712764c)()
        });
        let videoSource = new (0, $1c9745b17d341e9e$export$ca65ccf5708c6a0c)((0, $10c90e54c8ae0167$export$67ea982130081db), {
            codec: "avc",
            bitrate: 500000
        });
        // see: https://developer.mozilla.org/en-US/docs/Web/API/MediaStreamTrackProcessor#browser_compatibility
        if (!navigator.userAgent.toLowerCase().includes("firefox")) {
            let audioSource = new (0, $1c9745b17d341e9e$export$e991747f146543b3)((0, $7DyRn.default).audioMediaStreamDestination.stream.getTracks()[0], {
                codec: "aac",
                bitrate: 96000
            });
            $3fdac27332d5c6a7$var$output.addAudioTrack(audioSource);
        }
        $3fdac27332d5c6a7$var$output.addVideoTrack(videoSource);
        await $3fdac27332d5c6a7$var$output.start();
        $3fdac27332d5c6a7$var$recordingIntervalId = setInterval(()=>{
            let timestamp = $3fdac27332d5c6a7$var$framesAdded / 30;
            // Update video duration in UI
            document.getElementById("record-video-text").innerHTML = `${Math.floor(timestamp / 60).toString().padStart(2, "0")}:${Math.floor(timestamp % 60).toString().padStart(2, "0")}`;
            // Add frame
            videoSource.add(timestamp, $3fdac27332d5c6a7$var$frameRate);
            $3fdac27332d5c6a7$var$framesAdded++;
        }, 1000 / 30);
    } else {
        $3fdac27332d5c6a7$var$recording = false;
        clearInterval($3fdac27332d5c6a7$var$recordingIntervalId);
        document.getElementById("record-video-text").innerHTML = "Saving...";
        await $3fdac27332d5c6a7$var$output.finalize();
        const blob = new Blob([
            $3fdac27332d5c6a7$var$output.target.buffer
        ], {
            type: "video/mp4"
        });
        const url = window.URL.createObjectURL(blob);
        $3fdac27332d5c6a7$var$framesAdded = 0;
        let link = document.createElement("a");
        link.download = "recording.mp4";
        link.href = url;
        link.click();
        document.getElementById("record-video-text").innerHTML = "Record";
        setTimeout(()=>{
            window.URL.revokeObjectURL(url);
        }, 1000);
    }
}



/*
 * Dexie.js - a minimalistic wrapper for IndexedDB
 * ===============================================
 *
 * By David Fahlander, david.fahlander@gmail.com
 *
 * Version 4.0.11, Wed Jan 15 2025
 *
 * https://dexie.org
 *
 * Apache License Version 2.0, January 2004, http://www.apache.org/licenses/
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $f8ed024a6db1f9db$var$extendStatics = function(d, b) {
    $f8ed024a6db1f9db$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f8ed024a6db1f9db$var$extendStatics(d, b);
};
function $f8ed024a6db1f9db$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f8ed024a6db1f9db$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f8ed024a6db1f9db$var$__assign = function() {
    $f8ed024a6db1f9db$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f8ed024a6db1f9db$var$__assign.apply(this, arguments);
};
function $f8ed024a6db1f9db$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var $f8ed024a6db1f9db$var$_global = typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
var $f8ed024a6db1f9db$var$keys = Object.keys;
var $f8ed024a6db1f9db$var$isArray = Array.isArray;
if (typeof Promise !== 'undefined' && !$f8ed024a6db1f9db$var$_global.Promise) $f8ed024a6db1f9db$var$_global.Promise = Promise;
function $f8ed024a6db1f9db$var$extend(obj, extension) {
    if (typeof extension !== 'object') return obj;
    $f8ed024a6db1f9db$var$keys(extension).forEach(function(key) {
        obj[key] = extension[key];
    });
    return obj;
}
var $f8ed024a6db1f9db$var$getProto = Object.getPrototypeOf;
var $f8ed024a6db1f9db$var$_hasOwn = {}.hasOwnProperty;
function $f8ed024a6db1f9db$var$hasOwn(obj, prop) {
    return $f8ed024a6db1f9db$var$_hasOwn.call(obj, prop);
}
function $f8ed024a6db1f9db$var$props(proto, extension) {
    if (typeof extension === 'function') extension = extension($f8ed024a6db1f9db$var$getProto(proto));
    (typeof Reflect === "undefined" ? $f8ed024a6db1f9db$var$keys : Reflect.ownKeys)(extension).forEach(function(key) {
        $f8ed024a6db1f9db$var$setProp(proto, key, extension[key]);
    });
}
var $f8ed024a6db1f9db$var$defineProperty = Object.defineProperty;
function $f8ed024a6db1f9db$var$setProp(obj, prop, functionOrGetSet, options) {
    $f8ed024a6db1f9db$var$defineProperty(obj, prop, $f8ed024a6db1f9db$var$extend(functionOrGetSet && $f8ed024a6db1f9db$var$hasOwn(functionOrGetSet, "get") && typeof functionOrGetSet.get === 'function' ? {
        get: functionOrGetSet.get,
        set: functionOrGetSet.set,
        configurable: true
    } : {
        value: functionOrGetSet,
        configurable: true,
        writable: true
    }, options));
}
function $f8ed024a6db1f9db$var$derive(Child) {
    return {
        from: function(Parent) {
            Child.prototype = Object.create(Parent.prototype);
            $f8ed024a6db1f9db$var$setProp(Child.prototype, "constructor", Child);
            return {
                extend: $f8ed024a6db1f9db$var$props.bind(null, Child.prototype)
            };
        }
    };
}
var $f8ed024a6db1f9db$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
function $f8ed024a6db1f9db$var$getPropertyDescriptor(obj, prop) {
    var pd = $f8ed024a6db1f9db$var$getOwnPropertyDescriptor(obj, prop);
    var proto;
    return pd || (proto = $f8ed024a6db1f9db$var$getProto(obj)) && $f8ed024a6db1f9db$var$getPropertyDescriptor(proto, prop);
}
var $f8ed024a6db1f9db$var$_slice = [].slice;
function $f8ed024a6db1f9db$var$slice(args, start, end) {
    return $f8ed024a6db1f9db$var$_slice.call(args, start, end);
}
function $f8ed024a6db1f9db$var$override(origFunc, overridedFactory) {
    return overridedFactory(origFunc);
}
function $f8ed024a6db1f9db$var$assert(b) {
    if (!b) throw new Error("Assertion Failed");
}
function $f8ed024a6db1f9db$var$asap$1(fn) {
    if ($f8ed024a6db1f9db$var$_global.setImmediate) setImmediate(fn);
    else setTimeout(fn, 0);
}
function $f8ed024a6db1f9db$var$arrayToObject(array, extractor) {
    return array.reduce(function(result, item, i) {
        var nameAndValue = extractor(item, i);
        if (nameAndValue) result[nameAndValue[0]] = nameAndValue[1];
        return result;
    }, {});
}
function $f8ed024a6db1f9db$var$getByKeyPath(obj, keyPath) {
    if (typeof keyPath === 'string' && $f8ed024a6db1f9db$var$hasOwn(obj, keyPath)) return obj[keyPath];
    if (!keyPath) return obj;
    if (typeof keyPath !== 'string') {
        var rv = [];
        for(var i = 0, l = keyPath.length; i < l; ++i){
            var val = $f8ed024a6db1f9db$var$getByKeyPath(obj, keyPath[i]);
            rv.push(val);
        }
        return rv;
    }
    var period = keyPath.indexOf('.');
    if (period !== -1) {
        var innerObj = obj[keyPath.substr(0, period)];
        return innerObj == null ? undefined : $f8ed024a6db1f9db$var$getByKeyPath(innerObj, keyPath.substr(period + 1));
    }
    return undefined;
}
function $f8ed024a6db1f9db$var$setByKeyPath(obj, keyPath, value) {
    if (!obj || keyPath === undefined) return;
    if ('isFrozen' in Object && Object.isFrozen(obj)) return;
    if (typeof keyPath !== 'string' && 'length' in keyPath) {
        $f8ed024a6db1f9db$var$assert(typeof value !== 'string' && 'length' in value);
        for(var i = 0, l = keyPath.length; i < l; ++i)$f8ed024a6db1f9db$var$setByKeyPath(obj, keyPath[i], value[i]);
    } else {
        var period = keyPath.indexOf('.');
        if (period !== -1) {
            var currentKeyPath = keyPath.substr(0, period);
            var remainingKeyPath = keyPath.substr(period + 1);
            if (remainingKeyPath === "") {
                if (value === undefined) {
                    if ($f8ed024a6db1f9db$var$isArray(obj) && !isNaN(parseInt(currentKeyPath))) obj.splice(currentKeyPath, 1);
                    else delete obj[currentKeyPath];
                } else obj[currentKeyPath] = value;
            } else {
                var innerObj = obj[currentKeyPath];
                if (!innerObj || !$f8ed024a6db1f9db$var$hasOwn(obj, currentKeyPath)) innerObj = obj[currentKeyPath] = {};
                $f8ed024a6db1f9db$var$setByKeyPath(innerObj, remainingKeyPath, value);
            }
        } else if (value === undefined) {
            if ($f8ed024a6db1f9db$var$isArray(obj) && !isNaN(parseInt(keyPath))) obj.splice(keyPath, 1);
            else delete obj[keyPath];
        } else obj[keyPath] = value;
    }
}
function $f8ed024a6db1f9db$var$delByKeyPath(obj, keyPath) {
    if (typeof keyPath === 'string') $f8ed024a6db1f9db$var$setByKeyPath(obj, keyPath, undefined);
    else if ('length' in keyPath) [].map.call(keyPath, function(kp) {
        $f8ed024a6db1f9db$var$setByKeyPath(obj, kp, undefined);
    });
}
function $f8ed024a6db1f9db$var$shallowClone(obj) {
    var rv = {};
    for(var m in obj)if ($f8ed024a6db1f9db$var$hasOwn(obj, m)) rv[m] = obj[m];
    return rv;
}
var $f8ed024a6db1f9db$var$concat = [].concat;
function $f8ed024a6db1f9db$var$flatten(a) {
    return $f8ed024a6db1f9db$var$concat.apply([], a);
}
var $f8ed024a6db1f9db$var$intrinsicTypeNames = "BigUint64Array,BigInt64Array,Array,Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,FileSystemDirectoryHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey".split(',').concat($f8ed024a6db1f9db$var$flatten([
    8,
    16,
    32,
    64
].map(function(num) {
    return [
        "Int",
        "Uint",
        "Float"
    ].map(function(t) {
        return t + num + "Array";
    });
}))).filter(function(t) {
    return $f8ed024a6db1f9db$var$_global[t];
});
var $f8ed024a6db1f9db$var$intrinsicTypes = new Set($f8ed024a6db1f9db$var$intrinsicTypeNames.map(function(t) {
    return $f8ed024a6db1f9db$var$_global[t];
}));
function $f8ed024a6db1f9db$var$cloneSimpleObjectTree(o) {
    var rv = {};
    for(var k in o)if ($f8ed024a6db1f9db$var$hasOwn(o, k)) {
        var v = o[k];
        rv[k] = !v || typeof v !== 'object' || $f8ed024a6db1f9db$var$intrinsicTypes.has(v.constructor) ? v : $f8ed024a6db1f9db$var$cloneSimpleObjectTree(v);
    }
    return rv;
}
function $f8ed024a6db1f9db$var$objectIsEmpty(o) {
    for(var k in o)if ($f8ed024a6db1f9db$var$hasOwn(o, k)) return false;
    return true;
}
var $f8ed024a6db1f9db$var$circularRefs = null;
function $f8ed024a6db1f9db$var$deepClone(any) {
    $f8ed024a6db1f9db$var$circularRefs = new WeakMap();
    var rv = $f8ed024a6db1f9db$var$innerDeepClone(any);
    $f8ed024a6db1f9db$var$circularRefs = null;
    return rv;
}
function $f8ed024a6db1f9db$var$innerDeepClone(x) {
    if (!x || typeof x !== 'object') return x;
    var rv = $f8ed024a6db1f9db$var$circularRefs.get(x);
    if (rv) return rv;
    if ($f8ed024a6db1f9db$var$isArray(x)) {
        rv = [];
        $f8ed024a6db1f9db$var$circularRefs.set(x, rv);
        for(var i = 0, l = x.length; i < l; ++i)rv.push($f8ed024a6db1f9db$var$innerDeepClone(x[i]));
    } else if ($f8ed024a6db1f9db$var$intrinsicTypes.has(x.constructor)) rv = x;
    else {
        var proto = $f8ed024a6db1f9db$var$getProto(x);
        rv = proto === Object.prototype ? {} : Object.create(proto);
        $f8ed024a6db1f9db$var$circularRefs.set(x, rv);
        for(var prop in x)if ($f8ed024a6db1f9db$var$hasOwn(x, prop)) rv[prop] = $f8ed024a6db1f9db$var$innerDeepClone(x[prop]);
    }
    return rv;
}
var $f8ed024a6db1f9db$var$toString = {}.toString;
function $f8ed024a6db1f9db$var$toStringTag(o) {
    return $f8ed024a6db1f9db$var$toString.call(o).slice(8, -1);
}
var $f8ed024a6db1f9db$var$iteratorSymbol = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
var $f8ed024a6db1f9db$var$getIteratorOf = typeof $f8ed024a6db1f9db$var$iteratorSymbol === "symbol" ? function(x) {
    var i;
    return x != null && (i = x[$f8ed024a6db1f9db$var$iteratorSymbol]) && i.apply(x);
} : function() {
    return null;
};
function $f8ed024a6db1f9db$var$delArrayItem(a, x) {
    var i = a.indexOf(x);
    if (i >= 0) a.splice(i, 1);
    return i >= 0;
}
var $f8ed024a6db1f9db$var$NO_CHAR_ARRAY = {};
function $f8ed024a6db1f9db$var$getArrayOf(arrayLike) {
    var i, a, x, it;
    if (arguments.length === 1) {
        if ($f8ed024a6db1f9db$var$isArray(arrayLike)) return arrayLike.slice();
        if (this === $f8ed024a6db1f9db$var$NO_CHAR_ARRAY && typeof arrayLike === 'string') return [
            arrayLike
        ];
        if (it = $f8ed024a6db1f9db$var$getIteratorOf(arrayLike)) {
            a = [];
            while(x = it.next(), !x.done)a.push(x.value);
            return a;
        }
        if (arrayLike == null) return [
            arrayLike
        ];
        i = arrayLike.length;
        if (typeof i === 'number') {
            a = new Array(i);
            while(i--)a[i] = arrayLike[i];
            return a;
        }
        return [
            arrayLike
        ];
    }
    i = arguments.length;
    a = new Array(i);
    while(i--)a[i] = arguments[i];
    return a;
}
var $f8ed024a6db1f9db$var$isAsyncFunction = typeof Symbol !== 'undefined' ? function(fn) {
    return fn[Symbol.toStringTag] === 'AsyncFunction';
} : function() {
    return false;
};
var $f8ed024a6db1f9db$var$dexieErrorNames = [
    'Modify',
    'Bulk',
    'OpenFailed',
    'VersionChange',
    'Schema',
    'Upgrade',
    'InvalidTable',
    'MissingAPI',
    'NoSuchDatabase',
    'InvalidArgument',
    'SubTransaction',
    'Unsupported',
    'Internal',
    'DatabaseClosed',
    'PrematureCommit',
    'ForeignAwait'
];
var $f8ed024a6db1f9db$var$idbDomErrorNames = [
    'Unknown',
    'Constraint',
    'Data',
    'TransactionInactive',
    'ReadOnly',
    'Version',
    'NotFound',
    'InvalidState',
    'InvalidAccess',
    'Abort',
    'Timeout',
    'QuotaExceeded',
    'Syntax',
    'DataClone'
];
var $f8ed024a6db1f9db$var$errorList = $f8ed024a6db1f9db$var$dexieErrorNames.concat($f8ed024a6db1f9db$var$idbDomErrorNames);
var $f8ed024a6db1f9db$var$defaultTexts = {
    VersionChanged: "Database version changed by other database connection",
    DatabaseClosed: "Database has been closed",
    Abort: "Transaction aborted",
    TransactionInactive: "Transaction has already completed or failed",
    MissingAPI: "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb"
};
function $f8ed024a6db1f9db$var$DexieError(name, msg) {
    this.name = name;
    this.message = msg;
}
$f8ed024a6db1f9db$var$derive($f8ed024a6db1f9db$var$DexieError).from(Error).extend({
    toString: function() {
        return this.name + ": " + this.message;
    }
});
function $f8ed024a6db1f9db$var$getMultiErrorMessage(msg, failures) {
    return msg + ". Errors: " + Object.keys(failures).map(function(key) {
        return failures[key].toString();
    }).filter(function(v, i, s) {
        return s.indexOf(v) === i;
    }).join('\n');
}
function $f8ed024a6db1f9db$var$ModifyError(msg, failures, successCount, failedKeys) {
    this.failures = failures;
    this.failedKeys = failedKeys;
    this.successCount = successCount;
    this.message = $f8ed024a6db1f9db$var$getMultiErrorMessage(msg, failures);
}
$f8ed024a6db1f9db$var$derive($f8ed024a6db1f9db$var$ModifyError).from($f8ed024a6db1f9db$var$DexieError);
function $f8ed024a6db1f9db$var$BulkError(msg, failures) {
    this.name = "BulkError";
    this.failures = Object.keys(failures).map(function(pos) {
        return failures[pos];
    });
    this.failuresByPos = failures;
    this.message = $f8ed024a6db1f9db$var$getMultiErrorMessage(msg, this.failures);
}
$f8ed024a6db1f9db$var$derive($f8ed024a6db1f9db$var$BulkError).from($f8ed024a6db1f9db$var$DexieError);
var $f8ed024a6db1f9db$var$errnames = $f8ed024a6db1f9db$var$errorList.reduce(function(obj, name) {
    return obj[name] = name + "Error", obj;
}, {});
var $f8ed024a6db1f9db$var$BaseException = $f8ed024a6db1f9db$var$DexieError;
var $f8ed024a6db1f9db$var$exceptions = $f8ed024a6db1f9db$var$errorList.reduce(function(obj, name) {
    var fullName = name + "Error";
    function DexieError(msgOrInner, inner) {
        this.name = fullName;
        if (!msgOrInner) {
            this.message = $f8ed024a6db1f9db$var$defaultTexts[name] || fullName;
            this.inner = null;
        } else if (typeof msgOrInner === 'string') {
            this.message = "".concat(msgOrInner).concat(!inner ? '' : '\n ' + inner);
            this.inner = inner || null;
        } else if (typeof msgOrInner === 'object') {
            this.message = "".concat(msgOrInner.name, " ").concat(msgOrInner.message);
            this.inner = msgOrInner;
        }
    }
    $f8ed024a6db1f9db$var$derive(DexieError).from($f8ed024a6db1f9db$var$BaseException);
    obj[name] = DexieError;
    return obj;
}, {});
$f8ed024a6db1f9db$var$exceptions.Syntax = SyntaxError;
$f8ed024a6db1f9db$var$exceptions.Type = TypeError;
$f8ed024a6db1f9db$var$exceptions.Range = RangeError;
var $f8ed024a6db1f9db$var$exceptionMap = $f8ed024a6db1f9db$var$idbDomErrorNames.reduce(function(obj, name) {
    obj[name + "Error"] = $f8ed024a6db1f9db$var$exceptions[name];
    return obj;
}, {});
function $f8ed024a6db1f9db$var$mapError(domError, message) {
    if (!domError || domError instanceof $f8ed024a6db1f9db$var$DexieError || domError instanceof TypeError || domError instanceof SyntaxError || !domError.name || !$f8ed024a6db1f9db$var$exceptionMap[domError.name]) return domError;
    var rv = new $f8ed024a6db1f9db$var$exceptionMap[domError.name](message || domError.message, domError);
    if ("stack" in domError) $f8ed024a6db1f9db$var$setProp(rv, "stack", {
        get: function() {
            return this.inner.stack;
        }
    });
    return rv;
}
var $f8ed024a6db1f9db$var$fullNameExceptions = $f8ed024a6db1f9db$var$errorList.reduce(function(obj, name) {
    if ([
        "Syntax",
        "Type",
        "Range"
    ].indexOf(name) === -1) obj[name + "Error"] = $f8ed024a6db1f9db$var$exceptions[name];
    return obj;
}, {});
$f8ed024a6db1f9db$var$fullNameExceptions.ModifyError = $f8ed024a6db1f9db$var$ModifyError;
$f8ed024a6db1f9db$var$fullNameExceptions.DexieError = $f8ed024a6db1f9db$var$DexieError;
$f8ed024a6db1f9db$var$fullNameExceptions.BulkError = $f8ed024a6db1f9db$var$BulkError;
function $f8ed024a6db1f9db$var$nop() {}
function $f8ed024a6db1f9db$var$mirror(val) {
    return val;
}
function $f8ed024a6db1f9db$var$pureFunctionChain(f1, f2) {
    if (f1 == null || f1 === $f8ed024a6db1f9db$var$mirror) return f2;
    return function(val) {
        return f2(f1(val));
    };
}
function $f8ed024a6db1f9db$var$callBoth(on1, on2) {
    return function() {
        on1.apply(this, arguments);
        on2.apply(this, arguments);
    };
}
function $f8ed024a6db1f9db$var$hookCreatingChain(f1, f2) {
    if (f1 === $f8ed024a6db1f9db$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res !== undefined) arguments[0] = res;
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $f8ed024a6db1f9db$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $f8ed024a6db1f9db$var$callBoth(onerror, this.onerror) : onerror;
        return res2 !== undefined ? res2 : res;
    };
}
function $f8ed024a6db1f9db$var$hookDeletingChain(f1, f2) {
    if (f1 === $f8ed024a6db1f9db$var$nop) return f2;
    return function() {
        f1.apply(this, arguments);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = this.onerror = null;
        f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $f8ed024a6db1f9db$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $f8ed024a6db1f9db$var$callBoth(onerror, this.onerror) : onerror;
    };
}
function $f8ed024a6db1f9db$var$hookUpdatingChain(f1, f2) {
    if (f1 === $f8ed024a6db1f9db$var$nop) return f2;
    return function(modifications) {
        var res = f1.apply(this, arguments);
        $f8ed024a6db1f9db$var$extend(modifications, res);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $f8ed024a6db1f9db$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $f8ed024a6db1f9db$var$callBoth(onerror, this.onerror) : onerror;
        return res === undefined ? res2 === undefined ? undefined : res2 : $f8ed024a6db1f9db$var$extend(res, res2);
    };
}
function $f8ed024a6db1f9db$var$reverseStoppableEventChain(f1, f2) {
    if (f1 === $f8ed024a6db1f9db$var$nop) return f2;
    return function() {
        if (f2.apply(this, arguments) === false) return false;
        return f1.apply(this, arguments);
    };
}
function $f8ed024a6db1f9db$var$promisableChain(f1, f2) {
    if (f1 === $f8ed024a6db1f9db$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res && typeof res.then === 'function') {
            var thiz = this, i = arguments.length, args = new Array(i);
            while(i--)args[i] = arguments[i];
            return res.then(function() {
                return f2.apply(thiz, args);
            });
        }
        return f2.apply(this, arguments);
    };
}
var $f8ed024a6db1f9db$var$debug = typeof location !== 'undefined' && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
function $f8ed024a6db1f9db$var$setDebug(value, filter) {
    $f8ed024a6db1f9db$var$debug = value;
}
var $f8ed024a6db1f9db$var$INTERNAL = {};
var $f8ed024a6db1f9db$var$ZONE_ECHO_LIMIT = 100, $f8ed024a6db1f9db$var$_a$1 = typeof Promise === 'undefined' ? [] : function() {
    var globalP = Promise.resolve();
    if (typeof crypto === 'undefined' || !crypto.subtle) return [
        globalP,
        $f8ed024a6db1f9db$var$getProto(globalP),
        globalP
    ];
    var nativeP = crypto.subtle.digest("SHA-512", new Uint8Array([
        0
    ]));
    return [
        nativeP,
        $f8ed024a6db1f9db$var$getProto(nativeP),
        globalP
    ];
}(), $f8ed024a6db1f9db$var$resolvedNativePromise = $f8ed024a6db1f9db$var$_a$1[0], $f8ed024a6db1f9db$var$nativePromiseProto = $f8ed024a6db1f9db$var$_a$1[1], $f8ed024a6db1f9db$var$resolvedGlobalPromise = $f8ed024a6db1f9db$var$_a$1[2], $f8ed024a6db1f9db$var$nativePromiseThen = $f8ed024a6db1f9db$var$nativePromiseProto && $f8ed024a6db1f9db$var$nativePromiseProto.then;
var $f8ed024a6db1f9db$var$NativePromise = $f8ed024a6db1f9db$var$resolvedNativePromise && $f8ed024a6db1f9db$var$resolvedNativePromise.constructor;
var $f8ed024a6db1f9db$var$patchGlobalPromise = !!$f8ed024a6db1f9db$var$resolvedGlobalPromise;
function $f8ed024a6db1f9db$var$schedulePhysicalTick() {
    queueMicrotask($f8ed024a6db1f9db$var$physicalTick);
}
var $f8ed024a6db1f9db$var$asap = function(callback, args) {
    $f8ed024a6db1f9db$var$microtickQueue.push([
        callback,
        args
    ]);
    if ($f8ed024a6db1f9db$var$needsNewPhysicalTick) {
        $f8ed024a6db1f9db$var$schedulePhysicalTick();
        $f8ed024a6db1f9db$var$needsNewPhysicalTick = false;
    }
};
var $f8ed024a6db1f9db$var$isOutsideMicroTick = true, $f8ed024a6db1f9db$var$needsNewPhysicalTick = true, $f8ed024a6db1f9db$var$unhandledErrors = [], $f8ed024a6db1f9db$var$rejectingErrors = [], $f8ed024a6db1f9db$var$rejectionMapper = $f8ed024a6db1f9db$var$mirror;
var $f8ed024a6db1f9db$var$globalPSD = {
    id: 'global',
    global: true,
    ref: 0,
    unhandleds: [],
    onunhandled: $f8ed024a6db1f9db$var$nop,
    pgp: false,
    env: {},
    finalize: $f8ed024a6db1f9db$var$nop
};
var $f8ed024a6db1f9db$var$PSD = $f8ed024a6db1f9db$var$globalPSD;
var $f8ed024a6db1f9db$var$microtickQueue = [];
var $f8ed024a6db1f9db$var$numScheduledCalls = 0;
var $f8ed024a6db1f9db$var$tickFinalizers = [];
function $f8ed024a6db1f9db$var$DexiePromise(fn) {
    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
    this._listeners = [];
    this._lib = false;
    var psd = this._PSD = $f8ed024a6db1f9db$var$PSD;
    if (typeof fn !== 'function') {
        if (fn !== $f8ed024a6db1f9db$var$INTERNAL) throw new TypeError('Not a function');
        this._state = arguments[1];
        this._value = arguments[2];
        if (this._state === false) $f8ed024a6db1f9db$var$handleRejection(this, this._value);
        return;
    }
    this._state = null;
    this._value = null;
    ++psd.ref;
    $f8ed024a6db1f9db$var$executePromiseTask(this, fn);
}
var $f8ed024a6db1f9db$var$thenProp = {
    get: function() {
        var psd = $f8ed024a6db1f9db$var$PSD, microTaskId = $f8ed024a6db1f9db$var$totalEchoes;
        function then(onFulfilled, onRejected) {
            var _this = this;
            var possibleAwait = !psd.global && (psd !== $f8ed024a6db1f9db$var$PSD || microTaskId !== $f8ed024a6db1f9db$var$totalEchoes);
            var cleanup = possibleAwait && !$f8ed024a6db1f9db$var$decrementExpectedAwaits();
            var rv = new $f8ed024a6db1f9db$var$DexiePromise(function(resolve, reject) {
                $f8ed024a6db1f9db$var$propagateToListener(_this, new $f8ed024a6db1f9db$var$Listener($f8ed024a6db1f9db$var$nativeAwaitCompatibleWrap(onFulfilled, psd, possibleAwait, cleanup), $f8ed024a6db1f9db$var$nativeAwaitCompatibleWrap(onRejected, psd, possibleAwait, cleanup), resolve, reject, psd));
            });
            if (this._consoleTask) rv._consoleTask = this._consoleTask;
            return rv;
        }
        then.prototype = $f8ed024a6db1f9db$var$INTERNAL;
        return then;
    },
    set: function(value) {
        $f8ed024a6db1f9db$var$setProp(this, 'then', value && value.prototype === $f8ed024a6db1f9db$var$INTERNAL ? $f8ed024a6db1f9db$var$thenProp : {
            get: function() {
                return value;
            },
            set: $f8ed024a6db1f9db$var$thenProp.set
        });
    }
};
$f8ed024a6db1f9db$var$props($f8ed024a6db1f9db$var$DexiePromise.prototype, {
    then: $f8ed024a6db1f9db$var$thenProp,
    _then: function(onFulfilled, onRejected) {
        $f8ed024a6db1f9db$var$propagateToListener(this, new $f8ed024a6db1f9db$var$Listener(null, null, onFulfilled, onRejected, $f8ed024a6db1f9db$var$PSD));
    },
    catch: function(onRejected) {
        if (arguments.length === 1) return this.then(null, onRejected);
        var type = arguments[0], handler = arguments[1];
        return typeof type === 'function' ? this.then(null, function(err) {
            return err instanceof type ? handler(err) : $f8ed024a6db1f9db$var$PromiseReject(err);
        }) : this.then(null, function(err) {
            return err && err.name === type ? handler(err) : $f8ed024a6db1f9db$var$PromiseReject(err);
        });
    },
    finally: function(onFinally) {
        return this.then(function(value) {
            return $f8ed024a6db1f9db$var$DexiePromise.resolve(onFinally()).then(function() {
                return value;
            });
        }, function(err) {
            return $f8ed024a6db1f9db$var$DexiePromise.resolve(onFinally()).then(function() {
                return $f8ed024a6db1f9db$var$PromiseReject(err);
            });
        });
    },
    timeout: function(ms, msg) {
        var _this = this;
        return ms < Infinity ? new $f8ed024a6db1f9db$var$DexiePromise(function(resolve, reject) {
            var handle = setTimeout(function() {
                return reject(new $f8ed024a6db1f9db$var$exceptions.Timeout(msg));
            }, ms);
            _this.then(resolve, reject).finally(clearTimeout.bind(null, handle));
        }) : this;
    }
});
if (typeof Symbol !== 'undefined' && Symbol.toStringTag) $f8ed024a6db1f9db$var$setProp($f8ed024a6db1f9db$var$DexiePromise.prototype, Symbol.toStringTag, 'Dexie.Promise');
$f8ed024a6db1f9db$var$globalPSD.env = $f8ed024a6db1f9db$var$snapShot();
function $f8ed024a6db1f9db$var$Listener(onFulfilled, onRejected, resolve, reject, zone) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.resolve = resolve;
    this.reject = reject;
    this.psd = zone;
}
$f8ed024a6db1f9db$var$props($f8ed024a6db1f9db$var$DexiePromise, {
    all: function() {
        var values = $f8ed024a6db1f9db$var$getArrayOf.apply(null, arguments).map($f8ed024a6db1f9db$var$onPossibleParallellAsync);
        return new $f8ed024a6db1f9db$var$DexiePromise(function(resolve, reject) {
            if (values.length === 0) resolve([]);
            var remaining = values.length;
            values.forEach(function(a, i) {
                return $f8ed024a6db1f9db$var$DexiePromise.resolve(a).then(function(x) {
                    values[i] = x;
                    if (!--remaining) resolve(values);
                }, reject);
            });
        });
    },
    resolve: function(value) {
        if (value instanceof $f8ed024a6db1f9db$var$DexiePromise) return value;
        if (value && typeof value.then === 'function') return new $f8ed024a6db1f9db$var$DexiePromise(function(resolve, reject) {
            value.then(resolve, reject);
        });
        var rv = new $f8ed024a6db1f9db$var$DexiePromise($f8ed024a6db1f9db$var$INTERNAL, true, value);
        return rv;
    },
    reject: $f8ed024a6db1f9db$var$PromiseReject,
    race: function() {
        var values = $f8ed024a6db1f9db$var$getArrayOf.apply(null, arguments).map($f8ed024a6db1f9db$var$onPossibleParallellAsync);
        return new $f8ed024a6db1f9db$var$DexiePromise(function(resolve, reject) {
            values.map(function(value) {
                return $f8ed024a6db1f9db$var$DexiePromise.resolve(value).then(resolve, reject);
            });
        });
    },
    PSD: {
        get: function() {
            return $f8ed024a6db1f9db$var$PSD;
        },
        set: function(value) {
            return $f8ed024a6db1f9db$var$PSD = value;
        }
    },
    totalEchoes: {
        get: function() {
            return $f8ed024a6db1f9db$var$totalEchoes;
        }
    },
    newPSD: $f8ed024a6db1f9db$var$newScope,
    usePSD: $f8ed024a6db1f9db$var$usePSD,
    scheduler: {
        get: function() {
            return $f8ed024a6db1f9db$var$asap;
        },
        set: function(value) {
            $f8ed024a6db1f9db$var$asap = value;
        }
    },
    rejectionMapper: {
        get: function() {
            return $f8ed024a6db1f9db$var$rejectionMapper;
        },
        set: function(value) {
            $f8ed024a6db1f9db$var$rejectionMapper = value;
        }
    },
    follow: function(fn, zoneProps) {
        return new $f8ed024a6db1f9db$var$DexiePromise(function(resolve, reject) {
            return $f8ed024a6db1f9db$var$newScope(function(resolve, reject) {
                var psd = $f8ed024a6db1f9db$var$PSD;
                psd.unhandleds = [];
                psd.onunhandled = reject;
                psd.finalize = $f8ed024a6db1f9db$var$callBoth(function() {
                    var _this = this;
                    $f8ed024a6db1f9db$var$run_at_end_of_this_or_next_physical_tick(function() {
                        _this.unhandleds.length === 0 ? resolve() : reject(_this.unhandleds[0]);
                    });
                }, psd.finalize);
                fn();
            }, zoneProps, resolve, reject);
        });
    }
});
if ($f8ed024a6db1f9db$var$NativePromise) {
    if ($f8ed024a6db1f9db$var$NativePromise.allSettled) $f8ed024a6db1f9db$var$setProp($f8ed024a6db1f9db$var$DexiePromise, "allSettled", function() {
        var possiblePromises = $f8ed024a6db1f9db$var$getArrayOf.apply(null, arguments).map($f8ed024a6db1f9db$var$onPossibleParallellAsync);
        return new $f8ed024a6db1f9db$var$DexiePromise(function(resolve) {
            if (possiblePromises.length === 0) resolve([]);
            var remaining = possiblePromises.length;
            var results = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return $f8ed024a6db1f9db$var$DexiePromise.resolve(p).then(function(value) {
                    return results[i] = {
                        status: "fulfilled",
                        value: value
                    };
                }, function(reason) {
                    return results[i] = {
                        status: "rejected",
                        reason: reason
                    };
                }).then(function() {
                    return --remaining || resolve(results);
                });
            });
        });
    });
    if ($f8ed024a6db1f9db$var$NativePromise.any && typeof AggregateError !== 'undefined') $f8ed024a6db1f9db$var$setProp($f8ed024a6db1f9db$var$DexiePromise, "any", function() {
        var possiblePromises = $f8ed024a6db1f9db$var$getArrayOf.apply(null, arguments).map($f8ed024a6db1f9db$var$onPossibleParallellAsync);
        return new $f8ed024a6db1f9db$var$DexiePromise(function(resolve, reject) {
            if (possiblePromises.length === 0) reject(new AggregateError([]));
            var remaining = possiblePromises.length;
            var failures = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return $f8ed024a6db1f9db$var$DexiePromise.resolve(p).then(function(value) {
                    return resolve(value);
                }, function(failure) {
                    failures[i] = failure;
                    if (!--remaining) reject(new AggregateError(failures));
                });
            });
        });
    });
    if ($f8ed024a6db1f9db$var$NativePromise.withResolvers) $f8ed024a6db1f9db$var$DexiePromise.withResolvers = $f8ed024a6db1f9db$var$NativePromise.withResolvers;
}
function $f8ed024a6db1f9db$var$executePromiseTask(promise, fn) {
    try {
        fn(function(value) {
            if (promise._state !== null) return;
            if (value === promise) throw new TypeError('A promise cannot be resolved with itself.');
            var shouldExecuteTick = promise._lib && $f8ed024a6db1f9db$var$beginMicroTickScope();
            if (value && typeof value.then === 'function') $f8ed024a6db1f9db$var$executePromiseTask(promise, function(resolve, reject) {
                value instanceof $f8ed024a6db1f9db$var$DexiePromise ? value._then(resolve, reject) : value.then(resolve, reject);
            });
            else {
                promise._state = true;
                promise._value = value;
                $f8ed024a6db1f9db$var$propagateAllListeners(promise);
            }
            if (shouldExecuteTick) $f8ed024a6db1f9db$var$endMicroTickScope();
        }, $f8ed024a6db1f9db$var$handleRejection.bind(null, promise));
    } catch (ex) {
        $f8ed024a6db1f9db$var$handleRejection(promise, ex);
    }
}
function $f8ed024a6db1f9db$var$handleRejection(promise, reason) {
    $f8ed024a6db1f9db$var$rejectingErrors.push(reason);
    if (promise._state !== null) return;
    var shouldExecuteTick = promise._lib && $f8ed024a6db1f9db$var$beginMicroTickScope();
    reason = $f8ed024a6db1f9db$var$rejectionMapper(reason);
    promise._state = false;
    promise._value = reason;
    $f8ed024a6db1f9db$var$addPossiblyUnhandledError(promise);
    $f8ed024a6db1f9db$var$propagateAllListeners(promise);
    if (shouldExecuteTick) $f8ed024a6db1f9db$var$endMicroTickScope();
}
function $f8ed024a6db1f9db$var$propagateAllListeners(promise) {
    var listeners = promise._listeners;
    promise._listeners = [];
    for(var i = 0, len = listeners.length; i < len; ++i)$f8ed024a6db1f9db$var$propagateToListener(promise, listeners[i]);
    var psd = promise._PSD;
    --psd.ref || psd.finalize();
    if ($f8ed024a6db1f9db$var$numScheduledCalls === 0) {
        ++$f8ed024a6db1f9db$var$numScheduledCalls;
        $f8ed024a6db1f9db$var$asap(function() {
            if (--$f8ed024a6db1f9db$var$numScheduledCalls === 0) $f8ed024a6db1f9db$var$finalizePhysicalTick();
        }, []);
    }
}
function $f8ed024a6db1f9db$var$propagateToListener(promise, listener) {
    if (promise._state === null) {
        promise._listeners.push(listener);
        return;
    }
    var cb = promise._state ? listener.onFulfilled : listener.onRejected;
    if (cb === null) return (promise._state ? listener.resolve : listener.reject)(promise._value);
    ++listener.psd.ref;
    ++$f8ed024a6db1f9db$var$numScheduledCalls;
    $f8ed024a6db1f9db$var$asap($f8ed024a6db1f9db$var$callListener, [
        cb,
        promise,
        listener
    ]);
}
function $f8ed024a6db1f9db$var$callListener(cb, promise, listener) {
    try {
        var ret, value = promise._value;
        if (!promise._state && $f8ed024a6db1f9db$var$rejectingErrors.length) $f8ed024a6db1f9db$var$rejectingErrors = [];
        ret = $f8ed024a6db1f9db$var$debug && promise._consoleTask ? promise._consoleTask.run(function() {
            return cb(value);
        }) : cb(value);
        if (!promise._state && $f8ed024a6db1f9db$var$rejectingErrors.indexOf(value) === -1) $f8ed024a6db1f9db$var$markErrorAsHandled(promise);
        listener.resolve(ret);
    } catch (e) {
        listener.reject(e);
    } finally{
        if (--$f8ed024a6db1f9db$var$numScheduledCalls === 0) $f8ed024a6db1f9db$var$finalizePhysicalTick();
        --listener.psd.ref || listener.psd.finalize();
    }
}
function $f8ed024a6db1f9db$var$physicalTick() {
    $f8ed024a6db1f9db$var$usePSD($f8ed024a6db1f9db$var$globalPSD, function() {
        $f8ed024a6db1f9db$var$beginMicroTickScope() && $f8ed024a6db1f9db$var$endMicroTickScope();
    });
}
function $f8ed024a6db1f9db$var$beginMicroTickScope() {
    var wasRootExec = $f8ed024a6db1f9db$var$isOutsideMicroTick;
    $f8ed024a6db1f9db$var$isOutsideMicroTick = false;
    $f8ed024a6db1f9db$var$needsNewPhysicalTick = false;
    return wasRootExec;
}
function $f8ed024a6db1f9db$var$endMicroTickScope() {
    var callbacks, i, l;
    do while($f8ed024a6db1f9db$var$microtickQueue.length > 0){
        callbacks = $f8ed024a6db1f9db$var$microtickQueue;
        $f8ed024a6db1f9db$var$microtickQueue = [];
        l = callbacks.length;
        for(i = 0; i < l; ++i){
            var item = callbacks[i];
            item[0].apply(null, item[1]);
        }
    }
    while ($f8ed024a6db1f9db$var$microtickQueue.length > 0);
    $f8ed024a6db1f9db$var$isOutsideMicroTick = true;
    $f8ed024a6db1f9db$var$needsNewPhysicalTick = true;
}
function $f8ed024a6db1f9db$var$finalizePhysicalTick() {
    var unhandledErrs = $f8ed024a6db1f9db$var$unhandledErrors;
    $f8ed024a6db1f9db$var$unhandledErrors = [];
    unhandledErrs.forEach(function(p) {
        p._PSD.onunhandled.call(null, p._value, p);
    });
    var finalizers = $f8ed024a6db1f9db$var$tickFinalizers.slice(0);
    var i = finalizers.length;
    while(i)finalizers[--i]();
}
function $f8ed024a6db1f9db$var$run_at_end_of_this_or_next_physical_tick(fn) {
    function finalizer() {
        fn();
        $f8ed024a6db1f9db$var$tickFinalizers.splice($f8ed024a6db1f9db$var$tickFinalizers.indexOf(finalizer), 1);
    }
    $f8ed024a6db1f9db$var$tickFinalizers.push(finalizer);
    ++$f8ed024a6db1f9db$var$numScheduledCalls;
    $f8ed024a6db1f9db$var$asap(function() {
        if (--$f8ed024a6db1f9db$var$numScheduledCalls === 0) $f8ed024a6db1f9db$var$finalizePhysicalTick();
    }, []);
}
function $f8ed024a6db1f9db$var$addPossiblyUnhandledError(promise) {
    if (!$f8ed024a6db1f9db$var$unhandledErrors.some(function(p) {
        return p._value === promise._value;
    })) $f8ed024a6db1f9db$var$unhandledErrors.push(promise);
}
function $f8ed024a6db1f9db$var$markErrorAsHandled(promise) {
    var i = $f8ed024a6db1f9db$var$unhandledErrors.length;
    while(i)if ($f8ed024a6db1f9db$var$unhandledErrors[--i]._value === promise._value) {
        $f8ed024a6db1f9db$var$unhandledErrors.splice(i, 1);
        return;
    }
}
function $f8ed024a6db1f9db$var$PromiseReject(reason) {
    return new $f8ed024a6db1f9db$var$DexiePromise($f8ed024a6db1f9db$var$INTERNAL, false, reason);
}
function $f8ed024a6db1f9db$var$wrap(fn, errorCatcher) {
    var psd = $f8ed024a6db1f9db$var$PSD;
    return function() {
        var wasRootExec = $f8ed024a6db1f9db$var$beginMicroTickScope(), outerScope = $f8ed024a6db1f9db$var$PSD;
        try {
            $f8ed024a6db1f9db$var$switchToZone(psd, true);
            return fn.apply(this, arguments);
        } catch (e) {
            errorCatcher && errorCatcher(e);
        } finally{
            $f8ed024a6db1f9db$var$switchToZone(outerScope, false);
            if (wasRootExec) $f8ed024a6db1f9db$var$endMicroTickScope();
        }
    };
}
var $f8ed024a6db1f9db$var$task = {
    awaits: 0,
    echoes: 0,
    id: 0
};
var $f8ed024a6db1f9db$var$taskCounter = 0;
var $f8ed024a6db1f9db$var$zoneStack = [];
var $f8ed024a6db1f9db$var$zoneEchoes = 0;
var $f8ed024a6db1f9db$var$totalEchoes = 0;
var $f8ed024a6db1f9db$var$zone_id_counter = 0;
function $f8ed024a6db1f9db$var$newScope(fn, props, a1, a2) {
    var parent = $f8ed024a6db1f9db$var$PSD, psd = Object.create(parent);
    psd.parent = parent;
    psd.ref = 0;
    psd.global = false;
    psd.id = ++$f8ed024a6db1f9db$var$zone_id_counter;
    $f8ed024a6db1f9db$var$globalPSD.env;
    psd.env = $f8ed024a6db1f9db$var$patchGlobalPromise ? {
        Promise: $f8ed024a6db1f9db$var$DexiePromise,
        PromiseProp: {
            value: $f8ed024a6db1f9db$var$DexiePromise,
            configurable: true,
            writable: true
        },
        all: $f8ed024a6db1f9db$var$DexiePromise.all,
        race: $f8ed024a6db1f9db$var$DexiePromise.race,
        allSettled: $f8ed024a6db1f9db$var$DexiePromise.allSettled,
        any: $f8ed024a6db1f9db$var$DexiePromise.any,
        resolve: $f8ed024a6db1f9db$var$DexiePromise.resolve,
        reject: $f8ed024a6db1f9db$var$DexiePromise.reject
    } : {};
    if (props) $f8ed024a6db1f9db$var$extend(psd, props);
    ++parent.ref;
    psd.finalize = function() {
        --this.parent.ref || this.parent.finalize();
    };
    var rv = $f8ed024a6db1f9db$var$usePSD(psd, fn, a1, a2);
    if (psd.ref === 0) psd.finalize();
    return rv;
}
function $f8ed024a6db1f9db$var$incrementExpectedAwaits() {
    if (!$f8ed024a6db1f9db$var$task.id) $f8ed024a6db1f9db$var$task.id = ++$f8ed024a6db1f9db$var$taskCounter;
    ++$f8ed024a6db1f9db$var$task.awaits;
    $f8ed024a6db1f9db$var$task.echoes += $f8ed024a6db1f9db$var$ZONE_ECHO_LIMIT;
    return $f8ed024a6db1f9db$var$task.id;
}
function $f8ed024a6db1f9db$var$decrementExpectedAwaits() {
    if (!$f8ed024a6db1f9db$var$task.awaits) return false;
    if (--$f8ed024a6db1f9db$var$task.awaits === 0) $f8ed024a6db1f9db$var$task.id = 0;
    $f8ed024a6db1f9db$var$task.echoes = $f8ed024a6db1f9db$var$task.awaits * $f8ed024a6db1f9db$var$ZONE_ECHO_LIMIT;
    return true;
}
if (('' + $f8ed024a6db1f9db$var$nativePromiseThen).indexOf('[native code]') === -1) $f8ed024a6db1f9db$var$incrementExpectedAwaits = $f8ed024a6db1f9db$var$decrementExpectedAwaits = $f8ed024a6db1f9db$var$nop;
function $f8ed024a6db1f9db$var$onPossibleParallellAsync(possiblePromise) {
    if ($f8ed024a6db1f9db$var$task.echoes && possiblePromise && possiblePromise.constructor === $f8ed024a6db1f9db$var$NativePromise) {
        $f8ed024a6db1f9db$var$incrementExpectedAwaits();
        return possiblePromise.then(function(x) {
            $f8ed024a6db1f9db$var$decrementExpectedAwaits();
            return x;
        }, function(e) {
            $f8ed024a6db1f9db$var$decrementExpectedAwaits();
            return $f8ed024a6db1f9db$var$rejection(e);
        });
    }
    return possiblePromise;
}
function $f8ed024a6db1f9db$var$zoneEnterEcho(targetZone) {
    ++$f8ed024a6db1f9db$var$totalEchoes;
    if (!$f8ed024a6db1f9db$var$task.echoes || --$f8ed024a6db1f9db$var$task.echoes === 0) $f8ed024a6db1f9db$var$task.echoes = $f8ed024a6db1f9db$var$task.awaits = $f8ed024a6db1f9db$var$task.id = 0;
    $f8ed024a6db1f9db$var$zoneStack.push($f8ed024a6db1f9db$var$PSD);
    $f8ed024a6db1f9db$var$switchToZone(targetZone, true);
}
function $f8ed024a6db1f9db$var$zoneLeaveEcho() {
    var zone = $f8ed024a6db1f9db$var$zoneStack[$f8ed024a6db1f9db$var$zoneStack.length - 1];
    $f8ed024a6db1f9db$var$zoneStack.pop();
    $f8ed024a6db1f9db$var$switchToZone(zone, false);
}
function $f8ed024a6db1f9db$var$switchToZone(targetZone, bEnteringZone) {
    var currentZone = $f8ed024a6db1f9db$var$PSD;
    if (bEnteringZone ? $f8ed024a6db1f9db$var$task.echoes && (!$f8ed024a6db1f9db$var$zoneEchoes++ || targetZone !== $f8ed024a6db1f9db$var$PSD) : $f8ed024a6db1f9db$var$zoneEchoes && (!--$f8ed024a6db1f9db$var$zoneEchoes || targetZone !== $f8ed024a6db1f9db$var$PSD)) queueMicrotask(bEnteringZone ? $f8ed024a6db1f9db$var$zoneEnterEcho.bind(null, targetZone) : $f8ed024a6db1f9db$var$zoneLeaveEcho);
    if (targetZone === $f8ed024a6db1f9db$var$PSD) return;
    $f8ed024a6db1f9db$var$PSD = targetZone;
    if (currentZone === $f8ed024a6db1f9db$var$globalPSD) $f8ed024a6db1f9db$var$globalPSD.env = $f8ed024a6db1f9db$var$snapShot();
    if ($f8ed024a6db1f9db$var$patchGlobalPromise) {
        var GlobalPromise = $f8ed024a6db1f9db$var$globalPSD.env.Promise;
        var targetEnv = targetZone.env;
        if (currentZone.global || targetZone.global) {
            Object.defineProperty($f8ed024a6db1f9db$var$_global, 'Promise', targetEnv.PromiseProp);
            GlobalPromise.all = targetEnv.all;
            GlobalPromise.race = targetEnv.race;
            GlobalPromise.resolve = targetEnv.resolve;
            GlobalPromise.reject = targetEnv.reject;
            if (targetEnv.allSettled) GlobalPromise.allSettled = targetEnv.allSettled;
            if (targetEnv.any) GlobalPromise.any = targetEnv.any;
        }
    }
}
function $f8ed024a6db1f9db$var$snapShot() {
    var GlobalPromise = $f8ed024a6db1f9db$var$_global.Promise;
    return $f8ed024a6db1f9db$var$patchGlobalPromise ? {
        Promise: GlobalPromise,
        PromiseProp: Object.getOwnPropertyDescriptor($f8ed024a6db1f9db$var$_global, "Promise"),
        all: GlobalPromise.all,
        race: GlobalPromise.race,
        allSettled: GlobalPromise.allSettled,
        any: GlobalPromise.any,
        resolve: GlobalPromise.resolve,
        reject: GlobalPromise.reject
    } : {};
}
function $f8ed024a6db1f9db$var$usePSD(psd, fn, a1, a2, a3) {
    var outerScope = $f8ed024a6db1f9db$var$PSD;
    try {
        $f8ed024a6db1f9db$var$switchToZone(psd, true);
        return fn(a1, a2, a3);
    } finally{
        $f8ed024a6db1f9db$var$switchToZone(outerScope, false);
    }
}
function $f8ed024a6db1f9db$var$nativeAwaitCompatibleWrap(fn, zone, possibleAwait, cleanup) {
    return typeof fn !== 'function' ? fn : function() {
        var outerZone = $f8ed024a6db1f9db$var$PSD;
        if (possibleAwait) $f8ed024a6db1f9db$var$incrementExpectedAwaits();
        $f8ed024a6db1f9db$var$switchToZone(zone, true);
        try {
            return fn.apply(this, arguments);
        } finally{
            $f8ed024a6db1f9db$var$switchToZone(outerZone, false);
            if (cleanup) queueMicrotask($f8ed024a6db1f9db$var$decrementExpectedAwaits);
        }
    };
}
function $f8ed024a6db1f9db$var$execInGlobalContext(cb) {
    if (Promise === $f8ed024a6db1f9db$var$NativePromise && $f8ed024a6db1f9db$var$task.echoes === 0) {
        if ($f8ed024a6db1f9db$var$zoneEchoes === 0) cb();
        else enqueueNativeMicroTask(cb);
    } else setTimeout(cb, 0);
}
var $f8ed024a6db1f9db$var$rejection = $f8ed024a6db1f9db$var$DexiePromise.reject;
function $f8ed024a6db1f9db$var$tempTransaction(db, mode, storeNames, fn) {
    if (!db.idbdb || !db._state.openComplete && !$f8ed024a6db1f9db$var$PSD.letThrough && !db._vip) {
        if (db._state.openComplete) return $f8ed024a6db1f9db$var$rejection(new $f8ed024a6db1f9db$var$exceptions.DatabaseClosed(db._state.dbOpenError));
        if (!db._state.isBeingOpened) {
            if (!db._state.autoOpen) return $f8ed024a6db1f9db$var$rejection(new $f8ed024a6db1f9db$var$exceptions.DatabaseClosed());
            db.open().catch($f8ed024a6db1f9db$var$nop);
        }
        return db._state.dbReadyPromise.then(function() {
            return $f8ed024a6db1f9db$var$tempTransaction(db, mode, storeNames, fn);
        });
    } else {
        var trans = db._createTransaction(mode, storeNames, db._dbSchema);
        try {
            trans.create();
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === $f8ed024a6db1f9db$var$errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn('Dexie: Need to reopen db');
                db.close({
                    disableAutoOpen: false
                });
                return db.open().then(function() {
                    return $f8ed024a6db1f9db$var$tempTransaction(db, mode, storeNames, fn);
                });
            }
            return $f8ed024a6db1f9db$var$rejection(ex);
        }
        return trans._promise(mode, function(resolve, reject) {
            return $f8ed024a6db1f9db$var$newScope(function() {
                $f8ed024a6db1f9db$var$PSD.trans = trans;
                return fn(resolve, reject, trans);
            });
        }).then(function(result) {
            if (mode === 'readwrite') try {
                trans.idbtrans.commit();
            } catch (_a) {}
            return mode === 'readonly' ? result : trans._completion.then(function() {
                return result;
            });
        });
    }
}
var $f8ed024a6db1f9db$var$DEXIE_VERSION = '4.0.11';
var $f8ed024a6db1f9db$var$maxString = String.fromCharCode(65535);
var $f8ed024a6db1f9db$var$minKey = -Infinity;
var $f8ed024a6db1f9db$var$INVALID_KEY_ARGUMENT = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.";
var $f8ed024a6db1f9db$var$STRING_EXPECTED = "String expected.";
var $f8ed024a6db1f9db$var$connections = [];
var $f8ed024a6db1f9db$var$DBNAMES_DB = '__dbnames';
var $f8ed024a6db1f9db$var$READONLY = 'readonly';
var $f8ed024a6db1f9db$var$READWRITE = 'readwrite';
function $f8ed024a6db1f9db$var$combine(filter1, filter2) {
    return filter1 ? filter2 ? function() {
        return filter1.apply(this, arguments) && filter2.apply(this, arguments);
    } : filter1 : filter2;
}
var $f8ed024a6db1f9db$var$AnyRange = {
    type: 3,
    lower: -Infinity,
    lowerOpen: false,
    upper: [
        []
    ],
    upperOpen: false
};
function $f8ed024a6db1f9db$var$workaroundForUndefinedPrimKey(keyPath) {
    return typeof keyPath === "string" && !/\./.test(keyPath) ? function(obj) {
        if (obj[keyPath] === undefined && keyPath in obj) {
            obj = $f8ed024a6db1f9db$var$deepClone(obj);
            delete obj[keyPath];
        }
        return obj;
    } : function(obj) {
        return obj;
    };
}
function $f8ed024a6db1f9db$export$bc644a473284d944() {
    throw $f8ed024a6db1f9db$var$exceptions.Type();
}
function $f8ed024a6db1f9db$export$6154dcdb7d23e37b(a, b) {
    try {
        var ta = $f8ed024a6db1f9db$var$type(a);
        var tb = $f8ed024a6db1f9db$var$type(b);
        if (ta !== tb) {
            if (ta === 'Array') return 1;
            if (tb === 'Array') return -1;
            if (ta === 'binary') return 1;
            if (tb === 'binary') return -1;
            if (ta === 'string') return 1;
            if (tb === 'string') return -1;
            if (ta === 'Date') return 1;
            if (tb !== 'Date') return NaN;
            return -1;
        }
        switch(ta){
            case 'number':
            case 'Date':
            case 'string':
                return a > b ? 1 : a < b ? -1 : 0;
            case 'binary':
                return $f8ed024a6db1f9db$var$compareUint8Arrays($f8ed024a6db1f9db$var$getUint8Array(a), $f8ed024a6db1f9db$var$getUint8Array(b));
            case 'Array':
                return $f8ed024a6db1f9db$var$compareArrays(a, b);
        }
    } catch (_a) {}
    return NaN;
}
function $f8ed024a6db1f9db$var$compareArrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        var res = $f8ed024a6db1f9db$export$6154dcdb7d23e37b(a[i], b[i]);
        if (res !== 0) return res;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function $f8ed024a6db1f9db$var$compareUint8Arrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        if (a[i] !== b[i]) return a[i] < b[i] ? -1 : 1;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function $f8ed024a6db1f9db$var$type(x) {
    var t = typeof x;
    if (t !== 'object') return t;
    if (ArrayBuffer.isView(x)) return 'binary';
    var tsTag = $f8ed024a6db1f9db$var$toStringTag(x);
    return tsTag === 'ArrayBuffer' ? 'binary' : tsTag;
}
function $f8ed024a6db1f9db$var$getUint8Array(a) {
    if (a instanceof Uint8Array) return a;
    if (ArrayBuffer.isView(a)) return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    return new Uint8Array(a);
}
var $f8ed024a6db1f9db$var$Table = function() {
    function Table() {}
    Table.prototype._trans = function(mode, fn, writeLocked) {
        var trans = this._tx || $f8ed024a6db1f9db$var$PSD.trans;
        var tableName = this.name;
        var task = $f8ed024a6db1f9db$var$debug && typeof console !== 'undefined' && console.createTask && console.createTask("Dexie: ".concat(mode === 'readonly' ? 'read' : 'write', " ").concat(this.name));
        function checkTableInTransaction(resolve, reject, trans) {
            if (!trans.schema[tableName]) throw new $f8ed024a6db1f9db$var$exceptions.NotFound("Table " + tableName + " not part of transaction");
            return fn(trans.idbtrans, trans);
        }
        var wasRootExec = $f8ed024a6db1f9db$var$beginMicroTickScope();
        try {
            var p = trans && trans.db._novip === this.db._novip ? trans === $f8ed024a6db1f9db$var$PSD.trans ? trans._promise(mode, checkTableInTransaction, writeLocked) : $f8ed024a6db1f9db$var$newScope(function() {
                return trans._promise(mode, checkTableInTransaction, writeLocked);
            }, {
                trans: trans,
                transless: $f8ed024a6db1f9db$var$PSD.transless || $f8ed024a6db1f9db$var$PSD
            }) : $f8ed024a6db1f9db$var$tempTransaction(this.db, mode, [
                this.name
            ], checkTableInTransaction);
            if (task) {
                p._consoleTask = task;
                p = p.catch(function(err) {
                    console.trace(err);
                    return $f8ed024a6db1f9db$var$rejection(err);
                });
            }
            return p;
        } finally{
            if (wasRootExec) $f8ed024a6db1f9db$var$endMicroTickScope();
        }
    };
    Table.prototype.get = function(keyOrCrit, cb) {
        var _this = this;
        if (keyOrCrit && keyOrCrit.constructor === Object) return this.where(keyOrCrit).first(cb);
        if (keyOrCrit == null) return $f8ed024a6db1f9db$var$rejection(new $f8ed024a6db1f9db$var$exceptions.Type("Invalid argument to Table.get()"));
        return this._trans('readonly', function(trans) {
            return _this.core.get({
                trans: trans,
                key: keyOrCrit
            }).then(function(res) {
                return _this.hook.reading.fire(res);
            });
        }).then(cb);
    };
    Table.prototype.where = function(indexOrCrit) {
        if (typeof indexOrCrit === 'string') return new this.db.WhereClause(this, indexOrCrit);
        if ($f8ed024a6db1f9db$var$isArray(indexOrCrit)) return new this.db.WhereClause(this, "[".concat(indexOrCrit.join('+'), "]"));
        var keyPaths = $f8ed024a6db1f9db$var$keys(indexOrCrit);
        if (keyPaths.length === 1) return this.where(keyPaths[0]).equals(indexOrCrit[keyPaths[0]]);
        var compoundIndex = this.schema.indexes.concat(this.schema.primKey).filter(function(ix) {
            if (ix.compound && keyPaths.every(function(keyPath) {
                return ix.keyPath.indexOf(keyPath) >= 0;
            })) {
                for(var i = 0; i < keyPaths.length; ++i){
                    if (keyPaths.indexOf(ix.keyPath[i]) === -1) return false;
                }
                return true;
            }
            return false;
        }).sort(function(a, b) {
            return a.keyPath.length - b.keyPath.length;
        })[0];
        if (compoundIndex && this.db._maxKey !== $f8ed024a6db1f9db$var$maxString) {
            var keyPathsInValidOrder = compoundIndex.keyPath.slice(0, keyPaths.length);
            return this.where(keyPathsInValidOrder).equals(keyPathsInValidOrder.map(function(kp) {
                return indexOrCrit[kp];
            }));
        }
        if (!compoundIndex && $f8ed024a6db1f9db$var$debug) console.warn("The query ".concat(JSON.stringify(indexOrCrit), " on ").concat(this.name, " would benefit from a ") + "compound index [".concat(keyPaths.join('+'), "]"));
        var idxByName = this.schema.idxByName;
        function equals(a, b) {
            return $f8ed024a6db1f9db$export$6154dcdb7d23e37b(a, b) === 0;
        }
        var _a = keyPaths.reduce(function(_a, keyPath) {
            var prevIndex = _a[0], prevFilterFn = _a[1];
            var index = idxByName[keyPath];
            var value = indexOrCrit[keyPath];
            return [
                prevIndex || index,
                prevIndex || !index ? $f8ed024a6db1f9db$var$combine(prevFilterFn, index && index.multi ? function(x) {
                    var prop = $f8ed024a6db1f9db$var$getByKeyPath(x, keyPath);
                    return $f8ed024a6db1f9db$var$isArray(prop) && prop.some(function(item) {
                        return equals(value, item);
                    });
                } : function(x) {
                    return equals(value, $f8ed024a6db1f9db$var$getByKeyPath(x, keyPath));
                }) : prevFilterFn
            ];
        }, [
            null,
            null
        ]), idx = _a[0], filterFunction = _a[1];
        return idx ? this.where(idx.name).equals(indexOrCrit[idx.keyPath]).filter(filterFunction) : compoundIndex ? this.filter(filterFunction) : this.where(keyPaths).equals('');
    };
    Table.prototype.filter = function(filterFunction) {
        return this.toCollection().and(filterFunction);
    };
    Table.prototype.count = function(thenShortcut) {
        return this.toCollection().count(thenShortcut);
    };
    Table.prototype.offset = function(offset) {
        return this.toCollection().offset(offset);
    };
    Table.prototype.limit = function(numRows) {
        return this.toCollection().limit(numRows);
    };
    Table.prototype.each = function(callback) {
        return this.toCollection().each(callback);
    };
    Table.prototype.toArray = function(thenShortcut) {
        return this.toCollection().toArray(thenShortcut);
    };
    Table.prototype.toCollection = function() {
        return new this.db.Collection(new this.db.WhereClause(this));
    };
    Table.prototype.orderBy = function(index) {
        return new this.db.Collection(new this.db.WhereClause(this, $f8ed024a6db1f9db$var$isArray(index) ? "[".concat(index.join('+'), "]") : index));
    };
    Table.prototype.reverse = function() {
        return this.toCollection().reverse();
    };
    Table.prototype.mapToClass = function(constructor) {
        var _a = this, db = _a.db, tableName = _a.name;
        this.schema.mappedClass = constructor;
        if (constructor.prototype instanceof $f8ed024a6db1f9db$export$bc644a473284d944) constructor = function(_super) {
            $f8ed024a6db1f9db$var$__extends(class_1, _super);
            function class_1() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(class_1.prototype, "db", {
                get: function() {
                    return db;
                },
                enumerable: false,
                configurable: true
            });
            class_1.prototype.table = function() {
                return tableName;
            };
            return class_1;
        }(constructor);
        var inheritedProps = new Set();
        for(var proto = constructor.prototype; proto; proto = $f8ed024a6db1f9db$var$getProto(proto))Object.getOwnPropertyNames(proto).forEach(function(propName) {
            return inheritedProps.add(propName);
        });
        var readHook = function(obj) {
            if (!obj) return obj;
            var res = Object.create(constructor.prototype);
            for(var m in obj)if (!inheritedProps.has(m)) try {
                res[m] = obj[m];
            } catch (_) {}
            return res;
        };
        if (this.schema.readHook) this.hook.reading.unsubscribe(this.schema.readHook);
        this.schema.readHook = readHook;
        this.hook("reading", readHook);
        return constructor;
    };
    Table.prototype.defineClass = function() {
        function Class(content) {
            $f8ed024a6db1f9db$var$extend(this, content);
        }
        return this.mapToClass(Class);
    };
    Table.prototype.add = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = $f8ed024a6db1f9db$var$workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'add',
                keys: key != null ? [
                    key
                ] : null,
                values: [
                    objToAdd
                ]
            });
        }).then(function(res) {
            return res.numFailures ? $f8ed024a6db1f9db$var$DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                $f8ed024a6db1f9db$var$setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.update = function(keyOrObject, modifications) {
        if (typeof keyOrObject === 'object' && !$f8ed024a6db1f9db$var$isArray(keyOrObject)) {
            var key = $f8ed024a6db1f9db$var$getByKeyPath(keyOrObject, this.schema.primKey.keyPath);
            if (key === undefined) return $f8ed024a6db1f9db$var$rejection(new $f8ed024a6db1f9db$var$exceptions.InvalidArgument("Given object does not contain its primary key"));
            return this.where(":id").equals(key).modify(modifications);
        } else return this.where(":id").equals(keyOrObject).modify(modifications);
    };
    Table.prototype.put = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = $f8ed024a6db1f9db$var$workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'put',
                values: [
                    objToAdd
                ],
                keys: key != null ? [
                    key
                ] : null
            });
        }).then(function(res) {
            return res.numFailures ? $f8ed024a6db1f9db$var$DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                $f8ed024a6db1f9db$var$setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.delete = function(key) {
        var _this = this;
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'delete',
                keys: [
                    key
                ]
            });
        }).then(function(res) {
            return res.numFailures ? $f8ed024a6db1f9db$var$DexiePromise.reject(res.failures[0]) : undefined;
        });
    };
    Table.prototype.clear = function() {
        var _this = this;
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'deleteRange',
                range: $f8ed024a6db1f9db$var$AnyRange
            });
        }).then(function(res) {
            return res.numFailures ? $f8ed024a6db1f9db$var$DexiePromise.reject(res.failures[0]) : undefined;
        });
    };
    Table.prototype.bulkGet = function(keys) {
        var _this = this;
        return this._trans('readonly', function(trans) {
            return _this.core.getMany({
                keys: keys,
                trans: trans
            }).then(function(result) {
                return result.map(function(res) {
                    return _this.hook.reading.fire(res);
                });
            });
        });
    };
    Table.prototype.bulkAdd = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans('readwrite', function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new $f8ed024a6db1f9db$var$exceptions.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new $f8ed024a6db1f9db$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToAdd = keyPath && auto ? objects.map($f8ed024a6db1f9db$var$workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: 'add',
                keys: keys,
                values: objectsToAdd,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new $f8ed024a6db1f9db$var$BulkError("".concat(_this.name, ".bulkAdd(): ").concat(numFailures, " of ").concat(numObjects, " operations failed"), failures);
            });
        });
    };
    Table.prototype.bulkPut = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans('readwrite', function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new $f8ed024a6db1f9db$var$exceptions.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new $f8ed024a6db1f9db$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToPut = keyPath && auto ? objects.map($f8ed024a6db1f9db$var$workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: 'put',
                keys: keys,
                values: objectsToPut,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new $f8ed024a6db1f9db$var$BulkError("".concat(_this.name, ".bulkPut(): ").concat(numFailures, " of ").concat(numObjects, " operations failed"), failures);
            });
        });
    };
    Table.prototype.bulkUpdate = function(keysAndChanges) {
        var _this = this;
        var coreTable = this.core;
        var keys = keysAndChanges.map(function(entry) {
            return entry.key;
        });
        var changeSpecs = keysAndChanges.map(function(entry) {
            return entry.changes;
        });
        var offsetMap = [];
        return this._trans('readwrite', function(trans) {
            return coreTable.getMany({
                trans: trans,
                keys: keys,
                cache: 'clone'
            }).then(function(objs) {
                var resultKeys = [];
                var resultObjs = [];
                keysAndChanges.forEach(function(_a, idx) {
                    var key = _a.key, changes = _a.changes;
                    var obj = objs[idx];
                    if (obj) {
                        for(var _i = 0, _b = Object.keys(changes); _i < _b.length; _i++){
                            var keyPath = _b[_i];
                            var value = changes[keyPath];
                            if (keyPath === _this.schema.primKey.keyPath) {
                                if ($f8ed024a6db1f9db$export$6154dcdb7d23e37b(value, key) !== 0) throw new $f8ed024a6db1f9db$var$exceptions.Constraint("Cannot update primary key in bulkUpdate()");
                            } else $f8ed024a6db1f9db$var$setByKeyPath(obj, keyPath, value);
                        }
                        offsetMap.push(idx);
                        resultKeys.push(key);
                        resultObjs.push(obj);
                    }
                });
                var numEntries = resultKeys.length;
                return coreTable.mutate({
                    trans: trans,
                    type: 'put',
                    keys: resultKeys,
                    values: resultObjs,
                    updates: {
                        keys: keys,
                        changeSpecs: changeSpecs
                    }
                }).then(function(_a) {
                    var numFailures = _a.numFailures, failures = _a.failures;
                    if (numFailures === 0) return numEntries;
                    for(var _i = 0, _b = Object.keys(failures); _i < _b.length; _i++){
                        var offset = _b[_i];
                        var mappedOffset = offsetMap[Number(offset)];
                        if (mappedOffset != null) {
                            var failure = failures[offset];
                            delete failures[offset];
                            failures[mappedOffset] = failure;
                        }
                    }
                    throw new $f8ed024a6db1f9db$var$BulkError("".concat(_this.name, ".bulkUpdate(): ").concat(numFailures, " of ").concat(numEntries, " operations failed"), failures);
                });
            });
        });
    };
    Table.prototype.bulkDelete = function(keys) {
        var _this = this;
        var numKeys = keys.length;
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'delete',
                keys: keys
            });
        }).then(function(_a) {
            var numFailures = _a.numFailures, lastResult = _a.lastResult, failures = _a.failures;
            if (numFailures === 0) return lastResult;
            throw new $f8ed024a6db1f9db$var$BulkError("".concat(_this.name, ".bulkDelete(): ").concat(numFailures, " of ").concat(numKeys, " operations failed"), failures);
        });
    };
    return Table;
}();
function $f8ed024a6db1f9db$var$Events(ctx) {
    var evs = {};
    var rv = function(eventName, subscriber) {
        if (subscriber) {
            var i = arguments.length, args = new Array(i - 1);
            while(--i)args[i - 1] = arguments[i];
            evs[eventName].subscribe.apply(null, args);
            return ctx;
        } else if (typeof eventName === 'string') return evs[eventName];
    };
    rv.addEventType = add;
    for(var i = 1, l = arguments.length; i < l; ++i)add(arguments[i]);
    return rv;
    function add(eventName, chainFunction, defaultFunction) {
        if (typeof eventName === 'object') return addConfiguredEvents(eventName);
        if (!chainFunction) chainFunction = $f8ed024a6db1f9db$var$reverseStoppableEventChain;
        if (!defaultFunction) defaultFunction = $f8ed024a6db1f9db$var$nop;
        var context = {
            subscribers: [],
            fire: defaultFunction,
            subscribe: function(cb) {
                if (context.subscribers.indexOf(cb) === -1) {
                    context.subscribers.push(cb);
                    context.fire = chainFunction(context.fire, cb);
                }
            },
            unsubscribe: function(cb) {
                context.subscribers = context.subscribers.filter(function(fn) {
                    return fn !== cb;
                });
                context.fire = context.subscribers.reduce(chainFunction, defaultFunction);
            }
        };
        evs[eventName] = rv[eventName] = context;
        return context;
    }
    function addConfiguredEvents(cfg) {
        $f8ed024a6db1f9db$var$keys(cfg).forEach(function(eventName) {
            var args = cfg[eventName];
            if ($f8ed024a6db1f9db$var$isArray(args)) add(eventName, cfg[eventName][0], cfg[eventName][1]);
            else if (args === 'asap') var context = add(eventName, $f8ed024a6db1f9db$var$mirror, function fire() {
                var i = arguments.length, args = new Array(i);
                while(i--)args[i] = arguments[i];
                context.subscribers.forEach(function(fn) {
                    $f8ed024a6db1f9db$var$asap$1(function fireEvent() {
                        fn.apply(null, args);
                    });
                });
            });
            else throw new $f8ed024a6db1f9db$var$exceptions.InvalidArgument("Invalid event config");
        });
    }
}
function $f8ed024a6db1f9db$var$makeClassConstructor(prototype, constructor) {
    $f8ed024a6db1f9db$var$derive(constructor).from({
        prototype: prototype
    });
    return constructor;
}
function $f8ed024a6db1f9db$var$createTableConstructor(db) {
    return $f8ed024a6db1f9db$var$makeClassConstructor($f8ed024a6db1f9db$var$Table.prototype, function Table(name, tableSchema, trans) {
        this.db = db;
        this._tx = trans;
        this.name = name;
        this.schema = tableSchema;
        this.hook = db._allTables[name] ? db._allTables[name].hook : $f8ed024a6db1f9db$var$Events(null, {
            "creating": [
                $f8ed024a6db1f9db$var$hookCreatingChain,
                $f8ed024a6db1f9db$var$nop
            ],
            "reading": [
                $f8ed024a6db1f9db$var$pureFunctionChain,
                $f8ed024a6db1f9db$var$mirror
            ],
            "updating": [
                $f8ed024a6db1f9db$var$hookUpdatingChain,
                $f8ed024a6db1f9db$var$nop
            ],
            "deleting": [
                $f8ed024a6db1f9db$var$hookDeletingChain,
                $f8ed024a6db1f9db$var$nop
            ]
        });
    });
}
function $f8ed024a6db1f9db$var$isPlainKeyRange(ctx, ignoreLimitFilter) {
    return !(ctx.filter || ctx.algorithm || ctx.or) && (ignoreLimitFilter ? ctx.justLimit : !ctx.replayFilter);
}
function $f8ed024a6db1f9db$var$addFilter(ctx, fn) {
    ctx.filter = $f8ed024a6db1f9db$var$combine(ctx.filter, fn);
}
function $f8ed024a6db1f9db$var$addReplayFilter(ctx, factory, isLimitFilter) {
    var curr = ctx.replayFilter;
    ctx.replayFilter = curr ? function() {
        return $f8ed024a6db1f9db$var$combine(curr(), factory());
    } : factory;
    ctx.justLimit = isLimitFilter && !curr;
}
function $f8ed024a6db1f9db$var$addMatchFilter(ctx, fn) {
    ctx.isMatch = $f8ed024a6db1f9db$var$combine(ctx.isMatch, fn);
}
function $f8ed024a6db1f9db$var$getIndexOrStore(ctx, coreSchema) {
    if (ctx.isPrimKey) return coreSchema.primaryKey;
    var index = coreSchema.getIndexByKeyPath(ctx.index);
    if (!index) throw new $f8ed024a6db1f9db$var$exceptions.Schema("KeyPath " + ctx.index + " on object store " + coreSchema.name + " is not indexed");
    return index;
}
function $f8ed024a6db1f9db$var$openCursor(ctx, coreTable, trans) {
    var index = $f8ed024a6db1f9db$var$getIndexOrStore(ctx, coreTable.schema);
    return coreTable.openCursor({
        trans: trans,
        values: !ctx.keysOnly,
        reverse: ctx.dir === 'prev',
        unique: !!ctx.unique,
        query: {
            index: index,
            range: ctx.range
        }
    });
}
function $f8ed024a6db1f9db$var$iter(ctx, fn, coreTrans, coreTable) {
    var filter = ctx.replayFilter ? $f8ed024a6db1f9db$var$combine(ctx.filter, ctx.replayFilter()) : ctx.filter;
    if (!ctx.or) return $f8ed024a6db1f9db$var$iterate($f8ed024a6db1f9db$var$openCursor(ctx, coreTable, coreTrans), $f8ed024a6db1f9db$var$combine(ctx.algorithm, filter), fn, !ctx.keysOnly && ctx.valueMapper);
    else {
        var set_1 = {};
        var union = function(item, cursor, advance) {
            if (!filter || filter(cursor, advance, function(result) {
                return cursor.stop(result);
            }, function(err) {
                return cursor.fail(err);
            })) {
                var primaryKey = cursor.primaryKey;
                var key = '' + primaryKey;
                if (key === '[object ArrayBuffer]') key = '' + new Uint8Array(primaryKey);
                if (!$f8ed024a6db1f9db$var$hasOwn(set_1, key)) {
                    set_1[key] = true;
                    fn(item, cursor, advance);
                }
            }
        };
        return Promise.all([
            ctx.or._iterate(union, coreTrans),
            $f8ed024a6db1f9db$var$iterate($f8ed024a6db1f9db$var$openCursor(ctx, coreTable, coreTrans), ctx.algorithm, union, !ctx.keysOnly && ctx.valueMapper)
        ]);
    }
}
function $f8ed024a6db1f9db$var$iterate(cursorPromise, filter, fn, valueMapper) {
    var mappedFn = valueMapper ? function(x, c, a) {
        return fn(valueMapper(x), c, a);
    } : fn;
    var wrappedFn = $f8ed024a6db1f9db$var$wrap(mappedFn);
    return cursorPromise.then(function(cursor) {
        if (cursor) return cursor.start(function() {
            var c = function() {
                return cursor.continue();
            };
            if (!filter || filter(cursor, function(advancer) {
                return c = advancer;
            }, function(val) {
                cursor.stop(val);
                c = $f8ed024a6db1f9db$var$nop;
            }, function(e) {
                cursor.fail(e);
                c = $f8ed024a6db1f9db$var$nop;
            })) wrappedFn(cursor.value, cursor, function(advancer) {
                return c = advancer;
            });
            c();
        });
    });
}
var $f8ed024a6db1f9db$export$4118fdb20badc28d = function() {
    function PropModification(spec) {
        this["@@propmod"] = spec;
    }
    PropModification.prototype.execute = function(value) {
        var _a;
        var spec = this["@@propmod"];
        if (spec.add !== undefined) {
            var term = spec.add;
            if ($f8ed024a6db1f9db$var$isArray(term)) return $f8ed024a6db1f9db$var$__spreadArray($f8ed024a6db1f9db$var$__spreadArray([], $f8ed024a6db1f9db$var$isArray(value) ? value : [], true), term, true).sort();
            if (typeof term === 'number') return (Number(value) || 0) + term;
            if (typeof term === 'bigint') try {
                return BigInt(value) + term;
            } catch (_b) {
                return BigInt(0) + term;
            }
            throw new TypeError("Invalid term ".concat(term));
        }
        if (spec.remove !== undefined) {
            var subtrahend_1 = spec.remove;
            if ($f8ed024a6db1f9db$var$isArray(subtrahend_1)) return $f8ed024a6db1f9db$var$isArray(value) ? value.filter(function(item) {
                return !subtrahend_1.includes(item);
            }).sort() : [];
            if (typeof subtrahend_1 === 'number') return Number(value) - subtrahend_1;
            if (typeof subtrahend_1 === 'bigint') try {
                return BigInt(value) - subtrahend_1;
            } catch (_c) {
                return BigInt(0) - subtrahend_1;
            }
            throw new TypeError("Invalid subtrahend ".concat(subtrahend_1));
        }
        var prefixToReplace = (_a = spec.replacePrefix) === null || _a === void 0 ? void 0 : _a[0];
        if (prefixToReplace && typeof value === 'string' && value.startsWith(prefixToReplace)) return spec.replacePrefix[1] + value.substring(prefixToReplace.length);
        return value;
    };
    return PropModification;
}();
var $f8ed024a6db1f9db$var$Collection = function() {
    function Collection() {}
    Collection.prototype._read = function(fn, cb) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, $f8ed024a6db1f9db$var$rejection.bind(null, ctx.error)) : ctx.table._trans('readonly', fn).then(cb);
    };
    Collection.prototype._write = function(fn) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, $f8ed024a6db1f9db$var$rejection.bind(null, ctx.error)) : ctx.table._trans('readwrite', fn, "locked");
    };
    Collection.prototype._addAlgorithm = function(fn) {
        var ctx = this._ctx;
        ctx.algorithm = $f8ed024a6db1f9db$var$combine(ctx.algorithm, fn);
    };
    Collection.prototype._iterate = function(fn, coreTrans) {
        return $f8ed024a6db1f9db$var$iter(this._ctx, fn, coreTrans, this._ctx.table.core);
    };
    Collection.prototype.clone = function(props) {
        var rv = Object.create(this.constructor.prototype), ctx = Object.create(this._ctx);
        if (props) $f8ed024a6db1f9db$var$extend(ctx, props);
        rv._ctx = ctx;
        return rv;
    };
    Collection.prototype.raw = function() {
        this._ctx.valueMapper = null;
        return this;
    };
    Collection.prototype.each = function(fn) {
        var ctx = this._ctx;
        return this._read(function(trans) {
            return $f8ed024a6db1f9db$var$iter(ctx, fn, trans, ctx.table.core);
        });
    };
    Collection.prototype.count = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            var coreTable = ctx.table.core;
            if ($f8ed024a6db1f9db$var$isPlainKeyRange(ctx, true)) return coreTable.count({
                trans: trans,
                query: {
                    index: $f8ed024a6db1f9db$var$getIndexOrStore(ctx, coreTable.schema),
                    range: ctx.range
                }
            }).then(function(count) {
                return Math.min(count, ctx.limit);
            });
            else {
                var count = 0;
                return $f8ed024a6db1f9db$var$iter(ctx, function() {
                    ++count;
                    return false;
                }, trans, coreTable).then(function() {
                    return count;
                });
            }
        }).then(cb);
    };
    Collection.prototype.sortBy = function(keyPath, cb) {
        var parts = keyPath.split('.').reverse(), lastPart = parts[0], lastIndex = parts.length - 1;
        function getval(obj, i) {
            if (i) return getval(obj[parts[i]], i - 1);
            return obj[lastPart];
        }
        var order = this._ctx.dir === "next" ? 1 : -1;
        function sorter(a, b) {
            var aVal = getval(a, lastIndex), bVal = getval(b, lastIndex);
            return $f8ed024a6db1f9db$export$6154dcdb7d23e37b(aVal, bVal) * order;
        }
        return this.toArray(function(a) {
            return a.sort(sorter);
        }).then(cb);
    };
    Collection.prototype.toArray = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            if (ctx.dir === 'next' && $f8ed024a6db1f9db$var$isPlainKeyRange(ctx, true) && ctx.limit > 0) {
                var valueMapper_1 = ctx.valueMapper;
                var index = $f8ed024a6db1f9db$var$getIndexOrStore(ctx, ctx.table.core.schema);
                return ctx.table.core.query({
                    trans: trans,
                    limit: ctx.limit,
                    values: true,
                    query: {
                        index: index,
                        range: ctx.range
                    }
                }).then(function(_a) {
                    var result = _a.result;
                    return valueMapper_1 ? result.map(valueMapper_1) : result;
                });
            } else {
                var a_1 = [];
                return $f8ed024a6db1f9db$var$iter(ctx, function(item) {
                    return a_1.push(item);
                }, trans, ctx.table.core).then(function() {
                    return a_1;
                });
            }
        }, cb);
    };
    Collection.prototype.offset = function(offset) {
        var ctx = this._ctx;
        if (offset <= 0) return this;
        ctx.offset += offset;
        if ($f8ed024a6db1f9db$var$isPlainKeyRange(ctx)) $f8ed024a6db1f9db$var$addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function(cursor, advance) {
                if (offsetLeft === 0) return true;
                if (offsetLeft === 1) {
                    --offsetLeft;
                    return false;
                }
                advance(function() {
                    cursor.advance(offsetLeft);
                    offsetLeft = 0;
                });
                return false;
            };
        });
        else $f8ed024a6db1f9db$var$addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function() {
                return --offsetLeft < 0;
            };
        });
        return this;
    };
    Collection.prototype.limit = function(numRows) {
        this._ctx.limit = Math.min(this._ctx.limit, numRows);
        $f8ed024a6db1f9db$var$addReplayFilter(this._ctx, function() {
            var rowsLeft = numRows;
            return function(cursor, advance, resolve) {
                if (--rowsLeft <= 0) advance(resolve);
                return rowsLeft >= 0;
            };
        }, true);
        return this;
    };
    Collection.prototype.until = function(filterFunction, bIncludeStopEntry) {
        $f8ed024a6db1f9db$var$addFilter(this._ctx, function(cursor, advance, resolve) {
            if (filterFunction(cursor.value)) {
                advance(resolve);
                return bIncludeStopEntry;
            } else return true;
        });
        return this;
    };
    Collection.prototype.first = function(cb) {
        return this.limit(1).toArray(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.last = function(cb) {
        return this.reverse().first(cb);
    };
    Collection.prototype.filter = function(filterFunction) {
        $f8ed024a6db1f9db$var$addFilter(this._ctx, function(cursor) {
            return filterFunction(cursor.value);
        });
        $f8ed024a6db1f9db$var$addMatchFilter(this._ctx, filterFunction);
        return this;
    };
    Collection.prototype.and = function(filter) {
        return this.filter(filter);
    };
    Collection.prototype.or = function(indexName) {
        return new this.db.WhereClause(this._ctx.table, indexName, this);
    };
    Collection.prototype.reverse = function() {
        this._ctx.dir = this._ctx.dir === "prev" ? "next" : "prev";
        if (this._ondirectionchange) this._ondirectionchange(this._ctx.dir);
        return this;
    };
    Collection.prototype.desc = function() {
        return this.reverse();
    };
    Collection.prototype.eachKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.key, cursor);
        });
    };
    Collection.prototype.eachUniqueKey = function(cb) {
        this._ctx.unique = "unique";
        return this.eachKey(cb);
    };
    Collection.prototype.eachPrimaryKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.primaryKey, cursor);
        });
    };
    Collection.prototype.keys = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.key);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.primaryKeys = function(cb) {
        var ctx = this._ctx;
        if (ctx.dir === 'next' && $f8ed024a6db1f9db$var$isPlainKeyRange(ctx, true) && ctx.limit > 0) return this._read(function(trans) {
            var index = $f8ed024a6db1f9db$var$getIndexOrStore(ctx, ctx.table.core.schema);
            return ctx.table.core.query({
                trans: trans,
                values: false,
                limit: ctx.limit,
                query: {
                    index: index,
                    range: ctx.range
                }
            });
        }).then(function(_a) {
            var result = _a.result;
            return result;
        }).then(cb);
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.primaryKey);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.uniqueKeys = function(cb) {
        this._ctx.unique = "unique";
        return this.keys(cb);
    };
    Collection.prototype.firstKey = function(cb) {
        return this.limit(1).keys(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.lastKey = function(cb) {
        return this.reverse().firstKey(cb);
    };
    Collection.prototype.distinct = function() {
        var ctx = this._ctx, idx = ctx.index && ctx.table.schema.idxByName[ctx.index];
        if (!idx || !idx.multi) return this;
        var set = {};
        $f8ed024a6db1f9db$var$addFilter(this._ctx, function(cursor) {
            var strKey = cursor.primaryKey.toString();
            var found = $f8ed024a6db1f9db$var$hasOwn(set, strKey);
            set[strKey] = true;
            return !found;
        });
        return this;
    };
    Collection.prototype.modify = function(changes) {
        var _this = this;
        var ctx = this._ctx;
        return this._write(function(trans) {
            var modifyer;
            if (typeof changes === 'function') modifyer = changes;
            else {
                var keyPaths = $f8ed024a6db1f9db$var$keys(changes);
                var numKeys = keyPaths.length;
                modifyer = function(item) {
                    var anythingModified = false;
                    for(var i = 0; i < numKeys; ++i){
                        var keyPath = keyPaths[i];
                        var val = changes[keyPath];
                        var origVal = $f8ed024a6db1f9db$var$getByKeyPath(item, keyPath);
                        if (val instanceof $f8ed024a6db1f9db$export$4118fdb20badc28d) {
                            $f8ed024a6db1f9db$var$setByKeyPath(item, keyPath, val.execute(origVal));
                            anythingModified = true;
                        } else if (origVal !== val) {
                            $f8ed024a6db1f9db$var$setByKeyPath(item, keyPath, val);
                            anythingModified = true;
                        }
                    }
                    return anythingModified;
                };
            }
            var coreTable = ctx.table.core;
            var _a = coreTable.schema.primaryKey, outbound = _a.outbound, extractKey = _a.extractKey;
            var limit = 200;
            var modifyChunkSize = _this.db._options.modifyChunkSize;
            if (modifyChunkSize) {
                if (typeof modifyChunkSize == 'object') limit = modifyChunkSize[coreTable.name] || modifyChunkSize['*'] || 200;
                else limit = modifyChunkSize;
            }
            var totalFailures = [];
            var successCount = 0;
            var failedKeys = [];
            var applyMutateResult = function(expectedCount, res) {
                var failures = res.failures, numFailures = res.numFailures;
                successCount += expectedCount - numFailures;
                for(var _i = 0, _a = $f8ed024a6db1f9db$var$keys(failures); _i < _a.length; _i++){
                    var pos = _a[_i];
                    totalFailures.push(failures[pos]);
                }
            };
            return _this.clone().primaryKeys().then(function(keys) {
                var criteria = $f8ed024a6db1f9db$var$isPlainKeyRange(ctx) && ctx.limit === Infinity && (typeof changes !== 'function' || changes === $f8ed024a6db1f9db$var$deleteCallback) && {
                    index: ctx.index,
                    range: ctx.range
                };
                var nextChunk = function(offset) {
                    var count = Math.min(limit, keys.length - offset);
                    return coreTable.getMany({
                        trans: trans,
                        keys: keys.slice(offset, offset + count),
                        cache: "immutable"
                    }).then(function(values) {
                        var addValues = [];
                        var putValues = [];
                        var putKeys = outbound ? [] : null;
                        var deleteKeys = [];
                        for(var i = 0; i < count; ++i){
                            var origValue = values[i];
                            var ctx_1 = {
                                value: $f8ed024a6db1f9db$var$deepClone(origValue),
                                primKey: keys[offset + i]
                            };
                            if (modifyer.call(ctx_1, ctx_1.value, ctx_1) !== false) {
                                if (ctx_1.value == null) deleteKeys.push(keys[offset + i]);
                                else if (!outbound && $f8ed024a6db1f9db$export$6154dcdb7d23e37b(extractKey(origValue), extractKey(ctx_1.value)) !== 0) {
                                    deleteKeys.push(keys[offset + i]);
                                    addValues.push(ctx_1.value);
                                } else {
                                    putValues.push(ctx_1.value);
                                    if (outbound) putKeys.push(keys[offset + i]);
                                }
                            }
                        }
                        return Promise.resolve(addValues.length > 0 && coreTable.mutate({
                            trans: trans,
                            type: 'add',
                            values: addValues
                        }).then(function(res) {
                            for(var pos in res.failures)deleteKeys.splice(parseInt(pos), 1);
                            applyMutateResult(addValues.length, res);
                        })).then(function() {
                            return (putValues.length > 0 || criteria && typeof changes === 'object') && coreTable.mutate({
                                trans: trans,
                                type: 'put',
                                keys: putKeys,
                                values: putValues,
                                criteria: criteria,
                                changeSpec: typeof changes !== 'function' && changes,
                                isAdditionalChunk: offset > 0
                            }).then(function(res) {
                                return applyMutateResult(putValues.length, res);
                            });
                        }).then(function() {
                            return (deleteKeys.length > 0 || criteria && changes === $f8ed024a6db1f9db$var$deleteCallback) && coreTable.mutate({
                                trans: trans,
                                type: 'delete',
                                keys: deleteKeys,
                                criteria: criteria,
                                isAdditionalChunk: offset > 0
                            }).then(function(res) {
                                return applyMutateResult(deleteKeys.length, res);
                            });
                        }).then(function() {
                            return keys.length > offset + count && nextChunk(offset + limit);
                        });
                    });
                };
                return nextChunk(0).then(function() {
                    if (totalFailures.length > 0) throw new $f8ed024a6db1f9db$var$ModifyError("Error modifying one or more objects", totalFailures, successCount, failedKeys);
                    return keys.length;
                });
            });
        });
    };
    Collection.prototype.delete = function() {
        var ctx = this._ctx, range = ctx.range;
        if ($f8ed024a6db1f9db$var$isPlainKeyRange(ctx) && (ctx.isPrimKey || range.type === 3)) return this._write(function(trans) {
            var primaryKey = ctx.table.core.schema.primaryKey;
            var coreRange = range;
            return ctx.table.core.count({
                trans: trans,
                query: {
                    index: primaryKey,
                    range: coreRange
                }
            }).then(function(count) {
                return ctx.table.core.mutate({
                    trans: trans,
                    type: 'deleteRange',
                    range: coreRange
                }).then(function(_a) {
                    var failures = _a.failures;
                    _a.lastResult;
                    _a.results;
                    var numFailures = _a.numFailures;
                    if (numFailures) throw new $f8ed024a6db1f9db$var$ModifyError("Could not delete some values", Object.keys(failures).map(function(pos) {
                        return failures[pos];
                    }), count - numFailures);
                    return count - numFailures;
                });
            });
        });
        return this.modify($f8ed024a6db1f9db$var$deleteCallback);
    };
    return Collection;
}();
var $f8ed024a6db1f9db$var$deleteCallback = function(value, ctx) {
    return ctx.value = null;
};
function $f8ed024a6db1f9db$var$createCollectionConstructor(db) {
    return $f8ed024a6db1f9db$var$makeClassConstructor($f8ed024a6db1f9db$var$Collection.prototype, function Collection(whereClause, keyRangeGenerator) {
        this.db = db;
        var keyRange = $f8ed024a6db1f9db$var$AnyRange, error = null;
        if (keyRangeGenerator) try {
            keyRange = keyRangeGenerator();
        } catch (ex) {
            error = ex;
        }
        var whereCtx = whereClause._ctx;
        var table = whereCtx.table;
        var readingHook = table.hook.reading.fire;
        this._ctx = {
            table: table,
            index: whereCtx.index,
            isPrimKey: !whereCtx.index || table.schema.primKey.keyPath && whereCtx.index === table.schema.primKey.name,
            range: keyRange,
            keysOnly: false,
            dir: "next",
            unique: "",
            algorithm: null,
            filter: null,
            replayFilter: null,
            justLimit: true,
            isMatch: null,
            offset: 0,
            limit: Infinity,
            error: error,
            or: whereCtx.or,
            valueMapper: readingHook !== $f8ed024a6db1f9db$var$mirror ? readingHook : null
        };
    });
}
function $f8ed024a6db1f9db$var$simpleCompare(a, b) {
    return a < b ? -1 : a === b ? 0 : 1;
}
function $f8ed024a6db1f9db$var$simpleCompareReverse(a, b) {
    return a > b ? -1 : a === b ? 0 : 1;
}
function $f8ed024a6db1f9db$var$fail(collectionOrWhereClause, err, T) {
    var collection = collectionOrWhereClause instanceof $f8ed024a6db1f9db$var$WhereClause ? new collectionOrWhereClause.Collection(collectionOrWhereClause) : collectionOrWhereClause;
    collection._ctx.error = T ? new T(err) : new TypeError(err);
    return collection;
}
function $f8ed024a6db1f9db$var$emptyCollection(whereClause) {
    return new whereClause.Collection(whereClause, function() {
        return $f8ed024a6db1f9db$var$rangeEqual("");
    }).limit(0);
}
function $f8ed024a6db1f9db$var$upperFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toUpperCase();
    } : function(s) {
        return s.toLowerCase();
    };
}
function $f8ed024a6db1f9db$var$lowerFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toLowerCase();
    } : function(s) {
        return s.toUpperCase();
    };
}
function $f8ed024a6db1f9db$var$nextCasing(key, lowerKey, upperNeedle, lowerNeedle, cmp, dir) {
    var length = Math.min(key.length, lowerNeedle.length);
    var llp = -1;
    for(var i = 0; i < length; ++i){
        var lwrKeyChar = lowerKey[i];
        if (lwrKeyChar !== lowerNeedle[i]) {
            if (cmp(key[i], upperNeedle[i]) < 0) return key.substr(0, i) + upperNeedle[i] + upperNeedle.substr(i + 1);
            if (cmp(key[i], lowerNeedle[i]) < 0) return key.substr(0, i) + lowerNeedle[i] + upperNeedle.substr(i + 1);
            if (llp >= 0) return key.substr(0, llp) + lowerKey[llp] + upperNeedle.substr(llp + 1);
            return null;
        }
        if (cmp(key[i], lwrKeyChar) < 0) llp = i;
    }
    if (length < lowerNeedle.length && dir === "next") return key + upperNeedle.substr(key.length);
    if (length < key.length && dir === "prev") return key.substr(0, upperNeedle.length);
    return llp < 0 ? null : key.substr(0, llp) + lowerNeedle[llp] + upperNeedle.substr(llp + 1);
}
function $f8ed024a6db1f9db$var$addIgnoreCaseAlgorithm(whereClause, match, needles, suffix) {
    var upper, lower, compare, upperNeedles, lowerNeedles, direction, nextKeySuffix, needlesLen = needles.length;
    if (!needles.every(function(s) {
        return typeof s === 'string';
    })) return $f8ed024a6db1f9db$var$fail(whereClause, $f8ed024a6db1f9db$var$STRING_EXPECTED);
    function initDirection(dir) {
        upper = $f8ed024a6db1f9db$var$upperFactory(dir);
        lower = $f8ed024a6db1f9db$var$lowerFactory(dir);
        compare = dir === "next" ? $f8ed024a6db1f9db$var$simpleCompare : $f8ed024a6db1f9db$var$simpleCompareReverse;
        var needleBounds = needles.map(function(needle) {
            return {
                lower: lower(needle),
                upper: upper(needle)
            };
        }).sort(function(a, b) {
            return compare(a.lower, b.lower);
        });
        upperNeedles = needleBounds.map(function(nb) {
            return nb.upper;
        });
        lowerNeedles = needleBounds.map(function(nb) {
            return nb.lower;
        });
        direction = dir;
        nextKeySuffix = dir === "next" ? "" : suffix;
    }
    initDirection("next");
    var c = new whereClause.Collection(whereClause, function() {
        return $f8ed024a6db1f9db$var$createRange(upperNeedles[0], lowerNeedles[needlesLen - 1] + suffix);
    });
    c._ondirectionchange = function(direction) {
        initDirection(direction);
    };
    var firstPossibleNeedle = 0;
    c._addAlgorithm(function(cursor, advance, resolve) {
        var key = cursor.key;
        if (typeof key !== 'string') return false;
        var lowerKey = lower(key);
        if (match(lowerKey, lowerNeedles, firstPossibleNeedle)) return true;
        else {
            var lowestPossibleCasing = null;
            for(var i = firstPossibleNeedle; i < needlesLen; ++i){
                var casing = $f8ed024a6db1f9db$var$nextCasing(key, lowerKey, upperNeedles[i], lowerNeedles[i], compare, direction);
                if (casing === null && lowestPossibleCasing === null) firstPossibleNeedle = i + 1;
                else if (lowestPossibleCasing === null || compare(lowestPossibleCasing, casing) > 0) lowestPossibleCasing = casing;
            }
            if (lowestPossibleCasing !== null) advance(function() {
                cursor.continue(lowestPossibleCasing + nextKeySuffix);
            });
            else advance(resolve);
            return false;
        }
    });
    return c;
}
function $f8ed024a6db1f9db$var$createRange(lower, upper, lowerOpen, upperOpen) {
    return {
        type: 2,
        lower: lower,
        upper: upper,
        lowerOpen: lowerOpen,
        upperOpen: upperOpen
    };
}
function $f8ed024a6db1f9db$var$rangeEqual(value) {
    return {
        type: 1,
        lower: value,
        upper: value
    };
}
var $f8ed024a6db1f9db$var$WhereClause = function() {
    function WhereClause() {}
    Object.defineProperty(WhereClause.prototype, "Collection", {
        get: function() {
            return this._ctx.table.db.Collection;
        },
        enumerable: false,
        configurable: true
    });
    WhereClause.prototype.between = function(lower, upper, includeLower, includeUpper) {
        includeLower = includeLower !== false;
        includeUpper = includeUpper === true;
        try {
            if (this._cmp(lower, upper) > 0 || this._cmp(lower, upper) === 0 && (includeLower || includeUpper) && !(includeLower && includeUpper)) return $f8ed024a6db1f9db$var$emptyCollection(this);
            return new this.Collection(this, function() {
                return $f8ed024a6db1f9db$var$createRange(lower, upper, !includeLower, !includeUpper);
            });
        } catch (e) {
            return $f8ed024a6db1f9db$var$fail(this, $f8ed024a6db1f9db$var$INVALID_KEY_ARGUMENT);
        }
    };
    WhereClause.prototype.equals = function(value) {
        if (value == null) return $f8ed024a6db1f9db$var$fail(this, $f8ed024a6db1f9db$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $f8ed024a6db1f9db$var$rangeEqual(value);
        });
    };
    WhereClause.prototype.above = function(value) {
        if (value == null) return $f8ed024a6db1f9db$var$fail(this, $f8ed024a6db1f9db$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $f8ed024a6db1f9db$var$createRange(value, undefined, true);
        });
    };
    WhereClause.prototype.aboveOrEqual = function(value) {
        if (value == null) return $f8ed024a6db1f9db$var$fail(this, $f8ed024a6db1f9db$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $f8ed024a6db1f9db$var$createRange(value, undefined, false);
        });
    };
    WhereClause.prototype.below = function(value) {
        if (value == null) return $f8ed024a6db1f9db$var$fail(this, $f8ed024a6db1f9db$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $f8ed024a6db1f9db$var$createRange(undefined, value, false, true);
        });
    };
    WhereClause.prototype.belowOrEqual = function(value) {
        if (value == null) return $f8ed024a6db1f9db$var$fail(this, $f8ed024a6db1f9db$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $f8ed024a6db1f9db$var$createRange(undefined, value);
        });
    };
    WhereClause.prototype.startsWith = function(str) {
        if (typeof str !== 'string') return $f8ed024a6db1f9db$var$fail(this, $f8ed024a6db1f9db$var$STRING_EXPECTED);
        return this.between(str, str + $f8ed024a6db1f9db$var$maxString, true, true);
    };
    WhereClause.prototype.startsWithIgnoreCase = function(str) {
        if (str === "") return this.startsWith(str);
        return $f8ed024a6db1f9db$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return x.indexOf(a[0]) === 0;
        }, [
            str
        ], $f8ed024a6db1f9db$var$maxString);
    };
    WhereClause.prototype.equalsIgnoreCase = function(str) {
        return $f8ed024a6db1f9db$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return x === a[0];
        }, [
            str
        ], "");
    };
    WhereClause.prototype.anyOfIgnoreCase = function() {
        var set = $f8ed024a6db1f9db$var$getArrayOf.apply($f8ed024a6db1f9db$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return $f8ed024a6db1f9db$var$emptyCollection(this);
        return $f8ed024a6db1f9db$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.indexOf(x) !== -1;
        }, set, "");
    };
    WhereClause.prototype.startsWithAnyOfIgnoreCase = function() {
        var set = $f8ed024a6db1f9db$var$getArrayOf.apply($f8ed024a6db1f9db$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return $f8ed024a6db1f9db$var$emptyCollection(this);
        return $f8ed024a6db1f9db$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.some(function(n) {
                return x.indexOf(n) === 0;
            });
        }, set, $f8ed024a6db1f9db$var$maxString);
    };
    WhereClause.prototype.anyOf = function() {
        var _this = this;
        var set = $f8ed024a6db1f9db$var$getArrayOf.apply($f8ed024a6db1f9db$var$NO_CHAR_ARRAY, arguments);
        var compare = this._cmp;
        try {
            set.sort(compare);
        } catch (e) {
            return $f8ed024a6db1f9db$var$fail(this, $f8ed024a6db1f9db$var$INVALID_KEY_ARGUMENT);
        }
        if (set.length === 0) return $f8ed024a6db1f9db$var$emptyCollection(this);
        var c = new this.Collection(this, function() {
            return $f8ed024a6db1f9db$var$createRange(set[0], set[set.length - 1]);
        });
        c._ondirectionchange = function(direction) {
            compare = direction === "next" ? _this._ascending : _this._descending;
            set.sort(compare);
        };
        var i = 0;
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(compare(key, set[i]) > 0){
                ++i;
                if (i === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (compare(key, set[i]) === 0) return true;
            else {
                advance(function() {
                    cursor.continue(set[i]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.notEqual = function(value) {
        return this.inAnyRange([
            [
                $f8ed024a6db1f9db$var$minKey,
                value
            ],
            [
                value,
                this.db._maxKey
            ]
        ], {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.noneOf = function() {
        var set = $f8ed024a6db1f9db$var$getArrayOf.apply($f8ed024a6db1f9db$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return new this.Collection(this);
        try {
            set.sort(this._ascending);
        } catch (e) {
            return $f8ed024a6db1f9db$var$fail(this, $f8ed024a6db1f9db$var$INVALID_KEY_ARGUMENT);
        }
        var ranges = set.reduce(function(res, val) {
            return res ? res.concat([
                [
                    res[res.length - 1][1],
                    val
                ]
            ]) : [
                [
                    $f8ed024a6db1f9db$var$minKey,
                    val
                ]
            ];
        }, null);
        ranges.push([
            set[set.length - 1],
            this.db._maxKey
        ]);
        return this.inAnyRange(ranges, {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.inAnyRange = function(ranges, options) {
        var _this = this;
        var cmp = this._cmp, ascending = this._ascending, descending = this._descending, min = this._min, max = this._max;
        if (ranges.length === 0) return $f8ed024a6db1f9db$var$emptyCollection(this);
        if (!ranges.every(function(range) {
            return range[0] !== undefined && range[1] !== undefined && ascending(range[0], range[1]) <= 0;
        })) return $f8ed024a6db1f9db$var$fail(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", $f8ed024a6db1f9db$var$exceptions.InvalidArgument);
        var includeLowers = !options || options.includeLowers !== false;
        var includeUppers = options && options.includeUppers === true;
        function addRange(ranges, newRange) {
            var i = 0, l = ranges.length;
            for(; i < l; ++i){
                var range = ranges[i];
                if (cmp(newRange[0], range[1]) < 0 && cmp(newRange[1], range[0]) > 0) {
                    range[0] = min(range[0], newRange[0]);
                    range[1] = max(range[1], newRange[1]);
                    break;
                }
            }
            if (i === l) ranges.push(newRange);
            return ranges;
        }
        var sortDirection = ascending;
        function rangeSorter(a, b) {
            return sortDirection(a[0], b[0]);
        }
        var set;
        try {
            set = ranges.reduce(addRange, []);
            set.sort(rangeSorter);
        } catch (ex) {
            return $f8ed024a6db1f9db$var$fail(this, $f8ed024a6db1f9db$var$INVALID_KEY_ARGUMENT);
        }
        var rangePos = 0;
        var keyIsBeyondCurrentEntry = includeUppers ? function(key) {
            return ascending(key, set[rangePos][1]) > 0;
        } : function(key) {
            return ascending(key, set[rangePos][1]) >= 0;
        };
        var keyIsBeforeCurrentEntry = includeLowers ? function(key) {
            return descending(key, set[rangePos][0]) > 0;
        } : function(key) {
            return descending(key, set[rangePos][0]) >= 0;
        };
        function keyWithinCurrentRange(key) {
            return !keyIsBeyondCurrentEntry(key) && !keyIsBeforeCurrentEntry(key);
        }
        var checkKey = keyIsBeyondCurrentEntry;
        var c = new this.Collection(this, function() {
            return $f8ed024a6db1f9db$var$createRange(set[0][0], set[set.length - 1][1], !includeLowers, !includeUppers);
        });
        c._ondirectionchange = function(direction) {
            if (direction === "next") {
                checkKey = keyIsBeyondCurrentEntry;
                sortDirection = ascending;
            } else {
                checkKey = keyIsBeforeCurrentEntry;
                sortDirection = descending;
            }
            set.sort(rangeSorter);
        };
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(checkKey(key)){
                ++rangePos;
                if (rangePos === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (keyWithinCurrentRange(key)) return true;
            else if (_this._cmp(key, set[rangePos][1]) === 0 || _this._cmp(key, set[rangePos][0]) === 0) return false;
            else {
                advance(function() {
                    if (sortDirection === ascending) cursor.continue(set[rangePos][0]);
                    else cursor.continue(set[rangePos][1]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.startsWithAnyOf = function() {
        var set = $f8ed024a6db1f9db$var$getArrayOf.apply($f8ed024a6db1f9db$var$NO_CHAR_ARRAY, arguments);
        if (!set.every(function(s) {
            return typeof s === 'string';
        })) return $f8ed024a6db1f9db$var$fail(this, "startsWithAnyOf() only works with strings");
        if (set.length === 0) return $f8ed024a6db1f9db$var$emptyCollection(this);
        return this.inAnyRange(set.map(function(str) {
            return [
                str,
                str + $f8ed024a6db1f9db$var$maxString
            ];
        }));
    };
    return WhereClause;
}();
function $f8ed024a6db1f9db$var$createWhereClauseConstructor(db) {
    return $f8ed024a6db1f9db$var$makeClassConstructor($f8ed024a6db1f9db$var$WhereClause.prototype, function WhereClause(table, index, orCollection) {
        this.db = db;
        this._ctx = {
            table: table,
            index: index === ":id" ? null : index,
            or: orCollection
        };
        this._cmp = this._ascending = $f8ed024a6db1f9db$export$6154dcdb7d23e37b;
        this._descending = function(a, b) {
            return $f8ed024a6db1f9db$export$6154dcdb7d23e37b(b, a);
        };
        this._max = function(a, b) {
            return $f8ed024a6db1f9db$export$6154dcdb7d23e37b(a, b) > 0 ? a : b;
        };
        this._min = function(a, b) {
            return $f8ed024a6db1f9db$export$6154dcdb7d23e37b(a, b) < 0 ? a : b;
        };
        this._IDBKeyRange = db._deps.IDBKeyRange;
        if (!this._IDBKeyRange) throw new $f8ed024a6db1f9db$var$exceptions.MissingAPI();
    });
}
function $f8ed024a6db1f9db$var$eventRejectHandler(reject) {
    return $f8ed024a6db1f9db$var$wrap(function(event) {
        $f8ed024a6db1f9db$var$preventDefault(event);
        reject(event.target.error);
        return false;
    });
}
function $f8ed024a6db1f9db$var$preventDefault(event) {
    if (event.stopPropagation) event.stopPropagation();
    if (event.preventDefault) event.preventDefault();
}
var $f8ed024a6db1f9db$var$DEXIE_STORAGE_MUTATED_EVENT_NAME = 'storagemutated';
var $f8ed024a6db1f9db$var$STORAGE_MUTATED_DOM_EVENT_NAME = 'x-storagemutated-1';
var $f8ed024a6db1f9db$var$globalEvents = $f8ed024a6db1f9db$var$Events(null, $f8ed024a6db1f9db$var$DEXIE_STORAGE_MUTATED_EVENT_NAME);
var $f8ed024a6db1f9db$var$Transaction = function() {
    function Transaction() {}
    Transaction.prototype._lock = function() {
        $f8ed024a6db1f9db$var$assert(!$f8ed024a6db1f9db$var$PSD.global);
        ++this._reculock;
        if (this._reculock === 1 && !$f8ed024a6db1f9db$var$PSD.global) $f8ed024a6db1f9db$var$PSD.lockOwnerFor = this;
        return this;
    };
    Transaction.prototype._unlock = function() {
        $f8ed024a6db1f9db$var$assert(!$f8ed024a6db1f9db$var$PSD.global);
        if (--this._reculock === 0) {
            if (!$f8ed024a6db1f9db$var$PSD.global) $f8ed024a6db1f9db$var$PSD.lockOwnerFor = null;
            while(this._blockedFuncs.length > 0 && !this._locked()){
                var fnAndPSD = this._blockedFuncs.shift();
                try {
                    $f8ed024a6db1f9db$var$usePSD(fnAndPSD[1], fnAndPSD[0]);
                } catch (e) {}
            }
        }
        return this;
    };
    Transaction.prototype._locked = function() {
        return this._reculock && $f8ed024a6db1f9db$var$PSD.lockOwnerFor !== this;
    };
    Transaction.prototype.create = function(idbtrans) {
        var _this = this;
        if (!this.mode) return this;
        var idbdb = this.db.idbdb;
        var dbOpenError = this.db._state.dbOpenError;
        $f8ed024a6db1f9db$var$assert(!this.idbtrans);
        if (!idbtrans && !idbdb) switch(dbOpenError && dbOpenError.name){
            case "DatabaseClosedError":
                throw new $f8ed024a6db1f9db$var$exceptions.DatabaseClosed(dbOpenError);
            case "MissingAPIError":
                throw new $f8ed024a6db1f9db$var$exceptions.MissingAPI(dbOpenError.message, dbOpenError);
            default:
                throw new $f8ed024a6db1f9db$var$exceptions.OpenFailed(dbOpenError);
        }
        if (!this.active) throw new $f8ed024a6db1f9db$var$exceptions.TransactionInactive();
        $f8ed024a6db1f9db$var$assert(this._completion._state === null);
        idbtrans = this.idbtrans = idbtrans || (this.db.core ? this.db.core.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }) : idbdb.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }));
        idbtrans.onerror = $f8ed024a6db1f9db$var$wrap(function(ev) {
            $f8ed024a6db1f9db$var$preventDefault(ev);
            _this._reject(idbtrans.error);
        });
        idbtrans.onabort = $f8ed024a6db1f9db$var$wrap(function(ev) {
            $f8ed024a6db1f9db$var$preventDefault(ev);
            _this.active && _this._reject(new $f8ed024a6db1f9db$var$exceptions.Abort(idbtrans.error));
            _this.active = false;
            _this.on("abort").fire(ev);
        });
        idbtrans.oncomplete = $f8ed024a6db1f9db$var$wrap(function() {
            _this.active = false;
            _this._resolve();
            if ('mutatedParts' in idbtrans) $f8ed024a6db1f9db$var$globalEvents.storagemutated.fire(idbtrans["mutatedParts"]);
        });
        return this;
    };
    Transaction.prototype._promise = function(mode, fn, bWriteLock) {
        var _this = this;
        if (mode === 'readwrite' && this.mode !== 'readwrite') return $f8ed024a6db1f9db$var$rejection(new $f8ed024a6db1f9db$var$exceptions.ReadOnly("Transaction is readonly"));
        if (!this.active) return $f8ed024a6db1f9db$var$rejection(new $f8ed024a6db1f9db$var$exceptions.TransactionInactive());
        if (this._locked()) return new $f8ed024a6db1f9db$var$DexiePromise(function(resolve, reject) {
            _this._blockedFuncs.push([
                function() {
                    _this._promise(mode, fn, bWriteLock).then(resolve, reject);
                },
                $f8ed024a6db1f9db$var$PSD
            ]);
        });
        else if (bWriteLock) return $f8ed024a6db1f9db$var$newScope(function() {
            var p = new $f8ed024a6db1f9db$var$DexiePromise(function(resolve, reject) {
                _this._lock();
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p.finally(function() {
                return _this._unlock();
            });
            p._lib = true;
            return p;
        });
        else {
            var p = new $f8ed024a6db1f9db$var$DexiePromise(function(resolve, reject) {
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p._lib = true;
            return p;
        }
    };
    Transaction.prototype._root = function() {
        return this.parent ? this.parent._root() : this;
    };
    Transaction.prototype.waitFor = function(promiseLike) {
        var root = this._root();
        var promise = $f8ed024a6db1f9db$var$DexiePromise.resolve(promiseLike);
        if (root._waitingFor) root._waitingFor = root._waitingFor.then(function() {
            return promise;
        });
        else {
            root._waitingFor = promise;
            root._waitingQueue = [];
            var store = root.idbtrans.objectStore(root.storeNames[0]);
            (function spin() {
                ++root._spinCount;
                while(root._waitingQueue.length)root._waitingQueue.shift()();
                if (root._waitingFor) store.get(-Infinity).onsuccess = spin;
            })();
        }
        var currentWaitPromise = root._waitingFor;
        return new $f8ed024a6db1f9db$var$DexiePromise(function(resolve, reject) {
            promise.then(function(res) {
                return root._waitingQueue.push($f8ed024a6db1f9db$var$wrap(resolve.bind(null, res)));
            }, function(err) {
                return root._waitingQueue.push($f8ed024a6db1f9db$var$wrap(reject.bind(null, err)));
            }).finally(function() {
                if (root._waitingFor === currentWaitPromise) root._waitingFor = null;
            });
        });
    };
    Transaction.prototype.abort = function() {
        if (this.active) {
            this.active = false;
            if (this.idbtrans) this.idbtrans.abort();
            this._reject(new $f8ed024a6db1f9db$var$exceptions.Abort());
        }
    };
    Transaction.prototype.table = function(tableName) {
        var memoizedTables = this._memoizedTables || (this._memoizedTables = {});
        if ($f8ed024a6db1f9db$var$hasOwn(memoizedTables, tableName)) return memoizedTables[tableName];
        var tableSchema = this.schema[tableName];
        if (!tableSchema) throw new $f8ed024a6db1f9db$var$exceptions.NotFound("Table " + tableName + " not part of transaction");
        var transactionBoundTable = new this.db.Table(tableName, tableSchema, this);
        transactionBoundTable.core = this.db.core.table(tableName);
        memoizedTables[tableName] = transactionBoundTable;
        return transactionBoundTable;
    };
    return Transaction;
}();
function $f8ed024a6db1f9db$var$createTransactionConstructor(db) {
    return $f8ed024a6db1f9db$var$makeClassConstructor($f8ed024a6db1f9db$var$Transaction.prototype, function Transaction(mode, storeNames, dbschema, chromeTransactionDurability, parent) {
        var _this = this;
        this.db = db;
        this.mode = mode;
        this.storeNames = storeNames;
        this.schema = dbschema;
        this.chromeTransactionDurability = chromeTransactionDurability;
        this.idbtrans = null;
        this.on = $f8ed024a6db1f9db$var$Events(this, "complete", "error", "abort");
        this.parent = parent || null;
        this.active = true;
        this._reculock = 0;
        this._blockedFuncs = [];
        this._resolve = null;
        this._reject = null;
        this._waitingFor = null;
        this._waitingQueue = null;
        this._spinCount = 0;
        this._completion = new $f8ed024a6db1f9db$var$DexiePromise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
        this._completion.then(function() {
            _this.active = false;
            _this.on.complete.fire();
        }, function(e) {
            var wasActive = _this.active;
            _this.active = false;
            _this.on.error.fire(e);
            _this.parent ? _this.parent._reject(e) : wasActive && _this.idbtrans && _this.idbtrans.abort();
            return $f8ed024a6db1f9db$var$rejection(e);
        });
    });
}
function $f8ed024a6db1f9db$var$createIndexSpec(name, keyPath, unique, multi, auto, compound, isPrimKey) {
    return {
        name: name,
        keyPath: keyPath,
        unique: unique,
        multi: multi,
        auto: auto,
        compound: compound,
        src: (unique && !isPrimKey ? '&' : '') + (multi ? '*' : '') + (auto ? "++" : "") + $f8ed024a6db1f9db$var$nameFromKeyPath(keyPath)
    };
}
function $f8ed024a6db1f9db$var$nameFromKeyPath(keyPath) {
    return typeof keyPath === 'string' ? keyPath : keyPath ? '[' + [].join.call(keyPath, '+') + ']' : "";
}
function $f8ed024a6db1f9db$var$createTableSchema(name, primKey, indexes) {
    return {
        name: name,
        primKey: primKey,
        indexes: indexes,
        mappedClass: null,
        idxByName: $f8ed024a6db1f9db$var$arrayToObject(indexes, function(index) {
            return [
                index.name,
                index
            ];
        })
    };
}
function $f8ed024a6db1f9db$var$safariMultiStoreFix(storeNames) {
    return storeNames.length === 1 ? storeNames[0] : storeNames;
}
var $f8ed024a6db1f9db$var$getMaxKey = function(IdbKeyRange) {
    try {
        IdbKeyRange.only([
            []
        ]);
        $f8ed024a6db1f9db$var$getMaxKey = function() {
            return [
                []
            ];
        };
        return [
            []
        ];
    } catch (e) {
        $f8ed024a6db1f9db$var$getMaxKey = function() {
            return $f8ed024a6db1f9db$var$maxString;
        };
        return $f8ed024a6db1f9db$var$maxString;
    }
};
function $f8ed024a6db1f9db$var$getKeyExtractor(keyPath) {
    if (keyPath == null) return function() {
        return undefined;
    };
    else if (typeof keyPath === 'string') return $f8ed024a6db1f9db$var$getSinglePathKeyExtractor(keyPath);
    else return function(obj) {
        return $f8ed024a6db1f9db$var$getByKeyPath(obj, keyPath);
    };
}
function $f8ed024a6db1f9db$var$getSinglePathKeyExtractor(keyPath) {
    var split = keyPath.split('.');
    if (split.length === 1) return function(obj) {
        return obj[keyPath];
    };
    else return function(obj) {
        return $f8ed024a6db1f9db$var$getByKeyPath(obj, keyPath);
    };
}
function $f8ed024a6db1f9db$var$arrayify(arrayLike) {
    return [].slice.call(arrayLike);
}
var $f8ed024a6db1f9db$var$_id_counter = 0;
function $f8ed024a6db1f9db$var$getKeyPathAlias(keyPath) {
    return keyPath == null ? ":id" : typeof keyPath === 'string' ? keyPath : "[".concat(keyPath.join('+'), "]");
}
function $f8ed024a6db1f9db$var$createDBCore(db, IdbKeyRange, tmpTrans) {
    function extractSchema(db, trans) {
        var tables = $f8ed024a6db1f9db$var$arrayify(db.objectStoreNames);
        return {
            schema: {
                name: db.name,
                tables: tables.map(function(table) {
                    return trans.objectStore(table);
                }).map(function(store) {
                    var keyPath = store.keyPath, autoIncrement = store.autoIncrement;
                    var compound = $f8ed024a6db1f9db$var$isArray(keyPath);
                    var outbound = keyPath == null;
                    var indexByKeyPath = {};
                    var result = {
                        name: store.name,
                        primaryKey: {
                            name: null,
                            isPrimaryKey: true,
                            outbound: outbound,
                            compound: compound,
                            keyPath: keyPath,
                            autoIncrement: autoIncrement,
                            unique: true,
                            extractKey: $f8ed024a6db1f9db$var$getKeyExtractor(keyPath)
                        },
                        indexes: $f8ed024a6db1f9db$var$arrayify(store.indexNames).map(function(indexName) {
                            return store.index(indexName);
                        }).map(function(index) {
                            var name = index.name, unique = index.unique, multiEntry = index.multiEntry, keyPath = index.keyPath;
                            var compound = $f8ed024a6db1f9db$var$isArray(keyPath);
                            var result = {
                                name: name,
                                compound: compound,
                                keyPath: keyPath,
                                unique: unique,
                                multiEntry: multiEntry,
                                extractKey: $f8ed024a6db1f9db$var$getKeyExtractor(keyPath)
                            };
                            indexByKeyPath[$f8ed024a6db1f9db$var$getKeyPathAlias(keyPath)] = result;
                            return result;
                        }),
                        getIndexByKeyPath: function(keyPath) {
                            return indexByKeyPath[$f8ed024a6db1f9db$var$getKeyPathAlias(keyPath)];
                        }
                    };
                    indexByKeyPath[":id"] = result.primaryKey;
                    if (keyPath != null) indexByKeyPath[$f8ed024a6db1f9db$var$getKeyPathAlias(keyPath)] = result.primaryKey;
                    return result;
                })
            },
            hasGetAll: tables.length > 0 && 'getAll' in trans.objectStore(tables[0]) && !(typeof navigator !== 'undefined' && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604)
        };
    }
    function makeIDBKeyRange(range) {
        if (range.type === 3) return null;
        if (range.type === 4) throw new Error("Cannot convert never type to IDBKeyRange");
        var lower = range.lower, upper = range.upper, lowerOpen = range.lowerOpen, upperOpen = range.upperOpen;
        var idbRange = lower === undefined ? upper === undefined ? null : IdbKeyRange.upperBound(upper, !!upperOpen) : upper === undefined ? IdbKeyRange.lowerBound(lower, !!lowerOpen) : IdbKeyRange.bound(lower, upper, !!lowerOpen, !!upperOpen);
        return idbRange;
    }
    function createDbCoreTable(tableSchema) {
        var tableName = tableSchema.name;
        function mutate(_a) {
            var trans = _a.trans, type = _a.type, keys = _a.keys, values = _a.values, range = _a.range;
            return new Promise(function(resolve, reject) {
                resolve = $f8ed024a6db1f9db$var$wrap(resolve);
                var store = trans.objectStore(tableName);
                var outbound = store.keyPath == null;
                var isAddOrPut = type === "put" || type === "add";
                if (!isAddOrPut && type !== 'delete' && type !== 'deleteRange') throw new Error("Invalid operation type: " + type);
                var length = (keys || values || {
                    length: 1
                }).length;
                if (keys && values && keys.length !== values.length) throw new Error("Given keys array must have same length as given values array.");
                if (length === 0) return resolve({
                    numFailures: 0,
                    failures: {},
                    results: [],
                    lastResult: undefined
                });
                var req;
                var reqs = [];
                var failures = [];
                var numFailures = 0;
                var errorHandler = function(event) {
                    ++numFailures;
                    $f8ed024a6db1f9db$var$preventDefault(event);
                };
                if (type === 'deleteRange') {
                    if (range.type === 4) return resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: [],
                        lastResult: undefined
                    });
                    if (range.type === 3) reqs.push(req = store.clear());
                    else reqs.push(req = store.delete(makeIDBKeyRange(range)));
                } else {
                    var _a = isAddOrPut ? outbound ? [
                        values,
                        keys
                    ] : [
                        values,
                        null
                    ] : [
                        keys,
                        null
                    ], args1 = _a[0], args2 = _a[1];
                    if (isAddOrPut) for(var i = 0; i < length; ++i){
                        reqs.push(req = args2 && args2[i] !== undefined ? store[type](args1[i], args2[i]) : store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                    else for(var i = 0; i < length; ++i){
                        reqs.push(req = store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                }
                var done = function(event) {
                    var lastResult = event.target.result;
                    reqs.forEach(function(req, i) {
                        return req.error != null && (failures[i] = req.error);
                    });
                    resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: type === "delete" ? keys : reqs.map(function(req) {
                            return req.result;
                        }),
                        lastResult: lastResult
                    });
                };
                req.onerror = function(event) {
                    errorHandler(event);
                    done(event);
                };
                req.onsuccess = done;
            });
        }
        function openCursor(_a) {
            var trans = _a.trans, values = _a.values, query = _a.query, reverse = _a.reverse, unique = _a.unique;
            return new Promise(function(resolve, reject) {
                resolve = $f8ed024a6db1f9db$var$wrap(resolve);
                var index = query.index, range = query.range;
                var store = trans.objectStore(tableName);
                var source = index.isPrimaryKey ? store : store.index(index.name);
                var direction = reverse ? unique ? "prevunique" : "prev" : unique ? "nextunique" : "next";
                var req = values || !('openKeyCursor' in source) ? source.openCursor(makeIDBKeyRange(range), direction) : source.openKeyCursor(makeIDBKeyRange(range), direction);
                req.onerror = $f8ed024a6db1f9db$var$eventRejectHandler(reject);
                req.onsuccess = $f8ed024a6db1f9db$var$wrap(function(ev) {
                    var cursor = req.result;
                    if (!cursor) {
                        resolve(null);
                        return;
                    }
                    cursor.___id = ++$f8ed024a6db1f9db$var$_id_counter;
                    cursor.done = false;
                    var _cursorContinue = cursor.continue.bind(cursor);
                    var _cursorContinuePrimaryKey = cursor.continuePrimaryKey;
                    if (_cursorContinuePrimaryKey) _cursorContinuePrimaryKey = _cursorContinuePrimaryKey.bind(cursor);
                    var _cursorAdvance = cursor.advance.bind(cursor);
                    var doThrowCursorIsNotStarted = function() {
                        throw new Error("Cursor not started");
                    };
                    var doThrowCursorIsStopped = function() {
                        throw new Error("Cursor not stopped");
                    };
                    cursor.trans = trans;
                    cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsNotStarted;
                    cursor.fail = $f8ed024a6db1f9db$var$wrap(reject);
                    cursor.next = function() {
                        var _this = this;
                        var gotOne = 1;
                        return this.start(function() {
                            return gotOne-- ? _this.continue() : _this.stop();
                        }).then(function() {
                            return _this;
                        });
                    };
                    cursor.start = function(callback) {
                        var iterationPromise = new Promise(function(resolveIteration, rejectIteration) {
                            resolveIteration = $f8ed024a6db1f9db$var$wrap(resolveIteration);
                            req.onerror = $f8ed024a6db1f9db$var$eventRejectHandler(rejectIteration);
                            cursor.fail = rejectIteration;
                            cursor.stop = function(value) {
                                cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsStopped;
                                resolveIteration(value);
                            };
                        });
                        var guardedCallback = function() {
                            if (req.result) try {
                                callback();
                            } catch (err) {
                                cursor.fail(err);
                            }
                            else {
                                cursor.done = true;
                                cursor.start = function() {
                                    throw new Error("Cursor behind last entry");
                                };
                                cursor.stop();
                            }
                        };
                        req.onsuccess = $f8ed024a6db1f9db$var$wrap(function(ev) {
                            req.onsuccess = guardedCallback;
                            guardedCallback();
                        });
                        cursor.continue = _cursorContinue;
                        cursor.continuePrimaryKey = _cursorContinuePrimaryKey;
                        cursor.advance = _cursorAdvance;
                        guardedCallback();
                        return iterationPromise;
                    };
                    resolve(cursor);
                }, reject);
            });
        }
        function query(hasGetAll) {
            return function(request) {
                return new Promise(function(resolve, reject) {
                    resolve = $f8ed024a6db1f9db$var$wrap(resolve);
                    var trans = request.trans, values = request.values, limit = request.limit, query = request.query;
                    var nonInfinitLimit = limit === Infinity ? undefined : limit;
                    var index = query.index, range = query.range;
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    if (limit === 0) return resolve({
                        result: []
                    });
                    if (hasGetAll) {
                        var req = values ? source.getAll(idbKeyRange, nonInfinitLimit) : source.getAllKeys(idbKeyRange, nonInfinitLimit);
                        req.onsuccess = function(event) {
                            return resolve({
                                result: event.target.result
                            });
                        };
                        req.onerror = $f8ed024a6db1f9db$var$eventRejectHandler(reject);
                    } else {
                        var count_1 = 0;
                        var req_1 = values || !('openKeyCursor' in source) ? source.openCursor(idbKeyRange) : source.openKeyCursor(idbKeyRange);
                        var result_1 = [];
                        req_1.onsuccess = function(event) {
                            var cursor = req_1.result;
                            if (!cursor) return resolve({
                                result: result_1
                            });
                            result_1.push(values ? cursor.value : cursor.primaryKey);
                            if (++count_1 === limit) return resolve({
                                result: result_1
                            });
                            cursor.continue();
                        };
                        req_1.onerror = $f8ed024a6db1f9db$var$eventRejectHandler(reject);
                    }
                });
            };
        }
        return {
            name: tableName,
            schema: tableSchema,
            mutate: mutate,
            getMany: function(_a) {
                var trans = _a.trans, keys = _a.keys;
                return new Promise(function(resolve, reject) {
                    resolve = $f8ed024a6db1f9db$var$wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var length = keys.length;
                    var result = new Array(length);
                    var keyCount = 0;
                    var callbackCount = 0;
                    var req;
                    var successHandler = function(event) {
                        var req = event.target;
                        result[req._pos] = req.result;
                        if (++callbackCount === keyCount) resolve(result);
                    };
                    var errorHandler = $f8ed024a6db1f9db$var$eventRejectHandler(reject);
                    for(var i = 0; i < length; ++i){
                        var key = keys[i];
                        if (key != null) {
                            req = store.get(keys[i]);
                            req._pos = i;
                            req.onsuccess = successHandler;
                            req.onerror = errorHandler;
                            ++keyCount;
                        }
                    }
                    if (keyCount === 0) resolve(result);
                });
            },
            get: function(_a) {
                var trans = _a.trans, key = _a.key;
                return new Promise(function(resolve, reject) {
                    resolve = $f8ed024a6db1f9db$var$wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var req = store.get(key);
                    req.onsuccess = function(event) {
                        return resolve(event.target.result);
                    };
                    req.onerror = $f8ed024a6db1f9db$var$eventRejectHandler(reject);
                });
            },
            query: query(hasGetAll),
            openCursor: openCursor,
            count: function(_a) {
                var query = _a.query, trans = _a.trans;
                var index = query.index, range = query.range;
                return new Promise(function(resolve, reject) {
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    var req = idbKeyRange ? source.count(idbKeyRange) : source.count();
                    req.onsuccess = $f8ed024a6db1f9db$var$wrap(function(ev) {
                        return resolve(ev.target.result);
                    });
                    req.onerror = $f8ed024a6db1f9db$var$eventRejectHandler(reject);
                });
            }
        };
    }
    var _a = extractSchema(db, tmpTrans), schema = _a.schema, hasGetAll = _a.hasGetAll;
    var tables = schema.tables.map(function(tableSchema) {
        return createDbCoreTable(tableSchema);
    });
    var tableMap = {};
    tables.forEach(function(table) {
        return tableMap[table.name] = table;
    });
    return {
        stack: "dbcore",
        transaction: db.transaction.bind(db),
        table: function(name) {
            var result = tableMap[name];
            if (!result) throw new Error("Table '".concat(name, "' not found"));
            return tableMap[name];
        },
        MIN_KEY: -Infinity,
        MAX_KEY: $f8ed024a6db1f9db$var$getMaxKey(IdbKeyRange),
        schema: schema
    };
}
function $f8ed024a6db1f9db$var$createMiddlewareStack(stackImpl, middlewares) {
    return middlewares.reduce(function(down, _a) {
        var create = _a.create;
        return $f8ed024a6db1f9db$var$__assign($f8ed024a6db1f9db$var$__assign({}, down), create(down));
    }, stackImpl);
}
function $f8ed024a6db1f9db$var$createMiddlewareStacks(middlewares, idbdb, _a, tmpTrans) {
    var IDBKeyRange = _a.IDBKeyRange;
    _a.indexedDB;
    var dbcore = $f8ed024a6db1f9db$var$createMiddlewareStack($f8ed024a6db1f9db$var$createDBCore(idbdb, IDBKeyRange, tmpTrans), middlewares.dbcore);
    return {
        dbcore: dbcore
    };
}
function $f8ed024a6db1f9db$var$generateMiddlewareStacks(db, tmpTrans) {
    var idbdb = tmpTrans.db;
    var stacks = $f8ed024a6db1f9db$var$createMiddlewareStacks(db._middlewares, idbdb, db._deps, tmpTrans);
    db.core = stacks.dbcore;
    db.tables.forEach(function(table) {
        var tableName = table.name;
        if (db.core.schema.tables.some(function(tbl) {
            return tbl.name === tableName;
        })) {
            table.core = db.core.table(tableName);
            if (db[tableName] instanceof db.Table) db[tableName].core = table.core;
        }
    });
}
function $f8ed024a6db1f9db$var$setApiOnPlace(db, objs, tableNames, dbschema) {
    tableNames.forEach(function(tableName) {
        var schema = dbschema[tableName];
        objs.forEach(function(obj) {
            var propDesc = $f8ed024a6db1f9db$var$getPropertyDescriptor(obj, tableName);
            if (!propDesc || "value" in propDesc && propDesc.value === undefined) {
                if (obj === db.Transaction.prototype || obj instanceof db.Transaction) $f8ed024a6db1f9db$var$setProp(obj, tableName, {
                    get: function() {
                        return this.table(tableName);
                    },
                    set: function(value) {
                        $f8ed024a6db1f9db$var$defineProperty(this, tableName, {
                            value: value,
                            writable: true,
                            configurable: true,
                            enumerable: true
                        });
                    }
                });
                else obj[tableName] = new db.Table(tableName, schema);
            }
        });
    });
}
function $f8ed024a6db1f9db$var$removeTablesApi(db, objs) {
    objs.forEach(function(obj) {
        for(var key in obj)if (obj[key] instanceof db.Table) delete obj[key];
    });
}
function $f8ed024a6db1f9db$var$lowerVersionFirst(a, b) {
    return a._cfg.version - b._cfg.version;
}
function $f8ed024a6db1f9db$var$runUpgraders(db, oldVersion, idbUpgradeTrans, reject) {
    var globalSchema = db._dbSchema;
    if (idbUpgradeTrans.objectStoreNames.contains('$meta') && !globalSchema.$meta) {
        globalSchema.$meta = $f8ed024a6db1f9db$var$createTableSchema("$meta", $f8ed024a6db1f9db$var$parseIndexSyntax("")[0], []);
        db._storeNames.push('$meta');
    }
    var trans = db._createTransaction('readwrite', db._storeNames, globalSchema);
    trans.create(idbUpgradeTrans);
    trans._completion.catch(reject);
    var rejectTransaction = trans._reject.bind(trans);
    var transless = $f8ed024a6db1f9db$var$PSD.transless || $f8ed024a6db1f9db$var$PSD;
    $f8ed024a6db1f9db$var$newScope(function() {
        $f8ed024a6db1f9db$var$PSD.trans = trans;
        $f8ed024a6db1f9db$var$PSD.transless = transless;
        if (oldVersion === 0) {
            $f8ed024a6db1f9db$var$keys(globalSchema).forEach(function(tableName) {
                $f8ed024a6db1f9db$var$createTable(idbUpgradeTrans, tableName, globalSchema[tableName].primKey, globalSchema[tableName].indexes);
            });
            $f8ed024a6db1f9db$var$generateMiddlewareStacks(db, idbUpgradeTrans);
            $f8ed024a6db1f9db$var$DexiePromise.follow(function() {
                return db.on.populate.fire(trans);
            }).catch(rejectTransaction);
        } else {
            $f8ed024a6db1f9db$var$generateMiddlewareStacks(db, idbUpgradeTrans);
            return $f8ed024a6db1f9db$var$getExistingVersion(db, trans, oldVersion).then(function(oldVersion) {
                return $f8ed024a6db1f9db$var$updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans);
            }).catch(rejectTransaction);
        }
    });
}
function $f8ed024a6db1f9db$var$patchCurrentVersion(db, idbUpgradeTrans) {
    $f8ed024a6db1f9db$var$createMissingTables(db._dbSchema, idbUpgradeTrans);
    if (idbUpgradeTrans.db.version % 10 === 0 && !idbUpgradeTrans.objectStoreNames.contains('$meta')) idbUpgradeTrans.db.createObjectStore('$meta').add(Math.ceil(idbUpgradeTrans.db.version / 10 - 1), 'version');
    var globalSchema = $f8ed024a6db1f9db$var$buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
    $f8ed024a6db1f9db$var$adjustToExistingIndexNames(db, db._dbSchema, idbUpgradeTrans);
    var diff = $f8ed024a6db1f9db$var$getSchemaDiff(globalSchema, db._dbSchema);
    var _loop_1 = function(tableChange) {
        if (tableChange.change.length || tableChange.recreate) {
            console.warn("Unable to patch indexes of table ".concat(tableChange.name, " because it has changes on the type of index or primary key."));
            return {
                value: void 0
            };
        }
        var store = idbUpgradeTrans.objectStore(tableChange.name);
        tableChange.add.forEach(function(idx) {
            if ($f8ed024a6db1f9db$var$debug) console.debug("Dexie upgrade patch: Creating missing index ".concat(tableChange.name, ".").concat(idx.src));
            $f8ed024a6db1f9db$var$addIndex(store, idx);
        });
    };
    for(var _i = 0, _a = diff.change; _i < _a.length; _i++){
        var tableChange = _a[_i];
        var state_1 = _loop_1(tableChange);
        if (typeof state_1 === "object") return state_1.value;
    }
}
function $f8ed024a6db1f9db$var$getExistingVersion(db, trans, oldVersion) {
    if (trans.storeNames.includes('$meta')) return trans.table('$meta').get('version').then(function(metaVersion) {
        return metaVersion != null ? metaVersion : oldVersion;
    });
    else return $f8ed024a6db1f9db$var$DexiePromise.resolve(oldVersion);
}
function $f8ed024a6db1f9db$var$updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans) {
    var queue = [];
    var versions = db._versions;
    var globalSchema = db._dbSchema = $f8ed024a6db1f9db$var$buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
    var versToRun = versions.filter(function(v) {
        return v._cfg.version >= oldVersion;
    });
    if (versToRun.length === 0) return $f8ed024a6db1f9db$var$DexiePromise.resolve();
    versToRun.forEach(function(version) {
        queue.push(function() {
            var oldSchema = globalSchema;
            var newSchema = version._cfg.dbschema;
            $f8ed024a6db1f9db$var$adjustToExistingIndexNames(db, oldSchema, idbUpgradeTrans);
            $f8ed024a6db1f9db$var$adjustToExistingIndexNames(db, newSchema, idbUpgradeTrans);
            globalSchema = db._dbSchema = newSchema;
            var diff = $f8ed024a6db1f9db$var$getSchemaDiff(oldSchema, newSchema);
            diff.add.forEach(function(tuple) {
                $f8ed024a6db1f9db$var$createTable(idbUpgradeTrans, tuple[0], tuple[1].primKey, tuple[1].indexes);
            });
            diff.change.forEach(function(change) {
                if (change.recreate) throw new $f8ed024a6db1f9db$var$exceptions.Upgrade("Not yet support for changing primary key");
                else {
                    var store_1 = idbUpgradeTrans.objectStore(change.name);
                    change.add.forEach(function(idx) {
                        return $f8ed024a6db1f9db$var$addIndex(store_1, idx);
                    });
                    change.change.forEach(function(idx) {
                        store_1.deleteIndex(idx.name);
                        $f8ed024a6db1f9db$var$addIndex(store_1, idx);
                    });
                    change.del.forEach(function(idxName) {
                        return store_1.deleteIndex(idxName);
                    });
                }
            });
            var contentUpgrade = version._cfg.contentUpgrade;
            if (contentUpgrade && version._cfg.version > oldVersion) {
                $f8ed024a6db1f9db$var$generateMiddlewareStacks(db, idbUpgradeTrans);
                trans._memoizedTables = {};
                var upgradeSchema_1 = $f8ed024a6db1f9db$var$shallowClone(newSchema);
                diff.del.forEach(function(table) {
                    upgradeSchema_1[table] = oldSchema[table];
                });
                $f8ed024a6db1f9db$var$removeTablesApi(db, [
                    db.Transaction.prototype
                ]);
                $f8ed024a6db1f9db$var$setApiOnPlace(db, [
                    db.Transaction.prototype
                ], $f8ed024a6db1f9db$var$keys(upgradeSchema_1), upgradeSchema_1);
                trans.schema = upgradeSchema_1;
                var contentUpgradeIsAsync_1 = $f8ed024a6db1f9db$var$isAsyncFunction(contentUpgrade);
                if (contentUpgradeIsAsync_1) $f8ed024a6db1f9db$var$incrementExpectedAwaits();
                var returnValue_1;
                var promiseFollowed = $f8ed024a6db1f9db$var$DexiePromise.follow(function() {
                    returnValue_1 = contentUpgrade(trans);
                    if (returnValue_1) {
                        if (contentUpgradeIsAsync_1) {
                            var decrementor = $f8ed024a6db1f9db$var$decrementExpectedAwaits.bind(null, null);
                            returnValue_1.then(decrementor, decrementor);
                        }
                    }
                });
                return returnValue_1 && typeof returnValue_1.then === 'function' ? $f8ed024a6db1f9db$var$DexiePromise.resolve(returnValue_1) : promiseFollowed.then(function() {
                    return returnValue_1;
                });
            }
        });
        queue.push(function(idbtrans) {
            var newSchema = version._cfg.dbschema;
            $f8ed024a6db1f9db$var$deleteRemovedTables(newSchema, idbtrans);
            $f8ed024a6db1f9db$var$removeTablesApi(db, [
                db.Transaction.prototype
            ]);
            $f8ed024a6db1f9db$var$setApiOnPlace(db, [
                db.Transaction.prototype
            ], db._storeNames, db._dbSchema);
            trans.schema = db._dbSchema;
        });
        queue.push(function(idbtrans) {
            if (db.idbdb.objectStoreNames.contains('$meta')) {
                if (Math.ceil(db.idbdb.version / 10) === version._cfg.version) {
                    db.idbdb.deleteObjectStore('$meta');
                    delete db._dbSchema.$meta;
                    db._storeNames = db._storeNames.filter(function(name) {
                        return name !== '$meta';
                    });
                } else idbtrans.objectStore('$meta').put(version._cfg.version, 'version');
            }
        });
    });
    function runQueue() {
        return queue.length ? $f8ed024a6db1f9db$var$DexiePromise.resolve(queue.shift()(trans.idbtrans)).then(runQueue) : $f8ed024a6db1f9db$var$DexiePromise.resolve();
    }
    return runQueue().then(function() {
        $f8ed024a6db1f9db$var$createMissingTables(globalSchema, idbUpgradeTrans);
    });
}
function $f8ed024a6db1f9db$var$getSchemaDiff(oldSchema, newSchema) {
    var diff = {
        del: [],
        add: [],
        change: []
    };
    var table;
    for(table in oldSchema)if (!newSchema[table]) diff.del.push(table);
    for(table in newSchema){
        var oldDef = oldSchema[table], newDef = newSchema[table];
        if (!oldDef) diff.add.push([
            table,
            newDef
        ]);
        else {
            var change = {
                name: table,
                def: newDef,
                recreate: false,
                del: [],
                add: [],
                change: []
            };
            if ('' + (oldDef.primKey.keyPath || '') !== '' + (newDef.primKey.keyPath || '') || oldDef.primKey.auto !== newDef.primKey.auto) {
                change.recreate = true;
                diff.change.push(change);
            } else {
                var oldIndexes = oldDef.idxByName;
                var newIndexes = newDef.idxByName;
                var idxName = void 0;
                for(idxName in oldIndexes)if (!newIndexes[idxName]) change.del.push(idxName);
                for(idxName in newIndexes){
                    var oldIdx = oldIndexes[idxName], newIdx = newIndexes[idxName];
                    if (!oldIdx) change.add.push(newIdx);
                    else if (oldIdx.src !== newIdx.src) change.change.push(newIdx);
                }
                if (change.del.length > 0 || change.add.length > 0 || change.change.length > 0) diff.change.push(change);
            }
        }
    }
    return diff;
}
function $f8ed024a6db1f9db$var$createTable(idbtrans, tableName, primKey, indexes) {
    var store = idbtrans.db.createObjectStore(tableName, primKey.keyPath ? {
        keyPath: primKey.keyPath,
        autoIncrement: primKey.auto
    } : {
        autoIncrement: primKey.auto
    });
    indexes.forEach(function(idx) {
        return $f8ed024a6db1f9db$var$addIndex(store, idx);
    });
    return store;
}
function $f8ed024a6db1f9db$var$createMissingTables(newSchema, idbtrans) {
    $f8ed024a6db1f9db$var$keys(newSchema).forEach(function(tableName) {
        if (!idbtrans.db.objectStoreNames.contains(tableName)) {
            if ($f8ed024a6db1f9db$var$debug) console.debug('Dexie: Creating missing table', tableName);
            $f8ed024a6db1f9db$var$createTable(idbtrans, tableName, newSchema[tableName].primKey, newSchema[tableName].indexes);
        }
    });
}
function $f8ed024a6db1f9db$var$deleteRemovedTables(newSchema, idbtrans) {
    [].slice.call(idbtrans.db.objectStoreNames).forEach(function(storeName) {
        return newSchema[storeName] == null && idbtrans.db.deleteObjectStore(storeName);
    });
}
function $f8ed024a6db1f9db$var$addIndex(store, idx) {
    store.createIndex(idx.name, idx.keyPath, {
        unique: idx.unique,
        multiEntry: idx.multi
    });
}
function $f8ed024a6db1f9db$var$buildGlobalSchema(db, idbdb, tmpTrans) {
    var globalSchema = {};
    var dbStoreNames = $f8ed024a6db1f9db$var$slice(idbdb.objectStoreNames, 0);
    dbStoreNames.forEach(function(storeName) {
        var store = tmpTrans.objectStore(storeName);
        var keyPath = store.keyPath;
        var primKey = $f8ed024a6db1f9db$var$createIndexSpec($f8ed024a6db1f9db$var$nameFromKeyPath(keyPath), keyPath || "", true, false, !!store.autoIncrement, keyPath && typeof keyPath !== "string", true);
        var indexes = [];
        for(var j = 0; j < store.indexNames.length; ++j){
            var idbindex = store.index(store.indexNames[j]);
            keyPath = idbindex.keyPath;
            var index = $f8ed024a6db1f9db$var$createIndexSpec(idbindex.name, keyPath, !!idbindex.unique, !!idbindex.multiEntry, false, keyPath && typeof keyPath !== "string", false);
            indexes.push(index);
        }
        globalSchema[storeName] = $f8ed024a6db1f9db$var$createTableSchema(storeName, primKey, indexes);
    });
    return globalSchema;
}
function $f8ed024a6db1f9db$var$readGlobalSchema(db, idbdb, tmpTrans) {
    db.verno = idbdb.version / 10;
    var globalSchema = db._dbSchema = $f8ed024a6db1f9db$var$buildGlobalSchema(db, idbdb, tmpTrans);
    db._storeNames = $f8ed024a6db1f9db$var$slice(idbdb.objectStoreNames, 0);
    $f8ed024a6db1f9db$var$setApiOnPlace(db, [
        db._allTables
    ], $f8ed024a6db1f9db$var$keys(globalSchema), globalSchema);
}
function $f8ed024a6db1f9db$var$verifyInstalledSchema(db, tmpTrans) {
    var installedSchema = $f8ed024a6db1f9db$var$buildGlobalSchema(db, db.idbdb, tmpTrans);
    var diff = $f8ed024a6db1f9db$var$getSchemaDiff(installedSchema, db._dbSchema);
    return !(diff.add.length || diff.change.some(function(ch) {
        return ch.add.length || ch.change.length;
    }));
}
function $f8ed024a6db1f9db$var$adjustToExistingIndexNames(db, schema, idbtrans) {
    var storeNames = idbtrans.db.objectStoreNames;
    for(var i = 0; i < storeNames.length; ++i){
        var storeName = storeNames[i];
        var store = idbtrans.objectStore(storeName);
        db._hasGetAll = 'getAll' in store;
        for(var j = 0; j < store.indexNames.length; ++j){
            var indexName = store.indexNames[j];
            var keyPath = store.index(indexName).keyPath;
            var dexieName = typeof keyPath === 'string' ? keyPath : "[" + $f8ed024a6db1f9db$var$slice(keyPath).join('+') + "]";
            if (schema[storeName]) {
                var indexSpec = schema[storeName].idxByName[dexieName];
                if (indexSpec) {
                    indexSpec.name = indexName;
                    delete schema[storeName].idxByName[dexieName];
                    schema[storeName].idxByName[indexName] = indexSpec;
                }
            }
        }
    }
    if (typeof navigator !== 'undefined' && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && $f8ed024a6db1f9db$var$_global.WorkerGlobalScope && $f8ed024a6db1f9db$var$_global instanceof $f8ed024a6db1f9db$var$_global.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604) db._hasGetAll = false;
}
function $f8ed024a6db1f9db$var$parseIndexSyntax(primKeyAndIndexes) {
    return primKeyAndIndexes.split(',').map(function(index, indexNum) {
        index = index.trim();
        var name = index.replace(/([&*]|\+\+)/g, "");
        var keyPath = /^\[/.test(name) ? name.match(/^\[(.*)\]$/)[1].split('+') : name;
        return $f8ed024a6db1f9db$var$createIndexSpec(name, keyPath || null, /\&/.test(index), /\*/.test(index), /\+\+/.test(index), $f8ed024a6db1f9db$var$isArray(keyPath), indexNum === 0);
    });
}
var $f8ed024a6db1f9db$var$Version = function() {
    function Version() {}
    Version.prototype._parseStoresSpec = function(stores, outSchema) {
        $f8ed024a6db1f9db$var$keys(stores).forEach(function(tableName) {
            if (stores[tableName] !== null) {
                var indexes = $f8ed024a6db1f9db$var$parseIndexSyntax(stores[tableName]);
                var primKey = indexes.shift();
                primKey.unique = true;
                if (primKey.multi) throw new $f8ed024a6db1f9db$var$exceptions.Schema("Primary key cannot be multi-valued");
                indexes.forEach(function(idx) {
                    if (idx.auto) throw new $f8ed024a6db1f9db$var$exceptions.Schema("Only primary key can be marked as autoIncrement (++)");
                    if (!idx.keyPath) throw new $f8ed024a6db1f9db$var$exceptions.Schema("Index must have a name and cannot be an empty string");
                });
                outSchema[tableName] = $f8ed024a6db1f9db$var$createTableSchema(tableName, primKey, indexes);
            }
        });
    };
    Version.prototype.stores = function(stores) {
        var db = this.db;
        this._cfg.storesSource = this._cfg.storesSource ? $f8ed024a6db1f9db$var$extend(this._cfg.storesSource, stores) : stores;
        var versions = db._versions;
        var storesSpec = {};
        var dbschema = {};
        versions.forEach(function(version) {
            $f8ed024a6db1f9db$var$extend(storesSpec, version._cfg.storesSource);
            dbschema = version._cfg.dbschema = {};
            version._parseStoresSpec(storesSpec, dbschema);
        });
        db._dbSchema = dbschema;
        $f8ed024a6db1f9db$var$removeTablesApi(db, [
            db._allTables,
            db,
            db.Transaction.prototype
        ]);
        $f8ed024a6db1f9db$var$setApiOnPlace(db, [
            db._allTables,
            db,
            db.Transaction.prototype,
            this._cfg.tables
        ], $f8ed024a6db1f9db$var$keys(dbschema), dbschema);
        db._storeNames = $f8ed024a6db1f9db$var$keys(dbschema);
        return this;
    };
    Version.prototype.upgrade = function(upgradeFunction) {
        this._cfg.contentUpgrade = $f8ed024a6db1f9db$var$promisableChain(this._cfg.contentUpgrade || $f8ed024a6db1f9db$var$nop, upgradeFunction);
        return this;
    };
    return Version;
}();
function $f8ed024a6db1f9db$var$createVersionConstructor(db) {
    return $f8ed024a6db1f9db$var$makeClassConstructor($f8ed024a6db1f9db$var$Version.prototype, function Version(versionNumber) {
        this.db = db;
        this._cfg = {
            version: versionNumber,
            storesSource: null,
            dbschema: {},
            tables: {},
            contentUpgrade: null
        };
    });
}
function $f8ed024a6db1f9db$var$getDbNamesTable(indexedDB1, IDBKeyRange) {
    var dbNamesDB = indexedDB1["_dbNamesDB"];
    if (!dbNamesDB) {
        dbNamesDB = indexedDB1["_dbNamesDB"] = new $f8ed024a6db1f9db$export$4ece27d405df7279($f8ed024a6db1f9db$var$DBNAMES_DB, {
            addons: [],
            indexedDB: indexedDB1,
            IDBKeyRange: IDBKeyRange
        });
        dbNamesDB.version(1).stores({
            dbnames: "name"
        });
    }
    return dbNamesDB.table("dbnames");
}
function $f8ed024a6db1f9db$var$hasDatabasesNative(indexedDB1) {
    return indexedDB1 && typeof indexedDB1.databases === "function";
}
function $f8ed024a6db1f9db$var$getDatabaseNames(_a) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    return $f8ed024a6db1f9db$var$hasDatabasesNative(indexedDB1) ? Promise.resolve(indexedDB1.databases()).then(function(infos) {
        return infos.map(function(info) {
            return info.name;
        }).filter(function(name) {
            return name !== $f8ed024a6db1f9db$var$DBNAMES_DB;
        });
    }) : $f8ed024a6db1f9db$var$getDbNamesTable(indexedDB1, IDBKeyRange).toCollection().primaryKeys();
}
function $f8ed024a6db1f9db$var$_onDatabaseCreated(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !$f8ed024a6db1f9db$var$hasDatabasesNative(indexedDB1) && name !== $f8ed024a6db1f9db$var$DBNAMES_DB && $f8ed024a6db1f9db$var$getDbNamesTable(indexedDB1, IDBKeyRange).put({
        name: name
    }).catch($f8ed024a6db1f9db$var$nop);
}
function $f8ed024a6db1f9db$var$_onDatabaseDeleted(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !$f8ed024a6db1f9db$var$hasDatabasesNative(indexedDB1) && name !== $f8ed024a6db1f9db$var$DBNAMES_DB && $f8ed024a6db1f9db$var$getDbNamesTable(indexedDB1, IDBKeyRange).delete(name).catch($f8ed024a6db1f9db$var$nop);
}
function $f8ed024a6db1f9db$var$vip(fn) {
    return $f8ed024a6db1f9db$var$newScope(function() {
        $f8ed024a6db1f9db$var$PSD.letThrough = true;
        return fn();
    });
}
function $f8ed024a6db1f9db$var$idbReady() {
    var isSafari = !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent);
    if (!isSafari || !indexedDB.databases) return Promise.resolve();
    var intervalId;
    return new Promise(function(resolve) {
        var tryIdb = function() {
            return indexedDB.databases().finally(resolve);
        };
        intervalId = setInterval(tryIdb, 100);
        tryIdb();
    }).finally(function() {
        return clearInterval(intervalId);
    });
}
var $f8ed024a6db1f9db$var$_a;
function $f8ed024a6db1f9db$var$isEmptyRange(node) {
    return !("from" in node);
}
var $f8ed024a6db1f9db$export$34cb5241245008dd = function(fromOrTree, to) {
    if (this) $f8ed024a6db1f9db$var$extend(this, arguments.length ? {
        d: 1,
        from: fromOrTree,
        to: arguments.length > 1 ? to : fromOrTree
    } : {
        d: 0
    });
    else {
        var rv = new $f8ed024a6db1f9db$export$34cb5241245008dd();
        if (fromOrTree && "d" in fromOrTree) $f8ed024a6db1f9db$var$extend(rv, fromOrTree);
        return rv;
    }
};
$f8ed024a6db1f9db$var$props($f8ed024a6db1f9db$export$34cb5241245008dd.prototype, ($f8ed024a6db1f9db$var$_a = {
    add: function(rangeSet) {
        $f8ed024a6db1f9db$export$4876cc3130d3f820(this, rangeSet);
        return this;
    },
    addKey: function(key) {
        $f8ed024a6db1f9db$var$addRange(this, key, key);
        return this;
    },
    addKeys: function(keys) {
        var _this = this;
        keys.forEach(function(key) {
            return $f8ed024a6db1f9db$var$addRange(_this, key, key);
        });
        return this;
    },
    hasKey: function(key) {
        var node = $f8ed024a6db1f9db$var$getRangeSetIterator(this).next(key).value;
        return node && $f8ed024a6db1f9db$export$6154dcdb7d23e37b(node.from, key) <= 0 && $f8ed024a6db1f9db$export$6154dcdb7d23e37b(node.to, key) >= 0;
    }
}, $f8ed024a6db1f9db$var$_a[$f8ed024a6db1f9db$var$iteratorSymbol] = function() {
    return $f8ed024a6db1f9db$var$getRangeSetIterator(this);
}, $f8ed024a6db1f9db$var$_a));
function $f8ed024a6db1f9db$var$addRange(target, from, to) {
    var diff = $f8ed024a6db1f9db$export$6154dcdb7d23e37b(from, to);
    if (isNaN(diff)) return;
    if (diff > 0) throw RangeError();
    if ($f8ed024a6db1f9db$var$isEmptyRange(target)) return $f8ed024a6db1f9db$var$extend(target, {
        from: from,
        to: to,
        d: 1
    });
    var left = target.l;
    var right = target.r;
    if ($f8ed024a6db1f9db$export$6154dcdb7d23e37b(to, target.from) < 0) {
        left ? $f8ed024a6db1f9db$var$addRange(left, from, to) : target.l = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return $f8ed024a6db1f9db$var$rebalance(target);
    }
    if ($f8ed024a6db1f9db$export$6154dcdb7d23e37b(from, target.to) > 0) {
        right ? $f8ed024a6db1f9db$var$addRange(right, from, to) : target.r = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return $f8ed024a6db1f9db$var$rebalance(target);
    }
    if ($f8ed024a6db1f9db$export$6154dcdb7d23e37b(from, target.from) < 0) {
        target.from = from;
        target.l = null;
        target.d = right ? right.d + 1 : 1;
    }
    if ($f8ed024a6db1f9db$export$6154dcdb7d23e37b(to, target.to) > 0) {
        target.to = to;
        target.r = null;
        target.d = target.l ? target.l.d + 1 : 1;
    }
    var rightWasCutOff = !target.r;
    if (left && !target.l) $f8ed024a6db1f9db$export$4876cc3130d3f820(target, left);
    if (right && rightWasCutOff) $f8ed024a6db1f9db$export$4876cc3130d3f820(target, right);
}
function $f8ed024a6db1f9db$export$4876cc3130d3f820(target, newSet) {
    function _addRangeSet(target, _a) {
        var from = _a.from, to = _a.to, l = _a.l, r = _a.r;
        $f8ed024a6db1f9db$var$addRange(target, from, to);
        if (l) _addRangeSet(target, l);
        if (r) _addRangeSet(target, r);
    }
    if (!$f8ed024a6db1f9db$var$isEmptyRange(newSet)) _addRangeSet(target, newSet);
}
function $f8ed024a6db1f9db$export$8f43b23b5d8de905(rangeSet1, rangeSet2) {
    var i1 = $f8ed024a6db1f9db$var$getRangeSetIterator(rangeSet2);
    var nextResult1 = i1.next();
    if (nextResult1.done) return false;
    var a = nextResult1.value;
    var i2 = $f8ed024a6db1f9db$var$getRangeSetIterator(rangeSet1);
    var nextResult2 = i2.next(a.from);
    var b = nextResult2.value;
    while(!nextResult1.done && !nextResult2.done){
        if ($f8ed024a6db1f9db$export$6154dcdb7d23e37b(b.from, a.to) <= 0 && $f8ed024a6db1f9db$export$6154dcdb7d23e37b(b.to, a.from) >= 0) return true;
        $f8ed024a6db1f9db$export$6154dcdb7d23e37b(a.from, b.from) < 0 ? a = (nextResult1 = i1.next(b.from)).value : b = (nextResult2 = i2.next(a.from)).value;
    }
    return false;
}
function $f8ed024a6db1f9db$var$getRangeSetIterator(node) {
    var state = $f8ed024a6db1f9db$var$isEmptyRange(node) ? null : {
        s: 0,
        n: node
    };
    return {
        next: function(key) {
            var keyProvided = arguments.length > 0;
            while(state)switch(state.s){
                case 0:
                    state.s = 1;
                    if (keyProvided) while(state.n.l && $f8ed024a6db1f9db$export$6154dcdb7d23e37b(key, state.n.from) < 0)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                    else while(state.n.l)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                case 1:
                    state.s = 2;
                    if (!keyProvided || $f8ed024a6db1f9db$export$6154dcdb7d23e37b(key, state.n.to) <= 0) return {
                        value: state.n,
                        done: false
                    };
                case 2:
                    if (state.n.r) {
                        state.s = 3;
                        state = {
                            up: state,
                            n: state.n.r,
                            s: 0
                        };
                        continue;
                    }
                case 3:
                    state = state.up;
            }
            return {
                done: true
            };
        }
    };
}
function $f8ed024a6db1f9db$var$rebalance(target) {
    var _a, _b;
    var diff = (((_a = target.r) === null || _a === void 0 ? void 0 : _a.d) || 0) - (((_b = target.l) === null || _b === void 0 ? void 0 : _b.d) || 0);
    var r = diff > 1 ? "r" : diff < -1 ? "l" : "";
    if (r) {
        var l = r === "r" ? "l" : "r";
        var rootClone = $f8ed024a6db1f9db$var$__assign({}, target);
        var oldRootRight = target[r];
        target.from = oldRootRight.from;
        target.to = oldRootRight.to;
        target[r] = oldRootRight[r];
        rootClone[r] = oldRootRight[l];
        target[l] = rootClone;
        rootClone.d = $f8ed024a6db1f9db$var$computeDepth(rootClone);
    }
    target.d = $f8ed024a6db1f9db$var$computeDepth(target);
}
function $f8ed024a6db1f9db$var$computeDepth(_a) {
    var r = _a.r, l = _a.l;
    return (r ? l ? Math.max(r.d, l.d) : r.d : l ? l.d : 0) + 1;
}
function $f8ed024a6db1f9db$var$extendObservabilitySet(target, newSet) {
    $f8ed024a6db1f9db$var$keys(newSet).forEach(function(part) {
        if (target[part]) $f8ed024a6db1f9db$export$4876cc3130d3f820(target[part], newSet[part]);
        else target[part] = $f8ed024a6db1f9db$var$cloneSimpleObjectTree(newSet[part]);
    });
    return target;
}
function $f8ed024a6db1f9db$var$obsSetsOverlap(os1, os2) {
    return os1.all || os2.all || Object.keys(os1).some(function(key) {
        return os2[key] && $f8ed024a6db1f9db$export$8f43b23b5d8de905(os2[key], os1[key]);
    });
}
var $f8ed024a6db1f9db$var$cache = {};
var $f8ed024a6db1f9db$var$unsignaledParts = {};
var $f8ed024a6db1f9db$var$isTaskEnqueued = false;
function $f8ed024a6db1f9db$var$signalSubscribersLazily(part, optimistic) {
    $f8ed024a6db1f9db$var$extendObservabilitySet($f8ed024a6db1f9db$var$unsignaledParts, part);
    if (!$f8ed024a6db1f9db$var$isTaskEnqueued) {
        $f8ed024a6db1f9db$var$isTaskEnqueued = true;
        setTimeout(function() {
            $f8ed024a6db1f9db$var$isTaskEnqueued = false;
            var parts = $f8ed024a6db1f9db$var$unsignaledParts;
            $f8ed024a6db1f9db$var$unsignaledParts = {};
            $f8ed024a6db1f9db$var$signalSubscribersNow(parts, false);
        }, 0);
    }
}
function $f8ed024a6db1f9db$var$signalSubscribersNow(updatedParts, deleteAffectedCacheEntries) {
    if (deleteAffectedCacheEntries === void 0) deleteAffectedCacheEntries = false;
    var queriesToSignal = new Set();
    if (updatedParts.all) for(var _i = 0, _a = Object.values($f8ed024a6db1f9db$var$cache); _i < _a.length; _i++){
        var tblCache = _a[_i];
        $f8ed024a6db1f9db$var$collectTableSubscribers(tblCache, updatedParts, queriesToSignal, deleteAffectedCacheEntries);
    }
    else for(var key in updatedParts){
        var parts = /^idb\:\/\/(.*)\/(.*)\//.exec(key);
        if (parts) {
            var dbName = parts[1], tableName = parts[2];
            var tblCache = $f8ed024a6db1f9db$var$cache["idb://".concat(dbName, "/").concat(tableName)];
            if (tblCache) $f8ed024a6db1f9db$var$collectTableSubscribers(tblCache, updatedParts, queriesToSignal, deleteAffectedCacheEntries);
        }
    }
    queriesToSignal.forEach(function(requery) {
        return requery();
    });
}
function $f8ed024a6db1f9db$var$collectTableSubscribers(tblCache, updatedParts, outQueriesToSignal, deleteAffectedCacheEntries) {
    var updatedEntryLists = [];
    for(var _i = 0, _a = Object.entries(tblCache.queries.query); _i < _a.length; _i++){
        var _b = _a[_i], indexName = _b[0], entries = _b[1];
        var filteredEntries = [];
        for(var _c = 0, entries_1 = entries; _c < entries_1.length; _c++){
            var entry = entries_1[_c];
            if ($f8ed024a6db1f9db$var$obsSetsOverlap(updatedParts, entry.obsSet)) entry.subscribers.forEach(function(requery) {
                return outQueriesToSignal.add(requery);
            });
            else if (deleteAffectedCacheEntries) filteredEntries.push(entry);
        }
        if (deleteAffectedCacheEntries) updatedEntryLists.push([
            indexName,
            filteredEntries
        ]);
    }
    if (deleteAffectedCacheEntries) for(var _d = 0, updatedEntryLists_1 = updatedEntryLists; _d < updatedEntryLists_1.length; _d++){
        var _e = updatedEntryLists_1[_d], indexName = _e[0], filteredEntries = _e[1];
        tblCache.queries.query[indexName] = filteredEntries;
    }
}
function $f8ed024a6db1f9db$var$dexieOpen(db) {
    var state = db._state;
    var indexedDB1 = db._deps.indexedDB;
    if (state.isBeingOpened || db.idbdb) return state.dbReadyPromise.then(function() {
        return state.dbOpenError ? $f8ed024a6db1f9db$var$rejection(state.dbOpenError) : db;
    });
    state.isBeingOpened = true;
    state.dbOpenError = null;
    state.openComplete = false;
    var openCanceller = state.openCanceller;
    var nativeVerToOpen = Math.round(db.verno * 10);
    var schemaPatchMode = false;
    function throwIfCancelled() {
        if (state.openCanceller !== openCanceller) throw new $f8ed024a6db1f9db$var$exceptions.DatabaseClosed('db.open() was cancelled');
    }
    var resolveDbReady = state.dbReadyResolve, upgradeTransaction = null, wasCreated = false;
    var tryOpenDB = function() {
        return new $f8ed024a6db1f9db$var$DexiePromise(function(resolve, reject) {
            throwIfCancelled();
            if (!indexedDB1) throw new $f8ed024a6db1f9db$var$exceptions.MissingAPI();
            var dbName = db.name;
            var req = state.autoSchema || !nativeVerToOpen ? indexedDB1.open(dbName) : indexedDB1.open(dbName, nativeVerToOpen);
            if (!req) throw new $f8ed024a6db1f9db$var$exceptions.MissingAPI();
            req.onerror = $f8ed024a6db1f9db$var$eventRejectHandler(reject);
            req.onblocked = $f8ed024a6db1f9db$var$wrap(db._fireOnBlocked);
            req.onupgradeneeded = $f8ed024a6db1f9db$var$wrap(function(e) {
                upgradeTransaction = req.transaction;
                if (state.autoSchema && !db._options.allowEmptyDB) {
                    req.onerror = $f8ed024a6db1f9db$var$preventDefault;
                    upgradeTransaction.abort();
                    req.result.close();
                    var delreq = indexedDB1.deleteDatabase(dbName);
                    delreq.onsuccess = delreq.onerror = $f8ed024a6db1f9db$var$wrap(function() {
                        reject(new $f8ed024a6db1f9db$var$exceptions.NoSuchDatabase("Database ".concat(dbName, " doesnt exist")));
                    });
                } else {
                    upgradeTransaction.onerror = $f8ed024a6db1f9db$var$eventRejectHandler(reject);
                    var oldVer = e.oldVersion > Math.pow(2, 62) ? 0 : e.oldVersion;
                    wasCreated = oldVer < 1;
                    db.idbdb = req.result;
                    if (schemaPatchMode) $f8ed024a6db1f9db$var$patchCurrentVersion(db, upgradeTransaction);
                    $f8ed024a6db1f9db$var$runUpgraders(db, oldVer / 10, upgradeTransaction, reject);
                }
            }, reject);
            req.onsuccess = $f8ed024a6db1f9db$var$wrap(function() {
                upgradeTransaction = null;
                var idbdb = db.idbdb = req.result;
                var objectStoreNames = $f8ed024a6db1f9db$var$slice(idbdb.objectStoreNames);
                if (objectStoreNames.length > 0) try {
                    var tmpTrans = idbdb.transaction($f8ed024a6db1f9db$var$safariMultiStoreFix(objectStoreNames), 'readonly');
                    if (state.autoSchema) $f8ed024a6db1f9db$var$readGlobalSchema(db, idbdb, tmpTrans);
                    else {
                        $f8ed024a6db1f9db$var$adjustToExistingIndexNames(db, db._dbSchema, tmpTrans);
                        if (!$f8ed024a6db1f9db$var$verifyInstalledSchema(db, tmpTrans) && !schemaPatchMode) {
                            console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Dexie will add missing parts and increment native version number to workaround this.");
                            idbdb.close();
                            nativeVerToOpen = idbdb.version + 1;
                            schemaPatchMode = true;
                            return resolve(tryOpenDB());
                        }
                    }
                    $f8ed024a6db1f9db$var$generateMiddlewareStacks(db, tmpTrans);
                } catch (e) {}
                $f8ed024a6db1f9db$var$connections.push(db);
                idbdb.onversionchange = $f8ed024a6db1f9db$var$wrap(function(ev) {
                    state.vcFired = true;
                    db.on("versionchange").fire(ev);
                });
                idbdb.onclose = $f8ed024a6db1f9db$var$wrap(function(ev) {
                    db.on("close").fire(ev);
                });
                if (wasCreated) $f8ed024a6db1f9db$var$_onDatabaseCreated(db._deps, dbName);
                resolve();
            }, reject);
        }).catch(function(err) {
            switch(err === null || err === void 0 ? void 0 : err.name){
                case "UnknownError":
                    if (state.PR1398_maxLoop > 0) {
                        state.PR1398_maxLoop--;
                        console.warn('Dexie: Workaround for Chrome UnknownError on open()');
                        return tryOpenDB();
                    }
                    break;
                case "VersionError":
                    if (nativeVerToOpen > 0) {
                        nativeVerToOpen = 0;
                        return tryOpenDB();
                    }
                    break;
            }
            return $f8ed024a6db1f9db$var$DexiePromise.reject(err);
        });
    };
    return $f8ed024a6db1f9db$var$DexiePromise.race([
        openCanceller,
        (typeof navigator === 'undefined' ? $f8ed024a6db1f9db$var$DexiePromise.resolve() : $f8ed024a6db1f9db$var$idbReady()).then(tryOpenDB)
    ]).then(function() {
        throwIfCancelled();
        state.onReadyBeingFired = [];
        return $f8ed024a6db1f9db$var$DexiePromise.resolve($f8ed024a6db1f9db$var$vip(function() {
            return db.on.ready.fire(db.vip);
        })).then(function fireRemainders() {
            if (state.onReadyBeingFired.length > 0) {
                var remainders_1 = state.onReadyBeingFired.reduce($f8ed024a6db1f9db$var$promisableChain, $f8ed024a6db1f9db$var$nop);
                state.onReadyBeingFired = [];
                return $f8ed024a6db1f9db$var$DexiePromise.resolve($f8ed024a6db1f9db$var$vip(function() {
                    return remainders_1(db.vip);
                })).then(fireRemainders);
            }
        });
    }).finally(function() {
        if (state.openCanceller === openCanceller) {
            state.onReadyBeingFired = null;
            state.isBeingOpened = false;
        }
    }).catch(function(err) {
        state.dbOpenError = err;
        try {
            upgradeTransaction && upgradeTransaction.abort();
        } catch (_a) {}
        if (openCanceller === state.openCanceller) db._close();
        return $f8ed024a6db1f9db$var$rejection(err);
    }).finally(function() {
        state.openComplete = true;
        resolveDbReady();
    }).then(function() {
        if (wasCreated) {
            var everything_1 = {};
            db.tables.forEach(function(table) {
                table.schema.indexes.forEach(function(idx) {
                    if (idx.name) everything_1["idb://".concat(db.name, "/").concat(table.name, "/").concat(idx.name)] = new $f8ed024a6db1f9db$export$34cb5241245008dd(-Infinity, [
                        [
                            []
                        ]
                    ]);
                });
                everything_1["idb://".concat(db.name, "/").concat(table.name, "/")] = everything_1["idb://".concat(db.name, "/").concat(table.name, "/:dels")] = new $f8ed024a6db1f9db$export$34cb5241245008dd(-Infinity, [
                    [
                        []
                    ]
                ]);
            });
            $f8ed024a6db1f9db$var$globalEvents($f8ed024a6db1f9db$var$DEXIE_STORAGE_MUTATED_EVENT_NAME).fire(everything_1);
            $f8ed024a6db1f9db$var$signalSubscribersNow(everything_1, true);
        }
        return db;
    });
}
function $f8ed024a6db1f9db$var$awaitIterator(iterator) {
    var callNext = function(result) {
        return iterator.next(result);
    }, doThrow = function(error) {
        return iterator.throw(error);
    }, onSuccess = step(callNext), onError = step(doThrow);
    function step(getNext) {
        return function(val) {
            var next = getNext(val), value = next.value;
            return next.done ? value : !value || typeof value.then !== 'function' ? $f8ed024a6db1f9db$var$isArray(value) ? Promise.all(value).then(onSuccess, onError) : onSuccess(value) : value.then(onSuccess, onError);
        };
    }
    return step(callNext)();
}
function $f8ed024a6db1f9db$var$extractTransactionArgs(mode, _tableArgs_, scopeFunc) {
    var i = arguments.length;
    if (i < 2) throw new $f8ed024a6db1f9db$var$exceptions.InvalidArgument("Too few arguments");
    var args = new Array(i - 1);
    while(--i)args[i - 1] = arguments[i];
    scopeFunc = args.pop();
    var tables = $f8ed024a6db1f9db$var$flatten(args);
    return [
        mode,
        tables,
        scopeFunc
    ];
}
function $f8ed024a6db1f9db$var$enterTransactionScope(db, mode, storeNames, parentTransaction, scopeFunc) {
    return $f8ed024a6db1f9db$var$DexiePromise.resolve().then(function() {
        var transless = $f8ed024a6db1f9db$var$PSD.transless || $f8ed024a6db1f9db$var$PSD;
        var trans = db._createTransaction(mode, storeNames, db._dbSchema, parentTransaction);
        trans.explicit = true;
        var zoneProps = {
            trans: trans,
            transless: transless
        };
        if (parentTransaction) trans.idbtrans = parentTransaction.idbtrans;
        else try {
            trans.create();
            trans.idbtrans._explicit = true;
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === $f8ed024a6db1f9db$var$errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn('Dexie: Need to reopen db');
                db.close({
                    disableAutoOpen: false
                });
                return db.open().then(function() {
                    return $f8ed024a6db1f9db$var$enterTransactionScope(db, mode, storeNames, null, scopeFunc);
                });
            }
            return $f8ed024a6db1f9db$var$rejection(ex);
        }
        var scopeFuncIsAsync = $f8ed024a6db1f9db$var$isAsyncFunction(scopeFunc);
        if (scopeFuncIsAsync) $f8ed024a6db1f9db$var$incrementExpectedAwaits();
        var returnValue;
        var promiseFollowed = $f8ed024a6db1f9db$var$DexiePromise.follow(function() {
            returnValue = scopeFunc.call(trans, trans);
            if (returnValue) {
                if (scopeFuncIsAsync) {
                    var decrementor = $f8ed024a6db1f9db$var$decrementExpectedAwaits.bind(null, null);
                    returnValue.then(decrementor, decrementor);
                } else if (typeof returnValue.next === 'function' && typeof returnValue.throw === 'function') returnValue = $f8ed024a6db1f9db$var$awaitIterator(returnValue);
            }
        }, zoneProps);
        return (returnValue && typeof returnValue.then === 'function' ? $f8ed024a6db1f9db$var$DexiePromise.resolve(returnValue).then(function(x) {
            return trans.active ? x : $f8ed024a6db1f9db$var$rejection(new $f8ed024a6db1f9db$var$exceptions.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
        }) : promiseFollowed.then(function() {
            return returnValue;
        })).then(function(x) {
            if (parentTransaction) trans._resolve();
            return trans._completion.then(function() {
                return x;
            });
        }).catch(function(e) {
            trans._reject(e);
            return $f8ed024a6db1f9db$var$rejection(e);
        });
    });
}
function $f8ed024a6db1f9db$var$pad(a, value, count) {
    var result = $f8ed024a6db1f9db$var$isArray(a) ? a.slice() : [
        a
    ];
    for(var i = 0; i < count; ++i)result.push(value);
    return result;
}
function $f8ed024a6db1f9db$var$createVirtualIndexMiddleware(down) {
    return $f8ed024a6db1f9db$var$__assign($f8ed024a6db1f9db$var$__assign({}, down), {
        table: function(tableName) {
            var table = down.table(tableName);
            var schema = table.schema;
            var indexLookup = {};
            var allVirtualIndexes = [];
            function addVirtualIndexes(keyPath, keyTail, lowLevelIndex) {
                var keyPathAlias = $f8ed024a6db1f9db$var$getKeyPathAlias(keyPath);
                var indexList = indexLookup[keyPathAlias] = indexLookup[keyPathAlias] || [];
                var keyLength = keyPath == null ? 0 : typeof keyPath === 'string' ? 1 : keyPath.length;
                var isVirtual = keyTail > 0;
                var virtualIndex = $f8ed024a6db1f9db$var$__assign($f8ed024a6db1f9db$var$__assign({}, lowLevelIndex), {
                    name: isVirtual ? "".concat(keyPathAlias, "(virtual-from:").concat(lowLevelIndex.name, ")") : lowLevelIndex.name,
                    lowLevelIndex: lowLevelIndex,
                    isVirtual: isVirtual,
                    keyTail: keyTail,
                    keyLength: keyLength,
                    extractKey: $f8ed024a6db1f9db$var$getKeyExtractor(keyPath),
                    unique: !isVirtual && lowLevelIndex.unique
                });
                indexList.push(virtualIndex);
                if (!virtualIndex.isPrimaryKey) allVirtualIndexes.push(virtualIndex);
                if (keyLength > 1) {
                    var virtualKeyPath = keyLength === 2 ? keyPath[0] : keyPath.slice(0, keyLength - 1);
                    addVirtualIndexes(virtualKeyPath, keyTail + 1, lowLevelIndex);
                }
                indexList.sort(function(a, b) {
                    return a.keyTail - b.keyTail;
                });
                return virtualIndex;
            }
            var primaryKey = addVirtualIndexes(schema.primaryKey.keyPath, 0, schema.primaryKey);
            indexLookup[":id"] = [
                primaryKey
            ];
            for(var _i = 0, _a = schema.indexes; _i < _a.length; _i++){
                var index = _a[_i];
                addVirtualIndexes(index.keyPath, 0, index);
            }
            function findBestIndex(keyPath) {
                var result = indexLookup[$f8ed024a6db1f9db$var$getKeyPathAlias(keyPath)];
                return result && result[0];
            }
            function translateRange(range, keyTail) {
                return {
                    type: range.type === 1 ? 2 : range.type,
                    lower: $f8ed024a6db1f9db$var$pad(range.lower, range.lowerOpen ? down.MAX_KEY : down.MIN_KEY, keyTail),
                    lowerOpen: true,
                    upper: $f8ed024a6db1f9db$var$pad(range.upper, range.upperOpen ? down.MIN_KEY : down.MAX_KEY, keyTail),
                    upperOpen: true
                };
            }
            function translateRequest(req) {
                var index = req.query.index;
                return index.isVirtual ? $f8ed024a6db1f9db$var$__assign($f8ed024a6db1f9db$var$__assign({}, req), {
                    query: {
                        index: index.lowLevelIndex,
                        range: translateRange(req.query.range, index.keyTail)
                    }
                }) : req;
            }
            var result = $f8ed024a6db1f9db$var$__assign($f8ed024a6db1f9db$var$__assign({}, table), {
                schema: $f8ed024a6db1f9db$var$__assign($f8ed024a6db1f9db$var$__assign({}, schema), {
                    primaryKey: primaryKey,
                    indexes: allVirtualIndexes,
                    getIndexByKeyPath: findBestIndex
                }),
                count: function(req) {
                    return table.count(translateRequest(req));
                },
                query: function(req) {
                    return table.query(translateRequest(req));
                },
                openCursor: function(req) {
                    var _a = req.query.index, keyTail = _a.keyTail, isVirtual = _a.isVirtual, keyLength = _a.keyLength;
                    if (!isVirtual) return table.openCursor(req);
                    function createVirtualCursor(cursor) {
                        function _continue(key) {
                            key != null ? cursor.continue($f8ed024a6db1f9db$var$pad(key, req.reverse ? down.MAX_KEY : down.MIN_KEY, keyTail)) : req.unique ? cursor.continue(cursor.key.slice(0, keyLength).concat(req.reverse ? down.MIN_KEY : down.MAX_KEY, keyTail)) : cursor.continue();
                        }
                        var virtualCursor = Object.create(cursor, {
                            continue: {
                                value: _continue
                            },
                            continuePrimaryKey: {
                                value: function(key, primaryKey) {
                                    cursor.continuePrimaryKey($f8ed024a6db1f9db$var$pad(key, down.MAX_KEY, keyTail), primaryKey);
                                }
                            },
                            primaryKey: {
                                get: function() {
                                    return cursor.primaryKey;
                                }
                            },
                            key: {
                                get: function() {
                                    var key = cursor.key;
                                    return keyLength === 1 ? key[0] : key.slice(0, keyLength);
                                }
                            },
                            value: {
                                get: function() {
                                    return cursor.value;
                                }
                            }
                        });
                        return virtualCursor;
                    }
                    return table.openCursor(translateRequest(req)).then(function(cursor) {
                        return cursor && createVirtualCursor(cursor);
                    });
                }
            });
            return result;
        }
    });
}
var $f8ed024a6db1f9db$var$virtualIndexMiddleware = {
    stack: "dbcore",
    name: "VirtualIndexMiddleware",
    level: 1,
    create: $f8ed024a6db1f9db$var$createVirtualIndexMiddleware
};
function $f8ed024a6db1f9db$var$getObjectDiff(a, b, rv, prfx) {
    rv = rv || {};
    prfx = prfx || '';
    $f8ed024a6db1f9db$var$keys(a).forEach(function(prop) {
        if (!$f8ed024a6db1f9db$var$hasOwn(b, prop)) rv[prfx + prop] = undefined;
        else {
            var ap = a[prop], bp = b[prop];
            if (typeof ap === 'object' && typeof bp === 'object' && ap && bp) {
                var apTypeName = $f8ed024a6db1f9db$var$toStringTag(ap);
                var bpTypeName = $f8ed024a6db1f9db$var$toStringTag(bp);
                if (apTypeName !== bpTypeName) rv[prfx + prop] = b[prop];
                else if (apTypeName === 'Object') $f8ed024a6db1f9db$var$getObjectDiff(ap, bp, rv, prfx + prop + '.');
                else if (ap !== bp) rv[prfx + prop] = b[prop];
            } else if (ap !== bp) rv[prfx + prop] = b[prop];
        }
    });
    $f8ed024a6db1f9db$var$keys(b).forEach(function(prop) {
        if (!$f8ed024a6db1f9db$var$hasOwn(a, prop)) rv[prfx + prop] = b[prop];
    });
    return rv;
}
function $f8ed024a6db1f9db$var$getEffectiveKeys(primaryKey, req) {
    if (req.type === 'delete') return req.keys;
    return req.keys || req.values.map(primaryKey.extractKey);
}
var $f8ed024a6db1f9db$var$hooksMiddleware = {
    stack: "dbcore",
    name: "HooksMiddleware",
    level: 2,
    create: function(downCore) {
        return $f8ed024a6db1f9db$var$__assign($f8ed024a6db1f9db$var$__assign({}, downCore), {
            table: function(tableName) {
                var downTable = downCore.table(tableName);
                var primaryKey = downTable.schema.primaryKey;
                var tableMiddleware = $f8ed024a6db1f9db$var$__assign($f8ed024a6db1f9db$var$__assign({}, downTable), {
                    mutate: function(req) {
                        var dxTrans = $f8ed024a6db1f9db$var$PSD.trans;
                        var _a = dxTrans.table(tableName).hook, deleting = _a.deleting, creating = _a.creating, updating = _a.updating;
                        switch(req.type){
                            case 'add':
                                if (creating.fire === $f8ed024a6db1f9db$var$nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case 'put':
                                if (creating.fire === $f8ed024a6db1f9db$var$nop && updating.fire === $f8ed024a6db1f9db$var$nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case 'delete':
                                if (deleting.fire === $f8ed024a6db1f9db$var$nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case 'deleteRange':
                                if (deleting.fire === $f8ed024a6db1f9db$var$nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return deleteRange(req);
                                }, true);
                        }
                        return downTable.mutate(req);
                        function addPutOrDelete(req) {
                            var dxTrans = $f8ed024a6db1f9db$var$PSD.trans;
                            var keys = req.keys || $f8ed024a6db1f9db$var$getEffectiveKeys(primaryKey, req);
                            if (!keys) throw new Error("Keys missing");
                            req = req.type === 'add' || req.type === 'put' ? $f8ed024a6db1f9db$var$__assign($f8ed024a6db1f9db$var$__assign({}, req), {
                                keys: keys
                            }) : $f8ed024a6db1f9db$var$__assign({}, req);
                            if (req.type !== 'delete') req.values = $f8ed024a6db1f9db$var$__spreadArray([], req.values, true);
                            if (req.keys) req.keys = $f8ed024a6db1f9db$var$__spreadArray([], req.keys, true);
                            return $f8ed024a6db1f9db$var$getExistingValues(downTable, req, keys).then(function(existingValues) {
                                var contexts = keys.map(function(key, i) {
                                    var existingValue = existingValues[i];
                                    var ctx = {
                                        onerror: null,
                                        onsuccess: null
                                    };
                                    if (req.type === 'delete') deleting.fire.call(ctx, key, existingValue, dxTrans);
                                    else if (req.type === 'add' || existingValue === undefined) {
                                        var generatedPrimaryKey = creating.fire.call(ctx, key, req.values[i], dxTrans);
                                        if (key == null && generatedPrimaryKey != null) {
                                            key = generatedPrimaryKey;
                                            req.keys[i] = key;
                                            if (!primaryKey.outbound) $f8ed024a6db1f9db$var$setByKeyPath(req.values[i], primaryKey.keyPath, key);
                                        }
                                    } else {
                                        var objectDiff = $f8ed024a6db1f9db$var$getObjectDiff(existingValue, req.values[i]);
                                        var additionalChanges_1 = updating.fire.call(ctx, objectDiff, key, existingValue, dxTrans);
                                        if (additionalChanges_1) {
                                            var requestedValue_1 = req.values[i];
                                            Object.keys(additionalChanges_1).forEach(function(keyPath) {
                                                if ($f8ed024a6db1f9db$var$hasOwn(requestedValue_1, keyPath)) requestedValue_1[keyPath] = additionalChanges_1[keyPath];
                                                else $f8ed024a6db1f9db$var$setByKeyPath(requestedValue_1, keyPath, additionalChanges_1[keyPath]);
                                            });
                                        }
                                    }
                                    return ctx;
                                });
                                return downTable.mutate(req).then(function(_a) {
                                    var failures = _a.failures, results = _a.results, numFailures = _a.numFailures, lastResult = _a.lastResult;
                                    for(var i = 0; i < keys.length; ++i){
                                        var primKey = results ? results[i] : keys[i];
                                        var ctx = contexts[i];
                                        if (primKey == null) ctx.onerror && ctx.onerror(failures[i]);
                                        else ctx.onsuccess && ctx.onsuccess(req.type === 'put' && existingValues[i] ? req.values[i] : primKey);
                                    }
                                    return {
                                        failures: failures,
                                        results: results,
                                        numFailures: numFailures,
                                        lastResult: lastResult
                                    };
                                }).catch(function(error) {
                                    contexts.forEach(function(ctx) {
                                        return ctx.onerror && ctx.onerror(error);
                                    });
                                    return Promise.reject(error);
                                });
                            });
                        }
                        function deleteRange(req) {
                            return deleteNextChunk(req.trans, req.range, 10000);
                        }
                        function deleteNextChunk(trans, range, limit) {
                            return downTable.query({
                                trans: trans,
                                values: false,
                                query: {
                                    index: primaryKey,
                                    range: range
                                },
                                limit: limit
                            }).then(function(_a) {
                                var result = _a.result;
                                return addPutOrDelete({
                                    type: 'delete',
                                    keys: result,
                                    trans: trans
                                }).then(function(res) {
                                    if (res.numFailures > 0) return Promise.reject(res.failures[0]);
                                    if (result.length < limit) return {
                                        failures: [],
                                        numFailures: 0,
                                        lastResult: undefined
                                    };
                                    else return deleteNextChunk(trans, $f8ed024a6db1f9db$var$__assign($f8ed024a6db1f9db$var$__assign({}, range), {
                                        lower: result[result.length - 1],
                                        lowerOpen: true
                                    }), limit);
                                });
                            });
                        }
                    }
                });
                return tableMiddleware;
            }
        });
    }
};
function $f8ed024a6db1f9db$var$getExistingValues(table, req, effectiveKeys) {
    return req.type === "add" ? Promise.resolve([]) : table.getMany({
        trans: req.trans,
        keys: effectiveKeys,
        cache: "immutable"
    });
}
function $f8ed024a6db1f9db$var$getFromTransactionCache(keys, cache, clone) {
    try {
        if (!cache) return null;
        if (cache.keys.length < keys.length) return null;
        var result = [];
        for(var i = 0, j = 0; i < cache.keys.length && j < keys.length; ++i){
            if ($f8ed024a6db1f9db$export$6154dcdb7d23e37b(cache.keys[i], keys[j]) !== 0) continue;
            result.push(clone ? $f8ed024a6db1f9db$var$deepClone(cache.values[i]) : cache.values[i]);
            ++j;
        }
        return result.length === keys.length ? result : null;
    } catch (_a) {
        return null;
    }
}
var $f8ed024a6db1f9db$var$cacheExistingValuesMiddleware = {
    stack: "dbcore",
    level: -1,
    create: function(core) {
        return {
            table: function(tableName) {
                var table = core.table(tableName);
                return $f8ed024a6db1f9db$var$__assign($f8ed024a6db1f9db$var$__assign({}, table), {
                    getMany: function(req) {
                        if (!req.cache) return table.getMany(req);
                        var cachedResult = $f8ed024a6db1f9db$var$getFromTransactionCache(req.keys, req.trans["_cache"], req.cache === "clone");
                        if (cachedResult) return $f8ed024a6db1f9db$var$DexiePromise.resolve(cachedResult);
                        return table.getMany(req).then(function(res) {
                            req.trans["_cache"] = {
                                keys: req.keys,
                                values: req.cache === "clone" ? $f8ed024a6db1f9db$var$deepClone(res) : res
                            };
                            return res;
                        });
                    },
                    mutate: function(req) {
                        if (req.type !== "add") req.trans["_cache"] = null;
                        return table.mutate(req);
                    }
                });
            }
        };
    }
};
function $f8ed024a6db1f9db$var$isCachableContext(ctx, table) {
    return ctx.trans.mode === 'readonly' && !!ctx.subscr && !ctx.trans.explicit && ctx.trans.db._options.cache !== 'disabled' && !table.schema.primaryKey.outbound;
}
function $f8ed024a6db1f9db$var$isCachableRequest(type, req) {
    switch(type){
        case 'query':
            return req.values && !req.unique;
        case 'get':
            return false;
        case 'getMany':
            return false;
        case 'count':
            return false;
        case 'openCursor':
            return false;
    }
}
var $f8ed024a6db1f9db$var$observabilityMiddleware = {
    stack: "dbcore",
    level: 0,
    name: "Observability",
    create: function(core) {
        var dbName = core.schema.name;
        var FULL_RANGE = new $f8ed024a6db1f9db$export$34cb5241245008dd(core.MIN_KEY, core.MAX_KEY);
        return $f8ed024a6db1f9db$var$__assign($f8ed024a6db1f9db$var$__assign({}, core), {
            transaction: function(stores, mode, options) {
                if ($f8ed024a6db1f9db$var$PSD.subscr && mode !== 'readonly') throw new $f8ed024a6db1f9db$var$exceptions.ReadOnly("Readwrite transaction in liveQuery context. Querier source: ".concat($f8ed024a6db1f9db$var$PSD.querier));
                return core.transaction(stores, mode, options);
            },
            table: function(tableName) {
                var table = core.table(tableName);
                var schema = table.schema;
                var primaryKey = schema.primaryKey, indexes = schema.indexes;
                var extractKey = primaryKey.extractKey, outbound = primaryKey.outbound;
                var indexesWithAutoIncPK = primaryKey.autoIncrement && indexes.filter(function(index) {
                    return index.compound && index.keyPath.includes(primaryKey.keyPath);
                });
                var tableClone = $f8ed024a6db1f9db$var$__assign($f8ed024a6db1f9db$var$__assign({}, table), {
                    mutate: function(req) {
                        var _a, _b;
                        var trans = req.trans;
                        var mutatedParts = req.mutatedParts || (req.mutatedParts = {});
                        var getRangeSet = function(indexName) {
                            var part = "idb://".concat(dbName, "/").concat(tableName, "/").concat(indexName);
                            return mutatedParts[part] || (mutatedParts[part] = new $f8ed024a6db1f9db$export$34cb5241245008dd());
                        };
                        var pkRangeSet = getRangeSet("");
                        var delsRangeSet = getRangeSet(":dels");
                        var type = req.type;
                        var _c = req.type === "deleteRange" ? [
                            req.range
                        ] : req.type === "delete" ? [
                            req.keys
                        ] : req.values.length < 50 ? [
                            $f8ed024a6db1f9db$var$getEffectiveKeys(primaryKey, req).filter(function(id) {
                                return id;
                            }),
                            req.values
                        ] : [], keys = _c[0], newObjs = _c[1];
                        var oldCache = req.trans["_cache"];
                        if ($f8ed024a6db1f9db$var$isArray(keys)) {
                            pkRangeSet.addKeys(keys);
                            var oldObjs = type === 'delete' || keys.length === newObjs.length ? $f8ed024a6db1f9db$var$getFromTransactionCache(keys, oldCache) : null;
                            if (!oldObjs) delsRangeSet.addKeys(keys);
                            if (oldObjs || newObjs) $f8ed024a6db1f9db$var$trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs);
                        } else if (keys) {
                            var range = {
                                from: (_a = keys.lower) !== null && _a !== void 0 ? _a : core.MIN_KEY,
                                to: (_b = keys.upper) !== null && _b !== void 0 ? _b : core.MAX_KEY
                            };
                            delsRangeSet.add(range);
                            pkRangeSet.add(range);
                        } else {
                            pkRangeSet.add(FULL_RANGE);
                            delsRangeSet.add(FULL_RANGE);
                            schema.indexes.forEach(function(idx) {
                                return getRangeSet(idx.name).add(FULL_RANGE);
                            });
                        }
                        return table.mutate(req).then(function(res) {
                            if (keys && (req.type === 'add' || req.type === 'put')) {
                                pkRangeSet.addKeys(res.results);
                                if (indexesWithAutoIncPK) indexesWithAutoIncPK.forEach(function(idx) {
                                    var idxVals = req.values.map(function(v) {
                                        return idx.extractKey(v);
                                    });
                                    var pkPos = idx.keyPath.findIndex(function(prop) {
                                        return prop === primaryKey.keyPath;
                                    });
                                    for(var i = 0, len = res.results.length; i < len; ++i)idxVals[i][pkPos] = res.results[i];
                                    getRangeSet(idx.name).addKeys(idxVals);
                                });
                            }
                            trans.mutatedParts = $f8ed024a6db1f9db$var$extendObservabilitySet(trans.mutatedParts || {}, mutatedParts);
                            return res;
                        });
                    }
                });
                var getRange = function(_a) {
                    var _b, _c;
                    var _d = _a.query, index = _d.index, range = _d.range;
                    return [
                        index,
                        new $f8ed024a6db1f9db$export$34cb5241245008dd((_b = range.lower) !== null && _b !== void 0 ? _b : core.MIN_KEY, (_c = range.upper) !== null && _c !== void 0 ? _c : core.MAX_KEY)
                    ];
                };
                var readSubscribers = {
                    get: function(req) {
                        return [
                            primaryKey,
                            new $f8ed024a6db1f9db$export$34cb5241245008dd(req.key)
                        ];
                    },
                    getMany: function(req) {
                        return [
                            primaryKey,
                            new $f8ed024a6db1f9db$export$34cb5241245008dd().addKeys(req.keys)
                        ];
                    },
                    count: getRange,
                    query: getRange,
                    openCursor: getRange
                };
                $f8ed024a6db1f9db$var$keys(readSubscribers).forEach(function(method) {
                    tableClone[method] = function(req) {
                        var subscr = $f8ed024a6db1f9db$var$PSD.subscr;
                        var isLiveQuery = !!subscr;
                        var cachable = $f8ed024a6db1f9db$var$isCachableContext($f8ed024a6db1f9db$var$PSD, table) && $f8ed024a6db1f9db$var$isCachableRequest(method, req);
                        var obsSet = cachable ? req.obsSet = {} : subscr;
                        if (isLiveQuery) {
                            var getRangeSet = function(indexName) {
                                var part = "idb://".concat(dbName, "/").concat(tableName, "/").concat(indexName);
                                return obsSet[part] || (obsSet[part] = new $f8ed024a6db1f9db$export$34cb5241245008dd());
                            };
                            var pkRangeSet_1 = getRangeSet("");
                            var delsRangeSet_1 = getRangeSet(":dels");
                            var _a = readSubscribers[method](req), queriedIndex = _a[0], queriedRanges = _a[1];
                            if (method === 'query' && queriedIndex.isPrimaryKey && !req.values) delsRangeSet_1.add(queriedRanges);
                            else getRangeSet(queriedIndex.name || "").add(queriedRanges);
                            if (!queriedIndex.isPrimaryKey) {
                                if (method === "count") delsRangeSet_1.add(FULL_RANGE);
                                else {
                                    var keysPromise_1 = method === "query" && outbound && req.values && table.query($f8ed024a6db1f9db$var$__assign($f8ed024a6db1f9db$var$__assign({}, req), {
                                        values: false
                                    }));
                                    return table[method].apply(this, arguments).then(function(res) {
                                        if (method === "query") {
                                            if (outbound && req.values) return keysPromise_1.then(function(_a) {
                                                var resultingKeys = _a.result;
                                                pkRangeSet_1.addKeys(resultingKeys);
                                                return res;
                                            });
                                            var pKeys = req.values ? res.result.map(extractKey) : res.result;
                                            if (req.values) pkRangeSet_1.addKeys(pKeys);
                                            else delsRangeSet_1.addKeys(pKeys);
                                        } else if (method === "openCursor") {
                                            var cursor_1 = res;
                                            var wantValues_1 = req.values;
                                            return cursor_1 && Object.create(cursor_1, {
                                                key: {
                                                    get: function() {
                                                        delsRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.key;
                                                    }
                                                },
                                                primaryKey: {
                                                    get: function() {
                                                        var pkey = cursor_1.primaryKey;
                                                        delsRangeSet_1.addKey(pkey);
                                                        return pkey;
                                                    }
                                                },
                                                value: {
                                                    get: function() {
                                                        wantValues_1 && pkRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.value;
                                                    }
                                                }
                                            });
                                        }
                                        return res;
                                    });
                                }
                            }
                        }
                        return table[method].apply(this, arguments);
                    };
                });
                return tableClone;
            }
        });
    }
};
function $f8ed024a6db1f9db$var$trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs) {
    function addAffectedIndex(ix) {
        var rangeSet = getRangeSet(ix.name || "");
        function extractKey(obj) {
            return obj != null ? ix.extractKey(obj) : null;
        }
        var addKeyOrKeys = function(key) {
            return ix.multiEntry && $f8ed024a6db1f9db$var$isArray(key) ? key.forEach(function(key) {
                return rangeSet.addKey(key);
            }) : rangeSet.addKey(key);
        };
        (oldObjs || newObjs).forEach(function(_, i) {
            var oldKey = oldObjs && extractKey(oldObjs[i]);
            var newKey = newObjs && extractKey(newObjs[i]);
            if ($f8ed024a6db1f9db$export$6154dcdb7d23e37b(oldKey, newKey) !== 0) {
                if (oldKey != null) addKeyOrKeys(oldKey);
                if (newKey != null) addKeyOrKeys(newKey);
            }
        });
    }
    schema.indexes.forEach(addAffectedIndex);
}
function $f8ed024a6db1f9db$var$adjustOptimisticFromFailures(tblCache, req, res) {
    if (res.numFailures === 0) return req;
    if (req.type === 'deleteRange') return null;
    var numBulkOps = req.keys ? req.keys.length : 'values' in req && req.values ? req.values.length : 1;
    if (res.numFailures === numBulkOps) return null;
    var clone = $f8ed024a6db1f9db$var$__assign({}, req);
    if ($f8ed024a6db1f9db$var$isArray(clone.keys)) clone.keys = clone.keys.filter(function(_, i) {
        return !(i in res.failures);
    });
    if ('values' in clone && $f8ed024a6db1f9db$var$isArray(clone.values)) clone.values = clone.values.filter(function(_, i) {
        return !(i in res.failures);
    });
    return clone;
}
function $f8ed024a6db1f9db$var$isAboveLower(key, range) {
    return range.lower === undefined ? true : range.lowerOpen ? $f8ed024a6db1f9db$export$6154dcdb7d23e37b(key, range.lower) > 0 : $f8ed024a6db1f9db$export$6154dcdb7d23e37b(key, range.lower) >= 0;
}
function $f8ed024a6db1f9db$var$isBelowUpper(key, range) {
    return range.upper === undefined ? true : range.upperOpen ? $f8ed024a6db1f9db$export$6154dcdb7d23e37b(key, range.upper) < 0 : $f8ed024a6db1f9db$export$6154dcdb7d23e37b(key, range.upper) <= 0;
}
function $f8ed024a6db1f9db$var$isWithinRange(key, range) {
    return $f8ed024a6db1f9db$var$isAboveLower(key, range) && $f8ed024a6db1f9db$var$isBelowUpper(key, range);
}
function $f8ed024a6db1f9db$var$applyOptimisticOps(result, req, ops, table, cacheEntry, immutable) {
    if (!ops || ops.length === 0) return result;
    var index = req.query.index;
    var multiEntry = index.multiEntry;
    var queryRange = req.query.range;
    var primaryKey = table.schema.primaryKey;
    var extractPrimKey = primaryKey.extractKey;
    var extractIndex = index.extractKey;
    var extractLowLevelIndex = (index.lowLevelIndex || index).extractKey;
    var finalResult = ops.reduce(function(result, op) {
        var modifedResult = result;
        var includedValues = [];
        if (op.type === 'add' || op.type === 'put') {
            var includedPKs = new $f8ed024a6db1f9db$export$34cb5241245008dd();
            for(var i = op.values.length - 1; i >= 0; --i){
                var value = op.values[i];
                var pk = extractPrimKey(value);
                if (includedPKs.hasKey(pk)) continue;
                var key = extractIndex(value);
                if (multiEntry && $f8ed024a6db1f9db$var$isArray(key) ? key.some(function(k) {
                    return $f8ed024a6db1f9db$var$isWithinRange(k, queryRange);
                }) : $f8ed024a6db1f9db$var$isWithinRange(key, queryRange)) {
                    includedPKs.addKey(pk);
                    includedValues.push(value);
                }
            }
        }
        switch(op.type){
            case 'add':
                var existingKeys_1 = new $f8ed024a6db1f9db$export$34cb5241245008dd().addKeys(req.values ? result.map(function(v) {
                    return extractPrimKey(v);
                }) : result);
                modifedResult = result.concat(req.values ? includedValues.filter(function(v) {
                    var key = extractPrimKey(v);
                    if (existingKeys_1.hasKey(key)) return false;
                    existingKeys_1.addKey(key);
                    return true;
                }) : includedValues.map(function(v) {
                    return extractPrimKey(v);
                }).filter(function(k) {
                    if (existingKeys_1.hasKey(k)) return false;
                    existingKeys_1.addKey(k);
                    return true;
                }));
                break;
            case 'put':
                var keySet_1 = new $f8ed024a6db1f9db$export$34cb5241245008dd().addKeys(op.values.map(function(v) {
                    return extractPrimKey(v);
                }));
                modifedResult = result.filter(function(item) {
                    return !keySet_1.hasKey(req.values ? extractPrimKey(item) : item);
                }).concat(req.values ? includedValues : includedValues.map(function(v) {
                    return extractPrimKey(v);
                }));
                break;
            case 'delete':
                var keysToDelete_1 = new $f8ed024a6db1f9db$export$34cb5241245008dd().addKeys(op.keys);
                modifedResult = result.filter(function(item) {
                    return !keysToDelete_1.hasKey(req.values ? extractPrimKey(item) : item);
                });
                break;
            case 'deleteRange':
                var range_1 = op.range;
                modifedResult = result.filter(function(item) {
                    return !$f8ed024a6db1f9db$var$isWithinRange(extractPrimKey(item), range_1);
                });
                break;
        }
        return modifedResult;
    }, result);
    if (finalResult === result) return result;
    finalResult.sort(function(a, b) {
        return $f8ed024a6db1f9db$export$6154dcdb7d23e37b(extractLowLevelIndex(a), extractLowLevelIndex(b)) || $f8ed024a6db1f9db$export$6154dcdb7d23e37b(extractPrimKey(a), extractPrimKey(b));
    });
    if (req.limit && req.limit < Infinity) {
        if (finalResult.length > req.limit) finalResult.length = req.limit;
        else if (result.length === req.limit && finalResult.length < req.limit) cacheEntry.dirty = true;
    }
    return immutable ? Object.freeze(finalResult) : finalResult;
}
function $f8ed024a6db1f9db$var$areRangesEqual(r1, r2) {
    return $f8ed024a6db1f9db$export$6154dcdb7d23e37b(r1.lower, r2.lower) === 0 && $f8ed024a6db1f9db$export$6154dcdb7d23e37b(r1.upper, r2.upper) === 0 && !!r1.lowerOpen === !!r2.lowerOpen && !!r1.upperOpen === !!r2.upperOpen;
}
function $f8ed024a6db1f9db$var$compareLowers(lower1, lower2, lowerOpen1, lowerOpen2) {
    if (lower1 === undefined) return lower2 !== undefined ? -1 : 0;
    if (lower2 === undefined) return 1;
    var c = $f8ed024a6db1f9db$export$6154dcdb7d23e37b(lower1, lower2);
    if (c === 0) {
        if (lowerOpen1 && lowerOpen2) return 0;
        if (lowerOpen1) return 1;
        if (lowerOpen2) return -1;
    }
    return c;
}
function $f8ed024a6db1f9db$var$compareUppers(upper1, upper2, upperOpen1, upperOpen2) {
    if (upper1 === undefined) return upper2 !== undefined ? 1 : 0;
    if (upper2 === undefined) return -1;
    var c = $f8ed024a6db1f9db$export$6154dcdb7d23e37b(upper1, upper2);
    if (c === 0) {
        if (upperOpen1 && upperOpen2) return 0;
        if (upperOpen1) return -1;
        if (upperOpen2) return 1;
    }
    return c;
}
function $f8ed024a6db1f9db$var$isSuperRange(r1, r2) {
    return $f8ed024a6db1f9db$var$compareLowers(r1.lower, r2.lower, r1.lowerOpen, r2.lowerOpen) <= 0 && $f8ed024a6db1f9db$var$compareUppers(r1.upper, r2.upper, r1.upperOpen, r2.upperOpen) >= 0;
}
function $f8ed024a6db1f9db$var$findCompatibleQuery(dbName, tableName, type, req) {
    var tblCache = $f8ed024a6db1f9db$var$cache["idb://".concat(dbName, "/").concat(tableName)];
    if (!tblCache) return [];
    var queries = tblCache.queries[type];
    if (!queries) return [
        null,
        false,
        tblCache,
        null
    ];
    var indexName = req.query ? req.query.index.name : null;
    var entries = queries[indexName || ''];
    if (!entries) return [
        null,
        false,
        tblCache,
        null
    ];
    switch(type){
        case 'query':
            var equalEntry = entries.find(function(entry) {
                return entry.req.limit === req.limit && entry.req.values === req.values && $f8ed024a6db1f9db$var$areRangesEqual(entry.req.query.range, req.query.range);
            });
            if (equalEntry) return [
                equalEntry,
                true,
                tblCache,
                entries
            ];
            var superEntry = entries.find(function(entry) {
                var limit = 'limit' in entry.req ? entry.req.limit : Infinity;
                return limit >= req.limit && (req.values ? entry.req.values : true) && $f8ed024a6db1f9db$var$isSuperRange(entry.req.query.range, req.query.range);
            });
            return [
                superEntry,
                false,
                tblCache,
                entries
            ];
        case 'count':
            var countQuery = entries.find(function(entry) {
                return $f8ed024a6db1f9db$var$areRangesEqual(entry.req.query.range, req.query.range);
            });
            return [
                countQuery,
                !!countQuery,
                tblCache,
                entries
            ];
    }
}
function $f8ed024a6db1f9db$var$subscribeToCacheEntry(cacheEntry, container, requery, signal) {
    cacheEntry.subscribers.add(requery);
    signal.addEventListener("abort", function() {
        cacheEntry.subscribers.delete(requery);
        if (cacheEntry.subscribers.size === 0) $f8ed024a6db1f9db$var$enqueForDeletion(cacheEntry, container);
    });
}
function $f8ed024a6db1f9db$var$enqueForDeletion(cacheEntry, container) {
    setTimeout(function() {
        if (cacheEntry.subscribers.size === 0) $f8ed024a6db1f9db$var$delArrayItem(container, cacheEntry);
    }, 3000);
}
var $f8ed024a6db1f9db$var$cacheMiddleware = {
    stack: 'dbcore',
    level: 0,
    name: 'Cache',
    create: function(core) {
        var dbName = core.schema.name;
        var coreMW = $f8ed024a6db1f9db$var$__assign($f8ed024a6db1f9db$var$__assign({}, core), {
            transaction: function(stores, mode, options) {
                var idbtrans = core.transaction(stores, mode, options);
                if (mode === 'readwrite') {
                    var ac_1 = new AbortController();
                    var signal = ac_1.signal;
                    var endTransaction = function(wasCommitted) {
                        return function() {
                            ac_1.abort();
                            if (mode === 'readwrite') {
                                var affectedSubscribers_1 = new Set();
                                for(var _i = 0, stores_1 = stores; _i < stores_1.length; _i++){
                                    var storeName = stores_1[_i];
                                    var tblCache = $f8ed024a6db1f9db$var$cache["idb://".concat(dbName, "/").concat(storeName)];
                                    if (tblCache) {
                                        var table = core.table(storeName);
                                        var ops = tblCache.optimisticOps.filter(function(op) {
                                            return op.trans === idbtrans;
                                        });
                                        if (idbtrans._explicit && wasCommitted && idbtrans.mutatedParts) for(var _a = 0, _b = Object.values(tblCache.queries.query); _a < _b.length; _a++){
                                            var entries = _b[_a];
                                            for(var _c = 0, _d = entries.slice(); _c < _d.length; _c++){
                                                var entry = _d[_c];
                                                if ($f8ed024a6db1f9db$var$obsSetsOverlap(entry.obsSet, idbtrans.mutatedParts)) {
                                                    $f8ed024a6db1f9db$var$delArrayItem(entries, entry);
                                                    entry.subscribers.forEach(function(requery) {
                                                        return affectedSubscribers_1.add(requery);
                                                    });
                                                }
                                            }
                                        }
                                        else if (ops.length > 0) {
                                            tblCache.optimisticOps = tblCache.optimisticOps.filter(function(op) {
                                                return op.trans !== idbtrans;
                                            });
                                            for(var _e = 0, _f = Object.values(tblCache.queries.query); _e < _f.length; _e++){
                                                var entries = _f[_e];
                                                for(var _g = 0, _h = entries.slice(); _g < _h.length; _g++){
                                                    var entry = _h[_g];
                                                    if (entry.res != null && idbtrans.mutatedParts) {
                                                        if (wasCommitted && !entry.dirty) {
                                                            var freezeResults = Object.isFrozen(entry.res);
                                                            var modRes = $f8ed024a6db1f9db$var$applyOptimisticOps(entry.res, entry.req, ops, table, entry, freezeResults);
                                                            if (entry.dirty) {
                                                                $f8ed024a6db1f9db$var$delArrayItem(entries, entry);
                                                                entry.subscribers.forEach(function(requery) {
                                                                    return affectedSubscribers_1.add(requery);
                                                                });
                                                            } else if (modRes !== entry.res) {
                                                                entry.res = modRes;
                                                                entry.promise = $f8ed024a6db1f9db$var$DexiePromise.resolve({
                                                                    result: modRes
                                                                });
                                                            }
                                                        } else {
                                                            if (entry.dirty) $f8ed024a6db1f9db$var$delArrayItem(entries, entry);
                                                            entry.subscribers.forEach(function(requery) {
                                                                return affectedSubscribers_1.add(requery);
                                                            });
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                affectedSubscribers_1.forEach(function(requery) {
                                    return requery();
                                });
                            }
                        };
                    };
                    idbtrans.addEventListener('abort', endTransaction(false), {
                        signal: signal
                    });
                    idbtrans.addEventListener('error', endTransaction(false), {
                        signal: signal
                    });
                    idbtrans.addEventListener('complete', endTransaction(true), {
                        signal: signal
                    });
                }
                return idbtrans;
            },
            table: function(tableName) {
                var downTable = core.table(tableName);
                var primKey = downTable.schema.primaryKey;
                var tableMW = $f8ed024a6db1f9db$var$__assign($f8ed024a6db1f9db$var$__assign({}, downTable), {
                    mutate: function(req) {
                        var trans = $f8ed024a6db1f9db$var$PSD.trans;
                        if (primKey.outbound || trans.db._options.cache === 'disabled' || trans.explicit || trans.idbtrans.mode !== 'readwrite') return downTable.mutate(req);
                        var tblCache = $f8ed024a6db1f9db$var$cache["idb://".concat(dbName, "/").concat(tableName)];
                        if (!tblCache) return downTable.mutate(req);
                        var promise = downTable.mutate(req);
                        if ((req.type === 'add' || req.type === 'put') && (req.values.length >= 50 || $f8ed024a6db1f9db$var$getEffectiveKeys(primKey, req).some(function(key) {
                            return key == null;
                        }))) promise.then(function(res) {
                            var reqWithResolvedKeys = $f8ed024a6db1f9db$var$__assign($f8ed024a6db1f9db$var$__assign({}, req), {
                                values: req.values.map(function(value, i) {
                                    var _a;
                                    if (res.failures[i]) return value;
                                    var valueWithKey = ((_a = primKey.keyPath) === null || _a === void 0 ? void 0 : _a.includes('.')) ? $f8ed024a6db1f9db$var$deepClone(value) : $f8ed024a6db1f9db$var$__assign({}, value);
                                    $f8ed024a6db1f9db$var$setByKeyPath(valueWithKey, primKey.keyPath, res.results[i]);
                                    return valueWithKey;
                                })
                            });
                            var adjustedReq = $f8ed024a6db1f9db$var$adjustOptimisticFromFailures(tblCache, reqWithResolvedKeys, res);
                            tblCache.optimisticOps.push(adjustedReq);
                            queueMicrotask(function() {
                                return req.mutatedParts && $f8ed024a6db1f9db$var$signalSubscribersLazily(req.mutatedParts);
                            });
                        });
                        else {
                            tblCache.optimisticOps.push(req);
                            req.mutatedParts && $f8ed024a6db1f9db$var$signalSubscribersLazily(req.mutatedParts);
                            promise.then(function(res) {
                                if (res.numFailures > 0) {
                                    $f8ed024a6db1f9db$var$delArrayItem(tblCache.optimisticOps, req);
                                    var adjustedReq = $f8ed024a6db1f9db$var$adjustOptimisticFromFailures(tblCache, req, res);
                                    if (adjustedReq) tblCache.optimisticOps.push(adjustedReq);
                                    req.mutatedParts && $f8ed024a6db1f9db$var$signalSubscribersLazily(req.mutatedParts);
                                }
                            });
                            promise.catch(function() {
                                $f8ed024a6db1f9db$var$delArrayItem(tblCache.optimisticOps, req);
                                req.mutatedParts && $f8ed024a6db1f9db$var$signalSubscribersLazily(req.mutatedParts);
                            });
                        }
                        return promise;
                    },
                    query: function(req) {
                        var _a;
                        if (!$f8ed024a6db1f9db$var$isCachableContext($f8ed024a6db1f9db$var$PSD, downTable) || !$f8ed024a6db1f9db$var$isCachableRequest("query", req)) return downTable.query(req);
                        var freezeResults = ((_a = $f8ed024a6db1f9db$var$PSD.trans) === null || _a === void 0 ? void 0 : _a.db._options.cache) === 'immutable';
                        var _b = $f8ed024a6db1f9db$var$PSD, requery = _b.requery, signal = _b.signal;
                        var _c = $f8ed024a6db1f9db$var$findCompatibleQuery(dbName, tableName, 'query', req), cacheEntry = _c[0], exactMatch = _c[1], tblCache = _c[2], container = _c[3];
                        if (cacheEntry && exactMatch) cacheEntry.obsSet = req.obsSet;
                        else {
                            var promise = downTable.query(req).then(function(res) {
                                var result = res.result;
                                if (cacheEntry) cacheEntry.res = result;
                                if (freezeResults) {
                                    for(var i = 0, l = result.length; i < l; ++i)Object.freeze(result[i]);
                                    Object.freeze(result);
                                } else res.result = $f8ed024a6db1f9db$var$deepClone(result);
                                return res;
                            }).catch(function(error) {
                                if (container && cacheEntry) $f8ed024a6db1f9db$var$delArrayItem(container, cacheEntry);
                                return Promise.reject(error);
                            });
                            cacheEntry = {
                                obsSet: req.obsSet,
                                promise: promise,
                                subscribers: new Set(),
                                type: 'query',
                                req: req,
                                dirty: false
                            };
                            if (container) container.push(cacheEntry);
                            else {
                                container = [
                                    cacheEntry
                                ];
                                if (!tblCache) tblCache = $f8ed024a6db1f9db$var$cache["idb://".concat(dbName, "/").concat(tableName)] = {
                                    queries: {
                                        query: {},
                                        count: {}
                                    },
                                    objs: new Map(),
                                    optimisticOps: [],
                                    unsignaledParts: {}
                                };
                                tblCache.queries.query[req.query.index.name || ''] = container;
                            }
                        }
                        $f8ed024a6db1f9db$var$subscribeToCacheEntry(cacheEntry, container, requery, signal);
                        return cacheEntry.promise.then(function(res) {
                            return {
                                result: $f8ed024a6db1f9db$var$applyOptimisticOps(res.result, req, tblCache === null || tblCache === void 0 ? void 0 : tblCache.optimisticOps, downTable, cacheEntry, freezeResults)
                            };
                        });
                    }
                });
                return tableMW;
            }
        });
        return coreMW;
    }
};
function $f8ed024a6db1f9db$var$vipify(target, vipDb) {
    return new Proxy(target, {
        get: function(target, prop, receiver) {
            if (prop === 'db') return vipDb;
            return Reflect.get(target, prop, receiver);
        }
    });
}
var $f8ed024a6db1f9db$export$4ece27d405df7279 = function() {
    function Dexie(name, options) {
        var _this = this;
        this._middlewares = {};
        this.verno = 0;
        var deps = Dexie.dependencies;
        this._options = options = $f8ed024a6db1f9db$var$__assign({
            addons: Dexie.addons,
            autoOpen: true,
            indexedDB: deps.indexedDB,
            IDBKeyRange: deps.IDBKeyRange,
            cache: 'cloned'
        }, options);
        this._deps = {
            indexedDB: options.indexedDB,
            IDBKeyRange: options.IDBKeyRange
        };
        var addons = options.addons;
        this._dbSchema = {};
        this._versions = [];
        this._storeNames = [];
        this._allTables = {};
        this.idbdb = null;
        this._novip = this;
        var state = {
            dbOpenError: null,
            isBeingOpened: false,
            onReadyBeingFired: null,
            openComplete: false,
            dbReadyResolve: $f8ed024a6db1f9db$var$nop,
            dbReadyPromise: null,
            cancelOpen: $f8ed024a6db1f9db$var$nop,
            openCanceller: null,
            autoSchema: true,
            PR1398_maxLoop: 3,
            autoOpen: options.autoOpen
        };
        state.dbReadyPromise = new $f8ed024a6db1f9db$var$DexiePromise(function(resolve) {
            state.dbReadyResolve = resolve;
        });
        state.openCanceller = new $f8ed024a6db1f9db$var$DexiePromise(function(_, reject) {
            state.cancelOpen = reject;
        });
        this._state = state;
        this.name = name;
        this.on = $f8ed024a6db1f9db$var$Events(this, "populate", "blocked", "versionchange", "close", {
            ready: [
                $f8ed024a6db1f9db$var$promisableChain,
                $f8ed024a6db1f9db$var$nop
            ]
        });
        this.on.ready.subscribe = $f8ed024a6db1f9db$var$override(this.on.ready.subscribe, function(subscribe) {
            return function(subscriber, bSticky) {
                Dexie.vip(function() {
                    var state = _this._state;
                    if (state.openComplete) {
                        if (!state.dbOpenError) $f8ed024a6db1f9db$var$DexiePromise.resolve().then(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else if (state.onReadyBeingFired) {
                        state.onReadyBeingFired.push(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else {
                        subscribe(subscriber);
                        var db_1 = _this;
                        if (!bSticky) subscribe(function unsubscribe() {
                            db_1.on.ready.unsubscribe(subscriber);
                            db_1.on.ready.unsubscribe(unsubscribe);
                        });
                    }
                });
            };
        });
        this.Collection = $f8ed024a6db1f9db$var$createCollectionConstructor(this);
        this.Table = $f8ed024a6db1f9db$var$createTableConstructor(this);
        this.Transaction = $f8ed024a6db1f9db$var$createTransactionConstructor(this);
        this.Version = $f8ed024a6db1f9db$var$createVersionConstructor(this);
        this.WhereClause = $f8ed024a6db1f9db$var$createWhereClauseConstructor(this);
        this.on("versionchange", function(ev) {
            if (ev.newVersion > 0) console.warn("Another connection wants to upgrade database '".concat(_this.name, "'. Closing db now to resume the upgrade."));
            else console.warn("Another connection wants to delete database '".concat(_this.name, "'. Closing db now to resume the delete request."));
            _this.close({
                disableAutoOpen: false
            });
        });
        this.on("blocked", function(ev) {
            if (!ev.newVersion || ev.newVersion < ev.oldVersion) console.warn("Dexie.delete('".concat(_this.name, "') was blocked"));
            else console.warn("Upgrade '".concat(_this.name, "' blocked by other connection holding version ").concat(ev.oldVersion / 10));
        });
        this._maxKey = $f8ed024a6db1f9db$var$getMaxKey(options.IDBKeyRange);
        this._createTransaction = function(mode, storeNames, dbschema, parentTransaction) {
            return new _this.Transaction(mode, storeNames, dbschema, _this._options.chromeTransactionDurability, parentTransaction);
        };
        this._fireOnBlocked = function(ev) {
            _this.on("blocked").fire(ev);
            $f8ed024a6db1f9db$var$connections.filter(function(c) {
                return c.name === _this.name && c !== _this && !c._state.vcFired;
            }).map(function(c) {
                return c.on("versionchange").fire(ev);
            });
        };
        this.use($f8ed024a6db1f9db$var$cacheExistingValuesMiddleware);
        this.use($f8ed024a6db1f9db$var$cacheMiddleware);
        this.use($f8ed024a6db1f9db$var$observabilityMiddleware);
        this.use($f8ed024a6db1f9db$var$virtualIndexMiddleware);
        this.use($f8ed024a6db1f9db$var$hooksMiddleware);
        var vipDB = new Proxy(this, {
            get: function(_, prop, receiver) {
                if (prop === '_vip') return true;
                if (prop === 'table') return function(tableName) {
                    return $f8ed024a6db1f9db$var$vipify(_this.table(tableName), vipDB);
                };
                var rv = Reflect.get(_, prop, receiver);
                if (rv instanceof $f8ed024a6db1f9db$var$Table) return $f8ed024a6db1f9db$var$vipify(rv, vipDB);
                if (prop === 'tables') return rv.map(function(t) {
                    return $f8ed024a6db1f9db$var$vipify(t, vipDB);
                });
                if (prop === '_createTransaction') return function() {
                    var tx = rv.apply(this, arguments);
                    return $f8ed024a6db1f9db$var$vipify(tx, vipDB);
                };
                return rv;
            }
        });
        this.vip = vipDB;
        addons.forEach(function(addon) {
            return addon(_this);
        });
    }
    Dexie.prototype.version = function(versionNumber) {
        if (isNaN(versionNumber) || versionNumber < 0.1) throw new $f8ed024a6db1f9db$var$exceptions.Type("Given version is not a positive number");
        versionNumber = Math.round(versionNumber * 10) / 10;
        if (this.idbdb || this._state.isBeingOpened) throw new $f8ed024a6db1f9db$var$exceptions.Schema("Cannot add version when database is open");
        this.verno = Math.max(this.verno, versionNumber);
        var versions = this._versions;
        var versionInstance = versions.filter(function(v) {
            return v._cfg.version === versionNumber;
        })[0];
        if (versionInstance) return versionInstance;
        versionInstance = new this.Version(versionNumber);
        versions.push(versionInstance);
        versions.sort($f8ed024a6db1f9db$var$lowerVersionFirst);
        versionInstance.stores({});
        this._state.autoSchema = false;
        return versionInstance;
    };
    Dexie.prototype._whenReady = function(fn) {
        var _this = this;
        return this.idbdb && (this._state.openComplete || $f8ed024a6db1f9db$var$PSD.letThrough || this._vip) ? fn() : new $f8ed024a6db1f9db$var$DexiePromise(function(resolve, reject) {
            if (_this._state.openComplete) return reject(new $f8ed024a6db1f9db$var$exceptions.DatabaseClosed(_this._state.dbOpenError));
            if (!_this._state.isBeingOpened) {
                if (!_this._state.autoOpen) {
                    reject(new $f8ed024a6db1f9db$var$exceptions.DatabaseClosed());
                    return;
                }
                _this.open().catch($f8ed024a6db1f9db$var$nop);
            }
            _this._state.dbReadyPromise.then(resolve, reject);
        }).then(fn);
    };
    Dexie.prototype.use = function(_a) {
        var stack = _a.stack, create = _a.create, level = _a.level, name = _a.name;
        if (name) this.unuse({
            stack: stack,
            name: name
        });
        var middlewares = this._middlewares[stack] || (this._middlewares[stack] = []);
        middlewares.push({
            stack: stack,
            create: create,
            level: level == null ? 10 : level,
            name: name
        });
        middlewares.sort(function(a, b) {
            return a.level - b.level;
        });
        return this;
    };
    Dexie.prototype.unuse = function(_a) {
        var stack = _a.stack, name = _a.name, create = _a.create;
        if (stack && this._middlewares[stack]) this._middlewares[stack] = this._middlewares[stack].filter(function(mw) {
            return create ? mw.create !== create : name ? mw.name !== name : false;
        });
        return this;
    };
    Dexie.prototype.open = function() {
        var _this = this;
        return $f8ed024a6db1f9db$var$usePSD($f8ed024a6db1f9db$var$globalPSD, function() {
            return $f8ed024a6db1f9db$var$dexieOpen(_this);
        });
    };
    Dexie.prototype._close = function() {
        var state = this._state;
        var idx = $f8ed024a6db1f9db$var$connections.indexOf(this);
        if (idx >= 0) $f8ed024a6db1f9db$var$connections.splice(idx, 1);
        if (this.idbdb) {
            try {
                this.idbdb.close();
            } catch (e) {}
            this.idbdb = null;
        }
        if (!state.isBeingOpened) {
            state.dbReadyPromise = new $f8ed024a6db1f9db$var$DexiePromise(function(resolve) {
                state.dbReadyResolve = resolve;
            });
            state.openCanceller = new $f8ed024a6db1f9db$var$DexiePromise(function(_, reject) {
                state.cancelOpen = reject;
            });
        }
    };
    Dexie.prototype.close = function(_a) {
        var _b = _a === void 0 ? {
            disableAutoOpen: true
        } : _a, disableAutoOpen = _b.disableAutoOpen;
        var state = this._state;
        if (disableAutoOpen) {
            if (state.isBeingOpened) state.cancelOpen(new $f8ed024a6db1f9db$var$exceptions.DatabaseClosed());
            this._close();
            state.autoOpen = false;
            state.dbOpenError = new $f8ed024a6db1f9db$var$exceptions.DatabaseClosed();
        } else {
            this._close();
            state.autoOpen = this._options.autoOpen || state.isBeingOpened;
            state.openComplete = false;
            state.dbOpenError = null;
        }
    };
    Dexie.prototype.delete = function(closeOptions) {
        var _this = this;
        if (closeOptions === void 0) closeOptions = {
            disableAutoOpen: true
        };
        var hasInvalidArguments = arguments.length > 0 && typeof arguments[0] !== 'object';
        var state = this._state;
        return new $f8ed024a6db1f9db$var$DexiePromise(function(resolve, reject) {
            var doDelete = function() {
                _this.close(closeOptions);
                var req = _this._deps.indexedDB.deleteDatabase(_this.name);
                req.onsuccess = $f8ed024a6db1f9db$var$wrap(function() {
                    $f8ed024a6db1f9db$var$_onDatabaseDeleted(_this._deps, _this.name);
                    resolve();
                });
                req.onerror = $f8ed024a6db1f9db$var$eventRejectHandler(reject);
                req.onblocked = _this._fireOnBlocked;
            };
            if (hasInvalidArguments) throw new $f8ed024a6db1f9db$var$exceptions.InvalidArgument("Invalid closeOptions argument to db.delete()");
            if (state.isBeingOpened) state.dbReadyPromise.then(doDelete);
            else doDelete();
        });
    };
    Dexie.prototype.backendDB = function() {
        return this.idbdb;
    };
    Dexie.prototype.isOpen = function() {
        return this.idbdb !== null;
    };
    Dexie.prototype.hasBeenClosed = function() {
        var dbOpenError = this._state.dbOpenError;
        return dbOpenError && dbOpenError.name === 'DatabaseClosed';
    };
    Dexie.prototype.hasFailed = function() {
        return this._state.dbOpenError !== null;
    };
    Dexie.prototype.dynamicallyOpened = function() {
        return this._state.autoSchema;
    };
    Object.defineProperty(Dexie.prototype, "tables", {
        get: function() {
            var _this = this;
            return $f8ed024a6db1f9db$var$keys(this._allTables).map(function(name) {
                return _this._allTables[name];
            });
        },
        enumerable: false,
        configurable: true
    });
    Dexie.prototype.transaction = function() {
        var args = $f8ed024a6db1f9db$var$extractTransactionArgs.apply(this, arguments);
        return this._transaction.apply(this, args);
    };
    Dexie.prototype._transaction = function(mode, tables, scopeFunc) {
        var _this = this;
        var parentTransaction = $f8ed024a6db1f9db$var$PSD.trans;
        if (!parentTransaction || parentTransaction.db !== this || mode.indexOf('!') !== -1) parentTransaction = null;
        var onlyIfCompatible = mode.indexOf('?') !== -1;
        mode = mode.replace('!', '').replace('?', '');
        var idbMode, storeNames;
        try {
            storeNames = tables.map(function(table) {
                var storeName = table instanceof _this.Table ? table.name : table;
                if (typeof storeName !== 'string') throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
                return storeName;
            });
            if (mode == "r" || mode === $f8ed024a6db1f9db$var$READONLY) idbMode = $f8ed024a6db1f9db$var$READONLY;
            else if (mode == "rw" || mode == $f8ed024a6db1f9db$var$READWRITE) idbMode = $f8ed024a6db1f9db$var$READWRITE;
            else throw new $f8ed024a6db1f9db$var$exceptions.InvalidArgument("Invalid transaction mode: " + mode);
            if (parentTransaction) {
                if (parentTransaction.mode === $f8ed024a6db1f9db$var$READONLY && idbMode === $f8ed024a6db1f9db$var$READWRITE) {
                    if (onlyIfCompatible) parentTransaction = null;
                    else throw new $f8ed024a6db1f9db$var$exceptions.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
                }
                if (parentTransaction) storeNames.forEach(function(storeName) {
                    if (parentTransaction && parentTransaction.storeNames.indexOf(storeName) === -1) {
                        if (onlyIfCompatible) parentTransaction = null;
                        else throw new $f8ed024a6db1f9db$var$exceptions.SubTransaction("Table " + storeName + " not included in parent transaction.");
                    }
                });
                if (onlyIfCompatible && parentTransaction && !parentTransaction.active) parentTransaction = null;
            }
        } catch (e) {
            return parentTransaction ? parentTransaction._promise(null, function(_, reject) {
                reject(e);
            }) : $f8ed024a6db1f9db$var$rejection(e);
        }
        var enterTransaction = $f8ed024a6db1f9db$var$enterTransactionScope.bind(null, this, idbMode, storeNames, parentTransaction, scopeFunc);
        return parentTransaction ? parentTransaction._promise(idbMode, enterTransaction, "lock") : $f8ed024a6db1f9db$var$PSD.trans ? $f8ed024a6db1f9db$var$usePSD($f8ed024a6db1f9db$var$PSD.transless, function() {
            return _this._whenReady(enterTransaction);
        }) : this._whenReady(enterTransaction);
    };
    Dexie.prototype.table = function(tableName) {
        if (!$f8ed024a6db1f9db$var$hasOwn(this._allTables, tableName)) throw new $f8ed024a6db1f9db$var$exceptions.InvalidTable("Table ".concat(tableName, " does not exist"));
        return this._allTables[tableName];
    };
    return Dexie;
}();
var $f8ed024a6db1f9db$var$symbolObservable = typeof Symbol !== "undefined" && "observable" in Symbol ? Symbol.observable : "@@observable";
var $f8ed024a6db1f9db$var$Observable = function() {
    function Observable(subscribe) {
        this._subscribe = subscribe;
    }
    Observable.prototype.subscribe = function(x, error, complete) {
        return this._subscribe(!x || typeof x === "function" ? {
            next: x,
            error: error,
            complete: complete
        } : x);
    };
    Observable.prototype[$f8ed024a6db1f9db$var$symbolObservable] = function() {
        return this;
    };
    return Observable;
}();
var $f8ed024a6db1f9db$var$domDeps;
try {
    $f8ed024a6db1f9db$var$domDeps = {
        indexedDB: $f8ed024a6db1f9db$var$_global.indexedDB || $f8ed024a6db1f9db$var$_global.mozIndexedDB || $f8ed024a6db1f9db$var$_global.webkitIndexedDB || $f8ed024a6db1f9db$var$_global.msIndexedDB,
        IDBKeyRange: $f8ed024a6db1f9db$var$_global.IDBKeyRange || $f8ed024a6db1f9db$var$_global.webkitIDBKeyRange
    };
} catch (e) {
    $f8ed024a6db1f9db$var$domDeps = {
        indexedDB: null,
        IDBKeyRange: null
    };
}
function $f8ed024a6db1f9db$export$6a9705d8f6f38796(querier) {
    var hasValue = false;
    var currentValue;
    var observable = new $f8ed024a6db1f9db$var$Observable(function(observer) {
        var scopeFuncIsAsync = $f8ed024a6db1f9db$var$isAsyncFunction(querier);
        function execute(ctx) {
            var wasRootExec = $f8ed024a6db1f9db$var$beginMicroTickScope();
            try {
                if (scopeFuncIsAsync) $f8ed024a6db1f9db$var$incrementExpectedAwaits();
                var rv = $f8ed024a6db1f9db$var$newScope(querier, ctx);
                if (scopeFuncIsAsync) rv = rv.finally($f8ed024a6db1f9db$var$decrementExpectedAwaits);
                return rv;
            } finally{
                wasRootExec && $f8ed024a6db1f9db$var$endMicroTickScope();
            }
        }
        var closed = false;
        var abortController;
        var accumMuts = {};
        var currentObs = {};
        var subscription = {
            get closed () {
                return closed;
            },
            unsubscribe: function() {
                if (closed) return;
                closed = true;
                if (abortController) abortController.abort();
                if (startedListening) $f8ed024a6db1f9db$var$globalEvents.storagemutated.unsubscribe(mutationListener);
            }
        };
        observer.start && observer.start(subscription);
        var startedListening = false;
        var doQuery = function() {
            return $f8ed024a6db1f9db$var$execInGlobalContext(_doQuery);
        };
        function shouldNotify() {
            return $f8ed024a6db1f9db$var$obsSetsOverlap(currentObs, accumMuts);
        }
        var mutationListener = function(parts) {
            $f8ed024a6db1f9db$var$extendObservabilitySet(accumMuts, parts);
            if (shouldNotify()) doQuery();
        };
        var _doQuery = function() {
            if (closed || !$f8ed024a6db1f9db$var$domDeps.indexedDB) return;
            accumMuts = {};
            var subscr = {};
            if (abortController) abortController.abort();
            abortController = new AbortController();
            var ctx = {
                subscr: subscr,
                signal: abortController.signal,
                requery: doQuery,
                querier: querier,
                trans: null
            };
            var ret = execute(ctx);
            Promise.resolve(ret).then(function(result) {
                hasValue = true;
                currentValue = result;
                if (closed || ctx.signal.aborted) return;
                accumMuts = {};
                currentObs = subscr;
                if (!$f8ed024a6db1f9db$var$objectIsEmpty(currentObs) && !startedListening) {
                    $f8ed024a6db1f9db$var$globalEvents($f8ed024a6db1f9db$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, mutationListener);
                    startedListening = true;
                }
                $f8ed024a6db1f9db$var$execInGlobalContext(function() {
                    return !closed && observer.next && observer.next(result);
                });
            }, function(err) {
                hasValue = false;
                if (![
                    'DatabaseClosedError',
                    'AbortError'
                ].includes(err === null || err === void 0 ? void 0 : err.name)) {
                    if (!closed) $f8ed024a6db1f9db$var$execInGlobalContext(function() {
                        if (closed) return;
                        observer.error && observer.error(err);
                    });
                }
            });
        };
        setTimeout(doQuery, 0);
        return subscription;
    });
    observable.hasValue = function() {
        return hasValue;
    };
    observable.getValue = function() {
        return currentValue;
    };
    return observable;
}
var $f8ed024a6db1f9db$var$Dexie = $f8ed024a6db1f9db$export$4ece27d405df7279;
$f8ed024a6db1f9db$var$props($f8ed024a6db1f9db$var$Dexie, $f8ed024a6db1f9db$var$__assign($f8ed024a6db1f9db$var$__assign({}, $f8ed024a6db1f9db$var$fullNameExceptions), {
    delete: function(databaseName) {
        var db = new $f8ed024a6db1f9db$var$Dexie(databaseName, {
            addons: []
        });
        return db.delete();
    },
    exists: function(name) {
        return new $f8ed024a6db1f9db$var$Dexie(name, {
            addons: []
        }).open().then(function(db) {
            db.close();
            return true;
        }).catch('NoSuchDatabaseError', function() {
            return false;
        });
    },
    getDatabaseNames: function(cb) {
        try {
            return $f8ed024a6db1f9db$var$getDatabaseNames($f8ed024a6db1f9db$var$Dexie.dependencies).then(cb);
        } catch (_a) {
            return $f8ed024a6db1f9db$var$rejection(new $f8ed024a6db1f9db$var$exceptions.MissingAPI());
        }
    },
    defineClass: function() {
        function Class(content) {
            $f8ed024a6db1f9db$var$extend(this, content);
        }
        return Class;
    },
    ignoreTransaction: function(scopeFunc) {
        return $f8ed024a6db1f9db$var$PSD.trans ? $f8ed024a6db1f9db$var$usePSD($f8ed024a6db1f9db$var$PSD.transless, scopeFunc) : scopeFunc();
    },
    vip: $f8ed024a6db1f9db$var$vip,
    async: function(generatorFn) {
        return function() {
            try {
                var rv = $f8ed024a6db1f9db$var$awaitIterator(generatorFn.apply(this, arguments));
                if (!rv || typeof rv.then !== 'function') return $f8ed024a6db1f9db$var$DexiePromise.resolve(rv);
                return rv;
            } catch (e) {
                return $f8ed024a6db1f9db$var$rejection(e);
            }
        };
    },
    spawn: function(generatorFn, args, thiz) {
        try {
            var rv = $f8ed024a6db1f9db$var$awaitIterator(generatorFn.apply(thiz, args || []));
            if (!rv || typeof rv.then !== 'function') return $f8ed024a6db1f9db$var$DexiePromise.resolve(rv);
            return rv;
        } catch (e) {
            return $f8ed024a6db1f9db$var$rejection(e);
        }
    },
    currentTransaction: {
        get: function() {
            return $f8ed024a6db1f9db$var$PSD.trans || null;
        }
    },
    waitFor: function(promiseOrFunction, optionalTimeout) {
        var promise = $f8ed024a6db1f9db$var$DexiePromise.resolve(typeof promiseOrFunction === 'function' ? $f8ed024a6db1f9db$var$Dexie.ignoreTransaction(promiseOrFunction) : promiseOrFunction).timeout(optionalTimeout || 60000);
        return $f8ed024a6db1f9db$var$PSD.trans ? $f8ed024a6db1f9db$var$PSD.trans.waitFor(promise) : promise;
    },
    Promise: $f8ed024a6db1f9db$var$DexiePromise,
    debug: {
        get: function() {
            return $f8ed024a6db1f9db$var$debug;
        },
        set: function(value) {
            $f8ed024a6db1f9db$var$setDebug(value);
        }
    },
    derive: $f8ed024a6db1f9db$var$derive,
    extend: $f8ed024a6db1f9db$var$extend,
    props: $f8ed024a6db1f9db$var$props,
    override: $f8ed024a6db1f9db$var$override,
    Events: $f8ed024a6db1f9db$var$Events,
    on: $f8ed024a6db1f9db$var$globalEvents,
    liveQuery: $f8ed024a6db1f9db$export$6a9705d8f6f38796,
    extendObservabilitySet: $f8ed024a6db1f9db$var$extendObservabilitySet,
    getByKeyPath: $f8ed024a6db1f9db$var$getByKeyPath,
    setByKeyPath: $f8ed024a6db1f9db$var$setByKeyPath,
    delByKeyPath: $f8ed024a6db1f9db$var$delByKeyPath,
    shallowClone: $f8ed024a6db1f9db$var$shallowClone,
    deepClone: $f8ed024a6db1f9db$var$deepClone,
    getObjectDiff: $f8ed024a6db1f9db$var$getObjectDiff,
    cmp: $f8ed024a6db1f9db$export$6154dcdb7d23e37b,
    asap: $f8ed024a6db1f9db$var$asap$1,
    minKey: $f8ed024a6db1f9db$var$minKey,
    addons: [],
    connections: $f8ed024a6db1f9db$var$connections,
    errnames: $f8ed024a6db1f9db$var$errnames,
    dependencies: $f8ed024a6db1f9db$var$domDeps,
    cache: $f8ed024a6db1f9db$var$cache,
    semVer: $f8ed024a6db1f9db$var$DEXIE_VERSION,
    version: $f8ed024a6db1f9db$var$DEXIE_VERSION.split('.').map(function(n) {
        return parseInt(n);
    }).reduce(function(p, c, i) {
        return p + c / Math.pow(10, i * 2);
    })
}));
$f8ed024a6db1f9db$var$Dexie.maxKey = $f8ed024a6db1f9db$var$getMaxKey($f8ed024a6db1f9db$var$Dexie.dependencies.IDBKeyRange);
if (typeof dispatchEvent !== 'undefined' && typeof addEventListener !== 'undefined') {
    $f8ed024a6db1f9db$var$globalEvents($f8ed024a6db1f9db$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(updatedParts) {
        if (!$f8ed024a6db1f9db$var$propagatingLocally) {
            var event_1;
            event_1 = new CustomEvent($f8ed024a6db1f9db$var$STORAGE_MUTATED_DOM_EVENT_NAME, {
                detail: updatedParts
            });
            $f8ed024a6db1f9db$var$propagatingLocally = true;
            dispatchEvent(event_1);
            $f8ed024a6db1f9db$var$propagatingLocally = false;
        }
    });
    addEventListener($f8ed024a6db1f9db$var$STORAGE_MUTATED_DOM_EVENT_NAME, function(_a) {
        var detail = _a.detail;
        if (!$f8ed024a6db1f9db$var$propagatingLocally) $f8ed024a6db1f9db$var$propagateLocally(detail);
    });
}
function $f8ed024a6db1f9db$var$propagateLocally(updateParts) {
    var wasMe = $f8ed024a6db1f9db$var$propagatingLocally;
    try {
        $f8ed024a6db1f9db$var$propagatingLocally = true;
        $f8ed024a6db1f9db$var$globalEvents.storagemutated.fire(updateParts);
        $f8ed024a6db1f9db$var$signalSubscribersNow(updateParts, true);
    } finally{
        $f8ed024a6db1f9db$var$propagatingLocally = wasMe;
    }
}
var $f8ed024a6db1f9db$var$propagatingLocally = false;
var $f8ed024a6db1f9db$var$bc;
var $f8ed024a6db1f9db$var$createBC = function() {};
if (typeof BroadcastChannel !== 'undefined') {
    $f8ed024a6db1f9db$var$createBC = function() {
        $f8ed024a6db1f9db$var$bc = new BroadcastChannel($f8ed024a6db1f9db$var$STORAGE_MUTATED_DOM_EVENT_NAME);
        $f8ed024a6db1f9db$var$bc.onmessage = function(ev) {
            return ev.data && $f8ed024a6db1f9db$var$propagateLocally(ev.data);
        };
    };
    $f8ed024a6db1f9db$var$createBC();
    if (typeof $f8ed024a6db1f9db$var$bc.unref === 'function') $f8ed024a6db1f9db$var$bc.unref();
    $f8ed024a6db1f9db$var$globalEvents($f8ed024a6db1f9db$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
        if (!$f8ed024a6db1f9db$var$propagatingLocally) $f8ed024a6db1f9db$var$bc.postMessage(changedParts);
    });
}
if (typeof addEventListener !== 'undefined') {
    addEventListener('pagehide', function(event) {
        if (!$f8ed024a6db1f9db$export$4ece27d405df7279.disableBfCache && event.persisted) {
            if ($f8ed024a6db1f9db$var$debug) console.debug('Dexie: handling persisted pagehide');
            $f8ed024a6db1f9db$var$bc === null || $f8ed024a6db1f9db$var$bc === void 0 || $f8ed024a6db1f9db$var$bc.close();
            for(var _i = 0, connections_1 = $f8ed024a6db1f9db$var$connections; _i < connections_1.length; _i++){
                var db = connections_1[_i];
                db.close({
                    disableAutoOpen: false
                });
            }
        }
    });
    addEventListener('pageshow', function(event) {
        if (!$f8ed024a6db1f9db$export$4ece27d405df7279.disableBfCache && event.persisted) {
            if ($f8ed024a6db1f9db$var$debug) console.debug('Dexie: handling persisted pageshow');
            $f8ed024a6db1f9db$var$createBC();
            $f8ed024a6db1f9db$var$propagateLocally({
                all: new $f8ed024a6db1f9db$export$34cb5241245008dd(-Infinity, [
                    []
                ])
            });
        }
    });
}
function $f8ed024a6db1f9db$export$e16d8520af44a096(value) {
    return new $f8ed024a6db1f9db$export$4118fdb20badc28d({
        add: value
    });
}
function $f8ed024a6db1f9db$export$cd7f480d6b8286c3(value) {
    return new $f8ed024a6db1f9db$export$4118fdb20badc28d({
        remove: value
    });
}
function $f8ed024a6db1f9db$export$22ef8700548ec20(a, b) {
    return new $f8ed024a6db1f9db$export$4118fdb20badc28d({
        replacePrefix: [
            a,
            b
        ]
    });
}
$f8ed024a6db1f9db$var$DexiePromise.rejectionMapper = $f8ed024a6db1f9db$var$mapError;
$f8ed024a6db1f9db$var$setDebug($f8ed024a6db1f9db$var$debug);


const $2514b74cb35fc8c2$var$databaseName = "goputerEditor";
const $2514b74cb35fc8c2$export$61e7f1dafedc25b3 = 1;
const $2514b74cb35fc8c2$export$34ab9619700f31cc = "files";
const $2514b74cb35fc8c2$export$f932f06c7eb6abeb = new (0, $f8ed024a6db1f9db$export$4ece27d405df7279)($2514b74cb35fc8c2$var$databaseName);
$2514b74cb35fc8c2$export$f932f06c7eb6abeb.version($2514b74cb35fc8c2$export$61e7f1dafedc25b3).stores({
    files: "name, data, type"
});



var $bNfEN = parcelRequire("bNfEN");
var $8b57f80bd45fb842$exports = {};
$8b57f80bd45fb842$exports = import.meta.resolve("e5FoJ");



var $7DyRn = parcelRequire("7DyRn");
class $5768bc44f9ba13fe$var$IOSwitch extends HTMLElement {
    /** @type {boolean} */ #enabled = false;
    /** @type {string} */ #reg;
    constructor(){
        super();
    }
    get enabled() {
        return this.#enabled;
    }
    set enabled(val) {
        this.setAttribute("enabled", val);
        this.setAttribute("aria-checked", val);
        if ((0, $7DyRn.default).vmIsAlive) (0, $7DyRn.default).switchQueue.push({
            register: this.reg,
            enabled: this.enabled
        });
        this.#enabled = val;
        this.#updateLabel();
        const changeEvent = new CustomEvent("change", {
            detail: val
        });
        this.dispatchEvent(changeEvent);
    }
    get reg() {
        return this.#reg;
    }
    set reg(val) {
        this.#reg = val;
        this.#updateLabel();
    }
    #updateLabel() {
        this.setAttribute("aria-label", `light ${this.reg} is ${this.enabled ? "on" : "off"}`);
    }
    connectedCallback() {
        this.reg = this.getAttribute("reg") ?? "io00";
        this.enabled = this.getAttribute("enabled") ?? false;
        const shadow = this.attachShadow({
            mode: "open"
        });
        const stylesheet = document.createElement("link");
        stylesheet.rel = "stylesheet";
        stylesheet.href = $8b57f80bd45fb842$exports;
        const btn = document.createElement("div");
        btn.classList.add("switch");
        this.addEventListener("click", ()=>{
            if ((0, $7DyRn.default).vmIsAlive) this.enabled = !this.enabled;
        });
        this.addEventListener("keydown", (e)=>{
            if (e.key === "Enter") this.click();
        });
        shadow.appendChild(stylesheet);
        shadow.appendChild(btn);
        this.tabIndex = 0;
        this.setAttribute("enabled", this.enabled);
        this.setAttribute("reg", this.reg);
        this.setAttribute("role", "switch");
        this.setAttribute("aria-checked", this.enabled);
    }
    /**
     * @param {string} name 
     * @param {string} oldValue 
     * @param {string} newValue 
     */ attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue != newValue) switch(name){
            case "enabled":
                this.enabled = newValue === "true";
                break;
            case "reg":
                this.reg = newValue;
                break;
            default:
                break;
        }
    }
    static observedAttributes = [
        "enabled",
        "reg"
    ];
}
class $5768bc44f9ba13fe$var$IOLight extends HTMLElement {
    /** @type {boolean} */ #enabled = false;
    /** @type {string} */ #reg;
    constructor(){
        super();
    }
    get enabled() {
        return this.#enabled;
    }
    set enabled(val) {
        this.setAttribute("enabled", val);
        this.#enabled = val;
        this.#updateLabel();
    }
    get reg() {
        return this.#reg;
    }
    set reg(val) {
        this.#reg = val;
        this.#updateLabel();
    }
    #updateLabel() {
        this.setAttribute("aria-label", `light ${this.reg} is ${this.enabled ? "on" : "off"}`);
    }
    connectedCallback() {
        this.reg = this.getAttribute("reg") ?? "io00";
        this.enabled = this.getAttribute("enabled") ?? false;
        const shadow = this.attachShadow({
            mode: "open"
        });
        const stylesheet = document.createElement("link");
        stylesheet.rel = "stylesheet";
        stylesheet.href = $8b57f80bd45fb842$exports;
        const bulb = document.createElement("div");
        bulb.classList.add("bulb");
        shadow.appendChild(stylesheet);
        shadow.appendChild(bulb);
        this.setAttribute("enabled", this.enabled);
        this.setAttribute("reg", this.reg);
        this.#updateLabel();
    }
    /**
     * @param {string} name 
     * @param {string} oldValue 
     * @param {string} newValue 
     */ attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue != newValue) switch(name){
            case "enabled":
                this.enabled = newValue === "true";
                break;
            case "reg":
                this.reg = newValue;
                break;
            default:
                break;
        }
    }
    static observedAttributes = [
        "enabled",
        "reg"
    ];
}
customElements.define("io-switch", $5768bc44f9ba13fe$var$IOSwitch);
customElements.define("io-light", $5768bc44f9ba13fe$var$IOLight);
var $5768bc44f9ba13fe$export$2e2bcd8739ae039 = {};




var $dLq9J = parcelRequire("dLq9J");

var $bHLtA = parcelRequire("bHLtA");
await (0, $bNfEN.goputer).workerInit();
// Editor init
let $10c90e54c8ae0167$var$files = await (0, $2514b74cb35fc8c2$export$f932f06c7eb6abeb).table((0, $2514b74cb35fc8c2$export$34ab9619700f31cc)).toArray();
if ($10c90e54c8ae0167$var$files.length != 0) {
    for (const element of $10c90e54c8ae0167$var$files){
        (0, $4864cf74b2333fa3$export$6b897890ed9cf9df)(element.name, false);
        if (element.type == "image") {
            const imgBlob = new Blob([
                element.data
            ]);
            (0, $4864cf74b2333fa3$export$1a174d7d284a26e2)(imgBlob, element.name);
        }
        await (0, $bNfEN.goputer).files.update(element.name, element.data, element.data.length, element.type, true, false);
    }
    // Make sure main.gpasm is at beginning
    const mainTab = document.querySelector(`code-tab[filename="main.gpasm"]`);
    document.getElementById("code-names-container").prepend(mainTab);
    (0, $4864cf74b2333fa3$export$f6acc09de0557d94)("main.gpasm");
} else (0, $4864cf74b2333fa3$export$6b897890ed9cf9df)("main.gpasm");
(0, $bHLtA.setVersion)();
const $10c90e54c8ae0167$export$96e737b0349ce11f = document.getElementById("examples-div");
(0, $9515b9ba06508bd8$export$f08e7c5fc9ab694a)();
//Debug UI
const $10c90e54c8ae0167$export$90a0d993c601caf8 = document.getElementById("program-counter");
const $10c90e54c8ae0167$export$dc61b14e6b2175fe = document.getElementById("current-instruction");
//Init Canvas
/**
 * @type {HTMLCanvasElement}
 */ const $10c90e54c8ae0167$export$67ea982130081db = document.getElementById("render-canvas");
const $10c90e54c8ae0167$var$offscreenCanvas = $10c90e54c8ae0167$export$67ea982130081db.transferControlToOffscreen();
await (0, $bNfEN.goputer).drawing.setupCanvas($dLq9J.transfer($10c90e54c8ae0167$var$offscreenCanvas, [
    $10c90e54c8ae0167$var$offscreenCanvas
]));
$10c90e54c8ae0167$export$67ea982130081db.addEventListener("dblclick", ()=>{
    (0, $75b3f03462ab0244$export$64cd6327b1b8b7f9)(!(0, $7DyRn.default).keyboardLocked);
});
//Init audio
(0, $7DyRn.default).audioContext = new (window.AudioContext || window.webkitAudioContext)();
(0, $7DyRn.default).oscillator = (0, $7DyRn.default).audioContext.createOscillator();
(0, $7DyRn.default).audioVolume = (0, $7DyRn.default).audioContext.createGain();
(0, $7DyRn.default).audioMediaStreamDestination = (0, $7DyRn.default).audioContext.createMediaStreamDestination();
(0, $7DyRn.default).audioVolume.gain.value = 0.0;
(0, $7DyRn.default).oscillator.connect((0, $7DyRn.default).audioVolume);
(0, $7DyRn.default).audioVolume.connect((0, $7DyRn.default).audioContext.destination);
(0, $7DyRn.default).audioVolume.connect((0, $7DyRn.default).audioMediaStreamDestination);
//Init event listeners for general button UI.
document.getElementById("compile-code-button").addEventListener("click", (0, $75b3f03462ab0244$export$889b795e702c4b25));
document.getElementById("run-code-button").addEventListener("click", (0, $75b3f03462ab0244$export$ddae37e51c7979e2));
document.getElementById("download-code-button").addEventListener("click", (0, $2417d44c520c778f$export$48b966240d8e5e43));
document.getElementById("download-all-button").addEventListener("click", (0, $2417d44c520c778f$export$4bda4314ff8f4f9c));
document.getElementById("upload-binary-button").addEventListener("click", (0, $2417d44c520c778f$export$ca7b224f96fd7e64));
document.getElementById("save-video-button").addEventListener("click", (0, $75b3f03462ab0244$export$fd0c85d281559718));
document.getElementById("record-video-button").addEventListener("click", (0, $3fdac27332d5c6a7$export$ec00e8cdb5f248f4));
document.getElementById("kbd-locked-message").addEventListener("click", (_)=>{
    (0, $75b3f03462ab0244$export$64cd6327b1b8b7f9)(!(0, $7DyRn.default).keyboardLocked);
});
document.getElementById("stop-code-button").addEventListener("click", (_)=>{
    // Clear sound
    (0, $7DyRn.default).oscillator.frequency.value = 0;
    (0, $7DyRn.default).audioVolume.gain.value = 0;
    if ((0, $7DyRn.default).soundStarted) (0, $7DyRn.default).oscillator.stop();
    (0, $7DyRn.default).soundStarted = false;
    // Clear IO lights
    for(let reg in (0, $7DyRn.default).ioBulbs)(0, $7DyRn.default).ioBulbs[reg].setAttribute("enabled", "false");
    // Clear other data
    (0, $7DyRn.default).vmIsAlive = false;
    (0, $7DyRn.default).videoText = "";
    (0, $75b3f03462ab0244$export$64cd6327b1b8b7f9)(false);
    // Clear canvas
    (0, $bNfEN.goputer).drawing.clearCanvas();
    $10c90e54c8ae0167$export$67ea982130081db.setAttribute("running", "false");
    // Show editor again
    document.getElementById("code-editor").style.visibility = "visible";
    document.getElementById("binary-message").style.visibility = "hidden";
    document.getElementById("compile-code-button").disabled = false;
    document.getElementById("download-all-button").disabled = false;
});
if (localStorage.getItem("highContrast") != null) {
    if (localStorage.getItem("highContrast") === "true") document.documentElement.classList.add("high-contrast");
}
document.getElementById("toggle-contrast-button").addEventListener("click", ()=>{
    document.documentElement.classList.toggle("high-contrast");
    localStorage.setItem("highContrast", document.documentElement.classList.contains("high-contrast"));
});
//Init IO elements
for(let i = 0; i < document.getElementById("bulb-container").children.length; i++)(0, $7DyRn.default).ioBulbs[document.getElementById("bulb-container").children[i].getAttribute("reg")] = document.getElementById("bulb-container").children[i];
$10c90e54c8ae0167$export$67ea982130081db.addEventListener("mouseenter", ()=>{
    (0, $7DyRn.default).mouseOverDisplay = true;
});
$10c90e54c8ae0167$export$67ea982130081db.addEventListener("mouseleave", ()=>{
    (0, $7DyRn.default).mouseOverDisplay = false;
});
$10c90e54c8ae0167$export$67ea982130081db.addEventListener("mousemove", (0, $75b3f03462ab0244$export$3248c033e90a4ba0));
document.addEventListener("keydown", (0, $75b3f03462ab0244$export$bab59f27a7347e45));
document.addEventListener("keyup", (0, $75b3f03462ab0244$export$aef3a35367ddc990));
// Error messages
(0, $7DyRn.default).errorDiv = document.getElementById("error-div");
document.getElementById("error-clear-button").addEventListener("click", (e)=>{
    let p = document.createElement("p");
    p.textContent = "No notifications.";
    p.classList.add("text-center", "w-full");
    (0, $7DyRn.default).errorCount = 0;
    (0, $7DyRn.default).errorDiv.replaceChildren(p);
});
// Populate register keys
var $10c90e54c8ae0167$var$peekRegDatalist = document.getElementById("peek-reg-datalist");
const $10c90e54c8ae0167$export$ea454f442ecb1c77 = document.getElementById("peek-reg-value");
$10c90e54c8ae0167$export$ea454f442ecb1c77.addEventListener("click", (e)=>{
    if ($10c90e54c8ae0167$export$ea454f442ecb1c77.style.height != "auto") $10c90e54c8ae0167$export$ea454f442ecb1c77.style.height = "auto";
    else $10c90e54c8ae0167$export$ea454f442ecb1c77.style.height = "2rem";
});
Object.keys((0, $bNfEN.registerInts)).forEach((element)=>{
    let el = document.createElement("option");
    el.value = element;
    $10c90e54c8ae0167$var$peekRegDatalist.appendChild(el);
});
const $10c90e54c8ae0167$export$ca2646a4c0f0768f = document.getElementById("peek-reg");
$10c90e54c8ae0167$export$ca2646a4c0f0768f.value = "";
$10c90e54c8ae0167$export$ca2646a4c0f0768f.addEventListener("input", (0, $75b3f03462ab0244$export$6264774bc3649f49));
document.getElementById("peek-format-select").addEventListener("change", (0, $75b3f03462ab0244$export$6264774bc3649f49));
// Global keyboard shortcuts
document.addEventListener("keydown", (e)=>{
    if (e.altKey && e.key.charCodeAt(0) >= 49 && e.key.charCodeAt(0) <= 56) {
        e.preventDefault();
        document.getElementById("switch-container").children[e.key.charCodeAt(0) - 49].click();
    } else if (e.ctrlKey && e.altKey && (e.key == "ArrowLeft" || e.key == "ArrowRight")) {
        e.preventDefault();
        const increment = e.key == "ArrowLeft" ? -1 : 1;
        const tabs = (0, $4864cf74b2333fa3$export$1f9169f556c5cb13).querySelectorAll("code-tab");
        let selectedIndex = 0;
        for(let i = 0; i < tabs.length; i++)if (tabs[i].selected) {
            selectedIndex = i;
            break;
        }
        selectedIndex += increment;
        selectedIndex = (0, $98dd9785d83e1f2f$export$7d15b64cf5a3a4c4)(selectedIndex, 0, (0, $4864cf74b2333fa3$export$1f9169f556c5cb13).length - 1);
        (0, $4864cf74b2333fa3$export$f6acc09de0557d94)(tabs[selectedIndex].filename);
    } else if (e.ctrlKey && e.altKey && e.code == "KeyN") {
        e.preventDefault();
        (0, $4864cf74b2333fa3$export$552ff566cdfcd44c)(e);
    } else if (e.ctrlKey && e.altKey && e.code == "KeyW") {
        e.preventDefault();
        (0, $4864cf74b2333fa3$export$1f9169f556c5cb13).querySelector("code-tab[selected=true]").deleteFile(e);
    } else if (e.ctrlKey && e.altKey && e.code == "KeyR") {
        e.preventDefault();
        (0, $4864cf74b2333fa3$export$1f9169f556c5cb13).querySelector("code-tab[selected=true]").renameFile(e);
    } else if (e.altKey && e.code == "F1") {
        e.preventDefault();
        (0, $75b3f03462ab0244$export$889b795e702c4b25)();
    } else if (e.altKey && e.code == "F2") {
        e.preventDefault();
        (0, $75b3f03462ab0244$export$ddae37e51c7979e2)();
    } else if (e.altKey && e.code == "F3") {
        e.preventDefault();
        document.getElementById("stop-code-button").click();
    } else if (e.altKey && e.code == "F5") {
        e.preventDefault();
        document.getElementById("error-clear-button").click();
    } else if (e.ctrlKey && e.altKey && e.code == "KeyF") {
        if ((0, $bNfEN.goputer).files.type((0, $7DyRn.default).focusedFile) == "text") {
            e.preventDefault();
            (0, $4864cf74b2333fa3$export$88f7b74589ded201).focus();
        }
    } else if (e.ctrlKey && e.code == "Slash") {
        e.preventDefault();
        document.getElementById("key-shortcuts-summary").toggleAttribute("open");
        document.getElementById("key-shortcuts-summary").scrollIntoView();
    } else if (e.ctrlKey && e.altKey && e.code == "KeyS") {
        e.preventDefault();
        (0, $75b3f03462ab0244$export$fd0c85d281559718)();
    } else if (e.ctrlKey && e.altKey && e.code == "KeyV") {
        e.preventDefault();
        (0, $3fdac27332d5c6a7$export$ec00e8cdb5f248f4)();
    }
});




//# sourceMappingURL=web.e5a8ac80.js.map
